/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(32);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(171);
	
	var _useScroll = __webpack_require__(233);
	
	var _useScroll2 = _interopRequireDefault(_useScroll);
	
	var _createRoutes = __webpack_require__(243);
	
	var _createRoutes2 = _interopRequireDefault(_createRoutes);
	
	var _gatsbyBrowser = __webpack_require__(493);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	var loadContext = __webpack_require__(506);
	
	function loadConfig(cb) {
	  var stuff = __webpack_require__(385);
	
	  if (false) {
	    module.hot.accept(stuff.id, function () {
	      return cb();
	    });
	  }
	  return cb();
	}
	
	var currentLocation = null;
	
	_reactRouter.browserHistory.listen(function (location) {
	  currentLocation = location;
	  if (_gatsbyBrowser.onRouteChange) {
	    console.warn('onRouteChange is now deprecated and will be removed in the next major Gatsby release (0.13). Please use onRouteUpdate instead. See the PR for more info (https://github.com/gatsbyjs/gatsby/pull/321).');
	    (0, _gatsbyBrowser.onRouteChange)(location);
	  }
	});
	
	function onUpdate() {
	  if (_gatsbyBrowser.onRouteUpdate) {
	    (0, _gatsbyBrowser.onRouteUpdate)(currentLocation);
	  }
	}
	
	function defaultShouldUpdateScroll(prevRouterProps, nextRouterProps) {
	  if (_gatsbyBrowser.shouldUpdateScroll) {
	    return (0, _gatsbyBrowser.shouldUpdateScroll)(prevRouterProps, nextRouterProps);
	  }
	  if (prevRouterProps) {
	    var oldPathname = prevRouterProps.location.pathname;
	    var pathname = nextRouterProps.location.pathname;
	
	    if (oldPathname === pathname) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var routes = void 0;
	loadConfig(function () {
	  return loadContext(function (pagesReq) {
	    var _require = __webpack_require__(385),
	        pages = _require.pages;
	
	    if (!routes) {
	      routes = (0, _createRoutes2.default)(pages, pagesReq);
	    } else {
	      (0, _createRoutes2.default)(pages, pagesReq);
	    }
	
	    if (_gatsbyBrowser.modifyRoutes) {
	      routes = (0, _gatsbyBrowser.modifyRoutes)(routes);
	    }
	
	    var Root = function Root() {
	      return _react2.default.createElement(_reactRouter.Router, {
	        history: _reactRouter.browserHistory,
	        routes: routes,
	        render: (0, _reactRouter.applyRouterMiddleware)((0, _useScroll2.default)(defaultShouldUpdateScroll)),
	        onUpdate: onUpdate
	      });
	    };
	
	    if (_gatsbyBrowser.wrapRootComponent) {
	      Root = (0, _gatsbyBrowser.wrapRootComponent)(Root);
	    }
	
	    if (_gatsbyBrowser.replaceDOMRenderer) {
	      (0, _gatsbyBrowser.replaceDOMRenderer)({ routes: routes, defaultShouldUpdateScroll: defaultShouldUpdateScroll, onUpdate: onUpdate });
	    } else {
	      _reactDom2.default.render(_react2.default.createElement(Root, null), typeof window !== 'undefined' ? document.getElementById('react-mount') : undefined);
	    }
	  });
	});

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(3);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactBaseClasses = __webpack_require__(5);
	var ReactChildren = __webpack_require__(14);
	var ReactDOMFactories = __webpack_require__(22);
	var ReactElement = __webpack_require__(16);
	var ReactPropTypes = __webpack_require__(23);
	var ReactVersion = __webpack_require__(28);
	
	var createReactClass = __webpack_require__(29);
	var onlyChild = __webpack_require__(31);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(4);
	
	var ReactNoopUpdateQueue = __webpack_require__(7);
	
	var canDefineProperty = __webpack_require__(10);
	var emptyObject = __webpack_require__(11);
	var invariant = __webpack_require__(12);
	var lowPriorityWarning = __webpack_require__(13);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(8);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(9);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(15);
	var ReactElement = __webpack_require__(16);
	
	var emptyFunction = __webpack_require__(9);
	var traverseAllChildren = __webpack_require__(19);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 15 */
[729, 6],
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(17);
	
	var warning = __webpack_require__(8);
	var canDefineProperty = __webpack_require__(10);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(18);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var REACT_ELEMENT_TYPE = __webpack_require__(18);
	
	var getIteratorFn = __webpack_require__(20);
	var invariant = __webpack_require__(12);
	var KeyEscapeUtils = __webpack_require__(21);
	var warning = __webpack_require__(8);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(16);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(16),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(24);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(25);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(9);
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	var ReactPropTypesSecret = __webpack_require__(26);
	var checkPropTypes = __webpack_require__(27);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.1';

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(5),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(16),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(7);
	var factory = __webpack_require__(30);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyObject = __webpack_require__(11);
	var _invariant = __webpack_require__(12);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactElement = __webpack_require__(16);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(33);


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactDefaultInjection = __webpack_require__(38);
	var ReactMount = __webpack_require__(162);
	var ReactReconciler = __webpack_require__(59);
	var ReactUpdates = __webpack_require__(56);
	var ReactVersion = __webpack_require__(167);
	
	var findDOMNode = __webpack_require__(168);
	var getHostComponentFromComposite = __webpack_require__(169);
	var renderSubtreeIntoContainer = __webpack_require__(170);
	var warning = __webpack_require__(8);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var DOMProperty = __webpack_require__(36);
	var ReactDOMComponentFlags = __webpack_require__(37);
	
	var invariant = __webpack_require__(12);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 35 */
6,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var invariant = __webpack_require__(12);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(39);
	var BeforeInputEventPlugin = __webpack_require__(40);
	var ChangeEventPlugin = __webpack_require__(55);
	var DefaultEventPluginOrder = __webpack_require__(68);
	var EnterLeaveEventPlugin = __webpack_require__(69);
	var HTMLDOMPropertyConfig = __webpack_require__(74);
	var ReactComponentBrowserEnvironment = __webpack_require__(75);
	var ReactDOMComponent = __webpack_require__(88);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactDOMEmptyComponent = __webpack_require__(133);
	var ReactDOMTreeTraversal = __webpack_require__(134);
	var ReactDOMTextComponent = __webpack_require__(135);
	var ReactDefaultBatchingStrategy = __webpack_require__(136);
	var ReactEventListener = __webpack_require__(137);
	var ReactInjection = __webpack_require__(140);
	var ReactReconcileTransaction = __webpack_require__(141);
	var SVGDOMPropertyConfig = __webpack_require__(149);
	var SelectEventPlugin = __webpack_require__(150);
	var SimpleEventPlugin = __webpack_require__(151);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(41);
	var ExecutionEnvironment = __webpack_require__(48);
	var FallbackCompositionState = __webpack_require__(49);
	var SyntheticCompositionEvent = __webpack_require__(52);
	var SyntheticInputEvent = __webpack_require__(54);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(42);
	var EventPluginUtils = __webpack_require__(44);
	
	var accumulateInto = __webpack_require__(46);
	var forEachAccumulated = __webpack_require__(47);
	var warning = __webpack_require__(8);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var EventPluginRegistry = __webpack_require__(43);
	var EventPluginUtils = __webpack_require__(44);
	var ReactErrorUtils = __webpack_require__(45);
	
	var accumulateInto = __webpack_require__(46);
	var forEachAccumulated = __webpack_require__(47);
	var invariant = __webpack_require__(12);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var ReactErrorUtils = __webpack_require__(45);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(50);
	
	var getTextContentAccessor = __webpack_require__(51);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 50 */
[729, 35],
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(48);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(53);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(50);
	
	var emptyFunction = __webpack_require__(9);
	var warning = __webpack_require__(8);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(53);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(42);
	var EventPropagators = __webpack_require__(41);
	var ExecutionEnvironment = __webpack_require__(48);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(56);
	var SyntheticEvent = __webpack_require__(53);
	
	var inputValueTracking = __webpack_require__(64);
	var getEventTarget = __webpack_require__(65);
	var isEventSupported = __webpack_require__(66);
	var isTextInputElement = __webpack_require__(67);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35),
	    _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(57);
	var PooledClass = __webpack_require__(50);
	var ReactFeatureFlags = __webpack_require__(58);
	var ReactReconciler = __webpack_require__(59);
	var Transaction = __webpack_require__(63);
	
	var invariant = __webpack_require__(12);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(50);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(60);
	var ReactInstrumentation = __webpack_require__(62);
	
	var warning = __webpack_require__(8);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(61);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var invariant = __webpack_require__(12);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(34);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  delete inst._wrapperState.valueTracker;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(48);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(41);
	var ReactDOMComponentTree = __webpack_require__(34);
	var SyntheticMouseEvent = __webpack_require__(70);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(71);
	var ViewportMetrics = __webpack_require__(72);
	
	var getEventModifierState = __webpack_require__(73);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(53);
	
	var getEventTarget = __webpack_require__(65);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(36);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(76);
	var ReactDOMIDOperations = __webpack_require__(87);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(77);
	var Danger = __webpack_require__(83);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactInstrumentation = __webpack_require__(62);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(80);
	var setInnerHTML = __webpack_require__(79);
	var setTextContent = __webpack_require__(81);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(78);
	var setInnerHTML = __webpack_require__(79);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(80);
	var setTextContent = __webpack_require__(81);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(48);
	var DOMNamespaces = __webpack_require__(78);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(80);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(48);
	var escapeTextContentForBrowser = __webpack_require__(82);
	var setInnerHTML = __webpack_require__(79);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var DOMLazyTree = __webpack_require__(77);
	var ExecutionEnvironment = __webpack_require__(48);
	
	var createNodesFromMarkup = __webpack_require__(84);
	var emptyFunction = __webpack_require__(9);
	var invariant = __webpack_require__(12);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(48);
	
	var createArrayFromMixed = __webpack_require__(85);
	var getMarkupWrap = __webpack_require__(86);
	var invariant = __webpack_require__(12);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(48);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(76);
	var ReactDOMComponentTree = __webpack_require__(34);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35),
	    _assign = __webpack_require__(4);
	
	var AutoFocusUtils = __webpack_require__(89);
	var CSSPropertyOperations = __webpack_require__(91);
	var DOMLazyTree = __webpack_require__(77);
	var DOMNamespaces = __webpack_require__(78);
	var DOMProperty = __webpack_require__(36);
	var DOMPropertyOperations = __webpack_require__(99);
	var EventPluginHub = __webpack_require__(42);
	var EventPluginRegistry = __webpack_require__(43);
	var ReactBrowserEventEmitter = __webpack_require__(101);
	var ReactDOMComponentFlags = __webpack_require__(37);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactDOMInput = __webpack_require__(104);
	var ReactDOMOption = __webpack_require__(107);
	var ReactDOMSelect = __webpack_require__(108);
	var ReactDOMTextarea = __webpack_require__(109);
	var ReactInstrumentation = __webpack_require__(62);
	var ReactMultiChild = __webpack_require__(110);
	var ReactServerRenderingTransaction = __webpack_require__(129);
	
	var emptyFunction = __webpack_require__(9);
	var escapeTextContentForBrowser = __webpack_require__(82);
	var invariant = __webpack_require__(12);
	var isEventSupported = __webpack_require__(66);
	var shallowEqual = __webpack_require__(118);
	var inputValueTracking = __webpack_require__(64);
	var validateDOMNesting = __webpack_require__(132);
	var warning = __webpack_require__(8);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(34);
	
	var focusNode = __webpack_require__(90);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(92);
	var ExecutionEnvironment = __webpack_require__(48);
	var ReactInstrumentation = __webpack_require__(62);
	
	var camelizeStyleName = __webpack_require__(93);
	var dangerousStyleValue = __webpack_require__(95);
	var hyphenateStyleName = __webpack_require__(96);
	var memoizeStringOnly = __webpack_require__(98);
	var warning = __webpack_require__(8);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(94);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(92);
	var warning = __webpack_require__(8);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(97);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(36);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactInstrumentation = __webpack_require__(62);
	
	var quoteAttributeValueForBrowser = __webpack_require__(100);
	var warning = __webpack_require__(8);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(82);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventPluginRegistry = __webpack_require__(43);
	var ReactEventEmitterMixin = __webpack_require__(102);
	var ViewportMetrics = __webpack_require__(72);
	
	var getVendorPrefixedEventName = __webpack_require__(103);
	var isEventSupported = __webpack_require__(66);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(42);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(48);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35),
	    _assign = __webpack_require__(4);
	
	var DOMPropertyOperations = __webpack_require__(99);
	var LinkedValueUtils = __webpack_require__(105);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(56);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var ReactPropTypesSecret = __webpack_require__(106);
	var propTypesFactory = __webpack_require__(24);
	
	var React = __webpack_require__(3);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var React = __webpack_require__(3);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactDOMSelect = __webpack_require__(108);
	
	var warning = __webpack_require__(8);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var LinkedValueUtils = __webpack_require__(105);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(56);
	
	var warning = __webpack_require__(8);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35),
	    _assign = __webpack_require__(4);
	
	var LinkedValueUtils = __webpack_require__(105);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(56);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var ReactComponentEnvironment = __webpack_require__(111);
	var ReactInstanceMap = __webpack_require__(112);
	var ReactInstrumentation = __webpack_require__(62);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactReconciler = __webpack_require__(59);
	var ReactChildReconciler = __webpack_require__(113);
	
	var emptyFunction = __webpack_require__(9);
	var flattenChildren = __webpack_require__(128);
	var invariant = __webpack_require__(12);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var invariant = __webpack_require__(12);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(59);
	
	var instantiateReactComponent = __webpack_require__(115);
	var KeyEscapeUtils = __webpack_require__(123);
	var shouldUpdateReactComponent = __webpack_require__(119);
	var traverseAllChildren = __webpack_require__(124);
	var warning = __webpack_require__(8);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(127);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(114)))

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35),
	    _assign = __webpack_require__(4);
	
	var ReactCompositeComponent = __webpack_require__(116);
	var ReactEmptyComponent = __webpack_require__(120);
	var ReactHostComponent = __webpack_require__(121);
	
	var getNextDebugID = __webpack_require__(122);
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35),
	    _assign = __webpack_require__(4);
	
	var React = __webpack_require__(3);
	var ReactComponentEnvironment = __webpack_require__(111);
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactErrorUtils = __webpack_require__(45);
	var ReactInstanceMap = __webpack_require__(112);
	var ReactInstrumentation = __webpack_require__(62);
	var ReactNodeTypes = __webpack_require__(117);
	var ReactReconciler = __webpack_require__(59);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(11);
	var invariant = __webpack_require__(12);
	var shallowEqual = __webpack_require__(118);
	var shouldUpdateReactComponent = __webpack_require__(119);
	var warning = __webpack_require__(8);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var React = __webpack_require__(3);
	
	var invariant = __webpack_require__(12);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var invariant = __webpack_require__(12);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 123 */
21,
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var REACT_ELEMENT_TYPE = __webpack_require__(125);
	
	var getIteratorFn = __webpack_require__(126);
	var invariant = __webpack_require__(12);
	var KeyEscapeUtils = __webpack_require__(123);
	var warning = __webpack_require__(8);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 125 */
18,
/* 126 */
20,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(17);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(123);
	var traverseAllChildren = __webpack_require__(124);
	var warning = __webpack_require__(8);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(127);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(114)))

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(50);
	var Transaction = __webpack_require__(63);
	var ReactInstrumentation = __webpack_require__(62);
	var ReactServerUpdateQueue = __webpack_require__(130);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(131);
	
	var warning = __webpack_require__(8);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactInstanceMap = __webpack_require__(112);
	var ReactInstrumentation = __webpack_require__(62);
	var ReactUpdates = __webpack_require__(56);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyFunction = __webpack_require__(9);
	var warning = __webpack_require__(8);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var DOMLazyTree = __webpack_require__(77);
	var ReactDOMComponentTree = __webpack_require__(34);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35),
	    _assign = __webpack_require__(4);
	
	var DOMChildrenOperations = __webpack_require__(76);
	var DOMLazyTree = __webpack_require__(77);
	var ReactDOMComponentTree = __webpack_require__(34);
	
	var escapeTextContentForBrowser = __webpack_require__(82);
	var invariant = __webpack_require__(12);
	var validateDOMNesting = __webpack_require__(132);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactUpdates = __webpack_require__(56);
	var Transaction = __webpack_require__(63);
	
	var emptyFunction = __webpack_require__(9);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventListener = __webpack_require__(138);
	var ExecutionEnvironment = __webpack_require__(48);
	var PooledClass = __webpack_require__(50);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(56);
	
	var getEventTarget = __webpack_require__(65);
	var getUnboundedScrollPosition = __webpack_require__(139);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(9);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(36);
	var EventPluginHub = __webpack_require__(42);
	var EventPluginUtils = __webpack_require__(44);
	var ReactComponentEnvironment = __webpack_require__(111);
	var ReactEmptyComponent = __webpack_require__(120);
	var ReactBrowserEventEmitter = __webpack_require__(101);
	var ReactHostComponent = __webpack_require__(121);
	var ReactUpdates = __webpack_require__(56);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(57);
	var PooledClass = __webpack_require__(50);
	var ReactBrowserEventEmitter = __webpack_require__(101);
	var ReactInputSelection = __webpack_require__(142);
	var ReactInstrumentation = __webpack_require__(62);
	var Transaction = __webpack_require__(63);
	var ReactUpdateQueue = __webpack_require__(131);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(143);
	
	var containsNode = __webpack_require__(145);
	var focusNode = __webpack_require__(90);
	var getActiveElement = __webpack_require__(148);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(48);
	
	var getNodeForCharacterOffset = __webpack_require__(144);
	var getTextContentAccessor = __webpack_require__(51);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(146);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(147);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(41);
	var ExecutionEnvironment = __webpack_require__(48);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactInputSelection = __webpack_require__(142);
	var SyntheticEvent = __webpack_require__(53);
	
	var getActiveElement = __webpack_require__(148);
	var isTextInputElement = __webpack_require__(67);
	var shallowEqual = __webpack_require__(118);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var EventListener = __webpack_require__(138);
	var EventPropagators = __webpack_require__(41);
	var ReactDOMComponentTree = __webpack_require__(34);
	var SyntheticAnimationEvent = __webpack_require__(152);
	var SyntheticClipboardEvent = __webpack_require__(153);
	var SyntheticEvent = __webpack_require__(53);
	var SyntheticFocusEvent = __webpack_require__(154);
	var SyntheticKeyboardEvent = __webpack_require__(155);
	var SyntheticMouseEvent = __webpack_require__(70);
	var SyntheticDragEvent = __webpack_require__(158);
	var SyntheticTouchEvent = __webpack_require__(159);
	var SyntheticTransitionEvent = __webpack_require__(160);
	var SyntheticUIEvent = __webpack_require__(71);
	var SyntheticWheelEvent = __webpack_require__(161);
	
	var emptyFunction = __webpack_require__(9);
	var getEventCharCode = __webpack_require__(156);
	var invariant = __webpack_require__(12);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(53);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(53);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(71);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(71);
	
	var getEventCharCode = __webpack_require__(156);
	var getEventKey = __webpack_require__(157);
	var getEventModifierState = __webpack_require__(73);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 156 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(156);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(70);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(71);
	
	var getEventModifierState = __webpack_require__(73);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(53);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(70);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var DOMLazyTree = __webpack_require__(77);
	var DOMProperty = __webpack_require__(36);
	var React = __webpack_require__(3);
	var ReactBrowserEventEmitter = __webpack_require__(101);
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactDOMContainerInfo = __webpack_require__(163);
	var ReactDOMFeatureFlags = __webpack_require__(164);
	var ReactFeatureFlags = __webpack_require__(58);
	var ReactInstanceMap = __webpack_require__(112);
	var ReactInstrumentation = __webpack_require__(62);
	var ReactMarkupChecksum = __webpack_require__(165);
	var ReactReconciler = __webpack_require__(59);
	var ReactUpdateQueue = __webpack_require__(131);
	var ReactUpdates = __webpack_require__(56);
	
	var emptyObject = __webpack_require__(11);
	var instantiateReactComponent = __webpack_require__(115);
	var invariant = __webpack_require__(12);
	var setInnerHTML = __webpack_require__(79);
	var shouldUpdateReactComponent = __webpack_require__(119);
	var warning = __webpack_require__(8);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(132);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(166);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 167 */
28,
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(35);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactInstanceMap = __webpack_require__(112);
	
	var getHostComponentFromComposite = __webpack_require__(169);
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(117);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(162);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(172);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(173);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(178);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(180);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(210);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(211);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(212);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(214);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(216);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(215);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(217);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(218);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(219);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(220);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(221);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(207);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(222);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(223);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(227);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(228);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(229);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(232);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(224);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(2);
	
	var _deprecateObjectProperties = __webpack_require__(174);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(177);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(175);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(175);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(176);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(2);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(179);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(181);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(196);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(179);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(199);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(177);
	
	var _RouterContext = __webpack_require__(207);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(172);
	
	var _RouterUtils = __webpack_require__(209);
	
	var _routerWarning = __webpack_require__(175);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(176);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(179);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(182);
	
	var _PathUtils = __webpack_require__(183);
	
	var _ExecutionEnvironment = __webpack_require__(184);
	
	var _DOMUtils = __webpack_require__(185);
	
	var _DOMStateStorage = __webpack_require__(186);
	
	var _createDOMHistory = __webpack_require__(187);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ }),
/* 182 */
/***/ (function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(176);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(176);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(179);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(184);
	
	var _DOMUtils = __webpack_require__(185);
	
	var _createHistory = __webpack_require__(188);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(176);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(189);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(183);
	
	var _AsyncUtils = __webpack_require__(192);
	
	var _Actions = __webpack_require__(182);
	
	var _createLocation2 = __webpack_require__(193);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(194);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(195);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(190);
	var isArguments = __webpack_require__(191);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 190 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 191 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 192 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(176);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(182);
	
	var _PathUtils = __webpack_require__(183);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(176);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(176);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(176);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(197);
	
	var _runTransitionHook = __webpack_require__(194);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(183);
	
	var _deprecate = __webpack_require__(195);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(198);
	var objectAssign = __webpack_require__(4);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 198 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(175);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(200);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(201);
	
	var _isActive2 = __webpack_require__(203);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(204);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(206);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(178);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(202);
	
	var _routerWarning = __webpack_require__(175);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ }),
/* 202 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(178);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(202);
	
	var _makeStateWithLocation = __webpack_require__(205);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(174);
	
	var _routerWarning = __webpack_require__(175);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(202);
	
	var _makeStateWithLocation = __webpack_require__(205);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(178);
	
	var _routerWarning = __webpack_require__(175);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(179);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(174);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(208);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(172);
	
	var _routerWarning = __webpack_require__(175);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(178);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(174);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(175);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(179);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(210);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(179);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(213);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(175);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(179);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(215);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(179);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(172);
	
	var _PatternUtils = __webpack_require__(178);
	
	var _InternalPropTypes = __webpack_require__(177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(175);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(179);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(172);
	
	var _InternalPropTypes = __webpack_require__(177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(179);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(172);
	
	var _InternalPropTypes = __webpack_require__(177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(175);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(175);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(179);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(175);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(196);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(199);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(175);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(207);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(175);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(182);
	
	var _invariant = __webpack_require__(179);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(224);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(199);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(172);
	
	var _RouterUtils = __webpack_require__(209);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(196);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(225);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(226);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(176);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(184);
	
	var _PathUtils = __webpack_require__(183);
	
	var _runTransitionHook = __webpack_require__(194);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(195);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(176);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(179);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(183);
	
	var _Actions = __webpack_require__(182);
	
	var _createHistory = __webpack_require__(188);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(196);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(225);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(207);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(175);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(230);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(231);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(179);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(182);
	
	var _PathUtils = __webpack_require__(183);
	
	var _ExecutionEnvironment = __webpack_require__(184);
	
	var _DOMUtils = __webpack_require__(185);
	
	var _DOMStateStorage = __webpack_require__(186);
	
	var _createDOMHistory = __webpack_require__(187);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(227);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(181);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(231);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useScroll;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollBehaviorContext = __webpack_require__(234);
	
	var _ScrollBehaviorContext2 = _interopRequireDefault(_ScrollBehaviorContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useScroll(shouldUpdateScroll) {
	  return {
	    renderRouterContext: function renderRouterContext(child, props) {
	      return _react2.default.createElement(
	        _ScrollBehaviorContext2.default,
	        {
	          shouldUpdateScroll: shouldUpdateScroll,
	          routerProps: props
	        },
	        child
	      );
	    }
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollBehavior = __webpack_require__(235);
	
	var _ScrollBehavior2 = _interopRequireDefault(_ScrollBehavior);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  shouldUpdateScroll: _react2.default.PropTypes.func,
	  routerProps: _react2.default.PropTypes.object.isRequired,
	  children: _react2.default.PropTypes.element.isRequired
	};
	
	var childContextTypes = {
	  scrollBehavior: _react2.default.PropTypes.object.isRequired
	};
	
	var ScrollBehaviorContext = function (_React$Component) {
	  _inherits(ScrollBehaviorContext, _React$Component);
	
	  function ScrollBehaviorContext(props, context) {
	    _classCallCheck(this, ScrollBehaviorContext);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var routerProps = props.routerProps;
	
	
	    _this.scrollBehavior = new _ScrollBehavior2.default(routerProps.router, function () {
	      return _this.props.routerProps.location;
	    }, _this.shouldUpdateScroll);
	
	    _this.scrollBehavior.updateScroll(null, routerProps);
	    return _this;
	  }
	
	  ScrollBehaviorContext.prototype.getChildContext = function getChildContext() {
	    return {
	      scrollBehavior: this
	    };
	  };
	
	  ScrollBehaviorContext.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var routerProps = this.props.routerProps;
	
	    var prevRouterProps = prevProps.routerProps;
	
	    if (routerProps.location === prevRouterProps.location) {
	      return;
	    }
	
	    this.scrollBehavior.updateScroll(prevRouterProps, routerProps);
	  };
	
	  ScrollBehaviorContext.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.scrollBehavior.stop();
	  };
	
	  ScrollBehaviorContext.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return ScrollBehaviorContext;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	    var shouldUpdateScroll = _this2.props.shouldUpdateScroll;
	
	    if (!shouldUpdateScroll) {
	      return true;
	    }
	
	    // Hack to allow accessing scrollBehavior.readPosition().
	    return shouldUpdateScroll.call(_this2.scrollBehavior, prevRouterProps, routerProps);
	  };
	
	  this.registerElement = function (key, element, shouldUpdateScroll) {
	    _this2.scrollBehavior.registerElement(key, element, shouldUpdateScroll, _this2.props.routerProps);
	  };
	
	  this.unregisterElement = function (key) {
	    _this2.scrollBehavior.unregisterElement(key);
	  };
	};
	
	ScrollBehaviorContext.propTypes = propTypes;
	ScrollBehaviorContext.childContextTypes = childContextTypes;
	
	exports.default = ScrollBehaviorContext;
	module.exports = exports['default'];

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _off = __webpack_require__(236);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _on = __webpack_require__(238);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _scrollLeft = __webpack_require__(239);
	
	var _scrollLeft2 = _interopRequireDefault(_scrollLeft);
	
	var _scrollTop = __webpack_require__(241);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _requestAnimationFrame = __webpack_require__(242);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _Actions = __webpack_require__(182);
	
	var _DOMStateStorage = __webpack_require__(186);
	
	var _invariant = __webpack_require__(179);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-underscore-dangle */
	
	// FIXME: Stop using this gross hack. This won't collide with any actual
	// history location keys, but it's dirty to sneakily use the same storage here.
	var KEY_PREFIX = 's/';
	
	// Try at most this many times to scroll, to avoid getting stuck.
	var MAX_SCROLL_ATTEMPTS = 2;
	
	var ScrollBehavior = function () {
	  function ScrollBehavior(history, getCurrentLocation, shouldUpdateScroll) {
	    var _this = this;
	
	    _classCallCheck(this, ScrollBehavior);
	
	    this._onWindowScroll = function () {
	      // It's possible that this scroll operation was triggered by what will be a
	      // `POP` transition. Instead of updating the saved location immediately, we
	      // have to enqueue the update, then potentially cancel it if we observe a
	      // location update.
	      if (_this._saveWindowPositionHandle === null) {
	        _this._saveWindowPositionHandle = (0, _requestAnimationFrame2.default)(_this._saveWindowPosition);
	      }
	
	      if (_this._windowScrollTarget) {
	        var _windowScrollTarget = _this._windowScrollTarget;
	        var xTarget = _windowScrollTarget[0];
	        var yTarget = _windowScrollTarget[1];
	
	        var x = (0, _scrollLeft2.default)(window);
	        var y = (0, _scrollTop2.default)(window);
	
	        if (x === xTarget && y === yTarget) {
	          _this._windowScrollTarget = null;
	          _this._cancelCheckWindowScroll();
	        }
	      }
	    };
	
	    this._saveWindowPosition = function () {
	      _this._saveWindowPositionHandle = null;
	
	      _this._savePosition(null, window);
	    };
	
	    this._checkWindowScrollPosition = function () {
	      _this._checkWindowScrollHandle = null;
	
	      // We can only get here if scrollTarget is set. Every code path that unsets
	      // scroll target also cancels the handle to avoid calling this handler.
	      // Still, check anyway just in case.
	      /* istanbul ignore if: paranoid guard */
	      if (!_this._windowScrollTarget) {
	        return;
	      }
	
	      var _windowScrollTarget2 = _this._windowScrollTarget;
	      var x = _windowScrollTarget2[0];
	      var y = _windowScrollTarget2[1];
	
	      window.scrollTo(x, y);
	
	      ++_this._numWindowScrollAttempts;
	
	      /* istanbul ignore if: paranoid guard */
	      if (_this._numWindowScrollAttempts >= MAX_SCROLL_ATTEMPTS) {
	        _this._windowScrollTarget = null;
	        return;
	      }
	
	      _this._checkWindowScrollHandle = (0, _requestAnimationFrame2.default)(_this._checkWindowScrollPosition);
	    };
	
	    this._history = history;
	    this._getCurrentLocation = getCurrentLocation;
	    this._shouldUpdateScroll = shouldUpdateScroll;
	
	    // This helps avoid some jankiness in fighting against the browser's
	    // default scroll behavior on `POP` transitions.
	    /* istanbul ignore if: not supported by any browsers on Travis */
	    if ('scrollRestoration' in window.history) {
	      this._oldScrollRestoration = window.history.scrollRestoration;
	      window.history.scrollRestoration = 'manual';
	    } else {
	      this._oldScrollRestoration = null;
	    }
	
	    this._saveWindowPositionHandle = null;
	    this._checkWindowScrollHandle = null;
	    this._windowScrollTarget = null;
	    this._numWindowScrollAttempts = 0;
	
	    this._scrollElements = {};
	
	    // We have to listen to each window scroll update rather than to just
	    // location updates, because some browsers will update scroll position
	    // before emitting the location change.
	    (0, _on2.default)(window, 'scroll', this._onWindowScroll);
	
	    this._unlistenBefore = history.listenBefore(function () {
	      if (_this._saveWindowPositionHandle !== null) {
	        _requestAnimationFrame2.default.cancel(_this._saveWindowPositionHandle);
	        _this._saveWindowPositionHandle = null;
	      }
	
	      // It's fine to save element scroll positions here, though; the browser
	      // won't modify them.
	      Object.keys(_this._scrollElements).forEach(function (key) {
	        _this._saveElementPosition(key);
	      });
	    });
	  }
	
	  ScrollBehavior.prototype.stop = function stop() {
	    /* istanbul ignore if: not supported by any browsers on Travis */
	    if (this._oldScrollRestoration) {
	      window.history.scrollRestoration = this._oldScrollRestoration;
	    }
	
	    (0, _off2.default)(window, 'scroll', this._onWindowScroll);
	    this._cancelCheckWindowScroll();
	
	    this._unlistenBefore();
	  };
	
	  ScrollBehavior.prototype.registerElement = function registerElement(key, element, shouldUpdateScroll, context) {
	    !!this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is already an element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    this._scrollElements[key] = { element: element, shouldUpdateScroll: shouldUpdateScroll };
	    this._updateElementScroll(key, null, context);
	  };
	
	  ScrollBehavior.prototype.unregisterElement = function unregisterElement(key) {
	    !this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is no element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    delete this._scrollElements[key];
	  };
	
	  ScrollBehavior.prototype.updateScroll = function updateScroll(prevContext, context) {
	    var _this2 = this;
	
	    this._updateWindowScroll(prevContext, context);
	
	    Object.keys(this._scrollElements).forEach(function (key) {
	      _this2._updateElementScroll(key, prevContext, context);
	    });
	  };
	
	  ScrollBehavior.prototype.readPosition = function readPosition(location, key) {
	    return (0, _DOMStateStorage.readState)(this._getKey(location, key));
	  };
	
	  ScrollBehavior.prototype._cancelCheckWindowScroll = function _cancelCheckWindowScroll() {
	    if (this._checkWindowScrollHandle !== null) {
	      _requestAnimationFrame2.default.cancel(this._checkWindowScrollHandle);
	      this._checkWindowScrollHandle = null;
	    }
	  };
	
	  ScrollBehavior.prototype._saveElementPosition = function _saveElementPosition(key) {
	    var element = this._scrollElements[key].element;
	
	
	    this._savePosition(key, element);
	  };
	
	  ScrollBehavior.prototype._savePosition = function _savePosition(key, element) {
	    // We have to directly update `DOMStateStorage`, because actually updating
	    // the location could cause e.g. React Router to re-render the entire page,
	    // which would lead to observably bad scroll performance.
	    (0, _DOMStateStorage.saveState)(this._getKey(this._getCurrentLocation(), key), [(0, _scrollLeft2.default)(element), (0, _scrollTop2.default)(element)]);
	  };
	
	  ScrollBehavior.prototype._getKey = function _getKey(location, key) {
	    // Use fallback location key when actual location key is unavailable.
	    var locationKey = location.key || this._history.createHref(location);
	
	    return key == null ? '' + KEY_PREFIX + locationKey : '' + KEY_PREFIX + key + '/' + locationKey;
	  };
	
	  ScrollBehavior.prototype._updateWindowScroll = function _updateWindowScroll(prevContext, context) {
	    // Whatever we were doing before isn't relevant any more.
	    this._cancelCheckWindowScroll();
	
	    this._windowScrollTarget = this._getScrollTarget(null, this._shouldUpdateScroll, prevContext, context);
	
	    // Check the scroll position to see if we even need to scroll. This call
	    // will unset _windowScrollTarget if the current scroll position matches
	    // the target.
	    this._onWindowScroll();
	
	    if (!this._windowScrollTarget) {
	      return;
	    }
	
	    // Updating the window scroll position is really flaky. Just trying to
	    // scroll it isn't enough. Instead, try to scroll a few times until it
	    // works.
	    this._numWindowScrollAttempts = 0;
	    this._checkWindowScrollPosition();
	  };
	
	  ScrollBehavior.prototype._updateElementScroll = function _updateElementScroll(key, prevContext, context) {
	    var _scrollElements$key = this._scrollElements[key];
	    var element = _scrollElements$key.element;
	    var shouldUpdateScroll = _scrollElements$key.shouldUpdateScroll;
	
	
	    var scrollTarget = this._getScrollTarget(key, shouldUpdateScroll, prevContext, context);
	    if (!scrollTarget) {
	      return;
	    }
	
	    // Unlike with the window, there shouldn't be any flakiness to deal with
	    // here.
	    var x = scrollTarget[0];
	    var y = scrollTarget[1];
	
	    (0, _scrollLeft2.default)(element, x);
	    (0, _scrollTop2.default)(element, y);
	  };
	
	  ScrollBehavior.prototype._getScrollTarget = function _getScrollTarget(key, shouldUpdateScroll, prevContext, context) {
	    var scrollTarget = shouldUpdateScroll ? shouldUpdateScroll.call(this, prevContext, context) : true;
	
	    if (!scrollTarget || Array.isArray(scrollTarget)) {
	      return scrollTarget;
	    }
	
	    var location = this._getCurrentLocation();
	    if (location.action === _Actions.PUSH) {
	      return [0, 0];
	    }
	
	    return this.readPosition(location, key) || [0, 0];
	  };
	
	  return ScrollBehavior;
	}();
	
	exports.default = ScrollBehavior;
	module.exports = exports['default'];

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(237);
	var off = function off() {};
	
	if (canUseDOM) {
	
	  off = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = off;

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(237);
	var on = function on() {};
	
	if (canUseDOM) {
	  on = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = on;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getWindow = __webpack_require__(240);
	
	module.exports = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	};

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	};

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getWindow = __webpack_require__(240);
	
	module.exports = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var canUseDOM = __webpack_require__(237);
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'],
	    cancel = 'clearTimeout',
	    raf = fallback,
	    compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (canUseDOM) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function (cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function (cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  return window[cancel](id);
	};
	
	module.exports = compatRaf;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _filter = __webpack_require__(244);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _last = __webpack_require__(366);
	
	var _last2 = _interopRequireDefault(_last);
	
	var _sortBy = __webpack_require__(367);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _gatsbyHelpers = __webpack_require__(384);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	function requireComponent(moduleReq) {
	  // Minor differences in `require` behavior across languages
	  // are handled by this wrapper.
	  //
	  // If `moduleReq` is a typescript module (versus javascript/coffeescript)
	  // an object with a `default` property is returned rather than the
	  // default export.
	  var module = moduleReq;
	  if (module.default) {
	    module = module.default;
	  }
	  return module;
	}
	
	module.exports = function (files, pagesReq) {
	  // Remove files that start with an underscore as this indicates
	  // the file shouldn't be turned into a page.
	  var pages = (0, _filter2.default)(files, function (file) {
	    return file.file.name.slice(0, 1) !== '_';
	  });
	  var templates = (0, _filter2.default)(files, function (file) {
	    return (
	      // eslint-disable-next-line comma-dangle
	      file.file.name === '_template'
	    );
	  });
	
	  var routes = {
	    path: (0, _gatsbyHelpers.prefixLink)('/'),
	    component: requireComponent(__webpack_require__(387)),
	    childRoutes: [],
	    indexRoute: {},
	    pages: pages,
	    templates: templates
	  };
	  var notFound = null;
	  var templatesHash = {};
	  templatesHash.root = routes;
	  templatesHash['/'] = routes;
	
	  // Arrange pages in data structure according to their position
	  // on the file system. Then use this to create routes.
	  //
	  // Algorithm
	  // 1. Find all templates.
	  // 2. Create routes for each template russian-doll style.
	  // 3. For each index file paired with a template, create a default route
	  // 4. Create normal routes for each remaining file under the appropriate
	  // template
	  var templatesWithoutRoot = (0, _filter2.default)(files, function (file) {
	    return (
	      // eslint-disable-next-line comma-dangle
	      file.file.name === '_template' && file.file.dirname !== ''
	    );
	  }
	
	  // Find the parent template for each template file and create a route
	  // with it.
	  );templatesWithoutRoot.forEach(function (templateFile) {
	    var parentTemplates = (0, _filter2.default)(templatesWithoutRoot, function (template) {
	      return (
	        // eslint-disable-next-line comma-dangle
	        templateFile.requirePath.indexOf(template.file.dirname) === 0 && templateFile !== template
	      );
	    }
	    // Sort parent templates by directory length. In cases
	    // where a template has multiple parents
	    // e.g. /_template.js/blog/_template.js/archive/_template.js
	    // we want to nest this template under its most immediate parent.
	    );parentTemplates = (0, _sortBy2.default)(parentTemplates, function (template) {
	      if (template) {
	        return template.file.dirname.length;
	      } else {
	        return 0;
	      }
	    });
	    var parentTemplateFile = (0, _last2.default)(parentTemplates);
	    var parentRoute = void 0;
	    if (parentTemplateFile) {
	      parentRoute = templatesHash[parentTemplateFile.file.dirname];
	    }
	    if (!parentRoute) {
	      parentRoute = templatesHash.root;
	    }
	
	    // Create new route for the template.
	    var route = {
	      path: (0, _gatsbyHelpers.prefixLink)(templateFile.templatePath),
	      component: requireComponent(pagesReq('./' + templateFile.requirePath)),
	      childRoutes: [],
	      indexRoute: {},
	      pages: pages,
	      templates: templates,
	      parentTemplateFile: parentTemplateFile
	
	      // Add route to the templates object for easy access.
	    };templatesHash[templateFile.file.dirname] = route;
	
	    // Push new route onto its parent.
	    parentRoute.childRoutes.push(route);
	  });
	
	  var staticFileTypes = ['ipynb', 'md', 'rmd', 'mkd', 'mkdn', 'mdwn', 'mdown', 'markdown', 'litcoffee', 'html', 'json', 'yaml', 'toml'];
	  var reactComponentFileTypes = ['js', 'ts', 'jsx', 'tsx', 'cjsx'];
	  var wrappers = {};
	  staticFileTypes.forEach(function (type) {
	    try {
	      // $FlowIssue - https://github.com/facebook/flow/issues/1975
	      wrappers[type] = __webpack_require__(391)("./" + type);
	    } catch (e) {
	      // Ignore module not found errors; show others on console
	      if (e.code !== 'MODULE_NOT_FOUND' && e.message && !e.message.match(/^Cannot find module/) && typeof console !== 'undefined') {
	        console.error('Error requiring wrapper', type, ':', e);
	      }
	    }
	  });
	
	  pages.forEach(function (p) {
	    var page = p;
	    var handler = void 0;
	    if (staticFileTypes.indexOf(page.file.ext) !== -1) {
	      handler = wrappers[page.file.ext];
	      page.data = pagesReq('./' + page.requirePath);
	    } else if (reactComponentFileTypes.indexOf(page.file.ext) !== -1) {
	      handler = requireComponent(pagesReq('./' + page.requirePath));
	      page.data = page.data === undefined ? {} : page.data;
	    }
	
	    // Determine parent template for page.
	    var parentTemplates = (0, _filter2.default)(templatesWithoutRoot, function (templateFile) {
	      return (
	        // eslint-disable-next-line comma-dangle
	        page.requirePath.indexOf(templateFile.file.dirname) === 0
	      );
	    });
	
	    var sortedParentTemplates = (0, _sortBy2.default)(parentTemplates, function (route) {
	      return route.file.dirname.length;
	    });
	
	    var parentTemplateFile = (0, _last2.default)(sortedParentTemplates);
	    var parentRoute = void 0;
	    if (parentTemplateFile) {
	      parentRoute = templatesHash[parentTemplateFile.file.dirname];
	    }
	
	    if (!parentRoute) {
	      parentRoute = templatesHash.root;
	    }
	
	    // If page is an index page *and* has the same path as its parentRoute,
	    // it is the index route (for that template).
	    if (page.file.name === 'index' && (0, _gatsbyHelpers.prefixLink)(page.path) === parentRoute.path) {
	      parentRoute.indexRoute = {
	        component: handler,
	        page: page,
	        pages: pages,
	        templates: templates,
	        parentTemplateFile: parentTemplateFile
	      };
	    } else {
	      parentRoute.childRoutes.push({
	        path: (0, _gatsbyHelpers.prefixLink)(page.path),
	        component: handler,
	        page: page,
	        pages: pages,
	        templates: templates,
	        parentTemplateFile: parentTemplateFile
	      });
	    }
	
	    if (page.path.indexOf('/404') !== -1) {
	      notFound = {
	        path: '*',
	        component: handler,
	        page: page,
	        pages: pages,
	        templates: templates,
	        parentTemplateFile: parentTemplateFile
	      };
	    }
	  });
	
	  if (notFound) {
	    routes.childRoutes.push(notFound);
	  }
	
	  return routes;
	};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(245),
	    baseFilter = __webpack_require__(246),
	    baseIteratee = __webpack_require__(281),
	    isArray = __webpack_require__(263);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),
/* 245 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(247);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(248),
	    createBaseEach = __webpack_require__(280);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(249),
	    keys = __webpack_require__(251);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(250);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 250 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(252),
	    baseKeys = __webpack_require__(273),
	    isArrayLike = __webpack_require__(277);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(253),
	    isArguments = __webpack_require__(254),
	    isArray = __webpack_require__(263),
	    isBuffer = __webpack_require__(264),
	    isIndex = __webpack_require__(267),
	    isTypedArray = __webpack_require__(268);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 253 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(255),
	    isObjectLike = __webpack_require__(262);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(256),
	    isObjectLike = __webpack_require__(262);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(257),
	    getRawTag = __webpack_require__(260),
	    objectToString = __webpack_require__(261);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(258);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(259);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 259 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(257);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 262 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 263 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(258),
	    stubFalse = __webpack_require__(266);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(265)(module)))

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 266 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 267 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(269),
	    baseUnary = __webpack_require__(271),
	    nodeUtil = __webpack_require__(272);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(256),
	    isLength = __webpack_require__(270),
	    isObjectLike = __webpack_require__(262);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 270 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 271 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(259);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(265)(module)))

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(274),
	    nativeKeys = __webpack_require__(275);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 274 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(276);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 276 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(278),
	    isLength = __webpack_require__(270);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(256),
	    isObject = __webpack_require__(279);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 279 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(277);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(282),
	    baseMatchesProperty = __webpack_require__(346),
	    identity = __webpack_require__(362),
	    isArray = __webpack_require__(263),
	    property = __webpack_require__(363);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(283),
	    getMatchData = __webpack_require__(343),
	    matchesStrictComparable = __webpack_require__(345);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(284),
	    baseIsEqual = __webpack_require__(320);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(285),
	    stackClear = __webpack_require__(293),
	    stackDelete = __webpack_require__(294),
	    stackGet = __webpack_require__(295),
	    stackHas = __webpack_require__(296),
	    stackSet = __webpack_require__(297);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(286),
	    listCacheDelete = __webpack_require__(287),
	    listCacheGet = __webpack_require__(290),
	    listCacheHas = __webpack_require__(291),
	    listCacheSet = __webpack_require__(292);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 286 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(288);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(289);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 289 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(288);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(288);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(288);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(285);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 294 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 295 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 296 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(285),
	    Map = __webpack_require__(298),
	    MapCache = __webpack_require__(305);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(299),
	    root = __webpack_require__(258);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(300),
	    getValue = __webpack_require__(304);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(278),
	    isMasked = __webpack_require__(301),
	    isObject = __webpack_require__(279),
	    toSource = __webpack_require__(303);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(302);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(258);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 303 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 304 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(306),
	    mapCacheDelete = __webpack_require__(314),
	    mapCacheGet = __webpack_require__(317),
	    mapCacheHas = __webpack_require__(318),
	    mapCacheSet = __webpack_require__(319);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(307),
	    ListCache = __webpack_require__(285),
	    Map = __webpack_require__(298);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(308),
	    hashDelete = __webpack_require__(310),
	    hashGet = __webpack_require__(311),
	    hashHas = __webpack_require__(312),
	    hashSet = __webpack_require__(313);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(309);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(299);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 310 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(309);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(309);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(309);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(315);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(316);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(315);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(315);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(315);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(321),
	    isObjectLike = __webpack_require__(262);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(284),
	    equalArrays = __webpack_require__(322),
	    equalByTag = __webpack_require__(328),
	    equalObjects = __webpack_require__(332),
	    getTag = __webpack_require__(338),
	    isArray = __webpack_require__(263),
	    isBuffer = __webpack_require__(264),
	    isTypedArray = __webpack_require__(268);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(323),
	    arraySome = __webpack_require__(326),
	    cacheHas = __webpack_require__(327);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(305),
	    setCacheAdd = __webpack_require__(324),
	    setCacheHas = __webpack_require__(325);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 324 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 325 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 326 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 327 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(257),
	    Uint8Array = __webpack_require__(329),
	    eq = __webpack_require__(289),
	    equalArrays = __webpack_require__(322),
	    mapToArray = __webpack_require__(330),
	    setToArray = __webpack_require__(331);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(258);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 330 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 331 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(333);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(334),
	    getSymbols = __webpack_require__(336),
	    keys = __webpack_require__(251);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(335),
	    isArray = __webpack_require__(263);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(245),
	    stubArray = __webpack_require__(337);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(339),
	    Map = __webpack_require__(298),
	    Promise = __webpack_require__(340),
	    Set = __webpack_require__(341),
	    WeakMap = __webpack_require__(342),
	    baseGetTag = __webpack_require__(256),
	    toSource = __webpack_require__(303);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(299),
	    root = __webpack_require__(258);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(299),
	    root = __webpack_require__(258);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(299),
	    root = __webpack_require__(258);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(299),
	    root = __webpack_require__(258);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(344),
	    keys = __webpack_require__(251);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(279);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 345 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(320),
	    get = __webpack_require__(347),
	    hasIn = __webpack_require__(359),
	    isKey = __webpack_require__(350),
	    isStrictComparable = __webpack_require__(344),
	    matchesStrictComparable = __webpack_require__(345),
	    toKey = __webpack_require__(358);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(348);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(349),
	    toKey = __webpack_require__(358);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(263),
	    isKey = __webpack_require__(350),
	    stringToPath = __webpack_require__(352),
	    toString = __webpack_require__(355);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(263),
	    isSymbol = __webpack_require__(351);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(256),
	    isObjectLike = __webpack_require__(262);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(353);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(354);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(305);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(356);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(257),
	    arrayMap = __webpack_require__(357),
	    isArray = __webpack_require__(263),
	    isSymbol = __webpack_require__(351);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 357 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(351);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(360),
	    hasPath = __webpack_require__(361);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 360 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(349),
	    isArguments = __webpack_require__(254),
	    isArray = __webpack_require__(263),
	    isIndex = __webpack_require__(267),
	    isLength = __webpack_require__(270),
	    toKey = __webpack_require__(358);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 362 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(364),
	    basePropertyDeep = __webpack_require__(365),
	    isKey = __webpack_require__(350),
	    toKey = __webpack_require__(358);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 364 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(348);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 366 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(368),
	    baseOrderBy = __webpack_require__(370),
	    baseRest = __webpack_require__(375),
	    isIterateeCall = __webpack_require__(383);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(335),
	    isFlattenable = __webpack_require__(369);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(257),
	    isArguments = __webpack_require__(254),
	    isArray = __webpack_require__(263);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(357),
	    baseIteratee = __webpack_require__(281),
	    baseMap = __webpack_require__(371),
	    baseSortBy = __webpack_require__(372),
	    baseUnary = __webpack_require__(271),
	    compareMultiple = __webpack_require__(373),
	    identity = __webpack_require__(362);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(247),
	    isArrayLike = __webpack_require__(277);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 372 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(374);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(351);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(362),
	    overRest = __webpack_require__(376),
	    setToString = __webpack_require__(378);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(377);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 377 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(379),
	    shortOut = __webpack_require__(382);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(380),
	    defineProperty = __webpack_require__(381),
	    identity = __webpack_require__(362);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 380 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(299);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(289),
	    isArrayLike = __webpack_require__(277),
	    isIndex = __webpack_require__(267),
	    isObject = __webpack_require__(279);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _config = __webpack_require__(385);
	
	var _invariant = __webpack_require__(179);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isString = __webpack_require__(386);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isDataURL(s) {
	  // Regex from https://gist.github.com/bgrins/6194623#gistcomment-1671744
	  // eslint-disable-next-line
	  var regex = /^\s*data:([a-z]+\/[a-z0-9\-\+]+(;[a-z\-]+=[a-z0-9\-]+)?)?(;base64)?,[a-z0-9!\$&',\(\)\*\+,;=\-\._~:@\/\?%\s]*\s*$/i;
	  return !!s.match(regex);
	}
	
	// Function to add prefix to links.
	/*  weak */
	var prefixLink = function prefixLink(_link) {
	  if (typeof __PREFIX_LINKS__ !== 'undefined' && __PREFIX_LINKS__ !== null && __PREFIX_LINKS__ && _config.config.linkPrefix !== null) {
	    var invariantMessage = '\n    You\'re trying to build your site with links prefixed\n    but you haven\'t set \'linkPrefix\' in your config.toml.\n    ';
	    (0, _invariant2.default)((0, _isString2.default)(_config.config.linkPrefix), invariantMessage
	
	    // When url-loader is used with the limit option, some of images are encoded to
	    // base64 data url, this check prevent such links from being prefixed.
	    );if (isDataURL(_link)) {
	      return _link;
	    } else {
	      if (_link.slice(0, 1) !== '/') {
	        return _config.config.linkPrefix + '/' + _link;
	      }
	      return '' + _config.config.linkPrefix + _link;
	    }
	  } else {
	    return _link;
	  }
	};
	
	module.exports = {
	  prefixLink: prefixLink
	};

/***/ }),
/* 385 */
/***/ (function(module, exports) {

	module.exports = {
		"config": {
			"siteTitle": "Textkrieg",
			"siteDescr": "awkwardness as a service",
			"siteAuthor": "Ada Blitz",
			"siteTwitterUrl": "https://twitter.com/bangpowwww",
			"siteEmailUrl": "mail-to:kontakt@textkrieg.de",
			"googleAnalyticsId": "",
			"linkPrefix": "/gatsby-starter-lumen"
		},
		"relativePath": "",
		"pages": [
			{
				"file": {
					"root": "",
					"dir": "",
					"base": "_template.jsx",
					"ext": "jsx",
					"name": "_template",
					"extname": ".jsx",
					"basename": "_template.jsx",
					"dirname": "",
					"stem": "_template",
					"path": "_template.jsx"
				},
				"requirePath": "_template.jsx",
				"templatePath": "//",
				"data": {}
			},
			{
				"file": {
					"root": "",
					"dir": "10-dinge-die-man-bei-grippe-tun-kann",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "10-dinge-die-man-bei-grippe-tun-kann",
					"stem": "index",
					"path": "10-dinge-die-man-bei-grippe-tun-kann/index.md"
				},
				"requirePath": "10-dinge-die-man-bei-grippe-tun-kann/index.md",
				"path": "/10-dinge-die-man-bei-grippe-tun-kann/",
				"data": {
					"title": "10 Dinge, die man bei Grippe tun kann",
					"date": "2015-03-04 15:12:53 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "10-erkenntnisse-uber-frankreich",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "10-erkenntnisse-uber-frankreich",
					"stem": "index",
					"path": "10-erkenntnisse-uber-frankreich/index.md"
				},
				"requirePath": "10-erkenntnisse-uber-frankreich/index.md",
				"path": "/10-erkenntnisse-uber-frankreich/",
				"data": {
					"title": "10 Erkenntnisse über Frankreich",
					"date": "2014-09-15 13:53:40 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "10-grnde-warum-berlin-out-ist-",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "10-grnde-warum-berlin-out-ist-",
					"stem": "index",
					"path": "10-grnde-warum-berlin-out-ist-/index.md"
				},
				"requirePath": "10-grnde-warum-berlin-out-ist-/index.md",
				"path": "/10-grnde-warum-berlin-out-ist-/",
				"data": {
					"title": "10 Gründe warum Berlin out ist:",
					"date": "2014-02-27 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "",
					"base": "404.md",
					"ext": "md",
					"name": "404",
					"extname": ".md",
					"basename": "404.md",
					"dirname": "",
					"stem": "404",
					"path": "404.md"
				},
				"requirePath": "404.md",
				"path": "/404.html",
				"data": {
					"path": "/404.html",
					"layout": "page"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "99fire-films-award",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "99fire-films-award",
					"stem": "index",
					"path": "99fire-films-award/index.md"
				},
				"requirePath": "99fire-films-award/index.md",
				"path": "/99fire-films-award/",
				"data": {
					"title": "Der 99Fire-Films Award",
					"date": "2012-02-17 11:33:45 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "ada-and-her-dream-of-horses",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "ada-and-her-dream-of-horses",
					"stem": "index",
					"path": "ada-and-her-dream-of-horses/index.md"
				},
				"requirePath": "ada-and-her-dream-of-horses/index.md",
				"path": "/ada-and-her-dream-of-horses/",
				"data": {
					"title": "Ada and her dream of horses",
					"date": "2011-07-19 09:23:12 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "ada-blitzkrieg-das-hoerbuch",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "ada-blitzkrieg-das-hoerbuch",
					"stem": "index",
					"path": "ada-blitzkrieg-das-hoerbuch/index.md"
				},
				"requirePath": "ada-blitzkrieg-das-hoerbuch/index.md",
				"path": "/ada-blitzkrieg-das-hoerbuch/",
				"data": {
					"title": "Ada Blitzkrieg - Das Hörbuch",
					"date": "2011-12-01 18:12:43 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "ada-blitzkrieg-guckt-alles",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "ada-blitzkrieg-guckt-alles",
					"stem": "index",
					"path": "ada-blitzkrieg-guckt-alles/index.md"
				},
				"requirePath": "ada-blitzkrieg-guckt-alles/index.md",
				"path": "/ada-blitzkrieg-guckt-alles/",
				"data": {
					"title": "Ada Blitzkrieg guckt alles",
					"date": "2012-02-26 18:45:06 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "alles-gute-zum-geburtstag-ada",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "alles-gute-zum-geburtstag-ada",
					"stem": "index",
					"path": "alles-gute-zum-geburtstag-ada/index.md"
				},
				"requirePath": "alles-gute-zum-geburtstag-ada/index.md",
				"path": "/alles-gute-zum-geburtstag-ada/",
				"data": {
					"title": "Alles Gute zum Geburtstag Ada!",
					"date": "2011-08-11 13:13:42 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "als-ich-ein-pony-zu-weihnachten-bekam",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "als-ich-ein-pony-zu-weihnachten-bekam",
					"stem": "index",
					"path": "als-ich-ein-pony-zu-weihnachten-bekam/index.md"
				},
				"requirePath": "als-ich-ein-pony-zu-weihnachten-bekam/index.md",
				"path": "/als-ich-ein-pony-zu-weihnachten-bekam/",
				"data": {
					"title": "Als ich ein Pony zu Weihnachten bekam",
					"date": "2012-01-02 13:17:45 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "apartment-hunting-san-francisco",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "apartment-hunting-san-francisco",
					"stem": "index",
					"path": "apartment-hunting-san-francisco/index.md"
				},
				"requirePath": "apartment-hunting-san-francisco/index.md",
				"path": "/apartment-hunting-san-francisco/",
				"data": {
					"title": "Apartment hunting San Francisco",
					"date": "2014-04-23 16:14:03 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "archive-post",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "archive-post",
					"stem": "index",
					"path": "archive-post/index.md"
				},
				"requirePath": "archive-post/index.md",
				"path": "/archive-post/",
				"data": {
					"title": "archive",
					"date": "2012-12-17 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "articles",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "articles",
					"stem": "index",
					"path": "articles/index.md"
				},
				"requirePath": "articles/index.md",
				"path": "/articles/",
				"data": {
					"title": "Articles",
					"date": "2011-03-22 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "audiokrieg-gesammelte-werke-mit-sprachfehler",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "audiokrieg-gesammelte-werke-mit-sprachfehler",
					"stem": "index",
					"path": "audiokrieg-gesammelte-werke-mit-sprachfehler/index.md"
				},
				"requirePath": "audiokrieg-gesammelte-werke-mit-sprachfehler/index.md",
				"path": "/audiokrieg-gesammelte-werke-mit-sprachfehler/",
				"data": {
					"title": "Audiokrieg - Gesammelte Werke mit Sprachfehler",
					"date": "2012-06-06 15:27:45 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "awesome-places-grandmother",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "awesome-places-grandmother",
					"stem": "index",
					"path": "awesome-places-grandmother/index.md"
				},
				"requirePath": "awesome-places-grandmother/index.md",
				"path": "/awesome-places-grandmother/",
				"data": {
					"title": "Awesome Places: Grandmother",
					"date": "2011-11-07 13:07:37 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "balkankrieg-vs-textkrieg",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "balkankrieg-vs-textkrieg",
					"stem": "index",
					"path": "balkankrieg-vs-textkrieg/index.md"
				},
				"requirePath": "balkankrieg-vs-textkrieg/index.md",
				"path": "/balkankrieg-vs-textkrieg/",
				"data": {
					"title": "Balkankrieg vs. Textkrieg",
					"date": "2011-06-27 16:58:41 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "barbara-scheel-anne-will-und-rassismus-bei-den-piraten",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "barbara-scheel-anne-will-und-rassismus-bei-den-piraten",
					"stem": "index",
					"path": "barbara-scheel-anne-will-und-rassismus-bei-den-piraten/index.md"
				},
				"requirePath": "barbara-scheel-anne-will-und-rassismus-bei-den-piraten/index.md",
				"path": "/barbara-scheel-anne-will-und-rassismus-bei-den-piraten/",
				"data": {
					"title": "Barbara Scheel, Anne Will und Rassismus bei den Piraten",
					"date": "2012-03-29 13:49:02 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "batik-3000",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "batik-3000",
					"stem": "index",
					"path": "batik-3000/index.md"
				},
				"requirePath": "batik-3000/index.md",
				"path": "/batik-3000/",
				"data": {
					"title": "Batik3000",
					"date": "2011-06-09 08:54:13 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "batiken-statt-club",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "batiken-statt-club",
					"stem": "index",
					"path": "batiken-statt-club/index.md"
				},
				"requirePath": "batiken-statt-club/index.md",
				"path": "/batiken-statt-club/",
				"data": {
					"title": "Batiken statt Club",
					"date": "2011-06-06 16:25:25 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "baut-mal-was",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "baut-mal-was",
					"stem": "index",
					"path": "baut-mal-was/index.md"
				},
				"requirePath": "baut-mal-was/index.md",
				"path": "/baut-mal-was/",
				"data": {
					"title": "Baut mal was!",
					"date": "2014-06-17 17:29:17 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "berlin-festival-2011",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "berlin-festival-2011",
					"stem": "index",
					"path": "berlin-festival-2011/index.md"
				},
				"requirePath": "berlin-festival-2011/index.md",
				"path": "/berlin-festival-2011/",
				"data": {
					"title": "Berlin Festival 2011",
					"date": "2011-09-12 14:56:52 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "berlins-bestes-franzbrotchen",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "berlins-bestes-franzbrotchen",
					"stem": "index",
					"path": "berlins-bestes-franzbrotchen/index.md"
				},
				"requirePath": "berlins-bestes-franzbrotchen/index.md",
				"path": "/berlins-bestes-franzbrotchen/",
				"data": {
					"title": "Berlins bestes Franzbrötchen",
					"date": "2016-02-25 12:20:39 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "beschauliches-berlin",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "beschauliches-berlin",
					"stem": "index",
					"path": "beschauliches-berlin/index.md"
				},
				"requirePath": "beschauliches-berlin/index.md",
				"path": "/beschauliches-berlin/",
				"data": {
					"title": "Beschauliches Berlin",
					"date": "2011-10-10 14:47:18 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "best-of-republica-2015",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "best-of-republica-2015",
					"stem": "index",
					"path": "best-of-republica-2015/index.md"
				},
				"requirePath": "best-of-republica-2015/index.md",
				"path": "/best-of-republica-2015/",
				"data": {
					"title": "Best of re:publica 2015",
					"date": "2015-05-08 15:51:49 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "bildung-gegen-langeweile",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "bildung-gegen-langeweile",
					"stem": "index",
					"path": "bildung-gegen-langeweile/index.md"
				},
				"requirePath": "bildung-gegen-langeweile/index.md",
				"path": "/bildung-gegen-langeweile/",
				"data": {
					"title": "Bildung gegen Langeweile",
					"date": "2012-11-01 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "blitzkrieg-lesen-den-vierten-affen-bestellen",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "blitzkrieg-lesen-den-vierten-affen-bestellen",
					"stem": "index",
					"path": "blitzkrieg-lesen-den-vierten-affen-bestellen/index.md"
				},
				"requirePath": "blitzkrieg-lesen-den-vierten-affen-bestellen/index.md",
				"path": "/blitzkrieg-lesen-den-vierten-affen-bestellen/",
				"data": {
					"title": "Blitzkrieg lesen? Den vierten Affen bestellen!",
					"date": "2014-05-08 13:23:02 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "blutgrtsche-in-die-homophobie",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "blutgrtsche-in-die-homophobie",
					"stem": "index",
					"path": "blutgrtsche-in-die-homophobie/index.md"
				},
				"requirePath": "blutgrtsche-in-die-homophobie/index.md",
				"path": "/blutgrtsche-in-die-homophobie/",
				"data": {
					"title": "Blutgrätsche in die Homophobie",
					"date": "2013-04-02 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "books",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "books",
					"stem": "index",
					"path": "books/index.md"
				},
				"requirePath": "books/index.md",
				"path": "/books/",
				"data": {
					"title": "Romane von Ada Blitzkrieg",
					"date": "2014-07-24 12:30:31 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "born-in-1985",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "born-in-1985",
					"stem": "index",
					"path": "born-in-1985/index.md"
				},
				"requirePath": "born-in-1985/index.md",
				"path": "/born-in-1985/",
				"data": {
					"title": "Born in 1985",
					"date": "2014-08-22 09:33:50 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "brotaufstrich-hiroshima",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "brotaufstrich-hiroshima",
					"stem": "index",
					"path": "brotaufstrich-hiroshima/index.md"
				},
				"requirePath": "brotaufstrich-hiroshima/index.md",
				"path": "/brotaufstrich-hiroshima/",
				"data": {
					"title": "Brotaufstrich Hiroshima",
					"date": "2011-09-03 13:23:18 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "california-reisestimmung-mit-instagram-surfprints",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "california-reisestimmung-mit-instagram-surfprints",
					"stem": "index",
					"path": "california-reisestimmung-mit-instagram-surfprints/index.md"
				},
				"requirePath": "california-reisestimmung-mit-instagram-surfprints/index.md",
				"path": "/california-reisestimmung-mit-instagram-surfprints/",
				"data": {
					"title": "California Reisestimmung mit Instagram Surfprints",
					"date": "2014-04-28 09:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "cats-dogs-and-cake",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "cats-dogs-and-cake",
					"stem": "index",
					"path": "cats-dogs-and-cake/index.md"
				},
				"requirePath": "cats-dogs-and-cake/index.md",
				"path": "/cats-dogs-and-cake/",
				"data": {
					"title": "Cats, dogs and cake",
					"date": "2012-08-14 14:43:27 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "chaos-communication-camp-2011-erster-teil",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "chaos-communication-camp-2011-erster-teil",
					"stem": "index",
					"path": "chaos-communication-camp-2011-erster-teil/index.md"
				},
				"requirePath": "chaos-communication-camp-2011-erster-teil/index.md",
				"path": "/chaos-communication-camp-2011-erster-teil/",
				"data": {
					"title": "Chaos Communication Camp 2011 - Erster Teil",
					"date": "2011-08-12 11:40:15 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "christmas-mixtape-nock-nock-eggnog",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "christmas-mixtape-nock-nock-eggnog",
					"stem": "index",
					"path": "christmas-mixtape-nock-nock-eggnog/index.md"
				},
				"requirePath": "christmas-mixtape-nock-nock-eggnog/index.md",
				"path": "/christmas-mixtape-nock-nock-eggnog/",
				"data": {
					"title": "Christmas Mixtape: Nock Nock Eggnog",
					"date": "2013-12-21 13:21:32 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "contact",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "contact",
					"stem": "index",
					"path": "contact/index.md"
				},
				"requirePath": "contact/index.md",
				"path": "/contact/",
				"data": {
					"title": "KONTAKT",
					"date": "2011-04-11 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "content/images",
					"base": "README.md",
					"ext": "md",
					"name": "README",
					"extname": ".md",
					"basename": "README.md",
					"dirname": "content/images",
					"stem": "README",
					"path": "content/images/README.md"
				},
				"requirePath": "content/images/README.md",
				"path": "/content/images/README/",
				"data": {}
			},
			{
				"file": {
					"root": "",
					"dir": "dackelkrieg---ein-roman-von-ada-blitzkrieg",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "dackelkrieg---ein-roman-von-ada-blitzkrieg",
					"stem": "index",
					"path": "dackelkrieg---ein-roman-von-ada-blitzkrieg/index.md"
				},
				"requirePath": "dackelkrieg---ein-roman-von-ada-blitzkrieg/index.md",
				"path": "/dackelkrieg---ein-roman-von-ada-blitzkrieg/",
				"data": {
					"title": "DACKELKRIEG - ein Roman von Ada Blitzkrieg",
					"date": "2012-12-15 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "dackelkrieg---hrbuch-und-bekenntnisse",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "dackelkrieg---hrbuch-und-bekenntnisse",
					"stem": "index",
					"path": "dackelkrieg---hrbuch-und-bekenntnisse/index.md"
				},
				"requirePath": "dackelkrieg---hrbuch-und-bekenntnisse/index.md",
				"path": "/dackelkrieg---hrbuch-und-bekenntnisse/",
				"data": {
					"title": "Dackelkrieg - Hörbuch und Bekenntnisse",
					"date": "2013-05-28 08:27:59 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "dackelkrieg",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "dackelkrieg",
					"stem": "index",
					"path": "dackelkrieg/index.md"
				},
				"requirePath": "dackelkrieg/index.md",
				"path": "/dackelkrieg/",
				"data": {
					"title": "DACKELKRIEG - Ein Roman von Ada Blitzkrieg",
					"date": "2012-12-15 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "darf-man-als-moslem-schinkenchips-essen",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "darf-man-als-moslem-schinkenchips-essen",
					"stem": "index",
					"path": "darf-man-als-moslem-schinkenchips-essen/index.md"
				},
				"requirePath": "darf-man-als-moslem-schinkenchips-essen/index.md",
				"path": "/darf-man-als-moslem-schinkenchips-essen/",
				"data": {
					"title": "Darf man als Moslem Schinkenchips essen?",
					"date": "2012-12-09 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "das-ding-mit-den-dobermannvideos",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "das-ding-mit-den-dobermannvideos",
					"stem": "index",
					"path": "das-ding-mit-den-dobermannvideos/index.md"
				},
				"requirePath": "das-ding-mit-den-dobermannvideos/index.md",
				"path": "/das-ding-mit-den-dobermannvideos/",
				"data": {
					"title": "Das Ding mit den Dobermannvideos",
					"date": "2012-05-08 14:27:33 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "das-ding-mit-den-passfotos-ist-ja-so-",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "das-ding-mit-den-passfotos-ist-ja-so-",
					"stem": "index",
					"path": "das-ding-mit-den-passfotos-ist-ja-so-/index.md"
				},
				"requirePath": "das-ding-mit-den-passfotos-ist-ja-so-/index.md",
				"path": "/das-ding-mit-den-passfotos-ist-ja-so-/",
				"data": {
					"title": "Das Ding mit den Passfotos ist ja so:",
					"date": "2012-12-03 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "das-ding-mit-dobermannern-ist-ja-so",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "das-ding-mit-dobermannern-ist-ja-so",
					"stem": "index",
					"path": "das-ding-mit-dobermannern-ist-ja-so/index.md"
				},
				"requirePath": "das-ding-mit-dobermannern-ist-ja-so/index.md",
				"path": "/das-ding-mit-dobermannern-ist-ja-so/",
				"data": {
					"title": "Das Ding mit Dobermännern ist ja so:",
					"date": "2012-05-08 15:29:02 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "das-ding-mit-kurzhaarfrisuren-ist-ja-so",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "das-ding-mit-kurzhaarfrisuren-ist-ja-so",
					"stem": "index",
					"path": "das-ding-mit-kurzhaarfrisuren-ist-ja-so/index.md"
				},
				"requirePath": "das-ding-mit-kurzhaarfrisuren-ist-ja-so/index.md",
				"path": "/das-ding-mit-kurzhaarfrisuren-ist-ja-so/",
				"data": {
					"title": "Das Ding mit Kurzhaarfrisuren ist ja so:",
					"date": "2012-05-31 13:40:37 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "das-kuchenvoting",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "das-kuchenvoting",
					"stem": "index",
					"path": "das-kuchenvoting/index.md"
				},
				"requirePath": "das-kuchenvoting/index.md",
				"path": "/das-kuchenvoting/",
				"data": {
					"title": "Das Kuchenvoting",
					"date": "2011-11-21 16:13:46 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "der-blitz-geht-nach-san-francisco",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "der-blitz-geht-nach-san-francisco",
					"stem": "index",
					"path": "der-blitz-geht-nach-san-francisco/index.md"
				},
				"requirePath": "der-blitz-geht-nach-san-francisco/index.md",
				"path": "/der-blitz-geht-nach-san-francisco/",
				"data": {
					"title": "Der Blitz geht nach San Francisco",
					"date": "2014-04-16 16:42:15 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "der-plural-von-poster-lautet-nicht-posters",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "der-plural-von-poster-lautet-nicht-posters",
					"stem": "index",
					"path": "der-plural-von-poster-lautet-nicht-posters/index.md"
				},
				"requirePath": "der-plural-von-poster-lautet-nicht-posters/index.md",
				"path": "/der-plural-von-poster-lautet-nicht-posters/",
				"data": {
					"title": "Der Plural von Poster lautet nicht Posters",
					"date": "2012-05-22 14:58:50 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "deutsche-und-humor-wetten-dass",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "deutsche-und-humor-wetten-dass",
					"stem": "index",
					"path": "deutsche-und-humor-wetten-dass/index.md"
				},
				"requirePath": "deutsche-und-humor-wetten-dass/index.md",
				"path": "/deutsche-und-humor-wetten-dass/",
				"data": {
					"title": "Deutsche und Humor - Wetten, dass..?",
					"date": "2014-10-30 17:50:15 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "die-90er-megaparty-oder-wege-in-die-misanthropie",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "die-90er-megaparty-oder-wege-in-die-misanthropie",
					"stem": "index",
					"path": "die-90er-megaparty-oder-wege-in-die-misanthropie/index.md"
				},
				"requirePath": "die-90er-megaparty-oder-wege-in-die-misanthropie/index.md",
				"path": "/die-90er-megaparty-oder-wege-in-die-misanthropie/",
				"data": {
					"title": "Die 90er Megaparty oder Wege in die Misanthropie",
					"date": "2011-10-16 14:54:54 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "die-ada-blitzkrieg-homestory-ii",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "die-ada-blitzkrieg-homestory-ii",
					"stem": "index",
					"path": "die-ada-blitzkrieg-homestory-ii/index.md"
				},
				"requirePath": "die-ada-blitzkrieg-homestory-ii/index.md",
				"path": "/die-ada-blitzkrieg-homestory-ii/",
				"data": {
					"title": "Die Ada Blitzkrieg Homestory II",
					"date": "2013-04-23 16:06:11 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "die-blitzkrieg-filmographie",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "die-blitzkrieg-filmographie",
					"stem": "index",
					"path": "die-blitzkrieg-filmographie/index.md"
				},
				"requirePath": "die-blitzkrieg-filmographie/index.md",
				"path": "/die-blitzkrieg-filmographie/",
				"data": {
					"title": "Die Blitzkrieg Filmographie",
					"date": "2015-02-16 16:34:36 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "die-durum-depression",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "die-durum-depression",
					"stem": "index",
					"path": "die-durum-depression/index.md"
				},
				"requirePath": "die-durum-depression/index.md",
				"path": "/die-durum-depression/",
				"data": {
					"title": "Die Dürüm Depression",
					"date": "2014-08-05 14:43:44 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "die-illusion-einer-uberflussgesellschaft-containern-in-berlin",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "die-illusion-einer-uberflussgesellschaft-containern-in-berlin",
					"stem": "index",
					"path": "die-illusion-einer-uberflussgesellschaft-containern-in-berlin/index.md"
				},
				"requirePath": "die-illusion-einer-uberflussgesellschaft-containern-in-berlin/index.md",
				"path": "/die-illusion-einer-uberflussgesellschaft-containern-in-berlin/",
				"data": {
					"title": "Die Illusion einer Überflussgesellschaft - Containern in Berlin",
					"date": "2012-04-20 15:18:44 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "die-naziheimat-mochte-keine-moschee",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "die-naziheimat-mochte-keine-moschee",
					"stem": "index",
					"path": "die-naziheimat-mochte-keine-moschee/index.md"
				},
				"requirePath": "die-naziheimat-mochte-keine-moschee/index.md",
				"path": "/die-naziheimat-mochte-keine-moschee/",
				"data": {
					"title": "Die Naziheimat möchte keine Moschee",
					"date": "2014-10-17 17:10:40 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "die-strenge",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "die-strenge",
					"stem": "index",
					"path": "die-strenge/index.md"
				},
				"requirePath": "die-strenge/index.md",
				"path": "/die-strenge/",
				"data": {
					"title": "DIE STRENGE - Ein Leseheft von Ada Blitzkrieg",
					"date": "2014-07-24 11:23:02 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "die-zukunft-der-printmedien",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "die-zukunft-der-printmedien",
					"stem": "index",
					"path": "die-zukunft-der-printmedien/index.md"
				},
				"requirePath": "die-zukunft-der-printmedien/index.md",
				"path": "/die-zukunft-der-printmedien/",
				"data": {
					"title": "Die Zukunft der Printmedien",
					"date": "2013-03-03 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "dienstleister-die-auf-dich-scheieen-dhl",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "dienstleister-die-auf-dich-scheieen-dhl",
					"stem": "index",
					"path": "dienstleister-die-auf-dich-scheieen-dhl/index.md"
				},
				"requirePath": "dienstleister-die-auf-dich-scheieen-dhl/index.md",
				"path": "/dienstleister-die-auf-dich-scheieen-dhl/",
				"data": {
					"title": "Dienstleister, die auf Dich scheißen: DHL",
					"date": "2011-11-16 13:01:17 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "diy-cookies",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "diy-cookies",
					"stem": "index",
					"path": "diy-cookies/index.md"
				},
				"requirePath": "diy-cookies/index.md",
				"path": "/diy-cookies/",
				"data": {
					"title": "DIY Cookies",
					"date": "2012-08-06 14:53:52 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "ein-sonntag-auf-dem-dachshundrennen",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "ein-sonntag-auf-dem-dachshundrennen",
					"stem": "index",
					"path": "ein-sonntag-auf-dem-dachshundrennen/index.md"
				},
				"requirePath": "ein-sonntag-auf-dem-dachshundrennen/index.md",
				"path": "/ein-sonntag-auf-dem-dachshundrennen/",
				"data": {
					"title": "Ein Sonntag beim Dachshundrennen",
					"date": "2011-09-07 15:30:58 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "eine-bestandsaufnahme",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "eine-bestandsaufnahme",
					"stem": "index",
					"path": "eine-bestandsaufnahme/index.md"
				},
				"requirePath": "eine-bestandsaufnahme/index.md",
				"path": "/eine-bestandsaufnahme/",
				"data": {
					"title": "Die späten 90er und das Millenium - eine Bestandsaufnahme",
					"date": "2011-12-06 16:15:51 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "endstation-weisensee",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "endstation-weisensee",
					"stem": "index",
					"path": "endstation-weisensee/index.md"
				},
				"requirePath": "endstation-weisensee/index.md",
				"path": "/endstation-weisensee/",
				"data": {
					"title": "Endstation Weißensee",
					"date": "2011-06-03 08:55:49 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "erfolgreiche-frauen-im-internet---keine-liebesgeschichte",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "erfolgreiche-frauen-im-internet---keine-liebesgeschichte",
					"stem": "index",
					"path": "erfolgreiche-frauen-im-internet---keine-liebesgeschichte/index.md"
				},
				"requirePath": "erfolgreiche-frauen-im-internet---keine-liebesgeschichte/index.md",
				"path": "/erfolgreiche-frauen-im-internet---keine-liebesgeschichte/",
				"data": {
					"title": "Erfolgreiche Frauen im Internet - keine Liebesgeschichte",
					"date": "2013-06-10 18:30:15 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "erfolgreiche-frauen-und-das-impostor-syndrom",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "erfolgreiche-frauen-und-das-impostor-syndrom",
					"stem": "index",
					"path": "erfolgreiche-frauen-und-das-impostor-syndrom/index.md"
				},
				"requirePath": "erfolgreiche-frauen-und-das-impostor-syndrom/index.md",
				"path": "/erfolgreiche-frauen-und-das-impostor-syndrom/",
				"data": {
					"title": "Erfolgreiche Frauen und das Impostor Syndrom",
					"date": "2016-03-31 11:04:14 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "eure-meinung-zu-adhs-interessiert-mich-nicht",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "eure-meinung-zu-adhs-interessiert-mich-nicht",
					"stem": "index",
					"path": "eure-meinung-zu-adhs-interessiert-mich-nicht/index.md"
				},
				"requirePath": "eure-meinung-zu-adhs-interessiert-mich-nicht/index.md",
				"path": "/eure-meinung-zu-adhs-interessiert-mich-nicht/",
				"data": {
					"title": "Eure Meinung zu ADHS interessiert mich nicht",
					"date": "2014-02-06 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "exciting-autumn",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "exciting-autumn",
					"stem": "index",
					"path": "exciting-autumn/index.md"
				},
				"requirePath": "exciting-autumn/index.md",
				"path": "/exciting-autumn/",
				"data": {
					"title": "Exciting Autumn",
					"date": "2012-10-30 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "fashion-entry-mein-lieblingsshirt",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "fashion-entry-mein-lieblingsshirt",
					"stem": "index",
					"path": "fashion-entry-mein-lieblingsshirt/index.md"
				},
				"requirePath": "fashion-entry-mein-lieblingsshirt/index.md",
				"path": "/fashion-entry-mein-lieblingsshirt/",
				"data": {
					"title": "Fashion Entry: Mein Lieblingsshirt",
					"date": "2015-01-21 15:12:50 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "fatshaming-in-san-francisco-und-berlin",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "fatshaming-in-san-francisco-und-berlin",
					"stem": "index",
					"path": "fatshaming-in-san-francisco-und-berlin/index.md"
				},
				"requirePath": "fatshaming-in-san-francisco-und-berlin/index.md",
				"path": "/fatshaming-in-san-francisco-und-berlin/",
				"data": {
					"title": "Fatshaming in San Francisco und Berlin",
					"date": "2014-11-14 21:05:51 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "fernsehprogramm",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "fernsehprogramm",
					"stem": "index",
					"path": "fernsehprogramm/index.md"
				},
				"requirePath": "fernsehprogramm/index.md",
				"path": "/fernsehprogramm/",
				"data": {
					"title": "Bestimmt mein Fernsehprogramm für einen schlechten Zweck!",
					"date": "2012-02-14 13:21:49 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "fischinstallationen-im-offentlichen-raum",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "fischinstallationen-im-offentlichen-raum",
					"stem": "index",
					"path": "fischinstallationen-im-offentlichen-raum/index.md"
				},
				"requirePath": "fischinstallationen-im-offentlichen-raum/index.md",
				"path": "/fischinstallationen-im-offentlichen-raum/",
				"data": {
					"title": "Fischinstallationen im öffentlichen Raum",
					"date": "2012-04-02 13:11:23 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "food-truck-your-life",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "food-truck-your-life",
					"stem": "index",
					"path": "food-truck-your-life/index.md"
				},
				"requirePath": "food-truck-your-life/index.md",
				"path": "/food-truck-your-life/",
				"data": {
					"title": "Food Truck Your Life!",
					"date": "2014-03-27 14:34:01 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "freelance",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "freelance",
					"stem": "index",
					"path": "freelance/index.md"
				},
				"requirePath": "freelance/index.md",
				"path": "/freelance/",
				"data": {
					"title": "FREELANCE",
					"date": "2014-02-25T00:00:00.000+00:00",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "furnished-apartment-in-berlin-kreuzberg-for-18-months",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "furnished-apartment-in-berlin-kreuzberg-for-18-months",
					"stem": "index",
					"path": "furnished-apartment-in-berlin-kreuzberg-for-18-months/index.md"
				},
				"requirePath": "furnished-apartment-in-berlin-kreuzberg-for-18-months/index.md",
				"path": "/furnished-apartment-in-berlin-kreuzberg-for-18-months/",
				"data": {
					"title": "Furnished apartment in Berlin Kreuzberg for 18 months",
					"date": "2014-04-30 14:42:56 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "fusion-festival-2011",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "fusion-festival-2011",
					"stem": "index",
					"path": "fusion-festival-2011/index.md"
				},
				"requirePath": "fusion-festival-2011/index.md",
				"path": "/fusion-festival-2011/",
				"data": {
					"title": "Fusion Festival 2011",
					"date": "2011-07-04 07:57:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "gallery",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "gallery",
					"stem": "index",
					"path": "gallery/index.md"
				},
				"requirePath": "gallery/index.md",
				"path": "/gallery/",
				"data": {
					"title": "Gallery",
					"date": "2012-12-02 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "german-food-vs-amerikanisches-essen",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "german-food-vs-amerikanisches-essen",
					"stem": "index",
					"path": "german-food-vs-amerikanisches-essen/index.md"
				},
				"requirePath": "german-food-vs-amerikanisches-essen/index.md",
				"path": "/german-food-vs-amerikanisches-essen/",
				"data": {
					"title": "German Food vs. amerikanisches Essen",
					"date": "2014-04-03 15:10:32 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "gewinner-des-pferdefunpakets",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "gewinner-des-pferdefunpakets",
					"stem": "index",
					"path": "gewinner-des-pferdefunpakets/index.md"
				},
				"requirePath": "gewinner-des-pferdefunpakets/index.md",
				"path": "/gewinner-des-pferdefunpakets/",
				"data": {
					"title": "Gewinner des Pferdefunpakets",
					"date": "2011-08-01 13:35:37 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "gewinnspiel-mit-pferde-merchandise",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "gewinnspiel-mit-pferde-merchandise",
					"stem": "index",
					"path": "gewinnspiel-mit-pferde-merchandise/index.md"
				},
				"requirePath": "gewinnspiel-mit-pferde-merchandise/index.md",
				"path": "/gewinnspiel-mit-pferde-merchandise/",
				"data": {
					"title": "Gewinnspiel mit Pferde-Merchandise",
					"date": "2011-07-09 13:05:42 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "girls-who-release",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "girls-who-release",
					"stem": "index",
					"path": "girls-who-release/index.md"
				},
				"requirePath": "girls-who-release/index.md",
				"path": "/girls-who-release/",
				"data": {
					"title": "Girls who release",
					"date": "2015-10-05 09:09:33 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "google-analytics-bewaffnete-affen-und-katzen-mit-busen",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "google-analytics-bewaffnete-affen-und-katzen-mit-busen",
					"stem": "index",
					"path": "google-analytics-bewaffnete-affen-und-katzen-mit-busen/index.md"
				},
				"requirePath": "google-analytics-bewaffnete-affen-und-katzen-mit-busen/index.md",
				"path": "/google-analytics-bewaffnete-affen-und-katzen-mit-busen/",
				"data": {
					"title": "Google Analytics - Bewaffnete Affen und Katzen mit Busen",
					"date": "2012-06-11 14:02:22 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "googledogs-is-my-startup",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "googledogs-is-my-startup",
					"stem": "index",
					"path": "googledogs-is-my-startup/index.md"
				},
				"requirePath": "googledogs-is-my-startup/index.md",
				"path": "/googledogs-is-my-startup/",
				"data": {
					"title": "Googledogs is my startup",
					"date": "2012-06-20 09:52:42 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "guide-ekelhaftes-berlin",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "guide-ekelhaftes-berlin",
					"stem": "index",
					"path": "guide-ekelhaftes-berlin/index.md"
				},
				"requirePath": "guide-ekelhaftes-berlin/index.md",
				"path": "/guide-ekelhaftes-berlin/",
				"data": {
					"title": "Guide: Ekelhaftes Berlin",
					"date": "2014-08-13 16:21:54 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "guide-how-to-bath-a-cat",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "guide-how-to-bath-a-cat",
					"stem": "index",
					"path": "guide-how-to-bath-a-cat/index.md"
				},
				"requirePath": "guide-how-to-bath-a-cat/index.md",
				"path": "/guide-how-to-bath-a-cat/",
				"data": {
					"title": "Guide: How to bathe a cat",
					"date": "2014-03-25 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "guide-to-dublin",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "guide-to-dublin",
					"stem": "index",
					"path": "guide-to-dublin/index.md"
				},
				"requirePath": "guide-to-dublin/index.md",
				"path": "/guide-to-dublin/",
				"data": {
					"title": "Guide to Dublin",
					"date": "2015-04-01 16:54:29 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "happiness-eine-dystopie",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "happiness-eine-dystopie",
					"stem": "index",
					"path": "happiness-eine-dystopie/index.md"
				},
				"requirePath": "happiness-eine-dystopie/index.md",
				"path": "/happiness-eine-dystopie/",
				"data": {
					"title": "Happiness - eine Dystopie",
					"date": "2012-02-23 11:58:54 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "hello-san-francisco-mixtape",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "hello-san-francisco-mixtape",
					"stem": "index",
					"path": "hello-san-francisco-mixtape/index.md"
				},
				"requirePath": "hello-san-francisco-mixtape/index.md",
				"path": "/hello-san-francisco-mixtape/",
				"data": {
					"title": "Hello San Francisco: Mixtape",
					"date": "2014-09-30 12:30:15 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "hipster-outtakes",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "hipster-outtakes",
					"stem": "index",
					"path": "hipster-outtakes/index.md"
				},
				"requirePath": "hipster-outtakes/index.md",
				"path": "/hipster-outtakes/",
				"data": {
					"title": "Hipster Outtakes",
					"date": "2012-08-01 11:17:54 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "hipster-und-deutsche-vorurteile",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "hipster-und-deutsche-vorurteile",
					"stem": "index",
					"path": "hipster-und-deutsche-vorurteile/index.md"
				},
				"requirePath": "hipster-und-deutsche-vorurteile/index.md",
				"path": "/hipster-und-deutsche-vorurteile/",
				"data": {
					"title": "San Francisco Hipstercity und deutsche Vorurteile",
					"date": "2012-08-30 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "homestory",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "homestory",
					"stem": "index",
					"path": "homestory/index.md"
				},
				"requirePath": "homestory/index.md",
				"path": "/homestory/",
				"data": {
					"title": "Die Ada Blitzkrieg Homestory",
					"date": "2011-10-10 17:20:05 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "horses-and-their-dream-of-ada",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "horses-and-their-dream-of-ada",
					"stem": "index",
					"path": "horses-and-their-dream-of-ada/index.md"
				},
				"requirePath": "horses-and-their-dream-of-ada/index.md",
				"path": "/horses-and-their-dream-of-ada/",
				"data": {
					"title": "Horses and their dream of Ada",
					"date": "2012-03-19 16:05:34 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "how-to-hack-pesto",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "how-to-hack-pesto",
					"stem": "index",
					"path": "how-to-hack-pesto/index.md"
				},
				"requirePath": "how-to-hack-pesto/index.md",
				"path": "/how-to-hack-pesto/",
				"data": {
					"title": "How to hack pesto",
					"date": "2012-06-14 16:46:18 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "how-to-make-kimchi-fried-rice-with-tofu",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "how-to-make-kimchi-fried-rice-with-tofu",
					"stem": "index",
					"path": "how-to-make-kimchi-fried-rice-with-tofu/index.md"
				},
				"requirePath": "how-to-make-kimchi-fried-rice-with-tofu/index.md",
				"path": "/how-to-make-kimchi-fried-rice-with-tofu/",
				"data": {
					"title": "How to make Kimchi Fried Rice with Tofu",
					"date": "2017-03-14 10:22:09 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "i-talked-die-interviews",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "i-talked-die-interviews",
					"stem": "index",
					"path": "i-talked-die-interviews/index.md"
				},
				"requirePath": "i-talked-die-interviews/index.md",
				"path": "/i-talked-die-interviews/",
				"data": {
					"title": "I talked - die Interviews",
					"date": "2014-04-30 14:42:31 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "ich-mochte-teil-einer-jugendgefahrdung-sein",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "ich-mochte-teil-einer-jugendgefahrdung-sein",
					"stem": "index",
					"path": "ich-mochte-teil-einer-jugendgefahrdung-sein/index.md"
				},
				"requirePath": "ich-mochte-teil-einer-jugendgefahrdung-sein/index.md",
				"path": "/ich-mochte-teil-einer-jugendgefahrdung-sein/",
				"data": {
					"title": "Ich möchte Teil einer Jugendgefährdung sein",
					"date": "2011-09-11 15:54:09 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "ich-muss-etwas-beichten",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "ich-muss-etwas-beichten",
					"stem": "index",
					"path": "ich-muss-etwas-beichten/index.md"
				},
				"requirePath": "ich-muss-etwas-beichten/index.md",
				"path": "/ich-muss-etwas-beichten/",
				"data": {
					"title": "Ich muss etwas beichten",
					"date": "2015-03-05 10:04:28 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "im-test-vietnamesischer-groemarkt",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "im-test-vietnamesischer-groemarkt",
					"stem": "index",
					"path": "im-test-vietnamesischer-groemarkt/index.md"
				},
				"requirePath": "im-test-vietnamesischer-groemarkt/index.md",
				"path": "/im-test-vietnamesischer-groemarkt/",
				"data": {
					"title": "Im Test: Vietnamesischer Großmarkt",
					"date": "2011-08-17 17:31:59 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "",
					"base": "index.jsx",
					"ext": "jsx",
					"name": "index",
					"extname": ".jsx",
					"basename": "index.jsx",
					"dirname": "",
					"stem": "index",
					"path": "index.jsx"
				},
				"requirePath": "index.jsx",
				"path": "/",
				"data": {}
			},
			{
				"file": {
					"root": "",
					"dir": "interessengemeinschaft-batiken-n-e-v",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "interessengemeinschaft-batiken-n-e-v",
					"stem": "index",
					"path": "interessengemeinschaft-batiken-n-e-v/index.md"
				},
				"requirePath": "interessengemeinschaft-batiken-n-e-v/index.md",
				"path": "/interessengemeinschaft-batiken-n-e-v/",
				"data": {
					"title": "Interessengemeinschaft Batiken n.e.V.",
					"date": "2011-06-23 11:54:39 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "intro-album-preview-mit-lady-gaga-im-berghain",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "intro-album-preview-mit-lady-gaga-im-berghain",
					"stem": "index",
					"path": "intro-album-preview-mit-lady-gaga-im-berghain/index.md"
				},
				"requirePath": "intro-album-preview-mit-lady-gaga-im-berghain/index.md",
				"path": "/intro-album-preview-mit-lady-gaga-im-berghain/",
				"data": {
					"title": "INTRO Album Preview mit Lady Gaga im Berghain",
					"date": "2014-01-09 09:27:54 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "intro-jahrescharts-2012",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "intro-jahrescharts-2012",
					"stem": "index",
					"path": "intro-jahrescharts-2012/index.md"
				},
				"requirePath": "intro-jahrescharts-2012/index.md",
				"path": "/intro-jahrescharts-2012/",
				"data": {
					"title": "INTRO Jahrescharts 2012",
					"date": "2012-12-02 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "intro-jahrescharts",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "intro-jahrescharts",
					"stem": "index",
					"path": "intro-jahrescharts/index.md"
				},
				"requirePath": "intro-jahrescharts/index.md",
				"path": "/intro-jahrescharts/",
				"data": {
					"title": "INTRO Jahrescharts",
					"date": "2011-12-09 12:09:31 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "intro-kolumne-20-dinge-die-ich-bei-wetten-dass-gelernt-habe",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "intro-kolumne-20-dinge-die-ich-bei-wetten-dass-gelernt-habe",
					"stem": "index",
					"path": "intro-kolumne-20-dinge-die-ich-bei-wetten-dass-gelernt-habe/index.md"
				},
				"requirePath": "intro-kolumne-20-dinge-die-ich-bei-wetten-dass-gelernt-habe/index.md",
				"path": "/intro-kolumne-20-dinge-die-ich-bei-wetten-dass-gelernt-habe/",
				"data": {
					"title": "INTRO Kolumne: 20 Dinge, die ich bei Wetten, dass...? gelernt habe",
					"date": "2013-08-27 09:53:38 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "intro-kolumne-breaking-bad-in-deutschland",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "intro-kolumne-breaking-bad-in-deutschland",
					"stem": "index",
					"path": "intro-kolumne-breaking-bad-in-deutschland/index.md"
				},
				"requirePath": "intro-kolumne-breaking-bad-in-deutschland/index.md",
				"path": "/intro-kolumne-breaking-bad-in-deutschland/",
				"data": {
					"title": "INTRO Kolumne: Breaking Bad in Deutschland",
					"date": "2013-08-29 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "intro-kolumne-csi-ottweiler-die-deutschen-und-ihr-tatort",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "intro-kolumne-csi-ottweiler-die-deutschen-und-ihr-tatort",
					"stem": "index",
					"path": "intro-kolumne-csi-ottweiler-die-deutschen-und-ihr-tatort/index.md"
				},
				"requirePath": "intro-kolumne-csi-ottweiler-die-deutschen-und-ihr-tatort/index.md",
				"path": "/intro-kolumne-csi-ottweiler-die-deutschen-und-ihr-tatort/",
				"data": {
					"title": "INTRO Kolumne: CSI Ottweiler  Die Deutschen und ihr Tatort",
					"date": "2013-08-27 09:52:33 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "intro-kolumne-dschungelcamp",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "intro-kolumne-dschungelcamp",
					"stem": "index",
					"path": "intro-kolumne-dschungelcamp/index.md"
				},
				"requirePath": "intro-kolumne-dschungelcamp/index.md",
				"path": "/intro-kolumne-dschungelcamp/",
				"data": {
					"title": "INTRO Kolumne: Dschungelcamp",
					"date": "2014-01-27 11:13:34 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "intro-kolumne-fernseh-dit",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "intro-kolumne-fernseh-dit",
					"stem": "index",
					"path": "intro-kolumne-fernseh-dit/index.md"
				},
				"requirePath": "intro-kolumne-fernseh-dit/index.md",
				"path": "/intro-kolumne-fernseh-dit/",
				"data": {
					"title": "INTRO Kolumne: Fernseh-Diät",
					"date": "2014-01-09 09:17:53 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "intro-kolumne-germanys-next-hochwasser-contest",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "intro-kolumne-germanys-next-hochwasser-contest",
					"stem": "index",
					"path": "intro-kolumne-germanys-next-hochwasser-contest/index.md"
				},
				"requirePath": "intro-kolumne-germanys-next-hochwasser-contest/index.md",
				"path": "/intro-kolumne-germanys-next-hochwasser-contest/",
				"data": {
					"title": "INTRO Kolumne: Germanys Next Hochwasser-Contest",
					"date": "2013-08-27 09:53:10 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "intro-kolumne-got-to-dance",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "intro-kolumne-got-to-dance",
					"stem": "index",
					"path": "intro-kolumne-got-to-dance/index.md"
				},
				"requirePath": "intro-kolumne-got-to-dance/index.md",
				"path": "/intro-kolumne-got-to-dance/",
				"data": {
					"title": "INTRO Kolumne: Got To Dance",
					"date": "2013-08-27 09:53:18 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "intro-kolumne-markus-lanz-ein-backstreet-boy-auf-der-ersatzbank",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "intro-kolumne-markus-lanz-ein-backstreet-boy-auf-der-ersatzbank",
					"stem": "index",
					"path": "intro-kolumne-markus-lanz-ein-backstreet-boy-auf-der-ersatzbank/index.md"
				},
				"requirePath": "intro-kolumne-markus-lanz-ein-backstreet-boy-auf-der-ersatzbank/index.md",
				"path": "/intro-kolumne-markus-lanz-ein-backstreet-boy-auf-der-ersatzbank/",
				"data": {
					"title": "INTRO Kolumne: Markus Lanz, ein Backstreet Boy auf der Ersatzbank",
					"date": "2014-01-09 09:22:07 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "intro-kolumne-markus-lanz-und-die-ganzkrperhunziker",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "intro-kolumne-markus-lanz-und-die-ganzkrperhunziker",
					"stem": "index",
					"path": "intro-kolumne-markus-lanz-und-die-ganzkrperhunziker/index.md"
				},
				"requirePath": "intro-kolumne-markus-lanz-und-die-ganzkrperhunziker/index.md",
				"path": "/intro-kolumne-markus-lanz-und-die-ganzkrperhunziker/",
				"data": {
					"title": "INTRO Kolumne: Markus Lanz und die Ganzkörperhunziker",
					"date": "2013-08-27 09:53:24 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "intro-kolumne-sommerloch",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "intro-kolumne-sommerloch",
					"stem": "index",
					"path": "intro-kolumne-sommerloch/index.md"
				},
				"requirePath": "intro-kolumne-sommerloch/index.md",
				"path": "/intro-kolumne-sommerloch/",
				"data": {
					"title": "INTRO Kolumne: Sommerloch",
					"date": "2013-08-27 09:53:32 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "intro-kolumne-stuckrad-barre",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "intro-kolumne-stuckrad-barre",
					"stem": "index",
					"path": "intro-kolumne-stuckrad-barre/index.md"
				},
				"requirePath": "intro-kolumne-stuckrad-barre/index.md",
				"path": "/intro-kolumne-stuckrad-barre/",
				"data": {
					"title": "INTRO Kolumne: Stuckrad-Barre",
					"date": "2013-09-26 15:01:52 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "intro-kolumne-warum-sich-der-kleine-lord-ruhig-mal-die-haare-waschen-knnte",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "intro-kolumne-warum-sich-der-kleine-lord-ruhig-mal-die-haare-waschen-knnte",
					"stem": "index",
					"path": "intro-kolumne-warum-sich-der-kleine-lord-ruhig-mal-die-haare-waschen-knnte/index.md"
				},
				"requirePath": "intro-kolumne-warum-sich-der-kleine-lord-ruhig-mal-die-haare-waschen-knnte/index.md",
				"path": "/intro-kolumne-warum-sich-der-kleine-lord-ruhig-mal-die-haare-waschen-knnte/",
				"data": {
					"title": "INTRO Kolumne: Warum sich der kleine Lord ruhig mal die Haare waschen könnte",
					"date": "2014-01-09 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "ist-eine-schlgerei-mit-donato-undenkbar",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "ist-eine-schlgerei-mit-donato-undenkbar",
					"stem": "index",
					"path": "ist-eine-schlgerei-mit-donato-undenkbar/index.md"
				},
				"requirePath": "ist-eine-schlgerei-mit-donato-undenkbar/index.md",
				"path": "/ist-eine-schlgerei-mit-donato-undenkbar/",
				"data": {
					"title": "Ist eine Schlägerei mit Donato undenkbar?",
					"date": "2014-03-10 13:14:44 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "jeder-ist-jetzt-30",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "jeder-ist-jetzt-30",
					"stem": "index",
					"path": "jeder-ist-jetzt-30/index.md"
				},
				"requirePath": "jeder-ist-jetzt-30/index.md",
				"path": "/jeder-ist-jetzt-30/",
				"data": {
					"title": "Jeder ist 30",
					"date": "2015-08-12 08:30:43 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "kampagne-zum-fremdschamen",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "kampagne-zum-fremdschamen",
					"stem": "index",
					"path": "kampagne-zum-fremdschamen/index.md"
				},
				"requirePath": "kampagne-zum-fremdschamen/index.md",
				"path": "/kampagne-zum-fremdschamen/",
				"data": {
					"title": "Kampagne zum Fremdschämen",
					"date": "2012-04-18 10:23:18 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "katzen-und-laser-lauert-die-gefahr-in-den-kleinanzeigen",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "katzen-und-laser-lauert-die-gefahr-in-den-kleinanzeigen",
					"stem": "index",
					"path": "katzen-und-laser-lauert-die-gefahr-in-den-kleinanzeigen/index.md"
				},
				"requirePath": "katzen-und-laser-lauert-die-gefahr-in-den-kleinanzeigen/index.md",
				"path": "/katzen-und-laser-lauert-die-gefahr-in-den-kleinanzeigen/",
				"data": {
					"title": "Katzen und Laser, lauert der Tod in den Kleinanzeigen?",
					"date": "2012-10-10 13:22:28 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "kaufen",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "kaufen",
					"stem": "index",
					"path": "kaufen/index.md"
				},
				"requirePath": "kaufen/index.md",
				"path": "/kaufen/",
				"data": {
					"title": "kaufen",
					"date": "2012-12-16 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "keywords",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "keywords",
					"stem": "index",
					"path": "keywords/index.md"
				},
				"requirePath": "keywords/index.md",
				"path": "/keywords/",
				"data": {
					"title": "Keywords und Dackelkrieg",
					"date": "2011-11-17 11:09:42 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "kotti-couture",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "kotti-couture",
					"stem": "index",
					"path": "kotti-couture/index.md"
				},
				"requirePath": "kotti-couture/index.md",
				"path": "/kotti-couture/",
				"data": {
					"title": "Kotti Couture",
					"date": "2011-04-21 15:25:53 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "kultur-enlargement",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "kultur-enlargement",
					"stem": "index",
					"path": "kultur-enlargement/index.md"
				},
				"requirePath": "kultur-enlargement/index.md",
				"path": "/kultur-enlargement/",
				"data": {
					"title": "Kultur Enlargement",
					"date": "2011-04-27 15:19:39 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "lauter-verlorene-manner-frauenquote-und-feminismus",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "lauter-verlorene-manner-frauenquote-und-feminismus",
					"stem": "index",
					"path": "lauter-verlorene-manner-frauenquote-und-feminismus/index.md"
				},
				"requirePath": "lauter-verlorene-manner-frauenquote-und-feminismus/index.md",
				"path": "/lauter-verlorene-manner-frauenquote-und-feminismus/",
				"data": {
					"title": "'Lauter verlorene Männer', Frauenquote und Feminismus",
					"date": "2012-06-07 16:35:09 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "learn-the-kitchenbasics-salsa",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "learn-the-kitchenbasics-salsa",
					"stem": "index",
					"path": "learn-the-kitchenbasics-salsa/index.md"
				},
				"requirePath": "learn-the-kitchenbasics-salsa/index.md",
				"path": "/learn-the-kitchenbasics-salsa/",
				"data": {
					"title": "Learn The Kitchenbasics: Salsa",
					"date": "2012-11-01 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "learn-the-kitchenbasics-selfmade-pasta",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "learn-the-kitchenbasics-selfmade-pasta",
					"stem": "index",
					"path": "learn-the-kitchenbasics-selfmade-pasta/index.md"
				},
				"requirePath": "learn-the-kitchenbasics-selfmade-pasta/index.md",
				"path": "/learn-the-kitchenbasics-selfmade-pasta/",
				"data": {
					"title": "Learn The Kitchenbasics: Selfmade Pasta",
					"date": "2012-11-06 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "lisa-rank-die-klo-im-hals-autorin",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "lisa-rank-die-klo-im-hals-autorin",
					"stem": "index",
					"path": "lisa-rank-die-klo-im-hals-autorin/index.md"
				},
				"requirePath": "lisa-rank-die-klo-im-hals-autorin/index.md",
				"path": "/lisa-rank-die-klo-im-hals-autorin/",
				"data": {
					"title": "Lisa Rank, die Kloß-Im-Hals-Autorin",
					"date": "2013-04-08 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "listen-sind-das-neue-schwarz",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "listen-sind-das-neue-schwarz",
					"stem": "index",
					"path": "listen-sind-das-neue-schwarz/index.md"
				},
				"requirePath": "listen-sind-das-neue-schwarz/index.md",
				"path": "/listen-sind-das-neue-schwarz/",
				"data": {
					"title": "Listen sind das neue Schwarz",
					"date": "2014-05-15 16:49:03 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "lokalradiomoderatoren-beim-bundesvision-songcontest",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "lokalradiomoderatoren-beim-bundesvision-songcontest",
					"stem": "index",
					"path": "lokalradiomoderatoren-beim-bundesvision-songcontest/index.md"
				},
				"requirePath": "lokalradiomoderatoren-beim-bundesvision-songcontest/index.md",
				"path": "/lokalradiomoderatoren-beim-bundesvision-songcontest/",
				"data": {
					"title": "Lokalradiomoderatoren beim Bundesvisíon Songcontest",
					"date": "2011-09-30 16:06:27 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mal-ganz-unter-uns-rezeptlieblinge",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mal-ganz-unter-uns-rezeptlieblinge",
					"stem": "index",
					"path": "mal-ganz-unter-uns-rezeptlieblinge/index.md"
				},
				"requirePath": "mal-ganz-unter-uns-rezeptlieblinge/index.md",
				"path": "/mal-ganz-unter-uns-rezeptlieblinge/",
				"data": {
					"title": "Mal ganz unter uns: Rezeptlieblinge",
					"date": "2015-05-29 09:25:46 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "marathonmann",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "marathonmann",
					"stem": "index",
					"path": "marathonmann/index.md"
				},
				"requirePath": "marathonmann/index.md",
				"path": "/marathonmann/",
				"data": {
					"title": "Marathonmann",
					"date": "2011-07-14 15:28:39 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mein-neues-buch-ist-erschienen-die-strenge",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mein-neues-buch-ist-erschienen-die-strenge",
					"stem": "index",
					"path": "mein-neues-buch-ist-erschienen-die-strenge/index.md"
				},
				"requirePath": "mein-neues-buch-ist-erschienen-die-strenge/index.md",
				"path": "/mein-neues-buch-ist-erschienen-die-strenge/",
				"data": {
					"title": "Mein neues Buch ist erschienen: Die Strenge",
					"date": "2013-09-26 15:19:09 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mein-zweiter-roman---verlage-vor",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mein-zweiter-roman---verlage-vor",
					"stem": "index",
					"path": "mein-zweiter-roman---verlage-vor/index.md"
				},
				"requirePath": "mein-zweiter-roman---verlage-vor/index.md",
				"path": "/mein-zweiter-roman---verlage-vor/",
				"data": {
					"title": "Mein zweiter Roman - Verlage vor!",
					"date": "2014-03-14 14:32:14 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "meine-leistungen-als-freiberuflerin",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "meine-leistungen-als-freiberuflerin",
					"stem": "index",
					"path": "meine-leistungen-als-freiberuflerin/index.md"
				},
				"requirePath": "meine-leistungen-als-freiberuflerin/index.md",
				"path": "/meine-leistungen-als-freiberuflerin/",
				"data": {
					"title": "Meine Leistungen als Freiberuflerin",
					"date": "2013-04-09 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "menschen-carmen",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "menschen-carmen",
					"stem": "index",
					"path": "menschen-carmen/index.md"
				},
				"requirePath": "menschen-carmen/index.md",
				"path": "/menschen-carmen/",
				"data": {
					"title": "Menschen: Carmen",
					"date": "2011-09-13 14:57:55 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mira-lykke-im-interview",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mira-lykke-im-interview",
					"stem": "index",
					"path": "mira-lykke-im-interview/index.md"
				},
				"requirePath": "mira-lykke-im-interview/index.md",
				"path": "/mira-lykke-im-interview/",
				"data": {
					"title": "Mira Lykke im Interview",
					"date": "2013-04-10 15:29:57 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-anatolian-psychedelic",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-anatolian-psychedelic",
					"stem": "index",
					"path": "mixtape-anatolian-psychedelic/index.md"
				},
				"requirePath": "mixtape-anatolian-psychedelic/index.md",
				"path": "/mixtape-anatolian-psychedelic/",
				"data": {
					"title": "Mixtape: Anatolian Psychedelic",
					"date": "2016-05-23 09:03:38 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-april-sheesh-days",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-april-sheesh-days",
					"stem": "index",
					"path": "mixtape-april-sheesh-days/index.md"
				},
				"requirePath": "mixtape-april-sheesh-days/index.md",
				"path": "/mixtape-april-sheesh-days/",
				"data": {
					"title": "Mixtape April: Sheesh Days",
					"date": "2014-04-10 15:51:34 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-birddog",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-birddog",
					"stem": "index",
					"path": "mixtape-birddog/index.md"
				},
				"requirePath": "mixtape-birddog/index.md",
				"path": "/mixtape-birddog/",
				"data": {
					"title": "Mixtape: BIRDDOG",
					"date": "2014-06-09 20:49:48 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-butter-gang",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-butter-gang",
					"stem": "index",
					"path": "mixtape-butter-gang/index.md"
				},
				"requirePath": "mixtape-butter-gang/index.md",
				"path": "/mixtape-butter-gang/",
				"data": {
					"title": "Mixtape: Butter Gang",
					"date": "2015-07-26 11:49:59 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-chickengirlz",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-chickengirlz",
					"stem": "index",
					"path": "mixtape-chickengirlz/index.md"
				},
				"requirePath": "mixtape-chickengirlz/index.md",
				"path": "/mixtape-chickengirlz/",
				"data": {
					"title": "Mixtape: Chickengirlz",
					"date": "2015-05-14 15:07:57 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-entfremdung-von-der-leichtigkeit",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-entfremdung-von-der-leichtigkeit",
					"stem": "index",
					"path": "mixtape-entfremdung-von-der-leichtigkeit/index.md"
				},
				"requirePath": "mixtape-entfremdung-von-der-leichtigkeit/index.md",
				"path": "/mixtape-entfremdung-von-der-leichtigkeit/",
				"data": {
					"title": "Mixtape - Entfremdung von der Leichtigkeit",
					"date": "2012-10-11 14:24:22 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-fabruar-fap-fap-fap",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-fabruar-fap-fap-fap",
					"stem": "index",
					"path": "mixtape-fabruar-fap-fap-fap/index.md"
				},
				"requirePath": "mixtape-fabruar-fap-fap-fap/index.md",
				"path": "/mixtape-fabruar-fap-fap-fap/",
				"data": {
					"title": "Mixtape Fabruar: Fap Fap Fap",
					"date": "2014-02-03 10:18:36 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-fuck-tatort",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-fuck-tatort",
					"stem": "index",
					"path": "mixtape-fuck-tatort/index.md"
				},
				"requirePath": "mixtape-fuck-tatort/index.md",
				"path": "/mixtape-fuck-tatort/",
				"data": {
					"title": "Mixtape: Fuck Tatort",
					"date": "2015-01-18 18:14:46 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-goodbye-california",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-goodbye-california",
					"stem": "index",
					"path": "mixtape-goodbye-california/index.md"
				},
				"requirePath": "mixtape-goodbye-california/index.md",
				"path": "/mixtape-goodbye-california/",
				"data": {
					"title": "Mixtape: Goodbye California!",
					"date": "2014-11-11 00:56:55 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-hasenscharte",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-hasenscharte",
					"stem": "index",
					"path": "mixtape-hasenscharte/index.md"
				},
				"requirePath": "mixtape-hasenscharte/index.md",
				"path": "/mixtape-hasenscharte/",
				"data": {
					"title": "Mixtape: Hasenscharte",
					"date": "2015-04-03 09:49:32 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-howl-geheule",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-howl-geheule",
					"stem": "index",
					"path": "mixtape-howl-geheule/index.md"
				},
				"requirePath": "mixtape-howl-geheule/index.md",
				"path": "/mixtape-howl-geheule/",
				"data": {
					"title": "Mixtape: Howl Geheule",
					"date": "2015-05-21 12:22:57 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-im-august-the-miniwurstelmonth",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-im-august-the-miniwurstelmonth",
					"stem": "index",
					"path": "mixtape-im-august-the-miniwurstelmonth/index.md"
				},
				"requirePath": "mixtape-im-august-the-miniwurstelmonth/index.md",
				"path": "/mixtape-im-august-the-miniwurstelmonth/",
				"data": {
					"title": "Mixtape im August: The Miniwurstelmonth",
					"date": "2013-07-30 13:44:12 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-im-dezember-no-wanderlust",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-im-dezember-no-wanderlust",
					"stem": "index",
					"path": "mixtape-im-dezember-no-wanderlust/index.md"
				},
				"requirePath": "mixtape-im-dezember-no-wanderlust/index.md",
				"path": "/mixtape-im-dezember-no-wanderlust/",
				"data": {
					"title": "Mixtape im Dezember: No Wanderlust",
					"date": "2013-11-26 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-im-januar-fucktthatshit",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-im-januar-fucktthatshit",
					"stem": "index",
					"path": "mixtape-im-januar-fucktthatshit/index.md"
				},
				"requirePath": "mixtape-im-januar-fucktthatshit/index.md",
				"path": "/mixtape-im-januar-fucktthatshit/",
				"data": {
					"title": "Mixtape im Januar: FUCKTTHATSHIT!",
					"date": "2014-01-09 09:10:21 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-im-juli-adrette-ausreden",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-im-juli-adrette-ausreden",
					"stem": "index",
					"path": "mixtape-im-juli-adrette-ausreden/index.md"
				},
				"requirePath": "mixtape-im-juli-adrette-ausreden/index.md",
				"path": "/mixtape-im-juli-adrette-ausreden/",
				"data": {
					"title": "Mixtape im Juli: Adrette Ausreden",
					"date": "2013-07-10 08:08:16 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-im-juni-the-liverwurst-diaries",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-im-juni-the-liverwurst-diaries",
					"stem": "index",
					"path": "mixtape-im-juni-the-liverwurst-diaries/index.md"
				},
				"requirePath": "mixtape-im-juni-the-liverwurst-diaries/index.md",
				"path": "/mixtape-im-juni-the-liverwurst-diaries/",
				"data": {
					"title": "Mixtape im Juni: The Liverwurst Diaries",
					"date": "2013-06-07 14:59:06 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-im-mai-peng",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-im-mai-peng",
					"stem": "index",
					"path": "mixtape-im-mai-peng/index.md"
				},
				"requirePath": "mixtape-im-mai-peng/index.md",
				"path": "/mixtape-im-mai-peng/",
				"data": {
					"title": "Mixtape im Mai: Peng",
					"date": "2013-05-08 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-im-november-schnaps-and-zweifel",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-im-november-schnaps-and-zweifel",
					"stem": "index",
					"path": "mixtape-im-november-schnaps-and-zweifel/index.md"
				},
				"requirePath": "mixtape-im-november-schnaps-and-zweifel/index.md",
				"path": "/mixtape-im-november-schnaps-and-zweifel/",
				"data": {
					"title": "Mixtape im November: Schnaps and Zweifel",
					"date": "2013-11-02 09:50:39 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-im-oktober-the-darkness-lights-you-up",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-im-oktober-the-darkness-lights-you-up",
					"stem": "index",
					"path": "mixtape-im-oktober-the-darkness-lights-you-up/index.md"
				},
				"requirePath": "mixtape-im-oktober-the-darkness-lights-you-up/index.md",
				"path": "/mixtape-im-oktober-the-darkness-lights-you-up/",
				"data": {
					"title": "Mixtape im Oktober: The Darkness Lights You Up",
					"date": "2013-09-26 08:44:10 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-im-september-goodbye-flutschfinger",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-im-september-goodbye-flutschfinger",
					"stem": "index",
					"path": "mixtape-im-september-goodbye-flutschfinger/index.md"
				},
				"requirePath": "mixtape-im-september-goodbye-flutschfinger/index.md",
				"path": "/mixtape-im-september-goodbye-flutschfinger/",
				"data": {
					"title": "Mixtape im September: Goodbye Flutschfinger",
					"date": "2013-08-26 15:47:38 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-klammbumm",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-klammbumm",
					"stem": "index",
					"path": "mixtape-klammbumm/index.md"
				},
				"requirePath": "mixtape-klammbumm/index.md",
				"path": "/mixtape-klammbumm/",
				"data": {
					"title": "Mixtape: Klammbumm",
					"date": "2015-03-07 10:48:41 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-mai-what-the",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-mai-what-the",
					"stem": "index",
					"path": "mixtape-mai-what-the/index.md"
				},
				"requirePath": "mixtape-mai-what-the/index.md",
				"path": "/mixtape-mai-what-the/",
				"data": {
					"title": "Mixtape Mai: WHAT THE",
					"date": "2014-05-01 16:25:46 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-marzipanschnaps-und-gyroskekse",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-marzipanschnaps-und-gyroskekse",
					"stem": "index",
					"path": "mixtape-marzipanschnaps-und-gyroskekse/index.md"
				},
				"requirePath": "mixtape-marzipanschnaps-und-gyroskekse/index.md",
				"path": "/mixtape-marzipanschnaps-und-gyroskekse/",
				"data": {
					"title": "Mixtape: Marzipanschnaps und Gyroskekse",
					"date": "2013-10-15 15:12:39 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-monaco-mini",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-monaco-mini",
					"stem": "index",
					"path": "mixtape-monaco-mini/index.md"
				},
				"requirePath": "mixtape-monaco-mini/index.md",
				"path": "/mixtape-monaco-mini/",
				"data": {
					"title": "Mixtape: Monaco Mini",
					"date": "2015-07-18 07:54:09 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-mrz-fuck-you-eiscreme",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-mrz-fuck-you-eiscreme",
					"stem": "index",
					"path": "mixtape-mrz-fuck-you-eiscreme/index.md"
				},
				"requirePath": "mixtape-mrz-fuck-you-eiscreme/index.md",
				"path": "/mixtape-mrz-fuck-you-eiscreme/",
				"data": {
					"title": "Mixtape März: Fuck You Eiscreme",
					"date": "2014-02-26 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-next-stop-down",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-next-stop-down",
					"stem": "index",
					"path": "mixtape-next-stop-down/index.md"
				},
				"requirePath": "mixtape-next-stop-down/index.md",
				"path": "/mixtape-next-stop-down/",
				"data": {
					"title": "Mixtape: Next Stop - Down",
					"date": "2014-07-24 14:25:25 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-oh-komm-ohn",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-oh-komm-ohn",
					"stem": "index",
					"path": "mixtape-oh-komm-ohn/index.md"
				},
				"requirePath": "mixtape-oh-komm-ohn/index.md",
				"path": "/mixtape-oh-komm-ohn/",
				"data": {
					"title": "Mixtape: Oh komm ohn",
					"date": "2015-10-01 12:56:51 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-pappa-bear",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-pappa-bear",
					"stem": "index",
					"path": "mixtape-pappa-bear/index.md"
				},
				"requirePath": "mixtape-pappa-bear/index.md",
				"path": "/mixtape-pappa-bear/",
				"data": {
					"title": "Mixtape: Pappa Bear",
					"date": "2015-02-13 14:42:27 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-pizza-christmas",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-pizza-christmas",
					"stem": "index",
					"path": "mixtape-pizza-christmas/index.md"
				},
				"requirePath": "mixtape-pizza-christmas/index.md",
				"path": "/mixtape-pizza-christmas/",
				"data": {
					"title": "Mixtape: Pizza Christmas",
					"date": "2014-12-11 13:40:08 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-summer-silly",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-summer-silly",
					"stem": "index",
					"path": "mixtape-summer-silly/index.md"
				},
				"requirePath": "mixtape-summer-silly/index.md",
				"path": "/mixtape-summer-silly/",
				"data": {
					"title": "Mixtape: Summer Silly",
					"date": "2015-09-08 07:23:39 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-supersuper",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-supersuper",
					"stem": "index",
					"path": "mixtape-supersuper/index.md"
				},
				"requirePath": "mixtape-supersuper/index.md",
				"path": "/mixtape-supersuper/",
				"data": {
					"title": "Mixtape: SUPERSUPER",
					"date": "2016-07-06 08:28:34 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-the-birthday-tape",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-the-birthday-tape",
					"stem": "index",
					"path": "mixtape-the-birthday-tape/index.md"
				},
				"requirePath": "mixtape-the-birthday-tape/index.md",
				"path": "/mixtape-the-birthday-tape/",
				"data": {
					"title": "Mixtape: The Birthday Tape",
					"date": "2014-08-14 15:38:50 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "mixtape-the-catnapper",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "mixtape-the-catnapper",
					"stem": "index",
					"path": "mixtape-the-catnapper/index.md"
				},
				"requirePath": "mixtape-the-catnapper/index.md",
				"path": "/mixtape-the-catnapper/",
				"data": {
					"title": "Mixtape: The Catnapper",
					"date": "2014-09-01 15:10:13 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "nationale-burgerwehr-und-bundnis-gegen-das-pferd",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "nationale-burgerwehr-und-bundnis-gegen-das-pferd",
					"stem": "index",
					"path": "nationale-burgerwehr-und-bundnis-gegen-das-pferd/index.md"
				},
				"requirePath": "nationale-burgerwehr-und-bundnis-gegen-das-pferd/index.md",
				"path": "/nationale-burgerwehr-und-bundnis-gegen-das-pferd/",
				"data": {
					"title": "Nationale Bürgerwehr und Bündnis gegen das Pferd",
					"date": "2011-05-21 12:02:37 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "neid-im-internet",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "neid-im-internet",
					"stem": "index",
					"path": "neid-im-internet/index.md"
				},
				"requirePath": "neid-im-internet/index.md",
				"path": "/neid-im-internet/",
				"data": {
					"title": "Neid im Internet",
					"date": "2012-07-04 15:15:30 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "neues-blitzkrieg-mixtape-3000-den-tights",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "neues-blitzkrieg-mixtape-3000-den-tights",
					"stem": "index",
					"path": "neues-blitzkrieg-mixtape-3000-den-tights/index.md"
				},
				"requirePath": "neues-blitzkrieg-mixtape-3000-den-tights/index.md",
				"path": "/neues-blitzkrieg-mixtape-3000-den-tights/",
				"data": {
					"title": "Neues Blitzkrieg Mixtape 3000 DEN TIGHTS",
					"date": "2012-11-03 14:50:09 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "neues-blitzkrieg-mixtape-turnvatter",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "neues-blitzkrieg-mixtape-turnvatter",
					"stem": "index",
					"path": "neues-blitzkrieg-mixtape-turnvatter/index.md"
				},
				"requirePath": "neues-blitzkrieg-mixtape-turnvatter/index.md",
				"path": "/neues-blitzkrieg-mixtape-turnvatter/",
				"data": {
					"title": "Neues Blitzkrieg Mixtape TURNVATTER",
					"date": "2013-04-03 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "neues-blogdesign-und-mixtape",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "neues-blogdesign-und-mixtape",
					"stem": "index",
					"path": "neues-blogdesign-und-mixtape/index.md"
				},
				"requirePath": "neues-blogdesign-und-mixtape/index.md",
				"path": "/neues-blogdesign-und-mixtape/",
				"data": {
					"title": "Neues Blogdesign und Mixtape:",
					"date": "2014-07-24 14:18:46 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "neuigkeiten-zum-roman",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "neuigkeiten-zum-roman",
					"stem": "index",
					"path": "neuigkeiten-zum-roman/index.md"
				},
				"requirePath": "neuigkeiten-zum-roman/index.md",
				"path": "/neuigkeiten-zum-roman/",
				"data": {
					"title": "Neuigkeiten zum Roman",
					"date": "2012-12-07 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "neulich-im-supermarkt",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "neulich-im-supermarkt",
					"stem": "index",
					"path": "neulich-im-supermarkt/index.md"
				},
				"requirePath": "neulich-im-supermarkt/index.md",
				"path": "/neulich-im-supermarkt/",
				"data": {
					"title": "Neulich im Supermarkt",
					"date": "2012-10-05 14:04:30 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "nightlover-by-max-seedorf-and-airen",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "nightlover-by-max-seedorf-and-airen",
					"stem": "index",
					"path": "nightlover-by-max-seedorf-and-airen/index.md"
				},
				"requirePath": "nightlover-by-max-seedorf-and-airen/index.md",
				"path": "/nightlover-by-max-seedorf-and-airen/",
				"data": {
					"title": "Nightlover by Max Seedorf and Airen",
					"date": "2012-01-03 17:45:38 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "omg-tiere-videos-der-woche",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "omg-tiere-videos-der-woche",
					"stem": "index",
					"path": "omg-tiere-videos-der-woche/index.md"
				},
				"requirePath": "omg-tiere-videos-der-woche/index.md",
				"path": "/omg-tiere-videos-der-woche/",
				"data": {
					"title": "OMG Tiere - Videos der Woche",
					"date": "2012-08-22 12:47:44 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "ontape-bodi-bill",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "ontape-bodi-bill",
					"stem": "index",
					"path": "ontape-bodi-bill/index.md"
				},
				"requirePath": "ontape-bodi-bill/index.md",
				"path": "/ontape-bodi-bill/",
				"data": {
					"title": "Ontape Bodi Bill",
					"date": "2011-06-03 14:08:14 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "optimier-dich-doch-selbst-du-opfer",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "optimier-dich-doch-selbst-du-opfer",
					"stem": "index",
					"path": "optimier-dich-doch-selbst-du-opfer/index.md"
				},
				"requirePath": "optimier-dich-doch-selbst-du-opfer/index.md",
				"path": "/optimier-dich-doch-selbst-du-opfer/",
				"data": {
					"title": "Optimier dich doch selbst, du Opfer!",
					"date": "2014-06-05 15:46:37 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "paint-your-favorite-blogs",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "paint-your-favorite-blogs",
					"stem": "index",
					"path": "paint-your-favorite-blogs/index.md"
				},
				"requirePath": "paint-your-favorite-blogs/index.md",
				"path": "/paint-your-favorite-blogs/",
				"data": {
					"title": "Paint your favorite blogs!",
					"date": "2012-08-03 12:29:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "partykapitalismus",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "partykapitalismus",
					"stem": "index",
					"path": "partykapitalismus/index.md"
				},
				"requirePath": "partykapitalismus/index.md",
				"path": "/partykapitalismus/",
				"data": {
					"title": "Partykapitalismus",
					"date": "2011-11-01 17:04:07 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "pferdeshow-in-audio",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "pferdeshow-in-audio",
					"stem": "index",
					"path": "pferdeshow-in-audio/index.md"
				},
				"requirePath": "pferdeshow-in-audio/index.md",
				"path": "/pferdeshow-in-audio/",
				"data": {
					"title": "Pferdeshow in Audio",
					"date": "2011-07-16 12:02:30 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "pimp-your-silvesterbaum-und-gewinne",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "pimp-your-silvesterbaum-und-gewinne",
					"stem": "index",
					"path": "pimp-your-silvesterbaum-und-gewinne/index.md"
				},
				"requirePath": "pimp-your-silvesterbaum-und-gewinne/index.md",
				"path": "/pimp-your-silvesterbaum-und-gewinne/",
				"data": {
					"title": "Pimp your Silvesterbaum und gewinne!",
					"date": "2013-12-29 11:46:15 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "platzrebellen",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "platzrebellen",
					"stem": "index",
					"path": "platzrebellen/index.md"
				},
				"requirePath": "platzrebellen/index.md",
				"path": "/platzrebellen/",
				"data": {
					"title": "Platzrebellen",
					"date": "2011-07-13 08:10:34 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "podcasts-im-in-love",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "podcasts-im-in-love",
					"stem": "index",
					"path": "podcasts-im-in-love/index.md"
				},
				"requirePath": "podcasts-im-in-love/index.md",
				"path": "/podcasts-im-in-love/",
				"data": {
					"title": "Podcasts, I'm in love!",
					"date": "2015-03-06 16:27:20 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "portfolio",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "portfolio",
					"stem": "index",
					"path": "portfolio/index.md"
				},
				"requirePath": "portfolio/index.md",
				"path": "/portfolio/",
				"data": {
					"title": "PORTFOLIO",
					"date": "2011-04-20 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "pr-texte-aus-der-holle-folge-1",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "pr-texte-aus-der-holle-folge-1",
					"stem": "index",
					"path": "pr-texte-aus-der-holle-folge-1/index.md"
				},
				"requirePath": "pr-texte-aus-der-holle-folge-1/index.md",
				"path": "/pr-texte-aus-der-holle-folge-1/",
				"data": {
					"title": "PR-Texte aus der Hölle (Folge 1)",
					"date": "2014-08-04 14:52:35 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "prag-kann-das-was",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "prag-kann-das-was",
					"stem": "index",
					"path": "prag-kann-das-was/index.md"
				},
				"requirePath": "prag-kann-das-was/index.md",
				"path": "/prag-kann-das-was/",
				"data": {
					"title": "Prag - kann das was?",
					"date": "2011-09-21 16:27:29 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "presse",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "presse",
					"stem": "index",
					"path": "presse/index.md"
				},
				"requirePath": "presse/index.md",
				"path": "/presse/",
				"data": {
					"title": "PRESSE",
					"date": "2013-06-30 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "prinz-pi-bei-tape-tv",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "prinz-pi-bei-tape-tv",
					"stem": "index",
					"path": "prinz-pi-bei-tape-tv/index.md"
				},
				"requirePath": "prinz-pi-bei-tape-tv/index.md",
				"path": "/prinz-pi-bei-tape-tv/",
				"data": {
					"title": "Prinz Pi bei tape.tv",
					"date": "2011-05-24 08:41:28 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "rassekatzen-glitzer-und-katzenmasse",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "rassekatzen-glitzer-und-katzenmasse",
					"stem": "index",
					"path": "rassekatzen-glitzer-und-katzenmasse/index.md"
				},
				"requirePath": "rassekatzen-glitzer-und-katzenmasse/index.md",
				"path": "/rassekatzen-glitzer-und-katzenmasse/",
				"data": {
					"title": "Rassekatzen, Glitzer und Katzenmasse",
					"date": "2012-01-05 16:52:30 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "regentage",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "regentage",
					"stem": "index",
					"path": "regentage/index.md"
				},
				"requirePath": "regentage/index.md",
				"path": "/regentage/",
				"data": {
					"title": "Regentage",
					"date": "2012-06-20 14:07:47 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "sag-es-laut-mir-geht-es-gut",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "sag-es-laut-mir-geht-es-gut",
					"stem": "index",
					"path": "sag-es-laut-mir-geht-es-gut/index.md"
				},
				"requirePath": "sag-es-laut-mir-geht-es-gut/index.md",
				"path": "/sag-es-laut-mir-geht-es-gut/",
				"data": {
					"title": "Sag es laut: Mir geht es gut",
					"date": "2014-05-12 19:02:25 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "san-francisco-food-story",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "san-francisco-food-story",
					"stem": "index",
					"path": "san-francisco-food-story/index.md"
				},
				"requirePath": "san-francisco-food-story/index.md",
				"path": "/san-francisco-food-story/",
				"data": {
					"title": "San Francisco Food Story",
					"date": "2012-09-14 18:30:47 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "schlechte-zeiten-gute-zeiten",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "schlechte-zeiten-gute-zeiten",
					"stem": "index",
					"path": "schlechte-zeiten-gute-zeiten/index.md"
				},
				"requirePath": "schlechte-zeiten-gute-zeiten/index.md",
				"path": "/schlechte-zeiten-gute-zeiten/",
				"data": {
					"title": "Schlechte Zeiten, gute Zeiten - Neues Blitzkrieg HQ",
					"date": "2012-01-31 14:51:19 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "silenttiffy-ihr-roman-and-the-masters-of-aussiedlerfashion",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "silenttiffy-ihr-roman-and-the-masters-of-aussiedlerfashion",
					"stem": "index",
					"path": "silenttiffy-ihr-roman-and-the-masters-of-aussiedlerfashion/index.md"
				},
				"requirePath": "silenttiffy-ihr-roman-and-the-masters-of-aussiedlerfashion/index.md",
				"path": "/silenttiffy-ihr-roman-and-the-masters-of-aussiedlerfashion/",
				"data": {
					"title": "Silenttiffy, ihr Roman, and the Masters of Aussiedlerfashion",
					"date": "2012-06-04 11:55:34 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "slowenien-slowakei-oder-so",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "slowenien-slowakei-oder-so",
					"stem": "index",
					"path": "slowenien-slowakei-oder-so/index.md"
				},
				"requirePath": "slowenien-slowakei-oder-so/index.md",
				"path": "/slowenien-slowakei-oder-so/",
				"data": {
					"title": "Slowenien, Slowakei oder so",
					"date": "2011-06-27 16:04:49 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "sofawissenschaften",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "sofawissenschaften",
					"stem": "index",
					"path": "sofawissenschaften/index.md"
				},
				"requirePath": "sofawissenschaften/index.md",
				"path": "/sofawissenschaften/",
				"data": {
					"title": "Sofawissenschaften",
					"date": "2012-02-01 09:31:59 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "soundcloud-and-fun",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "soundcloud-and-fun",
					"stem": "index",
					"path": "soundcloud-and-fun/index.md"
				},
				"requirePath": "soundcloud-and-fun/index.md",
				"path": "/soundcloud-and-fun/",
				"data": {
					"title": "SoundCloud and Fun",
					"date": "2012-11-12 14:07:13 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "spannung-vor-dem-release",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "spannung-vor-dem-release",
					"stem": "index",
					"path": "spannung-vor-dem-release/index.md"
				},
				"requirePath": "spannung-vor-dem-release/index.md",
				"path": "/spannung-vor-dem-release/",
				"data": {
					"title": "Spannung vor dem Release",
					"date": "2012-12-15 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "start",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "start",
					"stem": "index",
					"path": "start/index.md"
				},
				"requirePath": "start/index.md",
				"path": "/start/",
				"data": {
					"title": "Start",
					"date": "2011-04-21 15:59:29 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "studiopublikum-frittenbude",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "studiopublikum-frittenbude",
					"stem": "index",
					"path": "studiopublikum-frittenbude/index.md"
				},
				"requirePath": "studiopublikum-frittenbude/index.md",
				"path": "/studiopublikum-frittenbude/",
				"data": {
					"title": "Prominente im Studiopublikum - Teil I: Der Sänger von Frittenbude",
					"date": "2011-07-28 16:12:21 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "sukultur",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "sukultur",
					"stem": "index",
					"path": "sukultur/index.md"
				},
				"requirePath": "sukultur/index.md",
				"path": "/sukultur/",
				"data": {
					"title": "SUKULTUR",
					"date": "2013-10-07 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "swag-guide-to-berlin",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "swag-guide-to-berlin",
					"stem": "index",
					"path": "swag-guide-to-berlin/index.md"
				},
				"requirePath": "swag-guide-to-berlin/index.md",
				"path": "/swag-guide-to-berlin/",
				"data": {
					"title": "Swag-Guide to Berlin",
					"date": "2011-05-30 15:58:50 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "techno-2pac",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "techno-2pac",
					"stem": "index",
					"path": "techno-2pac/index.md"
				},
				"requirePath": "techno-2pac/index.md",
				"path": "/techno-2pac/",
				"data": {
					"title": "Techno 2Pac",
					"date": "2012-02-14 10:47:37 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "text-fur-meine-demente-grosmutter",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "text-fur-meine-demente-grosmutter",
					"stem": "index",
					"path": "text-fur-meine-demente-grosmutter/index.md"
				},
				"requirePath": "text-fur-meine-demente-grosmutter/index.md",
				"path": "/text-fur-meine-demente-grosmutter/",
				"data": {
					"title": "Text für meine demente Großmutter",
					"date": "2012-11-16 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "textkrieg-buchen",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "textkrieg-buchen",
					"stem": "index",
					"path": "textkrieg-buchen/index.md"
				},
				"requirePath": "textkrieg-buchen/index.md",
				"path": "/textkrieg-buchen/",
				"data": {
					"title": "Textkrieg buchen",
					"date": "2014-02-25 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "textkrieg-goes-to-california",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "textkrieg-goes-to-california",
					"stem": "index",
					"path": "textkrieg-goes-to-california/index.md"
				},
				"requirePath": "textkrieg-goes-to-california/index.md",
				"path": "/textkrieg-goes-to-california/",
				"data": {
					"title": "Textkrieg goes to California",
					"date": "2012-08-21 06:43:37 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "the-guide-to-dont-give-a-fuck",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "the-guide-to-dont-give-a-fuck",
					"stem": "index",
					"path": "the-guide-to-dont-give-a-fuck/index.md"
				},
				"requirePath": "the-guide-to-dont-give-a-fuck/index.md",
				"path": "/the-guide-to-dont-give-a-fuck/",
				"data": {
					"title": "The Guide To Don´t Give A Fuck",
					"date": "2014-03-05 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "the-incredible-banana-bread-with-pecan-ice-cream",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "the-incredible-banana-bread-with-pecan-ice-cream",
					"stem": "index",
					"path": "the-incredible-banana-bread-with-pecan-ice-cream/index.md"
				},
				"requirePath": "the-incredible-banana-bread-with-pecan-ice-cream/index.md",
				"path": "/the-incredible-banana-bread-with-pecan-ice-cream/",
				"data": {
					"title": "Incredible banana bread with pecan ice cream",
					"date": "2012-11-06 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "thor-steinar-der-vorbereitungsnazis",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "thor-steinar-der-vorbereitungsnazis",
					"stem": "index",
					"path": "thor-steinar-der-vorbereitungsnazis/index.md"
				},
				"requirePath": "thor-steinar-der-vorbereitungsnazis/index.md",
				"path": "/thor-steinar-der-vorbereitungsnazis/",
				"data": {
					"title": "Thor Steinar der Vorbereitungsnazis",
					"date": "2011-07-07 08:09:41 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "tkkg-und-der-affen-und-vogelpark",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "tkkg-und-der-affen-und-vogelpark",
					"stem": "index",
					"path": "tkkg-und-der-affen-und-vogelpark/index.md"
				},
				"requirePath": "tkkg-und-der-affen-und-vogelpark/index.md",
				"path": "/tkkg-und-der-affen-und-vogelpark/",
				"data": {
					"title": "TKKG und der Affen- und Vogelpark",
					"date": "2011-07-22 12:53:36 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "welt-funk-blitzkrieg-weihnachtsgruee-c60",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "welt-funk-blitzkrieg-weihnachtsgruee-c60",
					"stem": "index",
					"path": "welt-funk-blitzkrieg-weihnachtsgruee-c60/index.md"
				},
				"requirePath": "welt-funk-blitzkrieg-weihnachtsgruee-c60/index.md",
				"path": "/welt-funk-blitzkrieg-weihnachtsgruee-c60/",
				"data": {
					"title": "WELT FUNK Blitzkrieg Weihnachtsgrüße C60",
					"date": "2011-12-24 14:20:28 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "werbeunterbrechung",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "werbeunterbrechung",
					"stem": "index",
					"path": "werbeunterbrechung/index.md"
				},
				"requirePath": "werbeunterbrechung/index.md",
				"path": "/werbeunterbrechung/",
				"data": {
					"title": "Werbeunterbrechung",
					"date": "2011-11-28 16:55:21 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "where-hipsters-get-their-coffee",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "where-hipsters-get-their-coffee",
					"stem": "index",
					"path": "where-hipsters-get-their-coffee/index.md"
				},
				"requirePath": "where-hipsters-get-their-coffee/index.md",
				"path": "/where-hipsters-get-their-coffee/",
				"data": {
					"title": "Where hipsters get their coffee",
					"date": "2013-09-24 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "wie-die-welt-quellen-aus-meinen-tweets-streicht",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "wie-die-welt-quellen-aus-meinen-tweets-streicht",
					"stem": "index",
					"path": "wie-die-welt-quellen-aus-meinen-tweets-streicht/index.md"
				},
				"requirePath": "wie-die-welt-quellen-aus-meinen-tweets-streicht/index.md",
				"path": "/wie-die-welt-quellen-aus-meinen-tweets-streicht/",
				"data": {
					"title": "Wie die WELT Quellen aus meinen Tweets streicht",
					"date": "2012-01-11 16:44:31 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "wie-ich-2kg-fleisch-in-den-slow-cooker-stammte",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "wie-ich-2kg-fleisch-in-den-slow-cooker-stammte",
					"stem": "index",
					"path": "wie-ich-2kg-fleisch-in-den-slow-cooker-stammte/index.md"
				},
				"requirePath": "wie-ich-2kg-fleisch-in-den-slow-cooker-stammte/index.md",
				"path": "/wie-ich-2kg-fleisch-in-den-slow-cooker-stammte/",
				"data": {
					"title": "Wie ich 2kg Fleisch in den Slow Cooker stämmte",
					"date": "2012-11-19 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "wie-ist-das-so-als-freiberufler",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "wie-ist-das-so-als-freiberufler",
					"stem": "index",
					"path": "wie-ist-das-so-als-freiberufler/index.md"
				},
				"requirePath": "wie-ist-das-so-als-freiberufler/index.md",
				"path": "/wie-ist-das-so-als-freiberufler/",
				"data": {
					"title": "Wie ist das so als Freiberufler?",
					"date": "2011-05-18 13:41:52 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "wie-meine-tweets-im-zdf-wieder-auftauchten",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "wie-meine-tweets-im-zdf-wieder-auftauchten",
					"stem": "index",
					"path": "wie-meine-tweets-im-zdf-wieder-auftauchten/index.md"
				},
				"requirePath": "wie-meine-tweets-im-zdf-wieder-auftauchten/index.md",
				"path": "/wie-meine-tweets-im-zdf-wieder-auftauchten/",
				"data": {
					"title": "Wie meine Tweets im ZDF wieder auftauchten",
					"date": "2011-12-02 13:15:56 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "wie-viel-wahrheit-steckt-in-dackelkrieg",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "wie-viel-wahrheit-steckt-in-dackelkrieg",
					"stem": "index",
					"path": "wie-viel-wahrheit-steckt-in-dackelkrieg/index.md"
				},
				"requirePath": "wie-viel-wahrheit-steckt-in-dackelkrieg/index.md",
				"path": "/wie-viel-wahrheit-steckt-in-dackelkrieg/",
				"data": {
					"title": "Wie viel Wahrheit steckt in DACKELKRIEG?",
					"date": "2012-12-22 00:00:00 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "wohnungssuche-in-berlin",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "wohnungssuche-in-berlin",
					"stem": "index",
					"path": "wohnungssuche-in-berlin/index.md"
				},
				"requirePath": "wohnungssuche-in-berlin/index.md",
				"path": "/wohnungssuche-in-berlin/",
				"data": {
					"title": "Wohnungssuche in Berlin",
					"date": "2011-08-22 10:50:32 +0000",
					"tags": null,
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "zwischen-frustration-und-freiheit",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "zwischen-frustration-und-freiheit",
					"stem": "index",
					"path": "zwischen-frustration-und-freiheit/index.md"
				},
				"requirePath": "zwischen-frustration-und-freiheit/index.md",
				"path": "/zwischen-frustration-und-freiheit/",
				"data": {
					"title": "Zwischen Frustration und Freiheit",
					"date": "2011-08-04 15:52:39 +0000",
					"tags": null,
					"layout": "post"
				}
			}
		]
	}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(256),
	    isArray = __webpack_require__(263),
	    isObjectLike = __webpack_require__(262);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(388);
	
	__webpack_require__(389);
	
	__webpack_require__(390);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, (Template.__proto__ || Object.getPrototypeOf(Template)).apply(this, arguments));
	  }
	
	  _createClass(Template, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'wrapper' },
	        children
	      );
	    }
	  }]);
	
	  return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	  children: _react2.default.PropTypes.any
	};
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ }),
/* 388 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 389 */
388,
/* 390 */
388,
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./md": 392,
		"./md.jsx": 392
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 391;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(393);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _config = __webpack_require__(385);
	
	var _SitePost = __webpack_require__(398);
	
	var _SitePost2 = _interopRequireDefault(_SitePost);
	
	var _SitePage = __webpack_require__(483);
	
	var _SitePage2 = _interopRequireDefault(_SitePage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarkdownWrapper = function (_React$Component) {
	  _inherits(MarkdownWrapper, _React$Component);
	
	  function MarkdownWrapper() {
	    _classCallCheck(this, MarkdownWrapper);
	
	    return _possibleConstructorReturn(this, (MarkdownWrapper.__proto__ || Object.getPrototypeOf(MarkdownWrapper)).apply(this, arguments));
	  }
	
	  _createClass(MarkdownWrapper, [{
	    key: 'render',
	    value: function render() {
	      var route = this.props.route;
	
	      var post = route.page.data;
	      var layout = post.layout;
	      var template = void 0;
	
	      if (layout !== 'page') {
	        template = _react2.default.createElement(_SitePost2.default, this.props);
	      } else {
	        template = _react2.default.createElement(_SitePage2.default, this.props);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactHelmet2.default, { title: post.title + ' - ' + _config.config.siteTitle }),
	        template
	      );
	    }
	  }]);
	
	  return MarkdownWrapper;
	}(_react2.default.Component);
	
	MarkdownWrapper.propTypes = {
	  route: _react2.default.PropTypes.object
	};
	
	exports.default = MarkdownWrapper;
	module.exports = exports['default'];

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSideEffect = __webpack_require__(394);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(189);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(397);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var HELMET_ATTRIBUTE = "data-react-helmet";
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props[property]) {
	            return props[property];
	        }
	    }
	    return null;
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, "title");
	    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, "defaultTitle");
	
	    return innermostTitle || innermostDefaultTitle || "";
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        return typeof props[tagName] !== "undefined";
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    document.title = title || document.title;
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var htmlTag = document.getElementsByTagName(tagName)[0];
	    var helmetAttributeString = htmlTag.getAttribute(HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	        htmlTag.setAttribute(attribute, value);
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        htmlTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        htmlTag.removeAttribute(HELMET_ATTRIBUTE);
	    } else {
	        htmlTag.setAttribute(HELMET_ATTRIBUTE, helmetAttributes.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector("head");
	    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === "innerHTML") {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === "cssText") {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateHtmlAttributesAsString = function generateHtmlAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes) {
	    var attributeString = generateHtmlAttributesAsString(attributes);
	    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(title) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === "innerHTML" || attribute === "cssText");
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute]) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = [_HelmetConstants.TAG_NAMES.NOSCRIPT, _HelmetConstants.TAG_NAMES.SCRIPT, _HelmetConstants.TAG_NAMES.STYLE].indexOf(type) === -1;
	
	        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    // assigning into an array to define toString function on it
	    var initProps = _defineProperty({
	        key: title
	    }, HELMET_ATTRIBUTE, true);
	    var props = Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var mappedTag = _defineProperty({
	            key: i
	        }, HELMET_ATTRIBUTE, true);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === "innerHTML" || mappedAttribute === "cssText") {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes);
	                }
	            };
	        case _HelmetConstants.TAG_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return tags;
	                },
	                toString: function toString() {
	                    return generateHtmlAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var htmlAttributes = _ref.htmlAttributes,
	        title = _ref.title,
	        titleAttributes = _ref.titleAttributes,
	        baseTag = _ref.baseTag,
	        metaTags = _ref.metaTags,
	        linkTags = _ref.linkTags,
	        scriptTags = _ref.scriptTags,
	        noscriptTags = _ref.noscriptTags,
	        styleTags = _ref.styleTags;
	    return {
	        htmlAttributes: getMethodsForTag(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }),
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	};
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, (HelmetWrapper.__proto__ || Object.getPrototypeOf(HelmetWrapper)).apply(this, arguments));
	        }
	
	        _createClass(HelmetWrapper, [{
	            key: "shouldComponentUpdate",
	            value: function shouldComponentUpdate(nextProps) {
	                return !(0, _deepEqual2.default)(this.props, nextProps);
	            }
	        }, {
	            key: "render",
	            value: function render() {
	                return _react2.default.createElement(Component, this.props);
	            }
	        }], [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	            /**
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {String} title: "Title"
	             * @param {String} defaultTitle: "Default Title"
	             * @param {String} titleTemplate: "MySite.com - %s"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div{ display: block; color: blue; }"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             */
	
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        htmlAttributes: _react2.default.PropTypes.object,
	        title: _react2.default.PropTypes.string,
	        defaultTitle: _react2.default.PropTypes.string,
	        titleTemplate: _react2.default.PropTypes.string,
	        titleAttributes: _react2.default.PropTypes.object,
	        base: _react2.default.PropTypes.object,
	        meta: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        link: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        script: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        noscript: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        style: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        onChangeClientState: _react2.default.PropTypes.func
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = mapStateOnServer({
	                htmlAttributes: {},
	                title: "",
	                titleAttributes: {},
	                baseTag: [],
	                metaTags: [],
	                linkTags: [],
	                scriptTags: [],
	                noscriptTags: [],
	                styleTags: []
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.TAG_NAMES.HTML, propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList("titleAttributes", propsList),
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        onChangeClientState: getOnChangeClientState(propsList)
	    };
	};
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    var htmlAttributes = newState.htmlAttributes,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes,
	        baseTag = newState.baseTag,
	        metaTags = newState.metaTags,
	        linkTags = newState.linkTags,
	        scriptTags = newState.scriptTags,
	        noscriptTags = newState.noscriptTags,
	        styleTags = newState.styleTags,
	        onChangeClientState = newState.onChangeClientState;
	
	
	    updateAttributes("html", htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);
	
	exports.default = Helmet(HelmetSideEffects);
	module.exports = exports["default"];

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(395);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(396);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 396 */
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),
/* 397 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var TAG_NAMES = exports.TAG_NAMES = {
	    HTML: "htmlAttributes",
	    TITLE: "title",
	    BASE: "base",
	    META: "meta",
	    LINK: "link",
	    SCRIPT: "script",
	    NOSCRIPT: "noscript",
	    STYLE: "style"
	};
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    NAME: "name",
	    CHARSET: "charset",
	    HTTPEQUIV: "http-equiv",
	    REL: "rel",
	    HREF: "href",
	    PROPERTY: "property",
	    SRC: "src",
	    INNER_HTML: "innerHTML",
	    CSS_TEXT: "cssText",
	    ITEM_PROP: "itemprop"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    "charset": "charSet",
	    "http-equiv": "httpEquiv",
	    "itemprop": "itemProp",
	    "class": "className"
	};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(399);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(171);
	
	var _gatsbyHelpers = __webpack_require__(384);
	
	var _config = __webpack_require__(385);
	
	var _ReadNext = __webpack_require__(400);
	
	var _ReadNext2 = _interopRequireDefault(_ReadNext);
	
	__webpack_require__(481);
	
	__webpack_require__(482);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SitePost = function (_React$Component) {
	  _inherits(SitePost, _React$Component);
	
	  function SitePost() {
	    _classCallCheck(this, SitePost);
	
	    return _possibleConstructorReturn(this, (SitePost.__proto__ || Object.getPrototypeOf(SitePost)).apply(this, arguments));
	  }
	
	  _createClass(SitePost, [{
	    key: 'render',
	    value: function render() {
	      var route = this.props.route;
	
	      var post = route.page.data;
	      var home = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { className: 'gohome', to: (0, _gatsbyHelpers.prefixLink)('/') },
	          'All Articles'
	        )
	      );
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        home,
	        _react2.default.createElement(
	          'div',
	          { className: 'blog-single' },
	          _react2.default.createElement(
	            'div',
	            { className: 'text' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              post.title
	            ),
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: post.body } }),
	            _react2.default.createElement(
	              'div',
	              { className: 'date-published' },
	              _react2.default.createElement(
	                'em',
	                null,
	                'Published ',
	                (0, _moment2.default)(post.date).format('D MMM YYYY')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'footer' },
	            _react2.default.createElement(_ReadNext2.default, _extends({ post: post }, this.props)),
	            _react2.default.createElement('hr', null),
	            _react2.default.createElement(
	              'p',
	              null,
	              _config.config.siteDescr,
	              _react2.default.createElement(
	                'a',
	                { href: _config.config.siteTwitterUrl },
	                _react2.default.createElement('br', null),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _config.config.siteAuthor
	                ),
	                ' on Twitter'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SitePost;
	}(_react2.default.Component);
	
	SitePost.propTypes = {
	  route: _react2.default.PropTypes.object.isRequired
	};
	
	exports.default = SitePost;
	module.exports = exports['default'];

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(265)(module)))

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(171);
	
	var _underscore = __webpack_require__(401);
	
	var _find = __webpack_require__(473);
	
	var _find2 = _interopRequireDefault(_find);
	
	__webpack_require__(480);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReadNext = function (_React$Component) {
	  _inherits(ReadNext, _React$Component);
	
	  function ReadNext() {
	    _classCallCheck(this, ReadNext);
	
	    return _possibleConstructorReturn(this, (ReadNext.__proto__ || Object.getPrototypeOf(ReadNext)).apply(this, arguments));
	  }
	
	  _createClass(ReadNext, [{
	    key: 'render',
	    value: function render() {
	      var post = this.props.post;
	      var pages = this.props.route.pages;
	      var readNext = post.readNext;
	
	
	      var nextPost = void 0;
	      if (readNext) {
	        nextPost = (0, _find2.default)(pages, function (page) {
	          return (0, _underscore.include)(page.path, readNext);
	        });
	      }
	      if (!nextPost) {
	        return _react2.default.createElement('noscript', null);
	      }
	
	      nextPost = (0, _find2.default)(pages, function (page) {
	        return (0, _underscore.include)(page.path, readNext.slice(1, -1));
	      });
	      var description = nextPost.data.description;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h6',
	          { style: { fontSize: '16px', margin: '20px 0 0' } },
	          'READ THIS NEXT:'
	        ),
	        _react2.default.createElement(
	          'h3',
	          { style: { margin: '5px 0 0' } },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: nextPost.path, query: { readNext: true } },
	            nextPost.data.title
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'description' },
	          description
	        )
	      );
	    }
	  }]);
	
	  return ReadNext;
	}(_react2.default.Component);
	
	ReadNext.propTypes = {
	  post: _react2.default.PropTypes.object.isRequired,
	  pages: _react2.default.PropTypes.array,
	  route: _react2.default.PropTypes.object
	};
	
	exports.default = ReadNext;
	module.exports = exports['default'];

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	* Underscore.string
	* (c) 2010 Esa-Matti Suuronen <esa-matti aet suuronen dot org>
	* Underscore.string is freely distributable under the terms of the MIT license.
	* Documentation: https://github.com/epeli/underscore.string
	* Some code is borrowed from MooTools and Alexandru Marasteanu.
	* Version '3.3.4'
	* @preserve
	*/
	
	'use strict';
	
	function s(value) {
	  /* jshint validthis: true */
	  if (!(this instanceof s)) return new s(value);
	  this._wrapped = value;
	}
	
	s.VERSION = '3.3.4';
	
	s.isBlank          = __webpack_require__(402);
	s.stripTags        = __webpack_require__(404);
	s.capitalize       = __webpack_require__(405);
	s.decapitalize     = __webpack_require__(406);
	s.chop             = __webpack_require__(407);
	s.trim             = __webpack_require__(408);
	s.clean            = __webpack_require__(411);
	s.cleanDiacritics  = __webpack_require__(412);
	s.count            = __webpack_require__(413);
	s.chars            = __webpack_require__(414);
	s.swapCase         = __webpack_require__(415);
	s.escapeHTML       = __webpack_require__(416);
	s.unescapeHTML     = __webpack_require__(418);
	s.splice           = __webpack_require__(420);
	s.insert           = __webpack_require__(421);
	s.replaceAll       = __webpack_require__(422);
	s.include          = __webpack_require__(423);
	s.join             = __webpack_require__(424);
	s.lines            = __webpack_require__(425);
	s.dedent           = __webpack_require__(426);
	s.reverse          = __webpack_require__(427);
	s.startsWith       = __webpack_require__(428);
	s.endsWith         = __webpack_require__(430);
	s.pred             = __webpack_require__(431);
	s.succ             = __webpack_require__(433);
	s.titleize         = __webpack_require__(434);
	s.camelize         = __webpack_require__(435);
	s.underscored      = __webpack_require__(436);
	s.dasherize        = __webpack_require__(437);
	s.classify         = __webpack_require__(438);
	s.humanize         = __webpack_require__(439);
	s.ltrim            = __webpack_require__(440);
	s.rtrim            = __webpack_require__(441);
	s.truncate         = __webpack_require__(442);
	s.prune            = __webpack_require__(443);
	s.words            = __webpack_require__(444);
	s.pad              = __webpack_require__(445);
	s.lpad             = __webpack_require__(447);
	s.rpad             = __webpack_require__(448);
	s.lrpad            = __webpack_require__(449);
	s.sprintf          = __webpack_require__(450);
	s.vsprintf         = __webpack_require__(453);
	s.toNumber         = __webpack_require__(454);
	s.numberFormat     = __webpack_require__(455);
	s.strRight         = __webpack_require__(456);
	s.strRightBack     = __webpack_require__(457);
	s.strLeft          = __webpack_require__(458);
	s.strLeftBack      = __webpack_require__(459);
	s.toSentence       = __webpack_require__(460);
	s.toSentenceSerial = __webpack_require__(461);
	s.slugify          = __webpack_require__(462);
	s.surround         = __webpack_require__(463);
	s.quote            = __webpack_require__(464);
	s.unquote          = __webpack_require__(465);
	s.repeat           = __webpack_require__(466);
	s.naturalCmp       = __webpack_require__(467);
	s.levenshtein      = __webpack_require__(468);
	s.toBoolean        = __webpack_require__(469);
	s.exports          = __webpack_require__(470);
	s.escapeRegExp     = __webpack_require__(410);
	s.wrap             = __webpack_require__(471);
	s.map              = __webpack_require__(472);
	
	// Aliases
	s.strip     = s.trim;
	s.lstrip    = s.ltrim;
	s.rstrip    = s.rtrim;
	s.center    = s.lrpad;
	s.rjust     = s.lpad;
	s.ljust     = s.rpad;
	s.contains  = s.include;
	s.q         = s.quote;
	s.toBool    = s.toBoolean;
	s.camelcase = s.camelize;
	s.mapChars  = s.map;
	
	
	// Implement chaining
	s.prototype = {
	  value: function value() {
	    return this._wrapped;
	  }
	};
	
	function fn2method(key, fn) {
	  if (typeof fn !== 'function') return;
	  s.prototype[key] = function() {
	    var args = [this._wrapped].concat(Array.prototype.slice.call(arguments));
	    var res = fn.apply(null, args);
	    // if the result is non-string stop the chain and return the value
	    return typeof res === 'string' ? new s(res) : res;
	  };
	}
	
	// Copy functions to instance methods for chaining
	for (var key in s) fn2method(key, s[key]);
	
	fn2method('tap', function tap(string, fn) {
	  return fn(string);
	});
	
	function prototype2method(methodName) {
	  fn2method(methodName, function(context) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    return String.prototype[methodName].apply(context, args);
	  });
	}
	
	var prototypeMethods = [
	  'toUpperCase',
	  'toLowerCase',
	  'split',
	  'replace',
	  'slice',
	  'substring',
	  'substr',
	  'concat'
	];
	
	for (var method in prototypeMethods) prototype2method(prototypeMethods[method]);
	
	
	module.exports = s;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function isBlank(str) {
	  return (/^\s*$/).test(makeString(str));
	};


/***/ }),
/* 403 */
/***/ (function(module, exports) {

	/**
	 * Ensure some object is a coerced to a string
	 **/
	module.exports = function makeString(object) {
	  if (object == null) return '';
	  return '' + object;
	};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function stripTags(str) {
	  return makeString(str).replace(/<\/?[^>]+>/g, '');
	};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function capitalize(str, lowercaseRest) {
	  str = makeString(str);
	  var remainingChars = !lowercaseRest ? str.slice(1) : str.slice(1).toLowerCase();
	
	  return str.charAt(0).toUpperCase() + remainingChars;
	};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function decapitalize(str) {
	  str = makeString(str);
	  return str.charAt(0).toLowerCase() + str.slice(1);
	};


/***/ }),
/* 407 */
/***/ (function(module, exports) {

	module.exports = function chop(str, step) {
	  if (str == null) return [];
	  str = String(str);
	  step = ~~step;
	  return step > 0 ? str.match(new RegExp('.{1,' + step + '}', 'g')) : [str];
	};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	var defaultToWhiteSpace = __webpack_require__(409);
	var nativeTrim = String.prototype.trim;
	
	module.exports = function trim(str, characters) {
	  str = makeString(str);
	  if (!characters && nativeTrim) return nativeTrim.call(str);
	  characters = defaultToWhiteSpace(characters);
	  return str.replace(new RegExp('^' + characters + '+|' + characters + '+$', 'g'), '');
	};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	var escapeRegExp = __webpack_require__(410);
	
	module.exports = function defaultToWhiteSpace(characters) {
	  if (characters == null)
	    return '\\s';
	  else if (characters.source)
	    return characters.source;
	  else
	    return '[' + escapeRegExp(characters) + ']';
	};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function escapeRegExp(str) {
	  return makeString(str).replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
	};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(408);
	
	module.exports = function clean(str) {
	  return trim(str).replace(/\s\s+/g, ' ');
	};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	
	var makeString = __webpack_require__(403);
	
	var from  = 'ąàáäâãåæăćčĉęèéëêĝĥìíïîĵłľńňòóöőôõðøśșşšŝťțţŭùúüűûñÿýçżźž',
	  to    = 'aaaaaaaaaccceeeeeghiiiijllnnoooooooossssstttuuuuuunyyczzz';
	
	from += from.toUpperCase();
	to += to.toUpperCase();
	
	to = to.split('');
	
	// for tokens requireing multitoken output
	from += 'ß';
	to.push('ss');
	
	
	module.exports = function cleanDiacritics(str) {
	  return makeString(str).replace(/.{1}/g, function(c){
	    var index = from.indexOf(c);
	    return index === -1 ? c : to[index];
	  });
	};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function(str, substr) {
	  str = makeString(str);
	  substr = makeString(substr);
	
	  if (str.length === 0 || substr.length === 0) return 0;
	  
	  return str.split(substr).length - 1;
	};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function chars(str) {
	  return makeString(str).split('');
	};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function swapCase(str) {
	  return makeString(str).replace(/\S/g, function(c) {
	    return c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase();
	  });
	};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	var escapeChars = __webpack_require__(417);
	
	var regexString = '[';
	for(var key in escapeChars) {
	  regexString += key;
	}
	regexString += ']';
	
	var regex = new RegExp( regexString, 'g');
	
	module.exports = function escapeHTML(str) {
	
	  return makeString(str).replace(regex, function(m) {
	    return '&' + escapeChars[m] + ';';
	  });
	};


/***/ }),
/* 417 */
/***/ (function(module, exports) {

	/* We're explicitly defining the list of entities we want to escape.
	nbsp is an HTML entity, but we don't want to escape all space characters in a string, hence its omission in this map.
	
	*/
	var escapeChars = {
	  '¢' : 'cent',
	  '£' : 'pound',
	  '¥' : 'yen',
	  '€': 'euro',
	  '©' :'copy',
	  '®' : 'reg',
	  '<' : 'lt',
	  '>' : 'gt',
	  '"' : 'quot',
	  '&' : 'amp',
	  '\'' : '#39'
	};
	
	module.exports = escapeChars;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	var htmlEntities = __webpack_require__(419);
	
	module.exports = function unescapeHTML(str) {
	  return makeString(str).replace(/\&([^;]+);/g, function(entity, entityCode) {
	    var match;
	
	    if (entityCode in htmlEntities) {
	      return htmlEntities[entityCode];
	    /*eslint no-cond-assign: 0*/
	    } else if (match = entityCode.match(/^#x([\da-fA-F]+)$/)) {
	      return String.fromCharCode(parseInt(match[1], 16));
	    /*eslint no-cond-assign: 0*/
	    } else if (match = entityCode.match(/^#(\d+)$/)) {
	      return String.fromCharCode(~~match[1]);
	    } else {
	      return entity;
	    }
	  });
	};


/***/ }),
/* 419 */
/***/ (function(module, exports) {

	/*
	We're explicitly defining the list of entities that might see in escape HTML strings
	*/
	var htmlEntities = {
	  nbsp: ' ',
	  cent: '¢',
	  pound: '£',
	  yen: '¥',
	  euro: '€',
	  copy: '©',
	  reg: '®',
	  lt: '<',
	  gt: '>',
	  quot: '"',
	  amp: '&',
	  apos: '\''
	};
	
	module.exports = htmlEntities;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	var chars = __webpack_require__(414);
	
	module.exports = function splice(str, i, howmany, substr) {
	  var arr = chars(str);
	  arr.splice(~~i, ~~howmany, substr);
	  return arr.join('');
	};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	var splice = __webpack_require__(420);
	
	module.exports = function insert(str, i, substr) {
	  return splice(str, i, 0, substr);
	};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function replaceAll(str, find, replace, ignorecase) {
	  var flags = (ignorecase === true)?'gi':'g';
	  var reg = new RegExp(find, flags);
	
	  return makeString(str).replace(reg, replace);
	};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function include(str, needle) {
	  if (needle === '') return true;
	  return makeString(str).indexOf(needle) !== -1;
	};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	var slice = [].slice;
	
	module.exports = function join() {
	  var args = slice.call(arguments),
	    separator = args.shift();
	
	  return args.join(makeString(separator));
	};


/***/ }),
/* 425 */
/***/ (function(module, exports) {

	module.exports = function lines(str) {
	  if (str == null) return [];
	  return String(str).split(/\r\n?|\n/);
	};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	function getIndent(str) {
	  var matches = str.match(/^[\s\\t]*/gm);
	  var indent = matches[0].length;
	  
	  for (var i = 1; i < matches.length; i++) {
	    indent = Math.min(matches[i].length, indent);
	  }
	
	  return indent;
	}
	
	module.exports = function dedent(str, pattern) {
	  str = makeString(str);
	  var indent = getIndent(str);
	  var reg;
	
	  if (indent === 0) return str;
	
	  if (typeof pattern === 'string') {
	    reg = new RegExp('^' + pattern, 'gm');
	  } else {
	    reg = new RegExp('^[ \\t]{' + indent + '}', 'gm');
	  }
	
	  return str.replace(reg, '');
	};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	var chars = __webpack_require__(414);
	
	module.exports = function reverse(str) {
	  return chars(str).reverse().join('');
	};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	var toPositive = __webpack_require__(429);
	
	module.exports = function startsWith(str, starts, position) {
	  str = makeString(str);
	  starts = '' + starts;
	  position = position == null ? 0 : Math.min(toPositive(position), str.length);
	  return str.lastIndexOf(starts, position) === position;
	};


/***/ }),
/* 429 */
/***/ (function(module, exports) {

	module.exports = function toPositive(number) {
	  return number < 0 ? 0 : (+number || 0);
	};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	var toPositive = __webpack_require__(429);
	
	module.exports = function endsWith(str, ends, position) {
	  str = makeString(str);
	  ends = '' + ends;
	  if (typeof position == 'undefined') {
	    position = str.length - ends.length;
	  } else {
	    position = Math.min(toPositive(position), str.length) - ends.length;
	  }
	  return position >= 0 && str.indexOf(ends, position) === position;
	};


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	var adjacent = __webpack_require__(432);
	
	module.exports = function succ(str) {
	  return adjacent(str, -1);
	};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function adjacent(str, direction) {
	  str = makeString(str);
	  if (str.length === 0) {
	    return '';
	  }
	  return str.slice(0, -1) + String.fromCharCode(str.charCodeAt(str.length - 1) + direction);
	};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	var adjacent = __webpack_require__(432);
	
	module.exports = function succ(str) {
	  return adjacent(str, 1);
	};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function titleize(str) {
	  return makeString(str).toLowerCase().replace(/(?:^|\s|-)\S/g, function(c) {
	    return c.toUpperCase();
	  });
	};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(408);
	var decap = __webpack_require__(406);
	
	module.exports = function camelize(str, decapitalize) {
	  str = trim(str).replace(/[-_\s]+(.)?/g, function(match, c) {
	    return c ? c.toUpperCase() : '';
	  });
	
	  if (decapitalize === true) {
	    return decap(str);
	  } else {
	    return str;
	  }
	};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(408);
	
	module.exports = function underscored(str) {
	  return trim(str).replace(/([a-z\d])([A-Z]+)/g, '$1_$2').replace(/[-\s]+/g, '_').toLowerCase();
	};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(408);
	
	module.exports = function dasherize(str) {
	  return trim(str).replace(/([A-Z])/g, '-$1').replace(/[-_\s]+/g, '-').toLowerCase();
	};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	var capitalize = __webpack_require__(405);
	var camelize = __webpack_require__(435);
	var makeString = __webpack_require__(403);
	
	module.exports = function classify(str) {
	  str = makeString(str);
	  return capitalize(camelize(str.replace(/[\W_]/g, ' ')).replace(/\s/g, ''));
	};


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	var capitalize = __webpack_require__(405);
	var underscored = __webpack_require__(436);
	var trim = __webpack_require__(408);
	
	module.exports = function humanize(str) {
	  return capitalize(trim(underscored(str).replace(/_id$/, '').replace(/_/g, ' ')));
	};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	var defaultToWhiteSpace = __webpack_require__(409);
	var nativeTrimLeft = String.prototype.trimLeft;
	
	module.exports = function ltrim(str, characters) {
	  str = makeString(str);
	  if (!characters && nativeTrimLeft) return nativeTrimLeft.call(str);
	  characters = defaultToWhiteSpace(characters);
	  return str.replace(new RegExp('^' + characters + '+'), '');
	};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	var defaultToWhiteSpace = __webpack_require__(409);
	var nativeTrimRight = String.prototype.trimRight;
	
	module.exports = function rtrim(str, characters) {
	  str = makeString(str);
	  if (!characters && nativeTrimRight) return nativeTrimRight.call(str);
	  characters = defaultToWhiteSpace(characters);
	  return str.replace(new RegExp(characters + '+$'), '');
	};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function truncate(str, length, truncateStr) {
	  str = makeString(str);
	  truncateStr = truncateStr || '...';
	  length = ~~length;
	  return str.length > length ? str.slice(0, length) + truncateStr : str;
	};


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * _s.prune: a more elegant version of truncate
	 * prune extra chars, never leaving a half-chopped word.
	 * @author github.com/rwz
	 */
	var makeString = __webpack_require__(403);
	var rtrim = __webpack_require__(441);
	
	module.exports = function prune(str, length, pruneStr) {
	  str = makeString(str);
	  length = ~~length;
	  pruneStr = pruneStr != null ? String(pruneStr) : '...';
	
	  if (str.length <= length) return str;
	
	  var tmpl = function(c) {
	      return c.toUpperCase() !== c.toLowerCase() ? 'A' : ' ';
	    },
	    template = str.slice(0, length + 1).replace(/.(?=\W*\w*$)/g, tmpl); // 'Hello, world' -> 'HellAA AAAAA'
	
	  if (template.slice(template.length - 2).match(/\w\w/))
	    template = template.replace(/\s*\S+$/, '');
	  else
	    template = rtrim(template.slice(0, template.length - 1));
	
	  return (template + pruneStr).length > str.length ? str : str.slice(0, template.length) + pruneStr;
	};


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	var isBlank = __webpack_require__(402);
	var trim = __webpack_require__(408);
	
	module.exports = function words(str, delimiter) {
	  if (isBlank(str)) return [];
	  return trim(str, delimiter).split(delimiter || /\s+/);
	};


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	var strRepeat = __webpack_require__(446);
	
	module.exports = function pad(str, length, padStr, type) {
	  str = makeString(str);
	  length = ~~length;
	
	  var padlen = 0;
	
	  if (!padStr)
	    padStr = ' ';
	  else if (padStr.length > 1)
	    padStr = padStr.charAt(0);
	
	  switch (type) {
	  case 'right':
	    padlen = length - str.length;
	    return str + strRepeat(padStr, padlen);
	  case 'both':
	    padlen = length - str.length;
	    return strRepeat(padStr, Math.ceil(padlen / 2)) + str + strRepeat(padStr, Math.floor(padlen / 2));
	  default: // 'left'
	    padlen = length - str.length;
	    return strRepeat(padStr, padlen) + str;
	  }
	};


/***/ }),
/* 446 */
/***/ (function(module, exports) {

	module.exports = function strRepeat(str, qty){
	  if (qty < 1) return '';
	  var result = '';
	  while (qty > 0) {
	    if (qty & 1) result += str;
	    qty >>= 1, str += str;
	  }
	  return result;
	};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	var pad = __webpack_require__(445);
	
	module.exports = function lpad(str, length, padStr) {
	  return pad(str, length, padStr);
	};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	var pad = __webpack_require__(445);
	
	module.exports = function rpad(str, length, padStr) {
	  return pad(str, length, padStr, 'right');
	};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	var pad = __webpack_require__(445);
	
	module.exports = function lrpad(str, length, padStr) {
	  return pad(str, length, padStr, 'both');
	};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	var deprecate = __webpack_require__(451);
	
	module.exports = deprecate(__webpack_require__(452).sprintf,
	  'sprintf() will be removed in the next major release, use the sprintf-js package instead.');


/***/ }),
/* 451 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	(function(window) {
	    var re = {
	        not_string: /[^s]/,
	        number: /[diefg]/,
	        json: /[j]/,
	        not_json: /[^j]/,
	        text: /^[^\x25]+/,
	        modulo: /^\x25{2}/,
	        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijosuxX])/,
	        key: /^([a-z_][a-z_\d]*)/i,
	        key_access: /^\.([a-z_][a-z_\d]*)/i,
	        index_access: /^\[(\d+)\]/,
	        sign: /^[\+\-]/
	    }
	
	    function sprintf() {
	        var key = arguments[0], cache = sprintf.cache
	        if (!(cache[key] && cache.hasOwnProperty(key))) {
	            cache[key] = sprintf.parse(key)
	        }
	        return sprintf.format.call(null, cache[key], arguments)
	    }
	
	    sprintf.format = function(parse_tree, argv) {
	        var cursor = 1, tree_length = parse_tree.length, node_type = "", arg, output = [], i, k, match, pad, pad_character, pad_length, is_positive = true, sign = ""
	        for (i = 0; i < tree_length; i++) {
	            node_type = get_type(parse_tree[i])
	            if (node_type === "string") {
	                output[output.length] = parse_tree[i]
	            }
	            else if (node_type === "array") {
	                match = parse_tree[i] // convenience purposes only
	                if (match[2]) { // keyword argument
	                    arg = argv[cursor]
	                    for (k = 0; k < match[2].length; k++) {
	                        if (!arg.hasOwnProperty(match[2][k])) {
	                            throw new Error(sprintf("[sprintf] property '%s' does not exist", match[2][k]))
	                        }
	                        arg = arg[match[2][k]]
	                    }
	                }
	                else if (match[1]) { // positional argument (explicit)
	                    arg = argv[match[1]]
	                }
	                else { // positional argument (implicit)
	                    arg = argv[cursor++]
	                }
	
	                if (get_type(arg) == "function") {
	                    arg = arg()
	                }
	
	                if (re.not_string.test(match[8]) && re.not_json.test(match[8]) && (get_type(arg) != "number" && isNaN(arg))) {
	                    throw new TypeError(sprintf("[sprintf] expecting number but found %s", get_type(arg)))
	                }
	
	                if (re.number.test(match[8])) {
	                    is_positive = arg >= 0
	                }
	
	                switch (match[8]) {
	                    case "b":
	                        arg = arg.toString(2)
	                    break
	                    case "c":
	                        arg = String.fromCharCode(arg)
	                    break
	                    case "d":
	                    case "i":
	                        arg = parseInt(arg, 10)
	                    break
	                    case "j":
	                        arg = JSON.stringify(arg, null, match[6] ? parseInt(match[6]) : 0)
	                    break
	                    case "e":
	                        arg = match[7] ? arg.toExponential(match[7]) : arg.toExponential()
	                    break
	                    case "f":
	                        arg = match[7] ? parseFloat(arg).toFixed(match[7]) : parseFloat(arg)
	                    break
	                    case "g":
	                        arg = match[7] ? parseFloat(arg).toPrecision(match[7]) : parseFloat(arg)
	                    break
	                    case "o":
	                        arg = arg.toString(8)
	                    break
	                    case "s":
	                        arg = ((arg = String(arg)) && match[7] ? arg.substring(0, match[7]) : arg)
	                    break
	                    case "u":
	                        arg = arg >>> 0
	                    break
	                    case "x":
	                        arg = arg.toString(16)
	                    break
	                    case "X":
	                        arg = arg.toString(16).toUpperCase()
	                    break
	                }
	                if (re.json.test(match[8])) {
	                    output[output.length] = arg
	                }
	                else {
	                    if (re.number.test(match[8]) && (!is_positive || match[3])) {
	                        sign = is_positive ? "+" : "-"
	                        arg = arg.toString().replace(re.sign, "")
	                    }
	                    else {
	                        sign = ""
	                    }
	                    pad_character = match[4] ? match[4] === "0" ? "0" : match[4].charAt(1) : " "
	                    pad_length = match[6] - (sign + arg).length
	                    pad = match[6] ? (pad_length > 0 ? str_repeat(pad_character, pad_length) : "") : ""
	                    output[output.length] = match[5] ? sign + arg + pad : (pad_character === "0" ? sign + pad + arg : pad + sign + arg)
	                }
	            }
	        }
	        return output.join("")
	    }
	
	    sprintf.cache = {}
	
	    sprintf.parse = function(fmt) {
	        var _fmt = fmt, match = [], parse_tree = [], arg_names = 0
	        while (_fmt) {
	            if ((match = re.text.exec(_fmt)) !== null) {
	                parse_tree[parse_tree.length] = match[0]
	            }
	            else if ((match = re.modulo.exec(_fmt)) !== null) {
	                parse_tree[parse_tree.length] = "%"
	            }
	            else if ((match = re.placeholder.exec(_fmt)) !== null) {
	                if (match[2]) {
	                    arg_names |= 1
	                    var field_list = [], replacement_field = match[2], field_match = []
	                    if ((field_match = re.key.exec(replacement_field)) !== null) {
	                        field_list[field_list.length] = field_match[1]
	                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== "") {
	                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
	                                field_list[field_list.length] = field_match[1]
	                            }
	                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
	                                field_list[field_list.length] = field_match[1]
	                            }
	                            else {
	                                throw new SyntaxError("[sprintf] failed to parse named argument key")
	                            }
	                        }
	                    }
	                    else {
	                        throw new SyntaxError("[sprintf] failed to parse named argument key")
	                    }
	                    match[2] = field_list
	                }
	                else {
	                    arg_names |= 2
	                }
	                if (arg_names === 3) {
	                    throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported")
	                }
	                parse_tree[parse_tree.length] = match
	            }
	            else {
	                throw new SyntaxError("[sprintf] unexpected placeholder")
	            }
	            _fmt = _fmt.substring(match[0].length)
	        }
	        return parse_tree
	    }
	
	    var vsprintf = function(fmt, argv, _argv) {
	        _argv = (argv || []).slice(0)
	        _argv.splice(0, 0, fmt)
	        return sprintf.apply(null, _argv)
	    }
	
	    /**
	     * helpers
	     */
	    function get_type(variable) {
	        return Object.prototype.toString.call(variable).slice(8, -1).toLowerCase()
	    }
	
	    function str_repeat(input, multiplier) {
	        return Array(multiplier + 1).join(input)
	    }
	
	    /**
	     * export to either browser or node.js
	     */
	    if (true) {
	        exports.sprintf = sprintf
	        exports.vsprintf = vsprintf
	    }
	    else {
	        window.sprintf = sprintf
	        window.vsprintf = vsprintf
	
	        if (typeof define === "function" && define.amd) {
	            define(function() {
	                return {
	                    sprintf: sprintf,
	                    vsprintf: vsprintf
	                }
	            })
	        }
	    }
	})(typeof window === "undefined" ? this : window);


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	var deprecate = __webpack_require__(451);
	
	module.exports = deprecate(__webpack_require__(452).vsprintf,
	  'vsprintf() will be removed in the next major release, use the sprintf-js package instead.');


/***/ }),
/* 454 */
/***/ (function(module, exports) {

	module.exports = function toNumber(num, precision) {
	  if (num == null) return 0;
	  var factor = Math.pow(10, isFinite(precision) ? precision : 0);
	  return Math.round(num * factor) / factor;
	};


/***/ }),
/* 455 */
/***/ (function(module, exports) {

	module.exports = function numberFormat(number, dec, dsep, tsep) {
	  if (isNaN(number) || number == null) return '';
	
	  number = number.toFixed(~~dec);
	  tsep = typeof tsep == 'string' ? tsep : ',';
	
	  var parts = number.split('.'),
	    fnums = parts[0],
	    decimals = parts[1] ? (dsep || '.') + parts[1] : '';
	
	  return fnums.replace(/(\d)(?=(?:\d{3})+$)/g, '$1' + tsep) + decimals;
	};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function strRight(str, sep) {
	  str = makeString(str);
	  sep = makeString(sep);
	  var pos = !sep ? -1 : str.indexOf(sep);
	  return~ pos ? str.slice(pos + sep.length, str.length) : str;
	};


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function strRightBack(str, sep) {
	  str = makeString(str);
	  sep = makeString(sep);
	  var pos = !sep ? -1 : str.lastIndexOf(sep);
	  return~ pos ? str.slice(pos + sep.length, str.length) : str;
	};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function strLeft(str, sep) {
	  str = makeString(str);
	  sep = makeString(sep);
	  var pos = !sep ? -1 : str.indexOf(sep);
	  return~ pos ? str.slice(0, pos) : str;
	};


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function strLeftBack(str, sep) {
	  str = makeString(str);
	  sep = makeString(sep);
	  var pos = str.lastIndexOf(sep);
	  return~ pos ? str.slice(0, pos) : str;
	};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	var rtrim = __webpack_require__(441);
	
	module.exports = function toSentence(array, separator, lastSeparator, serial) {
	  separator = separator || ', ';
	  lastSeparator = lastSeparator || ' and ';
	  var a = array.slice(),
	    lastMember = a.pop();
	
	  if (array.length > 2 && serial) lastSeparator = rtrim(separator) + lastSeparator;
	
	  return a.length ? a.join(separator) + lastSeparator + lastMember : lastMember;
	};


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	var toSentence = __webpack_require__(460);
	
	module.exports = function toSentenceSerial(array, sep, lastSep) {
	  return toSentence(array, sep, lastSep, true);
	};


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(408);
	var dasherize = __webpack_require__(437);
	var cleanDiacritics = __webpack_require__(412);
	
	module.exports = function slugify(str) {
	  return trim(dasherize(cleanDiacritics(str).replace(/[^\w\s-]/g, '-').toLowerCase()), '-');
	};


/***/ }),
/* 463 */
/***/ (function(module, exports) {

	module.exports = function surround(str, wrapper) {
	  return [wrapper, str, wrapper].join('');
	};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	var surround = __webpack_require__(463);
	
	module.exports = function quote(str, quoteChar) {
	  return surround(str, quoteChar || '"');
	};


/***/ }),
/* 465 */
/***/ (function(module, exports) {

	module.exports = function unquote(str, quoteChar) {
	  quoteChar = quoteChar || '"';
	  if (str[0] === quoteChar && str[str.length - 1] === quoteChar)
	    return str.slice(1, str.length - 1);
	  else return str;
	};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	var strRepeat = __webpack_require__(446);
	
	module.exports = function repeat(str, qty, separator) {
	  str = makeString(str);
	
	  qty = ~~qty;
	
	  // using faster implementation if separator is not needed;
	  if (separator == null) return strRepeat(str, qty);
	
	  // this one is about 300x slower in Google Chrome
	  /*eslint no-empty: 0*/
	  for (var repeat = []; qty > 0; repeat[--qty] = str) {}
	  return repeat.join(separator);
	};


/***/ }),
/* 467 */
/***/ (function(module, exports) {

	module.exports = function naturalCmp(str1, str2) {
	  if (str1 == str2) return 0;
	  if (!str1) return -1;
	  if (!str2) return 1;
	
	  var cmpRegex = /(\.\d+|\d+|\D+)/g,
	    tokens1 = String(str1).match(cmpRegex),
	    tokens2 = String(str2).match(cmpRegex),
	    count = Math.min(tokens1.length, tokens2.length);
	
	  for (var i = 0; i < count; i++) {
	    var a = tokens1[i],
	      b = tokens2[i];
	
	    if (a !== b) {
	      var num1 = +a;
	      var num2 = +b;
	      if (num1 === num1 && num2 === num2) {
	        return num1 > num2 ? 1 : -1;
	      }
	      return a < b ? -1 : 1;
	    }
	  }
	
	  if (tokens1.length != tokens2.length)
	    return tokens1.length - tokens2.length;
	
	  return str1 < str2 ? -1 : 1;
	};


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	/**
	 * Based on the implementation here: https://github.com/hiddentao/fast-levenshtein
	 */
	module.exports = function levenshtein(str1, str2) {
	  'use strict';
	  str1 = makeString(str1);
	  str2 = makeString(str2);
	
	  // Short cut cases  
	  if (str1 === str2) return 0;
	  if (!str1 || !str2) return Math.max(str1.length, str2.length);
	
	  // two rows
	  var prevRow = new Array(str2.length + 1);
	
	  // initialise previous row
	  for (var i = 0; i < prevRow.length; ++i) {
	    prevRow[i] = i;
	  }
	
	  // calculate current row distance from previous row
	  for (i = 0; i < str1.length; ++i) {
	    var nextCol = i + 1;
	
	    for (var j = 0; j < str2.length; ++j) {
	      var curCol = nextCol;
	
	      // substution
	      nextCol = prevRow[j] + ( (str1.charAt(i) === str2.charAt(j)) ? 0 : 1 );
	      // insertion
	      var tmp = curCol + 1;
	      if (nextCol > tmp) {
	        nextCol = tmp;
	      }
	      // deletion
	      tmp = prevRow[j + 1] + 1;
	      if (nextCol > tmp) {
	        nextCol = tmp;
	      }
	
	      // copy current col value into previous (in preparation for next iteration)
	      prevRow[j] = curCol;
	    }
	
	    // copy last col value into previous (in preparation for next iteration)
	    prevRow[j] = nextCol;
	  }
	
	  return nextCol;
	};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(408);
	
	function boolMatch(s, matchers) {
	  var i, matcher, down = s.toLowerCase();
	  matchers = [].concat(matchers);
	  for (i = 0; i < matchers.length; i += 1) {
	    matcher = matchers[i];
	    if (!matcher) continue;
	    if (matcher.test && matcher.test(s)) return true;
	    if (matcher.toLowerCase() === down) return true;
	  }
	}
	
	module.exports = function toBoolean(str, trueValues, falseValues) {
	  if (typeof str === 'number') str = '' + str;
	  if (typeof str !== 'string') return !!str;
	  str = trim(str);
	  if (boolMatch(str, trueValues || ['true', '1'])) return true;
	  if (boolMatch(str, falseValues || ['false', '0'])) return false;
	};


/***/ }),
/* 470 */
/***/ (function(module, exports) {

	module.exports = function() {
	  var result = {};
	
	  for (var prop in this) {
	    if (!this.hasOwnProperty(prop) || prop.match(/^(?:include|contains|reverse|join|map|wrap)$/)) continue;
	    result[prop] = this[prop];
	  }
	
	  return result;
	};


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	// Wrap
	// wraps a string by a certain width
	
	var makeString = __webpack_require__(403);
	
	module.exports = function wrap(str, options){
	  str = makeString(str);
	  
	  options = options || {};
	  
	  var width = options.width || 75;
	  var seperator = options.seperator || '\n';
	  var cut = options.cut || false;
	  var preserveSpaces = options.preserveSpaces || false;
	  var trailingSpaces = options.trailingSpaces || false;
	  
	  var result;
	  
	  if(width <= 0){
	    return str;
	  }
	  
	  else if(!cut){
	  
	    var words = str.split(' ');
	    var current_column = 0;
	    result = '';
	  
	    while(words.length > 0){
	      
	      // if adding a space and the next word would cause this line to be longer than width...
	      if(1 + words[0].length + current_column > width){
	        //start a new line if this line is not already empty
	        if(current_column > 0){
	          // add a space at the end of the line is preserveSpaces is true
	          if (preserveSpaces){
	            result += ' ';
	            current_column++;
	          }
	          // fill the rest of the line with spaces if trailingSpaces option is true
	          else if(trailingSpaces){
	            while(current_column < width){
	              result += ' ';
	              current_column++;
	            }            
	          }
	          //start new line
	          result += seperator;
	          current_column = 0;
	        }
	      }
	  
	      // if not at the begining of the line, add a space in front of the word
	      if(current_column > 0){
	        result += ' ';
	        current_column++;
	      }
	  
	      // tack on the next word, update current column, a pop words array
	      result += words[0];
	      current_column += words[0].length;
	      words.shift();
	  
	    }
	  
	    // fill the rest of the line with spaces if trailingSpaces option is true
	    if(trailingSpaces){
	      while(current_column < width){
	        result += ' ';
	        current_column++;
	      }            
	    }
	  
	    return result;
	  
	  }
	  
	  else {
	  
	    var index = 0;
	    result = '';
	  
	    // walk through each character and add seperators where appropriate
	    while(index < str.length){
	      if(index % width == 0 && index > 0){
	        result += seperator;
	      }
	      result += str.charAt(index);
	      index++;
	    }
	  
	    // fill the rest of the line with spaces if trailingSpaces option is true
	    if(trailingSpaces){
	      while(index % width > 0){
	        result += ' ';
	        index++;
	      }            
	    }
	    
	    return result;
	  }
	};


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(403);
	
	module.exports = function(str, callback) {
	  str = makeString(str);
	
	  if (str.length === 0 || typeof callback !== 'function') return str;
	
	  return str.replace(/./g, callback);
	};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(474),
	    findIndex = __webpack_require__(475);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(281),
	    isArrayLike = __webpack_require__(277),
	    keys = __webpack_require__(251);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(476),
	    baseIteratee = __webpack_require__(281),
	    toInteger = __webpack_require__(477);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 476 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(478);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(479);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(279),
	    isSymbol = __webpack_require__(351);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 480 */
388,
/* 481 */
388,
/* 482 */
388,
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SiteSidebar = __webpack_require__(484);
	
	var _SiteSidebar2 = _interopRequireDefault(_SiteSidebar);
	
	__webpack_require__(492);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SitePage = function (_React$Component) {
	  _inherits(SitePage, _React$Component);
	
	  function SitePage() {
	    _classCallCheck(this, SitePage);
	
	    return _possibleConstructorReturn(this, (SitePage.__proto__ || Object.getPrototypeOf(SitePage)).apply(this, arguments));
	  }
	
	  _createClass(SitePage, [{
	    key: 'render',
	    value: function render() {
	      var route = this.props.route;
	
	      var post = route.page.data;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_SiteSidebar2.default, this.props),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'main' },
	            _react2.default.createElement(
	              'div',
	              { className: 'main-inner' },
	              _react2.default.createElement(
	                'div',
	                { className: 'blog-page' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'text' },
	                  _react2.default.createElement(
	                    'h1',
	                    null,
	                    post.title
	                  ),
	                  _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: post.body } })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SitePage;
	}(_react2.default.Component);
	
	SitePage.propTypes = {
	  route: _react2.default.PropTypes.object.isRequired
	};
	
	exports.default = SitePage;
	module.exports = exports['default'];

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(171);
	
	var _gatsbyHelpers = __webpack_require__(384);
	
	var _config = __webpack_require__(385);
	
	var _SiteNav = __webpack_require__(485);
	
	var _SiteNav2 = _interopRequireDefault(_SiteNav);
	
	var _SiteLinks = __webpack_require__(487);
	
	var _SiteLinks2 = _interopRequireDefault(_SiteLinks);
	
	__webpack_require__(490);
	
	var _photo = __webpack_require__(491);
	
	var _photo2 = _interopRequireDefault(_photo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SiteSidebar = function (_React$Component) {
	  _inherits(SiteSidebar, _React$Component);
	
	  function SiteSidebar() {
	    _classCallCheck(this, SiteSidebar);
	
	    return _possibleConstructorReturn(this, (SiteSidebar.__proto__ || Object.getPrototypeOf(SiteSidebar)).apply(this, arguments));
	  }
	
	  _createClass(SiteSidebar, [{
	    key: 'render',
	    value: function render() {
	      var location = this.props.location;
	
	      var isHome = location.pathname === (0, _gatsbyHelpers.prefixLink)('/');
	
	      /* eslint-disable jsx-a11y/img-redundant-alt*/
	      var header = _react2.default.createElement(
	        'header',
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { style: { textDecoration: 'none', borderBottom: 'none', outline: 'none' }, to: (0, _gatsbyHelpers.prefixLink)('/') },
	          _react2.default.createElement('img', {
	            src: _photo2.default,
	            width: '75', height: '75',
	            alt: 'Profile picture of the author'
	          })
	        ),
	        isHome ? _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { style: { textDecoration: 'none', borderBottom: 'none', color: 'inherit' }, to: (0, _gatsbyHelpers.prefixLink)('/') },
	            ' ',
	            _config.config.siteAuthor
	          )
	        ) : _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { style: { textDecoration: 'none', borderBottom: 'none', color: 'inherit' }, to: (0, _gatsbyHelpers.prefixLink)('/') },
	            ' ',
	            _config.config.siteAuthor
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _config.config.siteDescr
	        )
	      );
	      /* eslint-enable jsx-a11y/img-redundant-alt*/
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'sidebar' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sidebar-inner' },
	          _react2.default.createElement(
	            'div',
	            { className: 'blog-details' },
	            _react2.default.createElement(
	              'header',
	              null,
	              header
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'blog-options' },
	            _react2.default.createElement(_SiteNav2.default, this.props),
	            _react2.default.createElement(
	              'footer',
	              null,
	              _react2.default.createElement(_SiteLinks2.default, this.props),
	              _react2.default.createElement(
	                'p',
	                { className: 'copyright' },
	                '\xA9 All rights reserved.'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SiteSidebar;
	}(_react2.default.Component);
	
	SiteSidebar.propTypes = {
	  location: _react2.default.PropTypes.object
	};
	
	exports.default = SiteSidebar;
	module.exports = exports['default'];

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(171);
	
	var _gatsbyHelpers = __webpack_require__(384);
	
	__webpack_require__(486);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SiteNav = function (_React$Component) {
	  _inherits(SiteNav, _React$Component);
	
	  function SiteNav() {
	    _classCallCheck(this, SiteNav);
	
	    return _possibleConstructorReturn(this, (SiteNav.__proto__ || Object.getPrototypeOf(SiteNav)).apply(this, arguments));
	  }
	
	  _createClass(SiteNav, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'nav',
	        { className: 'blog-nav' },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: (0, _gatsbyHelpers.prefixLink)('/'), activeClassName: 'current', onlyActiveOnIndex: true },
	              ' Articles'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: (0, _gatsbyHelpers.prefixLink)('/books/'), activeClassName: 'current' },
	              ' Books'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: (0, _gatsbyHelpers.prefixLink)('/freelance/'), activeClassName: 'current' },
	              ' Freelance'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: (0, _gatsbyHelpers.prefixLink)('/contact/'), activeClassName: 'current' },
	              ' Contact'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SiteNav;
	}(_react2.default.Component);
	
	exports.default = SiteNav;
	module.exports = exports['default'];

/***/ }),
/* 486 */
388,
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(385);
	
	__webpack_require__(488);
	
	__webpack_require__(489);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SiteLinks = function (_React$Component) {
	  _inherits(SiteLinks, _React$Component);
	
	  function SiteLinks() {
	    _classCallCheck(this, SiteLinks);
	
	    return _possibleConstructorReturn(this, (SiteLinks.__proto__ || Object.getPrototypeOf(SiteLinks)).apply(this, arguments));
	  }
	
	  _createClass(SiteLinks, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'blog-links' },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _config.config.siteTwitterUrl && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: _config.config.siteTwitterUrl },
	              _react2.default.createElement('i', { className: 'fa fa-twitter' })
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.facebook.com/adablitzkrieg' },
	              _react2.default.createElement('i', { className: 'fa fa-facebook' })
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://instagram.com/bangpowwww' },
	              _react2.default.createElement('i', { className: 'fa fa-instagram' })
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://soundcloud.com/bangpowwww' },
	              _react2.default.createElement('i', { className: 'fa fa-soundcloud' })
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'http://www.linkedin.com/in/adablitzkrieg' },
	              _react2.default.createElement('i', { className: 'fa fa-linkedin' })
	            )
	          ),
	          _config.config.siteGithubUrl && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: _config.config.siteGithubUrl },
	              _react2.default.createElement('i', { className: 'fa fa-github-alt' })
	            )
	          ),
	          _config.config.siteVkUrl && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: _config.config.siteVkUrl },
	              _react2.default.createElement('i', { className: 'fa fa-vk' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _config.config.siteEmailUrl && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:' + _config.config.siteEmailUrl },
	              _react2.default.createElement('i', { className: 'fa fa-envelope-o' })
	            )
	          ),
	          _config.config.siteTelegramUrl && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: _config.config.siteTelegramUrl },
	              _react2.default.createElement('i', { className: 'fa fa-paper-plane' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _config.config.siteRssUrl && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: _config.config.siteRssUrl },
	              _react2.default.createElement('i', { className: 'fa fa-rss' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SiteLinks;
	}(_react2.default.Component);
	
	exports.default = SiteLinks;
	module.exports = exports['default'];

/***/ }),
/* 488 */
388,
/* 489 */
388,
/* 490 */
388,
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "87a7189626963402bbcdf2c54be05a47.jpg";

/***/ }),
/* 492 */
388,
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactGa = __webpack_require__(494);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _config = __webpack_require__(385);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactGa2.default.initialize(_config.config.googleAnalyticsId);
	
	exports.onRouteUpdate = function (state) {
	  _reactGa2.default.pageview(state.pathname);
	};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * React Google Analytics Module
	 *
	 * @package react-ga
	 * @author  Adam Lofting <adam@mozillafoundation.org>
	 *          Atul Varma <atul@mozillafoundation.org>
	 */
	
	/**
	 * Utilities
	 */
	var format = __webpack_require__(495);
	var removeLeadingSlash = __webpack_require__(500);
	var trim = __webpack_require__(498);
	
	var warn = __webpack_require__(499);
	var log = __webpack_require__(501);
	
	var _debug = false;
	var _titleCase = true;
	
	var _format = function (s) {
	  return format(s, _titleCase);
	};
	
	var ReactGA = {
	  initialize: function (gaTrackingID, options) {
	    if (!gaTrackingID) {
	      warn('gaTrackingID is required in initialize()');
	      return;
	    }
	
	    if (options) {
	      if (options.debug && options.debug === true) {
	        _debug = true;
	      }
	
	      if (options.titleCase === false) {
	        _titleCase = false;
	      }
	    }
	
	    // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	    // jscs:disable
	    (function (i, s, o, g, r, a, m) {
	      i['GoogleAnalyticsObject'] = r;
	      i[r] = i[r] || function () {
	        (i[r].q = i[r].q || []).push(arguments);
	      }, i[r].l = 1 * new Date();
	      a = s.createElement(o),
	          m = s.getElementsByTagName(o)[0];
	      a.async = 1;
	      a.src = g;
	      m.parentNode.insertBefore(a, m);
	    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
	    // jscs:enable
	
	    if (options && options.gaOptions) {
	      ga('create', gaTrackingID, options.gaOptions);
	    } else {
	      ga('create', gaTrackingID, 'auto');
	    }
	  },
	
	  /**
	   * ga:
	   * Returns the original GA object.
	   */
	  ga: function () {
	    if (arguments.length > 0) {
	      ga.apply(this, arguments);
	      if (_debug) {
	        log('called ga(\'arguments\');');
	        log('with arguments: ' + JSON.stringify([].slice.apply(arguments)));
	      }
	
	      return;
	    }
	
	    return ga;
	  },
	
	  /**
	   * set:
	   * GA tracker set method
	   * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	   */
	  set: function (fieldsObject) {
	    if (typeof ga === 'function') {
	      if (!fieldsObject) {
	        warn('`fieldsObject` is required in .set()');
	        return;
	      }
	
	      if (typeof fieldsObject !== 'object') {
	        warn('Expected `fieldsObject` arg to be an Object');
	        return;
	      }
	
	      if (Object.keys(fieldsObject).length === 0) {
	        warn('empty `fieldsObject` given to .set()');
	      }
	
	      ga('set', fieldsObject);
	
	      if (_debug) {
	        log('called ga(\'set\', fieldsObject);');
	        log('with fieldsObject: ' + JSON.stringify(fieldsObject));
	      }
	    }
	  },
	
	  /**
	   * send:
	   * Clone of the low level `ga.send` method
	   * WARNING: No validations will be applied to this
	   * @param  {Object} fieldObject - field object for tracking different analytics
	   */
	  send: function (fieldObject) {
	    if (typeof ga === 'function') {
	      ga('send', fieldObject);
	
	      if (_debug) {
	        log('called ga(\'send\', fieldObject);');
	        log('with fieldObject: ' + JSON.stringify(fieldObject));
	      }
	    }
	  },
	
	  /**
	   * pageview:
	   * Basic GA pageview tracking
	   * @param  {String} path - the current page page e.g. '/about'
	   */
	  pageview: function (path) {
	    if (!path) {
	      warn('path is required in .pageview()');
	      return;
	    }
	
	    path = trim(path);
	    if (path === '') {
	      warn('path cannot be an empty string in .pageview()');
	      return;
	    }
	
	    if (typeof ga === 'function') {
	      ga('send', 'pageview', path);
	
	      if (_debug) {
	        log('called ga(\'send\', \'pageview\', path);');
	        log('with path: ' + path);
	      }
	    }
	  },
	
	  /**
	   * modalview:
	   * a proxy to basic GA pageview tracking to consistently track
	   * modal views that are an equivalent UX to a traditional pageview
	   * @param  {String} modalName e.g. 'add-or-edit-club'
	   */
	  modalview: function (modalName) {
	    if (!modalName) {
	      warn('modalName is required in .modalview(modalName)');
	      return;
	    }
	
	    modalName = trim(modalName);
	    modalName = removeLeadingSlash(modalName);
	
	    if (modalName === '') {
	      warn('modalName cannot be an empty string or a single / in .modalview()');
	      return;
	    }
	
	    if (typeof ga === 'function') {
	      modalName = trim(modalName);
	      var path = '/modal/' + modalName;
	      ga('send', 'pageview', path);
	
	      if (_debug) {
	        log('called ga(\'send\', \'pageview\', path);');
	        log('with path: ' + path);
	      }
	    }
	  },
	
	  /**
	   * timing:
	   * GA timing
	   * @param args.category {String} required
	   * @param args.variable {String} required
	   * @param args.value  {Int}  required
	   * @param args.label  {String} required
	   */
	  timing: function (args) {
	    if (typeof ga === 'function') {
	      if (!args || !args.category || !args.variable
	          || !args.value || typeof args.value !== 'number') {
	        warn('args.category, args.variable ' +
	              'AND args.value are required in timing() ' +
	              'AND args.value has to be a number');
	        return;
	      }
	
	      //Required Fields
	      var fieldObject = {
	        hitType: 'timing',
	        timingCategory: _format(args.category),
	        timingVar: _format(args.variable),
	        timingValue: args.value
	      };
	
	      if (args.label) {
	        fieldObject.timingLabel = _format(args.label);
	      }
	
	      this.send(fieldObject);
	    }
	  },
	
	  /**
	   * event:
	   * GA event tracking
	   * @param args.category {String} required
	   * @param args.action {String} required
	   * @param args.label {String} optional
	   * @param args.value {Int} optional
	   * @param args.nonInteraction {boolean} optional
	   */
	  event: function (args) {
	    if (typeof ga === 'function') {
	
	      // Simple Validation
	      if (!args || !args.category || !args.action) {
	        warn('args.category AND args.action are required in event()');
	        return;
	      }
	
	      // Required Fields
	      var fieldObject = {
	        hitType: 'event',
	        eventCategory: _format(args.category),
	        eventAction: _format(args.action)
	      };
	
	      // Optional Fields
	      if (args.label) {
	        fieldObject.eventLabel = _format(args.label);
	      }
	
	      if (args.hasOwnProperty('value')) {
	        if (typeof args.value !== 'number') {
	          warn('Expected `args.value` arg to be a Number.');
	        } else {
	          fieldObject.eventValue = args.value;
	        }
	      }
	
	      if (args.nonInteraction) {
	        if (typeof args.nonInteraction !== 'boolean') {
	          warn('`args.nonInteraction` must be a boolean.');
	        } else {
	          fieldObject.nonInteraction = args.nonInteraction;
	        }
	      }
	
	      if (args.transport) {
	        if (typeof args.transport !== 'string') {
	          warn('`args.transport` must be a string.');
	        } else {
	          if (['beacon', 'xhr', 'image'].indexOf(args.transport) === -1) {
	            warn('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	          }
	
	          fieldObject.transport = args.transport;
	        }
	      }
	
	      // Send to GA
	      this.send(fieldObject);
	    }
	  },
	
	  /**
	   * exception:
	   * GA exception tracking
	   * @param args.description {String} optional
	   * @param args.fatal {boolean} optional
	   */
	  exception: function (args) {
	    if (typeof ga === 'function') {
	
	      // Required Fields
	      var fieldObject = {
	        hitType: 'exception'
	      };
	
	      // Optional Fields
	      if (args.description) {
	        fieldObject.exDescription = _format(args.description);
	      }
	
	      if (typeof args.fatal !== 'undefined') {
	        if (typeof args.fatal !== 'boolean') {
	          warn('`args.fatal` must be a boolean.');
	        } else {
	          fieldObject.exFatal = args.fatal;
	        }
	      }
	
	      // Send to GA
	      this.send(fieldObject);
	    }
	  },
	
	  plugin: {
	    /**
	     * require:
	     * GA requires a plugin
	     * @param name {String} e.g. 'ecommerce' or 'myplugin'
	     * @param options {Object} optional e.g {path: '/log', debug: true}
	     */
	    require: function (name, options) {
	      if (typeof ga === 'function') {
	
	        // Required Fields
	        if (!name) {
	          warn('`name` is required in .require()');
	          return;
	        }
	
	        name = trim(name);
	        if (name === '') {
	          warn('`name` cannot be an empty string in .require()');
	          return;
	        }
	
	        // Optional Fields
	        if (options) {
	          if (typeof options !== 'object') {
	            warn('Expected `options` arg to be an Object');
	            return;
	          }
	
	          if (Object.keys(options).length === 0) {
	            warn('Empty `options` given to .require()');
	          }
	
	          ga('require', name, options);
	
	          if (_debug) {
	            log('called ga(\'require\', \'' + name + '\', ' + JSON.stringify(options) + ');');
	          }
	
	          return;
	        } else {
	          ga('require', name);
	
	          if (_debug) {
	            log('called ga(\'require\', \'' + name + '\');');
	          }
	
	          return;
	        }
	      }
	    },
	
	    /**
	     * execute:
	     * GA execute action for plugin
	     * Takes variable number of arguments
	     * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	     * @param action {String} e.g. 'addItem' or 'myCustomAction'
	     * @param actionType {String} optional e.g. 'detail'
	     * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	     */
	    execute: function () {
	      var args = Array.prototype.slice.call(arguments);
	
	      var pluginName = args[0];
	      var action = args[1];
	      var payload;
	      var actionType;
	
	      if (args.length === 3) {
	        payload = args[2];
	      } else {
	        actionType = args[2];
	        payload = args[3];
	      }
	
	      if (typeof ga === 'function') {
	        if (typeof pluginName !== 'string') {
	          warn('Expected `pluginName` arg to be a String.');
	        } else if (typeof action !== 'string') {
	          warn('Expected `action` arg to be a String.');
	        } else {
	          var command = pluginName + ':' + action;
	          payload = payload || null;
	          if (actionType && payload) {
	            ga(command, actionType, payload);
	            if (_debug) {
	              log('called ga(\'' + command + '\');');
	              log('actionType: "' + actionType + '" with payload: ' + JSON.stringify(payload));
	            }
	          } else if (payload) {
	            ga(command, payload);
	            if (_debug) {
	              log('called ga(\'' + command + '\');');
	              log('with payload: ' + JSON.stringify(payload));
	            }
	          } else {
	            ga(command);
	            if (_debug) {
	              log('called ga(\'' + command + '\');');
	            }
	
	          }
	        }
	      }
	    }
	  },
	
	  /**
	   * outboundLink:
	   * GA outboundLink tracking
	   * @param args.label {String} e.g. url, or 'Create an Account'
	   * @param {function} hitCallback - Called after processing a hit.
	   */
	  outboundLink: function (args, hitCallback) {
	    if (typeof hitCallback !== 'function') {
	      warn('hitCallback function is required');
	      return;
	    }
	
	    if (typeof ga === 'function') {
	
	      // Simple Validation
	      if (!args || !args.label) {
	        warn('args.label is required in outboundLink()');
	        return;
	      }
	
	      // Required Fields
	      var fieldObject = {
	        hitType: 'event',
	        eventCategory: 'Outbound',
	        eventAction: 'Click',
	        eventLabel: _format(args.label)
	      };
	
	      var safetyCallbackCalled = false;
	      var safetyCallback = function () {
	
	        // This prevents a delayed response from GA
	        // causing hitCallback from being fired twice
	        safetyCallbackCalled = true;
	
	        hitCallback();
	      };
	
	      // Using a timeout to ensure the execution of critical application code
	      // in the case when the GA server might be down
	      // or an ad blocker prevents sending the data
	
	      // register safety net timeout:
	      var t = setTimeout(safetyCallback, 250);
	
	      var clearableCallbackForGA = function () {
	        clearTimeout(t);
	        if (!safetyCallbackCalled) {
	          hitCallback();
	        }
	      };
	
	      fieldObject.hitCallback = clearableCallbackForGA;
	
	      // Send to GA
	      this.send(fieldObject);
	    } else {
	      // if ga is not defined, return the callback so the application
	      // continues to work as expected
	      setTimeout(hitCallback, 0);
	    }
	  }
	};
	
	var OutboundLink = __webpack_require__(502);
	OutboundLink.origTrackLink = OutboundLink.trackLink;
	OutboundLink.trackLink = ReactGA.outboundLink.bind(ReactGA);
	ReactGA.OutboundLink = OutboundLink;
	
	module.exports = ReactGA;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	var mightBeEmail = __webpack_require__(496);
	var toTitleCase = __webpack_require__(497);
	var warn = __webpack_require__(499);
	
	var _redacted = 'REDACTED (Potential Email Address)';
	
	function format(s, titleCase) {
	  if (mightBeEmail(s)) {
	    warn('This arg looks like an email address, redacting.');
	    return _redacted;
	  }
	
	  if (titleCase) {
	    return toTitleCase(s);
	  }
	
	  return s;
	}
	
	module.exports = format;


/***/ }),
/* 496 */
/***/ (function(module, exports) {

	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return (/[^@]+@[^@]+/).test(s);
	}
	
	module.exports = mightBeEmail;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * To Title Case 2.1 - http://individed.com/code/to-title-case/
	 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	 * https://github.com/gouch/to-title-case
	 */
	
	var trim = __webpack_require__(498);
	
	function toTitleCase(s) {
	  var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
	  s = trim(s);
	
	  return s.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 &&
	        index + match.length !== title.length &&
	        match.search(smallWords) > -1 &&
	        title.charAt(index - 2) !== ':' &&
	        (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
	        title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	module.exports = toTitleCase;


/***/ }),
/* 498 */
/***/ (function(module, exports) {

	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	
	function trim(s) {
	  return s.replace(/^\s+|\s+$/g, '');
	}
	
	module.exports = trim;


/***/ }),
/* 499 */
/***/ (function(module, exports) {

	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	module.exports = warn;


/***/ }),
/* 500 */
/***/ (function(module, exports) {

	function removeLeadingSlash(s) {
	  if (s.substring(0, 1) === '/') {
	    s = s.substring(1);
	  }
	
	  return s;
	}
	
	module.exports = removeLeadingSlash;


/***/ }),
/* 501 */
/***/ (function(module, exports) {

	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	module.exports = log;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(2);
	var CreateReactClass = __webpack_require__(503);
	var PropTypes = __webpack_require__(504);
	var assign = __webpack_require__(4);
	
	var NEWTAB = '_blank';
	
	var OutboundLink = CreateReactClass({
	  displayName: 'OutboundLink',
	  propTypes: {
	    eventLabel: PropTypes.string.isRequired
	  },
	  statics: {
	    trackLink: function () {
	      console.warn('ga tracking not enabled');
	    }
	  },
	  handleClick: function (e) {
	    e.preventDefault();
	    var props = this.props;
	    var eventMeta = { label: props.eventLabel };
	    OutboundLink.trackLink(eventMeta, function () {
	      if (props.target === NEWTAB) {
	        window.open(props.to, NEWTAB);
	      } else {
	        window.location.href = props.to;
	      }
	    });
	
	    if (props.onClick) {
	      props.onClick(e);
	    }
	  },
	
	  render: function () {
	    var props = assign({}, this.props, {
	      href: this.props.to,
	      onClick: this.handleClick
	    });
	    delete props.eventLabel;
	    return React.createElement('a', props);
	  }
	});
	
	module.exports = OutboundLink;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(2);
	var factory = __webpack_require__(30);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(505)();
	}


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(9);
	var invariant = __webpack_require__(12);
	var ReactPropTypesSecret = __webpack_require__(26);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*  weak */
	// This file is auto-written and used by Gatsby to require
	// files from your pages directory.
	
	module.exports = function (callback) {
	  var context = __webpack_require__(507);if (false) {
	    module.hot.accept(context.id, function () {
	      context = require.context('./pages', true, /(coffee|cjsx|ts|tsx|jsx|js|md|rmd|mkdn?|mdwn|mdown|markdown|litcoffee|ipynb|html|json|yaml|toml)$/ // eslint-disable-line
	      );return callback(context);
	    });
	  }
	  return callback(context);
	};

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./10-dinge-die-man-bei-grippe-tun-kann/index.md": 508,
		"./10-erkenntnisse-uber-frankreich/index.md": 509,
		"./10-grnde-warum-berlin-out-ist-/index.md": 510,
		"./404.md": 511,
		"./99fire-films-award/index.md": 512,
		"./_template.jsx": 387,
		"./ada-and-her-dream-of-horses/index.md": 513,
		"./ada-blitzkrieg-das-hoerbuch/index.md": 514,
		"./ada-blitzkrieg-guckt-alles/index.md": 515,
		"./alles-gute-zum-geburtstag-ada/index.md": 516,
		"./als-ich-ein-pony-zu-weihnachten-bekam/index.md": 517,
		"./apartment-hunting-san-francisco/index.md": 518,
		"./archive-post/index.md": 519,
		"./articles/index.md": 520,
		"./audiokrieg-gesammelte-werke-mit-sprachfehler/index.md": 521,
		"./awesome-places-grandmother/index.md": 522,
		"./balkankrieg-vs-textkrieg/index.md": 523,
		"./barbara-scheel-anne-will-und-rassismus-bei-den-piraten/index.md": 524,
		"./batik-3000/index.md": 525,
		"./batiken-statt-club/index.md": 526,
		"./baut-mal-was/index.md": 527,
		"./berlin-festival-2011/index.md": 528,
		"./berlins-bestes-franzbrotchen/index.md": 529,
		"./beschauliches-berlin/index.md": 530,
		"./best-of-republica-2015/index.md": 531,
		"./bildung-gegen-langeweile/index.md": 532,
		"./blitzkrieg-lesen-den-vierten-affen-bestellen/index.md": 533,
		"./blutgrtsche-in-die-homophobie/index.md": 534,
		"./books/index.md": 535,
		"./born-in-1985/index.md": 536,
		"./brotaufstrich-hiroshima/index.md": 537,
		"./california-reisestimmung-mit-instagram-surfprints/index.md": 538,
		"./cats-dogs-and-cake/index.md": 539,
		"./chaos-communication-camp-2011-erster-teil/index.md": 540,
		"./christmas-mixtape-nock-nock-eggnog/index.md": 541,
		"./contact/index.md": 542,
		"./content/images/README.md": 543,
		"./dackelkrieg---ein-roman-von-ada-blitzkrieg/index.md": 544,
		"./dackelkrieg---hrbuch-und-bekenntnisse/index.md": 545,
		"./dackelkrieg/index.md": 546,
		"./darf-man-als-moslem-schinkenchips-essen/index.md": 547,
		"./das-ding-mit-den-dobermannvideos/index.md": 548,
		"./das-ding-mit-den-passfotos-ist-ja-so-/index.md": 549,
		"./das-ding-mit-dobermannern-ist-ja-so/index.md": 550,
		"./das-ding-mit-kurzhaarfrisuren-ist-ja-so/index.md": 551,
		"./das-kuchenvoting/index.md": 552,
		"./der-blitz-geht-nach-san-francisco/index.md": 553,
		"./der-plural-von-poster-lautet-nicht-posters/index.md": 554,
		"./deutsche-und-humor-wetten-dass/index.md": 555,
		"./die-90er-megaparty-oder-wege-in-die-misanthropie/index.md": 556,
		"./die-ada-blitzkrieg-homestory-ii/index.md": 557,
		"./die-blitzkrieg-filmographie/index.md": 558,
		"./die-durum-depression/index.md": 559,
		"./die-illusion-einer-uberflussgesellschaft-containern-in-berlin/index.md": 560,
		"./die-naziheimat-mochte-keine-moschee/index.md": 561,
		"./die-strenge/index.md": 562,
		"./die-zukunft-der-printmedien/index.md": 563,
		"./dienstleister-die-auf-dich-scheieen-dhl/index.md": 564,
		"./diy-cookies/index.md": 565,
		"./ein-sonntag-auf-dem-dachshundrennen/index.md": 566,
		"./eine-bestandsaufnahme/index.md": 567,
		"./endstation-weisensee/index.md": 568,
		"./erfolgreiche-frauen-im-internet---keine-liebesgeschichte/index.md": 569,
		"./erfolgreiche-frauen-und-das-impostor-syndrom/index.md": 570,
		"./eure-meinung-zu-adhs-interessiert-mich-nicht/index.md": 571,
		"./exciting-autumn/index.md": 572,
		"./fashion-entry-mein-lieblingsshirt/index.md": 573,
		"./fatshaming-in-san-francisco-und-berlin/index.md": 574,
		"./fernsehprogramm/index.md": 575,
		"./fischinstallationen-im-offentlichen-raum/index.md": 576,
		"./food-truck-your-life/index.md": 577,
		"./freelance/index.md": 578,
		"./furnished-apartment-in-berlin-kreuzberg-for-18-months/index.md": 579,
		"./fusion-festival-2011/index.md": 580,
		"./gallery/index.md": 581,
		"./german-food-vs-amerikanisches-essen/index.md": 582,
		"./gewinner-des-pferdefunpakets/index.md": 583,
		"./gewinnspiel-mit-pferde-merchandise/index.md": 584,
		"./girls-who-release/index.md": 585,
		"./google-analytics-bewaffnete-affen-und-katzen-mit-busen/index.md": 586,
		"./googledogs-is-my-startup/index.md": 587,
		"./guide-ekelhaftes-berlin/index.md": 588,
		"./guide-how-to-bath-a-cat/index.md": 589,
		"./guide-to-dublin/index.md": 590,
		"./happiness-eine-dystopie/index.md": 591,
		"./hello-san-francisco-mixtape/index.md": 592,
		"./hipster-outtakes/index.md": 593,
		"./hipster-und-deutsche-vorurteile/index.md": 594,
		"./homestory/index.md": 595,
		"./horses-and-their-dream-of-ada/index.md": 596,
		"./how-to-hack-pesto/index.md": 597,
		"./how-to-make-kimchi-fried-rice-with-tofu/index.md": 598,
		"./i-talked-die-interviews/index.md": 599,
		"./ich-mochte-teil-einer-jugendgefahrdung-sein/index.md": 600,
		"./ich-muss-etwas-beichten/index.md": 601,
		"./im-test-vietnamesischer-groemarkt/index.md": 602,
		"./index.jsx": 603,
		"./interessengemeinschaft-batiken-n-e-v/index.md": 605,
		"./intro-album-preview-mit-lady-gaga-im-berghain/index.md": 606,
		"./intro-jahrescharts-2012/index.md": 607,
		"./intro-jahrescharts/index.md": 608,
		"./intro-kolumne-20-dinge-die-ich-bei-wetten-dass-gelernt-habe/index.md": 609,
		"./intro-kolumne-breaking-bad-in-deutschland/index.md": 610,
		"./intro-kolumne-csi-ottweiler-die-deutschen-und-ihr-tatort/index.md": 611,
		"./intro-kolumne-dschungelcamp/index.md": 612,
		"./intro-kolumne-fernseh-dit/index.md": 613,
		"./intro-kolumne-germanys-next-hochwasser-contest/index.md": 614,
		"./intro-kolumne-got-to-dance/index.md": 615,
		"./intro-kolumne-markus-lanz-ein-backstreet-boy-auf-der-ersatzbank/index.md": 616,
		"./intro-kolumne-markus-lanz-und-die-ganzkrperhunziker/index.md": 617,
		"./intro-kolumne-sommerloch/index.md": 618,
		"./intro-kolumne-stuckrad-barre/index.md": 619,
		"./intro-kolumne-warum-sich-der-kleine-lord-ruhig-mal-die-haare-waschen-knnte/index.md": 620,
		"./ist-eine-schlgerei-mit-donato-undenkbar/index.md": 621,
		"./jeder-ist-jetzt-30/index.md": 622,
		"./kampagne-zum-fremdschamen/index.md": 623,
		"./katzen-und-laser-lauert-die-gefahr-in-den-kleinanzeigen/index.md": 624,
		"./kaufen/index.md": 625,
		"./keywords/index.md": 626,
		"./kotti-couture/index.md": 627,
		"./kultur-enlargement/index.md": 628,
		"./lauter-verlorene-manner-frauenquote-und-feminismus/index.md": 629,
		"./learn-the-kitchenbasics-salsa/index.md": 630,
		"./learn-the-kitchenbasics-selfmade-pasta/index.md": 631,
		"./lisa-rank-die-klo-im-hals-autorin/index.md": 632,
		"./listen-sind-das-neue-schwarz/index.md": 633,
		"./lokalradiomoderatoren-beim-bundesvision-songcontest/index.md": 634,
		"./mal-ganz-unter-uns-rezeptlieblinge/index.md": 635,
		"./marathonmann/index.md": 636,
		"./mein-neues-buch-ist-erschienen-die-strenge/index.md": 637,
		"./mein-zweiter-roman---verlage-vor/index.md": 638,
		"./meine-leistungen-als-freiberuflerin/index.md": 639,
		"./menschen-carmen/index.md": 640,
		"./mira-lykke-im-interview/index.md": 641,
		"./mixtape-anatolian-psychedelic/index.md": 642,
		"./mixtape-april-sheesh-days/index.md": 643,
		"./mixtape-birddog/index.md": 644,
		"./mixtape-butter-gang/index.md": 645,
		"./mixtape-chickengirlz/index.md": 646,
		"./mixtape-entfremdung-von-der-leichtigkeit/index.md": 647,
		"./mixtape-fabruar-fap-fap-fap/index.md": 648,
		"./mixtape-fuck-tatort/index.md": 649,
		"./mixtape-goodbye-california/index.md": 650,
		"./mixtape-hasenscharte/index.md": 651,
		"./mixtape-howl-geheule/index.md": 652,
		"./mixtape-im-august-the-miniwurstelmonth/index.md": 653,
		"./mixtape-im-dezember-no-wanderlust/index.md": 654,
		"./mixtape-im-januar-fucktthatshit/index.md": 655,
		"./mixtape-im-juli-adrette-ausreden/index.md": 656,
		"./mixtape-im-juni-the-liverwurst-diaries/index.md": 657,
		"./mixtape-im-mai-peng/index.md": 658,
		"./mixtape-im-november-schnaps-and-zweifel/index.md": 659,
		"./mixtape-im-oktober-the-darkness-lights-you-up/index.md": 660,
		"./mixtape-im-september-goodbye-flutschfinger/index.md": 661,
		"./mixtape-klammbumm/index.md": 662,
		"./mixtape-mai-what-the/index.md": 663,
		"./mixtape-marzipanschnaps-und-gyroskekse/index.md": 664,
		"./mixtape-monaco-mini/index.md": 665,
		"./mixtape-mrz-fuck-you-eiscreme/index.md": 666,
		"./mixtape-next-stop-down/index.md": 667,
		"./mixtape-oh-komm-ohn/index.md": 668,
		"./mixtape-pappa-bear/index.md": 669,
		"./mixtape-pizza-christmas/index.md": 670,
		"./mixtape-summer-silly/index.md": 671,
		"./mixtape-supersuper/index.md": 672,
		"./mixtape-the-birthday-tape/index.md": 673,
		"./mixtape-the-catnapper/index.md": 674,
		"./nationale-burgerwehr-und-bundnis-gegen-das-pferd/index.md": 675,
		"./neid-im-internet/index.md": 676,
		"./neues-blitzkrieg-mixtape-3000-den-tights/index.md": 677,
		"./neues-blitzkrieg-mixtape-turnvatter/index.md": 678,
		"./neues-blogdesign-und-mixtape/index.md": 679,
		"./neuigkeiten-zum-roman/index.md": 680,
		"./neulich-im-supermarkt/index.md": 681,
		"./nightlover-by-max-seedorf-and-airen/index.md": 682,
		"./omg-tiere-videos-der-woche/index.md": 683,
		"./ontape-bodi-bill/index.md": 684,
		"./optimier-dich-doch-selbst-du-opfer/index.md": 685,
		"./paint-your-favorite-blogs/index.md": 686,
		"./partykapitalismus/index.md": 687,
		"./pferdeshow-in-audio/index.md": 688,
		"./pimp-your-silvesterbaum-und-gewinne/index.md": 689,
		"./platzrebellen/index.md": 690,
		"./podcasts-im-in-love/index.md": 691,
		"./portfolio/index.md": 692,
		"./pr-texte-aus-der-holle-folge-1/index.md": 693,
		"./prag-kann-das-was/index.md": 694,
		"./presse/index.md": 695,
		"./prinz-pi-bei-tape-tv/index.md": 696,
		"./rassekatzen-glitzer-und-katzenmasse/index.md": 697,
		"./regentage/index.md": 698,
		"./sag-es-laut-mir-geht-es-gut/index.md": 699,
		"./san-francisco-food-story/index.md": 700,
		"./schlechte-zeiten-gute-zeiten/index.md": 701,
		"./silenttiffy-ihr-roman-and-the-masters-of-aussiedlerfashion/index.md": 702,
		"./slowenien-slowakei-oder-so/index.md": 703,
		"./sofawissenschaften/index.md": 704,
		"./soundcloud-and-fun/index.md": 705,
		"./spannung-vor-dem-release/index.md": 706,
		"./start/index.md": 707,
		"./studiopublikum-frittenbude/index.md": 708,
		"./sukultur/index.md": 709,
		"./swag-guide-to-berlin/index.md": 710,
		"./techno-2pac/index.md": 711,
		"./text-fur-meine-demente-grosmutter/index.md": 712,
		"./textkrieg-buchen/index.md": 713,
		"./textkrieg-goes-to-california/index.md": 714,
		"./the-guide-to-dont-give-a-fuck/index.md": 715,
		"./the-incredible-banana-bread-with-pecan-ice-cream/index.md": 716,
		"./thor-steinar-der-vorbereitungsnazis/index.md": 717,
		"./tkkg-und-der-affen-und-vogelpark/index.md": 718,
		"./welt-funk-blitzkrieg-weihnachtsgruee-c60/index.md": 719,
		"./werbeunterbrechung/index.md": 720,
		"./where-hipsters-get-their-coffee/index.md": 721,
		"./wie-die-welt-quellen-aus-meinen-tweets-streicht/index.md": 722,
		"./wie-ich-2kg-fleisch-in-den-slow-cooker-stammte/index.md": 723,
		"./wie-ist-das-so-als-freiberufler/index.md": 724,
		"./wie-meine-tweets-im-zdf-wieder-auftauchten/index.md": 725,
		"./wie-viel-wahrheit-steckt-in-dackelkrieg/index.md": 726,
		"./wohnungssuche-in-berlin/index.md": 727,
		"./zwischen-frustration-und-freiheit/index.md": 728
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 507;


/***/ }),
/* 508 */
/***/ (function(module, exports) {

	module.exports = {"title":"10 Dinge, die man bei Grippe tun kann","date":"2015-03-04 15:12:53 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2015/Mar/IMG_2309.JPG\" alt=\"alt\">\nLetzte Woche ist es dann doch passiert: Am Samstag war ich noch hochmotiviert und frage meine Timeline nach Anregungen für tolle und aktive Unternehmungen. Die Sonne schien wie blöd und ich fuhr mit meinem aufregenden Zweisitzer-Cabrio (tiefergelegt) nach Berlin Mitte um dort ein bisschen im Park zu Joggen (gehen) und mir danach bei <a href=\"http://daluma.de/\">Daluma</a> (Don’t!) einen etwa 150ml “großen” Gemüse-Saft-Shake für mein Immunsystem zu kaufen. Für 3,50 Euro wohlgemerkt. Dreieurofünfzig. Wie es aber die Ironie des Schicksals so wollte, boostet der Saft meinen Body nicht auf ein höheres X-Men artiges Level, sondern ich steckte mich lediglich mit Grippe an, was ich im Nachhinein nur mit (1/10) bewerten möchte. Nicht eine dieser peinlichen Kindererkältungen. Nein, richtig echte Grippe mit hohem Fieber, Schüttelfrost und Augen so groß wie Medizinbällen. Am dritten Tag hatte ich zudem das Glück, dass aus meiner Nase und aus meinen Augen Wasser floss - mit mehr Druck als man ihn aus Berliner Altbauleitungen gewöhnt ist. Also lag ich im Bett. Von Sonntag bis Freitag. Well done.</p>\n<p>Wie krass krank ich eigentlich war, merkte ich erst, als ich “ein paar Tage später” dachte, dass ich wieder fit genug für den Laptop sei und dabei erstaunt feststellte, dass sich eine millimeterhohe Staubschicht auf die Tastatur gelegt hatte. Ich war einige Zeit aus der Welt gewesen…</p>\n<p>Da momentan immer noch die Grippewelle in Berlin umhergeht und ich gerne ein guter Freund und netter Mensch sein will, habe ich einige Tipps zusammengefasst, falls es euch auch erwischt:</p>\n<h3>1. Lustige Pjyamahosen</h3>\n<p><img src=\"/content/images/2015/Mar/IMG_2367.JPG\" alt=\"alt\">\nWer krank ist, hat es verdient Pyjamahosen mit kleinen Dackeln oder Kakteen zu tragen. Bei über 39,5 Grad Fieber tritt ausserdem das “Fieberschutz-Gesetz” in Kraft, dass es Betroffenen gestattet Shirts mit witziger Aufschrift zu tragen.</p>\n<h3>2. ARTE</h3>\n<p><img src=\"http://upload.wikimedia.org/wikipedia/commons/6/6c/Baobab_and_elephant_Tanzania_-_modified.jpg\" alt=\"alt\">\nAuf ARTE ist immer Verlass. Man schaltet ein und jemand brät Kaninchen in Knoblauchöl an. Wenn man Pech hat, kommt eine Doku über <a href=\"http://www.arte.tv/guide/de/040226-000/baobab\">Affenbrotbäume</a> oder Anacondas. Da kann man im Grund aber auch gut mit leben.</p>\n<h3>3. Better Call Saul</h3>\n<p>Braucht ihr jetzt echt eine Begründung dafür?</p>\n<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/9q4qzYrHVmI\" frameborder=\"0\" allowfullscreen></iframe>\n<h3>4. Omas Wollsocken</h3>\n<p><img src=\"/content/images/2015/Mar/IMG_2363.JPG\" alt=\"alt\">\nDer schwindende Körper hat es verdient nur in die herzigstens Geschmeide eingepackt zu werden. Und in welchem Kleidungsstück steckt mehr Liebe und Wärme, mehr Wohligkeit und Familie, als in den selbstgestrickten Socken unserer Großmütter?</p>\n<h3>5. Anthony Bourdain</h3>\n<p>I love <a href=\"http://en.wikipedia.org/wiki/Anthony_Bourdain\">Tony</a>. Und am meisten liebe ich ihn wenn ich krank bin. Tony ist so eine Art Superheld für mich, denn er reist in seinen Dokuformaten quer um die Welt und fährt sich geiles Essen rein. Essen ist dann geil, wenn es unprätentiös ist, wenn es nicht High-Class ist und wenn man dabei ein bisschen was rattern kann. Wir teilen uns auf jeden Fall den gleichen Geschmack. No Reservations ist vermutlich meine Lieblingsreihe von ihm.</p>\n<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/qoiQ6EI8Uss\" frameborder=\"0\" allowfullscreen></iframe>\n<h3>6. Schlafen</h3>\n<p>Man kann niemals genug schlafen. Besonders wenn man krank ist. Also Smartphone leise schalten, Biberbettwäsche aufziehen und ein paar Tage wegschlafen. Man hat jedes Recht dazu.</p>\n<h3>7. Power Food</h3>\n<p><img src=\"/content/images/2015/Mar/IMG_2364.JPG\" alt=\"alt\">\nJa klar, man könnte jetzt den ganzen Tag Hühnersuppe essen und sich von Gemüsesäften ernähren, aber ist es nicht sowieso schon beschissen genug, dass man krank ist? Während dem hohen Fieber hatte ich ohnehin keinen Appetit. Als ich dann wieder essen konnte, habe ich mich mit den Dingen verwöhnt, die noch im Froster ganz hinten lagen. Verbrannte Schnitzel in zu heißem Fett gebraten und Gewürz-Kartoffelpüree, das man eigentlich mit Wasser kochen sollte, in Milch. Top. Wer einkaufen geht, steckt sich nur mit der nächsten Pest an.</p>\n<h3>8. No Homoöpathie</h3>\n<p><img src=\"/content/images/2015/Mar/walking.jpg\" alt=\"alt\">\nBitch please! By <a href=\"https://www.facebook.com/IFeakingLoveScience?fref=photo&amp;sk=photos\">I fucking love science</a></p>\n<h3>9. Kein Social Media</h3>\n<p><img src=\"/content/images/2015/Mar/IMG_2365.JPG\" alt=\"alt\">\nSollte eigentlich für jeden Tag gelten. Hält sich nur keiner dran! Ein Selfie vom zerquollen Gesicht mit dem Hashtag #thefacesofflu geht hingegen immer.</p>\n<h3>10. Sunglasses</h3>\n<p><img src=\"/content/images/2015/Mar/IMG_2362.JPG\" alt=\"alt\">\nI wear my sunglasses at flu. Im Ernst, bei tränenden Augen und krass laufender Nase hat das wirklich geholfen. Ich schätze weil das Licht ja auch irgendwie reizt. Ausserdem habe ich mich cool und untouchable gefühlt.</p>\n"}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	module.exports = {"title":"10 Erkenntnisse über Frankreich","date":"2014-09-15 13:53:40 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2014/Sep/2014-09-09_1410245913.jpg\" alt=\"alt\"></p>\n<p><strong>1. Unterschätze niemals das Meer!</strong></p>\n<p>Es ist doch so, egal wo man sich aufhält, man wird immer gewarnt, dass man die Flut und den Gezeitenunterschied nicht unterschätzen soll. Dann nickt man wissend und denkt sich innerlich, man sei natürlich jung und fit und flink wie ein Wiesel und dass einen das alles nichts angehen würde. Und dann wird man in der Regel irgendwo eingeschlossen und muss vollbekleidet und mit Smartphone in der Hosentasche zum Strand zurückschwimmen.\nIn der Bretagne beträgt der Unterschied des Wasserstandes bis zu 15 Metern. Das ist impressiv. Man kann bei Ebbe also zu “Inseln” laufen, und über Stellen, die sich normalerweise tief unter der Wasseroberfläche befinden.\nWir wanderten also bewaffnet mit Crevetten-Körben und Kechern durch algenvermatschte Felsen um Krebse zu jagen und behielten die schnell steigende Flut im Auge. Als wir beschlossen langsam und gemütlich zum Strand zurückzuklettern, waren wir bereits auf den Felsen eingeschlossen. Im Rücken eine hohe Mauer auf den Klippen, die ein imposantes französischen Privatanwesen vom spröden Meer trennten. An beiden Seiten der Klippen unpassierbare Passagen. Die Bewohner des Anwesens haben es locker genommen. Immerhin wurden wir nicht nass.</p>\n<p><img src=\"/content/images/2014/Sep/2014-09-09_1410245973.jpg\" alt=\"alt\"></p>\n<p><strong>2. Alles schmeckt</strong></p>\n<p>Es ist wahr, die Qualität französischer Speisen ist weitaus hochwertiger als die vergleichbarer deutscher Produkte. Damit meine ich nicht nur hochpreisige Lebensmittel, sondern schier alles was man bekommt. Dabei ähneln die Preise denen der deutschen Waren. Die Frage lautet also nun: Warum?</p>\n<p><img src=\"/content/images/2014/Sep/2014-09-09_1410246029.jpg\" alt=\"alt\"></p>\n<p><strong>3. Crêpes sind überschätzt</strong></p>\n<p>Crêpes, ja die sind lecker. Und klar, in Frankreich bekommt man die Teiglappen hauchdünn und aus besseren Zutaten hergestellt (siehe 2.). In Creperien kosten die Teile allerdings ziemlich viel (mit Schokocreme 4 Euro) und sättigen nicht wirklich, so dass man für eine angenehme Sättigung mindestens drei Glutenmonster wegcocken müsste.\nDer geheime Star also, und das ist eine wichtige Erkenntnis, sind <a href=\"http://de.wikipedia.org/wiki/Galette\">Galettes</a>. Die Puppen schmecken herzhafter, bestehen aus Buchweizen und werden mit deftigen Zutaten belegt. Ein Klassiker in der Bretagne ist der Galette Complète mit Spiegelei, Schinken und Käse.</p>\n<p><img src=\"/content/images/2014/Sep/2014-09-10_1410330072.jpg\" alt=\"alt\"></p>\n<p><strong>4. Kochen: Je einfacher, desto besser!</strong></p>\n<p>Wenn die Qualität der Zutaten stimmt, gibt es nichts befriedigenderes als einfache Rezepte. Die meisten Abende haben wir damit verbracht hausgroße Käseplatten herzurichten, Baguette zu zerreissen, guten Wein zu kippen und komplette Fische (Sardinen) auf den Grill zu werfen, die lediglich gesalzen wurden und dann nachher mit den Händen, unausgenommen, zerpflückt wurden.</p>\n<p><img src=\"/content/images/2014/Sep/2014-09-14_1410711389.jpg\" alt=\"alt\"></p>\n<p><strong>5. Die Sonne ist in jedem Land ein Arschloch!</strong></p>\n<p>Klar, die Sonne macht tolle Sachen wie Blumen zum Wachsen zu bringen, Wärme spenden und für gute Laune zu sorgen, aber sie richtet auch brutale Schäden an. Besonders auf hellhäutigen Menschen. Besonders beim Cabriofahren. Und besonders an mir. Daher habe ich es mir abgewöhnt nach dem Urlaub meinen Fun anhand der Bräune zu messen, sitze lieber im Schatten und kleide mich adäquat.</p>\n<p><img src=\"/content/images/2014/Sep/2014-09-11_1410437649.jpg\" alt=\"alt\"></p>\n<p><strong>5. Spinnen können auch Kunsthandwerk</strong></p>\n<p>Ich möchte eigentlich keine Werbung für Typen machen, die ich auf den Tod nicht ausstehen kann, aber dieses Gebilde war einfach zu gelungen.</p>\n<p><img src=\"/content/images/2014/Sep/2014-09-10_1410345397.jpg\" alt=\"alt\"></p>\n<p><strong>6. Geschwindigkeitsbegrenzung auf der Autobahn ist gut</strong></p>\n<p>Freiheit ist natürlich ein hohes Gut, na klar, was aber, wenn einem diese Freiheit im Grunde keinen Vorteil bringt, ausser unendlichen Stress und viele Gefahrensituationen? In Frankreich fahren alle irgendwas zwischen 110 und 130 km/h. Das sorgt dafür, dass die Differenz zwischen den Geschwindigkeiten und Fahrstreifen nicht besonders hoch ist und es faktisch zu weniger Gefahrensituationen kommt. Selbst anrollende Fahrzeuge haben eine ähnliche Geschwidigkeit. Der Verkehr stockt und beschleunigt weniger. Ich nehme an, dass es sich bei einer längeren Fahrt eher positiv auf die Gesamtfahrdauer bei gleicher Strecke auswirkt - bloß weniger gefährlich und weniger stressig.</p>\n<p><img src=\"/content/images/2014/Sep/2014-09-09_1410246073.jpg\" alt=\"alt\"></p>\n<p><strong>7. Deutsches Brot ist falscher Stolz</strong></p>\n<p>Jedes Mal im Ausland schätze ich die lokalen Bäckereien für ihre Backkunst. Ob San Francisco, Bretagne oder Italien - mir schmeckt das Brot im Ausland meistens wesentlich besser als das vereinheitlichte Filialaufbackbrot oder -brötchen der verschissenen Deutschen, die nur ihre Ketten wie KAMPS oder was auch immer haben. Bemerkenswert auch, dass es hier kaum mehr Bäcker gibt, deren Brote nicht wie die Klumpen aus dem ALDI-Brotregal schmecken. Wir haben in Frankreich fettige Crossaints, Baguettes und alle Tartes und Teilchen gelobpreist. Die Papiertüten waren fettdurchtränkt. Wir lächelten zufrieden.</p>\n<p><img src=\"/content/images/2014/Sep/2014-09-11_1410418276.jpg\" alt=\"alt\"></p>\n<p><strong>8. Austern sind kein hochpreisiges Essen!</strong></p>\n<p>Austern bekommt man in Frankreich im Supermarkt in guter Qualität zu einem überraschend niedigem Kilopreis von 6 Tacken. Die Boys waren beim Essen noch lebendig, köstlich frisch und man muss sich dort nicht ins ätzende KaDeWe zu 60jährigen Immobilienmaklerinnen mit Shortcuts setzen, sondern kauft sich für 2 Euro ein Austernmesser im Supermarkt und knackt die Teile auf dem Rasen vor dem Haus. Angeblich kostet in Deutschland ein einigermaßen brauchbares Austernmesser an die 20 Euro. So viel dazu.\nZu den Austern trinkt man einen schönen Rieslingsekt oder einen Champagner und gruselt sich ein bisschen.</p>\n<p><img src=\"/content/images/2014/Sep/2014-09-09_1410246127.jpg\" alt=\"alt\"></p>\n<p><strong>9. Cider!!&quot;</strong></p>\n<p>Cider!!!</p>\n<p><img src=\"/content/images/2014/Sep/2014-09-10_1410330036.jpg\" alt=\"alt\"></p>\n<p><strong>10. Franzosen sind anders</strong></p>\n<p>Franzosen haben eine andere Mentalität. Zumindest in der Bretagne. Und ja, jeder auf der Straße trägt ein Baguette mit sich. Das mag allerdings daran liegen, dass die deutschen Brote oder Toasts kleiner sind und in den Taschen ungesehen verschwinden können.\nEs wird viel gestarrt. Es ist alles sehr langsam. Die Menschen bewegen sich reptilös. Aber das ist in Ordnung.</p>\n"}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

	module.exports = {"title":"10 Gründe warum Berlin out ist:","date":"2014-02-27 00:00:00 +0000","tags":null,"layout":"post","body":"<h1>1. <strong>Es gibt keinen Ramen Burger!</strong></h1>\n<img src=\"https://fbcdn-sphotos-a-a.akamaihd.net/hphotos-ak-ash3/t1/1395859_172990679571321_1101221735_n.jpg\" alt=\"\">\nEs kann jawohl nicht angehen, dass man mit seinem pastellfarbenen Vintage Rennrad erst 6.400 Kilometer bis nach Williamsburg New York fahren muss, um einen <a href=\"https://www.facebook.com/RamenBurger\">Ramen Burger</a> zu bekommen. Das schafft man nicht mal eben schnell in der Mittagspause ohne seinen unterbezahlten Job in der Agentur zu verlieren.\n<h1>2. <strong>Immer noch zu viele Kinder!</strong></h1>\n<p><img src=\"http://en.blog.hotelnights.com/wp-content/plugins/php-image-cache/image.php?path=/wp-content/uploads/2013/11/Bar-25-Berlin.jpg\" alt=\"Alt text\">\nKinder sind Gottes aggressive Art gegen die lebhafte Berliner Clubkultur vorzugehen. Wo früher Druffis fröhlich in der Sonne spielten, dehnen sich heute Spielplätze mit Erfahrungsmaterialien und pädagogischem Mehrwert.</p>\n<h1>3. <strong>Marihuana soll legalisiert werden!</strong></h1>\n<p><img src=\"http://media-cache-ec0.pinimg.com/736x/6b/3e/bd/6b3ebdd050f3e8d21561351aa8202003.jpg\" alt=\"Alt text\">\nBoring! Mit der Althippiemutter aus Stuttgart in den Coffee Shop am Görli und Ströbele treffen? Naja, geht so. Dabei ist sogar <a href=\"http://www.vice.com/de/read/forscher-beweisen-aspirin-ist-1000-mal-toedlicher-als-cannabis\">Aspirin spannender</a>.</p>\n<h1>4. <strong>Die Schlange vor Mustafas ist länger als dein scheiß Blasenvolumen!</strong></h1>\n<p><img src=\"https://irs1.4sqi.net/img/general/width960/42484149_BcIgvHT17h1quS325wHDqGn3As5-IyBWKVdP-HKPy6E.jpg\" alt=\"Alt text\">\nDie Schlange vor <a href=\"http://www.mustafas.de/\">Mustafa´s Gemüsekebap</a> ist zu jeder verdammten Tages- und Jahreszeit größer als das Volumen deiner Blase. Deal with it! Wer Ahnung von Physik hat und den Shittalk der Shitheads beim Schlange stehen nicht aushält, schaut bei <a href=\"https://de.foursquare.com/v/kottis-gem%C3%BCsekebap/4fccdb84e4b070d0e3c16f1f\">Kotti´s Gemüsekebap</a> vorbei und bekommt seinen Döner ganz undeutsch und ohne Warten.</p>\n<h1>5. <strong>Zu viele Gentrifizierungsgegner und trotzdem keine angesagte Wohnung für alle!</strong></h1>\n<p><img src=\"http://media-cache-ak0.pinimg.com/originals/64/95/a7/6495a76ff8a981f32c9b289577ddfb49.jpg\" alt=\"Alt text\">\n“Ich suche eine 2 Zimmer Wohnung in Kreuzberg, Mitte, Prenzlauer Berg oder Neukölln!”\n“Hipster! Zieh doch nach Pankow, du Hund!”\n“Wo wohnst Du denn?”\n“Reuterkiez!”</p>\n<h1>6. <strong>Alle sind schön und gesund!</strong></h1>\n<p><img src=\"http://24.media.tumblr.com/a76ccf7b6a6b1bbaa0189c692a241b2c/tumblr_mh8nkw1rlB1rl72tzo1_400.jpg\" alt=\"Alt text\">\nIn Berlin sind alle inzwischen derart schön, dass sich keiner mehr traut Döner mit Zwiebeln zu bestellen oder beim Pizza essen zu rülpsen.</p>\n<h1>7. <strong>Das “DEUTSCHLAND VERRECKE!” Graffiti bleicht langsam aus!</strong></h1>\n<p><img src=\"http://farm3.staticflickr.com/2768/5751330043_fe926d3b9f_b.jpg\" alt=\"Alt text\">\nStreetart ist ja das eine, aber das “DEUTSCHLAND VERRECKE!” Graffiti liegt mir einfach am Herzen. Einer müsste es mal nachmalen.\nFoto: <a href=\"http://www.flickr.com/photos/95714545@N00/5751330043\">Seven resist</a></p>\n<h1>8. <strong>Die Party ist zu Ende bevor sie angefangen hat!</strong></h1>\n<p><img src=\"http://media-cache-ec0.pinimg.com/736x/2d/0a/5c/2d0a5c89b902d23f7008db760ad7c016.jpg\" alt=\"Alt text\">\nBerlin. 24/7 Clubbing, aber mal Hand auf´s Herz, wer hat schon Lust mühsam bis 3 Uhr nachts vorzutäuschen sich megagut beschäftigen zu können, bevor es üblich ist in einem der unzähligen angesagten Clubs aufzuschlagen? Wieso können Partys nicht einfach um 22 Uhr beginnen?</p>\n<h1>9. <strong>Gehasst werden!</strong></h1>\n<p><img src=\"http://media-cache-ak0.pinimg.com/236x/3c/61/62/3c6162d611d5e73ee1973d08476aa859.jpg\" alt=\"Alt text\">\nIn Berlin hasst man sich gepflegt. Die meisten hassen Hipster, die Berliner die Touristen, die Alteingesessenen die Zugezogenen und man selbst hasst nach einer Weile alle.</p>\n<h1>10. <strong>Hundesohnwetter!</strong></h1>\n<p><img src=\"https://irs0.4sqi.net/img/general/width960/52048265_R9YouazdXXBpYfVPXIlMPa2EJWLku_Do52P-Tr-hiNU.jpg\" alt=\"Alt text\">\nKaum steigt die Temperatur in den zweistelligen Bereich, rastet die ganze Stadt aus und verstopft Parkanlagen, die eigentlich French Bulldogs ohne Leine zustehen.</p>\n"}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

	module.exports = {"path":"/404.html","layout":"page","body":"<h1>NOT FOUND</h1>\n<p>You just hit a route that doesn’t exist… the sadness.</p>\n"}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	module.exports = {"title":"Der 99Fire-Films Award","date":"2012-02-17 11:33:45 +0000","tags":null,"layout":"post","body":"<p>\n\t<img src=\"/content/images/tn_Foto__4_1.JPG\" alt=\"tn_Foto__4_1.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDank der Freunde von <a href=\"http://www.iheartberlin.de/\">iHeartBerlin</a> hatte ich gestern die Möglichkeit mich auf den 99Fire-Film Awards im Admiralspalast im Rahmen der Berlinale aufzuhalten und in einem mehr oder weniger (dazu später mehr) feierlichen Rahmen allerhand Kurioses zu beobachten. Für mich versprach der Besuch ausserordentliche spannend zu werden, weil in den letzten Tagen <a href=\"http://tookalook.de/wissenswertes/wir-bitten-um-ihre-aufmerksamkeit-99fire-films-award-2012/\">Kontroversen</a> über das Handling der Rechtevergabe an den Filmen der Nachwuchsregisseure in diversen Blogs diskutiert wurden.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDer Award war mir bisher nicht bekannt und ist, so kann ich im Nachhinein verraten, nichts was einem ein Begriff sein müsste. Der <a href=\"http://www.99fire-films.de/\">99Fire-Films Award</a>&nbsp;ist eine Werbeveranstaltung von einem bekannten Autohersteller und einem größeren Videoportal.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWer sich für den Wettbewerb anmeldet, bekommt ein Thema verkündet und hat nach Bekanntgabe 4 Tage und 3 Stunden Zeit um einen Film zu drehen, der exakt 99 Sekunden lang sein muss. Klingt nach einem witzigen und vernünftigen Konzept, wäre da nicht in den letzten Tagen eine immer lauter werdende&nbsp;<a href=\"http://www.out-takes.de/index.php/2012/video-protest-wettbewerbsfilm-zum-99fire-films-award-kritisiert-wettbewerb-selbst/\">Kritik</a> an den Teilnahmebedingungen des Wettbewerbs &nbsp;zu lesen gewesen. In diesem Jahr drehten Teilnehmer einen <a href=\"http://youtu.be/EUmmfpt5pyw\">Kurzfilm</a>, in dem sie sich über die Handhabung der Filmrechte echauffierten. Die Kritik beinhaltet, dass 99Fire Film Awards die Filmrechte an den eingesendeten Kurzfilmen der Jungregisseure an Dritte übertragen kann. Eingeschlossen ist eine kommerzielle Verwertung des Films durch Dritte. Der Filmemacher tritt laut Teilnahmebedingungen alle Rechte an der kommerziellen Nutzung seines eigenen Film vollständig ab und hat bei Zuwiderhandeln mit einer Vertragsstrafe zu rechnen. Die Kritik der Filmemacher lautet&nbsp;<a href=\"http://youtu.be/EUmmfpt5pyw\">&quot;Ihr fördert keine Kunst, ihr beutet sie aus!&quot;</a>. Was das bedeutet, kann man in den <a href=\"http://www.99fire-films.de/anmeldung.html\">AGB&acute;s</a> sehr gut nachvollziehen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img src=\"/content/images/tn_Foto__1_1.JPG\" alt=\"tn_Foto__1_1.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDer rote Teppich. Wow, ich kannte keinen der bereits im Vorfeld seitens des Veranstalter aufgelisteten Promineten, die sich für den Award angemeldet hatten! Alle sahen irgendwie aus wie Marco Schreyl. Ein Mann mit einer lila Samtjacke schien eine Art Überprominenter zu sein und den roten Teppich gar nicht mehr verlassen zu wollen. Who? Sachdienliche Hinweise gerne in die Kommentare packen oder per Mail an mich senden!</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img src=\"/content/images/tn_Foto__9_1.JPG\" alt=\"tn_Foto__9_1.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWir harrten also im strömenden Regen unter einem Heizpilz aus bis uns Einlass gewährt wurde. Gegen das Catering ist nichts zu sagen. Exzellente Getränke, hochwertiger Suff und köstliche kleine Canapés aus rohem Fleisch und mit ziemlich fettiger Geilmayonnaise. In den Getränken schwammen Gurken und Erdbeeren. Man war wieder etwas versöhnt. Warum wurden eigentlich auf der Karte Getränke geschwärzt?</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img src=\"/content/images/tn_Foto__2_1.JPG\" alt=\"tn_Foto__2_1.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img src=\"/content/images/tn_Foto__5_1.JPG\" alt=\"tn_Foto__5_1.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEröffnet wurde der Award mit einer &quot;spacigen&quot; Computerstimme, die einen Countdown ansagte. Es folgte James Bond Musik. Das Ganze wirkte ein bißchen wie eine Werberidee aus den frühen 90ern.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tBis zum Buffet schafften wir es nicht mehr.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWolfgang Joop war auch da.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img src=\"/content/images/tn_Foto__6_1.JPG\" alt=\"tn_Foto__6_1.JPG\" /></p>\n"}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

	module.exports = {"title":"Ada and her dream of horses","date":"2011-07-19 09:23:12 +0000","tags":null,"layout":"post","body":"<p>\n\tWir holen uns zurück, was uns gehört! Heute mit den neuesten Blitzkrieg-Kiezart Anti-Pferde-Kampagnen-Plakaten.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/kiez2.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/kiez3.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/kiez6.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/kiez1.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/kiez5.jpg\" width=\"500\" /></p>\n"}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

	module.exports = {"title":"Ada Blitzkrieg - Das Hörbuch","date":"2011-12-01 18:12:43 +0000","tags":null,"layout":"post","body":"<p>\n\tIch habe mir heute etwas Zeit genommen und für Euch zwei Kurzhörbücher meiner autobiographischen Texte für das <a href=\"http://stijlroyal.com/#magazin\">Stijlroyal Magazin</a> aufgenommen.</p>\n<p>\n\t </p>\n<p>\n\tKocht Euch etwas Crack auf, macht es Euch auf dem schmutzigen Badboden gemütlich und hört \"Jugend im Gehirn\" und \"Berlin mich voll\"!</p>\n<p>\n\t </p>\n<p>\n\t<img alt=\"\" src=\"/files/jugendhirn.jpg\" /></p>\n<p>\n\t </p>\n<p><iframe width=\"100%\"%\" scrolling=\"no\" frameborder=\"no\" src=\"http://w.soundcloud.com/player/?url=http%3A%2F%2Fapi.soundcloud.com%2Ftracks%2F29453594&amp;auto_play=false&amp;show_artwork=true&amp;color=ff8c1a\"></iframe></p>\n<p>\n\t </p>\n<p><iframe width=\"100%\"%\" scrolling=\"no\" frameborder=\"no\" src=\"http://w.soundcloud.com/player/?url=http%3A%2F%2Fapi.soundcloud.com%2Ftracks%2F29466936&amp;auto_play=false&amp;show_artwork=true&amp;color=ff8c1a\"></iframe></p>\n<p>\n\t </p>\n<p>\n\t </p>\n<p>\n\t </p>\n<p>\n\t </p>\n"}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

	module.exports = {"title":"Ada Blitzkrieg guckt alles","date":"2012-02-26 18:45:06 +0000","tags":null,"layout":"post","body":"<script src='/javascripts/jquery.js'></script><script src='/javascripts/widget.js'></script>\n<h2>10:00 ARTE - Latitia alleine unter Wölfen</h2>\n<p>Im Ernst, ich hatte mich vermutlich arbeitstechnisch ziemlich durchgepeitscht und in meiner naiven Vorstellung von “Dienstleitung” und “alles für den Blog” wurden die Faktoren “Beischlafbedürfnis” und “Faulheit” nicht genügend durchdacht. Den Wecker habe ich dann ignoriert und bin viel zu spät aufgestanden. Was für die einen zu spät ist, ist für diejenigen die im Gentrifizierungsviertel leben, immer der richtige Zeitpunkt zum Frühstücken. Ich transportierte Fischbrötchen und starken Kaffee nach Hause.</p>\n<p></p>\n<p></p>\n<p></p>\n<h2>11:00 Das VIERTE - Lebensberatung</h2>\n<p>Warum sehen Kartenlegerinnen eigentlich ausnahmslos aus wie Paul Stanley von Kiss?</p>\n<p></p>\n<p></p>\n<p>Ich nahm den Telefonhörer und rief an:</p>\n<p><a class=\"widget\" href=\"http://soundcloud.com/discordianfish/astrotv\">player</a></p>\n<p></p>\n<p></p>\n<p>Die Sendung beginnt klassisch mit der Erläuterung der etwas unfairen Regeln. Alles ist nur ein Spiel. Dort steht es ganz deutlich und trotzdem bleibt der unangenehme Geschmack, wenn man die selbe alte Dame zum dritten Mal in einer Stunde anrufen hört. Wann ihr Enkel heiraten wird, möchte sie erfahren. Wird es glücklich werden? Wann trifft er seine Frau? Vermutlich im April oder Mai nächsten Jahres. Sicher kann man das nicht sagen, aber er soll die Augen offen halten.</p>\n<p></p>\n<p></p>\n<p>Mit welcher Selbsverständlichkeit Anrufern ihre Träume und Visionen zerstört werden, indem ein beliebiger Paul Stanley Wenn die geistige Welt ganz klare Ansagen macht, dann kann ich nichts davon beschönigen! sagt.</p>\n<p></p>\n<p></p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1138.jpg\" alt=\"tn_iPhone_Fotos_1138.jpg\" />\n<p></p>\n<p></p>\n<p>Du hattest mir im letzten Jahr meinen Traummann angekündigt!</p>\n<p>Ja, Traummann ist relativ! Der wird noch kommen. Im Mai, Juni. Tschüss!</p>\n<p></p>\n<p>Lohnt es sich Lotto zu spielen?</p>\n<p>Es lohnt sich Lotto zu spielen!</p>\n<p></p>\n<p>Hast du schon häufiger versucht anzurufen?</p>\n<p>Sag du es mir!</p>\n<p></p>\n<p>Ich schaue heute die “JA/NEIN - schneller geht es nicht” Runde. Der Anruf kostet 50 Cent. Laut Moderatorin kommt jeder sechste Anrufer durch. Der Anruf kostet immer 50 Cent, egal ob man durchgestellt wird oder nicht. In einer Minute werden zwei Anrufe angenommen. Macht 12 Anrufe pro Minute und 720 Anrufe in einer Stunde. Das würde eine Summe von 360 Euro ergeben. Ich kann nicht mal vortäuschen schockiert zu sein. So wenig nur?</p>\n<p>UND ZACK DER NÄCHSTE!</p>\n<p></p>\n<p></p>\n<p>Neue Worte: Krafttier. Herzensmann.</p>\n<p></p>\n<p></p>\n<p></p>\n<h2>12:00 SUPER RTL - Barbie Mariposa</h2>\n<p>Ich schalte SuperRTL ein und finde mich direkt in einer adipösen Märchenwelt wieder. Wenn schon im echten Leben so schwer zu unterscheiden ist, ob es sich um Elfen oder Prostituierte mit Flügeln handelt, ist die Unterscheidung bei SuperRTL unmöglich geworden. Ich sagte so Hoffentlich wird der Barbiefilm anders als das! und im Fernsehen ruft jemand Marioposa! und ich so Nein!, weil ich erkenne, dass ich diesen Film nun 90 Minuten lang ertragen muss.</p>\n<p></p>\n<p></p>\n<p>Auch irgendwie enttäuschend, wenn man in der Programmzeitung “Barbie Adiposita” gelesen hatte.</p>\n<p></p>\n<p></p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1145.jpg\" alt=\"tn_iPhone_Fotos_1145.jpg\" />\n<p></p>\n<p></p>\n<p></p>\n<p>Könnt ihr euch eigentlich vorstellen wie jemand aussieht, der diese animierten SuperRTL Nachmittagsserien synchronspricht?</p>\n<p></p>\n<p></p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1144.jpg\" alt=\"tn_iPhone_Fotos_1144.jpg\" />\n<p></p>\n<p></p>\n<p></p>\n<p>Das eine männliche Barbiewesen hat Blaselippen und ist für einen Sohn von einem Schwarzen auffallend weiß. Wahrscheinlich um den Girls zu gefallen!</p>\n<p></p>\n<p>Formate, die billig produziert sind um Menschen in eine Sucht zu treiben.</p>\n<p></p>\n<p>Im Laufe der Sendung stellen sich mir einige ziemlich brisante Fragen: Wie bekommen die Barbie-Elfen eigentlich ihre Kleidung über die Flügel? Wie bilden sie Chitin? Wie tuscht sich der Feenhase eigentlich die Wimpern, wenn es so kleine dicke Hände hat?</p>\n<p></p>\n<p></p>\n<p>Diese Art von Produktion hat immer eines gemeinsam: Die Welt in der ihre Wesen leben erinnert immer an Gedärme. Ich will nicht in einer Welt leben, in der alles aussieht wie ein ausgehölter Walfisch! Alle Wesen haben Bicolorhaare.</p>\n<p></p>\n<p></p>\n<p>UND WARUM KOMMT EIGENTLICH VERDAMMT NOCHMAL KEINE WERBUNG?</p>\n<p></p>\n<p></p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1147.jpg\" alt=\"tn_iPhone_Fotos_1147.jpg\" />\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1152.jpg\" alt=\"tn_iPhone_Fotos_1152.jpg\" />\n<p></p>\n<p>Irgendwann wird dann der Zauberhase eingeblendet und ich habe wie durch Zufall den gleichen, aber als Zwergkaninchen. Die besagte Zwergkaninchenfee versuchte nach ihrem Fotoshooting für einen Nacktkalender die Grafik von Mariposa zu fressen, die wir liebvoll auf einen versifften Umzugskarton aufgezeichnet hatten, um den hochwertigen Inhalt und die Beziehungsgeflechte von Barbie Mariposa zu verstehen.</p>\n<p></p>\n<p></p>\n<h2>13:35 ARTE - Zu Tisch in… Lothringen</h2>\n<p>Sechs schmutzige Menschen fahren um 5:00 Uhr 6km unter Tage. Die letzte Salzmine Frankreichs oder so. Ohne Speck geht gar nichts in der lothringischen Küche. Heute gibt es Quiche Lorraine, so heißen normalerweise Huren in der Boddinstrasse.</p>\n<p>Ich bekomme Bauchkrämpfe, weil das Ei roh abgeschmeckt wird. Oder waren Salmonellen eine Lüge der Mütterindustrie um den Kuchenteig alleine auslecken zu dürfen?</p>\n<p></p>\n<p>Bei ARTE wird immer entweder irgendwelche Wurst gemacht oder gebumst. Das neue Sendekonzept sieht aber vor, dass dazwischen winzig kleine und für das menschliche Auge unsichtbare Minisequenzen geschnitten werden, bei denen man über Bergbau und die Probleme der ältern Menschen in der Gegend aufgeklärt wird.</p>\n<p></p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1155.jpg\" alt=\"tn_iPhone_Fotos_1155.jpg\" />\n<p></p>\n<p>Nach etwa einer halben Stunde stupider Wurstmacherei wird endlich eine neue Wurst eingeführt. Die neue Wurst! Dazu trägt jemand ein halbes Schwein in einen Hinterraum, kommt mit 40l Blut in einem Blecheimer wieder, rührt etwas Rahm in die Blutmasse ein. Dann wird alles in den Darm von irgendwem gesteckt und fertig ist die Wurst.</p>\n<p></p>\n<p></p>\n<img src=\"/content/images/animation__2_.gif\" alt=\"animation__2_.gif\" />\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1156.jpg\" alt=\"tn_iPhone_Fotos_1156.jpg\" />\n<p></p>\n<p></p>\n<p>Wusstet ihr schon, dass die Kühlschränke in Frankreich so groß sind wie DETLEF, das bekannteste deutsche Hymner Wohnmobil.</p>\n<p></p>\n<p>Nun machen die alten Weiber wieder Kuchen in Belegschaftsgröße. Dann ist die Sendung vorbei.</p>\n<p></p>\n<p></p>\n<h2>14:15 Phoenix - Abenteuer Linienbus</h2>\n<img src=\"/content/images/tn_iPhone_Fotos_1157.jpg\" alt=\"tn_iPhone_Fotos_1157.jpg\" />\n<p></p>\n<p>Vermutlich ist dies das Format, auf das ich mich am meisten gefreut habe. Der Name verspricht mehr als er hält. Es werden nur die Spezialfahrer gezeigt. So Kram wie in Nepal mit nem alten Büssken über den einen hohen Berg peesen. Und die Fahrer sind auch nicht wie erhofft vier Models schwer und haben eine Kimme, die ihre eigene Geschichte erzählt wie ARTE sagen würde, sondern sind schmale Wesen ohne nennenswerten Bartwuchs. Chakakterlos und distanziert.</p>\n<p></p>\n<p>Warum haben in Deutschland eigentlich ausschließlich Busfahrer Oberlippenbärte, und in Nepal alle anderen Menschen ausser Busfahrer? In asiatischen Ländern hängen übrigens am Bushanhof keine Jugendliche ab, sondern steinalte Leute. Steinalte Leute sind die Jugendlichen Asiens. In anderen Ländern fahren immer alle am Bus außen mit.</p>\n<p></p>\n<p>Ein Mönch oder ein andere Mensch mit unifarbener American Apparel Kleidung quatscht einen Reporter mit Wenn man glaubt, trägt man Butter im Herzen zu und ich beschließe kurz den Raum zu verlassen.</p>\n<p></p>\n<p></p>\n<h2>14:45 ARD - Rosamunde Pilcher - Zeit der Erkenntnis</h2>\n<p>In der Programmzeitung wird alleine im Beschreibungstext zu dieser Sendung acht Mal das Wort Erbschaftsangelegenheiten benutzt. Ich fühle mich plötzlich sehr alt und neugierig.</p>\n<p>Beim Einschalten dann der Schock: Überall Frauen. Alle heißen Cathrin oder Jenny. Und alle hassen sich und haben einen Sohn ohne einen Stiefsohn, dessen Großvater im Rahmen der Sendung stirbt. Nirgendwo kann man mehr alte Leute zu Unterhaltungszwecken sterben lassen als bei Rosamnund Pilchner. Wer alt ist stirbt, oder lebt und weint dann aber sehr viel. Alle schreiben sich ständig Briefe. In jeder Sequenz hört man Möwen im Hintergrund.</p>\n<p></p>\n<p></p>\n<p>Im Nachmittagsprogramm des ZDF tragen alle Frauen jeder Alters immer diese spitzformenden BHs, die die Brüste wie eine Waffe aussehen lässt, die nie zur Benutzung konstruiert wurde.</p>\n<p></p>\n<p></p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1161.jpg\" alt=\"tn_iPhone_Fotos_1161.jpg\" />\n<p></p>\n<p></p>\n<p></p>\n<p>Der eine “Herr” sieht aus wie Charlie Cheen, was man 2012 in keinem Format mehr bringen kann, in dem es angeblich um Romantik gehen soll. Hinzu kommt, dass in dieser Art Heimatromantikfilmscheiß immer irgend ein dickes Bonzenauto in gewichstem Glanzschwarz durch sommerliche Felder fahren muss. In diesem Pilcherfilm steht auf dem Nummernschild KAJAL, obwohl niemand welchen trägt.</p>\n<p></p>\n<p></p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1160.jpg\" alt=\"tn_iPhone_Fotos_1160.jpg\" />\n<p></p>\n<p></p>\n<p></p>\n<p>Das Pilcher-Format dreht sich um Sarah Wrightmann, die in “Queenswood” wohnt. Dabei stinkt das ganze Format so dermaßen deutsch, obwohl die Pilcher Britin ist. Oder Schottin. Das andere Deutsch also.</p>\n<p></p>\n<p>In einer Szene liegt der Hund am Grab des Vaters. Eine Frau bückt sich. Hier ist dann vermutlich die Synchronisation falsch gelaufen. Die Frau klopft leicht und tätschelnd auf den Brustkorb des Hundes und man vernimmt ein Geräusch, das klingt als wäre das gute Tier 900m hoch und hohl.</p>\n<p></p>\n<p>Übrigens ist der Drehort des Films ein Plattenbau in Britz, vor den ein paar Pappsäulen gebaut wurden.</p>\n<p></p>\n<p></p>\n<p>“Tierarztpraxis” klingt auch wie “Skiarztpraxis”. In Rosamunde Pilcher Filmen besitzen ausnahmslos alle beides. Ausserdem gibt es Teeservice, die so klein und filigran sind, dass man sie aus Versehen beim darüber lachen einatmen kann.</p>\n<p></p>\n<p></p>\n<p>Häufigster Satz: Sie braucht einen Arzt!</p>\n<p></p>\n<p>Der Film zieht sich ewig. Ich habe das Gefühl um Jahre gealtert zu sein und erwische mich dabei wie ich Fotos von Blumengestecken google.</p>\n<p></p>\n<p></p>\n<p>Abschiedsbriefe, auch so ein Ding.</p>\n<p></p>\n<p>Bei Rosamunde Pilcher dürfen Frauen noch fette Ärsche haben.</p>\n<p></p>\n<p>An Verhütung denkt bei dieser Art Film nie jemand. Man sieht nie Kondome. Gut, dass die Zielgruppe, schon längst zu alt für Geschlechtsverkehr ist!</p>\n<p></p>\n<p></p>\n<p>Sie singen plötzlich Dinge wie You are the Quiche to my heart! und ich schalte auf Jürgen Fliege um. Dachte ich.</p>\n<p></p>\n<p></p>\n<h2>16:00 TV.Berlin - Fliege</h2>\n<p>Auf TV.Berlin kommt kein Fliege und man schert sich einen ziemlichen Scheiß darum, welches Program angekündigt wurde. Der Blick in den Videotext verrät auch nicht mehr. Dort steht Nachtprogramm, was auch irgendwie stimmt.</p>\n<p></p>\n<p>Wieso heißt die Talkshow Fliege und wird nicht von Jürgen Fliege moderiert? Eine gesichtslose Frau mit pannierten Haaren befragt Kai Pflaume und einen anderen Kai Pflaume zu Pferderennen auf einer Eisbahn.</p>\n<p></p>\n<p>Viel zu spät merke ich, dass die Sendung gar nicht “Fliege” ist. Jemand kämmt sich in Nahaufnahme die Augenbrauen. Eine Werbung für Organgspende. Darauf hätte ich nicht gewettet.</p>\n<p></p>\n<p></p>\n<h2>16:00 Sat1 - Richter Alexander Hold</h2>\n<p>Mal wieder irgend ein Fetischscheiß von einem arbeitslosen Arbeitslosen, der eine Motorraduniform trägt, wenn er mit Frauen spricht. Durchtrennte Oberschenkel. Ob man den Mann mit dem Helm beschreiben könnte, was man nicht kann, denn er trägt einen Helm.</p>\n<p></p>\n<p>Hätte Richter Alexander Hold eigentlich einen Afro, wenn er längere Haare hätte?</p>\n<p></p>\n<p>In dieser Folge wird Darth Vader das Sorgerecht entzogen.</p>\n<p></p>\n<p></p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1164.jpg\" alt=\"tn_iPhone_Fotos_1164.jpg\" />\n<p></p>\n<p></p>\n<p>Richter Alexander Hold mit niedrigem Zuckerspiegel ist schlecht. Man wird müde und dann sieht der verschwimmende Richter aus wie der eine von den Ludolfs. Ich hole mir in einer kleinen Pause eine Handvoll zurckrigem Baklava um mich wieder in Form zu peitschen.</p>\n<p></p>\n<p></p>\n<h2>16:50 VOX - Tiere, Menschen und Doktoren</h2>\n<p>Menschen, Tiere und Doktoren sind die perfekte Gelegenheit für sozial akzeptiertes Rumheulen.</p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1165.jpg\" alt=\"tn_iPhone_Fotos_1165.jpg\" />\n<p></p>\n<p>Ein Hund wird eingeschläfert. Wir weinen ein bißchen und sind sehr traurig. Der Hund ist ein besonderer Freund des Menschen. Er hört immer zu und ist ein wunderbar treues Tier, selbst wenn man selber das totale Schwein ist. Deswegen weinen wir immer wenn einer stirbt.</p>\n<p></p>\n<p></p>\n<p>Frettchen sind wie Hunde, nur in krass.</p>\n<p></p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1173.jpg\" alt=\"tn_iPhone_Fotos_1173.jpg\" />\n<p>In den Werbepausen zwischen einer Tiersendung könnte auch ruhig mehr Werbung für bestimmte Tierrassen gemacht werden! Mal wieder die Dalmatinerindustrie ankurbeln nach dem großen Boom und dem damit verbunden starken Rückgang der Geburtenzahlen in den 90ern.</p>\n<p></p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1174.jpg\" alt=\"tn_iPhone_Fotos_1174.jpg\" />\n<p></p>\n<p>Ich würde keinen Arzt mit dieser Art OP-Kopftuch an meinen inneren Organen rummachen lassen! Aber das ist auch egal, denn irgendwann hat die Fernsehbranche angefangen alle TV-Formate mit ganz schlimm dramatischer Musik zu hinterlegen und niemand wunderte sich mehr, wenn Hunde vor laufender Kamera Brust-OPs bekommen.</p>\n<p></p>\n<p>Ein Karton mit Welpen wird gezeigt. Fernsehen kann so schön sein!</p>\n<p></p>\n<p></p>\n<h2>17:50 WDR - Von und zu lecker, wer kocht das beste Adelsmenü?</h2>\n<p>Wer kocht das beste Adelsmenü? Keine Ahnung. Ist mir eigentlich auch egal. Frauen mit nachschwabbelnden Oberarmen schälen riesige Kartoffelwesen. Rosmarin darf in der Adelsküche niemals fehlen, das hat inzwischen auch schon der letzte Mensch im Problembezirk mitgekriegt. Erzähl mir was Neues, versnobte Oberschicht!</p>\n<p></p>\n<p>Warum tragen Adelige eigentlich immer so viel Cordanteil?</p>\n<p></p>\n<p>Überall stehen Pferde zur Dekoration.</p>\n<p></p>\n<p>Dem Zuschauer wird zu keinem Zeitpunkt das Format erklärt. In der Beschreibung heißt es Wer kocht das beste Adelsmenü?. Adelige kämpfen aber scheinbar nicht gegeneinander, sondern gemeinsam mit ihren affektierten Formulierungen und erlesenen Zutaten gegen den niederen Pöbel. Es gibt eine Art Vorspeise. Etwas Suppe wird über den Trüffel gerieben, was dem Gericht angeblich Flügel gibt. Preiselbeeren, Pfifferlinge und Wildschwein, alle Zutaten beginnen mit P. Dabei spielt unaufhörlich ein durchgedrehtes Klavier festliche Musik. Man schämt sich für seine Baklava-Einkäufe. Dort hat niemand Schuppen.</p>\n<p></p>\n<p></p>\n<h2>18:15 KABEL EINS - Die Torten-Tuner</h2>\n<p>Esst ihr Trucker eigentlich was Spezielles an Kuchen?</p>\n<p>Gleich die gute Nachricht vorweg: Die Torte soll Truckform annehmen. Dazu benötigt man 850 Eier. Daraus fertigen die Profis den leckeren Teig für den LKW-Anhänger an. Es kann losgehen.</p>\n<p></p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1196.jpg\" alt=\"tn_iPhone_Fotos_1196.jpg\" />\n<p></p>\n<p></p>\n<p>In der Mitte der Sendung erfährt der Zuschauer, dass das ganze Gebinde auf einer acht Tonnen Stahlplatte fixiert werden muss, damit das Gewicht über 700qm verteilt werden kann und nicht die Erdoberfläche ungebremst zertrümmert.</p>\n<p></p>\n<p></p>\n<p>Der Dickere der beiden Tortentuner trinkt während der Arbeit Korn. Ich kann das nicht, dann schalten meine Kunden aus Neid die Webcam aus.</p>\n<p></p>\n<p></p>\n<p>Deine Mutter schiebt tagsüber auf KABEL EINS Tortentrucks!</p>\n<p></p>\n<p>Inspiration für den Tortentruck wird sich im Miniaturmuseum in der Austellung Miniatur bei Nacht geholt. Man ist sich schnell einig: Scheibenwischer, Scheinwerfer und LEDs!</p>\n<p></p>\n<p>Die meiste Zeit erkenne ich statt einer Torte ein belegtes Schinkensandwich. Irgendwas ist mit meinem Kopf falsch. Die Zugmaschine ist ein Frankfurter Kranz mit Schlagsahne und 400kg Marzipanhülle. Wenn die Tort gelingt, sind der Dicke und sein Freund glücklich, wenn sie missling, taucht sie in einem Rosamund Pilcher Film als Endgegner wieder auf.</p>\n<p></p>\n<p></p>\n<h2>19:00 QVC - Harald Glööckler Glamour &amp; Style</h2>\n<img src=\"/content/images/tn_iPhone_Fotos_1216.jpg\" alt=\"tn_iPhone_Fotos_1216.jpg\" />\n<p></p>\n<p>Harald Glööckler (hier rechts im Bild) ist der uneingeschränkte Herrscher über QVC und die Damenwelt der über 50 Jährigen. Zurecht. Er ist charmant. Macht Mode bis Größe 52 und trägt selber die schönsten Teile seiner Damenkollektion. Aussdem ist er ein ziemlicher Sexis, was alten Weibern zusagt. Aber ist der Harals jetzt eigentlich dick oder muskulös?</p>\n<p></p>\n<img src=\"/content/images/animation__1_.gif\" alt=\"animation__1_.gif\" />\n<p></p>\n<p></p>\n<p>Brigitte Nielsen modelt für Glööckler.</p>\n<p></p>\n<p>Es wird immerzu von einer Farbe namens “Ekrül” gesprochen und ich schäme mich so für mich.</p>\n<p></p>\n<p>Sexistischer Kackscheiss wie “Die Frau ist das einzige Wesen, das sich als Geschenkt verpackt!”.</p>\n<p>Mode, die nur Weißhaarigen steht.</p>\n<p>Erst soll man alle Treggings kaufen, wenn man sowieso schon eine holt, weil man sonst angeblich traurig sein soll, weil man nicht alle Farben hat. Verständlich! Und dann braucht man noch den dunkelblauen Blazer dazu. Alles anderen aus der Kollektion auch. Zusätzlich gibt es Lippenstifte und Lidschatten. Alle Jeggings formen.</p>\n<p></p>\n<p>Eine Tasche, die Leute als Essen bestellen und die Empfehlung von Harald dazu Gehen sie auf Internet!. Das tut gut.</p>\n<p></p>\n<p></p>\n<p>Am Ende schreit der Glööckler mich noch an, ich soll dran denken, dass ich die schwarze Hose 2, 3 oder 4 Mal haben muss. Alle Farben. Ich will alle Lippenstifte, und im Studio alles was zu sehen ist. Ich will alles haben. Ich möchte Harald in meine Adern drücken!</p>\n<p></p>\n<p>Es gibt einen großen Unterschied zwischen einem Model und einer Frau mit Größe 46, die modelt.</p>\n<p></p>\n<p></p>\n<h2>19:25 ZDF - Unser Charly</h2>\n<p>Ist das noch der gleiche Affe wie vor zwanzig Jahren und welchen Anzug trägt er bei seiner Beerdigung?</p>\n<p></p>\n<p>Ein Affe ist auch nur ein entstellter Hund.</p>\n<p></p>\n<p></p>\n<p>Der Affe wird total auf seinen Affesein reduziert. Alles was der Affe tut ist ziemlich Klischee: Kleidung tragen, Karten spielen, telefonieren und schelmenhaft Gegenstände klauen.</p>\n<p></p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1219.jpg\" alt=\"tn_iPhone_Fotos_1219.jpg\" />\n<p></p>\n<p>Unser Affe Charly bringt mich dann doch noch, nach etwas depressiven Stunden, wieder zum lachen. Ziemlich ulkig wie dieser Affe missbraucht wird um eine ansonsten zutiefst langweilige und ideenlose Serie mit grottenschlechten Schauspielern ein bißchen aufzuwerten.</p>\n<p></p>\n<p>Aber im Ernst, dieser Kleinwüchsige im Tierkostüm bewegt sich wahnsinnig überzeugend, aber wieso muss sich der Affe die ganze Zeit in den Schritt fassen?</p>\n<p>Ich erwische meinen Freund dabei, wie er zum wiederholten Male meine Wollsocken trägt. Er versucht sich auf fast unangehm peinliche Weise herauszureden, indem er denkt, er könnte die Situation dadurch retten, dass er behauptet: Die leiern nicht aus. Guck mal wie weit die sind!.</p>\n<p></p>\n<p></p>\n<p>Das ist der Moment, an dem wir anfangen zu trinken. Absinth und Bier, Rum und teuren Rotwein. Alles mit Zuckerwürfelchen. Ich freue mich schon nach den ersten Schlücken intensiv auf mein Abendprogramm. Wow, macht plötzlich alles Spaß! Im Suff oder bei sexueller Erregung wird alles zu einer Riesengaudi.</p>\n<p></p>\n<p>Wenn das angeblich “Unser Charly” ist, wieso erfüllt der dann nicht seine Aufgaen hier im Haushalt?</p>\n<p></p>\n<p></p>\n<p>Wir warten auf Carmen Nebel The Fog, weil ich keinen Bock mehr auf spackige Kinder habe.</p>\n<p></p>\n<p></p>\n<h2>20:15 ZDF - Willkommen bei Carmen Nebel</h2>\n<p>Für Carmen Nebel braucht man einen anderen Zustand.</p>\n<p>Im Vorfeld wurde das eine oder andere Mal von mir angekündigt, dass ich heute Weihnachten mit Carmen Nebel gucke. Was so nicht stimmt. Wilkommen bei Carmen Nebel. Eine scheinbar sehr berühmte Frau, nach der eine ganze Show benannt wurde, die eine wunderbare Gastgeberin und großzügige Person sein muss. Wir werden sehen.</p>\n<p>Kakao mit Mineralwasser.</p>\n<p></p>\n<p></p>\n<p>The Fog ist scheinbar die einzige, die keinen viel zu engen Badeanzug tragen muss, durch den man beginnt zu schwitzen und Pilze bekommt. Die Tänzerin aus dem Einspieler mussten das scheinbar. Das sah man auch.</p>\n<p></p>\n<p>“Ramona Drews am Flügel” hat ein unglaublich schlechtes Playback abbekommen. Jemand im Sender scheint diese arme Frau (?) zu recht sehr zu hassen.</p>\n<p></p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1222.jpg\" alt=\"tn_iPhone_Fotos_1222.jpg\" />\n<p></p>\n<p>Warum sollte in dem Drews-Lied auch ein Klavier zu hören sein, wenn die Drews am Flügel sitzt? Wir beginnen zu grübeln ob die Moderatorin schon bei der Einleitung ehrlich war und Hier ist Jürgen Drews und Ramona Drews sitzt am Flügel gesagt hat.</p>\n<p></p>\n<p>Häufigste Frage von alten Menschen im Showbiz: War es bei Euch eigentlich Liebe auf den ersten Blick?</p>\n<p>Die Moderatorin Carmen Nebel trägt übrigens in der Tat, und volkommen ohne Witz, ein Kleid aus der Glööckner Kollektion. Und so sieht übrigens ein SCHTARRIMPORT AUS ENGLAND&quot; aus:</p>\n<p></p>\n<p></p>\n<img src=\"/content/images/animation.gif\" alt=\"animation.gif\" />\n<p></p>\n<p>Das Geburtstagskind ist mindestens 60 Jahre alt und hat einen Mann Guck, da ist dein Mann, Klaus-Jürgen!. Daher erkennt es auch nicht, wer fünf Meter hohe Geburtstagsschilder in mindestens (!) vier Meter Entfernung hochhält und rät einfach mal munter drauf los. Ah, da sind ja meinen lieben Freunde! und es stimmt.</p>\n<p></p>\n<p></p>\n<p>Camen Nebel. Ich kann nicht unterscheiden wer Sängerin, wer Moderatorin oder wer Publikum ist. Alle glitzern und schwitzen wie die 7te Klasse einer Hauptschule nach dem Sport in gemischten Umkleidekabinen. Carmen Nebel ist überall, während sich die Backroundtänzer schmierig zu den Raveorgeln bewegen wie tanzende Seepferdchen. In pomööser Glamourisität bewegen sich die aalgleichen Wesen wie funkelnder Zauberstaub im Gegenlicht einer sakralen Sterbevision.</p>\n<p></p>\n<p>Jetzt kommen die Singlemänner, die um eine Singelfrau kochen müssen. Seixtisch aber irgendwie tiefgründiger sexistisch. Carmen Nebel, du Sau!</p>\n<p></p>\n<p></p>\n<p>Was ist dein Beruf? Ich gebe Seminare!</p>\n<p></p>\n<p></p>\n<p></p>\n<p>Als nächstes kommt eine Sängerin (?) die aussieht wie <a href=\"http://www.youtube.com/watch?v=Z8NKpyT-Jlk\">Transgender Kim Petras</a>.</p>\n<p></p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1241.jpg\" alt=\"tn_iPhone_Fotos_1241.jpg\" />\n<p></p>\n<p>Und sowieso, wieso sitzen Kinder im Studiopublikum von The Fog? Eine Jugend in Heizdecken?</p>\n<p></p>\n<p>Kinderbefragungen. In zwei Minuten werden so viel körpereigenes Eiweiß vernascht, wie bei einem erwachsenen Menschen in 20 Jahren nicht. Ein hoher Anteil an Pferdemotivpullovern und Spinat-Bashing.</p>\n<p></p>\n<p>Der nächste Gast ist ein Typ, den Frauen zum Fressen gerne haben. Trotzdem kocht er ein spiegelverkehrtes Hakenkreuz. Unschön in einem Programm der öffentlich-rechtlichen Sender!</p>\n<p></p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1244.jpg\" alt=\"tn_iPhone_Fotos_1244.jpg\" />\n<p></p>\n<p>Guckt mal, wo das überhypte, aber eigentlich ziemlich dümmliche Wunderkind hinstarrt! Ich bin doch nur neidisch.</p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1255.jpg\" alt=\"tn_iPhone_Fotos_1255.jpg\" />\n<p></p>\n<p></p>\n<h2>22:10 ARD - Das Wort zum Sonntag</h2>\n<p>Fastenzeit ist nicht mein Thema. Aber schön schlägt der ältere Herr den Bogen. Opfer! sagt Jesus im Matthäus Evangelium.</p>\n<p>Ich pilgere in die Küche neuen Suff holen.</p>\n<p></p>\n<p></p>\n<p></p>\n<h2>23:25 Das VIERTE - Heiße Girls</h2>\n<p>Für die heißen Girls dämme ich das Licht, ziehe mir eine speckige Satinschlafanzughose an, und putze mir die Hände an einem Stück Pizza sauber. Jetzt geht es los. Die heißen Mädchen.</p>\n<p>Vorher hatte ich meinem Freund die Haare geschnitten. Wir wollten schick für die Huren aussehen.</p>\n<p></p>\n<p></p>\n<p>WC Ente Gelpfropfen</p>\n<p></p>\n<p>Ramona Drews.</p>\n<p></p>\n<p></p>\n<img src=\"/content/images/tn_iPhone_Fotos_1258.jpg\" alt=\"tn_iPhone_Fotos_1258.jpg\" />\n<p></p>\n<p></p>\n<p>Alle sind total versaute, geile und besonders vulgäre Luder, die es ausnahmslos jedem spackigen Pekesack besorgen. Sagen sie.</p>\n<p></p>\n<p></p>\n<p>Die Plastikkostüme und nackten Brustgewebeknubbel nehmen kein Ende und ich schlief ein.</p>\n"}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

	module.exports = {"title":"Alles Gute zum Geburtstag Ada!","date":"2011-08-11 13:13:42 +0000","tags":null,"layout":"post","body":"<p>\n\tHallo Superfreunde, ich habe am Sonntag Geburtstag und wünsche mir von Euch Dinge, die Ihr auf meinem&nbsp;<a href=\"http://www.amazon.de/registry/wishlist/3PIK2FF6GZI5D\">Amazon-Wunschzettel</a>&nbsp;einsehen könnt. Hinzu kommt der Weltfrieden und in einem Raum mit 4000 Wellensittichen zu leben, die meinen Namen sagen können.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/jamjam.jpg\" width=\"500\" /></p>\n"}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

	module.exports = {"title":"Als ich ein Pony zu Weihnachten bekam","date":"2012-01-02 13:17:45 +0000","tags":null,"layout":"post","body":"<h3>\n\t1987:&nbsp;</h3>\n<p>\n\tSpäter erzählte man mir oft die unschöne Geschichte wie ich versucht habe mich mit ausgestreckten Beinen in das lachhaft kleine Puppenbett (Stichwort: neue Geschenke ausprobieren) zu quetschen und mich bis zur absoluten Bewegungsunfähigkeit in diesem groben Holzkäfig verkeilt habe. Ich war Jumbo Schreiner Junior und mein Einsatz im Sinne der Aufklärung war brutal, selbstzerstörisch und sollte zeitlebens ein Mahnmal für meinen weniger draufgängerischen Bruder darstellen.</p>\n<p>\n\tRosa Angorapullover, eine gemütliche aber zugleich modische blaue Latzhose, die heute nur Menschen aus dem Umland tragen, und den obligatorischen Hemdkragen (Nur Kinder, die in den 80er Jahren geboren wurden wissen, dass dieser Art des Kragens meistens nicht, wie schnell auf den ersten Blick vermutet wird, als Gesamtkonzept zu einem Hemd gehörte, sondern ein verlogener Accessoirekragen zum Vorheucheln von sozialem Status und guter Erziehung war).&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas1.JPG\" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas2.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tLatzhosen scheinen durch und durch mein Ding gewesen zu sein. An drei Weihnachtsfeiertagen des Jahres 1987 trage ich insgesamt drei Latzosen in drei verschiedenen Farben. Leider habe ich das Fotoalbum dieses Jahres nicht in Berlin vorliegen um den &quot;Verdachtsfall Latzhose&quot; näher zu untersuchen. Meine Logik suggeriert mir allerdings, dass ich vermutlich im Jahre 1987 genau 365 Latzhosen in 365 Farben besessen haben muss.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas3.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDie Geschenke waren klassisch, selbstgebaut, kreativ und hatten nichts mit dem zu tun was später folgen sollte: 64-Bit Welten, kräuselige wasserstoffblonde Plastikhaare auf einem Plastikkonstrukt, das dem Körper einer kleinwüchsigen Elefantitisfrau nachempfunden wirkte, ferngesteuerte Autos mit dem Namen &quot;RACER12000&quot;, in dessen Rädern sich später unser Hund im Welpenalter verbiss und mein Bruder nicht geistesgegenwärtig genug war mit dem Gas geben aufzuhören, so dass die ersten Zähne unseres kleinen Parson Jack Russel Terriers von dieser Perversion der Spielzeugindustrie zergeschmettert wurden.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t1987 war unser Jahr. Tipp-Kick, eine gebrauchte Ritterburg, in deren Inneren wir ein paar Jahre später den größten Popel der Welt fanden und einen coolen schwarzen Lenkschlitten, um den uns die anderen Kinder bis zum Abitur beneideten. Ich bekam meinen ersten Buggy und ein merkwürdiges Plastikhaus, in dem klotzige Figuren wohnten und alles was man anfasste nervige Geräusche machte. Mit dem praktischen Tragegriff sah das Teil aus wie ein frühes Apple Powerbook.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas4.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<h3>\n\t1988:</h3>\n<p>\n\tIn diesem Jahr sollte sich alles ändern. Mein Vater, der handwerklich begabte Tausendsassa, konstruierte ein gigantische Puppenhaus, das einen Raum in unserem Haus fast komplett mit der Masse an Holzideen und gestrickten Miniaturtopflappen ausfüllte. Tapeziert mit Tapetenresten aus dem Haus meiner Großmutter, Gardinen, deren muffiger Stoff in Erdfarbe heute nur noch durch H&amp;M in Berlin Mitte gewinnbringend verkauft werden kann, Spitzengardinen, winzig kleine Stühle, die sonst nur&nbsp;<a href=\"http://en.wikipedia.org/wiki/Goatse.cx\">Goatse</a> als Requisite für seine bereichernden Videos benutzt, und sehr kleines Geschirr. Für Kinder muss immer alles klein sein. Irgendwann möchte man dann alles groß haben. Dann ist man kein Kind mehr.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWen ich wohl anrufe? Dr. Helmut Kohl?</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas5.JPG\" style=\"width: 500px; height: 669px; \" /></p>\n<p>\n\t&nbsp;</p>\n<h3>\n\t1989:</h3>\n<p>\n\tDas Jahr des Mauerfalls. Der Einheitskanzler hat uns alle sehr lieb. Kinder in Schlafanzügen. Wir hatten ja im Westen immer von allem so viel! Mein Bruder präsentiert auf diesem Foto stolz sein neues ferngesteuertes Auto, und ich (im roten Schlafanzug mit Pfotenmuster und Motivkatze auf der Brust) habe offensichtlich Nachwuchs bekommen. Eine Glatze und ein Hartplastikwesen, das beim Drehen knatscht und die Frisur der heutigen Kanzlerin zur Show trägt. Vielleicht wollte ich mir vom Kindergeld auch ein ferngesteuertes Auto kaufen oder einen neuen Friseur beauftragen. Man hatte ja noch Pläne. Der Puppenwagen sieht ein bißchen aus wie das Geräusch, das man beim Bumsen auf einem älteren Gästebett macht. Im Hintergrund erkennen wir eine Sammlung lustiger Taschenbücher und einen Fernseher, auf dessen Bildschirm ein ganz besonders grausamer Mensch einen Aufkleber platziert hat. &quot;Das Gerät&quot; erinnert an einen altmodischen Volksempfänger, galt aber als High-Tech.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDer Kaufladen. Wenn deine einzigen Kunden deine Großmutter und deine Mutter sind, und höchstens alle paar Tage mal dein größerer Bruder im Laden vorbeischaut um Holzobst zu stehlen oder deine Ladentheke zu zertrümmern, dann solltest du aufhören zu glauben, dass du mal mit deinem kleinen Laden sehr reich werden wirst. Niemand ist je mit einem Kaufladen reich geworden. Die Leute bestellen lieber im Internet oder kaufen in den größeren Städten. Aus Frust habe ich im Folgejahr meinem Bruder eine Schere in den Kopf &quot;gesteckt&quot; und ihm mit dem Stopper meiner ersten Inline-Skates die Lippe aufgetrennt - beim Fahren - aus Versehen. Kapitalistensau!</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas6.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas7.JPG\" style=\"width: 500px; height: 373px; \" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<strong>1990:</strong></p>\n<p>\n\tMein schönstes Geschenk ist der Plüschelefant. Er ist perfekt gebaut. Perfekter als es Barbie je war. Jedes Detail an diesem Wundergeschenk ist faszinierend und funktional zugleich. Wenn man sich mit dem Kopf auf den Bauch des Elefanten legt, kann man seine Beine um den eigenen Hals legen und sein Rüssel liegt beruhigend auf der Stelle, wo der Wirbel auf meinem Kopf die Haare in alle Richtungen wirft. Jahrelang diente der Elefant als Kopfkissenersatz. Ich habe mit ihm gespielt, gelacht und ich habe in ihn geweint. Als ich mich vor Spinnen gefürchtet habe. Als ich nachts nichts schlafen konnte, weil ich so große Angst hatte, dass unser Haus von alleine Feuer fangen könnte. Als wir den Wellensittich weggeben mussten, weil der Hund ihn nur noch töten wollte. Als meine Bruder gemein zu mir war. Als meine Eltern gemein zu mir waren. Als die Welt gemein zu mir war. Als ich mich hasste. Als ich enttäuscht war. Als ich traurig war, wenn andere traurig waren. Als mein Hund krank war. Als mein erster Freund nachts betrunken vor meiner Tür stand und mir drohte. Als ich keine Lust hatte zur Schule zu gehen. Als ich meine Eltern hasste. Heute hole ich dieses Wunderwesen, mit den ausgeschlagenen Augen (Mutter schlug ihm beim Staub &quot;ausschütteln&quot; immer mit den Augen auf den Fensterrahmen), nur hervor, wenn es mir wirklich schlecht geht, wenn ich zweifele, wenn ich nicht weiter weiß, wenn es dunkel und kalt ist.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas8.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<h3>\n\t1991:</h3>\n<p>\n\tBarbie hat nun ein eigenes Appartement. Der Junge mit den kurzen Haaren und den fliederfarbenen Klamotten bin ich. Ambivalenz irgendwo zwischen 15cm hohem Frisierstuhl und beim Fussball die Jungs abziehen.&nbsp;</p>\n<p>\n\tBarbie wohnte in den frühen 90ern anders als heute. Ein kleines Appartment mit Boombox und zwei Spiegeln auf 4qm. Ein Alptraum ohne Fenster. Ich trug immer nur selbstgestrickte Wollsocken.</p>\n<p>\n\t1991 hat mein Leben revolutioniert. Vater besorgte uns ein nagelneues <a href=\"http://de.wikipedia.org/wiki/Nintendo_Entertainment_System\">NES</a>. Die ersten Spiele waren so bunt und aufregend. Ein derartiges Gerät hatte ich bisher noch nicht besessen. Wir packten Spiel um Spiel aus und schliefen in den Folgetagen nicht mehr. Das Startetpaket 3in1 mit Tetris, World Cup und Super Mario Bros 1 war jahrelang das großtmöglich vorstellbare Glück für meinen Bruder und mich. Zwei Jahre später, im Jahre 1993, beglückte mein Vater uns mit einer neuen Konsole, dem Supernintendo. Danach folgten Jahr um Jahr Spiele für beide Konsolen. Mein Bruder, mein Vater und ich. Ich besitze und benutze beide Konsolen bis heute.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas9.JPG\" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas10.JPG\" style=\"width: 500px; height: 373px; \" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas11.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<h3>\n\t1993:</h3>\n<p>\n\tThese: Jedes Kind hat mindestens ein Mal im Leben &quot;das verrückte Labyrinth&quot; geschenkt bekommen. Zum Glück hat aber nicht jedes Kind diese absurde Puppe geschenkt bekommen. Ihr Name: Starlet. Ihre Haare: leicht brennbar. Ihre Funktionen: Wiedergabe eines in ein Mikrofon eingesprochenen Textes durch die offenen Plastikfleischwunden ihres buckligen Rückens. Kein Wunder, dass ich lieber mit meinem ersten ferngesteuerten Auto spiele.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas12.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<h3>\n\t1994:</h3>\n<p>\n\tSpaghettipuppe. Keine Ahnung was die konnte. Cortisongesicht und irgendein ernsteres Chromosomenproblem. Dann schon lieber das erste Scrabbel geschenkt bekommen, um &nbsp;vom drei Jahre älteren Bruder und Vater bis aufs Blut gedemütigt werden. Heute bin ich Texterin. So habe ich mich damals nicht gefühlt.</p>\n<p>\n\tUnterm Baum liegt eine merkwürige Konsuminstallation aus Pferdchenfiguren, einem <a href=\"http://de.wikipedia.org/wiki/Mumins\">Mumins</a> Bilderbuch, einer &quot;Mein kleines Pony&quot; Ranch und einem Lego-Strand. Soweit gut. Auch weil ich Cordhose trage. Mein Bruder zockt unbeeindruckt Konsole. Aus uns beiden ist trotzdem was geworden.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas13.JPG\" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas14.JPG\" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas15.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<h3>\n\t1995:</h3>\n<p>\n\tDer Junge, das war immer ich. Aufgewachsen in einer Nachbarschaft, die ausschließlich aus älteren Jungs bestand, war ich der schönste Junge. Cordhosenkörperbau und Deutschlandtrikot. Den Fehltritt verzeihe ich mir. 1995 bekamen mein Bruder und ich unseren eigenen Kicker. Wow! Was für ein futuristisches Holzraumschiff. Das Mutterschiff der Langeweileabwehr. Vermutlich haben meine Eltern diesen Tisch ein paar Jahre später wieder verkauft, wie unsere Tischtennisplatte. Vom Geld haben mein Bruder und ich nichts gesehen. Bestimmt haben sich meine Eltern davon ein kleines Pony oder ein noch tolleres Puppenhaus gekauft.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas16.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<h3>\n\t1997:&nbsp;</h3>\n<p>\n\tAm Nikolaustag bekamen wir unseren Hund. Filou. Dieses zauberhafte Geschöpf stieß auch den ersten Umdenkprozess in mir an. Warum nicht mal jemanden beschenken und nicht nur Geschenke erhalten? Bis zu einem bestimmten Alter ist das moralisch unbedenklich. Ich entschied mich meinen Eltern weiterhin nichts zu schenken, aber den Hund mit einem tollen Präsent zu bedenken. Ich schenkte aus Liebe.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas17.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<h3>\n\t1998:</h3>\n<p>\n\tZum ersten Mal in meinem Leben trug ich lange Haare. Auf diesem qualitativ schlechten Foto (vermutlich eine Aufnahme von Mutter) erkennen wir den Lockenkopf meines Bruders und mich in Latzhose (großes Comeback) und mit auf dem Weihnachtsmarkt geklauter Nikolausmütze. Vermutlich wurde in diesem Jahr bereits der Großteil unserer Geschenke in bar ausgezahlt. Die Faszination an Weihnachten geht nach und nach verloren. Wir gehen verloren. Das wars.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas18.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<h3>\n\t2011:</h3>\n<p>\n\tEs ist still geworden in unserem Haus. Heiligabend. Meine Großmutter schläft unbeeindruckt auf dem Sofa ein. Als sie aufwacht geht sie einfach mitten in der Bescherung heim. Sie lebt hinter einem grauen Schleier. Niemand kann sie wissen lassen, dass heute Weihnachten ist. Der Hund hört nicht mehr. Er sieht nicht mehr. Er ist müde und alt geworden. Mein Onkel kommt gar nicht mehr. Sperrig fühlt sich meine Welt an. Ich bin wehmütig und mir fehlt das Lachen unterm Baum. Dieses Wohnzimmer ohne Kichern, Kreischen, Bellen, Anschreien und Fluchen ist ein leerer Raum. Wir versuchen es mit Gesprächen über die Zukunft zu füllen. Mit Wärme aus dem Kamin, mit Leckerchen für den Hund und mit Scrabble, bei dem ich heute immer gewinne.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_Xmas20.JPG\" /></p>\n"}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

	module.exports = {"title":"Apartment hunting San Francisco","date":"2014-04-23 16:14:03 +0000","tags":null,"layout":"post","body":"<img src=\"http://media-cache-ec0.pinimg.com/736x/22/d0/92/22d092fe58ae6525ee3a4bcf412504c0.jpg\" alt=''>\n<p>Hallo, wir sind Ada und Johannes aus Berlin und suchen ab dem 01.07. eine kleine Wohnung in San Francisco bis $3000 Dollar im Monat. Mit uns zieht ALF the Cat, also wäre eine Wohnung perfekt in der Katzenhaltung auch erlaubt ist. Am liebsten in Mission, Soma, Potrero Hill oder Hayes Valley.</p>\n<p>Wer jemanden kennt, der jemanden kennt oder sonstige Tipps für uns hat, kann uns gerne eine Freude machen und mir eine Mail schreiben. Ich bedanke mich gerne mit einer Kleinigkeit.</p>\n<img src=\"http://distilleryimage4.ak.instagram.com/5e452a9effa111e1bed91231380ffeeb_7.jpg\" alt=\"\">\n<img src=\"http://distilleryimage7.ak.instagram.com/7c2b2640114811e2868c12313817a130_7.jpg\" alt=\"\">\n<p>Hey there, we´re Ada and Johannes from Berlin. We´re looking for an apartment up to $3000 per month after 1 July 2014 in Mission, Soma, Potrero Hill or Hayes Valley which is available for cat owners. If you have any useful tips or proposals, let me know! I will thank you with cake!</p>\n"}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	module.exports = {"title":"archive","date":"2012-12-17 00:00:00 +0000","tags":null,"layout":"post","body":""}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	module.exports = {"title":"Articles","date":"2011-03-22 00:00:00 +0000","tags":null,"layout":"post","body":"<div class='article'>\n<h1>Alle Artikel</h1>\n<r:snippet name=\"archive\" />\n</div>\n"}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	module.exports = {"title":"Audiokrieg - Gesammelte Werke mit Sprachfehler","date":"2012-06-06 15:27:45 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/tn_auio.JPG\" alt=\"tn_auio.JPG\" />\n<p>Ja, ich habe einen total niedlichen Sprachfehler, und ja, ich lese Texte nur genau ein einziges Mal ein und gebe keinen Fick auf Lesefehler. Vielleicht weil ich es unverfälscht und spontan mag, oder vielleicht auch weil ich faul bin. Mag sein.</p>\n<p>Meine bisherigen Miniatur-Lesungen:</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/als-ich-ein-pony-zu\">player</a></p></p>\n<p><a class=\"widget\" href=\"http://soundcloud.com/bangpowwww/ada-blitzkrieg-liest-das-ding\">player</a></p></p>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/ein-sonntag-beim\">player</a></p></p>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/jugend-im-gehirn\">player</a></p></p>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/ada-blitzkrieg-stijlroyal\">player</a></p></p>\n"}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	module.exports = {"title":"Awesome Places: Grandmother","date":"2011-11-07 13:07:37 +0000","tags":null,"layout":"post","body":"<p>\n\t<img alt=\"\" src=\"/files/grandmother.JPG\" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/grandmother (2).JPG\" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/grandmother (3).JPG\" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/grandmother (4).JPG\" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/grandmother (5).JPG\" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/grandmother (6).JPG\" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/grandmother (7).JPG\" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/grandmother (8).JPG\" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/grandmother (9).JPG\" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/grandmother (10).JPG\" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/grandmother (11).JPG\" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/grandmother (12).JPG\" style=\"width: 500px; height: 333px; \" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/grandmother (13).JPG\" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/grandmother (14).JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/grandmother (1).JPG\" /></p>\n<p>\n\t&nbsp;</p>\n"}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

	module.exports = {"title":"Balkankrieg vs. Textkrieg","date":"2011-06-27 16:58:41 +0000","tags":null,"layout":"post","body":"<p>\n\tWir hatten also eine Ferienwohnung in Kroatien über das Internet reserviert. Bei 30 Euro pro Nacht hält man auch schön die Fresse, wenn nachts Kakerlaken benutzte Binden aus dem Badmülleimer stehlen oder es im Kühlschrank nach Kot riecht. Was aber wenn die Wohnung noch mehr Überraschungen auf Lager hat?</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/haus1.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tZugegeben, die Kroaten haben keinen Stil und Cevapcici sind auch nur hässlichere Frikadellen, aber einrichten kann man hier definitiv. Wieso nicht einfach Kindergesichter aus Zeitschriften ausschneiden und auf jede Kachel des Badezimmers kleben. Neben die Toilette ein paar original Rätselzeitschriften aus den 60er Jahren platzieren und einen verdächtig nach etwas Essbarem aussehenden Badteppich vor die Dusche legen, in der ein Stromkasten angebracht ist.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/haus2.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIm Rahmen meiner Herumschnüffeleien in diesem &quot;Ferienapartment&quot; fanden sich circa 3000 Groschenromane. Beim intensiven Studium von &quot;Sabine - Sonderband - Die Hochzeitsglocken werden läuten&quot; erfuhr ich endlich mehr über mich und meine Gefühle.&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/haus3.JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/haus5.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDas Ferienapartment war weder schön noch zweckdienlich eingerichtet und selbst wenn ich zu diesem Zeitpunkt über 80 Jahre alt gewesen wäre, hätte ich mich gefragt wieso dort Indianerbitches und Kornblumen an der Wand hängen und kein moderenes Portrait von &quot;dieser Hindenburg, von der immer alle erzählen&quot; oder vom aktuellen Kaiser.&nbsp;</p>\n<p>\n\tIn der Wohnung fanden sich dann noch mehr seltsame Dinge. Eine Brille mit mindestens 8 Dioptrin, Insektizide aus einer Zeit, als Kroatien noch Jugoslawien hieß und braune Leichenflecken auf der Matratze.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/haus6.JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/haus7.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tGekocht haben wir im SUPERAUTOMAT, der auch unsere Einkäufe erledigte, putzte und uns sexuell befriedrigte.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/haus8.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tRichtig unangenehm wurde es dann im Suff am zweiten Abend. Die offizielle Version lautet, ich war auf der Suche nach Klopapier und habe den Badschrank geöffnet. Ich öffnete den Badschrank und entdeckte schmutzige Verbände, benutzte Wattestäbchen, Glycerin, eine Intimlotion von 1978 und ein Gebiss mit echten Goldzähnen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/haus9.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/IMG_7269.jpg\" width=\"499\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIn panischer Angst, dass in den Schränken oder auf dem Dachboden noch die Leiche einer alten Dame liegen könnte, untersuchten wir die Wohnung genauer und fanden einen Haufen unmöglichen Kitschschrott, aber keine Leiche.&nbsp;</p>\n<p>\n\tUm den Gästen der Aufenthalt so schön wie möglich zu gestalten, hat man auch gleich das Foto der verstorbenen alten Frau über dem Esstisch hängen lassen und möglichst wenig geputzt und gewaschen, damit der Originalgeruch erhalten bleibt. Bis zu diesem Urlaub wusste ich nicht, dass selbst Glas nach dem Eigengeruch des Bewohners einer Räumlichkeit riechen kann.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/haus10.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/IMG_7266.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tInnenarchitektonische Highlights: Ein Portrait der Familie Jesus mit Stadttauben über dem Massivholztraum zum Schlafen, ein gewebter Wandteppich mit Hirschmotiv über dem Kinderbett und ein 40 Jahre alter Kühlschrank, der Stromschläge verteilt, wenn man ihn berührt.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/haus11.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/haus14.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tUns sonst so?</p>\n<p>\n\t&quot;Adria?&nbsp;Das ist doch dieses Bier in der 2l PET-Flasche nach dem das Meer benannt wurde!&quot;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDie Adria ist ein korrektes Meer. In diesem Meer befinden sich korrekte Fische. Sie leuchten und sind schön bunt und haben nichts mit dem ganzen Aalgekröse und Forellenglubsch in unseren Gewässern zu tun. Und dann sind wir wieder heimgefahren.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/haus 13.JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/haus 15.JPG\" width=\"500\" /></p>\n"}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	module.exports = {"title":"Barbara Scheel, Anne Will und Rassismus bei den Piraten","date":"2012-03-29 13:49:02 +0000","tags":null,"layout":"post","body":"<p>Gestern Abend gab sich die Frau des Ex-Bundespräsidenten Walter Scheel ‘die Ehre’ und trat als Gast in der Anne Will Sendung auf. Sparen wir uns nun das Vorgeplänkel einer bis dahin recht ereignislosen Sendungen und beginnen mit unserer Kritik dort, wo die Kritik leider fehlte.</p>\n<br>\n<p>Die Sendung ist <a href=\"http://daserste.ndr.de/annewill/videos/annewill3387.html\">hier</a> in der ARD Mediathek nachzusehen.</p>\n<br>\n<p>Scheel betäuert im Rahmen der Sendung das Verständnis für ihre pflegebedürftige Mutter und den Wunsch sich nicht von “dunkelhäutigem Pflegepersonal” waschen zu lassen. Für mich geht die Enttäuschung in rassistischen Momenten immer von zwei Seiten aus und ich kann mich nicht festlegen, welche Seite mich wütender/trauriger oder auf Dauer misanthropischer macht.</p>\n<br>\n<p>A) Der Urheber einer rassistischen Äußerung\nB) Die Reaktionen auf diese rassistische Äußerung</p>\n<br>\n<p>Gerade in den Reaktionen kann man den Stand einer Gesellschaft ablesen. Weggucker, Dulder, Egaler. Sind wir derart auf Frieden gepeitscht, dass wir selbst den offenkundigen Rassismus in einer Sendung der öffentlich rechtlichen Sender akzeptieren? Und was war nochmal genau der Unterschied zwischen Toleranz, Akzeptanz, Verständnis und Zustimmung?</p>\n<br>\n<p>Der genaue Ablauf:</p>\n<br>\n<p>Scheel tätigt ihr zutiefst <a href=\"http://www.ardmediathek.de/ard/servlet/content/3517136?documentId=9967394\">rassistische Äußerung</a>. <strong>In dem Pflegeheim, von dem ich rede, ist jeder zweite Pfleger ein Ausländer und spricht kaum Deutsch. Wir haben einen schwarzen Afrikaner, so wie ich ein weißer Europäer bin. Und wir haben 90-jährige Frauen, die sollen sich intim von so einem Menschen pflegen lassen. Die haben erst einmal einen Schock.</strong></p>\n<br>\n<p>Anne Will räumt ihr durch Nachfragen die Chance ein sich zu revidieren (Warum überhaupt diese Chance?). <strong>Moment mal, haben Sie das gerade gesagt, dass es schwierig ist, wenn ein schwarzer Afrikaner jemanden pflegt?\nJa! </strong></p>\n<br>\n<p>Ich sitze etwas fassungslos vor dem Fernseher. Der einzige dem die alte Damen offensichtlich noch aufstößt ist Heufer-Umlauf. Der zurecht ein paar provokante Gegenfragen tätigt. Ansonsten ist die Runde ruhig und scheint zwar der Rechtfertigung der alten Dame nicht zu trauen, aber sagen möchte man auch nichts. Deutschland. Land des Friedens. Ist wirklich jede Meinung eine Meinung? Sollten wir nicht unseren Scheinfrieden in solchen Situationen opfern um ganz klar rauszustellen, dass Frau Scheel, die Frau unserer Ex-Bundespräsidenten, eine Rassistin ist?</p>\n<br>\n<p>Wo liegt das Geheimnis von Alltagsrassismus. Ist das außer dem Heufer-Umlauf und mir niemandem aufgefallen? Wieso besitzt die alte Damen scheinbar einen Freifahrtschein? Mir schießen multiple Erklärungen durch den Kopf. Respekt gegenüber Menschen, die den Krieg erlebt haben? Warum denn nochmal genau? Ich möchte, dass Frau Scheel ganz klar gesagt wird: “HALLO FRAU SCHEEL, IHRE RECHTFERTIGUNGEN SIND PEINLICH. SIE SIND RASSIST!”</p>\n<br> \n<p>Sind die Medien zu feige? Ich packe also mein Handy und suche nach Reaktionen auf die noch recht junge Sendung und bin doch etwas verwundert, als ich über diese direkte Antwort eines Mitgliedes der Piratenpartei gestolpert bin:</p>\n<br>\n<img src=\"/content/images/tn_kekspiratin1.JPG\" alt=\"tn_kekspiratin1.JPG\" />\n<br>\n<p>Nun ja, wie geht man als ebenfalls noch recht junge Partei nun vor? Akzeptiert man diese Person als Mitglied oder verabschiedet man sich? Für mich steht fest, dass ich Schwierigkeiten habe eine Partei zu wählen, in der rassistische Äußerungen ohne Konsequenzen getätigt werden können, die sogar im gleichen Atemzug noch von vielen Mitgliedern relativiert werden. Da muss etwas passieren, damit ich Fan bleibe. <strong> “Ja, ja. blabla. Die Leute sind wütend auf dich (Kekspiratin), aber bitte nicht mit der gesamten Partei gleichsetzen.”</strong> Das dürfte so nicht sein. Man scheut sich vor Klartext. Ich aber möchte das. Wo finde ich mich also in Zukunft wieder?</p>\n<br>\n<p>Leider werden die wenigen kritischen Stimmen seitens der Piraten von einer Abgeordneten der Berliner Piratenpartei wieder relativiert. Das gefällt mir leider gar nicht. Ich wünsche mir eine offizielle Stellungnahme und eine einheitliche Einigung innerhalb der Partei, wie man mit Mitgliedern verfährt, die antidemokratisches und rassistisches Gedankengut publizieren.</p>\n<br>\n<img src=\"/content/images/tn_zuse.JPG\" alt=\"tn_zuse.JPG\" />\n<br>\n<p>Zum Glück gibt es aber auch Piraten, die nun ein <a href=\"http://de.wikipedia.org/wiki/Parteiausschluss\">Parteiausschlussverfahren</a> fordern. Bleibt auf eine zufriedenstellende Konsequenz zu hoffen.</p>\n<br>\n<img src=\"/content/images/tn_ennnooo.JPG\" alt=\"tn_ennnooo.JPG\" />\n<br>\n<p>Das Medienecho am nächsten Tag kotzte nicht nicht minder an. Kaum jemand verliert mehr als zwei Sätze über den “<a href=\"http://www.abendblatt.de/kultur-live/tv-und-medien/article2232347/Bei-Anne-Will-Rassismusvorwurf-gegen-Barbara-Scheel.html\">Ausrutscher</a>” (hier sind sich die Medien einig) der Gattin des Ex-Bundespräsidentin. Die Rede ist von “spontaner Äußerung”, “stellte Scheel schnell klar” und “unglückliche Aussage”. UNGLÜCKLICHE AUSSAGE! Rassismus ist keine unglückliche Aussage und auch keine “<a href=\"http://www.abendblatt.de/kultur-live/tv-und-medien/article2232347/Bei-Anne-Will-Rassismusvorwurf-gegen-Barbara-Scheel.html\">unglückliche Wortwahl</a>”, sonderne eine reale Gefahr für unsere moderne Gesellschaft. Die “unglückliche Wortwahl” ist Rassismus. Und wir dürfen gerne darüber reden. Ich möchte mündige Menschen, die rassitische Aussagen sowohl durchschauen, als auch die Pfeiler der Bühnen wegtreten, auf denen diese getätigt werden. Ich bin unzufrieden und ich sehne mich nach Menschen, die auch einer Frau Scheel den Mittelfinger zeigen. Für mich gehört diese Frau in dieser Sendung bis auf die Knochen auseinandergepflückt.</p>\n<br>\n<img src=\"/content/images/tn_meintweet.JPG\" alt=\"tn_meintweet.JPG\" />\n"}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

	module.exports = {"title":"Batik3000","date":"2011-06-09 08:54:13 +0000","tags":null,"layout":"post","body":"<p>\n\tNachdem <a href=\"http://www.spiegel.de/netzwelt/netzpolitik/0,1518,767375,00.html\">kino.to</a> von der Kriminalpolizei gefickt wurde und down ist, gibt es für mich als arbeitsloser Sozialschmarotzer keinen Grund mehr aufzustehen. Da ich allerdings die ganze Nacht nicht geschlafen habe, weil es in meiner Berliner Wohnung mallorcawarm ist, schütte ich nun 2l Fichtenaufguß in die heiße Badewanne und überlege wofür Ohrenkerzen eigentlich nochmal genau gut sind.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEs folgen die unansehnlichen Modefotos des Batikshootings und ich bin geneigt ein kleines Gewinnspiel hinzuwichsen. Ich möchte Euch bitten mir in den folgenden Tagen Euer Lieblingsfoto einer einurinierten Sperrmüllmatratze zu schicken. Der Gewinner erhält eine Packung Bussi Boy Eis.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tBatik könnte das große Ding werden. Gleich nach großporiger Haut und Damenglatze.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWie es mit den Shirts weitergehen soll steht noch im Raum. Derzeit existieren 6 Shirts, die alle rot, blau, blau - rot gebatik sind. Was soll ich nur tun? Pferde aufsticken? Vorne Löcher reinschneiden, wo sich bei meisten Frauen, die einen BMI über 18 haben, Brüste befinden?&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"326\" src=\"/files/batikkk (4).jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/batikkk (3).jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"327\" src=\"/files/batikkk (6).jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/batikkk (5).jpg\" /></p>\n<p>\n\t&nbsp;</p>\n"}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

	module.exports = {"title":"Batiken statt Club","date":"2011-06-06 16:25:25 +0000","tags":null,"layout":"post","body":"<p>\n\tOffensichtlich habe ich das ganzes Wochenende damit verbracht Billigtextilien zu batiken und schrill wie ein Hermaphrodit zu kreischen, wenn ich die Ergebnisse sah. Batiken ist meine Party und <a href=\"http://www.haraldgloeoeckler.de/\">Harald Glööckler</a> ist mein Villalobos.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tUm es direkt zu sagen: Ich war im <a href=\"http://www.taz.de/1/leben/medien/artikel/1/der-gentleman-laechelt-nur/\">KiK</a> und es tut mir leid. Es ging einfach nur darum einen möglichst großen Haufen weißer Baumwolle zu einem unverschämt günstigen Preis zu kaufen. Außerdem riecht es im KiK immer so gut.</p>\n<p>\n\tIch kaufte also 6 weiße Shirts, 2 weiße Hosen und 3 Paar Socken. Wenn es dort Unterwäsche aus Baumwolle gegeben hätte, ich schwöre bei den Händen thailändischer Kinderarbeiter, ich würde sie heute tragen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/batik3.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tFärbemittel. Färbemittel sind aggressiv. Ich wählte Echtfarben. Meine Hilfskraft, die ich exklusiv nur zu solchen Zwecken in meiner Wohnung gefangen halte, hatte die gute Idee mit Händen in die Wanne mit den Textilien und Echtfarben zu fassen. Ihr erkennt ihn die nächsten zwei Monate auf der Straße an seinen blauen Händen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch habe den ganzen Textilmüll in eine schmutzige Plastikbütte geworfen, in der normal unser Pfandgut vor sich hin gärt. Dazu noch ein paar weiße Stoffschuhe, die zu sehr nach Golfplatz und &quot;Hallo, ich bin der lockere Typ vom Gehirnchirurgen-Kongress&quot; aussahen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/batik1.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDer Scheiß liegt dann erstmal eine Stunde in der Siffbrühe rum, während man sich denkt, dass das alles sowieso nichts wird weil Batik cooler ist als man selbst.</p>\n<p>\n\tBeim Aufknoten habe ich dann ein paar welpige Laute von mir gegeben und wie eine Robbe in die Hände geklatscht, ohne dass mir jemand Fisch zugeworfen hätte. Schön sind sie geworden. Wer Shirts haben will, schreibt mir eine Email. Kleidergröße und Eure Motivation ist mir scheißegal.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/batik2.jpg\" width=\"500\" /></p>\n"}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

	module.exports = {"title":"Baut mal was!","date":"2014-06-17 17:29:17 +0000","tags":null,"layout":"post","body":"<p>{&lt;1&gt;}<img src=\"http://media-cache-ec0.pinimg.com/736x/da/6a/f6/da6af6c193c882746838adce22f35f03.jpg\" alt=\"alt\"></p>\n<p>Ganz ehrlich, Langeweile ist eben in erster Linie langweilig und ich bin leider keiner dieser charaktergeilen Menschen, die es genießen können “mal nichts tun zu müssen”. Daher sammele ich seit einiger Zeit schöne DIY Projekte und habe eine schöne Liste für Euch zusammengepappt:</p>\n<h1>1. <strong>Der IKEA Expedit Hack</strong></h1>\n<img src=\"http://cdn.ikeahackers.net/wp-content/uploads/2013/10/IMG_8460.jpg\" alt=\"\">\n<p>Einfach ein paar alte Schweinelappen mit Light-Margarine auf ein IKEA Expedit werfen und schon sieht das gute Stück aus wie in einem dänischen 60er Jahre Pornofilm. Wobei für mich bei dieser Anleitung der eigentlich überraschende Hack ist, dass man das Regal scheinbar auch vertikal aufstellen kann. Die <a href=\"http://www.ikeahackers.net/2013/10/ex-ikea-upright-bookcases-now-mid-century-modern-sideboards.html\">genaue Anleitung</a> findet Ihr <a href=\"http://www.ikeahackers.net/2013/10/ex-ikea-upright-bookcases-now-mid-century-modern-sideboards.html\">hier</a>. Auch wenn es gerade heiß hergeht um <a href=\"http://www.zeit.de/digital/internet/2014-06/ikea-zwingt-ikeahackers-zum-umzug\">IKEA vs. IKEA Hackers</a>.</p>\n<h1>2. <strong>Kekstüten</strong></h1>\n<img src=\"http://ohhappyday.com/wp-content/uploads/2014/04/2_cookie_bag.jpg\" alt=\"\">\n<p>Würde dieser Sankt Martin Typ heute leben, würde er bestimmt sein ganzes Geld in Kickstarterprojekte stecken oder einfach “ein Lächeln” verschenken. So ein Vollidiot! Wenn man schon unbedingt was verschenken muss, dann doch bitte Kekse! Zum Beispiel in diesen <a href=\"http://ohhappyday.com/2014/05/printable-cookie-monster-bags/#more-25043\">Cookietüten</a>. Wie die gehen? Einfach Beton in einem geklauten Sportwagen anrühren und im Bademantel einen Regenwurm mit Plastikbesteck bei Vollmond essen. Dann noch schnell die Beine hinter den Kopf zusammenfalten und Schnupftabak in eine alte Socken einwickeln. Das Ganze dann noch fotografieren, mit einem Schwarzweißdrucker ausdrucken und das Bild im Ofen für 80.000 Minuten bei 200 Grad mit Mayonnaise überbacken. Oder eben <a href=\"http://ohhappyday.com/2014/05/printable-cookie-monster-bags/#more-25043\">SO</a>.</p>\n<h1>3. <strong>Superflubber</strong></h1>\n<img src=\"http://blog.mrprintables.com/wp-content/uploads/2013/10/flubber-1-2.png\" alt=\"\">\n<p>Macht Euch doch Eure Knete einfach mal selber, Ihr Pleppos! Dazu müsst Ihr nur 20 Packungen streichzarte Leberwurst aus dem “Muss weg!” Regal kaufen. Ein anderes Rezept für Knete findet sich auf <a href=\"http://blog.mrprintables.com/a-flubber-recipe/\">mrprintables</a>.</p>\n<h1>4. <strong>Jumbo Popsicle Girland</strong></h1>\n<img src=\"http://ohhappyday.com/wp-content/uploads/2014/06/popsicle.garland.done2_.600.jpg\" alt=\"\">\n<p>Ich mag Eis. Auch optisch. Und wieso nicht mal das hässliche Wohnzimmer wie für einen Kindergeburtstag umstylen? Gute Laune garantiert. Eine <a href=\"http://ohhappyday.com/2014/06/jumbo-popsicle-garland//\">DIY Idee</a> für echte Harald Glööckler Typen.</p>\n<h1>5. <strong>Hipster Magazin Ständer</strong></h1>\n<img src=\"http://31.media.tumblr.com/tumblr_lxo373JAFg1qh5onlo1_400.jpg\" alt=\"\">\n<p>Man braucht vier Bretter und eine gehörige Portion Toleranz und unendlich Contenance um die dummen Fressen im Baumarkt zu ertragen. Dann befestigt man die Latten mit einem Nagel, bestellt sich Hipstermagazine bei Etsy oder kauft sich alle meine Bücher <a href=\"http://textkrieg.de/pages/sukultur\">Bücher</a> und packt sie in die Auslage. Genauer erklärt es <a href=\"http://item.rakuten.co.jp/margherita/mr-01/\">diese Seite</a> nicht. Und auch die Sprache ist mir fremd.</p>\n<h1>7. <strong>Wooden House For Cats</strong></h1>\n<img src=\"http://catissa.com/wp-content/uploads/2013/06/transp-3.jpg\" alt=\"\">\n<p>Für dieses Holzhaus für dicke Katzenidioten braucht man noch nicht einmal eine Anleitung, sondern nur eine gesunde Portion Menschenverstand und <a href=\"http://catissa.com/wooden-house/\">Inspiration</a>. Aber genau daran wird es bei den meisten von uns dann auch scheitern.</p>\n<h1>8. <strong>Hanging Herb Garden</strong></h1>\n<img src=\"http://s3-ec.buzzfed.com/static/2014-03/enhanced/webdr05/29/18/enhanced-11588-1396130736-8.jpg\" alt=\"\">\n<p>Wir müssen alle viel mehr geilen Scheiß anpflanzen, habe ich mir gedacht, und mich in diese Indoor-Gärten für Kräuter verliebt. Tja, dann lasst uns mal <a href=\"http://www.buzzfeed.com/benuyeda/diy-hanging-garden-awjd?sub=3124166_2696150\">bauen</a>!</p>\n<h1>9. <strong>Oakwood Makeup Brush Holder</strong></h1>\n<img src=\"http://dslznbjhfjfxj.cloudfront.net/public/images/product_images/260588/large/open-uri20131011-2-13sfmdo?1381526730\" alt=\"\">\n<p>Ihr braucht ein Brett, Treibholz oder einen Betonklotz. Dann löst Ihr den Dildo von Eurem Schlagbohrer, nehmt einen dicken Bohraufsatz und hämmert halt die verdammten Löcher rein. Schon ist ein <a href=\"http://www.luvocracy.com/mrs.french/recommendations/oakwood-makeup-brush-holder\">tolles Projekt</a> entstanden: Make-Up Holder oder eben als Stifthalter für intellektuelle Mädchen zu benutzen, die nicht so viel Wert auf ihr Aussehen legen. Man kann auch Candied Bacon reinstellen.</p>\n<h1>10. <strong>Planter Closet</strong></h1>\n<img src=\"http://cocolapinedesign.com/wp-content/uploads/2013/12/IMG_2847.jpg\" alt=\"\">\n<p>Das <a href=\"http://cocolapinedesign.com/2013/12/17/diy-planter-closet/\">Berlin Mitte</a> unter den Projekten. Könnte auch Mutter gefallen.</p>\n<h1>11. <strong>Goldene Bäm-Pinata</strong></h1>\n<img src=\"http://ohhappyday.com/wp-content/uploads/2011/09/alli5.jpg\" alt=\"\">\n<p>Was ist geiler als Basteln? Richtig: Schlagen und Gewalt! Hier in herrlicher Kombination in Form einer hübschen Pinata zum <a href=\"http://ohhappyday.com/2011/09/how-to-make-a-golden-alligator-pinata/\">selber basteln</a>.</p>\n"}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	module.exports = {"title":"Berlin Festival 2011","date":"2011-09-12 14:56:52 +0000","tags":null,"layout":"post","body":"<p>\n\tDank den Freunden der INTRO Redaktion machte ich mich Samstagnachmittag auf den Weg zum&nbsp;<a href=\"http://www.berlinfestival.de/\">Berlin Festival</a> 2011. Wie immer im dörflichsten Brackteil von Berlin Tempelhof gelegen, strahlt das alte Flughafengebäude diese epische Hässlichkeit aus, die zum einen berunruhigend, und zum anderen dunkel besänftigend wirkt.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDieses Jahr sind es drei Bühnen, die sich auf die Hangar verteilten. INTRO stellte die Hauptstage. Passend zu Beirut konnte ich mit meinem VIP Bändchen das Gelände betreten, zeitintensiv im &quot;Betreten verboten Teil&quot; des alten Flughafengebäudes in eine Art Schulsport-Umkleiderraum (mit STUFF ONLY VIP Schriftzug in Schreibschrift an der Tür) abpinkeln und hatte sogar noch Zeit eine Stunde auf meine Begleitung angepisst zu sein, die durch den normalen Eingang kam. Wir hatten vorgetrunken.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/tn_IMG_9103.JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/tn_IMG_9101.JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/tn_IMG_9073.JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"757\" src=\"/files/tn_IMG_9077.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/tn_IMG_9099.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDas Gelände ist groß, beherbegte ein Autoscooter, 5 Bierstände, einen Pizza.de Stand, der das ganze Festivalgelände mit seinen unmöglichen gelben Werbeaufdruckballons verunschönerte. Atmosphärisch natürlich in keinster Weise mit der liebevollen und verspielten Dekoration des Geländes zu vergleichen. Das Line-Up konnte dafür natürlich einiges. An diesem Tag schauten wir <a href=\"http://beirutband.com/\">Beirut</a>, <a href=\"http://soundcloud.com/panthaduprince\">Pantha du Prince</a>, <a href=\"http://soundcloud.com/boysnoize\">Boys Noize</a>, <a href=\"http://www.casperxo.com/\">Casper</a> und <a href=\"http://soundcloud.com/thebloodybeetroots\">The Bloody Beetroots Death Crew 77</a>.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/tn_IMG_9090.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tUnd plötzlich stehen gefühlte zehn Millionen Menschen vor der INTRO Stage und tanzen wie Schulkinder auf Klassenfahrt nach Früchtebowle und Sportzigarette auf Boys Noize.</p>\n<p>\n\tPlötzlich ist alles ganz still. Die Menge hört auf zu tanzen. Der Sound ist weg. Nur der DJ merkt nichts, denn seine Kopfhörer arbeiten weiter. Er feiert sich weiter. Fordert die Menge zum Tanzen auf. Unangenehm. Ich hasse die Welt so dafür, dass niemand dem Franzosentyp da vorne mal ein Zeichen gibt. Mehrere Minuten. Dieses Fremdscham werde ich einfach nie los.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tAuf der hintersten Hangarbühne legte Casper eine schöne Show hin. Ein bißchen Heulpotenzial und ein paar wunderschöne Momente als er die Menge mit Worten zerteilt und dann die Massen in einer hellen Lichtermeerexplosion zusammentreffen lässt. Seine Begleitung umarmen. Sagen, dass man sich freut da zu sein. &quot;Schön, dass du da bist!&quot;. Momente des Glücks.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/tn_IMG_9143.JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/tn_IMG_9159.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDann mein persönliches Highlight des diesjährigen Berlin Festivals: The Bloody Beetroots - Death Crew 77 mit monumentalem Bühnenbild. THE CHURCH OF NOISE. Gut, die Idee mit den Masken und des Messencharakter ist nicht neu. Aber diese absolut geile Komposition aus totaler Verausabung auf der Bühne, Elektroorgel, Death Metall Electronica Fummlerei und einer Lightshow mit weißem Licht ist absolut sehenswert. Wir haben getanzt bis zum Ende der Show und haben das Gelände mit Nahtoderfahrungsgesichtern und totaler Erschöpfung verlassen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/tn_IMG_9210.JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/tn_IMG_9264.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIn der U-Bahn auf dem Rückweg war es dann so eng, dass ich jetzt doch besser mal einen Schwangerschaftstest mache. Immer wieder gut, wenn man irgendwann lange schwarze Haare zwischen den Fingern hat und selber blond ist.</p>\n"}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	module.exports = {"title":"Berlins bestes Franzbrötchen","date":"2016-02-25 12:20:39 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2016/Feb/franzliberda.JPG\" alt=\"franzliberda\"></p>\n<p>Hallo, mein Name ist Ada Blitzkrieg und ich habe den ganzen Winter nichts anderes getan außer langweilige Serien zu gucken, eine unmenschliche Menge Franzbrötchen zu essen und mich durch alle Bäckereien der Stadt zu probieren. Sprich, ich hatte eine aufregende Zeit.</p>\n<p>Ich bin Foodblogger und zudem bekennenender Stoner. Mein Herz schlägt für einfaches Straßenessen mit wenig Schnickschnack und gut Wumms. Backwaren fetzen, das weiß jeder! Für mich stehen dabei Low-Budget und alltagstaugliche Produkte im Vordergrund, die sich jeder leisten kann. Damit fielen natürlich einige exzellente Coffeeshops flach, bei denen die Brötchen mehr als 1,50 Ocken kosten. Vielleicht starte ich eine zweite Runde und werde die etwas höherpreisigen Hefeklopper in einem epischen Blogartikel gegeneinander antreten lassen. Wir werden sehen. Wir werden sehen… Aber genug geredet, hier die Franzbrötchen-Ergebnisse:</p>\n<h3>Kettenware: Schäfer’s</h3>\n<p><img src=\"/content/images/2016/Feb/franzschaefers.jpg\" alt=\"alt\"></p>\n<p>Kostet 1,25€ und kommt total klassisch daher. Etwas überraschend, denn eigentlich hatte ich mir von einer Kette mit zugegebenermaßen total lieblos gestalteten Filialen etwas weniger erhofft. Ich halte also die erste gelungene Überraschung des Tages in meinen Händen. Ein Franzbrötchen, schön basic gebacken mit Zimt und Zucker. Innen herrlich weich, wie es sein muss. Die Knusprigkeit ist ein bißchen durch den Zucker am Rand gegeben. Punktlandung. Gar nicht so übel. Ein tolles Franzbrötchen für den kleinen, kaffeelosen Snack zwischendurch.\nWertung (8/10) und zu finden hier: <a href=\"http://www.schaefers-brot.de/\">Schäfer’s Filialen</a></p>\n<h3>Leicht wurstig: Steinecke</h3>\n<p><img src=\"/content/images/2016/Feb/franzsteinecke2.jpg\" alt=\"alt\"></p>\n<p>Steinecke verschleudert seine Franzbrötchen für 1,20€ und ist damit der zweitbilligste Ticker im Blitz-Test. Kleiner Nachteil der Backwaren: In der Filiale am Marheinekeplatz schmecken die Franzbrötchen manchmal leicht wurstig, was vermutlich daran liegt, dass sie gemeinsam mit Käse-Schinken-Laugenstangen gelagert werden und ein paar Stunden zusammen die gleiche Luft atmen. Eine Vermutung meinerseits. Für Vegetarier nicht so schön. An manchen Tagen schmecken sie aber auch ganz normal. Aber wer will schon ständig wechselnde Qualität und unerlässlichen Nervenkitzel? Für mich sind die Brötchen alles in alem die großen Testverlierer. Denn neben dem abgedrehten Wursttaste, bestehen sie zudem aus einer hohen Menge geschmacksarmen Marzipan, was eigentlich auch okay ist, aber meiner Franzbrötchenpräferenz (möglichst hefig und schön clean nur mit Zimt und Zucker) nicht im Geringsten entspricht.\nWertung (5/10) und zu finden hier: <a href=\"http://steinecke.info/index.php\">Steinecke Filialen</a></p>\n<h3>Die Bio-Wackersteine: Beumer &amp; Lutum</h3>\n<p><img src=\"/content/images/2016/Feb/franzbeumer.jpg\" alt=\"alt\"></p>\n<p>Zuerst die gute Nachricht, denn Beumer &amp; Lutum ist eine hervorragende Bio-Bäckerei aus Berlin, die Filialen in ein paar Kiezen (kreuzberglastig) vorzuweisen hat. Die Qualität stimmt hier eigentlich immer und über das Brot kann man nicht meckern. Ebenso über den herrlichen Cranberry-Stollen, den ich mir dieses Jahr im Rahmen meiner Ich-verbringe-Weihnachten-mutterseelenalleine-Haftigkeit innerhalb von zwei Stunden komplett einverleibt habe. Die Franzbrötchen haben eine krass leckere karamellisierte Zuckerkruste zwischen den Hefeschichten. Allerdings trifft dieses Zuckerwunder auf einen knüppeltrockenen Hefeteig, der sich nach dem Essen wie ein Wackerstein im Bauch anfühlt. Schade! Vielleicht hatte die Bäckerei auch nur einen schlechten Tag, aber ich lasse keine Gnade walten, denn die Konkurrenz schläft ja bekanntlich nicht. Ich empfehle daher: Lieber hier die Zimtschnecken kaufen. Die können nämlich was.\nWertung (6/10) und zu finden hier:<a href=\"http://www.beumer-lutum.de/\">Beumer &amp; Lutum Filialen</a></p>\n<h3>Knackig: CUCCIS</h3>\n<p><img src=\"/content/images/2016/Feb/franzcucis.jpg\" alt=\"alt\"></p>\n<p>CUCCIS nervt mich total. Was für ein Backwaren-Abfuck! Das fängt schon beim bloßen Betrachten der irren Homepage an und hört an den nervigsten Verkaufsorten der Welt auf: Bahnsteige. Ich hasse sie. Die Filialen befinden sich ausschließlich auf Berliner S-Bahnsteigen und das suckt gewaltig. Ich musste also am Testtag erst mit dem Rad dorthin fahren, und das obwohl sich mein Körpergewicht in den letzten Stunden seit dem Franzbrötchen-Testbeginn quasi vervierfacht hat. Mutig marschiere ich die Treppen (nicht gerade wenige) zum Verkaufsstand hoch und kaufe mir gleich zwei Stück, weil ich ja auch mit dem Rad gekommen bin und sich diese Tortur nun auch irgendwie lohnen soll. Man weiß ja nie. Den Preis vergesse ich natürlich, denn mir ist die Hektik hier derart zuwider, dass ich permanent gegen meinen Fluchtinstink ankämpfen muss. Ich zahle vermutlich irgendwas um die 1,50€, kauere mich vor dem Bahnhofsgebäude in der Hocke auf den Boden, betrachte die Polizeistreifen (Gesundbrunnen) und stecke mir das erste CUCCIS Franzbrötchen in den Mund. Gar nicht schlecht. Fuck, anders wäre mir lieber gewesen! Wenn auch überraschend unhefig im Geschmack, was mich dieses Mal gar nicht so stark zu irritieren scheint. Schöne Layer, knusprig, ohne dabei hart zu sein. Ein bisschen trocken, aber eher die gesellschaftlich erwünschte Form von Knusperhaftigkeit. Neben Zimt und Zucker spielt hier nichts eine Rolle. Ein Überraschungsfund.\nWertung (8/10) und zu finden hier:<a href=\"http://www.cuccis.de/\">CUCCIS Filialen</a></p>\n<h3>Auch gut: Die türkische Eckbäckerei in jedem Kiez</h3>\n<p><img src=\"/content/images/2016/Feb/franz3.JPG\" alt=\"alt\">\nIn den Folgestunden habe ich mich dann durch sämtliche Bäckereien in Kreuzberg gekauft. Kaum zu glauben, denn ich hatte immer noch Hunger. Franzbrötchen kosten bei den türkischen Aufbackstuben hier selten mehr als einen Euro, was total okay ist, denn die Qualität reicht an die anderen Franzbrötchen im Test nicht wirklich ran. Hier findet man keinen Zimt-Zucker-Knusper, ebenso wenig wie einen nennenswerten Eigengeschmack. Da ich aber Fan von diesen Bäckereien bin (eher Sesamkringel und ähnliches kaufen!) und der Preis mit Abstand der niedrigste im Test war, fällt mein Fazit fair aus. Diese Franzbrötchen sind okay gebacken, etwas langweilig aber für den kleinen Geldbeutel immer noch schön sättigend.\nWertung (5/10) und zu finden überall.</p>\n<h3>Machbar und klassisch: Alnatura</h3>\n<p><img src=\"/content/images/2016/Feb/franz1.JPG\" alt=\"alt\">\nEin Mittelfeld-Franzbrötchen. Simpel. Lecker. Gefunden habe ich das gute Stück in der Alnatura Filiale im Bergmannkiez, die eine kleine angeschlossene Bäckerei beherbergt. Das Brötchen war frisch und im Laden roch es sogar noch nach Zimt. Okay weich. Hefig auch. Check! Und eine schöne Zucker-Zimt-Masse im Innenteil, die zwar nicht knusprig war, aber sehr gut abgestimmt daherkam.\nWertung (7/10) und zu finden hier:<a href=\"http://www.alnatura.de/de-de/alnatura-maerkte/alnatura-filialen-detailseiten/b/berlin-alnatura-super-natur-markt-b061\">Alnatura Filialen</a></p>\n<h3>And the winner is: Backhaus Liberda</h3>\n<p><img src=\"/content/images/2016/Feb/franzliberda.JPG\" alt=\"alt\">\nHier könnte ich viele Worte verlieren. Vielleicht wäre interessant zu erwähnen, dass ich in den Wochen nach dem Test, der eigentlich im Dezember stattfand, immer wieder dorthin schlich und mir fast tageweise ein Franzbrötchen, manchmal auch zwei oder drei kaufte, weil es mir schlichtweg so gut schmeckte. Der Tipp für diese Bäckerei kam von jemandem, den ich nichtmal kannte, der aber scheinbar hier auch im Kiez wohnte. Thanks, Typ! You made me fat!\nZu den Fakten: Mein absoluter Favourite, denn hier stimmt absolut alles. Hefiger Teig, schöne Layer, das Brötchen bewegt sich irgendwo zwischen teilweise knaick, teilweise butterweich, mit einer kleinen Menge Puderzucker und einem richtig gut abgeschmeckten Zimt-Innenleben. Leider gehen die Teile weg wie - Achtung - geschnitten Brot (LOL!) und der Laden ist immer so ab 14 Uhr am Nachmittag hoffnungslos franzbrötchenlos. Was ich skandalös finde. Vielleicht gleich mal ansprechen im Laden, denn ich geh jetzt los und hau mir noch eins rein…\nWertung (9/10) und zu finden hier: <a href=\"https://de.foursquare.com/v/backhaus-liberda/4f2a54fae4b05b4a409236d3\">Backhaus Liberda im Bergmannkiez</a> und\n<a href=\"https://de.foursquare.com/v/backhaus-liberda/4d85e9d440a7a35dae2a2abe\">im Reuterkiez</a></p>\n"}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

	module.exports = {"title":"Beschauliches Berlin","date":"2011-10-10 14:47:18 +0000","tags":null,"layout":"post","body":"<p>\n\tDer letzte schöne Tag dieses Jahr. Die Sonne schmilzt mal eben mein Gesicht weg und wir entschliessen uns eine kleine Safari ins direke Umland der Innenstadt zu wagen. Was ist eigentlich dieses &quot;beschauliche Berlin&quot; von dem RTL bei Schwiegertochter Gesucht immer spricht? Was <a href=\"http://de.wikipedia.org/wiki/Martin_Sonneborn\">Martin Sonneborn</a> schon für seinen Doukmentarfilm <a href=\"http://www.heimatkunde-der-film.de/\">Heimatkunde</a> 2008 wagte, 18 Jahre nach Wiedervereinigung, soll für heute unsere größte Herausforderung werden.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tUnser Safariwagen ist offen und für den absoluten Notfall haben wir Zigaretten und Schokolade mit um die aufgebrachten Einheimischen zu besänftigen. </p>\n<p>\n\t&nbsp;</p>\n<p>\n\tSowieso episch: Berlin. Diese Weltmetropole. Mitten im Nichts. Nicht mal Nichts. Brandenburg. Fährt man am Stadtrand entlang, kann man Brandenburg schon spüren. Durch und durch. Nach Tanztees und Landgasthäusern, Deutschlandflaggen, Randbezirken und Schrebergärten, fand sich Glückseeligkeit.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDie Tour: Friedrichshain - Rummelsburg - Köpenick - Mahlsdorf - Hellersdorf - Marzahn - Eiche - Wartenberg - Malchow - Heinersdorf - Pankow - Reinickendorf - Spandau - Potsdam - Großbeeren - Blankenfelde - Schönefeld - Friedrichshain</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/tn_IMG_9382.JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/tn_IMG_9405.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tKaum haben wir die innere Stadtgrenze Berlins verlassen, biedern sich uns Hundertschaften von mobilen Rentnern auf Rollatoren, Caddies und sonstigen fahrbaren Altentransporten an. Hier muss niemand mehr laufen. Wie vesprochen ist hier alles beschaulich. Die Rentern leben nicht in Armut. Hier besteht kein Handlungsbedarf. Rentnerland. Wir wurden Zeuge eines illegalen Krankenfahrstuhlrennens.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/tn_IMG_9413.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWas hier gut läuft: Nagelstudios, Fettkliniken, Tattoostudios. Nahezu 90% der Bevölkerung sind hier beschäftigt um dem NPD-Vorstand French Nails zu machen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/tn_IMG_9417.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tPferde sind niemals Kunst, Randbezirke!&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/tn_IMG_9419.JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/tn_IMG_9429.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDie Menschen hier sind relativ einfach gestrickt. Man weiß nie so recht wo vorne und wo hinten ist, deshalb kommt es teilweise zu unangenehmen Sitiuationen, wenn man durch Klickgeräusche mit den Einheimischen Kontakt aufnehmen will.</p>\n<p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/tn_IMG_9447.JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/tn_IMG_9450.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tGroßes Bockbierfest oder die 90er MEGA PARTY mit Brooklyn Bounce auf der Trapprennbahn? Man möchte sich nicht entscheiden müssen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/tn_IMG_9464.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEin ansehnliches Potpourri der Sozialschichten: Global hinterm Kastanienwäldchen. Dazu wird Gardinenhaus Rybicki gereicht.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/tn_IMG_9471.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWow, der Laden in Reinickendorf hat zwar eine moralisch extrem unmögliche Kombination aus einer Nationalflagge mit dem Salonnamen &quot;HAAR WERT&quot; in Nazifarben, aber er ist immerhin klimatisiert. In der Peripherie kein Standard.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/tn_IMG_9491.JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/tn_IMG_9524.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tPotsdam: Wir lauerten einem Cabrio-Doppeldecker &quot;Historische Stadtrundfahrt Potsdam&quot; mit K.I.Z. und einem übersteuerten Verstärker auf. Wahrscheinlich das Highlight dieser Fahrt. Peter Pan Syndrom? Einige Minuten später wurden wir dann wieder venünftig und ich schloß endlisch mein Handy mit der Gun-App an den Verstärker an, um das Teil dann voll aufzudrehen und mit dem Cabrio und Maschinengewehrgeräuschen ein soziales Drive-By-Shooting an Passanten zu verüben.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tSchönefeld. Neben einer Menge Müll, der genau in der Einflugschneise des Flughafens lag, gab es noch einen extra für uns platzierten Bürostuhl, von dem aus wie entspannt beobachten konnten, wie EasyJet direkt über uns britische Touristen ins Berghain deportiert.</p>\n"}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

	module.exports = {"title":"Best of re:publica 2015","date":"2015-05-08 15:51:49 +0000","tags":null,"layout":"post","body":"<p><img src=\"https://igcdn-photos-d-a.akamaihd.net/hphotos-ak-xpt1/t51.2885-15/11203211_1581490325459579_181232064_n.jpg\" alt=\"alt\"></p>\n<p>Die <a href=\"https://re-publica.de/\">re:publica 2015</a> ist also vorbei. Also glaube ich zumindest, denn ich bin gestern noch vor dem Ende der Veranstaltung und des Schlusswortes vollkommen reizüberflutet geflüchtet um meinen Stresspegel mit einem Bacon-Chicken Burger bei <a href=\"http://piris-chicken.com/\">Piri Chicken</a> in Kreuzberg wieder auf Level zu bringen. Das “Netz” ist ohnehin voll mit Erfahrungsberichten der “Netzgemeide”, also habe ich mich dazu entschlossen einfach meine Lieblingstalks zu sammeln und euch als kleine Liste zur Verfügung zu stellen und euch mit Insidern und Gefühlsduselei in Ruhe zu lassen. Nett von mir.</p>\n<p>Wer also Lust auf ein paar interessante Talks und Panels hat, der möge sich bitte folgende Aufzeichnungen geben:</p>\n<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/zbpYwifm7oQ\" frameborder=\"0\" allowfullscreen></iframe>\n<p><a href=\"https://twitter.com/neinquarterly\">Nein Quarterly</a> about a culture of negation, German humor and cubistic avatars.</p>\n<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/Ji8JrpeuHfM\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Journelle gibt Einblicke in Beziehungen, Funktionales und Dysfunktionales. There’s a paradigmenwechsel, baby!</p>\n<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/l8tTRgTqLn8\" frameborder=\"0\" allowfullscreen></iframe>\n<p>“ESA-Astronaut Alexander Gerst lebte und arbeitete von Mai bis November 2014 im Rahmen seiner “Blue Dot”-Mission auf der Internationalen Raumstation ISS. Als @astro_alex begeisterte er viele Menschen mit faszinierenden Fotos und Videos der Erde.”</p>\n<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/cW2WLGloftk\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Leider wegen Burgeraufnahme verpasst. Macht aber nichts. Ich darf gerade ohnehin nichts trinken und als Video sehr angenehm.</p>\n<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/j8PFc99q0Sw\" frameborder=\"0\" allowfullscreen></iframe>\n<p>“How computation is being used to address cutting edge problems in astrophysics.”</p>\n<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/Vx9-8hNbjkI\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Anne Wizorek über verantwortungsvolles Internet, Hate Speech und “Meinungsfreiheit”.</p>\n"}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	module.exports = {"title":"Bildung gegen Langeweile","date":"2012-11-01 00:00:00 +0000","tags":null,"layout":"post","body":"<p><a href='http://www.instructables.com/id/Kaosduino-Create-your-own-kaosillitaor/'><img src=\"/content/images/kaos.jpg\" alt=\"kaos.jpg\" /></a></p>\n<p>Es ist Herbst. Manchmal sitze ich einfach nur so da und denke noch nicht einmal mehr nach, sondern starre nur und sitze. Ich starre nur auf mich, auf meine Fehler und auf meine Leere. Mein Horizont reicht gerade bis zur Fernbedienung. Was kann man dagegen tun? Gestaltet Eure Leere!</p>\n<p>Die neuste Ausgabe der <a href=\"http://www.neon.de/magazin/2012/11/940659\">NEON</a> hat im Rahmen des Artikels “Stanford auf dem Sofa” Links zu Vorlesungs- und Seminarvideos unterschiedlicher Universitäten, Experten und Fachrichtungen veröffentlicht.</p>\n<p>Ich möchte ebenfalls meine Lieblinge im Blog vorstellen. Mehr Bildung für den Herbst!</p>\n<p><a href=\"http://www.codecademy.com/de#!/exercises/0\"><img src=\"http://cdn.codecademy.com/assets/homepage/badges-aa2a01ba2930b6d9850b5e1d8a4954f6.png\" alt=\"Codeacademy\" /></a></p>\n<p>Bei <a href=\"http://www.codecademy.com/#!/exercises/0\">Codeacademy</a> kann man interaktiv HTML, CSS und javascript programmieren lernen.</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/BnIJ7Ba5Sr4\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Sebastian Thun &amp; Peter Norvig referieren in Stanford über <a href=\"https://www.ai-class.com/\">künstliche Intelligenz</a>. Eine Sammlung des Seminars.</p>\n<p>Der Verhaltensbiologe <a href=\"http://www.youtube.com/watch?v=NNnIGh9g6fA&feature=related\">Robert Sapolsky</a> dreht den Swag auf. (Die YouTube Videos des Stanford Channels sind gerade kaputt, wird vermutlich aber gleich wieder online stehen.)</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/NNnIGh9g6fA\" frameborder=\"0\" allowfullscreen></iframe>\n<p><a href=\"http://www.instructables.com/id/Glass-Potato-Chips/\"><img src=\"/content/images/glass.jpg\" alt=\"glass.jpg\" />\n</a></p>\n<p>Die Seite <a href=\"http://www.instructables.com/\">Instructables</a> macht mit Milliarden DIY Anleitungen, Fotos, Videos und Kommentaren tierisch Lust auf zum Beispiel <a href=\"http://www.instructables.com/id/Glass-Potato-Chips/\">Glass Potato Chips</a>, einen eigenen <a href=\"http://www.instructables.com/id/Kaosduino-Create-your-own-kaosillitaor/\">Kaosillitaor</a> oder <a href=\"http://www.instructables.com/id/How-to-Divide-1/\">Dividieren</a>.</p>\n<p>Diese Frau prügelt uns frontal Grundwissen über Biologie und Anatomie in Berkeley (Ihgitt!) ein. Sehenswert und verliebt sein!</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/S9WtBRNydso\" frameborder=\"0\" allowfullscreen></iframe>\n<p>In der <a href=\"http://www.noexcuselist.com/\">No-Excuse List</a> finden sich weitere Vorschläge zur Selbstbildung.</p>\n<p><a href=\"http://www.ikeahackers.net/2012/10/spicing-up-bedroom-with-killer-headboard.html?utm_source=BP_featured\"><img src=\"/content/images/ikea.jpg\" alt=\"ikea.jpg\" /></a></p>\n<p>Die <a href=\"http://www.ikeahackers.net/\">IKEA Hacker</a> zeigen perfekte Hacks für IKEA Möbel und Birkenfurnierlangeweile.</p>\n<p>Oder einfach nochmal das Grundwissen in “<a href=\"http://www.musictheory.net/\">Musictheory</a>” auffrischen?</p>\n<p>Das <a href=\"http://www.gutenberg.org/catalog/\">Project Gutenberg</a> bietet legal tausende Ebooks und Dokumente zum Lesen an.</p>\n<p>BBC bietet kostenlose <a href=\"http://www.bbc.co.uk/languages/\">Onlinekurse</a> zum Sprachenlernen an.</p>\n"}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	module.exports = {"title":"Blitzkrieg lesen? Den vierten Affen bestellen!","date":"2014-05-08 13:23:02 +0000","tags":null,"layout":"post","body":"<img src=\"http://audiolith.net/images/stories/virtuemart/product/1793AL216Book.jpg\">\n<p>Ich bekenne mich schuldig, ich publiziere meinen eigenen Schätzungen nach zu urteilen viel zu selten. Das hat natürlich Gründe, von denen ich normalerweise zwei Mal die Woche meinem Psychologen berichte. Gut, dass ab und zu mal ein paar talentierte Jungs des Weges kommen und mich zum Schreiben animieren. Ob ich Lust hätte für die Band Supershirt einen Text zu wursten? Klar, hatte ich. Und selbstredend ist er wunderbar geworden und findet sich im Begleitbuch zum aktuellen Album <a href=\"http://audiolith.net/de/shop/supershirt.html\">“Der vierte Affe”</a>. Das Beste an der Sache? Ihr könnt es <a href=\"http://audiolith.net/de/shop/supershirt.html\">käuflich erwerben</a> und dann ganz fest an Euch pressen.</p>\n<p><img src=\"http://teitmaschine.de/wp-content/gallery/galerie2011/supershirt_2011_03_andreas_chudowski.jpg\" alt=\"Der vierte Affe\"></p>\n<p><em>“Wörter zu Pflugscharen, Texte zu Texten. Im Buch kommen Autoren und Freunde zu Wort, die die Lyrics der Supershirt-EP interpretieren, das Werk oft nicht unkritisch hinterfragen oder Geschichten aus dem Band-Leben erzählen. So wird zum Beispiel eine Sternstunde der Band  die Konzerte bei Hurricane und Southside Festival 2012  endlich realistisch als absurder Trip in einem viel zu kleinen Wohnmobil erzählt. Dazu erscheinen Stücke von Linus Volkmann, Susanne Heinrich, Felix Scharlau und vielen anderen.”</em></p>\n<p><strong>Mit dabei?</strong></p>\n<h1>Natürlich Supershirt</h1>\n<h1>Vier Affen</h1>\n<h1>Felix Scharlau</h1>\n<h1>Linus Volkmann</h1>\n<h1>Ada Blitzkrieg</h1>\n<img src=\"http://teitmaschine.de/wp-content/uploads/2014/03/supershirt-affe_2014.jpg\">\n<p>Hier kann man das <a href=\"http://audiolith.net/de/shop/supershirt.html\">Buch und das Album bestellen</a></p>\n"}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

	module.exports = {"title":"Blutgrätsche in die Homophobie","date":"2013-04-02 00:00:00 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/wirsindfamiliefrittenbude.jpg\" alt=\"wirsindfamiliefrittenbude.jpg\" />\n<p><a href=\"http://www.manuel-braun.com/\">Manuel Braun</a> ist nicht nur ein Tausendsassa wenn es um Kunst, Fotografie und Theater geht, nein, der junge Regisseur sorgt derzeit auch mit seiner selbst ins Leben gerufenen Initiative <a href=\"http://www.wirsindfamilie.eu/\">“Wir sind Familie”</a>, die sich für die rechtliche und gesellschaftliche Gleichstellung homosexueller Partnerschaften einsetzt, für frischen Wind in einer zugegebenermaßen ziemlich verkalkten Diskussion. Bisher haben sich bereits namhafte Künstler und Kreativschaffende wie <a href=\"http://www.wirsindfamilie.eu/?p=93\">Thees Uhlmann</a>, <a href=\"http://www.wirsindfamilie.eu/?p=50\">Judith Holofernes</a> von Wir sind Helden und die Band <a href=\"http://www.wirsindfamilie.eu/?p=58\">Frittenbude</a> an der Aktion beteiligt und werben mit klaren Statements für mehr Aufklärung und eine Öffnung der Institution Ehe und Familie gegenüber gleichgeschlechtlichen Paaren.\nWer dieser Manuel eigentlich ist, wie es sich als Homosexueller so in Bayern lebt und warum seine Initiative mit Sicherheit erfolgreich sein wird, erfahrt Ihr im Interview:</p>\n<img src=\"/content/images/wirsindfamiliemanuel.jpg\" alt=\"wirsindfamiliemanuel.jpg\" />\n<p><strong>Hallo Manuel, du bist der Initiator der Aktion “Wir sind Familie”, die gerade auf Facebook und Twitter das Geschehen rund um homophob-konservative Politiker und die politische Diskussion zur Öffnung der Ehe und Familie für gleichgeschlechtliche Paare aufmischt. Warum kotzt dich eigentlich die Debatte eigentlich so an?</strong></p>\n<p>Ich hatte das Glück in einer Zeit und einem sozialen Umfeld groß zu werden, das mir nie das Gefühl gab, anders oder sogar benachteiligt zu sein. Natürlich kannte ich die Rechtslage, doch hatte ich stets das Gefühl inne, mir stehen die gleichen Möglichkeiten zur Option wie sie auch meinem besten heterosexuellen Freund zustehen. Erst seit kurzem, seitdem die Bundesregierung und die Öffentlichkeit darüber diskutiert, ob ich einmal heiraten und Kinder großziehen darf oder nicht, stößt mir die Sache auf. Dabei habe ich gemerkt, wie mich unsere Regierung zu einer Person zweiter Klasse macht. Sie sagt &quot;Hey, Manu, wir respektieren dich, alles supercool wie du bist, aber glaub ja nicht, du hättest die gleichen Rechte wie wir, wo kämen wir dahin, wenn wir einem wie dir erlauben…&quot;\nUnd genau damit stellen sie mich und alle anderen eine Stufe tiefer. Und das ist ungleich. Das ist gegen die Verfassung und das muss behoben werden.</p>\n<p><strong>Erkläre uns doch in ein paar Worten den aktuellen Stand der Dinge! In welchen Bereichen werden homosexuelle Pärchen auch heute noch benachteiligt?</strong></p>\n<p>Aktuell liegen die großen Benachteiligungen in der Adoption und im Steuerrecht. Wir fordern aber keine schrittweise Sonderlösung mit Sondergesetzen. Denn wir sind kein Sonderfall, der Sonderbehandlung braucht, wir sind nicht krank. Wir wollen die komplette Gleichstellung der Ehe. Um es einfach zu sagen, kein Unterschied zwischen einer heterosexuellen und homosexuellen Ehe.</p>\n<p><strong>Du wohnst in einem kleineren Ort in Bayern. Wie lebt es sich denn ausgerechnet in diesem Bundesland als homosexueller Mann? Lebst du mit deinem Freund zusammen?</strong></p>\n<p>Wir leben in München und haben aber auch ein kleines Haus in meinem Heimatort geerbt. Und dort lebt es sich ganz wunderbar. Ich habe dort die meiste Zeit meines Lebens verbracht. Ein Ort ohne Ampel aber mit einem Großteil meiner besten Freunde und Angehörigen in Laufweite. Wie ich eingangs bereits sagte, ich hatte großes Glück mit meinem sozialen Umfeld. Meine Freunde und Familie bildeten immer eine kleine rebellische Insel in einem Ort, dessen Stimmen mit knappen 90% an die CSU gehen. Mein großes Glück war es aber, als Jugendlicher zusammen mit Freunden eine illegale Kneipe im Ort eröffnet zu haben, mit allem drum und dran. Ich saß dadurch auf dem Alkoholmonopol, da alle anderen Lokalitäten kilometerweit entfernt waren und der letzte Nachtbus um zwei Uhr zurück ins Dorf fuhr, ich hingegen machte erst um sieben Uhr Sperrstunde. Wer trinken wollte, und das wollen sie alle, der musste zu mir. Der musste also auch ein bisschen nett sein. Zumindest kam er nicht drum herum, mich wahr zu nehmen, mit mir zu sprechen, mich kennen zu lernen, um dann fast immer festzustellen, dass ich nicht wirklich anders bin.\nDie meisten Vorurteile entstehen in der Blase, die sich in der Distanz zwischen Menschen bildet, sobald sie einen Berührungspunkt haben, platzt diese meist ganz schnell. Und für die ganz harten Fälle gab es meine beste Freundin, der alle den Hof machten, die hat denen dann ordentlich in die Eier getreten. Also im wörtlichen Sinne. Das trifft so ein bayerisches Männerego dann doch hart. Das war eine schöne Zeit. Man braucht aber auch eine gute Portion Humor,  man muss auch mal über sich selbst lachen können. So ein Mensch ist doch meist was selten komisches.\nJedenfalls habe mir schnell sehr viel Respekt und Sichtbarkeit verschafft und fühle mich hier sehr wohl. Und dass ich jetzt heute von Zeit zu Zeit auch noch wegen meiner beruflichen Laufbahn positiv in der Zeitung erwähnt werde, irritiert dann auch die letzten alten Stammtischherren. Alles wird hier akribisch beäugt und ich liebe es für ein wenig Irritation in ihren Köpfen zu sorgen. Ganz nach dem Motto Herbert Achternbuschs - ein bayerisches Regie-Urgestein, Idol, Sturkopf, Rebell, der meint: “Diese Gegend hat mich kaputt gemacht und ich werde solange bleiben, bis man ihr das auch anmerkt.”</p>\n<p><strong>Möchtet ihr Kinder haben?</strong></p>\n<p>Ja gerne. Charlie Braun und Calendula Physalis. Scherz, die Namen stehen natürlich noch nicht fest. Aber ja, wir hätten gerne Kinder, und ich lasse es mir von niemanden verbieten meine Luftschlösser zu bauen, und eines Tages werden diese auch konkret werden. Ich persönlich konnte und kann mir ein Leben ohne Familie nicht vorstellen. Ich habe einfach richtig viel Lust auf dieses wunderbare Abenteuer.</p>\n<p><strong>Was unterscheidet den Alltag eines gleichgeschlechtlichen von dem eines heterosexuellen Paares und wie würde ein Kind in diesen Alltag passen? Wäre das Familie?</strong></p>\n<p>Der Alltag unterscheidet sich nicht von anderen. Das ist der gleiche wunderschöne Wahnsinn wie woanders auch.\nMit den gleichen Fehler, den gleichen unvergesslichen Momenten. Wir sind alle nur Menschen.\nJedoch gibt es einen Unterschied gegenüber heterosexuellen Paaren. Es gibt keine ungeplante Schwangerschaft.\nJedes unserer Kinder ist ein absolutes Wunschkind. Die Rahmenbedingungen werden ja gerade bei einer Adoption genau geprüft.Das Kind wird also in eine Familie geboren, die für sie Sorgen kann. Die Platz hat für dieses Leben, eine Familie, die da sein kann.</p>\n<img src=\"/content/images/wirsindfamilie1.jpg\" alt=\"wirsindfamilie1.jpg\" />\n<p><strong>Welche Probleme sehen die Gegner einer Öffnung von Ehe und Familie für homosexuelle Menschen?</strong></p>\n<p>Ich bin verdammt froh, diese Kampagne nicht in Amerika machen zu müssen, dort muss man nämlich auch noch gegen die fundamentalen Christen und ihren Bezug auf die Schöpfung und die Bibel ankämpfen. Dieses Problem haben wir hier in Deutschland nicht so sehr. Hier hat man - wer auch immer “man” eigentlich ist, ich glaube gar nicht dass so viele Menschen wirklich ein Problem damit haben - jedenfalls hat irgendjemand dann doch die Angst die Gesellschaft würde aussterben, die Ehe würde ihren besonderen Schutz verlieren und das Wohl des Kindes sei gefährdet. Das sind im wesentlichen die drei Punkte mit denen wir es in Deutschland zu tun haben.</p>\n<p><strong>Diese Argumente sind für rational denkende Menschen einfach nur völlig bescheuert.</strong></p>\n<p>Hahah, ja. Aber lass es mich dennoch noch einmal klarstellen: Die Gesellschaft stirbt nicht aus, wenn man Menschen ermöglicht Familien zu gründen. Welchen besonderen Schutz eine Ehe genießt, bei der ich morgen eine mir völlig unbekannte, zufällige Frau von der Straße heiraten könnte, aber nicht meinen jahrelangen Freund, ist mir eh nicht ganz klar. Und jeder der Angst hat, Kinder würden ohne beide Geschlechter als Elternteil völlig unbrauchbare Monster werden, der denkt bitte mal an all die alleinerziehenden Menschen, die er damit beleidigt.</p>\n<p><strong>Hast du eine Illusion von einer schöneren Gesellschaft? Wie würde diese aussehen und was unternimmt deine Aktion “Wir sind Familie” um das zu erreichen?</strong></p>\n<p>Im Internet sind die Fronten ziemlich verhärtet. Homoehe-Befürworter beschimpfen Konservative als Hinterwäldler und Konservative schreien um Hilfe weil sie Angst haben die Homos wollen die Keimzelle der Gesellschaft zerstören. Dann wird sich wild beleidigt und gebracht hat es nicht viel. Und da grätschen wir mitten rein, mit ganz viel Liebe. Konfrontation ist gut, bis zu einem Gewissen grad, ab dann erzeugt Hass nur noch mehr Hass und wir drehen uns im Kreis.  Wir wollen sagen “Hey, wir sind da, wir gehen hier nicht mehr weg” Und das mit Geduld, Nachdruck und Liebe. Natürlich gehen wir auch auf Argumente ein. Aber versuchen wenig zu polemisieren. Und irgendwie sprechen wir damit vielen Menschen aus der Seele. Die Zeit ist einfach reif dafür, man merkt richtig was die Menschen für ein Bedürfnis nach Fairness haben. Denn genau darum geht es. Um Gleichheit.</p>\n<p><strong>Du kommentierst auf Facebook die Profile bekannter Gegner der Öffnung von Ehe und Familie der großen Parteien. Wie sind die Reaktionen?</strong></p>\n<p>Das mache ich nur als Privatperson. “Wir sind Familie” ist eine sehr herzliche und unpolemische Aktion. Vergangenen Sommer habe ich mit ein paar Mitgliedern des Bundestags ein paar Facebook-Nachrichten ausgetauscht.\nDie waren meistens sehr nett. Von den wirklichen Schreckensgestallten bekommt man da keine Antwort.</p>\n<p><strong>Warum sollten sich auch heterosexuelle Menschen für dein Projekt interessieren?</strong></p>\n<p>Das Schöne ist, dass wir mittlerweile die größte deutsche Onlinekampagne sind, die sich speziell für die komplette Gleichstellung der Ehe einsetzt. Und es ist das erste Mal, dass es dabei auf eine solch überwältigende Unterstützung der Allgemeinheit stößt. Ich glaube meine Generation unterscheidet nicht mehr. Mein heterosexueller Kumpel denkt, ey, wieso soll der Manu anders sein und nicht die Wahl haben zu heiraten wen er will, geht’s noch? Immer mehr Menschen begreifen dass es sich hier um ein generelles Problem handelt. Dass wir nicht weiter in einer Gesellschaft leben wollen, die ungleich behandelt. Das wir nicht weiter mit einer Politik leben wollen, die entgegen der Verfassung Menschen diskriminiert.</p>\n<p><a href=\"http://www.wirsindfamilie.eu/\"><img src=\"/content/images/wirsindfamilielogo.jpg\" alt=\"wirsindfamilielogo.jpg\" /></a></p>\n<p><strong>Wie kann man sich engagieren?</strong></p>\n<p>Das geht im Alltag los, man muss wach sein und darf nicht müde werden, Leuten genau zu zuhören und ihnen ihre Ansichten widerspiegeln. Homophobe Äußerungen nicht länger tolerieren. Es geht um Toleranz und Gleichberechtigung und darum, diese zu vertreten und zu Leben und zu allererst bei sich selbst anzufangen. Seine eigenen Ansichten und Verhaltensmuster überdenken. Ich weiß nicht, was es mit dem Wort “Gutmensch” auf sich hat und warum es so negativ konnotiert ist, ich glaube es sagt, man soll sich einfach nicht Scheiße benehmen, und das finde ich eigentlich ziemlich gut.\nFür “Wir sind Familie” kann man sich stark machen, indem man die Leute auf die Aktion aufmerksam macht. Das geht mit einem “gefällt mir” auf unserer <a href=\"https://www.facebook.com/wirsindfamilie\">Facebookseite</a> los, und endet dabei dass man uns bei der Suche nach bekannten Pappnasen, wie Bands, Schauspielern, Autoren und so weiter, unterstützt, die sich gerne für die Sache stark machen. Das wäre super. Danke Ada für das Interview, es war mir wie immer ein verrücktes Geburtstagsfest!</p>\n<p><strong>Alles Liebe und viel Erfolg!</strong></p>\n"}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

	module.exports = {"title":"Romane von Ada Blitzkrieg","date":"2014-07-24 12:30:31 +0000","tags":null,"layout":"post","body":"<p><a href=\"http://textkrieg.de/dackelkrieg/\">DACKELKRIEG - Ein Roman von Ada Blitzkrieg</a>\n<a href=\"http://textkrieg.de/dackelkrieg/\"><img src=\"http://textkrieg.de/content/images/2014/Sep/cover-1.jpg\" alt=\"alt\"></a></p>\n<p><a href=\"http://textkrieg.de/die-strenge/\">DIE STRENGE - Ein Leseheft von Ada Blitzkrieg</a></p>\n<p><img src=\"/content/images/2015/Jan/strenge-2.jpg\" alt=\"alt\"></p>\n"}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

	module.exports = {"title":"Born in 1985","date":"2014-08-22 09:33:50 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2014/Aug/spice.JPG\" alt=\"alt\"></p>\n<p>Rollschuhe waren in diesem Sommer schon lange out und galten vielmehr als ein Fortbewegungsmittel für unsere kurzhaarigen Reformhausmütter, wenn sie sich nach zwei Weißweinschorlen in einem ausmaßenden, alljährlichen Anfall zu Frühlingsbeginn ihrer noch vorhandenen Sportlichkeit rückversichern mussten. Man ernährte sich ausschließlich von den runden, in Staniolfolie eingewickelten Kügelchen aus den Automaten, die behaupteten “Bubble Gums” zu sein und doch nur den Darm verstopften. 5 Pfennige. Die Sonne ballerte. Im Schwimmbad musste ich wegen meiner hellen Haut im Wasser ein T-Shirt tragen und wenn mich jemand tunken wollte, dann tunkte ich ihn.</p>\n<p>Amerika presste sich in uns. Musik war für uns da. NKOTB. Caught In The Act. Und in Sachen Girlbands und Frauenpower kam gerade echt was in Bewegung. Ich kaufte meinen ersten BH in der Unterwäscheabteilung des NKD. Und als die erste Deichmann Filiale Anfang der 90er Jahre in unserem kleinen Ort eröffnete, heizte ich gerade mit meinem Rollerblades auf dem asphaltierten Weg, der um den städtischen Friedhof führte, und hörte Mel B auf meinem Walkman. Einige Meter entfernt lag die Frau unter der dunklen Erde, deren Namen ich trug, und die meine Brüste nie kennenlernen würde. Clara. Zwei Weltkriege erlebt, aber sie hätte sich bestimmt über meine Klumpfüße für 20 Mark gefreut. Meine neuerworbenen Spice Girls Plateauschuhe passten mir wie angegossen. Zumal die beiden Schweinefüße in 41 noch herrlicher und furchteinflößender daherkamen als es das ohnehin schon grenzwertig billige Fabrikat an den zartbefußten Mädchen meiner Klasse tat. Ich war nun 1,82m groß. Mit 12.</p>\n<blockquote>\n<p>Yo, I’ll tell you what I want, what I really really want. So tell me what you want, what you really really want. I wanna huh, I wanna huh, I wanna huh, I wanna huh, I wanna really really really wanna zig-a-zig ahhh.</p>\n</blockquote>\n<p><img src=\"/content/images/2014/Aug/retro1.jpg\" alt=\"alt\"></p>\n<p>Ich kann mich nur wundern, dass ich nie auf die Idee gekommen bin, die aufwärmbare Bürste meiner Lil MissMagic Hair als Sexspielzeug zu benutzen. Auch sonst war ich eher ein zurückhaltendes Kind, das gerne mit Freunden in einen Eimer pinkelte und damit die Bäume und Autos der Nachbarschaft verarztete. Und auch heute noch quält mich der Gedanke daran, ob ich mit der heißen Bürste nicht nachhaltige Schäden und Spliss im Haar der kleinen Puppe hinterlassen habe. Muss sie heute etwa auch eine Kurzhaarfrisur tragen? Wie unsere Mütter?</p>\n<p><img src=\"/content/images/2014/Aug/lil-miss.jpg\" alt=\"alt\"></p>\n<p>Auch hier sehen wir noch ein Mal Lil Miss MagicHair. Selbst der Schminktisch ist züchtiger angezogen als die kleine Madame.</p>\n<p><img src=\"/content/images/2014/Aug/retro3.jpg\" alt=\"alt\"></p>\n<p>Das Barbie Mofa - wow was würde ich für so ein Teufelsgerät in Lebensgröße geben. Aber passte Barbie mit ihren langen Beinen überhaupt darauf? Und was sollte eigentlich in den Picknickkorb, wenn die Frau doch ohnehin nichts isst? Fragen über Fragen.</p>\n<p><img src=\"/content/images/2014/Aug/retro4.JPG\" alt=\"alt\"></p>\n<p>Hey Hipster, aufgepasst!</p>\n<iframe width=\"<iframe width=\"420\" height=\"315\" src=\"//www.youtube.com/embed/URRuNTfBcuY\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Die offizielle und international anerkannte Wertigkeit bei Stickern lautete immer:</p>\n<blockquote>\n<p>Obstaufkleber &lt; Plüschaufkleber &lt; Dinosaurieraufkleber &lt; Aufkleber mit 3D Effekt &lt; Glow in the Dark Aufkleber &lt; Aufkleber mit 3D Effekt und Dinosauriern &lt; Bandsticker</p>\n</blockquote>\n<p><img src=\"/content/images/2014/Aug/retro6.jpg\" alt=\"alt\"></p>\n<p>Vielleicht ist man heute ganz froh, dass Skip It’s aus der Mode gekommen sind, denn zugegeben, ich würde lieber gegen ein Kind mit einem Klappmesser (kurzer Arm, geringe Reichweite, wenig Kraft) kämpfen, als gegen ein ehrgeiziges Mädchen mit einem schnell kreisenden Skip It.</p>\n<p><img src=\"/content/images/2014/Aug/retro7.jpg\" alt=\"alt\"></p>\n<p>Eines Tages möchte ich, dass es eine Neuauflage für Jungs gibt, in der ich mit meinem Gesicht auf einer der Karten abgebildet bin und “Ich bin gerade im Snackpark und trage eine graue Jogginghose!” sage.</p>\n<p><img src=\"/content/images/2014/Aug/retro9.jpg\" alt=\"alt\"></p>\n<p>In diesem Sinne:</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/162589044&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

	module.exports = {"title":"Brotaufstrich Hiroshima","date":"2011-09-03 13:23:18 +0000","tags":null,"layout":"post","body":"<p>\n\t<img alt=\"\" height=\"345\" src=\"/files/IMG_8908.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tBrotaufstriche? Da gab es früher nur Butter und Butter mit Salz. Heute kann die Hi-Tech-Brotaufstrichindustrie einfach alles in Aufstrichform pressen &nbsp;und die Ethikkommission schaut einfach weg.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/IMG_8892.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEin Fahrradkurier brachte mir ein Paket voller Brotaufstiche. <a href=\"http://twitter.com/#!/ruhepuls\">Maike Hank</a>, Redakteurin für <a href=\"http://www.freitag.de/\">der Freitag</a> lud zum großen <a href=\"http://www.freitag.de/alltag/1135-schmeckt-das-denn\">Brotaufstrich-Test</a>. Zugegeben, etwas berattert und mitten in der Nacht begab ich mich mit dem Toaster auf geheime Mission: Brotaufstriche verköstigen. Irgendwo zwischen schrillem Wohlgefallengekreische, Panikattacken und heroischer Selbstaufgabe fanden sich sehr gute, scheißegale und hochgradig sadistische Brotaufstriche. Den ganzen Test könnt Ihr <a href=\"http://www.freitag.de/datenbank/pdf-archiv/Brotaufstriche-2011-35.pdf\">hier</a> als PDF lesen.</p>\n"}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

	module.exports = {"title":"California Reisestimmung mit Instagram Surfprints","date":"2014-04-28 09:00:00 +0000","tags":null,"layout":"post","body":"<img src='http://www.urbanara.de/3327-14531-thickbox/myan-soffia-no-189.jpg' alt=''>\n<p><em>Stop, this is commercially:</em></p>\n<p>Mich beschäftigen gerade ein paar überaus quirlige Themen, denn wie es aussieht geht es für uns im Mai los zur Wohnungssuche nach San Francisco und im Juli dann hoffentlich mit Visum zum dauerhaften Burrito-Reinbaggern und Hautkrebs bekommen. Natürlich ist es totaler Irrsinn sich vor dem Move noch Gegenstände zuzulegen, die größer als ein Päckchen handelsüblicher Schnupftabak sind, und so ist es ein denkbar ungünstiger Zufall, dass in diesem Monat gutes Wetter, Geldsegen und manische Laune aufeinandertreffen. Sprich: Ich habe es in der Tat geschafft mir vier Paar neue Sneakers zuzulegen und allerhand Kram, der nicht im Geringsten Platz in den zwei Koffern finden wird, mit denen ich in zwei Monaten am Frankfurter Flughafen mit eingetüteter Katze und Freund in die Freiheit starten werden.</p>\n<img src=\"http://www.urbanara.de/3323-14518-thickbox/myan-soffia-surge.jpg\" alt=\"\">\n<p>Daher habe ich mir überlegt, meine Reisestimmung und perfekte Laune an einige liebe Freunde weiterzuschenken. Und da ich in der Regel - bekannterweise - der faulste Mensch der Welt bin, der mehr Ahnung von Geben als von Nehmen hat, habe ich mich ausnahmsweise mal von einem netten Store inspirieren lassen, der den California Instagram Look auf Leinwand gepappt hat. Super um ihn den Zurückgelassenen weiterzugeben. Einerseits natürlich um sie neidisch zu machen und andererseits um sich ein letztes Mal richtig gönnerhaft zu zeigen. Die <a href=\"http://www.urbanara.de/kunst\" rel=\"nofollow\">Kunstdrucke</a> gibt es bei Urbanara. Und ja, ich habe lange danach gesucht. Und ja, sie gefallen mir. Und nein, ich werde dieses eine Mal keine eigenen Prints bei einem verpixelten Kackposterservice bestellen. Natürlich hat dieser Shop auch stilecht einen Showroom in Hipster Mitte, aber ich muss zugeben - i like. Man kann sich den Kram wenigstens angucken und bestellt nicht blind.</p>\n<img src=\"http://www.urbanara.de/3328-14533-thickbox/myan-soffia-no-365.jpg\" alt=\"\">\n<p>Vielleicht sollte ich denen aber auch mal ein paar meiner eigenen California Fotos als Motiv nahelegen:</p>\n<img src=\"http://distilleryimage9.ak.instagram.com/6c8cfc38006611e2ba4022000a1e8932_7.jpg\" alt=\"\">\n<img src=\"http://distilleryimage8.ak.instagram.com/b3259ca4fad011e18a5622000a1cf717_7.jpg\" alt=\"\">\n<img src=\"http://distilleryimage7.ak.instagram.com/d36e187cf7c111e1b83422000a1de2ad_7.jpg\" alt=\"\">\n<p>Auch interessant: Bei <a href=\"http://www.eyeem.com/market\">EyeEm</a> gibt es nun offiziell die Möglichkeit Fotos aus seiner eigenen Sammlung zu Geld zu machen. Wir werden sehen. Hauptsache Sommer an die Wände.</p>\n"}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	module.exports = {"title":"Cats, dogs and cake","date":"2012-08-14 14:43:27 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/tn_IMG_9101.JPG\" alt=\"tn_IMG_9101.JPG\" />\n<p>Da morgen mein Geburtstag ist, habe ich die Gelegenheit beim Schopf ergriffen und mich im Geburtstagsknigge schlau gemacht wie man einen solchen Tag zelebriert. Es scheint auf Katzen, Hunde und Kuchen hinauszulaufen. Aber seht selbst:</p>\n<p>DIY Pudeltorte - für Menschen, die es verdient haben. Also nicht für mich.</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/5DUEbQNLv_w\" frameborder=\"0\" allowfullscreen></iframe>\n<p>How to party:</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/5DghEoUmR6w\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Großmutter bekommt ein Minipony:</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/cjTqXsG_O2g\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Happy Birthday, Ron Swanson!</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/1mQUgrwVcCA\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Kann ich mich reinfühlen:</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/PN1iT64Qm1Q\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Corgis essen eine 3m hohe Torte:</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/uUbpbfSTts8\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Könnte mir auch passieren:</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/MiLt_JOH8ZM\" frameborder=\"0\" allowfullscreen></iframe>\n"}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	module.exports = {"title":"Chaos Communication Camp 2011 - Erster Teil","date":"2011-08-12 11:40:15 +0000","tags":null,"layout":"post","body":"<p>\n\tDas <a href=\"http://events.ccc.de/camp/2011/\">Chaos Communication Camp</a> scheint eine große Sache für Langhaarige und Menschen zu sein, die Handys besitzen, die schlauer sind als 90% der Weltbevölkerung. Mein Handy hat weder Empfang, noch traue ich mich mein Windows Notebook von Acer auszupacken. Vielleicht werde ich auch niemals verstehen, warum auf diesem Camp eine 900m hohe Antenne aufgebaut wurde, die den Mond aus Gründen mit irgendwas beschiessen soll.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tNerds können sich zwar nicht die Haare waschen, aber dafür können sie aus einem alten Kondom, 30kg Menschenhaar und einer 4er Packung Skittles, einen haushohen Roboter konstruieren, der alle Menschen mit gewaschenen Haaren zerstören könnte.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"601\" src=\"/files/tn_eyeemfiltered1313049578537.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tÜberall blinkt und piept etwas und in mir keimt leise die Hoffnung auf, irgendwann ganz auf menschlichen Kontakt verzichten zu können und mich an einen warmen Roboterkörper anzulehnen, dessen Rumpf aus einer gallertartigen Geleemasse besteht, die weder klebt noch in irgendeiner Art und Weise uangenehm riecht. Ein bißchen wie die emotionale Lieber einer Fucking Machine zu genießen. Vielleicht werden Kinder schon bald sagen &quot;Ich bin von einer Fucking Machine großgezogen worden&quot;.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/tn_IMG_20110811_185818.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"667\" src=\"/files/tn_eyeemfiltered1312983480241.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tFür Menschen wie mich, mit einer Geduldspanne von zwei Sekunden, ist es schon verblüffend überhaupt länger als nötig bei Ausstellungsstücken oder Workshops stehen zu bleiben. Die <a href=\"http://de.wikipedia.org/wiki/Tesla-Transformator\">Tesla-Spule</a> ist der David Hasselhoff unter den Vorführgeräten - hatte 1995 echt mal Power im Physikunterricht, ist heute aber nur noch ein echtes Liebhabervorführstück. Ich bleibe stehen, weil ich die Hoffnung habe, dass jemand der Anwesenden in die Spannung fasst und sich verletzt. Dazu kommt es nicht. Aber das Camp dauert ja noch ein paar Tage.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/tn_IMG_20110811_140652.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWenn man die Aussage &quot;Hygieneartikel gehören in den Mülleimer&quot; aus seinem Gesamtzusammenhang löst, erreicht der Satz auf einem Nerd-Camp eine ungeahnte Tiefe.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"667\" src=\"/files/tn_IMG_20110811_181814.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"720\" src=\"/files/tn_eyeemfiltered1313072372476.jpg\" width=\"480\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tAuf die kleine Rakete, die ich beim Einlass bekommen hab, habe ich mir den Schriftzug GRATISAFFEN programmiert. Niemand fragt nach. In was für einer Welt leben wir eigentlich?</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/tn_IMG_20110811_193442.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tAnsonsten: Die Leute hier sind wirklich entspannt, überall stehen Sofas im Wald, alles ist wunderschön beleuchtet und es fällt mir schwer negative Aspekte zu finden, die ich betonen kann. Und ja, ich habe großen Spaß und will eine Rakete bauen um meinen Badmüll zum Mond zu schießen.</p>\n"}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

	module.exports = {"title":"Christmas Mixtape: Nock Nock Eggnog","date":"2013-12-21 13:21:32 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://31.media.tumblr.com/tumblr_lugrlwTkQx1qgpecho1_500.jpg\" alt=\"Alt text\"></p>\n<p>Mutti wünscht sich zu Weihnachten ein Fixie und niemand schenkt Euch Fluoxetin? Weihnachten ist einfach nicht mehr wie früher, also schnell Ada Blitzkrieg bei <a href=\"https://soundcloud.com/bangpowwww/sets/nock-nock-eggnog\">SoundCloud</a> folgen und lieber mit musikalischer Untermalung rumflennen!</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/nock-nock-eggnog\">player</a></p></p>\n"}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

	module.exports = {"title":"KONTAKT","date":"2011-04-11 00:00:00 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2015/Jan/waslanwas.JPG\" alt=\"alt\"></p>\n<p><a href=\"mailto:kontakt@textkrieg.de\">kontakt@textkrieg.de</a></p>\n<p>ALL CONTENT © ADA BLITZKRIEG 2017</p>\n"}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	module.exports = {"body":"<h1>Content / Images</h1>\n<p>If using the standard file storage, Ghost will upload images to this directory.</p>\n"}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	module.exports = {"title":"DACKELKRIEG - ein Roman von Ada Blitzkrieg","date":"2012-12-15 00:00:00 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/dackelblitz.jpg\" alt=\"dackelblitz.jpg\" />\n<p>Heute ist es endlich soweit: Mein erster Roman &quot;<a href=\"http://textkrieg.de/pages/dackelkrieg\">DACKELKRIEG - Rouladen und Rap</a> ist ab sofort bei <a href=\"http://textkrieg.de/pages/dackelkrieg\">AMAZON</a> oder über meine Homepage käuflich zu erwerben.</p>\n<p>Informationen zu Inhalt und Preis findet Ihr auf der <a href=\"http://textkrieg.de/pages/dackelkrieg\">DACKELKRIEG SEITE</a> zum Buch.</p>\n<p>Kauft ihn, lest ihn und verschenkt ihn zu Weihnachten!</p>\n"}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

	module.exports = {"title":"Dackelkrieg - Hörbuch und Bekenntnisse","date":"2013-05-28 08:27:59 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/dackelblitzkrieg.jpg\" alt=\"dackelblitzkrieg.jpg\" />\n<p>Es ist nun schon eine ganze Weile her, dass ich meinen Roman <a href=\"http://textkrieg.de/pages/dackelkrieg\">DACKELKRIEG</a> veröffentlicht habe. Über die vielen verkauften Exemplare, die guten Rezensionen und das großartige Echo war ich mehr als überrascht. Heute möchte ich als kleines Dankeschön für alle, die mich durch den Kauf oder Ihre Unterstützung angefeuert haben, ein Kapitel des Buches als Hörbuch veröffentlichen und ein paar Fragen beantworten, die mich in den letzten Tagen auf Twitter und Facebook erreicht haben.</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/ada-blitzkrieg-dackelkrieg-h\">player</a></p></p>\n<p><strong>Auf Twitter möchte <a href=\"https://twitter.com/Blaubierhund/status/337841848758460416\">Blaubierhund</a> meine Verkaufszahlen wissen und fragt nach einer Aufsschlüsselung nach Verkaufsplattform.</strong></p>\n<p>Mit den Verkaufszahlen ist es im Fall von Dackelkrieg etwas verwirrend. Mein Roman wurde als ebook über zwei Verkaufswege vertrieben: Den &lt;a href=&quot;http://www.amazon.de/DACKELKRIEG-Rouladen-und-Rap-ebook/dp/B00AO6VVN0/ref=sr_1_1?ie=UTF8&amp;qid=1369653775&amp;sr=8-1&amp;keywords=dackelkrieg&gt;Amazon Kindle Shop</a> und als &lt;a href=&quot;http://textkrieg.de/pages/dackelkrieg/kaufen&gt;Direktverkauf</a> über meine Homepage. Die Verkäufe über den Amazon Shop sind in Sachen Verkaufszahlen bisher noch nicht sehr aufschlussreich, da man die Abrechnungen und die erwirtschafteten Beträge erst einige Monate (in der Regel 4 Monate) später erhält. Daher liegen mir von Amazon nur die ersten Verkaufszahlen für Dezember und Januar vor - bevor der Roman in Printmedien und im Rundfunk besprochen wurde. Diese Zahlen sind nicht besonders aussagekräftig, da das Buch erst in den letzten Dezembertagen publiziert wurde. Geläufig sind mir hingegen die Platzierungen in den Bestsellerlisten bei Amazon, in denen das Buch Platz Eins unter “Ratgeber” erreichte und unter Neuerscheinungen in den Top5 lag. Kein Mensch weiß warum, also das mit dem Ratgeber.</p>\n<p>Die Verkaufszahlen über meine Homepage und die Direktbestellung über PayPal sind mir hingegen geläufig, weil ich bei PayPal Zugriff auf meine Verkäufe habe. Da es mir aber fern liegt zu spekulieren was wohl über Amazon verkauft wurde, werde ich Dich noch etwas vertrösten müssen. Wenn ich die neuen Zahlen (bis April) von Kindle habe, werde ich ohnehin einen Hintergrundartikel verfassen, um auch die Vor- und Nachteile von Selbstverlag und ebooks zu erläutern und einen Mehrwert für Interessierte zu erschaffen.</p>\n<p><strong>Awndre fragt mich auf Facebook: “wo kann man das büchlein denn erwerben? möchte es endlich mal lesen!”</strong></p>\n<p>Am Besten kaufst du das Buch natürlich direkt über meine Homepage, dann ist Amazon nicht zwischengeschaltet und die Provision bleibt bei mir. Also hundert Prozent monetäre Liebe für den Autor. Super, oder? Dazu gehst Du auf meine <a href=\"http://textkrieg.de/pages/dackelkrieg/kaufen\">DACKELKRIEG Bestellseite</a>, wählst Dein Wunschformat und meldest Dich mit Deiner PayPal Adresse an. Der Prozess läuft automatisiert ab und nach der Bestellung bekommst Du per Mail einen Downloadlink.</p>\n<p><strong><a href=\"https://twitter.com/Nordseehallig/status/337843115459244032\">Nordeehallig</a> fragt ob ich mal ein Buch auf der Hallig schreiben möchte.</strong></p>\n<p>Ich würde mich gerne an verschiedenen Orten für meinen nächsten Roman inspirieren lassen. Für spezielle Angebote kann man mir gerne immer eine Mail schreiben. Sprich, wenn man ein Haus, eine Wohnung oder ein Zelt an einem spannenden Ort hat und an etwas Schönem mitwirken möchte, sollte man mich kontaktieren.</p>\n<p><strong>Haras schreibt auf Facebook: “mach dein buch als echtes buch. nich so nen digitalen quatsch ! bitte.”</strong></p>\n<p>Ich würde Dackelkrieg natürlich gerne auch in gedruckter Form sehen. Mich erreichen jeden Tag Anfragen von Menschen, die kein Smartphone und keinen ebook Reader haben. Am liebsten würde ich die Druckversion ebenfalls im Eigenverlag veröffentlichen. Allerdings sind die Druckkosten für kleine Auflagen so hoch, dass später das einzelne Taschenbuch in der einfachsten Form über 11 Euro (exklusive Versand) kosten würde. Ich finde das etwas zu hoch für ein Buch, weil ich weiß das bei vielen Lesern das Geld nicht so locker sitzt. Ich arbeite aber gerade an einer Lösung und denke über <a href=\"http://de.wikipedia.org/wiki/Crowdfunding\">Crowdfunding</a> oder die Zusammenarbeit mit einem sympathischen Verlag nach. Fakt ist aber, dass mein nächstes Buch in gedruckter Form erscheinen wird.</p>\n<p><strong>Und Andreas möchte wissen: Wie fühlt es sich an, ganz bei sich zu sein?</strong></p>\n<p>Du spielst auf die Empfehlung von Sybille Berg an, die das über meinem Roman gesagt hat? Ich denke da wirst Du sie fragen müssen!</p>\n<p><strong>Auf Twitter fragt <a href=\"https://twitter.com/benneedsholiday/status/337846833223172096\">benneedsholiday</a> ob man bei der INTRO Autogrammkarten von mir bekommen kann.</strong></p>\n<p>Die kann man noch nicht bekommen. Ich habe keine Autogrammkarten, weil ich nur Kolumnistin und ein klitzekleiner Fisch aus Kreuzberg bin. Aber man kann meine monatliche <a href=\"http://www.intro.de/autor/Ada%20Blitzkrieg\">Kolumne bei INTRO</a> lesen und sich freuen.</p>\n"}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	module.exports = {"title":"DACKELKRIEG - Ein Roman von Ada Blitzkrieg","date":"2012-12-15 00:00:00 +0000","tags":null,"layout":"post","body":"<blockquote>\n<p>“Ich würde einfach zurück zu Mutter aufs Land ziehen, so lautete der Plan. Dort wäre ich sicher vor Shitstorms und würde mich im Falle eines wütenden Lynch-Mobs mit ihrer 80er Jahre Rüstung aus Schulterpolstern und Birkenstocksandaletten mit dem vier Meter langen Quittenpflücker aus dem Keller heraus zu verteidigen wissen.”</p>\n</blockquote>\n<p><strong>Autor: Ada Blitzkrieg\nHerausgeber: Ada Blitzkrieg\nFormate: epub, mobi, PDF\nSprache: Deutsch\nAuflage: 2012</strong></p>\n<p><img src=\"/content/images/2014/Sep/cover-1.jpg\" alt=\"alt\"></p>\n<p>DACKELKRIEG  Rouladen und Rap, der autobiographische Roman von Ada Blitzkrieg, ist die skurille Geschichte einer typisch untypischen Jugend in den 90er Jahren. Voller Komik und Selbstironie erzählt die junge Autorin schonungslos von ihrer Kindheit auf dem Land aus einer Zeit, als Winterjacken noch Anoraks hießen und Helmut Kohl der König des geweihten Landes war.</p>\n<p>Irgendwo zwischen Frankfurt und Köln spielen sich bizarre Szenen ab: Ein kleines Mädchen das durch einen Inline-Skate Unfall ihr Selbstbewusstsein verliert, wird von einer Herde Pferde böswillig attackiert und zerbricht in einer Welt voller Selbstzweifel und Egomanie. Immer im Kampf gegen die Absurdität der eigenen Mutter, die in den Augen der Autorin eher einer Wachsfigur aus Fleischgelee gleicht, als einer ernstzunehmden Erziehungsberechtigten, findet Ada dann doch ihren ganz eigenen Weg der Rebellion und blickt inzwischen auf die erschreckende Gesamtsumme von 4800 gestohlenen Sauren Schnüren zurück. Kein Wunder, dass die Akneproblemen nicht lange auf sich warten lassen und der Körper der Autorin sich in der Pubertät grotesk verformt. Das Mädchen ist nicht nur eine fresssüchtige Schulschwänzerin, sondern auch eine Aufmerksamkeitshure, die sich an den nächstbesten verschenkt, der über ein beleuchtetes Display verfügt.</p>\n<p>Heute, mit siebenundzwanzig Jahren, hat sich Ada Blitzkieg nicht nur eine Katze und ein Rezeptbuch zugelegt, sondern sich auch in den Kopf gesetzt an Weihnachten alles das zurückzuerobern, was ihr zusteht: Frieden und Harmonie. Notfalls eben mit Gewalt. Ob dieser Plan aufgehen wird?</p>\n<p>Wieso fängt ein siebenjähriges Mädchen wegen König der Löwen an zu trinken? Und trägt der blaue Wellensittich Coco wirklich die Schuld an der Demenz der Großmutter? Ob im Reformhaus oder im Discountsupermarkt, dieser Roman vereint Humor und Tragik auf eine mitreißende Weise.</p>\n<blockquote>\n<p>Ada Blitzkrieg entwirft ein neues Bild des Schriftstellers, indem sie es in die Welt der digitalen Gesellschaft übersetzt.</p>\n</blockquote>\n<div class=\"source\">(FAZ)</div>\n<blockquote>\n<p>Das erste Buch der begabten Autorin Ada Blitzkrieg handelt von Pferden,\nGeschlechtsorganen und dem guten Gefühl ganz bei sich zu sein.</p>\n</blockquote>\n<div class=\"source\">(Sybille Berg)</div>\n<blockquote>\n<p>Wenn ich hundertprozentig sicher wäre, dass Ada Blitzkrieg wirklich ein\nMensch wäre, würde ich sagen, Ada Blitzkrieg ist der beste\nTwittermensch.</p>\n</blockquote>\n<div class=\"source\">(Casper)</div>\n<h1>Leseprobe:</h1>\n<p>Mit Dreizehn muss ich ziemlich schwer Akne gehabt haben, zumindest entnehme ich das den kindlichen Aufzeichnungen in meinem Tagebuch, das eigentlich “Nächtebuch” hätte heißen müssen, denn nach der Schule schlief ich nur noch, weil ich mich in meiner Haut einfach nicht mehr so wohl fühlte. Mir wurde klar, dass da wohl ziemlich was im Argen liegen musste, als Mutter eines Tages ein “ernsthaftes Gespräch” mit mir führen wollte, vor denen sich Kinder vollkommen zurecht fürchten. In “ernsten Gesprächen” geht es immer um Tod, Sex, Scheidung oder eben Akne. Bei mir war es Akne.</p>\n<p>Die Akne kommt von deinem Vater!</p>\n<p>Kann er sie dann nicht wieder weg machen?</p>\n<p>Ich meine, er hatte auch Akne.</p>\n<p>Ach, ist er deswegen heute so?</p>\n<p>Er hatte auf jeden Fall auch Probleme damit.</p>\n<p>Toll, und jetzt hat er mich auch angesteckt, um sein Leid unsterblich zu machen? Die Rache der Akneopfer. Die Spirale der Eitergewalt muss sich weiter drehen, ja?</p>\n<p>Akne ist nicht ansteckend.</p>\n<p>Blödsinn. Ich hab ja welche!</p>\n<p>Ja.</p>\n<p>Es folgten unzählige Arzttermine. Aber weder der rumänische Wunderheiler, noch die tranreichen Pasten des Inuit-Doktors, noch der Laserspezialist der NASA konnten mir helfen.\nDoch dann zeichnete sich ein kleiner Hoffnungsschimmer am Pustelhorizont ab: Der ortsansässige Hautarzt war ein geschlechtsloses Wesen ohne spezielles Alter und ohne nennenswerte äußerliche Merkmale. In der Praxis roch es immer nach einer Mischung aus Desinfektionsmitteln und Arsch. Ich entblößte meinen verkraterten Rücken vor dem studierten Dermatologen und es herrschte einige Zeit bedrückende Stille im Behandlungszimmer des Spezialisten. Ich starrte das Gemälde mit den expressionistischen Klotzpferden an und wünschte mich an einen Ort, an dem ich mich wohler fühlte: In ein Schlachthaus oder in den Altgriechischunterricht, erste Reihe, Mittelgangplatz, direkt vor dem Lehrerpult. Du kannst deinen BH ruhig anlassen, Ada! Das war mir nun aber wirklich peinlich. Ich schämte mich sehr.</p>\n<p>Der Arzt drückte so lange aufgeregt an meinem entzündeten Ekelrücken herum, bis wir beide knietief in dem von mir produzierten Wund- und Eitersekret standen und uns ratlos anschauten. Ein Plan musste her, der mehr beinhaltete, als mich auf den Boden seiner einfallslos möblierten Hautarztpraxis zu entleeren, das war uns beiden klar. Und Mutter, die auf dem Gaffer-Stuhl der Nichtpatienten thronte, wie eine Wachsfigur aus Fleischgelee die Socken strickte, während ich mich langsam leerte, wusste es auch.</p>\n<p>Ich solle ab sofort unter die Sonnenbank gehen, so lautetet die Fachmeinung zu meinen Kratern und Beulen, aber immer nur kurz und auch nicht zu oft, wegen meines Hauttyps, und weil ich dann vielleicht auf dem Gymnasium nicht mehr so leicht von den anderen Mitschülern akzeptiert werden würde. Dafür würde ich - und das war die gute Nachricht - im Rahmen der Solarium-Therapie in der In-Diskothek Carambar donnerstags, wenn es mal wieder hieß “Flotter Dreier - Drei Getränke zum Preis von Einem”, sicherlich den ein oder anderen Cocktail von einem netten Polohemdträger spendiert bekommen. Der studierte Dermatologen schaute auf seine Flik Flak Uhr. Wer braun ist, ist auch willig, Ada. Pass also auf dich auf, mein Kind! Alles Gute für dich und deine liebe Frau Mama. Gott segne euch beide! Das alles sagte mein Hautarzt an diesem Tag zu mir. Und er bat mich mitzuschreiben und holte noch weiter aus, während die infektiöse Suppe weiter aus meinem offenen Rücken auf den Praxisboden lief. Hier, da hätte er eine besonders starke Aknesalbe, die ich vor dem Schlafengehen auf mein Gesicht und auf die betroffenen Stellen am Rücken auftragen solle. Also in meinem Fall den gesamten Rücken, wenn nicht sogar noch mehr.</p>\n<p>Bei Aknesalben heißt es immer nur die “betroffenen Stellen”, weil die Pharmaindustrie zu faul ist die Packungsbeilagen für Aknepatienten zu personalisieren. Es gibt bei Scheidenpilz ja schließlich auch nicht die “betroffene Stelle”, sondern nur “die Scheide”. Aber Medikamentenkäufer sind ja ohnehin keine Premiumkunden, denn sie sind krank und sterben bald, so dass sich sprachliche Finesse in der Regel nicht mehr bezahlt macht. Und Aknepatienten sind sowieso nur zweite Wahl, weil ihre Verpackung nach nichts aussieht.&quot;</p>\n<h1>Den Roman bei <a href=\"http://www.amazon.de/DACKELKRIEG-Rouladen-und-Rap-ebook/dp/B00AO6VVN0\">Amazon</a> kaufen.</h1>\n"}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

	module.exports = {"title":"Darf man als Moslem Schinkenchips essen?","date":"2012-12-09 00:00:00 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/64.jpg\" alt=\"64.jpg\" />\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/darf-man-als-moslem\">player</a></p></p>\n<p>Die Menschen sind inzwischen aus dem Teletext ins Internet abgewandert und so liest sich der meiste Kram dann dort auch. Ich bin bekanntlich ein Riesenfan von Seiten wie <a href=\"http://www.gutefrage.net/\">gutefrage.net</a> oder <a href=\"http://www.wer-weiss-was.de/\">wer-weiss-was.de</a>, weil jeder dort immer alles weiß und die Diskussionen immer nach dem gleichen globalen Trottel-Schema abzulaufen scheint. <strong>Es gibt genau sechs Arten von Menschen, die im Internet kommentieren:</p>\n<p>Der Minimalist. Der Sozialpädagoge. Der Agressor. Der Besserwisser. Der Troll. Und mich.</strong></p>\n<p>Die Tasse <a href=\"http://www.dooyoo.de/kaffee-cappuccino/markus-kaffee-mild/1045967/\">MARKUS Exklusiv</a> verströmt ihr köstliches Aroma im Arbeitszimmer. Draußen scheint die Sonne von der immer alle erzählen, aber nicht in diesen Raum. Diese Wohnung kennt kein direktes Licht mehr. Spielten nicht früher auch immer diverse Kinder vom irgendwem auf der Straße? Wo sind die denn alle hin? Heute muss man beim Autofahren in Szenebezirk nicht mal mehr Acht geben, wenn ein Kettcar auf die Straße rollt, denn es gehört unter Garantie keinem Kind, sondern einem “Junggebliebenem”, einem Trendsetter aus der Kreuzberger Designszene, der vermutlich vernünftig genug ist mit dem Teil nicht auf die Straße zu fahren ohne sich vorher nach Autos umgeschaut zu haben. Kreuzberg ist so leer geworden. Alte Leute gibt hier es auch schon lange keine mehr. Aber das ist auch in Ordnung so. Hier gibt es offenbar nur so welche wie mich, aber in einer besseren und funktionierenden Version. Menschen, die sich nicht andauernd fragen was eigentlich die weißen Stücke in der Salami sind, oder ob <a href=\"http://www.stefan-niggemeier.de/blog/kein-schoener-lanz/\">Markus Lanz</a> manchmal schlimme Albträume hat. Und wenn ja, wovon sie wohl handeln? Ob er träumt beim Bücken aus Versehen zu blähen? Und das in einer Live-Sendung! Auf diese Art könnten wir uns wieder versöhnen.</p>\n<p>Ich hatte gestern vor dem Einschlafen bekifft tierisch Hunger auf diese <a href=\"http://www.yopi.de/Ja_Knabbersnacks_mit_herzhaftem_Schinkengeschmack_Suesswaren_Knabberzeug\">Knabber-Snacks</a> von ja!. Geschmacksrichtung Schinken. Wie sich das schon wieder liest. Eigentlich eine Todesqual, und sowas wird normalerweise bestimmt den Häftlingen in Guantanamo als Folter serviert, aber es erinnert mich an die Zeiten, als ich noch jung war und wir einfach maßlos alles in uns reingestopft haben, um unsern Motor immer auf Hochtouren zu befeuern. Die “Nahrungsmittel” von ja! sind eine eigene Welt für sich. Nichts schmeckt so abscheulich und sonderbar wie diese Abfallprodukte der Lebensmittelindustrie. Alles scheint irgendwie aus Pappe zu bestehen und mit der gleichen unmöglichen Art von Gewürz hergestellt worden zu sein. Schlecht schmeckendes Pappe-Gewürz, das geschmacklich irgendwo zweischen Hähnchenwürzsalz und Aal liegt und offenbar vom Hersteller auch für die Produktion von Schokolade oder Milch verwendet wird.</p>\n<p>Wir lagen im Bett und mir fielen diese verdammten Chips wieder ein. Schinkengeschmack, wow! Aber schmeckte Schinken in meiner Erinnerung nicht immer irgendwie anders? Irgendwie mehr nach Schinken? Also fingen wir an abwechselnd ja! Produkte aufzuzählen, um uns gegenseitig an Scheußlichkeit zu überbieten: Bierschinken von ja!. Cervelatwurst von ja!. Fleischwurst von ja!. Baguettebrötchen von ja!. Sauerkraut von ja!. Mayonnaise von ja!. Die 500g Schweinehackfleisch Packung von ja!. Das Sortiment der Premium-Lebensmittelmarke zog sich schier ins Endlose und der Abend nahm erst spät ein Ende. In der Nacht passiere das: <a href=\"http://omgcatsinspace.tumblr.com/\">OMG</a>!</p>\n<img src=\"http://25.media.tumblr.com/tumblr_lw7fawphA01r4xjo2o1_250.gif\" alt=\"\" />\n<p>Im Arbeitszimmer googlte ich am nächsten Tag nach den besagten Chips mit “köstlichem” Schinkenaroma und die ersten Treffer versprachen mehr als ich mir erhofft hatte.\n<a href=\"http://www.gutefrage.net/frage/darf-man-als-moslem-schinkenchips-essen\">Darf man als Moslem Schinkenchips essen?</a>\nEine Frage wie ein Schlag ins Gesicht des Bildungssystems. Der Schläger hieß Dennys0106. Seine Waffe hieß “geistige Gewalt” und vermutlich ist er zum Zeitpunkt der Frage schon mehrfach für ähnliche Delikte vorbestraft gewesen.</p>\n<blockquote>Eine Freundin von mir ist Moslem und ich weiß nicht ob ich es ihr anbieten kann. Ist da überhaupt was von Schinken drin? Bei dem Aroma bin ich mir nämlich nicht sicher obs natürlich ist oder künstlich..</blockquote>\n<p>In solchen Foren läuft immer alles absolut vorhersehbar ab und ich dachte mir, Vorhang auf für den Minimalist, die Sozialpädagogin, den Agressor, den Besserwisser, den Troll und mich.</p>\n<p>Der <strong>Sozialpädagoge</strong> schrieb:</p>\n<blockquote>Biete einfach an was im Rahmen Diener Kultur ist, und sei nicht ärgerlich wenn es abgelehnt wird....Du kannst ja schliesslich und letztendlich nicht alles drehen und wenden nur wegen einer Religion die Du vielleicht gar nicht verstehst...</blockquote>\n<p>Der <strong>Minimalist</strong> meinte:</p>\n<blockquote>Ließ die Zutatenliste, ist angegeben!</blockquote>\n<p>Der <strong>Agressor</strong> antwortete:</p>\n<blockquote>Als Muslim ist einem Schweinefleisch verboten. und wie es verboten ist, so ekelt man sich auch davor. wer wollte dann etwas essen, was danach riecht und schmeckt. künstlich hin oder her....bäääää!</blockquote>\n<p>Der <strong>Besserwisser</strong> behauptet:</p>\n<blockquote>Nein,denn Schweinefleisch ist ungesund! Wenn du's nicht glaubst dann Google!!</blockquote>\n<p>Der <strong>Troll</strong> stichelt:</p>\n<blockquote>Ich würde lieber Krabbenchips essen.....köstlich!</blockquote>\n<p><strong>Und ich</strong> nur so:</p>\n<blockquote>WTF?</blockquote>\n"}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

	module.exports = {"title":"Das Ding mit den Dobermannvideos","date":"2012-05-08 14:27:33 +0000","tags":null,"layout":"post","body":"<p>None</p>\n"}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

	module.exports = {"title":"Das Ding mit den Passfotos ist ja so:","date":"2012-12-03 00:00:00 +0000","tags":null,"layout":"post","body":"<p>Stellt Euch mal vor, wir würden in echt alle aussehen wie auf unseren Ausweisbildern!</p>\n<img src=\"/content/images/319606_528043113873667_586965723_n.jpg\" alt=\"319606_528043113873667_586965723_n.jpg\" />\n<img src=\"/content/images/hahahaa.jpg\" alt=\"hahahaa.jpg\" />\nDanke für das Foto, David!\n"}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

	module.exports = {"title":"Das Ding mit Dobermännern ist ja so:","date":"2012-05-08 15:29:02 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/dobermann.JPG\" alt=\"dobermann.JPG\" />\n<p>Das Ding mit Dobermännern ist ja so: Wikipedia kann mir noch hundert Mal erklären, dass der Dobermann ein “eleganter Hund” sei, solange der Autor zwei Sätze später wieder mit “eleganterer Form des Pinschers” revidiert. Der Dobermann ist also ein Pinscher, bloß in eleganterer Form und ungefähr dreitausend Mal so groß. Mag sein. Aber für mich ist der Dobermann in erster Linie eins: Ein vierbeiniger Aal und irgendwie beängstigend.</p>\n<p>Bitte dranbleiben: Es folgen verstörende Dobermannvideos!</p>\n<p>Ich habe keine Angst vor Hunden. Die hatte ich noch nie. Als Kind habe ich Hunden bei jeder Gelegenheit ins Maul gefasst, auf Pit Bull Terriern geritten und am Napf meines Jack Russels grobe Fleischbrocken mitgegessen. Hunde akzeptieren mich in der Regel. Hunde haben mich schon immer akzeptiert. Meine laute und unangenehme Lache verschreckt ausnahmslos jedes Tier. Ausser Hunde. Hunde zieht dieses Gekreische nahezu magisch an. Ich kreische und Hunde rennen in freudiger Erwartung zu mir. Wir tummeln uns dann auf dem Boden, auf den Polstermöbeln, auf Wiesen und am Strand. Wir schlafen zusammen im Bett. Hunde und ich.</p>\n<p>Die Katze und ich kamen nie zusammen.</p>\n<p>Ich bin ein Hundetyp. Wirrer Gang. Wirre Haare. Auffällige Schwierigkeiten meinen Gemütszustand zu verbergen. Hunde sind mir schon immer gefolgt. Hunde lieben meine Unbefangenheit.</p>\n<p>Der Habitus eines Tieres bestimmt dessen Marktwert bei mir. Ich brauche nicht diese muskelbepackten Glatthaarspacken mit 20cm langen Reißzähnen, dunklen Fischschuppen und kleinem Augenabstand. Eines dieser Aalwesen hat mir mal meinen kleinen Terrier zereissen wollen. Ich habe ihn dann mit bloßen Händen auf den Boden gedrückt und er hat sich gewunden wie eine verkrummbeinte Schlange, in seinem eigenen Glitsch. Ich habe ihm in die Augen gesehen und dann meinen Giftstachel direkt in sein Herz gejagt.</p>\n<p>Das ist ein paar Jahre her. Hunde kennen mich inzwischen. Sowas spricht sich rum. Hunde schauen zu mir empor. Der Dobermann wiegt in der Regel 45kg und ist damit “bodymäßig” ein feines Vorbild für viele Frauen. Wikipedia nennt eine “Verwendung” des Hundes als “bevorzugter Diensthund in Konzentrationslagern”. Sag ich doch!</p>\n<p>Im Rahmen meiner fundierten Recherche über das Wesen des Doberaales, sind mir einige beunruhigende Videos über den Weg gelaufen. Hier also eine videozentrierte Charakterstudie über den Dobermann:</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/cGoKX6iUM9I\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Dieses Video hat mich anhand des Vorschaubildes neugierig gemacht. Wer stellt so etwas in Netz? Und was wird passieren? Zwar ist dieses Video zugegebenermaßen kein Dobermannvideo, aber ermöglichte mir das sanfte Aufbrechen meiner Ideale: Keine Youtubevideos mit Kindern gucken.</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/kPwaolO5ArU\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Wow, wer guckt sowas, und warum?</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/3gZBC1GxwW4\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Die rührende Lebensgeschichte von schrammeligem Deutschlandmerch und einem Dobermann, unterlegt mit Enya.</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/YWIfW73sxXs\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Jemand fasst einem Dobermann in den Fang. Unterlegt mit Evanescenes.</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/UKkDxhbY8gs\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Ein Dobermann spielt mit einer blinden Katze (Oh!) und lächelt danach ins Video.</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/eYhm5JbGNZ4\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Wie cool ist es denn bitte Hamburger mit seinem Hund zu essen?</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/z9w3KL9MbkQ\" frameborder=\"0\" allowfullscreen></iframe>\n<p>In diesem Video hat jemand 10 Minuten lang aufgezeichnet wie ein Dobermann regungslos auf dem Boden liegt.</p>\n"}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

	module.exports = {"title":"Das Ding mit Kurzhaarfrisuren ist ja so:","date":"2012-05-31 13:40:37 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/Kurzhaaradamann.JPG\" alt=\"Kurzhaaradamann.JPG\" />\n<p>1986-1988 war ich übrigens das süße Mädchen mit den schulterlangen hellblonden Locken bei dessen Anblick alle Frauen zwischen 12 und 45 Jahren “Ohhhhhhhh!” schrien und die etwas betagteren Mütterchen zwischen 46 und 99 begannen sturzflutartig vor Rührung zu weinen. Mutter ließ mich nie unbeaufsichtigt im Garten liegen.</p>\n<p>Eines Tages beschlossen meine Eltern im zarten Alter von drei Jahren (also ich), dass nun es Zeit für eine Veränderung sei, um dem Niedlich-Hype ein schroffes Ende zu setzen und mich für mein späteres Leben ausreichend zu wappnen. Ich sollte nicht mehr das süße Kind mit den Löckchen sein, sondern Ada Blitzkrieg, Handwerkerin, Skaterin, Fussballerin, Naziverprüglerin und Chefin. Kleidung trug ich fortan von meinem älteren Bruder. Ausrangiert und cool. Meine Gummizughosen in neutraler Farbgebung und Strickpullover mit Werkzeugmotiven waren meine Zöpfe. Meinen ersten Rock trug ich mit 20 Jahren.</p>\n<p>Ich bekam also meinen ersten Kurzhaarschnitt. Stilecht mit dem Topf und einer Küchenschere. Mutters Hände schnippelten an meinem Schicksal. Mit meiner neuen Pottfrisur ging ich dann in die Welt und wurde schnell Vorstand einer Jungsbande, die zudem drei Jahre älter als ich war. Kommandieren. Mein Befehl war unanfechtbar.</p>\n<p>Irgendwann wuchsen dann die Haare nach, aber die Macht bliebt. Manchmal machen Eltern ganz schön viel richtig. Danke!</p>\n<p>Heute möchte Ich möchte schon alleine keine Kurzhaarfrisur, weil die ersten fünf Ergebnisse meiner Google-Bildersuche nach “Kurzhaarfrisuren” diese sind:</p>\n<ol>\n<li>\n<p><a href=\"http://ellete.de/Frisuren/Foto/Kurzhaarfrisuren-Damen-2012-2013.jpg\">Es muss ständig so unglaublich gute Laune machen kurze Haare zu tragen!</a></p>\n</li>\n<li>\n<p><a href=\"http://www.frisurenkatalog.eu/frisuren/kurzhaarfrisuren-2010.jpg\">Ein Denkmal für missverstandenen Feminismus.</a></p>\n</li>\n<li>\n<p><a href=\"http://www.hairblog.eu/wp-content/Frisuren-2012-Trends-Colour-Shots-J7-11.jpg\">Forschungsgegenstand - Korrelation Inzucht und Kurzhaarfrisuren. </a></p>\n</li>\n<li>\n<p><a href=\"http://www.joy.de/imgs-267x400_09_dc_23_29_3a39f1f48722a5ce78775b30c803cca0/frisuren-f-r-kurze-haare-2012.jpg\">Ich möchte nicht darüber sprechen!</a></p>\n</li>\n<li>\n<p><a href=\"http://hochsteckfrisuren-hochzeit.net/wp-content/uploads/2011/08/Frisuren-Bob1.jpg\">Jetzt weiß ich was es heißt, wenn man sagt, dass Haare “liegen”.</a></p>\n</li>\n</ol>\n"}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	module.exports = {"title":"Das Kuchenvoting","date":"2011-11-21 16:13:46 +0000","tags":null,"layout":"post","body":"<img src='/files/pommet.jpg'>\n<br />\nTextkriegfreunde, ich denke derzeit daran Jutetaschen bedrucken zu lassen und möchte mich auf einen Kollektivspaß einlassen und die meistgevotete Tasche für Euch zum Liebhaberpreis drucken lassen. Also ran ans Voten:\n<br />\n<!-- BlogPolls -->\n<script type=\"text/javascript\" language=\"javascript\" src=\"http://www.blogpolls.com/poll/77907.js\"></script>\n<noscript><a href=\"http://www.blogpolls.com/poll/77907.html\">Blog Polls</a></noscript><!-- /BlogPolls -->\n"}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

	module.exports = {"title":"Der Blitz geht nach San Francisco","date":"2014-04-16 16:42:15 +0000","tags":null,"layout":"post","body":"<img src='http://distilleryimage2.ak.instagram.com/2c5c3f5efa0111e19c031231380e6971_7.jpg' alt=''>\n<p>Endlich finde ich neben dem ganzen Roman für Euch wursten und auf der Straße den Frühlingsanfang für mich zu genießen ein paar Momente Ruhe für Aufklärungsarbeit im Blog. Ihr werdet es bestimmt schon gehört haben - ja, ich gehe. Goodbye Berlin! Es ist wahr und ich bin glücklicher denn je Euch hier in Zukunft über das Rumaalen in Kalifornien, die Techszene, die Kultur und die Schwierigkeiten zu berichten, die so ein Umzug von Berlin in die USA so mit sich bringt.</p>\n<img src=\"http://media-cache-ec0.pinimg.com/736x/5f/f1/a6/5ff1a64bf22fbdbfb2a56dba59f73623.jpg\" alt=\"\">\n<p>Die Faktenlage:\nWir, das sind Johannes und ich, verabschieden uns erstmal von Berlin und ziehen nach San Francisco. Zunächst für 18 Monate - so lange erlaubt es das Visum - danach steht uns die Welt offen. Dieser Punkt ist nicht nur unfassbar aufregend, sondern auch schrecklich chaotisch. Dennoch bin ich derzeit jeden Tag dankbar bestimmte Entscheidungen in meinem Leben gegen Sesshaftigkeit und Stabilität getroffen zu haben und so Hand in Hand mit der Ungewissheit durch die Welt zu schreiten. Das muss Freiheit sein, denke ich mir dann und lächele (aber nicht auf Fotos).</p>\n<img src=\"http://distilleryimage3.ak.instagram.com/585ae668fc5011e1a4d022000a1cdd3a_7.jpg\" alt=\"\">\n<p>Für das US-Visum muss man so ziemlich alles dokumentieren, was man jemals gemacht hat und für Unverheiratete, wie wir es sind, liegt zusätzlich noch ein steiler Berg Klotzhindernisse im Weg rum.\nAber langsam kommt alles in Touren und wir hoffen im Juni aufbrechen zu können, denn ich freue mich auf den Sommer in Kalifornien, auf Mission Style Burritos, Longboard eiern und das lang ersehnte Wiedersehen mit meinen Taco Truck. Auf neue Gesichter und das Leben in einer der schönsten Städte der Welt. Hello San Francisco!</p>\n<p>In den nächsten Tagen bekommen wir vermutlich recht kurzfristig mit wann genau es losgeht und in meinem Kopf schweben unfassbar viele Gedanken. Ob ich meine Wohnung hier aufgebe, oder tausche oder ob ich sie untervermiete. Meine Möbel werde ich nicht mitnehmen können. Und so startet mein neues Leben mit einem großen Koffer voll Kleidung, meinem Laptop und einer Riesenportion Optimismus. Ich war nie ein Mensch, der eine Heimat hatte, außer im Abenteuer.</p>\n<img src=\"http://distilleryimage8.ak.instagram.com/af1cf55efacf11e191d6123138072de5_7.jpg\" alt=\"\">\n<p>Auf die Frage, warum ich Berlin erstmal verlasse, antworte ich immer: Ich liebe dieses Berlin, auch wenn es sehr voll geworden ist, und werde vielleicht auch zurückkehren, aber ich möchte Chancen nutzen, wenn sie sich bieten und ich möchte gerne Abenteuer erleben solange ich jung bin, neue Menschen kennenlernen und meine Sicht auf die Dinge erweitern. Der Zeitpunkt ist optimal. Er könnte nicht besser liegen. Ich bin jung und ich werde mich erst in 18 Monaten noch einmal fragen müssen wohin ich denn mit meinem Leben möchte. Ob ich dort bleibe, ob ich zurückkomme oder ob es ein anderer Ort wird, ob ich eine Familie gründen möchte, eine Bank überfalle oder Kanzlerin werde. Ich fühle mich überall auf der Welt zuhause, das ist mir in den letzten Tagen bewusst geworden, solange mein Freund bei mir ist. Wir freuen uns auf ein Abenteuer und sind wie die Fünf Freunde mit unserer fetten Katze. Nur zu dritt und mit geileren Frisuren.</p>\n<p>Berlin, ich werde deine Mietpreise nie wieder schimpfen! Eine kleine Wohnung kostet derzeit in San Francisco um die $3000, aber wir haben Lust. Am liebsten würden wir unsere Wohnung in Kreuzberg mit jemandem tauschen, der ebenfalls für eine längere Zeit nach Berlin will. Falls also jemand jemanden kennt, der jemanden kennt, dann sollte er mir unbedingt Bescheid sagen!</p>\n<img src=\"http://distilleryimage1.ak.instagram.com/f09487e6f57911e199b11231380729f1_7.jpg\" alt=\"\">\n<p>Wer wissen mag, warum ich mein Herz an San Francisco verschenkt habe, kann sich meine <a href=\"https://de.foursquare.com/bangpowwww/list/san-francisco\">Foursquare Liste</a> angucken und sich mit mir freuen. Ich werde versuchen meinen Blog in Bezug auf Visum und meine Wohnung aktuell zu halten und von meinem Abenteuer zu erzählen.</p>\n"}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

	module.exports = {"title":"Der Plural von Poster lautet nicht Posters","date":"2012-05-22 14:58:50 +0000","tags":null,"layout":"post","body":"<p>Text ist mehr als Textkörper. Text ist Stimulation. Text ist für mich nicht nur Hobby, sondern auch unausweichlicher Beruf, den ich voller Leidenschaft ausübe, um mir Textprodukte leisten zu können. Werbung vertextet unsere Passionen. Ich vertexte Schönheit.</p>\n<p>Meine Plakate:</p>\n<img src=\"/content/images/tn_delfin1.png\" alt=\"tn_delfin1.png\" />\n<img src=\"/content/images/tn_pferde1.png\" alt=\"tn_pferde1.png\" />\n<img src=\"/content/images/tn_emanzipation1.png\" alt=\"tn_emanzipation1.png\" />\n<p>In der Ausführung sieht das (Serviervorschlag) dann etwa so aus:</p>\n<img src=\"/content/images/delfffifin.jpg\" alt=\"delfffifin.jpg\" />\n"}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

	module.exports = {"title":"Deutsche und Humor - Wetten, dass..?","date":"2014-10-30 17:50:15 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://scontent-a-sjc.cdninstagram.com/hphotos-xfa1/t51.2885-15/10724825_477978699009209_723194079_n.jpg\" alt=\"alt\"></p>\n<p>Im Moment kursiert ein äußerst unterhaltsames Video im Netz, das einen Ausschnitt einer US-Talkshow zeigt, die ich gestern Abend vor dem Schlafengehen hier in San Francisco live im Fernsehen erleben durfte. Dabei musste ich Tränen lachen:</p>\n<iframe width=\"560\" height=\"315\" src=\"//www.youtube.com/embed/QWx5KWWGFN4\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Im Video erzählt <strong>Will Arnett</strong>, mein Lieblingsschauspieler aus der unfassbar tollen Serie <a href=\"http://www.youtube.com/watch?v=OuNB3iz3MUI\">Arrested Development</a>, dem US-Comedian <strong>Jimmy Kimmel</strong> in dessen <a href=\"http://abc.go.com/shows/jimmy-kimmel-live\">Live-Talk</a> von seinem Auftritt in der deutschen TV-Sendung <strong>Wetten, dass…?</strong></p>\n<p>Prompt titelte die Süddeutsche Zeitung <a href=\"http://www.sueddeutsche.de/medien/will-arnett-laestert-ueber-wetten-dass-sie-wollten-dass-ich-einen-nervenzusammenbruch-erleide-1.2199066\">“Will Arnett lästert über Wetten, das…?”</a>. Allerdings wurde inzwischen die Schlagzeile offenbar angepasst, weil man merkte, dass der Begriff des Lästern nicht recht zu einem Auftritt bei einer der zuschauerstärksten US-Talksendungen passen könnte. Die URL wurde allerdings noch nicht angepasst, ebenso die Posts auf Facebook zum Thema. Nun findet man “Lästern” lediglich in der Unterüberschrift. Nunja.</p>\n<p>Schon wieder so etwas, das scheinbar die deutsche Seele mitten ins Herz trifft. <strong>Wetten, dass…?</strong> ist nationale Identität und viele von uns sind Zuschauer seit der frühen Kindheit. Die deutsche Show steht also für Heimat, Nostalgie, Identität und noch vieles mehr. Die Kommentare auf der Facebook Seite der SZ sind sich einig: “Will Arnett besucht die Sendung, informiert sich vorher nicht und ‘lästert’ dann noch über die Show. Dreist und deshalb unwahr!” Dabei vergessen die Aufgebrachten vermutlich, dass wir selber die Humorlosen in diesem Spiel sind und Will so gesehen mit seiner sehr unterhaltsam formulierten These nur recht geben. Eigentor. Die Deutschen können eben Humor nicht so gut. Nicht im Mainstream.</p>\n<p>Eigentlich ist das Witzeln von Will Arnett bei genauer Analyse sehr positiv und als Werbung für das deutsche Format zu bewerten. Ich meine, wer guckt ernsthaft <strong>Wetten, dass…?</strong> aus Qualitätsgründen? Wegen dem guten Talk? Wegen den spannenden Gästen? Wegen den seriösen Wetten? Ach bitte! Gucken wir nicht eigentlich aus Traditionsgründen? Auch wegen der unglaublichen Absurdität der Wetten? Weil wir samstags nicht zu tun haben und zu dick oder zu traurig für die Disko sind? Einen Hund an seinem Bissabdruck auf einer Frisbee erkennen? Könnten wir nicht auch langsam mal beginnen über uns selber zu lachen? Nur weil die Kritik von einem Amerikaner kommt, ist sie nicht böse oder verkehrt, sondern in erster Linie wahr und witzig und zeigt den eigentlichen Wert von <strong>Wetten, dass…?</strong> -  gelockerte Unterhaltung mit einem hohen Trashfaktor. Sorry, Will hat recht!</p>\n<p>Für mich sind übrigens die von Will aufgezählten Gründen, die einzige Motivation die Sendung überhaupt zu gucken. Und ich glaube die Amerikaner, und das erlebe ich hier täglich, fühlen sich durch Will und die vielen anderen US-Stars, die irritiert über ihre Gastrolle in deutschen TV-Formaten berichten, eher interessiert an solchen Formaten. Der Asurdität wegen.</p>\n<p>Generell ist zu sagen, dass sich Humor hier in den USA oft anders äußerst. Der deutsche Mainstream schaut sich gerne Barth an, lacht über Nuhr - man lacht eher über die anderen als über sich selbst. Lieber über Frauen, lieber über Menschen mit Migrationshintergrund, lieber über homosexuelle Menschen. Unser Humormainstream ist recht flach und geht häufig auf Kosten der anderen. In den USA geht es thematisch im Grunde aber nicht anders zu, dennoch ist der Zugang zum Thema ein anderer - filigraner. Der Comedian sieht sich dabei selbst eher als fehlbar, er lässt kein gutes Haar an sich selbst. Ein schlauer Mensch hat mal gesagt: “Ein Witz, der eine Minderheit thematisiert, muss in erster Linie sehr gut sein, damit er berechtigt ist.” Das fehlt mir in Deutschland oft. Die Leute lachen aus den falschen Gründen. Aber das ist erstmal eine subjektive Einschätzung. Daher hier zum Abgleich mal die hervorragende Sarah Silverman:</p>\n<iframe width=\"560\" height=\"315\" src=\"//www.youtube.com/embed/Ze0T-DdDqEw\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Kimmel himself brachte mich kürzlich übrigens auch sehr zum Lachen, als er bei der US-Sendung Shark Tank eine Idee für Horse Pants pitchte:</p>\n<iframe width=\"560\" height=\"315\" src=\"//www.youtube.com/embed/opNiKBP7hQo\" frameborder=\"0\" allowfullscreen></iframe>\n"}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

	module.exports = {"title":"Die 90er Megaparty oder Wege in die Misanthropie","date":"2011-10-16 14:54:54 +0000","tags":null,"layout":"post","body":"<p>\n\t&quot;Wow, wir haben Gästelistenplätze für die 90er Megaparty!&quot;, schrie ich und wir fühlten uns wie total erhabene Bildungswichser, die bei RTL direkt immer weiterschalten und sich Parmesan über ihren Grana Padano streuen. Meine Fresse, so eine 90er Party mit Opfern aus dem Umland. Das könnte ein guter Blogartikel werden. Ich wollte viel, bekam noch mehr und musste am Ende nur noch weinen.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWeinen, weil ich das alles nicht mehr lustig fand und weil man mir auf dem Rückweg ein Fahrrad auf dem Kopf abstellte.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/Megaparty.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDie Plakate für die große 90er Megaparty fielen mir erstmals bei meiner kleinen <a href=\"http://textkrieg.de/2011/10/12/beschauliches-berlin\">Berlintour</a>&nbsp;ins Auge, über die ich jüngst in diesem Blog berichtete. Mega. Alleine schon das Wort! Kai Ebel findet &quot;Mega&quot; nicht mehr zeitgemäß. &nbsp;&quot;Affengeil, das müssen wir hin!&quot;. Und das taten wir auch.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/Megaparty1.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tMit der merkwürdigen Tram 21, die ausschließlich in absolut unattraktive Ostbezirke und raus aus der Stadt führt, transportierten wir unseren Alkohol zur Traprennbahn nach Karlshorst. Jahrelang fragte ich mich, wer diese Tram benutzt. Gott höchstpersönlich muss diesen Verkehrsweg extra gebaut haben um menschlichen Abfall raus aus der Stadt zu karren. Weiße Stiefel gelten als legale Fahrkarten. Noch waren wir bester Dinge. Etwas schadenfroh und in Erwartung auf ein paar fehlgeleitete Frühdreißiger und Sonnenbankunfälle. Immerhin ist alles umsonst und ich brauchte Füllsel für meine &quot;<a href=\"http://textkrieg.de/2011/09/07/ein-sonntag-auf-dem-dachshundrennen\">Ein Sonntag</a>&quot; Idee für den Blog. Und dass ich mich trotz Alkohol nicht amüsieren werden würde können, das ahnte ich noch nicht. Mir machen Menschen Angst. Es wurde unangenehm.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/Megaparty2.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tZugegeben, nach zwei Cocktails unterschätze ich häufig die Breite meiner Schulter und mein Türrahmen anzurempeln ist nicht nur äußerst belustigend für mein Umfeld, sondern zudem auch noch sehr schmerzhaft und entwürdiged für mich - und dadurch noch unterhaltsamern für alle, außer mir. Unterwegs tranken wir merkwürdige Softdrinks mit Wodka, Goldkrone und Rum, so dass wir auf den 100m Luftlinie zur Traprennbahn Karlshorst, wo das &quot;Megaevent&quot; stattfinden sollte, drei Mal zum Pinkeln und zwei Mal zum &quot;Grundlage schaffen&quot; an verschiedenen Döner- und Broilerbuden anhalten mussten.&nbsp;</p>\n<p>\n\tDies wäre der Zeitpunkt gewesen, um noch ein &quot;Alles in bester Ordnung!&quot; an die Mutter loszuwerden bevor der Sturm losbricht.</p>\n<p>\n\tIm Grillhaus, wo wir eine charaktervolle Dönerbox dinierten unterhielten sich drei Baseballmützenträger über Moneyboy, Realness und Haftbefehl.&nbsp;Doch dann kam die Angst.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tVor der Halle ausschließlich Hemdträger mit Basketballschuhen und Frauen, die unmöglich spitz-zulaufende Stiefel trugen. Die Inhalte der Unterhaltungen machten mit Angst, Ich wollte umdrehen und den Ausflug unter &quot;Naja, aber immerhin etwas gegessen!&quot; abbuchen, mich zuhause mit Christian Kracht ins Bett legen und Limo trinken. Nach einer Zigarette machten wir uns gegenseitig Mut und gingen dann doch rein. Ich hätte auf mein Bauchgefühl hören sollen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDer Mann am Einlass sagte zu den drei blondierten Typen vor uns &quot;Wenn Ihr Euch noch jemand sucht, dann kommt ihr für den Viererpreis rein. Und das ist fünf Euro günstiger!&quot;. Mir fiel wieder ein warum ich Groupon so schrecklich hasse und fühlte mich unwohl.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIn der Halle werden wir von einem höllischen Lärm und vollkommen übersteuerten Lautsprechern empfangen. Übersteuerte Menschen. Die Hemdkrägen höher als der IQ. Alles dröhnt. Billig produzierte Beats, wippende Motivshirts und tiefe Ausschnitte, die signalisieren sollen, dass man leicht zu haben ist. Jeder hier ist leicht zu haben. Diese Erkenntnis zieht sich wie ein roter Faden durch die ganze Nacht. Frauen verhalten sich. Männer verhalten sich. Mich beschleicht das dumpfe Gefühl Emanzipation könnte hier gescheitert sein. Und wieder kann man niemandem einen Vorwurf machen, außer der Gesellschaft. Und die kann man nicht mal im Ganzen anspucken. Ich will einen Schuldigen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/Megaparty3.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t10 Gründe, warum ich Menschen hasse - die 90er Megaparty Edition:</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t1. Rosa Hemden und Make-Up-Ränder bei Männern</p>\n<p>\n\t2. Weil sich über Musik tänzerisch lustig machen in etwa so lustig ist wie Holocaustwitze und Vegetariern Rinderbrühwürfel in den Kaffee werfen</p>\n<p>\n\t3. Das Minimotorrad auf der Bühne</p>\n<p>\n\t4. Weil ausnahmslos alle &quot;Schuhe&quot; auf dieser Party aus dem Dong Xuan Center in Lichtenberg stammen</p>\n<p>\n\t5. Weil der DJ das Publikum mehrere Stunden alle vier Minuten fragt &quot;Und, habt ihr Bock auf Brooklyn Bounce?&quot; und immer alle im Einklang &quot;Whoooo!&quot; antworten</p>\n<p>\n\t6. Weil mich eine ziemlich unfreundliche Person mit &quot;Entschuldigung, Du sitzt auf unseren reservierten Stühlen!&quot; mitten in der Halle anschreit und ich &quot;Ich sehe hier keine Schilder!&quot; antworte und sie mir dann mit &quot;Ich hol die Security!&quot; droht und ich mit &quot;Ja, was auch immer!&quot; antworte</p>\n<p>\n\t7. Weil fünf Minuten später ein Security erscheint, der sich für ziemlich wichtig hält und mich ohne zu fragen direkt anschreit &quot;Sofort aufstehen!&quot;. Weil ich ihm antworte &quot;Warum?&quot; und weil er wieder schreit &quot;Sofort aufstehen!&quot;. Ich stehe auf, beuge mich vor und spreche ihm direkt in sein kleines angewachsenes Ohr, das sich vor zu intensiver Solariumleidenschaft leicht pellt. &quot;Ich habe hier kein Schild gesehen. Aber wissen Sie was? Sehen Sie hier mein Schild? Nein. Schade! Denn darauf steht ICH GEBE KEINEN FICK, ALTER!&quot;. Dann gehe ich zwei Meter weiter, wo sich direkt der nächste Mensch von meiner bloßen Erscheinung gleich derart provoziert fühlt, dass er mich affig antanzt und mein Bier mit seinem muskulösem Oberkörper leicht verschüttet. Ich beuge mich wieder vor und sage &quot;Durch dein Hemd in der Hose wirkt dein Genitalbereich voluminöser und das gefällt mir!&quot; und verlasse diese Ecke der Halle. Sie wissen jetzt, dass wir nicht dazugehören.</p>\n<p>\n\t8. Weil der Ausgang aus der Halle mit einem Bauzaun versperrt ist und händisch geöffnet werden muss. Man muss darum bitten die Halle verlassen zu dürfen. Wie schlimm sich das anfühlt.</p>\n<p>\n\t9. Weil synthetische Textilfasern schneller nach Schweiß riechen</p>\n<p>\n\t10. Mono-Menschenmassen</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/Megaparty4.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tSeit ich mich erinnern kann, jagen mir Mono-Massen große Angst ein. Viele Menschen, die alle gleich zu ticken scheinen, die die gleichen Interessen haben und ähnlich gekleidet sind, auf engstem Raum. Zusammen. Als eine Einheit. Die hässliche Psychologie der Masse. Diese pubertäre gegenseitige Hochschaukeln und &quot;Eins fühlen&quot;. Ich möchte mich nicht Eins fühlen. Ich möchte kein Ganzes ergänzen. Gerne bin ich das verfickte Teil, das zum Ganzen fehlt. ich möchte alleine sein und meine Ruhe haben.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tMir war alles irgendwann zu viel. Ich sackte kraftlos und menschlich desillusioniert an der Wand im Eingang zusammen. Dies war mein letzter großer Flug. Ich möchte das nicht mehr mit diesen Menschen und der Musik und der Gesellschaft, Staat und &quot;Eine Welt&quot;. Ich schaffte es noch eben auf der Damentoilette einen kritischen Lippenstift-Schriftzug zu hinterlassen, bevor ich fluchtartig die Halle verlasse. Bis zum Hauptact Brooklyn Bounce habe ich es nicht ausgehalten und mehr habe ich nicht zu erzählen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/Megaparty5.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWenn das die 90er sind, dann möchte ich rückwirkend direkt nach meiner Geburt sterben.&nbsp;</p>\n"}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

	module.exports = {"title":"Die Ada Blitzkrieg Homestory II","date":"2013-04-23 16:06:11 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/adatv.jpg\" alt=\"adatv.jpg\" />\n<p>Die Menschen fragen mich immer “Wie lebst Du so, Ada Blitzkrieg!” und ich sage “So!” und zeige ihnen dieses Video:</p></p>\n<iframe src=\"http://player.vimeo.com/video/64625377\" width=\"500\" height=\"281\" frameborder=\"0\" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe> <p><a href=\"http://vimeo.com/64625377\">Ada Blitzkrieg Homestory II</a> from <a href=\"http://vimeo.com/bangpowwww\">Ada Blitzkrieg</a> on <a href=\"http://vimeo.com\">Vimeo</a>.</p>\n"}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

	module.exports = {"title":"Die Blitzkrieg Filmographie","date":"2015-02-16 16:34:36 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2015/Feb/Screen-Shot-2015-02-16-at-17-12-18-1.png\" alt=\"alt\"></p>\n<p>Mein Lieblingsregisseur? Ich selber. Mein Lieblingsschauspieler? ALF the Cat. Meine Superpower? Wurst abbilden und idiotische Schnitte.\nIch habe für Euch etwas in meiner alten Filmkiste (<a href=\"https://www.youtube.com/user/lsf90/\">YouTube</a>) gekramt und die Highlights der letzten Jahre Blitzkrieg Filmproduktion wieder auferstehen lassen. Natürlich hat das auch einen Grund - ich habe ein neues Video in der Mache. Bringt also schon mal Eure Väter in Sicherheit, zieht Euch die Hosen aus und habt Spaß!</p>\n<p>In diesem kleinen Portrait über meinen Alltag verrate ich Euch wie man auf einen zwei Meter hohen Schrank springt und dafür die Energie aus hartgekochten Eiern nutzt:</p>\n<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/4k9sMg0zpfA\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Außerdem nehme ich Euch mit auf eine Reise in meinen Kopf, bzw. auf eine Reise in der mein Kopf in einer Mülltüte weggeworfen wird:</p>\n<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/p6Xgq0P3JKE\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Kinder sollten auf keinen Fall “Ulrich” gucken!</p>\n<iframe width=\"420\" height=\"315\" src=\"https://www.youtube.com/embed/2KNHh1_N3B0\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Wusstet Ihr, dass ich mal ein eigenes Mesut Özil Museum besessen habe? Zur Eröffnung habe ich einen lebensgroßen Özilkopf mit Pappmaché nachgebaut und mit einer Rakete in die Luft gejagt.</p>\n<iframe width=\"420\" height=\"315\" src=\"https://www.youtube.com/embed/URWfXE9fB08\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Ich möchte nicht prahlen, aber meine Prognose bezüglich der Zukunft der Printmedien scheint einzutreffen:</p>\n<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/OpV9OIDgj2Y?list=UUrHEkMzQAYHb_2J6VYP9cNA\" frameborder=\"0\" allowfullscreen></iframe>\n"}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

	module.exports = {"title":"Die Dürüm Depression","date":"2014-08-05 14:43:44 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2014/Aug/Foto-2--6--1.JPG\" alt=\"alt\"></p>\n<p>Meine Stimmungen sind wie schöne, wilde Tiere. Fremd und irre. Von Außen sind sie bestimmt wunderbar zu beobachten. Faszinierend und etwas gefährlich. Sie sind unvorhersehbar und wenn man ihre schillernde Schönheit endlich erkannt hat, liegt man bereits mit zerbissenem Genick unter ihnen oder sie sind schon längst ausgestorben. Nicht mehr greifbar. So ist das. Und das ist nicht immer schön. Das war es nie.</p>\n<p>Gerade ist wieder Dürüm und Selbsthass angesagt. Doch was war passiert?</p>\n<p><img src=\"/content/images/2014/Aug/Foto-4.JPG\" alt=\"alt\"></p>\n<p>Hallo, ich bin Ada und ich habe extreme Stimmungsschwankungen. Ich habe sie einfach. Ich möchte das Wort “leiden” nicht benutzen. Ich leide nicht unter ihnen. Ich leide in erster Linie an mir selbst. Also habe ich sie. Diese Schwankungen zieren meine Biographie schon sehr lange und manchmal sind die Perioden kurz und intensiv, manchmal nur wie ein leichter Schleier, der sich schmierig über einige Wochen legt und den Blick verdunkelt. Aber immer sind sie da, weil ich es auch bin. Ich kenne mich nur so. Labil. Zerbrechlich. Emotional. Weinend. Vor Glück kreischend. Bester und schlechtester Mensch der Welt zugleich.</p>\n<p>An die Zeit bevor das alles mit den Brüsten, der Überheblichkeit und den Zweifeln kam, erinnere ich mich kaum. Mein Tagebuch erzählte mir jüngst etwas anderes und ich erschrak. Die Geschichte vom inneren Wert und dem Wert der Welt. Mein Selbstwertgefühl ist immerzu betrunken und taumelt. Und das schon echt lange. Ganz schön irre, denke ich mir und fahre mir den dritten Dürüm am heutigen Tag im abgedunkelten Wohnzimmer rein, während sich in meinem Mailaccount die Verpflichtungen zu riesigen Bergen, zu unüberwindbaren Gebirgen anhäufen und alles zerbricht, so denke ich. Den Spiegel habe ich vor einiger Zeit umgedreht. Ich antworte kaum mehr. Ich versacke. Freunde kennen das mit mir bereits. So bin ich, sagen sie. Zumindest glaube ich das. Freunde wissen, man lässt mich etwas, rede ich mir ein. Bald gehe ich bestimmt wieder aus. Bald wird es wieder gut sein. Die Ada fängt sich immer irgendwie. Ach Ada! Kein Bock mehr auf Stillstand. Ich will dort draußen wieder an den Dingen teilnehmen und ich will mehr vom verschissenen Tag haben als die Zeit zwischen meinen Dürüms abzusitzen und mich dafür zu hassen nur die Zeit zwischen meinen Dürüms abzusitzen.</p>\n<p><img src=\"/content/images/2014/Aug/Foto-1--5-.JPG\" alt=\"alt\"></p>\n<p>Irgendwann war ich mir unsicher ob das alles so muss. Ob ich noch ausreiche. Ob ich nicht lieber klein bleiben wollte. So ohne Brüste. Ohne Rollenbild und ohne Ansprüche. Die anderen funktionierten doch immer so herrlich. Ich wollte das auch. Wollte, dass mein Körper passte. Wollte Hobbys, die ein Mädchen wollen sollte. Mit Ansprüchen habe ich heute noch meine Probleme. Mit 28 kann ich es nun sagen, ich habe noch nie Ansprüche enttäuscht. Ich war immer exzellent in der Schule. Ich war fantastisch im Ich sein. Ich war nahezu perfekt im perfekt sein. Schnellstes, schlaustes, schönstes Kind. Dann kam Unsicherheit. Aber warum? Ja, warum eigentlich?</p>\n<p><img src=\"/content/images/2014/Aug/Foto-2--5-.JPG\" alt=\"alt\"></p>\n<p>In all der Bemühung wurde ich irgendwann rebellisch. Und ich wurde traurig. Ich optimierte mich im Enttäuschen von Ansprüchen auf das höchste Maß. Mit 11 oder 12 oder 13 habe ich zum ersten Mal erlebt wie man sehr traurig ist. Dieser Gefühl war neu und intensiv. Mit meinem Minipiano habe ich die kompletten Sommerferien im Dauerregen am Fenster meines Kinderzimmers gesessen und mich fremd gefühlt. Alleine. Einerseits selbst genau so gewollt, so sagte ich mir, aber andererseits halt eben trotzdem verdammt alleine. Mich verstand keiner mehr. Warum weinte das Kind so viel? Warum traf es keine Freunde mehr? Warum schaute es nur noch Nachrichten und weinte wegen der Welt?</p>\n<p>Immer ist etwas und ich wünsche auch heute noch oft genug, wenn es mir gerade sehr schlecht geht, dass mich das alles nichts angehen würde und das mal nichts wäre. Welt ausknipsen. So ein Herz aus Stein, schade dass man sich nicht bewusst dafür entscheiden kann. Zumindest wenn man so ein schwacher Kerli ist, wie ich es dann immer von mir glaube. Sei es der gottverdammte Hund, den meine Eltern mir nicht kaufen wollten, als ich gerade 12 war und ich mich einsam fühlte. Sei es der Balkankrieg über den ich Gedichte und Songs mit Tränen in den Augen schrieb, sei es der Gazakonflikt heute und die dumme Scheiße die immerzu abgeht. Antisemitismus. Die Menschen sind so dumm. Ungerechtigkeit überall. Im Fernsehen. In den Menschen. In den Herzen. FUCKTHATSHIT! Dumme Sätze, die dumme Idioten auf Facebook teilen. Ich kann es nicht mehr filtern. Ungebremst bratscht die ganze negative Kacke durch einen durch und zersiebt das Innerste. Abends weint man viel. Morgens liegt noch unendlich Tag vor einem. Anstregend, Es ist manchmal eben alles zu viel. Man will die Welt aus seinem Leben entfernen, findet aber das Lösungsmittel nicht.</p>\n<p><img src=\"/content/images/2014/Aug/Foto-3--4-.JPG\" alt=\"alt\"></p>\n<p><img src=\"/content/images/2014/Aug/Foto-1--6-.JPG\" alt=\"alt\"></p>\n<p>Hier könnte die Erzählung eigentlich zu Ende sein. Wenn es da nicht auch die andere Seite geben würde. Anstrengend.</p>\n<p>Plötzlich passiert mit mir etwas. Wenn die Depression verschwindet. Leider geschieht es nicht, wie es vorgesehen ist, so dass man durchatmen kann. Es passiert das genaue Gegenteil. Ich werde schnell, flink, schillernd. Ich klappe auf wie ein Messer, das mit spitzer Klinge durch die Welt rast. Plötzlich wechseln sich meine Kleider, das Leben wird bunt, und ich laufe lachend durch die Straßen. Der schönste Papagei der Welt und was der zu erzählen hat, wird gehört. Man lächelt mich wieder an. Ich sehe plötzlich wieder aus. Ich tausche den Dürüm gegen aufwendige Speisen, die ich mir in aller Sorgfalt und Selbstliebe stundenlang zubereite. Ich decke den Tisch. Ich bilde mich. Ich esse auf einem Stuhl sitzend und nicht auf dem Sofa. Ich arbeite, flaniere, funktioniere. Soll die Welt mich doch sehen. Anstrengend. Die Zweifel, die noch einige Tage zuvor in mir wohnten, welche es mir nicht erlaubten am hellichten Tag auf die Straße zu gehen oder Freunde zu treffen, weil ich so schrecklich aussah, wie ich glaubte, oder so ein schlimmer Loser war, wie ich annahm, sind wie weggeblasen. Anstrengend. Ich bin die schönste Person der Welt. Ein echter Erfolgstyp.</p>\n<p><img src=\"/content/images/2014/Aug/Foto-3--3--3.JPG\" alt=\"alt\"></p>\n<p>In meiner Jugend bin ich in diesen Phasen nächtelang um die Häuser gezogen, habe gestohlen, Raptexte geschrieben, gekifft und mir Jungs klargemacht. Sex. Heute kenne ich mich ein wenig und muss dann am meistens auf mich aufpassen. Anstrengend. In den Momenten in der Nacht, wenn ich plötzlich um vier Uhr noch das Haus verlassen will. Weil ich so glücklich bin, dass die Sorgen endlich weg sind. Anstrengend. Wenn man sich plötzlich federleicht und leer fühlt, weil man abhebt und schwebt, denn die Schwere ist aus einem herausgelaufen. Einfach so. Unverwundbar. Anstrengend. Weil man auferstanden ist, unter diesen Trümmern an emotionaler Scheiße, die nun in der Retrospektive total dumm, kindisch und bescheuert wirken. Weil man alles das geleistet hat. Spitzentyp. Wie Jesus. Anstrengend. Unter der Woche. Nachts. Aus dem Haus. In die Welt. Ins Leben. Um Drogen zu kaufen, zu sprechen und einfach etwas zu tanzen.</p>\n<p>Ich muss dann besonders auf mich aufpassen, denn ich mag gar nicht der irrsinnige Spitzentyp sein. Ich mag im Grund lieber daheim und ganz, heil und unversehrt bleiben. Und Partydrogen mag ich nicht. Weil ich groß geworden bin und stolz auf mich sein kann. Dann passe ich heute auf mich auf, dann schreibe ich und male. Weil ich das inzwischen kann. Mir soll nichts passieren, denn ich bin wertvoll. Niemandem soll etwas passieren. Man muss auf sich aufpassen!</p>\n<p><img src=\"/content/images/2014/Aug/Foto-5.JPG\" alt=\"alt\"></p>\n<p>Dieses Foto ist während der schlimmsten Phase der letzten Wochen entstanden. Im Regen. Beim Schwimmen. Ich hatte kurz das Gefühl normal zu sein. So ohne Spitzentyp oder Loser. Wie sich so ein Mensch eben fühlt, wenn er im warmen Wasser treibt und kalte Regentropfen auf seine Füße fallen. Ganz schön in Ordnung. Und das reicht mir auch schon, um sagen zu können, ich bin in Ordnung so wie ich bin und ich mach das einfach mal weiter.</p>\n"}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

	module.exports = {"title":"Die Illusion einer Überflussgesellschaft - Containern in Berlin","date":"2012-04-20 15:18:44 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/containern4.jpg\" alt=\"containern4.jpg\" />\n<p>Mal wieder irgendeine bescheuerte und völlig überbewertete Uhrzeit an einem beliebigen Wochentag im Frühling. Gerade warm genug um keine Blasenentzündung beim Outdoorpinkeln zu bekommen, aber immer noch zu kalt um betrunken gegen einen Zaun zu steuern und die Nacht im weichen Grasmassengrab der Exkremente französischer Bulldoggen zu verbringen.</p>\n<p>Wir wollen containern.\n**\nWenn das Glück angeblich auf der Straße liegt, wieso hilft ihm dann keiner auf?** Überflussgesellschaft hier und da. Wir kaufen zu viel. Mutter sagt, schmeiß nichts weg. Wir denken zu wenig. Irgendwo zwischen den Mülltonnen muss das Glück liegen. Massenhaft fabelhafte und köstliche Lebensmittel, die Lebensmittelmärkte ungeachtet wegwerfen. Freude für diejenigen, die es sich sonst nicht leisten könnten. Obst, Vitamine, Nudeln, Milch. Ungekauft ablaufend, ungeliebt im Übermaß. Genießbarer Verfall. Wo genau beginnt das Zuviel einer Gesellschaft? Wo wird es entsorgt? Biosupermärkte so weit das Auge reicht. Die müssen doch viel wegwerfen, schließlich dürfen die in ihren Produkten keine Konservierungsmittel verwenden. Glied an Glied in der endlosen Dauerschleife von Menschen die viel zu viel Geld haben, dort wo andere Menschen zu wenig haben. Überproduktion. Regalaufhübscher. Füllmasse der Supermarktglotzereien.</p>\n<p>Berlin Kreuzberg - 1:00 Uhr. Wir auf unseren Fahrrädern. neugierig und naiv. In der Hoffnung gleich den größten Fund unseres Lebens zu machen - im Müll. Rohen Fisch. In den 90er abgelaufenen Joghurt. Hartwurst. Stunden später sitzen wir etwas enttäuscht wieder daheim. Doch ist das nun eigentlich gut oder schlecht?</p>\n<p>Doch von vorne: Im <a href=\"http://www.containern.de/\">Containern</a> Forum erfahre ich im Vorfeld allerhand Wissenswertes und allerhand unnützes Zeug. Jeder zweite Eintrag stammt von einem Journalisten oder Fernsehfuzzi, der die Mitglieder der Containergemeide dazu aufruft sich bei ihnen zu melden. Man möchte medientauglich begleiten, Fotos und Videos. “Findet für uns den Überfluß!” Containern, das hat inzwischen jeder Sender ausgeschlachtet. Wenn man den unzähligen Berichten glauben soll, dann liegt das Schlaraffenland in einem schwarzen Containern hinter jedem WALDI NORD. Wir wollen nicht wirklich containern, denn wir möchten den Menschen, die wirklich Hunger haben nichts wegnehmen. Wir möchten lediglich den Müll studieren um aus ihm abzulesen wohin wir uns bewegen.</p>\n<p>Alle Container sind ausnahmslos verschlossen. Die Ernüchterung. Vielleicht hätte ich vorher nicht twittern sollen, dass ich gleich containern gehe? Den durch die Medien versprochenen Fresssegen finden wir nicht. Wir finden aber auch keine <a href=\"http://derstandard.at/1226396871388\">vergifteten Lebensmittel</a>. Ob BRUTTO, Minus, AKNEKA, KÖNIGS oder wie der ganze andere Unsinn heißt, nichts. In Berlin liegt Müll und Lebensmittelglück nicht auf der Straße. Wir schließen unseren Überfluss weg. Selbst den überschüssigen Überfluss teilen wir nicht mehr. Man möchte nicht vorschnell urteilen. Vielleicht spenden inzwischen viele Supermärkte ihre abgelaufenen Lebensmittel an <a href=\"http://www.tafel.de/\">die Tafeln</a> oder einen sonstigen guten Zweck. Bestimmt möchte man nicht, dass sich nachts dunkle Gestalten über Müllcontainern hermachen und wie die Ratten nachts um die Hausecken huschen, als wenn dies die sonstigen Produkte entwertet. Kontrollverlust. Dabei gibt es beim Containern wichtige Regeln zu beachten:</p>\n<ul>\n<li>\n<p>Nimm dir nur so viel, wie du auch tragen und essen kannst!</p>\n</li>\n<li>\n<p>Räume den Platz nachher auf und verlasse ihn wie du ihn angetroffen hast!</p>\n</li>\n</ul>\n<p>Der Biomarkt besticht durch einen 80000000qm Innenhof mit Kameraüberwachung. BRUTTO scheint überhaupt keinen Müll zu produzieren. Hier gibt es weder Zugänge zu Innenhöfen, noch Tonnen oder sonstige Verschläge, in denen teure Müllschätze auf einen mutigen Entdecker warten.</p>\n<img src=\"/content/images/containern3.jpg\" alt=\"containern3.jpg\" />\n<p>Schließlich finden wir doch Container. Ich reiße den Kram auf. Nur Hausmüll. Binden. Alte Pullover. Matschkarton. Vielleicht war jemand vor uns dort.</p>\n<img src=\"/content/images/containern2.jpg\" alt=\"containern2.jpg\" />\n<img src=\"/content/images/containern1.jpg\" alt=\"containern1.jpg\" />\n<p>Die Tipps der Container-Gemeinde bestätigen dies: Lieber Randgebiete. Lieber kleine Märkte (die sollen oft sogar so freundlich sein und im stillen Einverständnis ihre abgelaufenen Lebensmittel in einer Kiste auf die Mülltonnen stellen). Lieber Spätabends nach Ladenschluss.</p>\n"}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

	module.exports = {"title":"Die Naziheimat möchte keine Moschee","date":"2014-10-17 17:10:40 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2014/Oct/2535778673_bf7f42054d_b.jpg\" alt=\"alt\">\nFoto: <a href=\"https://www.flickr.com/photos/gregmote/2535778673\">Greg Mote</a></p>\n<p>Es ist ja nicht gerade ein großes Geheimnis, dass ich nicht aus Berlin stamme, sondern aus einer recht nazidurchsetzten Gegend im Westerwald: <a href=\"http://www.hachenburg.de/\">Hachenburg</a>. Ich erinnere da gerne an “glorreiche” Dinge wie:</p>\n<ul>\n<li>\n<p>Die <a href=\"http://www.netz-gegen-nazis.de/lexikontext/kameradschaft-westerwald\">Kameradschaft Westerwald</a></p>\n</li>\n<li>\n<p>&quot;O Du schöner Westerwald, über Deine Hügel pfeift der Wind so kalt.“ <a href=\"http://www.indiepedia.de/index.php?title=Rheinland-Pfalz\">Das Westerwaldlied, Nazilied für völkische Propaganda von 1936</a></p>\n</li>\n<li>\n<p>Die damaligen Proteste und das große Engagement der Anwohner gegen die Rückbenennung der <a href=\"http://www.denktag-archiv.de/Rueckbennung-der-Judengasse.2674.0.html\">Judengasse</a>, die im dritten Reich zwangsumbenannt wurde. Selbstverständlich nach der Vertreibung und Ausrottung der ansässigen Juden, sowie der Zerstörung der inneren Synagoge und deren Umnutzung als deutsche Berufsschule.</p>\n</li>\n<li>\n<p>Die Ermordung des 17-jährige <a href=\"http://de.wikipedia.org/wiki/Nihat_Yusufo%C4%9Flu\">Nihad Yusufoglu</a> durch Nazis in Hachenburg.</p>\n</li>\n</ul>\n<p>Ich kann mich noch äußerst genau an den Tag erinnern, an dem meine Eltern und ich in den 90ern auf die Straße gegangen sind, um anlässlich der Ermordung von Nihad gegen rechtes Gedankengut zu demonstrieren. Ich werde niemals vergessen wie ich mich damals, als sehr junges Mädchen, bereits fragte, wer zur Hölle an diesem gottverdammten Tag eigentlich nicht auf der verdammten Demo mitläuft und warum. Diese Frage stelle ich mir bis heute. Und genau jetzt ist die Frage wieder sehr aktuell geworden, denn viele Einwohner der Stadt wehren sich derzeit gegen den geplanten Bau einer Moschee am Stadtrand.</p>\n<p><img src=\"/content/images/2014/Oct/6669275075_cc6008d4d0_b.jpg\" alt=\"alt\">\nFoto: <a href=\"https://www.flickr.com/photos/thomasmies/6669275075\">Thomas Mies</a></p>\n<p>Kurzerhand starteten die “besorgten” Bewohner eine <a href=\"https://www.openpetition.de/petition/online/keine-moschee-in-hachenburg\">Onlinepetition</a> gegen den geplanten Bau der Moschee mit folgendem Wortlaut:</p>\n<blockquote>\n<p>“Keine Moschee in Hachenburg! Dies ist eine stille Initiative gegen die Erbauung einer Moschee in Hachenburg. Diese Seite hat und teilt kein Rechtes Gedankengut. Sie soll lediglich den Protest gegen ein Gotteshaus darstellen, in der Unterdrückung und Aufrufe zur Gewalt zur Tagesordnung gehören. Wir sind froh das in unserem christlich orientierten Städtchen die “Welt noch in Ordnung” ist. Die westliche Einstellung, das Grundgesetz der BRD, sowie unsere gültigen Gesetzte sind mit dem Islam und deren Kultur nicht vereinbar. In jüngsten Nachrichten sieht man das Gewaltpotential dieser Religion. Hier zeige man nicht nur nach Syrien, Afghanistan und in den Irak, nein die Gewalt ist schon in Hamburg, Celle und Frankfurt angekommen. Soweit wollen wir es hier nicht kommen lassen. Daher: Keine Moschee in Hachenburg!”</p>\n</blockquote>\n<p>Die sind mal richtig gut drauf - die Dörfler, denke ich mir. Schon 250 Unterschriften. Hui. Die meisten selbstverständlich anonym. Viele sogar aus den umliegenden Minikäffern. Richtig engagiert, wenn es um den Erhalt einer Stadt geht, in der die “Welt noch in Ordnung” ist.</p>\n<p>Dazu ist zu sagen, dass in Hachenburg ein sehr geringer Anteil von Menschen mit muslimischen Glauben lebt. Es gibt keinesfalls die “große Gefahr” für “demokratische” und “christliche” Werte der Stadt, mit denen die Petition an den hölzernden Türen der Provinzler hausieren geht.</p>\n<p>Wer will, liest mal die <a href=\"https://www.openpetition.de/petition/kommentare/keine-moschee-in-hachenburg\">Kommentare</a> unter der Petition. Diese Dorfdummheit macht mich heute ganz krank. Sprachlich und inhaltlich. Ich falle vom Lachen ins Weinen. Leider reden viele Menschen dort auch so wie sie schreiben. Und traurigerweise glauben viele Menschen auch was sie verschriftlichen. So hat sich eine kleine aber feine Sammlung menschlicher Dummheit in Form von Kommentaren manifestiert. Ich lade Euch also herzlich zu einer Runde <a href=\"http://upgrademeblog.com/2013/07/11/das-heimliche-rechte-bullshit-bingo/\">Bullshit-Bingo</a> ein und präsentiere Euch hier einige der dümmsten Kommentare - mit Gruß in die Heimat!</p>\n<p>So funktioniert Bullshit-Bingo:\n<img src=\"/content/images/2014/Oct/das-heimlich-rechte-bullshit-bingo.png\" alt=\"alt\">\nQuelle: <a href=\"http://upgrademeblog.com/2013/07/11/das-heimliche-rechte-bullshit-bingo/\">Upgradememblog</a></p>\n<h4>Und so sehen die Kommentare unter der Petition aus, die sich der Frage widmen “Warum für die Petition stimmen?”:</h4>\n<blockquote>\n<p>“Für die Erhaltung der Kultur!”</p>\n</blockquote>\n<p><a href=\"http://en.wikipedia.org/wiki/Leitkultur\">:(</a></p>\n<blockquote>\n<p>“Weil ich dagegen bin.”</p>\n</blockquote>\n<p>Mein persönlicher Lieblingskommentar.</p>\n<blockquote>\n<p>“Da ich dagegen bin.”</p>\n</blockquote>\n<p>Dicht gefolgt von diesem Kommentar. Die Entscheidung fiel mir echt schwer.</p>\n<blockquote>\n<p>“Es gibt in Betzdorf zwei Moscheen und ich denke es gäbe jetzt mal wichtigeres, das vorrang hätte, statt in Hachenburg eine Moschee zu errichten.”</p>\n</blockquote>\n<p>Zum Beispiel Leitkultur voranzubringen und zu erhalten?</p>\n<blockquote>\n<p>“Um unsere kultur zuschützen!”</p>\n</blockquote>\n<p>Vielleicht mal eine Petition gegen <a href=\"http://de.wikipedia.org/wiki/Mischehe_(Nationalsozialismus)\">Mischehen</a> starten? Ach ja, gab es ja schon.</p>\n<blockquote>\n<p>“Es geht einfach zu weit mittlerweile!”</p>\n</blockquote>\n<p>Fast schon poetisch.</p>\n<blockquote>\n<p>“Ich bin in Hachenburg geboren, und deswegen unterstütze ich das .”</p>\n</blockquote>\n<p>Zwingende Logik. Einwandfreie Kausalität.</p>\n<blockquote>\n<p>“Mir ist es wichtig das keine Moschee in Hachenburg gebaut wird , denn ich habe gehört sie soll außerhalb der Stadt auf dem alten schiesplatz gebaut werden und da kann ich aus meinem Schlafzimmer drauf gucken!!!”</p>\n</blockquote>\n<p>Ich musste ihm beim Schießen immer beim Kein-Sex-Haben zuschauen.</p>\n<blockquote>\n<p>“Gleiches Recht für alle ! Ich darf auch keine Kirche in Istanbul errichten.”</p>\n</blockquote>\n<p>Vermutlich bist du auch zu dumm um eine Kirche baulich zu entwerfen und zu erichten.</p>\n<blockquote>\n<p>“Da der Bau einer Mosche zu weit geht! Deutschland tut bereits genug für das Ausland, wir lassen sie hier leben, geben ihnen Unterkunft, Geld und Arbeit und jeder kann hier Zuflucht finden. Wenn wir deutschen eine Kirche in der Türkei bauen würden, würde diese in Brand gesetzt werden und zerstört werden. Dutschland ist mittlerweile viel zu tollerant geworden und wenn das so weitergeht wird aus Deugschland bald Mischland…!!!”</p>\n</blockquote>\n<p>Fazit: Ich würde gerne die Kultur im Allgemeinen vor dummen Menschen beschützen und bin daher für den Abriss der drei im Ort ansässigen Kirchen und des naheliegenden Kloster Marienstatt, so wie der dort angeschlossenen Schule. Unterzeichnen kann man meine Petition <a href=\"http://www.omgcatsinspace.com/\">HIER</a>.</p>\n<h3>Nachtrag aufgrund der unzähligen, persönlich stark beleidigenden Mails und Kommentare, die ich bei Facebook im Laufe des gestrigen Tages bekommen habe. Darunter konkrete Drohmails für mich, meine Familie und unsere Freunde, sowie die vielen Beschimpfungen:</h3>\n<p>Im Westerwald, der hier nur stellvertretend für beliebige Orte in Deutschland steht, gibt es ein großes Problem mit rechtem Gedankengut. Dem Fall Hachenburg habe ich mich angenommen, weil es der Ort ist, an dem ich biographisch 19 Jahre meines Lebens verbracht habe. Der Artikel ist in meinen Augen mehr als notwendig. Viele Bewohner scheinen sich allerdings durch die offene Nennung der vorhanden Problematik angeriffen zu fühlen, und reagieren mit großem Engangement bezüglich der Beleidigung und Einschüchterung meiner Person.</p>\n<p>Ich weiß, dass meine Eltern und viele Menschen im Ort diesen Artikel und mich in seiner Intention unterstützen. Das sehe ich an den Likes und den ebenso unfassbar vielen positiven Zuschriften, die sich ebenfalls eine weltoffene Stadt wünschen. Diese Menschen leben gerne in Hachenburg, fühlen sich aber durch die unsägliche Petition und die fremdenfeindliche Diskussion, sowie durch die Relativierung deren Vorhandenseins nicht gerade wohl. Mir geht es nicht darum zu zeigen, dass alle Menschen speziell in diesem beispielhaften Ort rechts sind. Das behauptet der Text auch schlichtweg nicht. Ich spreche von einer “sehr nazidurchsetzten Gegend”, was sich für mich letztlich auch herrlich anhand der Petition und den Drohungen und Beleidigungen belegen lässt, die gestern im Laufe des Tages bei mir eingegangen sind.</p>\n<p>Mein Dank geht vorallem an diejenigen, die dem Bau gegenüber freundlich gestimmt sind und diesen Artikel nicht als Angriff auf Hachenburg sehen, was im übrigen eine wundervolle Stadt ist, die ich immer wieder gerne besuche, sondern den Angriff als das werten, was er ist: Ein Angriff auf die unzähligen Vollidioten, die dort leben und mit ihrer Petition und ihrer Deutschheit das Klima für Einwohner anderer Kulturen verderben.</p>\n"}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

	module.exports = {"title":"DIE STRENGE - Ein Leseheft von Ada Blitzkrieg","date":"2014-07-24 11:23:02 +0000","tags":null,"layout":"post","body":"<p>Endlich steht mal wieder ein großartiges Release meiner Texte vor der Tür und dieses Mal ist es ein hübsches Projekt bei dem tollen Verlag <a href=\"http://www.sukultur.de\">(SuKultur)</a> geworden, der meine Geschichte ab sofort als eBook, als Leseheftchen über den Onlineshop oder als Automatenkauf in Vending Machines an unterschiedlichen Standorten verkauft.</p>\n<p><img src=\"/content/images/2015/Jan/strenge-3.jpg\" alt=\"alt\"></p>\n<p><a href=\"http://www.sukultur.de/die-strenge.html\">Die Strenge</a>, so lautet der Titel des Werkes, ist ein ganz besonderes Stück Blitzkrieg geworden, dass sich im Regal äußerst gut neben Dem Mann ohne Eigenschaften und einer Flasche Sliwowitz machen kann, wenn man es denn nur lässt.</p>\n<h1>Textauszug:</h1>\n<p>“Für den Fall, dass Herr K. nun nicht tot auf dem weißen Vinyl seines Arbeitstraumes liegen würde, hätte die Histamin-Konzentration in seinem Blut in den folgenden Stunden unwiderruflich zu starken und schmerzhaften Blähungen geführt. Nun aber, da er eben tot ist, wird sein sportlicher Leichnam in dreißig Minuten von der netten Thea aus der Buchhaltung entdeckt werden, die aus Gewohnheit verschämt auf den Boden schaut. Dort wird heute allerdings ihr inzwischen ehemaliger Chef liegen und tot zu sein scheinen. Sie wird ihn kurz betrachten und die Mappe mit den Recruitment-Unterlagen auf dem rechten der beiden kniehohen Leuchtbuchstaben ablegen, der laut Company Philosophie für F wie FUTURE steht, eigentlich aber aus dem Fundus einer geschlossenen FDP Zentrale stammt.”</p>\n<iframe width=\"560\" height=\"315\" src=\"//www.youtube.com/embed/CMylGxfeG2E\" frameborder=\"0\" allowfullscreen></iframe>\n<h1>Buy Online:</h1>\n<p><strong>Als eBook <a href=\"http://www.sukultur.de/die-strenge-ebook.html\">HIER</a></strong>\n<strong>Oder als Leseheftchen <a href=\"http://www.sukultur.de/die-strenge.html\">HIER</a></strong></p>\n<p><strong>Automaten:</strong></p>\n<p>Berlin S-Bhf. Gesundbrunnen\nBerlin S-Bhf. Potsdamer Platz\nBerlin S-Bhf. Zoologischer Garten\nBerlin S-Bhf. Schöneberg\nBerlin S-Bhf. Tempelhof\nBerlin S-Bhf. Rathaus Steglitz\nRantum/Sylt\nRaum Sylt-Quelle, Hafenstraße 1, 25980 Rantum/Sylt</p>\n<h1>Über SuKultur:</h1>\n<p>The SuKuLTuR Publishing Company sells small books called Schöner Lesen for one euro in vending machines since 2004. Most vending machines selling Schöner Lesen you can find in Berlin, but also in other parts of Germany. With over 75.000 books sold so far, Schöner Lesen is a great success. The first books-only vending machine was established in June 2006 on the island Sylt.</p>\n<p>Mehr über den Verlag und die Automaten könnt Ihr <a href=\"http://www.sukultur.de/komplett.html\">HIER</a> erfahren. Die Automaten findet Ihr an den folgenden Standorten. Gründet also Banden, zieht Euch Strumpfhosen über die Gesichter und holt Euch meinen Text:</p>\n"}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

	module.exports = {"title":"Die Zukunft der Printmedien","date":"2013-03-03 00:00:00 +0000","tags":null,"layout":"post","body":"<iframe width='560' height='315' src='http://www.youtube.com/embed/OpV9OIDgj2Y' frameborder='0' allowfullscreen></iframe>\n<p>Eine kurze Prognose von Ada Blitzkrieg über die Zukunft der Printmedien.</p>\n"}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

	module.exports = {"title":"Dienstleister, die auf Dich scheißen: DHL","date":"2011-11-16 13:01:17 +0000","tags":null,"layout":"post","body":"<p>\n\t<img alt=\"\" src=\"/files/DHL.JPG\" style=\"width: 500px; height: 333px; \" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDienstleister, die auf Dich scheißen sind Dienstleister, die Dich auch gerne mal wie Dreck behandeln und Dir jederzeit zu spüren geben, dass sie auf Dein Geld und Dein Wohlwollen in keinster Art und Weise angewiesen sind. Warum Sie trotzdem um Dich als Kunden werben ist Dir unbegreiflich? Willkommen in der Wirtschaft! Wir sind Dreck!</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tVorweg: Dieser Beitrag ist als erster Teil einer zukünftigen Serie zu begreifen, die sich heute einem der bekanntesten Dienstleister widmet, der auf seine Privatkunden scheißt: DHL.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tSeit ich in Berlin wohne ist die Sache mit DHL ja so:</p>\n<p>\n\tPakete verschwinden spurlos oder werden bei Nachbarn abgegeben, deren Klingelschild nicht existiert. Sie tauchen manchmal Wochen später wieder auf oder verschwinden ganz. Pakete werden Nachbarn in die Hand gedrückt, die dann in Urlaub fahren oder nur nachts zwischen 2 und 6 Uhr daheim sind. Teilweise werden Pakete ein paar Häsuer weiter an völlig fremde Personen abgegeben. Nur damit wir uns richtig verstehen, ich beschwere mich nicht über die Menschen, die Pakete für andere annehmen, sondern über eine Praktik, die inzwischen bei DHL gang und gäbe geworden ist.</p>\n<p>\n\tRaum für Beschwerden gibt es nicht. Entweder man ruft die kostenpflichtige (!) Servicehotline an und bezahlt noch schön was drauf um seine berechtigte Kritik loszuwerden, oder man versucht es direkt in der Post, in der man aber garantiert von einer der dauergewellten Mitarbeiterinnen direkt an die Hotline verwiesen wird. Wie schön das System doch funktioniert! Keine direkten Ansprechpartner. Anonyme Paketboten und Briefträger. So kommt es dann zu Szenen, die sich mir bis heute als besonders arschlochhaft eingebrannt haben. &quot;Bitte gehen Sie weiter!&quot;.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tMachen wir uns nichts vor: Die Post ist kein ehrenamtlicher Dienstleister, sondern tauscht eine Leistung gegen eine monetäre Gegenleistung. Die Kippe hängt leider zur einen Seite über. Denn der Service ist in meiner Strasse kein Geld wert, wie ich an wahren Gegebenheiten im Folgenden ausführen möchte.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch bin, wie Ihr bestimmt wisst, freiberufliche Texterin und arbeite in meiner Wohnung. Daher bin ich häufig tagsüber daheim. Vor ein paar Monaten klingelte jeden Tag der Paketbote an meiner Wohnung (weil ich vermutlich so dumm war und ihm ein Mal einen Gefallen getan habe). Der &quot;gute&quot; Mensch klingelte teilweise schon um 10 Uhr. Das ist eine Uhrzeit, zu der ich normalerweise gerade meinen ersten Kaffee trinke oder unter der Dusche stehe. Ich öffnete die Tür mit großem Widerwillen und in großer Hektik mich anzukleiden, weil ich dachte es wären Freunde oder etwas &quot;wichtiges&quot;. Das ging dann ein paar Tage fröhlich so weiter, obwohl ich ihn freundlich mehrmals bat es zu unterlassen bei mir zu klingeln, wenn er kein Paket für mich oder meine direkten Wohnungsnachbarn habe. Beim ersten Mal nahm ich die Pakete noch unwissend an. Beim zweiten und dritten Mal will er mir sage und schreibe 6 (!) Pakete in die Hand drücken, die dann die einzelnen Leute alle im Laufe der nächsten Tage bei mir abholt hätten. Das ärgert mich, dann mich stresst die Tatsache, dass ich immer erwarten muss, dass es gleich klingelt. Ich nehme also lediglich ein Paket für meine direkte Nachbarin an, verweise ihn mit dem Rest an andere Etagen, und sage ihm noch eindringlich, dass er bei mir in Zukunft bitte nur noch klingeln soll, wenn er auch ein Paket für mich hat.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDamit wir uns richtig verstehen: Der DHL-Mann darf klingeln (soll er sogar), wenn er eine Sendung für mich hat. Vorausgesetzt er verfügt über diese Sendung, bin ich gerne bereit Pakete für die Menschen im Haus anzunehmen, die ich kenne und die mich kennen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDer Terror ging weiter. Er klingelte noch ein paar Mal an den danach folgenden Tagen und ich weigerte mich nach wie vor ein Paket für Unbekannte anzunehmen und sagte ihm dann recht deutlich die Meinung. Fortan wurde jeden Tag bei mir Klingelterror gemacht zur gleichen Zeit, nämlich immer, wenn gerade auch ganz zufällig kurz vorher die DHL Sendungen verteilt wurden. Wer war das denn nur? Auf mein Öffnen reagierte immer niemand. Der DHL-Mann war augenscheinlich nicht nur faul, sondern auch gehässig. Prima!</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEinige Monate später: Ein neuer Briefträger. Ich denke: Juhu! Und siehe da, vom einen auf den anderen Tag kein Klingelterror mehr. Aber zu früh gefreut. DHL scheißt einfach auf mich und auf dieses gesamte Haus. Von einigen netten Nachbarn erfahre ich dann folgendes: &quot;Hallo Ada, hast du auch so Probleme mit DHL? Wir haben schon ewig kein Paket mehr geliefert bekommen. Nur Zettel im Briefkasten.&quot; Und ja, ich bin den ganzen Tag daheim und die letzten Wochen kam tatsächlich kein Paket bei mir an, sondern wie durch ein Wunder lag immer nur der Benachrichtigungsschein der Sendung im Briefkasten, in dem man mich verweist die Sendungen bei der Post abzuholen. Ok, für meine Nachbarn kann ich mich nicht verbürgen. Aber ich arbeite wie gesagt den gesamten Tag an meinem Schreibtisch und kann sehr wohl beurteilen, ob der Paketbote im Laufe des Tages geklingelt hat. Hat er nicht. Macht er einfach nicht mehr. Zu faul? Hasst er seinen Job? Hasst er uns?&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tAber hey, immerhin ein Abholzettel, dachte ich manchmal, hinsichtlich der komplett vergessenen Benachrichtigung vom alten Paketboten.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDas schöne an diesen Abholzetteln ist ja, dass man sich in der örtlichen Postfiliale anstellen muss. Mein örtliches Postendlager ist die Filiale Frankfurter Allee. Kennt man ja. Minimum dreißig Minuten anstehen. Und einfach nur, weil der Postbote zu gehässig, beschäftigt oder zu faul ist um bei mir zu klingeln?</p>\n<p>\n\t&nbsp;</p>\n<h2>\n\tEine kleine Rechnung:</h2>\n<p>\n\tAlleine im letzten Monat habe ich circa 10 Paketsendungen erhalten. Davon sind vielleicht 5 bei Nachbarn abgegeben worden. Für 2 Sendungen musste ich inmtensiver telefonisch nachrecherchieren und 3 Sendungen habe ich in der Postfiliale abgeholt. Der Weg zu Fuß zur Post beträgt für mich circa 15 Minuten. Es fahren keine geeigneten öffentlichen Verkehrsmittel. Hin und zurück also 30 Minuten. Hinzu veranschlage ich 30 Minuten für das Anstehen in der Filiale.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<strong>Fußweg für einen Monat: 1 Stunde 30 Minuten</strong></p>\n<p>\n\t<strong>Anstehen in der Post: 1 Stunde 30 Minuten</strong></p>\n<p>\n\t<strong>Mehrmals bei Nachbarn klingeln um Pakete zu erhalten: 30 Minuten</strong></p>\n<p>\n\t<strong>Telefonrecherche bei DHL über den Verbleib der Sendung: 30 Minuten</strong></p>\n<p>\n\t<strong>Gesamtdauer meiner Beschäftigung mit DHL: 4 Stunden</strong></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<strong>4 Stunden, für die ich oder der Absender eigentlich einen Dienstleister bezahlt haben.</strong></p>\n<p>\n\t&nbsp;</p>\n<h2>\n\tFunfacts:</h2>\n<p>\n\tFunfact I: Während ich diesen Blogbeitrag geschrieben habe, verfolgte ich eine Sendungsnummer einer erwarteten Sendung im Internet und siehe da - 12:04 am heutigen Mittwoch wurde die Sendung ausgeliefert an &quot;Nachbarn&quot;. Wieder keine Benachrichtigung im Briefkasten.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tFunfact II: Wieder kein Abholzettel im Briefkasten und wieder kein Klingeln des Paketboten an der Haustür, obwohl wir heute um diese Uhrzeit zweifelsfrei daheim waren.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tFunfact III: Auf telefonische Nachfrage teilte man mir mit, die Sendung würde bei einem Nachbarn names &quot;Dingas&quot; liegen. Ich bin kurz beruhigt, weil ich mich auf den Inhalt freue. Ich bestehe dennoch darauf eine schrifliche Beschwerde erfassen zu lassen. Man nimmt sich meiner an. Ich bezahle für die Beschwerde mit den üppigen Gebühren für die Servicerufnummer der DHL und verlasse dann die Wohnung um bei dem besagten Nachbarn zu klingeln.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tFunfact IV: Es gibt keine Klingel mit diesem Namen. Ich muss also noch ein Mal bei DHL anrufen. Vermutlich bin ich diesmal sichtlich aufgebrachter. Denn ich muss wieder für einen Anruf bezahlen. Man verspricht mir &quot;nachzuhaken&quot;. Nun warte ich immer noch auf Rückruf.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tFazit: DHL stiehlt mir jeden Monat im Schnitt 4 Stunden, die ich sonst mit Arbeiten verbringen könnte, da sie immer in den Nachmittagsstunden liegen (Postfiliale Öffnungszeiten, Nachbarn höfliche Klingelzeiten, etc.). Hinzu kommt das Geld, das ich investiere um meine Beschwerde überhaupt aufgeben zu dürfen (ca. 4 Euro alleine für den heutigen Anruf).</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<strong>Mit einem Stundenverdienst von im Schnitt 40 Euro schuldet DHL mir für die 4 Stunden in diesem Monat und die Telefongebühren satte 164 Euro. Ich würde mich über eine Überweisung freuen!</strong></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tService gehört für mich zu einem kundenfreundlichen Unternehmen dazu. Und seien wir ehrlich, diese Hotline wird wohl kaum von zufriedenen Kunden genutzt, die sich einfach mal bei DHL bedanken möchten, sondern von Menschen, die sich hauptsächlich melden, weil DHL in ihrem Service (für den sie entlohnt wurden) unzufriedenstellend waren.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWas können Alternativen zu DHL sein? Und ich möchte gerne für die nächste Werbekampagne von DHL gebucht werden und &quot;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDer aktuelle Werbeslogan von DHL lautet übrigens: &quot;Immer genau wissen wann mein Paket da ist&quot;.</p>\n"}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

	module.exports = {"title":"DIY Cookies","date":"2012-08-06 14:53:52 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/white1.JPG\" alt=\"white1.JPG\" />\n<p>Cookies sind die Golden Retriever unter den Backwaren - leicht zu händeln und jeder mag sie. Die Riesencookies, deren Rezept ich Euch gleich verrate, schmecken viel besser als jeder bisher von mir gekaufte Cookie und können auch perfekt eingefroren und dann bei Bedarf gegessen werden.</p>\n<p>Wenn man ein geiles Basisrezept für den Teig besitzt, hat man die Möglichkeit die Cookies ganz nach seinem Geschmack zu pimpen. Ich habe mich an ein Teigrezept von <a href=\"http://www.honigkuchenpferd.com/\">Honigkuchenpferd</a> gehalten und meine Cookies natürlich noch blitzkrieggerecht aufgemotzt.</p>\n<p><strong>Zum <a href=\"http://www.honigkuchenpferd.com/content/white-chocolate-chip-cranberry-cookies\">Grundrezept</a> für 20 Riesencookies:</strong></p>\n<ul>\n<li>350g Mehl</li>\n<li>1 TL Natron</li>\n<li>1/2 Prise Salz</li>\n<li>250g weiche Butter</li>\n<li>150g Zucker</li>\n<li>100g brauner Zucker</li>\n<li>1 EL Gerstenmalz</li>\n<li>1 Vanilleschote</li>\n<li>2 Eier</li>\n</ul>\n<p>Im Unterschied zum Originalrezept habe ich für meinen Teig echte Vanille verwendet und Gerstenmalz statt Zuckersirup.</p>\n<p>Der Grundteig kann nach Belieben modifiziert werden. Ich habe also drei leckere Varianten für Euch.</p>\n<img src=\"/content/images/white2.JPG\" alt=\"white2.JPG\" />\n<p><strong>White Chocolate Chip Pistachio:</strong></p>\n<ul>\n<li>200g weiße Schokolade</li>\n<li>100g Pistazien geschält und gesalzen</li>\n</ul>\n<p><strong>Chocolate Chip Trio Macadamia Cookies:</strong></p>\n<ul>\n<li>75g weiße Schokolade</li>\n<li>75g Vollmilchschokolade</li>\n<li>75g Zartbitterschokolade</li>\n<li>100g Macadamia</li>\n</ul>\n<p><strong>Und so funktioniert es:</strong></p>\n<p>Ihr müsst den Ofen auf 190ºC vorheizen.</p>\n<p>In einer Rührschüssel vermischt Ihr das Mehl, Natron und Salz. In einer zweiten Schüssel schlagt ihr die Butter, die ihr vorher kurz anwärmt, mit Zucker, braunem Zucker, Gerstenmalz und dem Mark einer Vanilleschote cremig.</p>\n<p>Jetzt müsst Ihr den Inhalt der Rührschüssel mit dem Mehl in die schaumige Masse unterheben.</p>\n<p>Als nächstes könnt Ihr in den Teig die Zutaten Eurer Wahl für die modifizierten Cookies beimengen. Wenn Ihr mit Schokolade arbeitet, dann bröckelt die Schokolade in größeren Stücken in den Teig, damit Ihr später schöne Chocolate Chips Stellen im fertigen Cookie habt, die cremig schokoladig schmecken. Alles vermengen.</p>\n<p>Auf ein mit Backpapier ausgelegtes Blech nun die Cookies ausbreiten. Die könnt Ihr mit den Händen formen. Für jeden Cookie nehmt Ihr ungefähr einen großen Esslöffel Teig und drückt ihn etwas platt. Ihr müsst unbedingt zwischen den Cookies auf dem Backblech genug Platz lassen, weil sie im Backofen noch sehr aufgehen. Wir haben zwei Bleche mit dieser Teigmenge gebacken.</p>\n<p>Nun die Cookies 12 Minuten lang backen, bis sich die Ränder golden verfärben. Aus dem Backofen nehmen und abkühlen lassen. Keine Angst, wenn die Cookies erst noch etwas weich sind, denn sie werden beim Abkühlen noch härter.</p>\n<p>Fertig. Geil!</p>\n"}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

	module.exports = {"title":"Ein Sonntag beim Dachshundrennen","date":"2011-09-07 15:30:58 +0000","tags":null,"layout":"post","body":"<p>\n\tHeute startet bei Textkrieg eine neue Serie mit dem schönen Namen &quot;Ein Sonntag&quot;, die ab sofort unsere Herzen voller wilder Actionliebe pressen wird. Wer generell cool und jetzt bis zum Erbrechen mit Endorphinen vollgepumpt ist, schlägt mir per Mail oder in den Kommentaren merkwürdige Sonntags-Events vor, über die ich berichten soll.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tJedes Jahr öffnet die <a href=\"http://www.dackelranch.de/\">Dackelranch Lichtenrade</a> ihr Pforten zum Dachshundrennen. Richtig, Dackel sind meterlang, haben kürzere Beine als die Nutten an der Oranienburgerstrasse und wenn die borstigen Biester laufen, dann beeindruckt das nicht mal einen überfahrenen Fuchs. Offensichtlich ist das Rennen ein modisch gemeinter Anziehungspunkt für Hipster in Berlin, die zum Wurstessen und Starren kommen und Menschen ohne Migrationshintergrund, die ihre ahnenbetäfelten Dackel antreten lassen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tVollbepackt mit Vorurteilen machte ich mich auf den Weg zur Ranch. Einige der Vorurteile bestätigten sich, andere erwiesen sich als vollkommen irrsinnig. Es wurde ein schöner Tag,</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/tn_IMG_8929.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tAusnahmslos alle parkenden Autos waren mit Hundestickern versehen. Hundefreunde sind die frühen Hipster. Man zeigt stolz nach außen welche Hunderasse man züchtet und vermutlich hat alles das nichts mit einem politischen Statement zu tun. Die schönsten Aufkleber sind Kombinationen aus dem gezeichneten Rassetier und dem Namen des Züchters. Dackel von der Krabummsweide. Echte 2000 Euro Klopper.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/tn_IMG_8945.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEinige Dackel trugen schöne Kleidung. Ich kann zu Hunden, die Hüte tragen einfach nichts schlechtes schreiben.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/tn_IMG_8971.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEin Dachshund alleine ist schon witzig, aber alle Dachshunde Berlins auf einen Haufen penetrieren mein Lustzentrum auf eine großartige Art und Weise.&nbsp;</p>\n<p>\n\tDas Gelände der Dackelranch beseht aus einer 50m Laufstrecke, einem Wurststand, einem Bierstand und dem Clubhaus. Ich fühlte mich auf Anhieb sehr wohl, gönnte mir ein Alsterwasser in der prallen Sonne und mir wurde schnell alles egal.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/tn_IMG_9006.JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/tn_IMG_9019.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tBei der Siegerehrung wurde ein Dackel nach dem anderen aufgerufen. Der Dackel gewann eine Wurst und das Herrchen erhielt einen Pokal. Wie stolz diese Menschen sein mussten.&nbsp;</p>\n<p>\n\tZeitweise begann ein Dackel zu kreischen und alle anderen stimmten ein. Mein Wunsch nach Eskalation wurde leider enttäuscht und die Dachshunde bekamen sich schnell wieder ein.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/tn_IMG_9037.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tMein absoluter Held, der Hund, der nach dem Wurstverzehr Kotzgeräusche machte und von der Dame, die die Pokale überreichte, weggeschickt wurde, weil er &quot;wieder falsch atmen würde&quot;.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch bewerte den Sonntag auf der Dackelranch mit 9/10 Punkten. Ein liebevoll gestaltetes Event auf einem tollen Grundstück mit interessanten Menschen und vielen Awwwwww-süß-Tiere-Momenten.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tMehr Fotos bei <a href=\"http://texinberlin.tumblr.com/post/9796484270/more-pictures-from-the-dachshund-races\">A Texan in Berlin</a>.</p>\n"}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

	module.exports = {"title":"Die späten 90er und das Millenium - eine Bestandsaufnahme","date":"2011-12-06 16:15:51 +0000","tags":null,"layout":"post","body":"<p>\n\tSchon die Donots sangen &quot;What ever happend to the 80s?&quot; und ich frage mich häufiger im Suff oder an Tagen wie diesem, an denen ich auf dem Zimmerboden sitze und auf Schnee warte, in welcher Zeit bin ich eigentlich aufgewachsen? Welches Fundament bot sich unserem pubertären Knetgummicharakter? Fußen unsere Ideale auf dem Tobi und das Bo oder auf dem Jojo-Trend? Oder hatte ich vielleicht sogar Glück in einer Zeit zu leben, in der es noch kein Internet für uns Landkinder gab und wir uns Zitate von Nietzsche und Songtexte von Bob Dylan an die Wand hingen, die wir gnadenlos falsch aus dem Englischen übersetzen und zu unserer Hymne machten? Im Grunde war es auch vollkommen&nbsp;egal was ein Tambourine ist, wenn man sich rebellisch fühlen wollte.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_damer1.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t1999 war ein ziemlich übles Jahr für alle. Vielleicht seid Ihr zu jung oder zu alt, um diesem Jahr eine epische Bedeutung zuzumessen, aber mich traf das Millenium mit voller Wucht in einer Phase meiner Entwicklung, in der Drogen und Sex einen immer größeren Stellenwert einnahmen. Das Millenium stand vor der Tür. Wir wussten alle nicht, ob die Welt vielleicht untergehen und alle Computer in den Tod mitreißen würde, aber wir wussten eines: Wir wollten Geschlechtsverkehr und harte alkoholische Getränke, mit denen wir uns in Zweiergruppen vom Rest der Freunde absetzen. Wir führten tiefphilosophische Unterhaltungen mit unseren verrauchten Kratzstimmen, in denen wir uns Werte und unsere Ideale rund um Freundschaft, Liebe und Gesellschaft erarbeiteten und uns solange darauf einschworen, bis der erste keine Lust mehr hatte und sich so verhalten musste als ob er ziemlich betrunken war, damit den Jungs der Gruppe die Möglichkeit erleichtert wurde den ersten Schritt in Richtung Fummelverkehr zu unternehmen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIn so einer Zeit wuchsen wir auf.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWie dieses Foto beweist, war ich zu diesem Zeitpunkt nur physisch ein Mädchen. Mein Jugendzimmer konnte mit jeder Kifferwohnung eines Neuköllner Ghettorappers konkurrieren. Ich hatte Angst vor nichts und niemandem. In der Folie meiner Busfahrkarte führte ich Haschisch mit und im Supermarkt aß ich direkt aus den Regalen. Meine Eltern verloren vollkommen die Kontrolle über mich und ich zog umher und terrorisierte Freunde, Freundeskreise und ganze Bildungseinrichtungen. Später machte ich mein Diplom in Sozialpädagogik.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tSelbstgemachte Dreadlocks sehen nicht nur unmöglich aus, sondern riechen auch so. Meine <strong>Dreadlocks</strong> blieben exakt einen Monat, bis ich mich entschloss den Geheimtipp zu befolgen, der unter uns coolen Kids so exklusiv verbreitet wurde wie mobile Schlägervideos heute.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDreadlocks lassen sich wieder öffnen, wenn man sie mit Weichspüler behandelt. Das ändert die Struktur und man konnte sich in tagelanger Kleinarbeit durch die Knoten kämpfen. Ich konnte wochenlang nicht schlafen, weil mein Kopf durch die Chemie wund wurde und schließlich verschorfte. Da kam es mir ganz recht, dass der Trend ohnehin zu <strong>übergroßen Wollmützen</strong> ging. Ich war eine der ersten.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_damer2.JPG\" /></p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_damer3.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEine Bestandsaufnahme meines Schlafplatzes aus einem Urlaub mit meiner damaligen besten Freundin zeigt eigentlich alle essentiellen Dinge, die uns Jugendliche beschäftigt haben:</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEine <strong>Baby-G-Shock</strong>, ohne die man für die anderen Luft war. Ich habe meine Uhr angemalt. Das babyblaue Band fiel erst meinem roten und dann meinem schwarzen Edding zum Opfer. Irgendwie wollte ich dabei sein, aber irgendwie dachte ich, da müsse es noch mehr geben.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<strong>Fanta</strong>. Ich war immer ein Fantakind. Cola muss einem von klein auf erst mühsam beigebracht werden. Cola ist ein Lernprodukt. Das haben meine Eltern wohl versäumt und auch heute lasse ich meinen Hals lieber bei einer kalten Fanta verschleimen, als mich mit Cola zu betrinken.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<strong>Rote Haare</strong>. Jeder hatte mal rote Haare. Meine wurden aufgrund meiner Naturhaarfarbe knallorange und ich wurde so wütend, dass ich sie mir raspelkurz schnitt, weil ich dem brasilianischen Nationalspieler <strong>Ronaldo</strong> ähnlich sehen wollte. Im Nachhinein eine zweifelafte Entscheidung.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<strong>Bravo Boy Quartett</strong>. Was will man mehr? Eine handvoll Singleboys, die alle 4 Jahre älter waren und Namen wie &quot;Marc&quot; oder &quot;Jamie&quot; hatten. Alle blond und Surferfrisur. Hobbies irgendwo zwischen Fußball und Disko. Wir malten Hitlerbärte an die Kommerzspackos und wollten lieber richtige Typen mit Schlägereien-Portfolio und der Fähigkeit Tüten in unter einer Minute zu drehen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<strong>Etnies</strong> Skaterschuhe. Ohne Worte.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tZwei <strong>Disneyhörspiele</strong>,&nbsp;König der Löwen und die Weihnachtsgeschichte, die wir damals im Urlaub, mit 13 oder 14, schon hörten, weil wir sie trashig fanden.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_damer4.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch war die einzige <strong>Skaterin</strong> an der Halfpipe am Jugendzentrum unserer Stadt und ich habe mir die Titten mit Gaffatape weggeklebt oder zwei Badeanzüge unter meine <strong>Motivshirts</strong> aus dem lokalen Skaterstore angezogen. Vielleicht war ich damals schon Funktionalist genug um zu erkennen, dass mich Brüste nur störten und keinerlei praktische Funktion erfüllten. Aber Männer scheinen das früher wie heute zu mögen. Ästhetikbanausen!</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_damer5.JPG\" style=\"width: 500px; height: 373px; \" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<strong>Kajalstift</strong> war unsere Religion und in der gelben <strong>Posttasche</strong> transportiere ich meistens nur Luft.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_damer7.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tMein Religionslehrer schenkte uns einen Schokoladennikolaus, der ausgepackt wie ein <strong>Schwanz</strong> aussah.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_damer8.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tKennt Ihr noch <strong>Boxerstiefel</strong> und <strong>Cordhosen</strong>?</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_damer9.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<strong>Dickieshose</strong> und <strong>Volumenshampoo</strong>.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEs war eine merkwürdige Zeit, in der ich die orientierungsloseste Phase meines Lebens erlebte. Werte konnten nicht von der Stange gekauft werden, sondern mussten wachsen und ein festes verinnerlichtes System bilden. Die späten 90er und das Millenium waren eine Zeit, in der alte Trends wieder aufkamen, sich mit neuen Trends mischten, Bastardtrends entstanden und wir als junge Menschen zwischen Konsum und Konsumkritik hin- und hergeworfen wurden wie eine Frisbee. Ich bin irgendwann in der Mitte einfach heruntergefallen.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tUnd wenn mich jemand &quot;What ever happend to the Millenium?&quot; fragt, dann zeige ich auf mich.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n"}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

	module.exports = {"title":"Endstation Weißensee","date":"2011-06-03 08:55:49 +0000","tags":null,"layout":"post","body":"<p>\n\tEin bißchen fühlt sich Weißensee an wie die Endstation von etwas, in das man nie eingestiegen ist. Irgendwo zwischen zugezogenen Vorhägen und geschlossenen Kneipen befindet sich eine solide Anzahl Nagelstudios und eine Imbissbude, die mit der Aufschrift &quot;Hähnchen Eis&quot; wirbt.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tThese: Je höher die Anzahl an Nagelstudios, Spielotheken und Bettengeschäften in Eckhäusern, desto niedriger das durchschnittliche Einkommen und der Bildungsstand der Einwohner.&nbsp;</p>\n<p>\n\tWer in Weißensee wohnt ist entweder Asiate oder Nazi, hat aber auf jeden Fall gepflegte Nägel.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/weissensee.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/weissensee2.jpg\" width=\"500\" /></p>\n"}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

	module.exports = {"title":"Erfolgreiche Frauen im Internet - keine Liebesgeschichte","date":"2013-06-10 18:30:15 +0000","tags":null,"layout":"post","body":"<p>Es gab mal eine Zeit, in der glaubte ich, dass mich persönlich die gesellschaftlichen Nachteile nicht treffen, die mir aufgrund meines biologischen Geschlechts in die Wiege gelegt wurden. Ich gestand zu diesem Zeitpunkt zwar jeder anderen Frau zu, durch die Gesellschaft in ihrer privaten und beruflichen Entfaltung benachteiligt zu werden, machte mich dennoch von dem Anspruch frei, das dies auch für mich selbst gelten könnte. Ich wurde sehr emanzipiert erzogen und bin meinen Eltern äußerst dankbar dafür, so sehr, dass mir bis heute das Gefühl durch mein Geschlecht schlechtere Chancen zu erfahren schlichtweg total absurd erschien. Zu hart war die Arbeit, die ich täglich in meine Karriere und meinen Job investierte, zu hoch der Intellekt und zu großartig meine charmante Persönlichkeit, um zuzulassen, dass dort noch Platz für Lehrbuchprobleme wie ‘Chancenungleichkeit’ und Anfeindungen aufgrund meines Geschlechts wäre, aber 2013 kann ich behaupten: Erfolgreiche Frauen im Netz - keine Liebesgeschichte.</p>\n<p>Frauen mit Erfolg:</p>\n<ul>\n<li>sind entweder dumm und ihr Erfolg ist nur ein Missverständnis</li>\n<li>haben sich nach oben geschlafen</li>\n<li>sind hässlich und tragen hässliche Kleidung</li>\n<li>sind frustriert</li>\n<li>sind bemüht</li>\n</ul>\n<img src=\"/content/images/girlpeng.jpg\" alt=\"girlpeng.jpg\" />\n<p>Auf Facebook kommentierte heute jemand names Katharina einen <a href=\"http://www.intro.de/news/newsfeatures/23072040/20-dinge-die-ich-bei-wetten-dass-auf-palma-de-mallorca-gelernt-habe\">“Artikel”</a>, den ich einige Tage zuvor für das INTRO Magazin über die Sommerspezialsendung von “Wetten, Dass…?” verfasst hatte. Dieser Artikel wurde wie gewohnt sehr stark zerrissen. Gleiches gilt auch für meine monatliche Kolumne, die immer auf der Liste der meistgeklicktesten Artikel auf <a href=\"http://intro.de\">intro.de</a> zu finden ist. Darunter findet sch immer die gleiche Art von Kommentaren, außer dieser:</p>\n<p><strong>“das erste mal, dass ich echt traurig bin, dass ich wetten dass… nicht geschaut hab! gibt ja anscheinend ne menge zündstoff.”</strong></p>\n<p>Irgendwie erschrak ich beim Lesen selber, denn die Naivität der Kommentatorin rührte mich unerwartet. In diesem Moment wurde mir klar: Wenn der Zündstoff nicht mehr eine Sendung ist (wie es im Kommentar noch naiv geglaubt wird), sondern eine Person, dann…</p>\n<p>Vorweg möchte ich ein paar Worte zu Kommentaren in Blogs im allgemeinen verlieren, bevor ich auf den speziellen Fall erfolgreicher Frauen im Internet eingehe.</p>\n<p>Das Problem mit Kritik im Netz ist ein allgemeines Problem und tritt unter den Artikel von Frauen und Mädchen, die sich publizistisch als Bloggerin oder Journalistin betätigen, nur besonders gehäuft auf, weil es einen zusätzlichen Motor neben dem Inhalt gibt. Die Weiblichkeit bietet eine weitere besonders offensichtliche Angriffsfläche, von der sich ein Großteil der Nutzer bewusst oder unbewusst motiviert fühlt anzugreifen. Doch Kommentare im Netz, und da möchte ich nicht noch einmal so weit ausholen, werden häufig genutzt um schlichtweg inhaltslose Kritik am Verfasser eines Textes anzubringen. Dazu fand sich im <a href=\"http://www.der-postillon.com/2012/09/welt-online-in-wahrheit-trick-um-rechte.html\">“Postillon”</a> ein sehr schöner Artikel, der versuchte das Phänomen humoristisch auf die Schippe zu nehmen. Fakt ist, man muss mit Kritik leben, aber man kann selbst entscheiden wie viel Einfluss man diese auf sein Leben nehmen lässt. Dabei gibt es eine einfache Zeitkomponente und eine Komponente auf der Gefühlsebene. Wie viel Zeit möchte ich mit dem Lesen von Kommentaren verbringen? Wie viele Zeit rauben mir Beleidigungen und Anfeindungen, die keinerlei Mehrwert für mich haben? Wie setze ich meine verfügbare Zeit am besten ein, um möglichst viel Nutzen aus den Lesern und ihren Ideen zu ziehen? Die zweite Frage spielt sich auf der Gefühlsebene ab und betrifft die eigene Politik mit Kritik und Lob umzugehen. Wie viel der anderen lasse ich an mein Selbstwertgefühl ran? Wie grenze ich mich ab? Welche Kritiken sollten wirklich zu einer Korrektur meiner Fähigkeiten, Inhalte und meiner Person führen?</p>\n<p>Aus diesem Grund wird es nun einige Änderungen meinerseits geben: Auf <a href=\"http://textkrieg.de\">textkrieg.de</a> wurden die Kommentare deaktiviert, mein Facebookprofil wird nur noch interessante Links und Eckdaten zu meinen Projekten öffentlich posten. Der Rest wird nur noch für meine Freunde und Freunde des Accounts online sichtbar sein. Das hat zum einen den Grund, dass es unter rund 500.000 Kommentaren auf den unterschiedlichsten Social Media Kanälen und in meinem Blog nur eine handvoll Kommentare und Kritiken zu meiner Arbeit gab, die für mich das Gütekriterium “inhaltskritisch” erreichten. Natürlich danke ich diesen Menschen für ihre Inspiration und ihre Vorschläge ebenso wie den vielen vielen positiven Kritikern, die mich täglich liken und gerne lesen.</p>\n<p>Aber was genau war passiert?</p>\n<p>Eine der vermutlich am häufigsten für mich benutzen Beschimpfungen neben “Schlampe”, scheint “Göre” zu sein. Ich habe mich intensiver mit diesen beiden Wörtern auseinandergesetzt und kann ihre Definitionen nicht auf das Selbstbild meiner Person aneignen. Gerne wird mir unterstellt “bemüht” zu sein. Immer wieder. Aber was bedeutet das? Wieso kommentiert jemand meine Arbeiten mit diesen Worten? Wieso assoziiert man mich damit? Bevor ich also anfing mich selber so wie die Kommentatoren wahrzunehmen, sammelte ich Eindrücke unter den Kolumnen anderer junger Journalistinnen und unter den Statusmeldungen, Blogbeiträgen und YouTube Videos junger Bloggerinnen und Frauen, die in der Öffentlichkeit stehen, und musste erschreckenderweise feststellen, dass sich die Kritik nie (Einzelfälle gabe es natürlich immer wieder) auf deren Inhalte und Texte bezogen, wie bei ihren männlichen Kollegen, sondern ausschliesslich auf ihre Person, ihre Karrieren oder ihr Aussehen. Daraus teilte ich die Kommentare in unterschiedliche Themenbereiche ein, deren Gedankenkonstrukt in den Köpfen der Menschen weit weiter verbreitet ist, als ich bisher annahm:</p>\n<p>Frauen mit Erfolg:</p>\n<ul>\n<li>sind entweder dumm und ihr Erfolg ist nur ein Missverständnis</li>\n<li>haben sich nach oben geschlafen</li>\n<li>sind hässlich und tragen hässliche Kleidung</li>\n<li>sind frustriert</li>\n<li>sind bemüht</li>\n</ul>\n<p>Der Kommentator fühlt sich stets im recht, denn er glaubt einen Missstand aufgedeckt zu haben und handelt in seinen Beleidigungen in dem besten Wissen einen guten Beitrag zu leisten. Die anderen Herren und viele der Frauen geben ihm recht, denn ihnen fehlt die nötige Meta-Perspektive auf Chancenungleichheit, die man erst durch Diskussionskultur oder Erziehung erlernt haben muss. Hier liegt ein großes Versäumnis. Viele der Kritiker glauben fest an eine schicksalhafte Fügung und sehen nicht ihr eigenes Menschenbild dahinter, welches das Fundament für solche Annahmen bildet. Eine junge Frau im Internet mit Erfolg hat schlichtweg Glück gehabt, lautet die Meinung der besagten “Kritiker”, und der Frau werden im gleichen Zug alle Fähigkeiten und Bemühungen abgesprochen, diesen Erfolg mit eigenen Kräften erarbeitet zu haben. Man gerät schnell unter eine harsche Kritik, weil man jung ist. Und noch schlimmer: weil man weiblich ist. Der <a href=\"http://textkrieg.de/articles/2012/07/04/neid-im-internet\">“Neid im Internet”</a> ist derzeit männlich.</p>\n<p>Ich möchte meine Zeit und Gefühle nicht mehr für Menschen opfern, die mich schlichtweg reduzieren. Menschen, die es nicht schaffen eine Kritik von ihrer persönlichen Befindlichkeitsebene zu abstrahieren, sind keine Gesprächspartner mehr für mich, denn sie hindern mich an meinen eigentlichen persönlichen Zielen und saugen nur Kraft und wertvolle Zeit, die ich lieber aufwenden würde, um mich in meinen Texten und Werken zu verbessern (aber nicht in meiner Weiblichkeit).</p>\n<p>Schlampe? Göre? Diese Attribute, und die durch den vorwiegend männlichen Kommentator implizierten unlauteren Karrierewege (“hochschlafen”), die stets Frauen zugeschrieben werden, sind die moderene “Hexenjagd” im Netz. Was der Bauer nicht kennt das frisst er nicht. Vor dem Rechner sitzend wird dann gemutmaßt: “Ich bin doch genauso gut. Warum bin ich nicht bekannt? Weil die Blitzkrieg eine Frau ist!” Der einfachste Weg ist gefunden. Statt selbstkritischer Gedanken gibt es nun einen schnellen Schuldigen: Das System ist schuld, denn es bietet Schlupflöcher, so dass junge Menschen, ja sogar Frauen, schnell und talentlos Karriere machen können. Da entsteht Wut und da entsteht Hass, denn die Arbeit dahinter ist für die Leser unsichtbar. Mit dieser Mauer des Unwissens und des Unverständnisses haben Frauen Tag für Tag zu kämpfen. Auch wenn es um das schlichte Ignorieren geht, das auch einen nicht zu verachtenden Kraftaufwand einfordert. Verdrängen und positiv denken, während der Scheiterhaufen unter einem immer heisser und heisser wird, ist nicht immer leicht.</p>\n<img src=\"/content/images/girlpeng2.jpg\" alt=\"girlpeng2.jpg\" />\n<p>Ich möchte in diesem Blogbeitrag keinerlei Schuldzuweisungen treffen, sondern analytisch an die Sache herangehen und als Erkenntnis festhalten, dass die Gesellschaft noch sehr stark an starren Geschlechterrollen festhält, auch wenn sie sich dessen oft nicht bewusst ist. Ich verurteile niemanden, wenn er im Rahmen seiner Biographie bisher nicht die Möglichkeit hatte, ein offenes und geschlechtsneutrales Weltbild zu erfahren und dieses nicht nur in sein Denken, sondern auch in sein Handeln aufzunehmen, aber ich möchte dennoch nicht ständig mit den persönlichen Konsequenzen für mich als arbeitende Kreative und erfolgreiche Frau eingeschränkt und konfrontiert werden. Die Frustration solcher Kommentatoren muss ebenso hoch sein wie die meinige, denn sonst würden sie sich vermutlich kaum die Zeit nehmen ihr patriarchisches Rollenbild derart vehement zu verteidigen, dass ihnen Beleidigungen als Mittel recht sind und sie so viel Zeit auf ihre Kritiken aufwenden. Wer sich die Zeit nimmt Rechtschreibfehler einzeln aufzulisten und die Verfasserin dabei noch herablassend “Göre” nennt, dessen Rollenbild muss entweder gerade sehr stark am Schwanken sein, so dass es wenn es ein Mal ins Stolpern gerät, Gefahr läuft schon bald komplett in sich zusammenzukrachen, oder es ist eben so fest, dass man sich als eine Art “Auserwählter” fühlt und seine detektivischen Erkenntnisse gerne für das Allgemeinwohl teilen möchte. “Die Frau ist eine Hexe. Ihr Erfolg ist fauler Zauber und nun holt sie!”. Heute ist der Scheiterhaufen in Wortform und auf den Pinnwänden und in den Kommentaren unter den Texten und Statusmeldungen junger Frauen, Journalistinnen und Bloggerinnen.</p>\n<p>Bei mir macht sich der Druck mit dem steigenden Erfolg bemerkbar. Erst schreibt man einen Artikel für ein Magazin, dann eine weiteren, dann eine Kolumne, dann einen der Texte, die normalerweise die Chefredakteure selbst übernehmen, das bleibt den Lesern natürlich nicht verborgen. Die Reaktionen fallen mit jeder Karrierestufe heftiger aus. Die Luft nach oben wird für Frauen immer dünner. Dennoch möchte ich die vielen Frauen, die diesen Artikel gerade lesen ermutigen: Dranbleiben und einen für Euch zufriedenstellenden Weg finden, das gesellschaftliche Echo, das aufgrund Eures Geschlechts auf Euch trifft, zu händeln. Die Leser reiben sich so oder so an Eurer Person auf, daher ist es notwendig diese Tatsache vorerst zu akzeptieren, und auch im Jahr 2013 sein Selbstbild vor der blinden Wut und dem fehlenden Weitblick der inhaltslosen Anfeindungen zu schützen.</p>\n<p><strong>“Hallo Intro, wart Ihr nicht mal kreativ? Man kann offenbar nicht bestreiten, dass die WD Sendung nicht gelungen war - aber warum lasst Ihr eine postpubertäre Göre etwas kommentieren was Ihre Zielgruppe um etwa 30 Jahre verfehlt?”</strong></p>\n<p>Das Internet ist dennoch und trotz allem ein schöner Ort, und da ich auch weiterhin daran glauben möchte, habe ich mich gegen Nutzerkommentare entschieden, um das Netz weiterhin als gut zu erfahren.</p>\n<p>Danke für Euer Verständnis!</p>\n<p>Zum Schluss möchte ich noch ein beleidigendes Gedicht von einem älteren “Kollegen” anhängen, das mich kürzlich per Mail erreichte und exemplarisch für die Hintergründe dieses Artikels stehen soll:</p>\n<h2>Im Görencontainer</h2>\n<p>Über Helene Hegemann und Ada Blitzkrieg</p>\n<blockquote>\n<p>Das deutsche Blitzmädel ist wieder da.\nHegemanns Helene, die sich an Axoloti Roadkill\nÜberfressen hatte und im Höllenkreis PI wie\nPlagiator/Innen ihr Gnadenbrötchen erhielt,\nWard jüngst abgelöst von einer anderen\nJungen Berliner Trash- Trutsche, Ada Blitzkrieg,\nDie sich dem quasselindustriellen Komplex\nDurch getextete Töpfer- und Batikware anzudienen\nSich anschickt. Transgressionen des Ungeschicks.\nIm Rattenkäfig Berlin verfängt Überbietung\nNicht mehr. Die gefickten Babys liegen\nLängst im Glaskasten aus Scherben.\nDie Manen Heiner Müllers und die Witwen\nSchlingensiefs scheißen auf ihre Kinder.\nTEXTKRIEG, KRIEG OHNE SCHLACHT,\nTweets zum Mitsingen. Darfs zum Aas ein\nSchlückchen Urinauslese sein? Oder bevorzugen\nAuch Sie den Käse aus Grind? Herr George?\nWie in der Bücher Buch spricht der Gesalbte\nAn jeder wendewelt: Ich bin gekommen\nDes weibes werke aufzulösen.\nIch bin so froh, dass keiner weiß,\nDass ich homo sapiens heiß.\nIm Kanister, das Wutplasma; der Zünder\nUnter dem Lid, der ist nass.&quot;</p>\n</blockquote>\n<ul>\n<li>Ralf Frodermann</li>\n</ul>\n"}

/***/ }),
/* 570 */
/***/ (function(module, exports) {

	module.exports = {"title":"Erfolgreiche Frauen und das Impostor Syndrom","date":"2016-03-31 11:04:14 +0000","tags":null,"layout":"post","body":"<p><img src=\"https://img.buzzfeed.com/buzzfeed-static/static/2016-01/7/19/enhanced/webdr11/enhanced-3646-1452212525-17.jpg?no-auto\" alt=\"alt\"></p>\n<p>Als ich das erste Mal vom <a href=\"https://en.wikipedia.org/wiki/Impostor_syndrome\">Impostor Snydrom</a> gelesen habe, das übrigens besonders häufig bei Frauen anzutreffen ist, fiel eine große Last von mir. Offiziell war ich nun also nicht verrückt und meine Selbstzweifel, die regelmäßig zwischen “Genie” und “Faker” wankten, hatten nun eine psychologische Bezeichnung. Die Gewissheit, dass das Syndrom besonders bei Frauen auftritt, hat mich in meiner Selbsteinschätzung und in den Bewertungen meiner Leistungen positiv beeinflusst.</p>\n<p>Guess what? You’re not faking it!</p>\n<p>Was ist also das \t<a href=\"http://www.buzzfeed.com/kristinchirico/13-charts-that-will-make-total-sense-to-people-with-impostor#.ipww4EzdpL\">Impostor Syndrom?</a></p>\n<blockquote>\n<p>“Impostor syndrome” is that feeling where — even if you get good grades, good jobs, accomplish things, have special talents, and people compliment you — you feel like you’re tricking everyone and you’re actually not good at anything.&quot;</p>\n</blockquote>\n<p>Übersetzt heißt das, dass das Impostor Syndrom sich durch das Gefühl bemerkbar macht, man hätte Erfolge, den Job oder gute Dinge, die einem widerfahren, nicht verdient, denn die eigenen Leistungen fühlen sich für Betroffene immer nur an wie ein riesiger Fake oder Bluff.</p>\n<blockquote>\n<p>I’d replaced someone else on the panel, so in a way I was an imposter. But even as I spoke to the 100 assembled women, I had to bite my tongue to stop myself putting my (small) achievements in life down to luck and happenstance, rather than hard work. I still didn’t feel like I deserved to be on that stage.</p>\n</blockquote>\n<p>In dem Blog <a href=\"http://startupbros.com/21-ways-overcome-impostor-syndrome/\">21 hilfreiche Tipps für den Umgang mit dem Imposter Syndrom</a> gibt es einige hilfreiche Vorschläge für Menschen, die zu ähnlichen Gedanken- und Bewertungsmustern neigen, um ihr Leben nachhaltig zu verbessern. Ich habe mir die Punkt vorgenommen und die Liste etwas auf ihre Tauglichkeit hin modifiziert. Im Folgenden findet ihr also ein paar gute Tipps:</p>\n<p>Die Bilder stammen übrigens aus diesem tollen Buzzfeed zum Thema:\n<a href=\"http://www.buzzfeed.com/kristinchirico/13-charts-that-will-make-total-sense-to-people-with-impostor#.ipww4EzdpL\">13 Charts That Will Make Total Sense To People With Impostor Syndrome</a></p>\n<h5>1. Sich selber nicht so wichtig nehmen</h5>\n<p>Lasst den Glauben los, dass ihr etwas Besonderes seid! Jeder Erfolg ist Produkt eurer Arbeit, genau wie es bei jedem anderen Menschen auch der Fall ist. Es gibt keine Sonderrolle von Menschen, deren Erfolg nur dem Zufall oder dem Glück zuzuschreiben ist.</p>\n<p><img src=\"https://img.buzzfeed.com/buzzfeed-static/static/2016-01/8/18/enhanced/webdr13/enhanced-29764-1452295117-1.jpg?no-auto\" alt=\"alt\"></p>\n<h5>2. Akzeptiert, dass ihr eine Rolle in eurem Erfolg spielt!</h5>\n<p>Natürlich spielt auch “Glück” oder “Zufall” für euren Erfolg eine Rolle, aber vergesst nicht, dass eure Person nicht anhand eines einzigen Erfolges messbar ist, sondern das Produkt eines lebenslangen Prozesses, dessen Protagonist man selber ist. Alle Handlungen gehen auf die eigene Person und ihre Entscheidungen zurück. Man hat den eigenen Erfolg also geformt und bestimmt. Man hat etwas getan.</p>\n<h5>3. Lob und Anerkennung annehmen</h5>\n<p>Jedes Mal wenn jemand ein Lob ausspricht, gilt es dieses wahrzunehmen und stärker zu gewichten als der eigene Impuls die Leistung nicht als verdient anzuerkennen.</p>\n<h5>4. Hört auf euch zu vergleichen!</h5>\n<p>Sich mit anderen zu vergleichen ist eine Falle für Menschen, die unter dem Impostor Syndrom leiden, denn der Vergleich wird nie positiv für das eigene Selbstbild ausgehen, denn machen wir uns nichts vor, euer Leben ist nicht das beste Leben der Welt, ihr seid nicht die Schönsten und da draußen laufen schrecklich viele Leute rum, die vielleicht intelligenter und leistungsfähiger sind als ihr. Verpflichtet euch lieber dazu eure eigenen Umstände und die Ausgangsposition zu akzeptieren und von dieser Position aus sein euer bestes Ich zu zeigen. Nämlich jenes, das für euch machbar und realitisch ist.</p>\n<h5>5. Es ist das Impostor Syndrom, es bist nicht du!</h5>\n<p>Kognitiv ist schon viel gewonnen, wenn wir uns in solchen Situationen oder in Momenten mit großem Selbstzweifel sagen, dass wir dazu neigen Erfolge und Leistung durch das verzerrte Bild zu sehen, das sich Impostor Syndrom nennt.</p>\n<p><img src=\"https://img.buzzfeed.com/buzzfeed-static/static/2016-01/7/20/enhanced/webdr09/enhanced-27835-1452216300-10.jpg?no-auto\" alt=\"alt\"></p>\n<h5>6. Sich irren macht dich nicht zu einem Betrüger!</h5>\n<p>Ein Fehler stellt weder deine gesamte Person, noch deinen Job, noch deine bisher erlebten Erfolge in Frage. Jeder Mensch macht Fehler oder irrt sich, es ist entscheidend aus diesen Fehlern zu lernen und sie als selbstverständlichen Teil eines Prozesses zu akzeptieren.</p>\n<h5>7. Bemerken, dass Zurückhaltung auch bedeutet den anderen etwas vorzuenthalten</h5>\n<p>Wer permanent das Gefühl in sich trägt, im Job, in der Familie oder im Freundeskreis nicht ausreichen zu können, entzieht die Möglichkeit für andere da zu sein, im Job etwas zu leisten oder jemanden mit den eigenen Fähigkeiten zu unterstützen.</p>\n<h5>8. Du wirst sterben!</h5>\n<p>Nach dem derzeitigen Stand der Medizin müssen wir alle sterben. Auch du. Schade wäre es nur, wenn du dein ganzes Leben damit verbracht hättest zu glauben, dass du ein Betrüger und Hochstapler bist, anstatt Dinge voran zu bringen, sich weiterzuentwickeln, Fehler zu machen, etwas richtig zu machen und Erfolge zu haben, die du verdient hat.</p>\n<h5>9. Sag was du kannst!</h5>\n<p>Wir erleben es immer wieder, dass wir durch andere in die Rolle eine Experten gedrängt werden, sei es bei Vorträgen, in Texten oder im Reallife. Wir glauben, dass Menschen in diesen Situationen von uns erwarten alles zu wissen. Lückenlos. Menschen ohne Impostor Syndrom neigen in diesen Situationen zum Bullshitting. Das ist unser gutes Recht und eine Fähigkeit, die auch du erlernen und anwenden kannst. Falls wir mal wieder etwas nicht wissen, gilt es nicht direkt zu verzeifeln und sich selbst in Frage zu stelle, sondern die Lücke zwar offen zuzugeben, aber gleichsam ehrlich anzuerkennen, dass dies nicht unsere Rolle gefährdet, sondern lediglich einer von vielen Bausteinen von Leistung, bzw. Profession ist.</p>\n<h5>10. Keiner weiß was er tut</h5>\n<p>Firmen gehen bankrott. Start-Ups werden gegründet und aufgelöst. Mal verliert man seinen Job. Mal gehen Beziehungen in die Brüche. Niemand kann mit Sicherheit die Zukunft vorherbestimmen und somit fehlerlos und ständig erfolgreich handeln. Die Inklusion von Fehlern in den eigenen Persönlichkeitsprozess ist wichtig, denn deren Existenz ist unausweichlich.</p>\n<h5>11. Authentizität ist für den Arsch!</h5>\n<p>Das Impostor Syndrom vermittelt einem das Gefühl, das man nie authentisch wäre. Man hat das Gefühl Leistung nur “vorzuspielen” und eigentlich ein Lügner zu sein. Das ist Blödsinn, denn man verändert sich fortlaufenden. Mit seinen Eltern spricht man anders als mit seinem Freund. Heisst das nun aber direkt, dass man nicht authentisch ist? Meinungen ändern sich im Laufe der Zeit. Bestimmte Denkmuster treten nur in bestimmten Rollen auf, die man im sozialen Leben einnimmt. Man bleibt man selbst. Mal ist man Kind. Mal Freundin. Mal Mutter. Mal Chef.</p>\n<p><img src=\"https://img.buzzfeed.com/buzzfeed-static/static/2016-01/8/19/enhanced/webdr09/enhanced-17159-1452299159-10.jpg?no-auto\" alt=\"alt\"></p>\n<h5>12. Lacht über euch!</h5>\n<p>Eine Person zu finden, der man erzählen kann, dass man Impostor Syndrom hat und zu welchen Gedanken dies führt, kann eine große Hilfe sein. Zusammen über die Absurdität der Gedanken zu lachen und somit die eigene Denke einer Art Realitätsabgleich zu unterziehen, das heilt. Ebenso über sich selber zu lachen oder die störenden Gedanken auf Papier zu bringen und einige Zeit später nochmal zu lesen.</p>\n"}

/***/ }),
/* 571 */
/***/ (function(module, exports) {

	module.exports = {"title":"Eure Meinung zu ADHS interessiert mich nicht","date":"2014-02-06 00:00:00 +0000","tags":null,"layout":"post","body":"<p>Nun ist es so, ich habe ADHS und zeitgleich existiert dazu eine öffentliche Meinung, die sich absolut nicht mit meiner Erfahrung und meiner Ansicht über dieses kleine ‘Defizit’ deckt. Diese Meinung dreht sich um eine Krankheit, um ein Medikament und stigmatisiert mich. Ganz schön blöd, so fühlt sich das manchmal an.</p>\n<p>Aber erstmal zu mir:\nIch bin 28 Jahre alt und habe nun seit zwei Jahren ADHS, zumindest diagnostiziert. Die Krankheit oder Einschränkung, oder wie auch immer man ADHS beschreiben möchte, zieht sich allerdings wie ein roter Faden durch meine Biographie und ist an den Seiten von Scherben und Zerstörung geziert.</p>\n<p>ADHS, da denkt man erstmal an die Zappelkinder aus den hässlichen Hochhäusern am Rande der Stadt, die Cola-Trinker und Süßigkeiten-Esser, die Baller-Spiele-Zocker und die, die in der Klasse rumschreien und ihren Geschwistern Geld stehlen. Diese Facette ist aber nur ein kleiner Ausschnitt einer komplexen Einschränkung, das sollten wir nicht vergessen. ADHS ist kein schichtspezifisches Phänomen, sondern ein Problem, das viele Kinder und Erwachsene betrifft. Natürlich kann man durch liebevolle Zuwendung und Kenntnis des Problems die Spitzen der Symptome etwas abdämpfen, aber gänzlich “heilen” kann man ADHS nicht. Und genau an diesem Punkt packt mich regelmäßig die Wut wenn das Internet mir wieder groben und unreflektierten Gedankenauswurf hinrotzt. “Die sollten halt einfach wieder mehr draußen spielen!” - Klar! So einfach ist das…</p>\n<img src=\"/content/images/adhs1.jpg\" alt=\"adhs1.jpg\" />\n<p>Ich für meinen Teil bin sehr behütet aufgewachsen. Ganz ohne Hochhaus, süße Cola und ganz ohne Eltern, die keine Zeit für mich hatten. Meine Eltern hatten viel Zeit und gestalteten meine Freizeit liebevoll, kreativ und offen. Ich wurde immer geliebt und umsorgt. Wir hatten einen riesengroßen Garten in einer netten Kleinstadt und wir haben getobt und gebrüllt. Dabei fiel ich als kleines Kind nie so besonders auf. Ein gesundes und glückliches Kind, das war ich wohl. Ich war den ganzen Tag aktiv und hing mit den älteren Jungs der Nachbarschaft rum. Dabei konnte ich immer am meisten rumkommandieren und meistens lief alles so wie ich es wollte. Ich gestaltete meinen Tag und es gab kein Problem für mich. Das System funktionierte und arbeitete mir sogar hervorragend zu. Ich war das mutige Mädchen. Das sportliche Kind. Ich galt als selbstsicher und selbstbewusst. Das sollte sich bald ändern. Irgendwann wurden meine Charakterstärken zu Charakterschwächen. Das lag allerdings nicht an mir, sondern am System (Schule und Erwachsensein), was ich leider erst viel zu spät begreifen lernte.</p>\n<p>Am Tag der Einschulung wurde vieles anders für mich, auch wenn ich im Nachhinein zugeben muss, mit meiner Grundschulzeit großes Glück gehabt zu haben, denn meine Klassenlehrerin war gerade examiniert und frisch von der Uni, motiviert, voller Energie und ließ das etwas eigenbrödlerische Kind einfach das tun was es am besten konnte und lobte mich für meine Charakterstärke und meine Kreativität. Ich hatte Einsen und ich war motiviert mich einzubringen im offenen Unterricht.</p>\n<p>Im Gymnasium wurden mir dann schnell die Beine gebrochen. Meine Ideen und meine Durchsetzungskraft wurden zu einem unüberwindbaren Hindernis für mich. Zu einem handfesten Defizit. Zehn Unterrichtsstunden am Tag. Eigene Meinung galt nun als Aufsässigkeit. Hinterfragen als Frechheit und neue Wege finden als Faulheit. Frontalunterricht. Ich hasste Mathe und ich hasse Latein, und irgendwann hasste ich alle Fächer, verweigerte das Lernen komplett, schaffte es dennoch gute Arbeiten zu schreiben und mich irgendwie durch das System zu aalen, vermutlich weil ich nicht auf den Kopf gefallen war und mich in den richtigen Momenten halbwegs zusammenreißen konnte. Ich wurde unglücklich, denn eigentlich wollte ich ja gerne lernen und was aus mir machen. Ich hatte Wissenshunger, den die Schule mir nicht stillen konnte. Ich war schneller im Lernen als die anderen Kinder. Ich blickte immer nur zurück. Das langweilte mich. Die Frustration wuchs von Tag zu Tag. Ich gab vor die Schule zu besuchen und ließ mich tagelang dort nicht blicken und fütterte lieber im Vogelpark Schmetterlinge. Ich fühlte mich schlecht. Ich kiffte. Ich randalierte. Ich verweigerte mich dem System, das mich nicht mit meiner Persönlichkeit integrieren wollte. Irgendwie hat es einen kleinen Knacks hinterlassen plötzlich für die eigenen Stärken nicht mehr bewundert zu werden, sondern verachtet und getadelt. Diese Ambivalenz ist mir auch heute noch inne, wenn es darum geht mich selber zu beurteilen. Ich habe oft ein sehr gespaltenes Verhältnis zu meinem Ego. Gute Ada. Böse Ada. So ist das eben, ich möchte mich aber nicht beschweren, denn ich komme zurecht. Ich möchte lediglich erzählen.</p>\n<p>Das Problem bei ADHS ist bei jedem “Betroffenem” unterschiedlich ausgeprägt und die Krankheit ist facettenreich mit diversen Ausprägungen. Konzentration, Hyperaktivität, Impulsivität und so weiter. Ich kann mich auch heute noch stundenlang in eine Arbeit vertiefen und dieser in absolut asketischer Konzentration nachgehen, solange ich mich selbst dafür entscheide, und solange ich einen Nutzen darin sehe und es mir Spaß macht. Dabei kann ich alles um mich herum vollkommen ausblenden und ein Ergebnis abliefern, das beeindruckt. Aber wehe jemand stört mich darin. Ich arbeite manchmal mit Kopfhörern und kenne Wege und Mittel um aus meinem Defizit einen klaren Vorteil für mich und meine Arbeit zu schaffen. Ich musste erst lernen mir selber ein System zu schaffen, das mich mit meinem ADHS bevorteilt und begünstigt, statt mich zu deprivieren. Dieser Weg war lang und schmerzlich und oftmals ohne Verständnis meiner Umwelt. Und genau das wäre mir vermutlich eine große Hilfe gewesen.</p>\n<p>Damit Menschen mit dieser Störung auch einen Weg für sich finden, damit ihnen Verhaltenstherapien oder bestimmte Mittel helfen können, die abseits von Selbstmedikation mit Drogen oder totaler Verzweiflung liegen, ist es notwendig, dass man ihnen ihre Bedürfnisse und Defizite anerkennt und nicht in Abrede stellt. Dabei ist es nicht notwendig sie als ADHSler zu stigmatisieren oder ein Label zu verwenden, sondern sie individuell in ihren Schwächen, Bedürfnissen und Fähigkeiten anzuerkennen. Die komplette Leugnung der Symptome durch die Gesellschaft und die Bagatellisierung des Leids der Betroffenen arbeiten klar dagegen und das sollte jeder Laie und Nichtbetroffene wissen, wenn er wieder vorschnell ein Urteil im Netz fällt.\n“Einfach mehr draußen toben und Sport treiben!”, das klingt wie ein sehr dummer Witz, wenn man 28 Jahre alt ist und manchmal so verzweifelt und voller Impulsivität, dass man sich so hart ins Gesicht schlägt, dass die Augen für Tage zuschwillen. Ein ganz dummer Witz, wenn man sich wieder mal im Affekt die Hände an der Wand dick und blau geschlagen hat um Erregung abzubauen. Wenn man den tausend Euro teuren Laptop vor lauter Wut über ein Telefonat gegen die Wand wirft, und wenn man Dinge zu Menschen sagt, die man nicht sagen möchte, weil man diese Menschen liebt.</p>\n<img src=\"/content/images/adhs2.jpg\" alt=\"adhs2.jpg\" />\n<p>Versteht mich nicht falsch, ich bin ein intelligenter Mensch, aber meine Sicherungen sind sehr leicht zum Durchbrennen zu kriegen. Das passiert zum Glück nur daheim und auch nur gegenüber mir selbst oder Gegenständen, aber ich habe keine Kontrolle darüber. Ich bin impulsiv. Und ich habe ein Problem mit Konzentration und Warten. Das kann ich schlecht.</p>\n<p>Ein Beispiel: Mein Freund schaltet den Fernsehsender um und bittet mich er möge nur fünf Minuten lang einen wichtigen Ausschnitt in einer Doku gucken und ich könne sofort danach weiter entscheiden was ich gucken möchte. Mein Verstand sagt mir, ich sollte mich zurücknehmen, denn natürlich möchte ich, dass mein Freund etwas gucken kann, wenn es ihn interessiert. Ich merke allerdings wie es in mir brodelt. Da schleicht sich plötzlich eine fiese Unruhe ein, die ich selber nicht kontrollieren und steuern kann. Dieses Gefühl die Situation nicht aushalten zu können wird übermächtig. Meine Laune wird schlecht, ich stehe auf uns bringe Sachen in die Küche und komme zurück. Fünf Minuten! Ich kann es nicht. Hantiere am Sofa. Versuche mich zu setzen. Laufe zum Fenster und schaue raus. Mein Freund, der mich liebt, möchte nun wissen, was denn los sei. Und dann platze ich heraus, weil mein Erregungslevel so hoch ist. Die Antwort die nun kommt ist meistens doof und ungerecht. Weil ich sie nicht steuern kann. Weil ich voll mit Energie und Wut bin. Meistens dann schon in einem kleinen Meta-Kreis auf mich selber, weil ich weiß wie ätzend ich mich verhalte und dass andere Menschen sich zusammenreißen können. Warum kann ich es nicht? Defizite. Defizite. Defizite. Ich aber kann es nicht steuern. Ich kann keine fünf Minuten etwas gucken was ich nicht mag. Ich kann nicht still sitzen. Ich könnte nun aufstehen und eine Runde joggen gehen. Das tue ich auch. Oder so ähnlich, aber ich kann es eben nicht in jeder Situation machen. Ständig joggen, wer will das schon? Also muss ich lernen mich diesem Problem zu stellen und Strategien zu entwickeln, die meine Erregung wieder abbauen.</p>\n<p>Nun gibt es aber eine wundersame Waffe, die mir hilft dieses Erregungslevel zu kontrollieren, es niedrig zu halten und somit zu vermeiden, dass ich mich gegenüber mir selbst, meinem Freund oder meinen Mitmenschen so verhalte, dass ich mich nachher dafür schäme und die Frustration und Unzufriedenheit weiter anwächst: Methylphenidat (MPH), auch bekannt unter dem Namen “Ritalin” (nur einer von vielen Handelsnamen). Ich nehme täglich drei Kapseln des Arzneimittels und erziele damit große Erfolge. 60-70mg MPH am Tag. Das ist nicht viel. Aber es hilft mir. Ich schaffe es, mein Erregungslevel dauerhaft zu stabilisieren. Das klappt natürlich nicht immer vollkommen, aber es klappt spürbar. Für mich und für meine Umgebung. Das tut mir gut, denn ich laufe nicht wie ein angespannter Flitzebogen durch die Welt. Oder wie Woyzeck sagte: Wie ein aufgeklapptes Messer. Das ist ein echtes Geschenk für mich und ermöglicht mir die Ruhe zu finden um mich mit anderen Strategien auseinandersetzen zu können. Ich habe mich nie gefühlt als ob das Medikament mich verändert hat, wie es Kritiker immer anführen. Ich bin immer noch kreativ und schaffe es endlich wieder meine Schwächen als Stärken nutzen zu können. Das ist ein schöner Moment für das Selbstbewusstsein und das möchte ich mir von uninformierten Laien ohne Leidensdruck nicht nehmen und in Abrede stellen lassen.</p>\n<p>Ich sehe ADHS auch mit meinem Background als Diplom Sozialpädagogin ganz pragmatisch: Das Medikament kann helfen einen Basis zu schaffen sich selber mit psychologischen Strategien helfen zu können, dennoch gilt es immer zwischen Nebenwirkungen und Nutzen abzuwägen. Im Einzelfall sollte entschieden werden und das möglichst systemisch: Möchte das Kind das Medikament nehmen? Möchten die Eltern dies? Empfehlen es Fachärzte? Und wenn man sich dann für eine Einnahme von MPH entscheidet, möchte ich bitte auch, das ein Gesellschaft das akzeptiert. Denn diese Medikamente werden eben nicht “verabreicht”, weil sich niemand interessiert, sondern weil Eltern verzweifelt sind und ihrem Kind eine Chancen auf Normalität in einem System einräumen möchten, die ihm sonst vielleicht verwehrt bleiben würden.</p>\n<p>Ich programmiere mich nun seit zwei Jahren langsam und mühevoll um. Der Anfang lässt hoffen und ich bin optimistisch. Und dabei ist es mir egal was Ihr über ADHS denkt, aber Euch sollte es nicht egal sein!\nDanke für die “Aufmerksamkeit”!</p>\n"}

/***/ }),
/* 572 */
/***/ (function(module, exports) {

	module.exports = {"title":"Exciting Autumn","date":"2012-10-30 00:00:00 +0000","tags":null,"layout":"post","body":"<p>Es ist Herbst. Die Eichhörnchen legen sich Vorräte an und wir können die Nummer des Pizzalieferservice wieder auswendig. Ja, wir werden wieder dicker und ja, Schwiegertochter Gesucht schafft es im Jahr 2012 nicht mehr unser Selbstwertgefühl wieder aufzurichten.</p>\n<p>Jetzt heißt es wieder: Weg von den Menschen und ein wenig Zeit mit sich und den schönen Dingen verbringen. Kerzen an, Jogginghosen raus.</p>\n<p>Ich habe ein paar Tipps gegen die Herbst-Langeweile für Euch zusammengestellt:</p>\n<img src=\"/content/images/kuchen.jpg\" alt=\"kuchen.jpg\" />\n<p>Einen Apple Mosaic Tart With Salted Caramel backen. Meiner war übrigens perfekt (siehe Foto). Denkt aber unbedingt daran ein gutes Vanilleeis im Haus zu haben, das ihr über den warmen Kuchen werfen könnt. Hier das Rezept gefunden bei <a href=\"http://smittenkitchen.com/blog/2012/10/apple-mosaic-tart-with-salted-caramel/\">Smittenkitchen</a>.</p>\n<p>Das Mixtape “My Type Of Party” von <a href=\"https://twitter.com/eins\">Aleks</a>:</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/yo-eins-raps/yo-eins-raps-1-week-43\">player</a></p></p>\n<p>Lesestoff von <a href=\"http://www.welt.de/print/wams/article110319267/Nuechtern.html\">Benjamin von Stuckrad-Barre</a>.</p>\n<blockquote>\"Wenn ich am Alkoholtrinken etwas immer verachtet habe, so ist es das sogenannte maßvolle Trinken. Vernünftig trinken wohl gar noch, Rausch ohne Reue? Amateure!\"</blockquote>\n<p>Das Halloween-Mixtape von Snoop Dogg hören:</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/snoopdogg/dj-snoopadelic-halloween\">player</a></p></p>\n<img src=\"/content/images/kastanie.jpg\" alt=\"kastanie.jpg\" />\n<p>Auf <a href=\"http://mundraub.org/\">Mundraub.org</a> nachschauen wo in Eurer Region tolle Beeren, leckere Früchte oder Nüsse wachsen, die niemandem gehören und dann auf zur Ernte!</p>\n<p>Das neue Album von Lindstrøm “Smalhans” hören:</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/feedelity/sets/smalhans\">player</a></p></p>\n<img src=\"/content/images/FZMSI6UG0ZWKX6Y.LARGE.jpg\" alt=\"FZMSI6UG0ZWKX6Y.LARGE.jpg\" />\n<p>Habt Ihr Euch schon ein eigenes Lichtschwert gebaut? Anleitung findet Ihr bei <a href=\"http://www.instructables.com/id/Building-a-Lightsaber/\">Instructables</a>.</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/E21LJiFJ7zM\" frameborder=\"0\" allowfullscreen></iframe>\n"}

/***/ }),
/* 573 */
/***/ (function(module, exports) {

	module.exports = {"title":"Fashion Entry: Mein Lieblingsshirt","date":"2015-01-21 15:12:50 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2015/Jan/jesus.jpg\" alt=\"alt\"></p>\n<p>Tagesaktuell zur Berliner Fashion Week, die derzeit wieder tausende Menschen mit <a href=\"http://blog.shopstyle.de/Keilabsatz-23625835\">Schweinefuß-Schuhen</a> in die ohnehin schon total überfüllte Stadt an der Spree stolpern lässt, möchte ich den Auftakt zu einer neuen Serie hier auf Textkrieg starten:</p>\n<h3>Fashion Entry: Heute über mein Lieblingsshirt.</h3>\n<p>Es begab sich also zu der Zeit, in der ich mich im letzten Herbst mal wieder in San Francisco aufhielt, als mein Handy klingelte und mich meine aufgelöste Mutter informierte, dass meine Großmutter soeben (einige Tage vorher) verstorben sei. Hanna, mein Vorbild in Sachen Feminismus und Herrenstyle. Ich erlitt einen emotionalen Streifschuss.</p>\n<p>Irgendwie traurig das Ganze, dachte ich mir. Und ich bin ja auch so ein schrecklich sensibler Mensch. Das wußte ich inzwischen sehr wohl. Also verabschiedete ich meine Frau Mutter und zog los, um mich gewaltsam abzulenken und beschloss alles zu essen, was meinen Weg kreuzte und irgendwie lebensbejahend daherkam. Nach getaner Arbeit, einige Tage später, fühlte ich mich wieder regeneriert. Allerdings spannten die wenigen Shirts, die bei der Anreise in meinem Koffer im Gepäck Platz gefunden hatten, über meinem Bauchschinken und ich fand mich gezwungen, in einem äußerst energetischen Schub, der mich aufgrund meines Erfolgerlebnisses hinsichtlich der totalen Verdrängung meiner Gefühle ereilte,  erneut in die Strassen von San Francisco zu drängen und mich zu bekleiden, wie so ein Mensch, der modebewusst ist und einen lockeren Geldbeutel besitzt. Da mir Mode aber nicht viel gibt, ausser Verhüllung meines ohnehin perfekten Körpers und Schutz gegen Klimaauswirkungen, und ich mein Geld im Allgemeinen auch eher lieber in Essen investiere, zog es mich auf den Weg zum lokalen <a href=\"http://thrifttown.com/\">Thrift Shop</a>, um mich mit Body Positiven Übergrößenshirts auszustatten, statt mich zu bemitleiden.</p>\n<p>Wie es der Zufall so wollte (ich habe ihn zwar nicht persönlich fragen können, aber ich nehme an, es war ganz nach seinem Gusto) fand ich mich inmitten eines großen Halloween Ausverkaufs des gammeligen Second-Hand Shops wieder. Vermutlich war ich aber bereits mittags schon superstoned und somit mein Geschmack an diesem Tag und die Folgen meiner breiten Entscheidungen auch besonders erlesen. Mein Fund bestätigt dies auch eindringlich im Nachhinein.</p>\n<p>In Windeseile packte ich etwa zehn riesige Shirts in meinen Korb und eilte ohne Anprobe zu Kasse, denn ich wußte dass ich gerade aufgrund der Geschehnisse in den letzten Tagen in der Mitte groß war und dass mir folglich große Shirts auch passen würden. Für das XXL-Shirt mit einem aufgedruckten <a href=\"http://en.wikipedia.org/wiki/Jes%C3%BAs_Malverde\">Jesús Malverde</a>, dass stark nach Schweiß roch, ausgewaschen und ausgebeult war, zahlte ich kaum einen Dollar und verschwand mit Sonnenbrille und Laseraugen in die taghellen Strassen des Mission Districts, in dem mexikanische Einwanderer das Erscheinungsbild auf so wundersam attraktive Art und Weise prägen. Natürlich nicht ohne mir vorher eine <a href=\"http://en.wikipedia.org/wiki/Cuban_sandwich\">Torta Cubana</a> “with fried cuban beef, chicken, bacon, ham, pig legs, ground beef, hot dogs, cheese, scrambled eggs and lettuce” und einen 1l Becher Ben &amp; Jerry’s zu kaufen.</p>\n<p><img src=\"/content/images/2015/Jan/torta.jpg\" alt=\"alt\"></p>\n<blockquote>\n<p>Jesús Malverde, possibly born as Jesús Juarez Mazo (1870-1909) (pronounced: [xeˈsus malˈβeɾ.ðe]), sometimes known as the “generous bandit”, “angel of the poor”, or the “narco-saint”, is a folklore hero in the Mexican state of Sinaloa. He is a “Robin Hood figure” who was supposed to have stolen from the rich to give to the poor.</p>\n</blockquote>\n<blockquote>\n<p>He is celebrated as a folk saint by some in Mexico and the United States, particularly among those involved in drug trafficking. He is not recognized as a saint by the Catholic Church.</p>\n</blockquote>\n<p>Kaum trug ich fortan das Shirt, fühlte ich mich auf wundersame Art und Weise sehr mächtig und absolut geschlechtslos (Macht kennt kein Geschlecht!), so dass ich beschloss, das Shirt immer dann zu tragen, wenn ich mich unendlich fühlte, was derzeit recht häufig vorkommt.</p>\n<p>Das ist Fashion für mich.</p>\n"}

/***/ }),
/* 574 */
/***/ (function(module, exports) {

	module.exports = {"title":"Fatshaming in San Francisco und Berlin","date":"2014-11-14 21:05:51 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://media3.policymic.com/OTU4Zjk1ZTYwZiMvbTlPbGI2dkZ4WjgtMzdJX3ZXWlpUNlNGMVdBPS8weDA6OTY0eDEwMDAvODQweDUzMC9maWx0ZXJzOnF1YWxpdHkoNzApL2h0dHA6Ly9zMy5hbWF6b25hd3MuY29tL3BvbGljeW1pYy1pbWFnZXMvYXZycGEydm5iNGxhYzlsaG1ncXlneHBrYmg0NmxjemMzOXpqNm55MXhobTJxNW1zYTZ3anUzdWFmNXM1d3dzMC5qcGc=.jpg\" alt=\"alt\"></p>\n<p>Anlässlich des Artikels <a href=\"http://mic.com/articles/104030/here-s-what-it-feels-like-to-be-fat-in-public-in-america\">11 Powerful Photos Show What It Feels Like to Be Fat in America</a>, den Misha von <a href=\"https://www.facebook.com/indubioblog?fref=nf\">indub.io</a> auf seiner Facebookseite geteilt hat, habe ich mir ein paar Gedanken zu meinen Erfahrungen mit Fatshaming und Glotzen in San Francisco und Berlin gemacht.</p>\n<p>Vorweg: Natürlich lässt sich ein flächenmäßig so großes Land wie die USA kaum unter einen Nenner bringen bezüglich einer Gesamtaussage über das Verhalten seiner Bewohner. Daher vergleiche ich die beiden Städte, die ich inzwischen sehr gut kenne, die ähnlich beliebt sind und sich beide selbst als “bunt” und “tolerant” verstehen.</p>\n<p>Ich kann die Beobachtungen aus dem verlinkten Blog in Bezug auf San Francisco so nicht bestätigen. Eher im Gegenteil, denn ich habe selten so viele tolle und selbstbewusste Dicke gesehen, die sich ganz “selbstverständlich” modisch und bequem kleiden und natürlich wunderbar aussehen. Und mich schmerzt es sehr in diesem Zusammenhang von “selbstverständlich” sprechen zu müssen. Ebenso sehr viele Dicke, die Hipsterfreunde haben oder eben selber welche sind und super integriert wirken. Das ist hier Normalität. Man sieht glückliche Dicke auf den Strassen und in diesem Moment fällt einem erst auf, wie sehr das alles in Berlin gerade schiefläuft, weil man dieses Bild einfach nicht gewohnt ist. Es könnte so schön sein.</p>\n<p>Ich sehe lachende Gesichter und keine verschämten Blicke auf den Boden. Und ich war in der Tat sehr verblüfft darüber, denn diese Normalität gibt es in Berlin nicht. In San Francisco trägt so ziemlich jeder einen Rock wenn es warm ist und die “bösen” Leggings sieht man an allen Beinformen, weil sie eben bequem und günstig sind. In der Tat bekommt man hier sogar häufig Komplimente von Fremden (sogar von Frauen, was ich so in Berlin ebenfalls noch nicht erlebt habe) - “Nice shirt!”. Blabla. Man ist schnell im Gespräch. Wo man herkommt und so weiter. Während meiner Zeit in Kalifornien, und ich habe inzwischen eine Menge davon hier verbracht, habe ich nie einen Amerikaner über einen Passanten oder dessen Körper lästern hören, sondern nur Freundlichkeit gehört und wahrgenommen. Entweder man sagt nichts, oder man sagt etwas Nettes. Ich gehöre vielleicht nicht zwingend (je nachdem wer es definiert) zur angesprochenen Gruppe, aber ich könnte diverse Gründe aufzählen warum ich in Berlin häufig angestarrt und angefeindet werde (zu fettige Haare, zu dicke Beine, zu dicker Popo, ungekämmt, Flecken auf der Hose oder mal eine Jogginghose an oder schlechte Haut, wasauchimmer usw.). Ich habe mich noch nie so wohl und akzeptiert gefühlt wie in San Francisco und ich bin nicht bereit auf diesen Komfort nach meiner Rückkehr nach Berlin wieder zu verzichten.</p>\n<p>In Kalifornien sieht man zudem ein weiteres Bild, das für einen Berliner sehr ungewohnt ist: Viele Dicke, die in engen Hosen und ärmellosen Tops Sport treiben. Joggen, Radfahren und alles was man eben so macht, wenn man Sport mag. In Berlin bedarf es schon eines sehr guten Selbstbildes, eines schier unbegrenzten Selbstbewusstseins, wenn man als Dicker Mensch in engen Klamotten laufen geht oder ein Fitnessstudio besucht. Mich macht das traurig. Ist das die Realität, die wir begrüßen?</p>\n<p><img src=\"http://media3.policymic.com/OWI3NDBiMDM5OSMvV29jSWtfQjZJRkJBeE95dWo2bEZVckhEU3RrPS8yeDc4Ojk4MXg3NjkvODQweDU5Mi9maWx0ZXJzOnF1YWxpdHkoNzApL2h0dHA6Ly9zMy5hbWF6b25hd3MuY29tL3BvbGljeW1pYy1pbWFnZXMvMWFxb3RzbDRjZTR5OTVwMWo1djM5cWNlZjlwY3JvZGJubGZubHQzZ3NhOHg2cnF6c2VhM2Z0bWNjZzR5dnBvMi5qcGc=.jpg\" alt=\"alt\"></p>\n<p>Berlin ist eben anders. Berlin ist insgesamt wesentlich dünner. Die modischen Damen der deutschen Hauptstadt haben alle sehr, sehr schlanke Körper. In Kalifornien scheint mir das Ideal zwar auch dünn, aber nicht das magere Dünn zu sein. Der Körperumfang ist in den Köpfen der meisten jungen Berliner, die man so trifft, mit Charaktereigenschaften wie “Stärke”, “Disziplin” und “Kontrolle” verbunden. Heißt: “Wer dick ist, ist schwach und ein Opfer.” Und nach dieser (vermutlich meist äußerst unbewussten - und das meine ich sehr entschuldigend, denn den Fehler möchte ich nicht individuell bei Einzelpersonen suchen) Einstellung wird dann auch gehandelt. Die Verlierer möchte man für ihre fehlende Disziplin abstrafen. Sie sollen ihr Verliererdasein gefälligst auch zu spüren bekommen. Und wenn es nicht offen gesagt wird, dann liest man es aus dem Kontext heraus, oder die Blicke, mit denen dicken Menschen begegnet wird, verraten es. Wer nicht in die sozial akzeptiere Kleidermindestgröße passt oder eben schlechte Haut hat oder “es wagt” trotz seines dicken Arschs eine graue Joggingshose anzuziehen (wie ich), wird attackiert oder schief angeguckt. Es sei denn sie kennen einen und wissen, dass man Ada Blitzkrieg ist. Dann ist es komischerweise immer in Ordnung. LOL! Denkt mal drüber nach…</p>\n<p><em>Nachtrag: Ich hoffe inständig, dass sich niemand durch den Begriff “Dicke” verletzt fühlt. Ich verfolge die aktuelle Diskussion schon lange und leider gibt es für mich noch kein wirklich wertneutrales Konsenswort. Wer einen Vorschlag hat, kann ihn mir gerne per Mail schicken! Dankesehr.</em></p>\n"}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

	module.exports = {"title":"Bestimmt mein Fernsehprogramm für einen schlechten Zweck!","date":"2012-02-14 13:21:49 +0000","tags":null,"layout":"post","body":"<p>\n\tIm Hause Blitzkrieg steht wieder ein kleines Projekt an für das ich Eure Hilfe benötige.</p>\n<p>\n\t&nbsp;</p>\n<h1>\n\tADA WATCHES TV</h1>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img src=\"/content/images/tn_erteel.jpg\" alt=\"tn_erteel.jpg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIhr bestimmt durch Euren Kommentar unter diesem Beitrag welche TV-Formate ich am Samstag, den <strong>25.02 zwischen 10:00 und 24:00 Uhr</strong> sehen muss. Jedes Format, jeder Film, jede Sendung wird mit einer Kurzrezension meinerseits bedacht.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEure Motivation mir eine Sendung vorzuschlagen kann sehr verschieden sein:</p>\n<p>\n\t<br />\n\t- Interesse an der Rezension einer bestimmten Sendung</p>\n<p>\n\t- Sadismus</p>\n<p>\n\t- Aufdrängen Eurer Lieblingsformate und -filme</p>\n<p>\n\t- Spaß</p>\n<p>\n\t- Pferdedokus promoten</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tAlso, langweilt mich zu Tode, schickt mich zu RTL II, JuweloTV oder lasst mich ARTE zerficken.&nbsp;</p>\n<p>\n\tVorschläge entnehmt Ihr bitte dem Fernsehprogramm für den 25.02 zwischen 10:00 und 24:00 und postet den Namen der Sendung oder des Films, den Sender und die Uhrzeit in einen Kommentar oder schickt das Ganze per Mail an <strong>kontakt@textkrieg.de</strong>.</p>\n<p>\n\tBei Doppelbelegungen entscheide ich mich jeweils für den ersten Kommentar. Kleine zeitliche Überschneidungen von ein paar Minuten sind nicht schlimm.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<strong>Bisher durch Euch ausgewählt wurden:</strong></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<strong>10:00 ARTE - Laetitia, allein unter Wölfen</strong></p>\n<p>\n\t<strong>11:00 DAS VIERTE - Lebensberatung</strong></p>\n<p>\n\t<strong>12:00 Super RTL - Barbie Mariposa</strong></p>\n<p>\n\t<strong>13:35 ARTE - Zu Tisch in... Lothringen</strong></p>\n<p>\n\t<strong>14:15 PHOENIX - Abenteuer Linienbus&nbsp;</strong></p>\n<p>\n\t<strong>14:45 ARD - Rosamunde Pilchner - Zeit dr Erkenntnis</strong></p>\n<p>\n\t<strong>16:00 TV.Berlin - Fliege&nbsp;</strong></p>\n<p>\n\t<strong>16:00 Sat! - Richter Alexander Hold</strong></p>\n<p>\n\t<strong>16:50 VOX - Menschen, Tiere und Doktoren</strong></p>\n<p>\n\t<strong>17:50 WDR - Von und zu lecker, wer kocht das beste Adelsmenü?</strong></p>\n<p>\n\t<strong>18:15 Kabel 1 - Die Torten-Tuner</strong></p>\n<p>\n\t<strong>19:00 QVC - Harald Glööckler Glamour &amp; Style</strong></p>\n<p>\n\t<strong>19:25 ZDF - Unser Charly</strong></p>\n<p>\n\t<strong>20.15 ZDF - Willkommen bei Carmen Nebel</strong></p>\n<p>\n\t<strong>22:10 ARD - Das Wort zum Sonntag</strong></p>\n<p>\n\t<strong>23:25 DAS VIERTE - Heiße Girls</strong></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDie Lücken dürfen von Euch noch prall aufgefüllt werden!</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n"}

/***/ }),
/* 576 */
/***/ (function(module, exports) {

	module.exports = {"title":"Fischinstallationen im öffentlichen Raum","date":"2012-04-02 13:11:23 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://textkrieg.de/gallery/image/1/Fischinstallationen/album.jpg.jpg\" alt=\"\"></p>\n<br>\n<p>Vorneweg: Ich habe keine Kunst gemacht! Die Objekte sind nur rein technische Installationen verschiedener Fische im öffentlichen Raum.</p>\n<br>\n<p>Die Installationen bestehen jeweils aus einem Räucherfisch (Forelle oder Bückling) und Gaffa-Tape oder Nägeln, die in den Fisch geschlagen wurden. Die Fische sind in Berlin Kreuzberg installiert und entblößen eine geheime Botschaft, wenn ihre Standorte auf einer Karte verbunden werden.</p>\n<br>\n<p><img src=\"http://textkrieg.de/gallery/image/1/Fischinstallationen/tn_Fis1.jpg\" alt=\"\"></p>\n<br>\n<p><img src=\"http://textkrieg.de/gallery/image/1/Fischinstallationen/tn_Fis3.jpg\" alt=\"\"></p>\n<br>\n<p><img src=\"http://textkrieg.de/gallery/image/1/Fischinstallationen/tn_Fis5.jpg\" alt=\"\"></p>\n<br>\n<p><img src=\"http://textkrieg.de/gallery/image/1/Fischinstallationen/tn_Fis4.jpg\" alt=\"\"></p>\n<br>\n<p><img src=\"http://textkrieg.de/gallery/image/1/Fischinstallationen/tn_Fis7.jpg\" alt=\"\"></p>\n<br>\n<p><img src=\"http://textkrieg.de/gallery/image/1/Fischinstallationen/tn_Fis6.jpg\" alt=\"\"></p>\n"}

/***/ }),
/* 577 */
/***/ (function(module, exports) {

	module.exports = {"title":"Food Truck Your Life!","date":"2014-03-27 14:34:01 +0000","tags":null,"layout":"post","body":"<img src='https://irs2.4sqi.net/img/general/width960/15619140_6ljf1zNBerbzb2tniFPTpNo6ZyaGN36q83aGb-m-rWA.jpg' alt=''>\n<p>Vorweg: Essen ist vermutlich das mit Abstand Beste auf der ganzen Welt. Schön, wenn man sich dafür nicht extra noch ankleiden muss, sondern einfach auf der Strasse die Hände aufhält und sich mit Sauce vollkleckern kann ohne dass es jemand stört. In den USA sind Food Trucks ein alter Hut - langsam erobern sie in kulinarisch hochwertiger Form (Nein, nicht die Crêpes Stände auf den Trödelmärkten) auch Europa. Ich sage HALLO FRESSEN und habe für Euch eine ausführliche Liste mit den besten Food Trucks rund um den Globus zusammengestellt.</p>\n<img src=\"https://irs1.4sqi.net/img/general/width960/aFhIzKpXwcAkLp6FLo8C2_Mn5qTIA5KkTMU5MYySqwQ.jpg\" alt=\"\">\nLet´s get fat! Hier findet Ihr die <a href=\"https://de.foursquare.com/bangpowwww/list/food-trucks-food-courts-street-food\">Food Truck Liste</a>.\n<p>Folgt mir gerne auch auf <a href=\"https://foursquare.com/bangpowwww\">Foursquare</a> und schickt mir gerne Tipps zum Erweitern!</p>\n<img src=\"https://irs3.4sqi.net/img/general/width960/10257938_ITgfqbEDD_Th905HWMgwIXN9U2qnkQVJ96eDZurVEY0.jpg\" alt=\"\">\n"}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

	module.exports = {"title":"FREELANCE","date":"2014-02-25T00:00:00.000+00:00","tags":null,"layout":"post","body":"<p><img src=\"http://media-cache-ec0.pinimg.com/originals/2d/d9/9e/2dd99eca41b5f2c2c070df867e533247.jpg\" alt=\"alt\"></p>\n<h3>ADA</h3>\n<p>Hallo, ich bin Ada Blitz und ich arbeite als Freelance Writer für diverse Formate und Redaktionen in Berlin Kreuzberg und San Francisco.</p>\n<p>27k Follower bei <a href=\"https://twitter.com/bangpowwww\">Twitter</a>, ein paar Tausend Gequetschte bei <a href=\"https://www.facebook.com/bangpowwww\">Facebook</a>, sowie über 10k Fans auf <a href=\"http://instagram.com/bangpowwww\">Instagram</a>. Wer mich bucht, bucht eine ganze Menge Kreativität und originäre Felderfahrung mit.</p>\n<p>Außerdem bin ich Teil des <a href=\"https://fiber.berlin/\">FIBER</a> Squads, einem Boutique Network für Food Influencer Relations.</p>\n<p>Ich bin käuflich und bestreite meinen Lebensunterhalt mit redaktioneller Arbeit, u.a. für <a href=\"http://www.refinery29.de/author/ada-blitzkrieg\">Refinery29</a> oder VICE <a href=\"https://munchies.vice.com/de/contributor/ada-blitzkrieg\">Munchies</a>. Auf Anfrage erstelle ich auch Pressetexte, übernehme Social Media Redaktion &amp; Konzept.</p>\n<p>Anfragen zu Stundensatz und freien Kapazitäten gerne im Rahmen einer Mail an <a href=\"mailto:kontakt@textkrieg.de\">kontakt@textkrieg.de</a>, über <a href=\"https://www.linkedin.com/in/adablitzkrieg/\">LinkedIn</a> oder über meine Social Media Kanäle.</p>\n"}

/***/ }),
/* 579 */
/***/ (function(module, exports) {

	module.exports = {"title":"Furnished apartment in Berlin Kreuzberg for 18 months","date":"2014-04-30 14:42:56 +0000","tags":null,"layout":"post","body":"<img src=\"https://fbcdn-sphotos-b-a.akamaihd.net/hphotos-ak-ash4/t1.0-9/10157278_777841975560445_4119254945576073867_n.jpg\" alt=\"\">\n<p>(Scroll down for English version!)</p>\n<p>Unsere schöne Altbauwohnung in Kreuzberg 61 wird ab 1.Juli 2014 frei und wir suchen einen Untermieter für die vollen 18 Monate. Sagt es gerne weiter!</p>\n<p>Eckdaten:\n86qm in der Mittenwalder Strasse 24 in 10961 Kreuzberg. 3.OG mit 3ZKB, tollen alten Dielen in der gesamten Wohnung, Badewanne und Stuck mit Schwangerenbäuchen in zwei Räumen.</p>\n<p>Monatlich: 957 Euro inklusive warm, Wasser, Strom und Möbelnutzung.</p>\n<img src=\"https://fbcdn-sphotos-g-a.akamaihd.net/hphotos-ak-ash3/t1.0-9/10170987_777841878893788_2399726109856976115_n.jpg\" alt=\"\">\n<p>Zwei Räume sind sehr hell und liegen zur Strasse. Die helle Küche und ein weiteres Zimmer liegen zum ruhigen Innenhof mit Blick auf einen alten Baum und ein altes Fabrikloft. Die U7 Gneisenausstrasse liegt nur ein paar Meter entfernt.</p>\n<p>Im Wohnzimmer und in der Küche haben wir mit viel Arbeit renoviert und die alten Tapeten entfernt (siehe Fotos!). Und im riesigen Wohnzimmer haben wir mit spezieller Leinwandfarbe eine ordentliche Leinwandfläche (riesig!) um Beamer zu gucken aufgemalt. Cinemagefühl. Außerdem wurden zum Einzug die ochsenroten Dielen abgeschliffen und sind nun im schönen Holzlook.</p>\n<img src=\"https://fbcdn-sphotos-f-a.akamaihd.net/hphotos-ak-prn2/t1.0-9/10155773_777842012227108_1740573606352656867_n.jpg\" alt=\"\">\n<img src=\"https://scontent-a-ams.xx.fbcdn.net/hphotos-ash3/t1.0-9/10169261_777841735560469_5120943903126212554_n.jpg\" alt=\"\">\n<p>Wer Interesse hat und die Wohnung mit Möbeln für die vollen 18 Monate mieten möchte, kann mir eine Mail schreiben.</p>\n<p>Außerdem besteht nach wie vor die Option eines Wohnungstauschs nach San Francisco. Kreuzberg gegen San Francisco. Hierfür auch gerne melden! Meine Mailadresse und Kontaktdaten findet Ihr <a href=\"http://textkrieg.de/pages/kontakt\">HIER!</a></p>\n<img src=\"https://scontent-b-ams.xx.fbcdn.net/hphotos-prn2/t1.0-9/10170855_777841738893802_6475096342804570235_n.jpg\" alt=\"\">\n<img src=\"https://scontent-a-ams.xx.fbcdn.net/hphotos-frc3/t1.0-9/1925147_777841762227133_7765536180969741642_n.jpg\" alt=\"\">\n<p>English:\nWe’re looking for someone who wants to rent our beautiful and furnished apartment in Berlin Kreuzberg for 18 months. It will be available from July 01 2014 for the period of 18 months.</p>\n<p>3 rooms, kitchen and bath in Berlin Kreuzberg. 86 squaremeters. Near U Gneisenausstrasse. Monthly rent is 957 Euro. Security deposit is 2000 Euro.</p>\n<p>If you’re interested, <a href=\"http://textkrieg.de/pages/kontakt\">contact me!</a>\nPlease share with your friends!</p>\n<img src=\"https://scontent-a-ams.xx.fbcdn.net/hphotos-prn2/t1.0-9/988864_777841775560465_737460678903688356_n.jpg\" alt=\"\">\n<img src=\"https://fbcdn-sphotos-f-a.akamaihd.net/hphotos-ak-frc3/t1.0-9/1779695_777841728893803_7661253699900144408_n.jpg\" alt=\"\">\n<img src=\"https://fbcdn-sphotos-c-a.akamaihd.net/hphotos-ak-prn2/t1.0-9/10157383_777841782227131_1888034501498789746_n.jpg\" alt=\"\">\n<img src=\"https://scontent-b-ams.xx.fbcdn.net/hphotos-prn2/t1.0-9/p417x417/1532159_777841838893792_1281626459269857218_n.jpg\" alt=\"\">\n<img src=\"https://scontent-b-ams.xx.fbcdn.net/hphotos-prn2/t1.0-9/1530303_777841868893789_2772531739251912783_n.jpg\" alt=\"\">\n<img src=\"https://scontent-a-ams.xx.fbcdn.net/hphotos-frc3/t1.0-9/10256493_777841895560453_758718375127038678_n.jpg\" alt=\"\">\n<img src=\"https://scontent-a-ams.xx.fbcdn.net/hphotos-prn1/t1.0-9/10153962_777841922227117_21082365716100671_n.jpg\" alt=\"\">\n<img src=\"https://fbcdn-sphotos-e-a.akamaihd.net/hphotos-ak-prn2/t1.0-9/10268599_777841928893783_2622514728741431671_n.jpg\" alt=\"\">\n<img src=\"https://fbcdn-sphotos-h-a.akamaihd.net/hphotos-ak-prn2/t1.0-9/1554422_777841965560446_6950765116424909265_n.jpg\" alt=\"\">\n<img src=\"https://fbcdn-sphotos-d-a.akamaihd.net/hphotos-ak-prn2/t1.0-9/10268725_777841982227111_1938033635109623109_n.jpg\" alt=\"\">\n<img src=\"https://fbcdn-sphotos-e-a.akamaihd.net/hphotos-ak-ash3/t1.0-9/10170832_777842035560439_6651167989681542320_n.jpg\" alt=\"\">\n<img src=\"https://fbcdn-sphotos-c-a.akamaihd.net/hphotos-ak-ash3/t1.0-9/10155276_777842055560437_3957183934071254455_n.jpg\" alt=\"\">\n<img src=\"https://fbcdn-sphotos-h-a.akamaihd.net/hphotos-ak-ash4/t1.0-9/10246827_777842065560436_4520309421970489568_n.jpg\" alt=\"\">\n<img src=\"https://fbcdn-sphotos-b-a.akamaihd.net/hphotos-ak-prn1/t1.0-9/10175036_777842082227101_4262476102191685454_n.jpg\" alt=\"\">\n<img src=\"https://fbcdn-sphotos-d-a.akamaihd.net/hphotos-ak-frc3/t1.0-9/1896840_777842102227099_951909383543034852_n.jpg\" alt=\"\">\n"}

/***/ }),
/* 580 */
/***/ (function(module, exports) {

	module.exports = {"title":"Fusion Festival 2011","date":"2011-07-04 07:57:00 +0000","tags":null,"layout":"post","body":"<p>\n\tFestivals sind eine ganz tolle Sache. Bei gutem Wetter für alle. Bei schlechtem Wetter ist *** (auf Wunsch der Marke entfernt) das Thor Steinar der Vorbereitungsnazis. Wir hatten nur ein Billigzelt von ALDI und Stoffschuhe. Das war das <a href=\"http://www.fusion-festival.de/\">Fusion Festival 2011</a>:</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWir starteten am Mittwoch bei strahlendem Sonnenschein und einer Temperatur von mindestens 30&deg;C in Berlin mit einem Zweisitzer-Cabrio. Klar, in so einem Auto ist wenig Platz und ich musste &quot;nur&quot; drei Stunden in draller Sonne, eingewickelt in zwei Biberbettwäschen, auf dem Beifahrersitz vor mich hin siechen. Im Ort, Mirow oder so, angekommen, besorgten wir dann noch zwei Kästen Bier für den Typ, der unser Lager organisiert hatte. Unsere Vorhut hielt sich bereits seit den frühen Morgenstunden auf dem Festivalgelände auf und hielt mit ihren überdimensionierten Funktionsfahrzeugen den Platz für unser Camp frei. Der VW Bulli ist das Platzhalterhandtuch des Festivaltouristen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/fusion5.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tMit zwei Kästen Bier auf dem Schoß und eingewickelt in mehrere Lagen Biberbettwäsche reihten wir uns dann mehrere Stunden in die wartende Autoschlange mit den anderen Druffis vor dem Gelände ein. Dummerweise hatte ich eine Artisten-Freikarte und hätte einfach den VIP Eingang ohne Schlange nehmen können.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWeder mein Gesicht noch das gute Wetter hat sich gehalten. In der Nacht auf Donnerstag fielen die Temepraturen auf -800&deg;C und es regnete ins Zelt. Ich fror und habe Würstchenbrote gegessen. Das Programm startete erst Donnerstags.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tFür mich als absoluten Hygiene-Neurotiker war besonders die Toilettensituation ein echtes Problem. Also aß und trank ich einfach nichts mehr. Es funktionierte.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/fusion6.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"709\" src=\"/files/fusion4.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tMusikalisch ist es auf Festivals immer so ein Ding. Man nimmt sich alles vor und schafft davon nur die Hälfte, wobei man sich davon aktiv nur an ein Viertel erinnern kann. An was kann man sich erinnern und welche Acts hat man verpasst, weil man doch nur in der &nbsp;Rootbase in den Hängematten bei unwürdiger Reggaemusik hin- und herschaukelte?</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<a href=\"http://soundcloud.com/stevebug\">Steve Bug</a>: Steve Bug&nbsp;ist so ziemlich der langweiligste Scheiß seit der Erfindung von Waschmaschinen mit Fenstern.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<a href=\"http://soundcloud.com/electric-sheep\">Electric Sheep</a>: Hoher Elfenanteil im Publikum. Muss man mögen. Alle zwei Minuten wird man gefragt ob man Rollenspiele spielt oder auf Mittelaltermärkten Bienenwachskerzen mit den Füßen herstellt.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<a href=\"http://www.youtube.com/watch?v=EV8lmVGvziM&amp;feature=related\">SCSI-9</a>: Fühlt sich live nach schlaflosen Nächten an, wie in der 9ten Stunde Latein Vokabeltest nach 8 Joints.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<a href=\"http://soundcloud.com/sexy-sushi-1/sexy-sushi-mixt-vol-2\">Sexy Sushi</a>: Wurde groß als French Electro angegündigt, war aber nur eine wirre Mischung aus Autoscootergeräuschen und Tiersexlauten.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<a href=\"http://soundcloud.com/brunogrife/terry-poison-fix-the-night\">Terry Poison</a>: Terry Poison im Luftschloss mit überdimensionierter Lautstärke. Neben uns rauchte ein Typ, der aussah wie der langweilige vom A-Team, mal eben ein Blech Crack in der Glühbirne weg.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<a href=\"http://soundcloud.com/audiolith/sets/supershirt\">Supershirt</a>: Man munkelt das soll gut gewesen sein. Ich habe mir die Typen vor ein paar Wochen im <a href=\"http://aboutparty.net/\">About:Blank</a> gegeben und bin absoluter Fan der Liveshow.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<a href=\"http://soundcloud.com/slagsmalsklubben\">Slagmalsklubben</a>: Auf dem Rückweg von irgendwo durch Zufall an der Turmbühne vorbeigelaufen und mein musikalisches Highlight des Festivals. Zu einer unmöglichen Zeit am Nachmittag im strömenden Regen und trotzdem zertanzt.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/fusion3.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/fusion1.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"323\" src=\"/files/fusion7.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tUnd weil das Wetter hässlicher als ich nach vier Tagen nicht duschen war, sind wir einen Tag früher abgereist und haben daheim erstmal Chickenteile bestellt und in der Badewanne rumgelegen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/fusion9.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/fusion8.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"667\" src=\"/files/fusion2.jpg\" width=\"500\" /></p>\n"}

/***/ }),
/* 581 */
/***/ (function(module, exports) {

	module.exports = {"title":"Gallery","date":"2012-12-02 00:00:00 +0000","tags":null,"layout":"post","body":"<div id='gallery'>\n  <r:gallery />\n</div>\n<script src=\"/vendor/gammagallery/js/jquery.masonry.min.js\"></script>\n<script src=\"/vendor/gammagallery/js/jquery.history.js\"></script>\n<script src=\"/vendor/gammagallery/js/js-url.min.js\"></script>\n<script src=\"/vendor/gammagallery/js/jquerypp.custom.js\"></script>\n<script src=\"/vendor/gammagallery/js/gamma.js\"></script>\n<script type=\"text/javascript\">      \n$(function() {\n  var GammaSettings = {\n      // order is important!\n      viewport : [ {\n        width : 1900,\n        columns : 10\n      }, {\n        width : 1600,\n        columns : 10\n      }, {\n        width : 1200,\n        columns : 10\n      }, {\n        width : 900,\n        columns : 8\n      }, {\n        width : 500,\n        columns : 6\n      }, {   \n        width : 320,\n        columns : 4\n      }, {   \n        width : 0,\n        columns : 4\n      } ]\n  };\n    \n  Gamma.init( GammaSettings);\n});\n</script>\n"}

/***/ }),
/* 582 */
/***/ (function(module, exports) {

	module.exports = {"title":"German Food vs. amerikanisches Essen","date":"2014-04-03 15:10:32 +0000","tags":null,"layout":"post","body":"<img src='http://media-cache-ak0.pinimg.com/236x/37/7a/9d/377a9de017764558dfd378e992e5c5a4.jpg' alt=''>\n<p>Hallo Google, würdest Du uns freundlicherweise verraten was die Topsuchtreffer für “Amerikanisches Essen” und die Top Treffer der Suche nach “German Food” sind?\nJa, sicher. Hier ist eine Liste mit gegenseitigen Vorurteilen:</p>\n<h1>“German Food”?</h1>\n<img src=\"https://farm8.staticflickr.com/7053/13604005754_df24dd6478_o.png\" alt=\"\">\n<img src=\"https://farm8.staticflickr.com/7371/13604000824_887fd6b47a_o.png\" alt=\"\">\n<h1>“Amerikanisches Essen”?</h1>\n<img src=\"https://farm8.staticflickr.com/7001/13603672493_ff4a25844a_o.png\" alt=\"\">\n<img src=\"https://farm8.staticflickr.com/7041/13603654225_4ebb9af169_o.png\" alt=\"\">\n"}

/***/ }),
/* 583 */
/***/ (function(module, exports) {

	module.exports = {"title":"Gewinner des Pferdefunpakets","date":"2011-08-01 13:35:37 +0000","tags":null,"layout":"post","body":"<p>\n\tDer Gewinner des <a href=\"http://textkrieg.de/2011/07/18/pferdeshow-in-audio\">Pferdestorycontests</a> steht fest. Herzlichen Glückwunsch, <a href=\"https://www.facebook.com/pages/MHYH/181444751876259\">Kittklitt</a>! Dein Remix hat gewonnen. In den nächsten Tagen wird dich ein köstliches Pferdepaket erreichen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"500\" src=\"/files/184845_190966890924045_181444751876259_551763_4105423_n.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n<p><object height=\"81\" width=\"100%\"> <param name=\"movie\" value=\"http://player.soundcloud.com/player.swf?url=http%3A%2F%2Fapi.soundcloud.com%2Ftracks%2F19148745&amp;show_comments=true&amp;auto_play=false&amp;color=ff7700\"></param> <param name=\"allowscriptaccess\" value=\"always\"></param> <embed allowscriptaccess=\"always\" height=\"81\" src=\"http://player.soundcloud.com/player.swf?url=http%3A%2F%2Fapi.soundcloud.com%2Ftracks%2F19148745&amp;show_comments=true&amp;auto_play=false&amp;color=ff7700\" type=\"application/x-shockwave-flash\" width=\"100%\"></embed> </object></p>\n</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDanke für die vielen Einsendungen und tollen Erzählungen. Pferde sind wirklich echte Wichser!</p>\n<div>\n\t&nbsp;</div>\n<div>\n\t&nbsp;</div>\n<div><p>\n\tDer Gewinner ist übrigens begnadeter Supermarktdauerwellenträger und seine Jingles kennt man aus nahezu jeder Wurstwerbung in Südostasien. Nebenher bespielt er das pferdefeindliche Regime unter dem Pseudonym <a href=\"http://soundcloud.com/mhyh/\">MHYH</a><a href=\"http://soundcloud.com/mhyh/\"> (My Heart Your Heart)</a> mit speckglitzerndern Sounds.</p></div>\n"}

/***/ }),
/* 584 */
/***/ (function(module, exports) {

	module.exports = {"title":"Gewinnspiel mit Pferde-Merchandise","date":"2011-07-09 13:05:42 +0000","tags":null,"layout":"post","body":"<p>\n\tHeute morgen als ich bei der Fleischerei Domke in der drallen Sonne saß und mir eine ungerechtfertig große Menge zerkochtes Fleisch mit Rotkohl einfuhr, kam mir der Gedanke eine wissenschaftliche Erhebung zum Thema &quot;Aggressive Pferde&quot; durchführen zu müssen. Warum sind Pferde eigentlich so hassenswert? Was sind Eure schlimmsten und traumatischsten Erlebnisse in Bezug auf Pferde?&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEs gibt etwas zu gewinnen! Der Gewinner erhält ein extra von mir gefertigtes Pferde-Merchandise Paket mit vielen Überraschungen. Um teilzunehmen bitte meine <a href=\"http://soundcloud.com/bangpowwww/dropbox\">Dropbox</a>&nbsp;bei Soundcloud benutzen und Eure Aufnahme (Pferdestory) mit Eurem Namen versehen. Die Aufnahmen sind zuerst nur für mich sichtbar. Ich stelle die besten Aufnahmen dann nach Teilnahmeschluss online und lasse Euch den Gewinner auswählen. Teilnahmeschluss ist der 17.07.2011.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"368\" src=\"/files/barbara.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tKeine der Geschichten wird auf ihren Wahrheitsgehalt hin überprüft. Das Kollektiv stimmt ab, wer das Pferde-Merch-Paket als verspätete Reparationszahlung für sein Pferdetraumata gewinnen soll.</p>\n"}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

	module.exports = {"title":"Girls who release","date":"2015-10-05 09:09:33 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2016/Feb/minus.jpg\" alt=\"alt\"></p>\n<p>Heute ist ein guter Montag. Und das hat zwei aberwitzige Gründe in Papier- oder eBook-Form, die ich Euch zwingend ans Herz legen will, denn wie es der merkwürdige Zufall so will: Heute haben zwei feine Freundinnen Bücher veröffentlicht. Und ich freue mich wie ein Kind darauf beide zu lesen. Sofa absaugen. Hinsetzen. Legen. Lesen!</p>\n<p>Hier erstmal Jana, die unangefochtene Haikönigin, die uns mit ihrem Buch <a href=\"http://www.piper.de/buecher/minusgefuehle-isbn-978-3-492-06021-9\">Minusgefühle</a> garantiert zum Weinen, Schreien und Rumwüten bringen wird.</p>\n<blockquote>\n<p>&quot;Nur, weil ich alles habe, was ich brauche, muss es mir nicht gut gehen.“</p>\n</blockquote>\n<p><a href=\"http://www.amazon.de/Minusgef%C3%BChle-Mein-Leben-zwischen-Dunkel/dp/3492060218/ref=sr_1_1?ie=UTF8&amp;qid=1444035387&amp;sr=8-1&amp;keywords=minusgef%C3%BChle\">KAUFEN, KAUFEN, KAUFEN, HIER, HIER. FÜR WENIGER MINUSGEFÜHLE</a></p>\n<p>Aber ich habe noch mehr auf Lager: Denise Linke, die Mutter des legendären <a href=\"https://nummer-magazin.de/\">N#MMER Magazin</a> erscheint heute auf dem Buchmarkt mit <a href=\"http://www.amazon.de/Nicht-normal-aber-das-richtig/dp/3827012783/ref=sr_1_1?ie=UTF8&amp;qid=1444035511&amp;sr=8-1&amp;keywords=denise+linke\">Nicht normal, aber das richtig gut: Mein wunderbares Leben mit Autismus und ADHS</a> und ist eine übergute Sache von einer begnadeten Autorin.</p>\n<p><img src=\"http://www.berlinverlag.de/fileadmin/import/produkte/produkt-2563.jpg\" alt=\"alt\"></p>\n<blockquote>\n<p>Von ihrem Autismus erfährt Denise Linke eher zufällig. Ein Mitbewohner ihrer WG hat Asperger und rät ihr, sich auch testen zu lassen: Volltreffer. Mit Witz und Charme erzählt sie von ihrem außergewöhnlichen Leben - und zeigt auf, was unsere Gesellschaft von denen lernen kann, die anders sind. Und warum Neurodiversität eine große Chance ist.</p>\n</blockquote>\n<p><a href=\"http://www.amazon.de/gp/product/3827012783/ref=s9_psimh_gw_p14_d0_i1?pf_rd_m=A3JWKAKR8XB7XF&amp;pf_rd_s=desktop-1&amp;pf_rd_r=15A9M29V06QKPS9G69RG&amp;pf_rd_t=36701&amp;pf_rd_p=585296347&amp;pf_rd_i=desktop\">Hier kaufen.</a></p>\n"}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	module.exports = {"title":"Google Analytics - Bewaffnete Affen und Katzen mit Busen","date":"2012-06-11 14:02:22 +0000","tags":null,"layout":"post","body":"<p>Dieser Blog ist serviceorientiert und zu 100% viagrafrei. Lesen Sie nun eine Neuauflage der <a href=\"http://textkrieg.de/2011/11/17/keywords\">Keywords-Studien</a>.</p>\n<img src=\"/content/images/tn_google1.JPG\" alt=\"tn_google1.JPG\" />\n<p>Das sind sie also meine Top-Suchanfragen (ermittelt über <a href=\"http://www.google.com/intl/de/analytics/\">Google Analytics</a>), die Leser auf meinen Blog führen. Immerhin kommen mehr Menschen auf meinem Blog, wenn sie nach “Ramona Drews” suchen, als wenn sie meinen Namen googlen. Ich habe es offenbar endlich geschafft meine einnehmende Persönlichkeit hinter meinen journalistischen Leistungen zurückzustellen. Also höchste Zeit für mich einen Porno zu produzieren. Immerhin fällt in den Anfragen ziemlich oft das Wort “geil”. Und Batiken scheint immer noch “das große neue Ding” der coolen Kids zu sein. Hallo Internet, mein Name ist Ada Blitzkrieg und ich beantworte nun die schönsten Suchmaschinenanfragen.</p>\n<img src=\"/content/images/tn_google2.JPG\" alt=\"tn_google2.JPG\" />\n<p>Ich habe sicherheitshalber alle Türen und Fenster verriegelt, denn die Angst, dass alle vier Anfragen von ein und derselben Person stammen könnten, lähmt meine Vernunft. Ist es wieder soweit? Rotten sich gerade da draußen Katzen mit geilen Busen in dunklen Kellerlöchern zusammen? Bewaffenen sich Affen global mit Lasern und Napalm? Werden sie etwa nicht davor zurückschrecken die Dancemusik der 90er Jahre mit allen Mitteln durchzusetzen? Ich denke ja.</p>\n<img src=\"/content/images/tn_google3.JPG\" alt=\"tn_google3.JPG\" />\n<p>Ebenfalls eine Kombination der Liebe. Wer muss bei Ramona Drews nicht an Leichenflecken denken? Ist <a href=\"http://textkrieg.de/2012/03/29/barbara-scheel-anne-will-und-rassismus-bei-den-piraten\">Barbara Scheel</a> ein versautes Girl?</p>\n<img src=\"/content/images/tn_google4.JPG\" alt=\"tn_google4.JPG\" />\n<p>Ob diese Suchanfrage von Barbara Scheel stammt?</p>\n<img src=\"/content/images/tn_google5.JPG\" alt=\"tn_google5.JPG\" />\n<p>Weckt mich, wenn 2Pacs Hologramm bei Richter Alexander Hold auftaucht!</p>\n<img src=\"/content/images/tn_google6.JPG\" alt=\"tn_google6.JPG\" />\n<p>Ich als Referenz Nummer Eins für Wurmbefall - quasi der Marcell Davis des Wurmbefalls - rate folgendes: Würmer im Körper sollten solange kein Thema darstellen, bis das Gerhin betroffen ist.</p>\n<img src=\"/content/images/tn_google7.JPG\" alt=\"tn_google7.JPG\" />\n<p>Richtig, die gab es hier selbstverständlich auch zu bestaunen:\n<img src=\"/content/images/dobermann.JPG\" alt=\"dobermann.JPG\" /></p>\n<p>Bleiben Sie sauber!\nIhr Jonathan Frakes</p>\n"}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

	module.exports = {"title":"Googledogs is my startup","date":"2012-06-20 09:52:42 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/tn_kasten.JPG\" alt=\"tn_kasten.JPG\" />\n<p>Wow, my new project is online. Say hello to <a href=\"http://googledogs.de/\">Googledogs</a>! Now I´m a startup called Googledogs.</p>\n"}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

	module.exports = {"title":"Guide: Ekelhaftes Berlin","date":"2014-08-13 16:21:54 +0000","tags":null,"layout":"post","body":"<p><img src=\"https://irs3.4sqi.net/img/general/width960/129681_lrXnhnEDIRQOmFHnGs71dZVsX3KAjpXFMj33WueScVk.jpg\" alt=\"alt\"></p>\n<p>Berlin ist manchmal echt ziemlich ekelhaft, wir sprechen nur viel zu selten darüber. Touristenmassen, Jungesellenabschiede und MacBooks in Kinderwägen. Listen von schönen Dingen, gibt es viel zu oft, wer fasst denn nun das Unschöne in Worte?</p>\n<p>Daher habe ich für den Fall, dass Ihr unliebsame Gäste (Eltern oder Expartner) in der Hauptstadt bespaßen müsst und ihnen ein maximal schlechtes Hotel, eine versiffte Bar mit Kot an den Türen oder ein Restaurant empfehlen wollt, das stinkende Blähungen und starkes Erbrechen verursacht, einen Guide bei Foursquare zusammengestellt. Keine Ursache.</p>\n<p>Hier findet Ihr die ganze Liste: <a href=\"https://de.foursquare.com/bangpowwww/list/berlin-youre-gross\">Berlin, you’re gross!</a></p>\n<p><img src=\"https://irs0.4sqi.net/img/general/width960/25676066_qiJt8pfCN-HxwtttpmUcHXYNfuojTGs485M-RBT97Uk.jpg\" alt=\"alt\"></p>\n<p>Für weitere Berlin-Empfehlungen einfach meinem <a href=\"https://de.foursquare.com/bangpowwww\">Account auf Foursquare</a> folgen.</p>\n<p>Titelfoto: <a href=\"http://boschblog.de\">Bosch</a></p>\n"}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

	module.exports = {"title":"Guide: How to bathe a cat","date":"2014-03-25 00:00:00 +0000","tags":null,"layout":"post","body":"<img src='http://media-cache-ec0.pinimg.com/736x/3f/0a/94/3f0a94af0898219c14f8bf187a2f4cdb.jpg' alt=''>\n<img src=\"https://farm4.staticflickr.com/3793/13401196823_14e849dfaa_o.jpg\" alt=\"\">\n<p>Für Unverbesserliche: <a href=\"http://www.wikihow.com/Bathe-a-Cat\">WikiHow</a></p>\n"}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

	module.exports = {"title":"Guide to Dublin","date":"2015-04-01 16:54:29 +0000","tags":null,"layout":"post","body":"<p><img src=\"https://igcdn-photos-e-a.akamaihd.net/hphotos-ak-xaf1/t51.2885-15/10952562_902334036476308_93959759_n.jpg\" alt=\"alt\">\nMan muss ja kein bornierter Reiseblogger sein um anderen Tipps für einen Trip nach Dublin zu geben. Mir hat also niemand umsonst Essen serviert, mein Hotel bezahlt oder meinen großen Zeh butterweich gelutscht, sondern ich war ganz alleine im kalten Dauerregen mit meinem 5XL Regencape unterwegs, habe hunderte Pints Bier getrunken und die schönsten Impressionen fotografiert.\nSelbstverständlich habe ich mich auch durch die ganze Stadt gegessen und immer dafür gesorgt dass mein Belly zum bersten voll war. Daraus ist meine <a href=\"https://de.foursquare.com/bangpowwww/list/dublin\">foursquare Dublin To-Do Liste</a> entstanden, die euch eure zukünftigen Tripps versüßen wird. Die vollständige Liste findet ihr unter dem Link bei foursquare, wo ihr mir auch folgen könnt.\n<img src=\"https://igcdn-photos-g-a.akamaihd.net/hphotos-ak-xfa1/t51.2885-15/11032970_937810899593158_581105548_n.jpg\" alt=\"alt\">\nDublin hat weitaus mehr zu bieten als Fish und Chips und verkacktes Wetter, dennoch war das Wetter ziemlich verkackt und ich habe selbstredend direkt mal eine Portion Fish &amp; Chips mit Vinegar auf dem Markt in Howth verschlungen. Die Qualität war unfassbar gut, obwohl es nur ein kleiner Ministand war. Daneben wurden noch furztrockenes Baklava und überteuerte Oliven verkauft. Die Menschen trugen Funktionskleidung.\n<img src=\"https://igcdn-photos-d-a.akamaihd.net/hphotos-ak-xfa1/t51.2885-15/11098661_1558292721118075_1094142488_n.jpg\" alt=\"alt\">\nGenerell muss man sich auf das Wetter einlassen und nicht gegen die elendige Feuchtigkeit kämpfen. Den Fight gegen seine Naturkrause verliert man ohnehin binnen Minuten. Wir haben es so gehandhabt, dass wir bei jedem Nieselregen so getan haben, als wäre nichts. Bei jedem größeren Schauer sind wir in eine Bar gestürmt und haben Craft Beer getrunken. Man muss sich darauf einstellen, dass man sein Street Food und seine Takeaway Optionen im Regen verspeist. Man tut alles im Regen. Ich sehe auf allen Selfies nass und irgendwie dümmlich aus.\n<img src=\"https://igcdn-photos-f-a.akamaihd.net/hphotos-ak-xaf1/t51.2885-15/11055475_785497688198845_1594285730_n.jpg\" alt=\"alt\">\nDafür macht es einen großen Spaß - wenn man denn ein trockes Plätzchen gefunden hat - aus dem Trockenen in den Regen zu starren und den Menschen beim Durchnässen zuzusehen.</p>\n<p>Dublin ist eine Frühstückscity. Die Möglichkeiten für Breakfast und Brunch sind schier unendlich und jedes Restaurant bietet gute Qualität an. Überall bekommt man leckere Eggs Benedict, ohne die man die Lizens verliert einen Instagram Account zu besitzen.\nWir haben es am ersten Tag sehr klassisch gehalten. Mit einem Pott Filterkaffe, Irish Scones mit Jam und Cream und irischem Soda Bread. Hier findet ihr die Rezepte:\n<a href=\"http://farmette.ie/2012/04/06/irish-brown-bread/\">Irish Soda Bread</a> und\n<a href=\"http://www.tinnedtomatoes.com/2009/07/scones-with-clottted-cream-jam.html\">Scones with Clottted Cream &amp; Jam</a>\n<img src=\"https://igcdn-photos-h-a.akamaihd.net/hphotos-ak-xaf1/t51.2885-15/11084815_1419934948309783_655414047_n.jpg\" alt=\"alt\">\nUnd wär hätte es gedacht, dass man den besten Burger und die besten Burritos ausserhalb Kalifornien in der Tat in Dublin findet? Das Beef passte genau auf den Bun, der supersoft war. Das Fleisch war medium gegart, voll mit Fleischsaft. Die Sauce war schön mimimal und es gab keinen unnötigen Salatschnickschnack. Die Burritos waren ebenfalls interessant. Sie versuchten gar nicht die kalifornischen Taquerien zu kopieren, sondern trumpften mit eigenen Kreationen wie Pulled Pork oder Irish Guiness Beef auf. Die Guacamole und das Pico de Gallo gingen mir ebenfalls super rein.\n<img src=\"https://igcdn-photos-g-a.akamaihd.net/hphotos-ak-xaf1/t51.2885-15/11055994_1420755074894974_1220418175_n.jpg\" alt=\"alt\">\nIch habe noch niemals so viel Kaffee getrunken. Zum einen weil ich Schutz vor dem Regen suchen musst, zum anderen weil es eine große Auswahl an gut ausgeführten Filterkaffees gab. Eine Hipsterstadt ohne Hipster. Die fehlten irgendwie. Außer ein paar vereinzelten Bärtigen auf Bikes war kaum etwas zu spüren. Keine Ahnung ob das jetzt positiv oder negativ ist.\n<img src=\"https://igcdn-photos-f-a.akamaihd.net/hphotos-ak-xaf1/t51.2885-15/11049427_960067794004357_238716482_n.jpg\" alt=\"alt\">\nWo, was und warum ihr in Dublin aufschlagen solltet und die vollständige Liste mit allen Adressen und Tipps findet ihr hier:\n#<a href=\"https://de.foursquare.com/bangpowwww/list/dublin\">Guide to Dublin</a></p>\n"}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

	module.exports = {"title":"Happiness - eine Dystopie","date":"2012-02-23 11:58:54 +0000","tags":null,"layout":"post","body":"<p>\n\t<img src=\"/content/images/tn_happiness.jpg\" alt=\"tn_happiness.jpg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDystopie ist unsere Lüge.</p>\n<p>\n\tWas, wenn wer wirklich glaubt.</p>\n<p>\n\tAmbivalenz zwischen Glaube und Handlung.</p>\n<p>\n\tWeiße Wände.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDie Heizung schreit Wärme in den Raum.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIrgendwie hält man sich aufrecht.</p>\n<p>\n\tWir sind nicht Design.</p>\n<p>\n\tDie Knicke lassen weiche und Hohläume zurück.</p>\n<p>\n\tWir sind Designer.</p>\n<p>\n\tDas Rückgrat ist eine matschige Zellmasse.</p>\n<p>\n\tEnge Hosen halten uns zusammen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n"}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

	module.exports = {"title":"Hello San Francisco: Mixtape","date":"2014-09-30 12:30:15 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://media-cache-ec0.pinimg.com/736x/25/75/e8/2575e8bdd8a28183cb36b216edad18d0.jpg\" alt=\"alt\"></p>\n<p>Gottverdammter Herbst - wie die nebelige Sau uns nun wieder ins Gemüt grätscht. In diesem hässlichen Berlin. Zwischen all dem irrsinnigen Betongewurste und den siffigen Krähen. Wie kurz die Tage sind und wie dunkel die Welt.</p>\n<p>Gut, dass ich Euch für den Herbst im Stich lasse und meine Koffer für San Francisco packe. Ein Apartment ist bereits gefunden, ein Flug gebucht. Ende der Woche geht es in die Stadt der Burritos. 27 Grad, das liest sich gut. Viel Sonne. Nette Menschen. Zum Abschied habe ich Euch noch schnell ein Mixtape gebastelt. That’s all.</p>\n<p>Folgt mir bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> und lasst Euch nicht unterkriegen!</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/52437472&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	module.exports = {"title":"Hipster Outtakes","date":"2012-08-01 11:17:54 +0000","tags":null,"layout":"post","body":"<p>Wann denn jetzt endlich mein Kochbuch rauskommt, fragt Ihr immer wieder, und hey, ich schreibe derzeit in der Tat an etwas. Allerdings wird es ein Roman und der wird natürlich richtig gut und hat rein gar nichts mit Essen zu tun.\nDa ich dennoch gefühlte hundert Stunden jeden Tag in meiner kleinen siffigen Küche stehe und Torten aufschminke, habe ich ein kleines Appetithäppchen für Euch: Die Outtakes.</p>\n<p>Ada Blitzkrieg - meine hässlichsten Speise. Dabei handelt es sich um eine liebevoll getätigte Auswahl der hässlichsten und schlecht fotografiertesten Gerichte, die ich verzehrte oder kochte und niemals hochgeladen haben.</p>\n<p>Guten Appetit!</p>\n<img src=\"/content/images/tn_iPhone_Fotos_615.jpg\" alt=\"tn_iPhone_Fotos_615.jpg\" />\n<img src=\"/content/images/tn_iPhone_Fotos_1256.jpg\" alt=\"tn_iPhone_Fotos_1256.jpg\" />\n<img src=\"/content/images/tn_iPhone_Fotos_970.jpg\" alt=\"tn_iPhone_Fotos_970.jpg\" />\n<img src=\"/content/images/tn_iPhone_Fotos_869.jpg\" alt=\"tn_iPhone_Fotos_869.jpg\" />\n<img src=\"/content/images/tn_iPhone_Fotos_654.jpg\" alt=\"tn_iPhone_Fotos_654.jpg\" />\n<img src=\"/content/images/tn_iPhone_Fotos_621.jpg\" alt=\"tn_iPhone_Fotos_621.jpg\" />\n<img src=\"/content/images/tn_iPhone_Fotos_616.jpg\" alt=\"tn_iPhone_Fotos_616.jpg\" />\n<img src=\"/content/images/tn_iPhone_Fotos_557.jpg\" alt=\"tn_iPhone_Fotos_557.jpg\" />\n<img src=\"/content/images/tn_iPhone_Fotos_520.jpg\" alt=\"tn_iPhone_Fotos_520.jpg\" />\n<img src=\"/content/images/tn_iPhone_Fotos_386.jpg\" alt=\"tn_iPhone_Fotos_386.jpg\" />\n<img src=\"/content/images/tn_iPhone_Fotos_374.jpg\" alt=\"tn_iPhone_Fotos_374.jpg\" />\n<img src=\"/content/images/tn_iPhone_Fotos_241.jpg\" alt=\"tn_iPhone_Fotos_241.jpg\" />\n<img src=\"/content/images/tn_iPhone_Fotos_182.jpg\" alt=\"tn_iPhone_Fotos_182.jpg\" />\n<img src=\"/content/images/tn_iPhone_Fotos_180.jpg\" alt=\"tn_iPhone_Fotos_180.jpg\" />\n<img src=\"/content/images/tn_IMG_5941.jpg\" alt=\"tn_IMG_5941.jpg\" />\n<img src=\"/content/images/tn_IMG_5800.jpg\" alt=\"tn_IMG_5800.jpg\" />\n<img src=\"/content/images/tn_IMG_5345.jpg\" alt=\"tn_IMG_5345.jpg\" />\n<img src=\"/content/images/tn_IMG_5775.jpg\" alt=\"tn_IMG_5775.jpg\" />\n<img src=\"/content/images/tn_IMG_5169.jpg\" alt=\"tn_IMG_5169.jpg\" />\n<img src=\"/content/images/tn_IMG_4944.jpg\" alt=\"tn_IMG_4944.jpg\" />\n<img src=\"/content/images/tn_IMG_4615.jpg\" alt=\"tn_IMG_4615.jpg\" />\n<img src=\"/content/images/tn_IMG_4455.jpg\" alt=\"tn_IMG_4455.jpg\" />\n<img src=\"/content/images/tn_IMG_2278.jpg\" alt=\"tn_IMG_2278.jpg\" />\n"}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

	module.exports = {"title":"San Francisco Hipstercity und deutsche Vorurteile","date":"2012-08-30 00:00:00 +0000","tags":null,"layout":"post","body":"<p>\n\t<img src=\"/content/images/SF11.JPG\" alt=\"SF11.JPG\" /></p>\n<p>\n\tDer erste Absatz dreht sich wie in jedem schlechten Reisetext ausschließlich um den Flug und interessiert in der Regel auch wirklich niemanden, der nicht zufällig mit Vornamen &quot;Mutter&quot; heißt und sich gerade Sorgen um dich macht. Ich bin also geflogen, mit einem Flugzeug (nehme ich an), und angekommen in den USA. Ort: San Francisco. Laune: Drive-By-Lachen. Temperatur: Sommerlich.</p>\n<p>\n\tNun, ich bin also seit ein paar Tagen in diesem gigantischen und großartigen Amerika. Ich glaube heute ist der dritte Tag hier im Land der &quot;unbegrenzten Möglichkeiten&quot;. Ihr kennt Amerika ja aus den Erzählungen vorurteilsbehafteter Deutscher:</p>\n<p>\n\t- Amerikaner sind übergewichtig</p>\n<p>\n\t- Amerikaner sind moralbefreit</p>\n<p>\n\t- Amerikaner besitzen Waffen</p>\n<p>\n\t- Amerikanisches Essen ist minderwertig</p>\n<p>\n\t- Amerikanischer Kaffee ist schlecht</p>\n<p>\n\t- Amerikaner sind unfreundlich, laut und unreflektiert</p>\n<p>\n\t<img src=\"/content/images/SF9.JPG\" alt=\"SF9.JPG\" /></p>\n<p>\n\tAch Deutschland, wieso fühlst Du Dich eigentlich gegenüber Amerikanern immer so hochwertig, europäisch und sowieso irgendwie kulturell überlegen? Möchtest Du etwas überspielen? Völkermord oder andere &quot;kleinere&quot; gesellschaftliche Defizite? Amerikafeindlicheit ist in Deutschland weit verbreitet und manchmal bloß etwas netter und schöner verpackt als die herkömmliche Fremdenfeindlichkeit, die sonst immer gleich ins Auge springt. Amerikafeindlichkeit ist in Deutschland akzeptiert. Wieso eigentlich? Ist das nicht irgendwie verkehrt?</p>\n<p>\n\tAber was wäre, wenn ich an einem Ort gelandet bin, an dem es eine lebhafte und akzeptierte Kultur der gemischten Lebensentwürfe geben würde? In dem die verschiedensten Menschen im gleichen Grocery-Store einkaufen und zusammen Taccos in der 24th Street verschlingen? Ganz schön tolerant und multikulturell hier. So kenne ich es aus Berlin nicht. Berlin, das Aushängeschild deutscher Toleranz. Liberales Berlin. Kreuzberg, wie &quot;nett dieses Multikulturelle ist&quot;. Wie groß die Lügen manchmal sind.</p>\n<p>\n\tDie Vorurteile gegenüber Amerika dienen dem eigenen Klötenschlecken und rückversichern einer nationalen Elite. Deutschland! Berlin! &quot;Wie gut wir es doch in Deutschland haben. Da darf man sich nicht beschweren!&quot; Blödsinn. San Francisco belehrt uns eines Besseren. Berlin, du kannst noch so viel lernen!&nbsp;</p>\n<p>\n\t<img src=\"/content/images/SF10.JPG\" alt=\"SF10.JPG\" /></p>\n<p>\n\tSan Francisco, auch bekannt als Hipstermetropole, Kernpunkt der Homosexuellenbewegung und Flower Power Metropole. Aber was ist 2012 davon übrig geblieben? Überraschend viel. Eine bunte Gesellschaft, die einen nicht anstarrt, wenn man ungewaschen in Jogginghose im Trendcafé Brötchen holt. In der wir nicht auffallen. In der niemand auffällt. Die Menschen sind in der Tat toleranter als ich es aus Berlin gewohnt bin. Diese Stadt hat mich gleich begeistert. Ich liebe Berlin, aber ich liebe auch dieses Offenheit in San Francisco. Es ist hier ein wenig als wäre man in den Fernsehserien seiner Kindheit augestiegen. Dicke Karren, alte Karren. Palmen. Taccos und Burritos an jeder Ecke. Grocery Stores. Und kein einziger Supermarkt mit XXL Fettmachern. Die Leute sind hier gar nicht so fett, sondern ganz normal. Wir hingegen essen uns durch alle Burgerläden der Stadt, denn das Essen ist hochwertig und lecker hier. Wir trinken Bier auf dem Hausdach. Sitzen auf der Feuertreppe und im Dolores Park mit einem total irrsinnigen Blick auf die hügelige Stadt. Heute Morgen zog Nebel über die Berge. Nun heizen die Wolken mit 92987277298 km/h über uns. Dieses Glück fühlt sich richtig und gut an. Ich bin überall dort zuhause wo ich Glück spüren kann. Ohne Land. Ohne Nationalität. Da ist Heimat. Ich bin hier daheim. Diese Stadt mag mich.</p>\n<p>\n\t<img src=\"/content/images/SF5.JPG\" alt=\"SF5.JPG\" /></p>\n<p>\n\tUnd Berlin? Berlin könnte fast so cool und hip sein wie San Francisco, wäre da nicht ein kleiner Unterschied: Berliner sind grundlos arrogant. Aus unerklärlichen Gründen hat sich eine große Berlinarroganz entwickelt. &quot;Ich komme aus Berlin, mir kann keiner was!&quot; Beste Stadt der Welt! Überheblichkeit. Die Leute treten sich gegenseitig auf die Egos. Die Sonnenbrillen sind zu dunkel. Zu wenig Kommunikation. Die Bewohner oft zu sehr damit beschäftigt sich selber zu zelebrieren. Man kann sich im Unterschied dazu San Francisco als Szenestadt vorstellen, aber ohne Zelebration der Szene. Man kann die schönen Dinge also nutzen ohne sich deswegen ständig geil fühlen zu müssen, sich umzusehen und am laufenden Band darüber zu reden wie geil man ist. Das fühlt sich frei und richtig an. Das entspannt die Lage in der Stadt. Berlin krampft.</p>\n<p>\n\t<img src=\"/content/images/SF3.JPG\" alt=\"SF3.JPG\" /></p>\n<p>\n\t<img src=\"/content/images/SF8.JPG\" alt=\"SF8.JPG\" /></p>\n<p>\n\t<img src=\"/content/images/SF4.JPG\" alt=\"SF4.JPG\" /></p>\n<p>\n\t<img src=\"/content/images/SF6.JPG\" alt=\"SF6.JPG\" /></p>\n<p>\n\tDer Burger kostet 8 Dollar, kommt aber nicht aus der METRO Theke, dafür aber von einem geilen Rind, mit selbstgeschnittenen Potato Wedges und vielen scharfen Tabascosaucen. Der Salat ist frisch. Bier gibt es in großen Plastikbechern. Amerianisches Essen ist gut. Burritos. Was weiß ich. Taccos. Ich mag das alles. BBQ. Wir blicken auf die Stadt. Auf die Skyline. Auf Hänge mit Blechhütten und auf uns selbst.&nbsp;</p>\n<p>\n\t<img src=\"/content/images/SF13.JPG\" alt=\"SF13.JPG\" /></p>\n<p>\n\t<img src=\"/content/images/SF12_.JPG\" alt=\"SF12_.JPG\" /></p>\n<p>\n\tDie nächsten Tage wird gearbeitet und die Stadt weiter erkundet. Am 16.September geht es dann mit dem Mietwagen los auf den Kalifornien-Trip.</p>\n<p>\n\t<img src=\"/content/images/SF2.JPG\" alt=\"SF2.JPG\" /></p>\n<p>\n\tDer erste Eindruck: Gut den Berliner Coolnesskampf und die Vorurteile mal kurz verlassen zu haben. Amerika fühlt sich bisher gut an.</p>\n<p>\n\t<img src=\"/content/images/SF7.JPG\" alt=\"SF7.JPG\" /></p>\n"}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

	module.exports = {"title":"Die Ada Blitzkrieg Homestory","date":"2011-10-10 17:20:05 +0000","tags":null,"layout":"post","body":"<p>\n\t </p>\n<p>\n\tDie Menschen fragen mich immer \"Wie lebst Du so, Ada Blitzkrieg!\" und ich sage \"Ich funktioniere gut!\".</p>\n<p>\n\tHeute möchte ich Euch einen kleinen Einblick hinter die Kulissen meiner Person geben. Wie sieht meine Wohnung aus? Wie lebt eine Ada Blitzkrieg so? Stimmt das mit dem Zwergkaninchen? Wie arbeite ich? </p>\n<p>\n\t </p>\n<p>\n\t<iframe width=\"100%\" src=\"http://www.youtube.com/embed/p6Xgq0P3JKE\" frameborder=\"0\" allowfullscreen></iframe></p>\n<p>\n\t </p>\n<p>\n\tLehrvideo: Ada Blitzkrieg - Leben, Wirken, Wohnen (Ada Blitzkrieg 2011)</p>\n"}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

	module.exports = {"title":"Horses and their dream of Ada","date":"2012-03-19 16:05:34 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/tn_IMG_0222.JPG\" alt=\"tn_IMG_0222.JPG\" />\n<br>\nAlles neu. Immer. Draussen nervt die Sonne mal wieder und man kann sich selber diesem emotionalen Seelengulasch nicht entziehen. Ich bin also leider gut gelaunt und baue Textkrieg gerade aus. Zum einen, weil ich mich in Zukunft mehr auf das konzentrieren möchte was ich besonders gut kann: Kochen, Geschichten erzählen, Pressetexte für Künstler, Journalismus und Busen. Scheiß Motivation!\n<br>\nIn Zukunft wird es neben dem neuen Blitzkrieg HQ noch zu weiteren Professionalisierungen kommen. Ein neues Portfolio und einen Ada Blitzkrieg 3D Druck zum Angrabschen und Ankleiden. Unter Hochdruck (diese Formulierung wird Mutter lieben) arbeite ich im Hintergrund an neuen blitzgescheiten Projekten und freue mich über Kontakte zu Verlagen, Presse, Autoren und Foodfreunden:\n<br>\n<strong>I   Ein englischsprachiger Foodporn Blog</strong>\n<br>\n<strong>II  Ein DIY Action-Kochbuch</strong>\n<br>\n<img src=\"/content/images/tn_IMG_0388.JPG\" alt=\"tn_IMG_0388.JPG\" />\n<br>\n<img src=\"/content/images/tn_IMG_0197.JPG\" alt=\"tn_IMG_0197.JPG\" />\n<br>\n"}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

	module.exports = {"title":"How to hack pesto","date":"2012-06-14 16:46:18 +0000","tags":null,"layout":"post","body":"<p>In der Hauptstadt wohnen und ständig Pesto fressen, das geht ganz schön ins Geld und ist bei manchen ZEIT-Abonnenten der zweitgrößte Ausgabeposten. Ich beschloss irgendwann auf Pesto zu verzichten solange ich dieses Edelgematsche nicht von der Steuer absetzen kann. Das Zeug ist auf Dauer teurer als ein Kind durchzufüttern, es sei denn man versucht das Kind mit Pesto durchzubringen. Pesto ist aber auch mein Zugang zum <em>Food Hacking</em> gewesen und hat das unbedingte Interesse geweckt mich nicht mehr von Fertigprodukten aus der Tiefkühlboutique zu ernähren, sondern mein Essen mittels Grundzutaten selber zu konzeptionieren - nicht zuletzt um ein Verständnis für die Materie unserer Nahrung und die Zusammenhänge einer guten Küche zu erlernen.</p>\n<p>Fickt Euch! <a href=\"http://www.jamieoliver.de/\">Jamie Oliver</a> war schon immer eine Art Magier oder moderner Guru für mich. Zugegeben, etwas angegeilt sitze ich bereits nachmittags in kurzen Hosen vor dem Fernseher, wenn dieser Typ einfach irgendwelche lebendigen Hühner in den Backofen wirft, mit einem 8m langen und 9km breiten Pinsel hauchdünn Senf auf ein Kobe-Rind aufstreicht oder einfach Schokolade und eine Jahresration Zucker zu einer 3mm Durchmesserkugel Insulin kreischender Perfektion komprimiert.</p>\n<p>Um Euch einen kleinen Einstieg in die Basics des intuitiv anregenden Kochens zu geben, habe ich mich für einfache Rezepte entschieden, die aber jeder (ausser ganz ganz ganz schlimmen Menschen) ausnahmslos liebt: <strong>Pesto Verde und Pesto Rosso</strong>.</p>\n<img src=\"/content/images/tn_pesto1.JPG\" alt=\"tn_pesto1.JPG\" />\n<h2><strong>Pesto Rosso - Make it work, Ada!</strong></h2>\n<p><strong><em>Need:</em></strong></p>\n<p><em>Ergibt ein Glas:</em></p>\n<ul>\n<li>Getrockene Tomaten in Öl (300-400ml)</li>\n<li>Wer hat: Chipotles (2-3)</li>\n<li>Pinienkerne, Mandeln, Cashewkerne, Haselnüsse oder Walnüsse je nach Vorliebe gemischt (150g)</li>\n<li>Parmesan (100g)</li>\n<li>Chilipulver oder frische Chilis</li>\n<li>Petersilie</li>\n<li>Knoblauch</li>\n<li>Salz</li>\n</ul>\n<img src=\"/content/images/tn_pesto5.JPG\" alt=\"tn_pesto5.JPG\" />\n<p><strong><em>DIY:</em></strong></p>\n<p>Es ist vollkommen egal für welche Nüsse Ihr Euch entscheidet, die Mischung aus Fett, Nüssen, Parmesan, Knoblauch und scharfem Kram schmeckt immer richtig geil. Ich persönlich hasse Walnüsse! Die schmecken alt und vergessen. Ich variiere bei meinem Pesto Rosso sehr gerne. Mal ein Pesto mit Chipotles aus der Dose, mal eines mit frischen Chilis oder Chilipulver. Mal Mandeln. Mal Cashews. Derzeit bin ich etwas auf Cashewnüssen hängen geblieben. Damit Ihr einen geilen und runden Nussgeschmack erzielt, solltet Ihr die Nüsse oder Kerne vor dem Verarbeiten klein hacken und in einer Pfanne ohne Fett kurz bräunen. Passt dabei gut auf, denn die Nussbiester brennen unglaublich unverschämt schnell an. Wer arbeitslos ist, als Freiberufler viel Zusatzzeit übrig hat oder einfach nur vor Freunden angeben will, wirft am Ende noch einen Teelöffel Honig in die Pfanne und karamellisiert die Nüsse ein paar Sekunden. Wow, das muss schnell gehen! Die Nüsse jetzt abkühlen lassen und erstmal ein Glas Rotwein trinken.</p>\n<img src=\"/content/images/tn_pesto2.JPG\" alt=\"tn_pesto2.JPG\" />\n<p>Nun aber zum eigentlichen Pesto:\nDas Öl der getrockneten Tomaten auffangen. Petersilie hacken, Chipotle oder Chilis hacken, Knoblauch hacken, abgetropfte getrockenete Tomaten hacken. Hackt einfach alles! Knoblauch packe ich in der Regel immer die 4-fache Menge der empfohlenen Angabe in ein Rezept, weil ich weiß, dass die meisten Leute überängstlich mit Knoblauch sind - was sehr schade ist. Ich nehme 4-6 Knoblauchzehen.</p>\n<p>Nun das aufgefange Öl der Tomaten mit einem Schuss Olivenöl vermengen und mit den gehackten Zutaten in einem Gefäß pürieren. Nach dem Pürieren den feingeriebenen Parmesan dazu geben.</p>\n<p>Nun kommt der eigentlich heikle Punkt, an dem Ihr Euch gut ausprobieren könnt: Das Würzen und Abschmecken. Einfach mit Salz und Chillipulver perfektionieren. Würzen, probieren, nachwürzen, probieren. In kleinen Schritten an den perfekten Geschmack rantasten und den Zenit nicht überschreiten. Wenn die Konsistenz zu trocken ist, fügt noch einen kleinen Schuss gutes Olivenöl bei. Nun das Pesto in ein altes Honig- oder Marmeladenglas füllen und ab in den Kühlschrank.</p>\n<p>Wie lange das Pesto hält? Keine Ahnung. Bis es schimmelt!</p>\n<h3><strong>Pesto Verde - Make it work, Ada!</strong></h3>\n<p>Im Ernst, was Ihr genau in Euer Pesto werft, ist mir egal. Für mich ist die Hauptsache und der “Trick” mit dem auch jeder Anfänger sein eigenes Pesto kreiren kann, dass niemals an den Grundzutaten gespart wird. Wer am Basilikum oder am Olivenöl spart - oder sich seine Pinienkerne beim Gemischtwarenladen aus dem 6 Jahre unangetasten Nussfach greift (Passiert mir nicht nochmal!) - hat nachher lediglich eine schlecht schmeckende gesalzene Butter als Produkt. Iren mögen sowas. Wir möchten aber heute Pesto herstellen. Deswegen gilt unbedingt: Den besten Basilikum kaufen (den gibts erfahrungsgemäß nicht bei LIDL, sondern auf dem Wochenmarkt am Maybachufer, den Märkten Eurer Stadt, im Bioladen oder selbst angepflanzt.</p>\n<img src=\"/content/images/tn_pesto4.JPG\" alt=\"tn_pesto4.JPG\" />\n<p><strong><em>Need:</em></strong></p>\n<p><em>Ergibt ein Glas:</em></p>\n<ul>\n<li>Olivenöl (200ml)</li>\n<li>Basilikum (100g)</li>\n<li>Parmesan (50g)</li>\n<li>Pinienkerne (50g)</li>\n<li>Ziegenfrischkäse (optional 2EL)</li>\n<li>Knoblauch (4 Zehen)</li>\n<li>Salz</li>\n</ul>\n<p><strong><em>DIY:</em></strong></p>\n<p>Die Zubereitung unterscheidet sich nicht von der des Pesto Rosso. Am besten schmecken die Pinienkerne, wenn sie vor der Verarbeitung in einer heißen Pfanne ohne Fett von allen Seiten geröstet werden.</p>\n<p>Alle Zutaten hacken. Den Parmesan reiben. Nun alles in einem Gefäß mit Olivenöl mit dem Pürierstab zerkleinern. Der Parmesan wird allerdings erst ganz zum Schluss feingerieben untergemengt. Optional gebe ich noch 2EL Ziegenfrischkäse bei, der ist aber wirklich nur was für Fans und Liebhaber von Ziegenprodukten, verkürzt zudem die Haltbarkeit des fertigen Pesto, macht das fertige Produkt etwas fluffig-cremiger und schmeckt einfach nur groß. Am Ende die pürierte Masse mit Salz abschmecken. Auch hier gilt: Immer nur wenig salzen und probieren. Nachsalzen und probieren, bis Ihr Euch der richtigen Intensität angenähert habt. In ein Glas füllen und dann nach einmaligem Konsum zu leckerer Pasta zum Verschimmeln in eine uneinsichtige Ecke Eures Kühlschranks stellen.</p>\n<p>Schickt mir Eure Pesto!\n“Ich muss ein neues Pesto beantragen!”</p>\n"}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

	module.exports = {"title":"How to make Kimchi Fried Rice with Tofu","date":"2017-03-14 10:22:09 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2017/03/kimmm-1.JPG\" alt=\"alt\"></p>\n<p>Ich habe meine neue Aufgabe darin gefunden, Rezepte zu vereinfachen und ohne großes Drumrumgerede auf die wesentlichen Abläufe zu reduzieren.</p>\n<h1>no schnickschnack</h1>\n<h1>just food</h1>\n<p><img src=\"/content/images/2017/03/mix.JPG\" alt=\"alt\"></p>\n<h4>Kimchi Fried Rice with Tofu</h4>\n<h6>Braucht man:</h6>\n<p>Rice Leftover\nKimchi\nSoft Tofu\nZwiebel\nGochujang Paste\nErdnüsse gesalzen</p>\n<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/0t9l1ri_qqU\" frameborder=\"0\" allowfullscreen></iframe>\n<ol>\n<li>Kimchi klein schneiden</li>\n<li>Tofu klein krümmeln</li>\n<li>Zwiebeln klein schneiden</li>\n<li>Zwiebeln in 3 EL Öl anbraten</li>\n<li>Tofu hinzugeben und mitbraten</li>\n<li>Reis hinzugeben und mitbraten</li>\n<li>1 EL Gochujang Paste untermengen</li>\n<li>Kimchi hinzugeben</li>\n<li>Erdnüsse untermengen</li>\n<li>Fertig!</li>\n</ol>\n"}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

	module.exports = {"title":"I talked - die Interviews","date":"2014-04-30 14:42:31 +0000","tags":null,"layout":"post","body":"<img src=\"http://www.thisisjanewayne.com/news/wp-content/uploads//2014/04/adablitziklamaukig-800x500.jpg\" alt=\"\">\n<p>Ich zähle gerade die Tag rückwärts, denn in den nächsten Wochen steht nicht nur mein Umzug an, sondern auch eine neuüberarbeitete Homepage und viele andere News. Und so habe ich mit bester Aufbruchslaune mit zwei lieben Menschen über mich und meine Arbeit gequatscht, über meinen Glauben und Feminismus. Dazu sind tolle neue Fotos von mir uns meiner Wohnung entstanden.</p>\n<img src=\"http://www.thisisjanewayne.com/news/wp-content/uploads//2014/04/adablitzialbern-800x533.jpg\" alt=\"\">\n<p>Unter anderem habe ich mit Misha, dem ich mal nach dem Geburtstag unseres Kumpels Casper das Leben gerettet habe, über Glauben und meinen Kirchenaustritt gesprochen. Das Interview findet Ihr hier: <a href=\"http://indub.io/blog/2014/04/18/woran-glaubst-du-ada-blitzkrieg/\">Woran glaubst Du, Ada Blitzkrieg?</a></p>\n<p>Und zum anderen habe ich mich der zuckrigen Anni von <a href=\"http://www.thisisjanewayne.com/\">This is Jane Wayne</a> über mein neues Buch und meine Idee des Feminismus gesprochen. Nachlesen könnt ihr das <a href=\"http://www.thisisjanewayne.com/news/2014/04/28/girlcrush-interview-ada-blitzkrieg-und-warum-feminismus-das-absolute-must-have-des-lebens-ist/\">das ganze Interview</a> hier.</p>\n<img src=\"http://www.thisisjanewayne.com/news/wp-content/uploads//2014/04/adablitziquatschkoepfig-800x533.jpg\" alt=\"\">\n<img src=\"http://www.thisisjanewayne.com/news/wp-content/uploads//2014/04/adablitzi-800x530.jpg\" alt=\"\">\n"}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

	module.exports = {"title":"Ich möchte Teil einer Jugendgefährdung sein","date":"2011-09-11 15:54:09 +0000","tags":null,"layout":"post","body":"<p>\n\tAm Donnerstag wurde seitens des <a href=\"http://www.magnet-club.de/\">Magnet Clubs</a> und dem neuen synthetischen Label- und Managementbasstards&nbsp;<a href=\"http://www.audiolith.net/\">Audiolith</a> und <a href=\"http://www.beattherich.de/\">Beat The Rich</a> zum großen Abschlussball der musikinfizierten Jugendgefährdung geladen. Unter dem Namen &quot;<strong>Ich möchte Teil einer Jugendgefährdung sein vs. Abschaum erwache</strong>&quot; gaben sich Rockstah, Supershirt, Vierkanttretlager und der mysteriöse Akt Pommesbude Arschloch die Ehre.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/cas2.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tKurzfassung: Einer der besten Clubabende dieses Jahr. Pommesbude Arschloch aka Casper und Band sehen auf der Bühne nicht nur enorm schön aus, sondern fallen ebenso wie Supershirt für mich live unter die Kategorie der Bands, die ich nach ihrem Auftritt nicht öffentlich in meinem Blog zerstören, sondern hypen und feiern möchte. Auf der Bühne einfach alles geben, das Publikum und die Show kaputt lieben. Wenn ich hätte Eintritt bezahlen müssen, dann hätte ich es gerne gemacht.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDanke und bis zur nächsten &quot;Ich möchte Teil einer Jugendgefährdung sein!&quot;</p>\n"}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

	module.exports = {"title":"Ich muss etwas beichten","date":"2015-03-05 10:04:28 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2015/Mar/IMG_2391.JPG\" alt=\"alt\"></p>\n<p>In der Regel beherrsche ich ja alles mehr als perfekt und bin ein fehlerfreier Mensch mit geleckter Seele und einem blitzscharfen Verstand, aber es gibt da eine Macke an mir, die sowohl charmant als auch einfach unfassbar dumpfbackig ist: Das Problem mit dem Knallerbsenkracher. Meinem Endgegner.</p>\n<p>Es ist so, dass mein Freund von Silvester einen kleinen grünen Kracher übrig hat, den man eigentlich anzünden muss und den er in seiner Jackentasche nun immer mit sich führt. Immer wenn er dann in die besagte Tasche greift, stößt er auf das kleine Überbleibsel und drückt es mir in besonders unpassenden Situationen in die Patschehand. Ich greife automatisch danach, ohne nachzudenken, weil ich ihm vertraue. Als unpassend gelten für meine Person Situationen, die Multi-Tasking erfordern. Sagen wir mal so, ich habe scheinbar so meine Problemchen damit…</p>\n<p>Wir schlenderen also zum Beispiel durch die Strassen Neuköllns und ich bin eigentlich gerade dabei über einen Laden zu meckern, der Macarons an Arschlöcher verkauft, da hält mein Freund kurz inne und drückt mir den Knallkracher in die Hand. Was nun passiert, läuft in allen Situationen gleich ab und ich muss es euch beichten. Die pure Idiotie: Sobald ich den Kracher in die Hand gedrückt bekomme, reagiere ich sekundenschnell, lache, freue mich wie ein kleines Kind und werfe den Kracher wie eine Knallerbse auf den Boden, weil ich im Bruchteil eines Moments einordne, dass es sich um eine Knallerbse handeln muss, die so zum Explodieren gebracht wird. Erst einige Sekunden später, wenn die erwartete Explosion ausbleibt, merke ich, dass es nur wieder dieser Knallkracher ist, den mein Freund mir da gegeben hat. Das wirklich Spannende daran ist eigentlich nur, dass ich bezüglich des Krachers vollkommen lernresistent zu sein scheine. Es stellt sich keinerlei Lerneffekt ein. Es passiert mir also immer wieder. Eine Beichte.</p>\n"}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

	module.exports = {"title":"Im Test: Vietnamesischer Großmarkt","date":"2011-08-17 17:31:59 +0000","tags":null,"layout":"post","body":"<p>\n\tManchmal muss man seinen Ängsten in die Augen blicken, nur um dann zu erkennen, dass man sich hätte noch mehr fürchten müssen.</p>\n<p>\n\tDas <a href=\"http://www.mc-china.de/\">Dong Xuan Center</a> in Berlin Lichtenberg verkörpert so ziemlich alles wovor ich Angst habe: Künstliche Nägel und flockige Kokusnussmilch. Eigentlich wollte ich nur ein paar Taipioka-Perlen holen um daheim Bubble Tea zuzubereiten. Mit dem tiefergelegten Proletenauto fuhr ich durch halb Berlin um dann exakt acht Mal an der Strasse an diesem gigantischen Center vorbeizufahren, weil niemand es für nötig hält Schilder aufzustellen. Wofür auch das Gesundheitsamt unnötig aufmerksam machen?</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"667\" src=\"/files/leer.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tSchön mit dem Auto an einer Bodenwelle hängengeblieben, stieg ich mutig aus dem Wagen aus. Trotz des heissen Sommertages trug ich einen langen Mantel, der meinen Körper vor gierigen Blicken und Spinnenbissen aus Importbananen schützen sollte.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"405\" src=\"/files/nagekl.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tStation 1: Nagelpflege</p>\n<p>\n\tZwei Euro für einen Nagel. Ich sage erstmal gar nichts. Mir war das Prinzip der Nagelpflege bis zu diesem Moment gänzlich unbekannt. Mutig stürzte ich mich in die Hölle des Löwen. Die Damen konnte kein Wort Deutsch, schien aber zu verstehen, dass mein bis ins Nagelbett gesplitterter Nagel irgendwie uncool für mich sei und fing direkt an zu arbeiten. Fünf Minuten später hatte ich eine Art künstlichen Nagel auf meinem Nagel kleben, bei dem ich mich lieber nicht traute nachzufragen, ob er von einer Leiche stammt. Mein Nagelbett blutet. Die Frau hat einen Fehler gemacht, lief hektisch auf den Gang des Centers (Center ist ein Euphemismus für Betonbaracken) und guckte sich hektisch um. Niemand hatte sie gesehen. Sie musste nicht sterben, wegen fehlerhafter Dienstleistungen. Ich gebe ihr vier Euro und stecke mir drei vietamesische Lutscher ein.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tAuf dem Weg zu den nächsten Baracken werde ich von einem Lieferwagen verfolgt. Im Schritttempo bahnt er sich seinen Weg hinter mir her - durch Schlachtabfälle und Berge von BELINDA Schuhkartons. Ich bin erleichtert als das Fenster runtergekurbelt wird und ein 60Jähriger Asiate mich nach meiner Handynummer fragt. Ich gebe sie gerne heraus und bitte um ein Date.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"637\" src=\"/files/belinda.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tStation 2:&nbsp;Supermarkt</p>\n<p>\n\tIm Asia-Supermarkt gibt es so ziemlich alles was man nicht haben möchte zu einem Preis, den man nicht bezahlen kann. Ich nehme alles mit, packe es in meinen Beutel und kaufe wieder diese Ingwer-Kaubonbons, von denen ich jedes Mal schlimme Mageschmerzen bekomme und esse die ganze Packung vor Aufregung, während ich durch die zahlreichen Designershops flaniere. Ich mag keine Rosen, ich mag keine bunten Farben, ich mag keine Tiere, ich mag kein Spielzeug, ich mag keine Chinaböller und ich mag kein fauliges Obst aus Zuckermasse. Wenn allerdings alle Punkte zusammen kommen mag ich das.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"667\" src=\"/files/stuss.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tStation 3: Pärchen</p>\n<p>\n\tWer kauft im vietnamesischen Großhandel ein? Ausschliesslich Vietnamesen. Vereinzelte Deutsch-Vietamesische-Ehen mit einem Altersunterschied von mindestens 40 Jahren werfen bei mir einige Fragen auf. Hinzu kommt ein kleiner Anteil ostdeutscher Fashionopfer, die Hello Kitty und Flip Flops mit Deutschlandflaggen zur Show tragen. Ich wünsche mir, dass es irgendwann keine Nationen mehr gibt. Dennoch möchte ich nach Hause</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"667\" src=\"/files/strauss.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tStation 4: Tee-Bar</p>\n<p>\n\tIn der Tee-Bar versteht man mich nicht. Nachdem die Bedienung dann doch nickt und im hinteren Teil des Ladens verschwindet, bin ich zufrieden, denn ich fühle mich verstanden. Ich warte zwanzig langweilige Minuten, in denen ich meinen toten neuen Nagel anstarre. Nichts passiert. Ich will gerade denn Laden verlassen, als mich eine mir bisher unbekante Person in die Küche schiebt. &quot;Mach selbst&quot;, sagt sie. Ich denke mir so, ja okay, wieso nicht und mische mir Fanta Exotic mit Milch, fülle Eis ein, bezahle einen Euro dafür und gehe hektisch zum Auto.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch versuche schnell die Ausfahrt zu nehmen. Der Wagen setzt auf. Ich rase davon und verschütte im Innenraum des Wagens 8l Litschisaft. Gut, dass diesen Sommer die Wespenpopulation in Berlin so groß wie nie zuvor ist.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/zeitung.jpg\" width=\"500\" /></p>\n"}

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(171);
	
	var _sortBy = __webpack_require__(367);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _moment = __webpack_require__(399);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactHelmet = __webpack_require__(393);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyHelpers = __webpack_require__(384);
	
	var _safeAccess = __webpack_require__(604);
	
	var _safeAccess2 = _interopRequireDefault(_safeAccess);
	
	var _config = __webpack_require__(385);
	
	var _SiteSidebar = __webpack_require__(484);
	
	var _SiteSidebar2 = _interopRequireDefault(_SiteSidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SiteIndex = function (_React$Component) {
	  _inherits(SiteIndex, _React$Component);
	
	  function SiteIndex() {
	    _classCallCheck(this, SiteIndex);
	
	    return _possibleConstructorReturn(this, (SiteIndex.__proto__ || Object.getPrototypeOf(SiteIndex)).apply(this, arguments));
	  }
	
	  _createClass(SiteIndex, [{
	    key: 'render',
	    value: function render() {
	      var pageLinks = [];
	      // Sort pages.
	      var sortedPages = (0, _sortBy2.default)(this.props.route.pages, function (page) {
	        return (0, _safeAccess2.default)(page, 'data.date');
	      }).reverse();
	      sortedPages.forEach(function (page) {
	        if ((0, _safeAccess2.default)(page, 'file.ext') === 'md' && (0, _safeAccess2.default)(page, 'data.layout') === 'post') {
	          var title = (0, _safeAccess2.default)(page, 'data.title') || page.path;
	          var description = (0, _safeAccess2.default)(page, 'data.description');
	          var datePublished = (0, _safeAccess2.default)(page, 'data.date');
	          var category = (0, _safeAccess2.default)(page, 'data.category');
	
	          pageLinks.push(_react2.default.createElement(
	            'div',
	            { className: 'blog-post', key: title },
	            _react2.default.createElement(
	              'time',
	              { dateTime: (0, _moment2.default)(datePublished).format('MMMM D, YYYY') },
	              (0, _moment2.default)(datePublished).format('MMMM YYYY')
	            ),
	            _react2.default.createElement('span', { style: { padding: '5px' } }),
	            _react2.default.createElement(
	              'span',
	              { className: 'blog-category' },
	              category
	            ),
	            _react2.default.createElement(
	              'h2',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { style: { borderBottom: 'none' }, to: (0, _gatsbyHelpers.prefixLink)(page.path) },
	                title
	              )
	            ),
	            _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: description } }),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { className: 'readmore', to: (0, _gatsbyHelpers.prefixLink)(page.path) },
	              'Read'
	            )
	          ));
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactHelmet2.default, { title: _config.config.siteTitle }),
	        _react2.default.createElement(_SiteSidebar2.default, this.props),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'main' },
	            _react2.default.createElement(
	              'div',
	              { className: 'main-inner' },
	              pageLinks
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SiteIndex;
	}(_react2.default.Component);
	
	SiteIndex.propTypes = {
	  route: _react2.default.PropTypes.object
	};
	
	exports.default = SiteIndex;
	module.exports = exports['default'];

/***/ }),
/* 604 */
/***/ (function(module, exports) {

	module.exports = function access(obj, accessStr) {
	  // auto-curry here
	  if (isUndefined(accessStr)) {
	    return access.bind(null, obj);
	  }
	
	  var funcArgs = Array.prototype.slice.call(arguments, 2);
	  return helper(obj, tokenize(accessStr), null, funcArgs);
	};
	
	function helper(obj, tokens, ctx, fnArgs) {
	  if (tokens.length === 0) {
	    return obj;
	  }
	
	  var currentToken = tokens[0];
	
	  if (isUndefined(obj) || isNull(obj) ||
	    (isTokenFunctionCall(currentToken) && !isFunction(obj))) {
	    return undefined;
	  }
	
	  if (isTokenFunctionCall(currentToken)) {
	
	    return helper(obj[isArray(fnArgs[0]) ? 'apply' : 'call'](ctx, fnArgs[0]),
	      tokens.slice(1),
	      // clear context because consecutive fn calls execute in global context
	      // e.g. `a.b()()`
	      null,
	      fnArgs.slice(1));
	
	  } else if (isTokenArrayAccess(currentToken)) {
	
	    return helper(obj[parseInt(currentToken.substr(1), 10)],
	      tokens.slice(1),
	      // lookahead two tokens for function calls
	      isTokenFunctionCall(tokens[1]) ? obj : ctx,
	      fnArgs);
	
	  } else {
	
	    return helper(obj[currentToken],
	      tokens.slice(1),
	      // lookahead two tokens for function calls
	      isTokenFunctionCall(tokens[1]) ? obj : ctx,
	      fnArgs);
	
	  }
	}
	
	function isUndefined(a) {
	  return a === void 0;
	}
	
	function isNull(a) {
	  return a === null;
	}
	
	function isArray(a) {
	  return Array.isArray(a);
	}
	
	function isFunction(a) {
	  return typeof a === 'function';
	}
	
	function isTokenFunctionCall(token) {
	  return token === '()';
	}
	
	function isTokenArrayAccess(token) {
	  return /^\[\d+\]$/.test(token);
	}
	
	function tokenize(str) {
	  return str.split(/\.|(\(\))|(\[\d+?])/).filter(function(t) { return t; });
	}


/***/ }),
/* 605 */
/***/ (function(module, exports) {

	module.exports = {"title":"Interessengemeinschaft Batiken n.e.V.","date":"2011-06-23 11:54:39 +0000","tags":null,"layout":"post","body":"<p>\n\tDie Interessengemeinschaft Batiken n.e.V. (nicht eingetragener Verein) bergüßt ihre neuen Mitglieder <a href=\"http://twitter.com/#!/euphoriefetzen\">Euphoriefetzen</a>, <a href=\"http://twitter.com/#!/scholt\">Scholt</a> und <a href=\"http://twitter.com/#!/reuberlee\">Reuberlee</a> als Models, Freunde und Förderer. </p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"670\" src=\"/files/Foto 2.JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"364\" src=\"/files/Foto 1.JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/image_11.jpeg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/image_1.jpeg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/image_2.jpeg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/image_10.jpeg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/image_9.jpeg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/image_8.jpeg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/image_7.jpeg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/image_6.jpeg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/image_5.jpeg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/image_4.jpeg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/image_3.jpeg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/image.jpeg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/Foto 4.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n"}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	module.exports = {"title":"INTRO Album Preview mit Lady Gaga im Berghain","date":"2014-01-09 09:27:54 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://www.intro.de/img/artikel/artikel_originale/23073151.jpg\" alt=\"Alt text\"></p>\n<p>Am gestrigen Donnerstag stellte Lady Gaga höchstpersönlich ihr neues Album »Artpop« im Berliner Berghain vor. Intro-Kolumnistin Ada Blitzkrieg war dabei - und ist verliebt…</p>\n<p>Normalerweise stehe ich nicht vor dem Berghain an. Ich friere einfach zu schnell und bin peinlich berührt wenn es in zähen Warteschlangen zu Verbrüderungsversuchen mit Menschen kommt, denen man ein paar Minuten später beim Drängeln auf der Tanzfläche aus Versehen Wodka überschütten wird. Für Lady Gaga machte ich natürlich eine Ausnahme.</p>\n<p>Die Künstlerin hatte an diesem Abend einige ihrer treusten Fans und ein paar Pressevertreter zur Vorabpremiere ihres dritten Albums Artpop, das am 8. November erscheinen wird, zum gemeinsamen Hören und Zelebrieren in ihren Berliner Lieblingsclub geladen. An diesem Abend sollte es Strapse, Musik und Erkenntnis für sechshundert exklusive Gäste und für mich regnen. In einem Betonwal. Aber wie war der Abend eigentlich überhaupt?</p>\n<p>Lady Gaga hatte die Sonne bereits gegen 18 Uhr untergehen lassen und so war es schon stockdunkel als ich am späten Nachmittag das Berghain erreichte und mich in die wartende Menge vor dem Club einfügte, die sich in zwei Schlangen teilte: Die Presseschlange, das sind immer die älteren Herren mit Geheimratsecken in schwarzen Sportsakkos, die wie Christian Kracht von der Stange aussehen. Und die Schlange der Generation YouTube, die »Little Monsters«, wie Lady Gaga von ihren Fans spricht, die eine bunte Ansammlung schöner Menschen mit Undercuts, Transgenderkleidung, Plateauschuhbewuchs und geschminkten Glitzerwesen ausmachte. Ich stellte mich irgendwo in der Mitte an.</p>\n<p>Wie ein ausgehöhlter sowjetischer Blauwal empfing mich das Berghain. Das Handy schnell noch an der Garderobe abgegeben, ein paar Getränkebons abgegriffen und dann im unteren Stockwerk zwischen neonbeleuchteten Gaga-Portraits beobachten wie Sushi für die hungrigen Fans zusammengebaut wird. Im oberen Stockwerk dann die Bühne, die so vermutlich eins zu eins aus dem Wohnzimmer des Barbie Dreamhouse entnommen wurde.</p>\n<p>Endlich hatte ich ein paar Minuten Ruhe um die VIP-Shortlist mit anwesenden Promis auszuchecken, die ich alle nicht kannte, die sich aber erfahrungsgemäß am Weißweinausschank zusammenrotten würden um eine gute Zeit zu verbringen. Der versprochene Jorge Gonzales wurde nicht eingelöst. Lady Gaga ist mir etwas schuldig!</p>\n<p>Ich hatte mir ein Buch mitgenommen um die Wartezeit auf den Auftritt etwas zu verkürzen und kam mir sehr exotisch vor, weil mich jemand in einer Hitradio-Ostseewelle-Jacke lange sehr wütend anguckte. Wann geht es endlich los, dachte ich. Das Kostüm von Lady Gaga wird bestimmt schon unruhig! Und mit Kostüm meinte ich einen herrlichen Purismus. Das Licht änderte sich unvermittelt und nach einer kurzer Anmoderation betrat Lady Gaga als Albino-Boris Becker mit Strapse, Unterwäsche und einen Dalí-Bart die Bühne. Die Morgenpost hatte ihre Schlagzeile bereits und ich war einfach nur verliebt.</p>\n<p>Mehr Ada und meine monatliche Kolumne natürlich auf <a href=\"http://www.intro.de/autor/Ada%20Blitzkrieg\">INTRO</a>.</p>\n"}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

	module.exports = {"title":"INTRO Jahrescharts 2012","date":"2012-12-02 00:00:00 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/23069848.jpg\" alt=\"23069848.jpg\" />\n<p>Wie auch im letzten Jahr, habe ich für die aktuelle Ausgabe der <a href=\"http://www.intro.de/news/newsfeatures/23069845/intro-jahrescharts-2012-unsere-autoren-haben-abgestimmt-ada-blitzkrieg\">INTRO meine Jahrescharts 2012 für Alben und Singles</a> zusammengestellt und Euch meine Lieblinge und was das Jahr über so bei mir hängen geblieben ist, in eine kleine Playlist bei SoundCloud gepackt. Viel Spaß!</p>\n<script src=\"/javascripts/jquery.js\"></script>\n<script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/intro-jahrescharts-2012\">player</a></p></p>\n"}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	module.exports = {"title":"INTRO Jahrescharts","date":"2011-12-09 12:09:31 +0000","tags":null,"layout":"post","body":"<script src='/javascripts/jquery.js'></script><script src='/javascripts/widget.js'></script>\n<p>\n\t<img alt=\"\" src=\"/files/metronomy.jpg\" /></p>\n<p>\n\t </p>\n<p>\n\tIn den letzten Tagen habe ich für die <a href=\"http://www.intro.de\">INTRO</a> meine <a href=\"http://www.intro.de/news/newsfeatures/23066169\">persönlichen Jahrescharts</a> für 2011 aufgestellt. Neben meiner Person haben viele andere Autoren ihre Lieblingsalben und Singles nominiert. Wer einen Überblick über die Einzelcharts haben will, der zerflettert die INTRO Homepage nach den <a href=\"http://www.intro.de/suche?suchbegriff=Intro%20Jahrescharts%202011\">Jahrescharts</a>.</p>\n<p>\n\t </p>\n<p>\n\t </p>\n<p>\n\tHier meine Charts:</p>\n<p>\n\t </p>\n<p>\n\t<strong style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \">Alben</strong><br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t01    Metronomy »The English Riviera«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t02    Wu Lyf »Go Tell Fire To The Mountain«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t03    Casper »XOXO«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t04    M83 »Hurry Up, Were Dreaming«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t05    Tyler, The Creator »Goblin«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t06    Zola Jesus »Conatus«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t07    Gypsy & The Cat »Gilgamesh«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t08    Digitalism »I Love You, Dude«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t09    James Blake »James Blake«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t10    Apparat »The Devils Walk«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t11    Pollyester »Earthly Powers«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t12    Dear Reader »Idealistic Animals«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t13    Crystal Fighters »Star Of Love«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t14    Bon Iver »Bon Iver«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t15    Four Tet »Fabric Live 59«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t16    FM Belfast »Dont Want To Sleep«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t17    Captain Capa »Saved My Life«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t18    Ladytron »Gravity The Seducer«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t19    Supershirt »Kunstwerk«<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n\t20    Esben And The Witch »Violent Cries«</p>\n<p>\n\t </p>\n<p>\n\t<strong style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \">Songs</strong></p>\n<br style=\"border-top-width: 0px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px; border-style: initial; border-color: initial; margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px; color: rgb(51, 51, 51); font-family: Verdana, Arial, Helvetica, sans-serif; line-height: 18px; \" />\n<div>\n\t<p>\n\t\t01 Marie Madeleine »Swimming Pool«</p>\n\t<p>\n\t\t<a class=\"widget\" href=\"http://soundcloud.com/mariemadeleine/01-swimming-pool\">player</a></p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t02  Metronomy »She Wants«</p>\n\t<p>\n\t\t<a class=\"widget\" href=\"http://soundcloud.com/the-recommender/metronomy-she-wants\">player</a></p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t03  Prinz Pi »Du Bist«</p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t04  Miami Horror »Infinite Canyons«</p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t05  Casper »Kontrolle/Schlaf«</p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t06  Boy »Little Numbers«</p>\n\t<p>\n\t\t<a class=\"widget\" href=\"http://soundcloud.com/music-week/boy-little-numbers\">player</a></p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t07  Nagel »Tel Aviv«</p>\n\t<p>\n\t\t<a class=\"widget\" href=\"http://soundcloud.com/audiolith/nagel-tel-aviv\">player</a></p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t08  Metronomy »The Look (Fred Falke Remix)«</p>\n\t<p>\n\t\t<a class=\"widget\" href=\"http://soundcloud.com/fredfalke/metronomy-the-look-fred-falke\">player</a></p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t09  Casper »Michael X«</p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t10  Apparat »Escape«</p>\n\t<p>\n\t\t<a class=\"widget\" href=\"http://soundcloud.com/apparat/escape\">player</a></p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t11  Zola Jesus »Lick The Palm Of The Burning Handshake«</p>\n\t<p>\n\t\t<a class=\"widget\" href=\"http://soundcloud.com/247qm/zola-jesus-lick-the-palm-of\">player</a></p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t12  Digitalism »Blitz«</p>\n\t<p>\n\t\t<a class=\"widget\" href=\"http://soundcloud.com/digitalism_official/blitz-preview\">player</a></p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t13  Wu Lyf »Lyf«</p>\n\t<p>\n\t\t<a class=\"widget\" href=\"http://soundcloud.com/umpg/wu-lyf-lyf-ad-edit\">player</a></p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t14  Ira Atari »Dont Wanna Miss You«</p>\n\t<p>\n\t\t<a class=\"widget\" href=\"http://soundcloud.com/audiolith/ira-atari-dont-wanna-miss-you-radio-edit\">player</a></p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t15  Tyler, The Creator »Yonkers«</p>\n\t<p>\n\t\t<a class=\"widget\" href=\"http://soundcloud.com/hhvmag/tyler-the-creator-yonkers\">player</a></p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t16  Esben And The Witch »Warpath«</p>\n\t<p>\n\t\t<a class=\"widget\" href=\"http://soundcloud.com/culturedeluxedotcom/esben-and-the-witch-warpath\">player</a></p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t17  Ladytron »Ace Of Hz«</p>\n\t<p>\n\t\t<a class=\"widget\" href=\"http://soundcloud.com/nettwerkmusicgroup/sets/ladytron-ace-of-hz/\">player</a></p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t18  Mount Kimbie »Carbonated«</p>\n\t<p>\n\t\t<a class=\"widget\" href=\"http://soundcloud.com/mountkimbie/06-carbonated\">player</a></p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t19  Rockstah »A-Taste«</p>\n\t<p>\n\t\t<a class=\"widget\" href=\"http://soundcloud.com/rockstah/a-taste\">player</a></p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t20  The Head And The Heart »Ghosts«</p>\n\t<p>\n\t\t<a class=\"widget\" href=\"http://soundcloud.com/theheadandtheheart/03-ghosts\">player</a></p>\n</div>\n<p>\n\t </p>\n"}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

	module.exports = {"title":"INTRO Kolumne: 20 Dinge, die ich bei Wetten, dass...? gelernt habe","date":"2013-08-27 09:53:38 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/introcoverweare.jpg\" alt=\"introcoverweare.jpg\" />\n<p>Das Sommerspezial von »Wetten dass…?« aus der Stierkampfarena in Palma de Mallorca verspricht mal wieder einiges: Keine internationalen Gäste, eine Musical-Performance mit Mascaramännern und Markus Lanz als strahlendem Gewinner der Niveau-Limbo-Challenge. Herzlichen Glückwunsch, Deutschland! Ein Stierkampf wäre geschmackvoller gewesen.</p>\n<p>01 Sendungen, die mit einer frenetischen »We will rock you!« Klatsch-Stampf-Einlage beginnen, lügen dich einfach nur an.</p>\n<p>02 Der einzige internationale Gast, der sich noch zu »Wetten, dass…?« traut, ist Cindy aus Marzahn und die kommt aus der DDR.</p>\n<p>03 Unter den ZDF-Mitarbeitern gibt es scheinbar niemanden mit Humor: Als in der Arena von Palma live riesige Flaggen mit den Konterfeis der Promi-Gäste ausgerollt werden, hat keiner der Mitarbeiter eine Kim Jong-un Flagge eingeschmuggelt. Schade und Danke für nichts!</p>\n<p>04 Niemand lacht, wenn man »Die heutige Kinderwette stammt aus Belgien« sagt. Dabei sind Kinderwetten immer peinlich, weil Kinder Loser sind.</p>\n<p>05 Unnützes Wissen: Wusstet Ihr schon, dass alle Gäste, die man nicht kennt, Tatort-Kommissare sind und dass Musicals von den Genfer Konventionen als menschenverachtend eingestuft wurden, weil sie aus moralisch humanitären Gründen ungerecht gegenüber Freddie Mercury (»We Will Rock You«), gegenüber Tieren (»Cats«), oder gegenüber der edlen Sportart des Eiskunstlaufens (»Starlight Express«) sind?</p>\n<p>06 Markus Lanz sieht sogar in entspannten Freizeitschuhen aus, als würde er zu einer geilen Hochzeit mit sich selbst aufbrechen wollen. Seine Sneaker stammen heute von Graceland und wurden in China genäht. Lässig!</p>\n<p>07 In einer Sendung, in der ohnehin alles gleich langweilig ist, gibt es nie den richtigen Zeitpunkt um pinkeln zu gehen.</p>\n<p>08 Das Publikum trägt lieber einheitlich verspiegelte ADIDAS-Sonnenbrillen im 90er Jahre Spacelook statt Google Glasses. Sehen wir gerade etwa den nächsten großen Modetrend? Dont fuck with the 90s, Google!</p>\n<p>09 Gibt es da draußen wirklich noch Zuschauer, die glauben Lanz würde achtlos eine Unterhaltungsshow machen ohne sich bei den Flutopfern anzubiedern? Die »Saalwette« lautet heute: Wetten, dass die Zuschauer bis zum Ende der Sendung 500.000 Euro für die Flutopfer spenden? Wenn die Summe nicht zustande kommt, muss Markus Lanz als Wetteinsatz mit Georgina Fleur auf einem aufgetürmten Wall aus Sandsäcken vor dem überfluteten Dresden posieren.</p>\n<p>10 »Wenn es drauf ankommt, dann steht dieses Land zusammen«, sagt Markus Lanz. Und später will angeblich niemand bemerkt haben, dass es 2013 blanker Wahnsinn ist eine 150-minütige Unterhaltungssendung ohne Dubstep anzubieten.</p>\n<p>11 In der Hochwassersendung kommen alle Gäste motorisiert ins Studio gefahren. Für den Klimawandel.</p>\n<p>12 Stellt euch vor, es würde jedes Mal das »Wette verloren«-Geräusch kommen, wenn ihr in den Spiegel guckt! Lieber nicht.</p>\n<p>13 Ob Olli Schulz nicht einfach »Wetten, dass…?« moderieren könnte?</p>\n<p>14 Homophobes Witzeln über Rektalmassagen. Die CDU wird ordentlich gelacht haben. Auch als dann Gerard Butler als Wetteinsatz mit einer handvoll Eiswürfel im Schritt den Erlkönig aufsagen muss, fragt man sich, wessen Humor ist das eigentlich? Da geht es doch gar nicht mehr um Ficken und Sexyness. Dieser Humor ist passgenau für Hetero-Pärchen, die bei der Verrichtung ihres großen Geschäfts die Badtür offen lassen. Also Christian Wulff und seine DJane.</p>\n<p>15 Amerikanische Wissenschaftler haben während einer »Wetten, dass…?« Folge herausgefunden, dass Depressionen sehr einfach behandelbar sind, wenn sich Betroffene, jedes Mal wenn sie traurig sind, Markus Lanz mit einer Uncle-Sam-Hose vorstellen. Dann geht es wieder.</p>\n<p>16 Michelle Hunziker ist schwanger. Es ist wohl ein Kind. Auf die Frage, ob es ein Junge oder Mädchen wird, gibt sie keine Antwort. Hauptsache die Oberarm-Tätowierung ist nicht genetisch!</p>\n<p>17 Von einem Wettkandidaten mit dem Namen Andreas Mofa erwartet man eigentlich mehr: »Ich wette, dass ich Markus Lanz ein Mofa in den Rücken werfen kann, ohne dabei zu lachen.« Unmöglich!</p>\n<p>18 Und noch eine Premiere: Der Euro Hawk liefert für das ZDF gestochen scharfe Kamerabilder von Markus Lanz Graceland-Sneakern aus der Arena in Palma de Mallorca.</p>\n<p>19 Die Live-Musik bei »Wetten, dass…?« stammt nie von Bands, sondern immer nur von »Show-Acts«.</p>\n<p>20 Wer keine Erektion bekommt, wenn er zwanzig Walnüsse als Live-Wette mit seiner Hinternmuskulatur knackt, ist doch nicht normal. Ist ein Arzt anwesend?</p>\n<p>Mehr Ada und meine monatliche Kolumne natürlich auf <a href=\"http://www.intro.de/autor/Ada%20Blitzkrieg\">INTRO</a>.</p>\n"}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

	module.exports = {"title":"INTRO Kolumne: Breaking Bad in Deutschland","date":"2013-08-29 00:00:00 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/introcoverweare.jpg\" alt=\"introcoverweare.jpg\" />\n<p>Könnten wir aufhören ständig rumzunölen und uns von den anstehenden Bundestagswahlen wieder auf das Wesentliche zurückbesinnen? Die lang herbeigefieberte zweite Hälfte der finalen Staffel von »Breaking Bad« hat gerade begonnen. Die glatzköpfigen Boys aus New Mexico laufen wieder: sonntags in den USA zur Hauptsendezeit und bei uns - natürlich illegal  oder schon wenige Jahre später auf ARTE. In der deutschen Synchronfassung natürlich, was nicht nur schrecklich unsexy, sondern auch irgendwie verkehrt ist. Warum aber ist das eigentlich so und wieso macht man sich Feinde wenn man Serien »nur im Original« guckt?</p>\n<p>Liebe Freunde, jetzt bloß bis zur deutschen Ausstrahlung von »Breaking Bad« schön achtsam sein, um sich keinen Spoiler bei Twitter oder Facebook einzufangen! Und sowieso, läuft man nicht stets Gefahr die Handlung seiner Lieblingsserie vorab verraten zu bekommen, wenn man Freundschaften pflegt? Jeder ist dabei ein potenzieller Whistleblower! Walter White steigt also in der neuen Staffel von Crystal Meth auf die Herstellung einer Bio-Holunderlimonade um? Hank zeugt ein Mädchen mit Skyler und erzieht es vegan und feministisch? Marie verlässt Hank aus eigenen Stücken und erkennt ihren Selbstwert? Puh, nun ist die Spannung wohl komplett raus. Hätte man die Episode doch lieber mal zeitnah in Originalsprache gesehen. Ich sags ja! In »Homeland« würde die Protagonistin diese Misere prägnant mit »Fuck that shit!« zusammenfassen. In Deutsch klingt das allerdings nicht, denn in dieser Sprache gibt es einfach kein passendes Äquivalent zur Ausdrucksweise eines mexikanischen Kartellbosses, der nebenberuflich fettige Chickenteile in einem Drive-In mitten in der Wüste verkauft. Und wir müssen lernen dieses Tatsache auch zu akzeptieren!</p>\n<p>Was wäre also, wenn »Breaking Bad« dem deutschen Kleingeist und der Forderung nach mehr Einfachheit noch weiter als ohnehin schon entgegenkommen würde und nicht nur in deutscher Synchronfassung produziert würde, sondern auch in Deutschland spielt? Crystal Meth in Oberfranken?</p>\n<p>Walter Weiss, ein netter Chemielehrer in einer harmonischen Gesamtschule, erfährt, dass er schwer an Lungenkrebs erkrankt ist. Weil er aber sicher verbeamtet ist und in einem gut funktionierenden Sozialstaat lebt, in dem er sich aufgrund einer privaten Krankenversicherung keinerlei Gedanken um eine vortreffliche medizinische Versorgung machen muss, beschließt er eines Tages Crystal Meth herzustellen. Natürlich nicht aus finanziellen Gründen  er ist ja schließlich Beamter - sondern als zeitintensives Hobby, weil er sich in seinem Provinzleben oftmals tödlich langweilt. Das hängt zum einen mit dem TV-Programm und zum anderen mit seinem Status als Privatpatient zusammen, aufgrund dessen er im Krankenhaus und bei niedergelassenen Ärzten ohne nennenswerte Wartezeiten behandelt wird. Da bleibt viel Zeit zu füllen. Warum also kein schönes Hobby pflegen, denkt sich der Familienvater.</p>\n<p>Jesse Pinkman, der Walters Partner im Drogengeschäft ist, heißt in der deutschen Fassung Jens Rossmann und kann mit den Einnahmen aus dem Meth-Geschäft neue Felgen und Chromaccessoires für seinen Golf III kaufen. Ab und zu bestellt er im Internet Gyrospizza mit 38cm Durchmesser beim Griechen oder ein Paar angesagte Sneaker in den USA, die er Markus Lanz nachkauft und für die er dann am oberfränkischen Zollamt vorsprechen muss. Seinen Jungs gefallen die Teile aber immer ganz gut. Das sagen sie zumindest beim Bong rauchen.</p>\n<p>Walter kauft sich dann bei ebay-Kleinanzeigen, nach einem endlos langen Dialog mit einem Privatverkäufer, der partout den Preis nicht verhandeln will (»Wir sind doch hier nicht auf dem Basar!«) einen gemütlichen Wohnwagen der deutschen Traditionsmarke Dethleffs, den er irgendwo zwischen A9 und der tschechischen Grenze auf einer Brachfläche abstellt. Hier beginnt er die chemische Droge herzustellen.</p>\n<p>Sein Sohn, der ebenfalls Walter heißt und eine körperliche Behinderung hat, besucht die Sonderschule der nächsten Kreisstadt, die eigentlich Förderschule heißt. Es gibt dort weder Perspektiven, noch Stellplätze für seinen mondänen Sportwagen.</p>\n<p>Eines Nachts ruft Walter Weiss bei Domian an.\n»Hallo ihr Lieben. Da sind wir wieder.«\n»Ja, hier ist Walter, ich stelle Crystal Meth hinter dem Rücken meiner Frau her und verkaufe tonnenweise davon an abgefuckte Kids und Gangster aus Eisenhüttenstadt.«\n»Hast du denn schon mal das Gespräch mit deiner Frau gesucht?«\n»Oh, nein, das ist wirklich eine gute Idee! Wäre ich nicht drauf gekommen. Dann hat sich ja alles geklärt. Danke Domian!«</p>\n<p>Skyler, die mit Walter Weiss verheiratet ist, wird in dieser Fassung Sandra genannt und ist mit dem zweiten Kind schwanger. Das Pärchen steht vor der schweren Entscheidung Elterngeld zu beantragen. Wegen Menschen wie Kristina Schröder bleibt Walter dann doch daheim und kocht auch kein Meth mehr, weil die Erziehung des Kindes ihn gänzlich vereinnahmt. Das Wohnmobil wird familienfreundlich umgebaut. Alle scharfen Kanten werden abgeschliffen und die Messer in einer Schublade mit Kindersicherung aufbewahrt. Mit dem Dethleffs fährt die ganze Familie dann einige Tage an die Ostsee. Hier ist es sehr schön. Statt einem »Los Pollos Hermanos« gibt es dort das Restaurant »Wienerwald«, wo man noch weiß was man bekommt.</p>\n<p>Eines Tages klopft es an das Dethleffs und die Stimme eines Polizeibeamten hallt durch den mitteleuropäischen Mischwald: »Haben sie eigentlich eine Umweltplakette?« Ein spannendes Serienfinale, oder?</p>\n<p>Mehr Ada und meine monatliche Kolumne natürlich auf <a href=\"http://www.intro.de/autor/Ada%20Blitzkrieg\">INTRO</a>.</p>\n"}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

	module.exports = {"title":"INTRO Kolumne: CSI Ottweiler  Die Deutschen und ihr Tatort","date":"2013-08-27 09:52:33 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/introcoverweare.jpg\" alt=\"introcoverweare.jpg\" />\n<p>Da werden jeden Sonntag seit rund zweitausend Jahren 1,2 Millionen Piepen öffentliche Rundfunkgelder aufgewendet, um dem devoten Zuschauer vor Augen zu führen, dass Claude-Oliver Rudolph zwar ein Gesicht hat, auf dem man problemlos Zitrusfrüchte auspressen kann, dafür aber festere Oberarme als man selbst mit Mitte Zwanzig. Na Dankeschön, ARD! Der innere Montag kann also schon am Sonntagabend beginnen. Ich habe zum ersten Mal in meinem Leben einen »Tatort« geguckt:</p>\n<p>Es ist mir ein unerklärliches Rätsel wie ich es siebenundzwanzig Jahre lang geschafft habe, den »Tatort« ohne jeglichen Kraftaufwand wegzuignorieren. Denn laut einer Studie gucken einhundert Prozent der Menschen im Freundeskreis  speziell in meinem - die kriminalistischen Ermittlungsbemühungen zwischen profillosen Kaffeevollautomaten und wenig stimulierenden anthrazitfarbenen 5er-BMW-Ermittlungsfahrzeugen. Aber wir Deutsche haben ja schließlich auch keinen Ocean Drive. Den Fans genügt offenbar die Abwesenheit eines Ferrari 308 GTS, um der Sendung einen Eventcharakter abzugewinnen, den ich leider viel zu mühsam suchen muss.</p>\n<p>Wer nur ein einziges Mal eine amerikanische TV-Serie geguckt hat, wird »Tatort« nicht mehr bedenkenlos gut finden können. Kennen diese Menschen Steve McQueen nicht? Haben sie Torte zu Hause und greifen trotzdem lieber zum Brot? Doch selbst das hätte mehr Charme und Tiefgang als ein nüchterner Til Schweiger, der neuerdings auch für die Quote ermitteln darf. Der Deutsche liebt eben sein Brot und »unseren« Til. Leider will das weiße Jackett von Sonny Crockett nicht recht in deutsche Wohnzimmerlandschaften passen. Statt LA oder New York haben wir Ottweiler und Sulzbach, Veronica Ferres als Erika Steinbach, Hannelore Elsner als Uschi Glas und Claude-Oliver Rudolph als Typ mit Gummihose und beneidenswerten Armen. Eigentlich sehen Schießereien mit Schwarzen natürlich cooler aus, dafür heißen unsere Kommissare aber Stellbrink oder Borowski, tragen ausgebeulte Physiklehrerhosen und haben nicht das nervenaufreibende Charisma eines Magnum, der mit seinem Bart Sehnsüchte bei beiden Geschlechtern weckt. Das hatte immer nur Matula, auch ohne Schnorres.</p>\n<p>Viertel nach Acht. Ich schalte den Fernseher ein. Drei Vier-Zentner-Männer füttern sich andächtig mit Miniwürstchen. Ob ich bei »Bauer sucht Frau« gelandet bin, denke ich, weiß aber gleich, dafür sind die Schauspieler und die Musikauswahl zu schlecht. Es ist ein ganz normaler »Tatort« mit dem vorhersehbaren Titel »Eine Handvoll Paradies«, für den 1,2 Millionen Euro in Bockwürste investiert wurden - was mich durchaus wieder versöhnlich stimmt.</p>\n<p>Im Saarland gibt es eine einzige Bundesstraße und an der wird der lederne Kadaver von Rocker Rüdiger gefunden, den man neckisch »Rüde« ruft. Der Alltag der Rocker-Gang »Dark Dogs«, der sich im Großen und Ganzen darum dreht, mit digital vertiefter Stimme über »Höllenmaschinen« zu sprechen, interessiert den Zuschauer. Der Anführer der Gang heißt »Mutti« und verteilt sein Taschengeld in Form von Heroinspritzen in die Leiste. Neunzig Minuten Sendezeit kriegt man damit schon irgendwie gefüllt.</p>\n<p>Was ist das Erfolgsgeheimnis des deutschen »The Wire«? Das Format ist ein waschechter Unterhaltungszigeuner und präsentiert sich in wechselnden Städten. Jeder darf mal ran, hat seinen eigenen Lokalkommissar und kann sich dabei irgendwie fühlen. Die Dialoge sind entmenschlicht und eine Rocker-Bande ohne Martin Semmelrogge wirkt peinlich klamaukig, trifft aber den Nerv der Menschen, die Sonntagabends keine Pläne haben. Und das sind viele. Dann doch lieber Mickey Rourke, weniger straffe Arme oder »Sons of Anarchy« auf Netflix anschauen, wo niemand »Und by the way«sagt, um sich bei der jungen Zielgruppe anzubiedern.</p>\n<p>Nicht mal eine Werbepause zum Abpinkeln wird einem gegönnt, so dass die ständige Angst etwas Belangloses zu verpassen eineinhalb Stunden im Beiwagen der Langweile mitreist. Bloß nichts unternehmen, was mehr Spaß als der »Tatort« bereitet: Bad putzen oder den Spülmaschinenabfluss mit den Händen freipuhlen. Ich lasse den gebührenfinanzierten Instagram-Filter mit Tiefenunschärfe einfach weiter passieren und fühle mich schmutzig. Brauchen wir das? Man könnte den Tatort doch einfach absetzen und von den eingesparten Gebührengeldern Christoph von der »Sendung mit der Maus« endlich einen neuen Pullover kaufen. Aber mitdenken tut im Öffentlich-Rechtlichen sowieso keiner und der errechnete Todeszeitpunkt der Zuschauer liegt am Sonntagabend seit über vierzig Jahren auf Viertel nach Acht.</p>\n<p>Mehr Ada und meine monatliche Kolumne natürlich auf <a href=\"http://www.intro.de/autor/Ada%20Blitzkrieg\">INTRO</a>.</p>\n"}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

	module.exports = {"title":"INTRO Kolumne: Dschungelcamp","date":"2014-01-27 11:13:34 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/introcoverweare.jpg\" alt=\"introcoverweare.jpg\" />\n<p>Wisst Ihr noch Big Brother? Zur Erinnerung: Das war dieses damals äußerst revolutionäre TV-Format aus dem fernen Ausland, das unsere Eltern ganz schrecklich fanden und in dem gut frisierte Menschen ohne nennenswerten Körperhaarwuchs für uns Sex unter Satinbettdecken mit chinesischen Schriftzeichen hatten. Ja, das alles fanden wir natürlich ganz schlimm doof und waren auch ziemlich genau null angegeilt von der eruptiven Libido der wie Tiere eingepferchten Teilnehmer, die sich in die schlecht ausgeleuchteten Blechräume des ranzigen Fischwerft-Containers ergoß. Selbstverständlich haben wir alle auf der Stelle empört umgeschaltet, als sich die junge, bis aufs Letzte durchtrainierten Körper mit ihren funktionstüchtigen Genitalien halb öffentlich aneinander rieben um im weiteren Fortlauf des Hergangs wie exotische Wildtiere ungebremst und fremdartig zu bumsen (wahlweise »den Geschlechtsakt zu vollziehen«). Was haben wir doch alle sofort mit großer Bestimmtheit den Fernseher ausgemacht und die Augen geschlossen. War doch so, oder? Aber einen Preis haben wir dafür nicht bekommen. Warum also der elendige Firlefanz? Hat sich der ganze Selbstbetrug am Ende etwa gar nicht gelohnt? Für niemanden?</p>\n<p>Bei Unfällen gucken wir ja schließlich auch weg. Zumindest wenn uns jemand danach fragt oder wir davon ausgehen müssen, dass eine realistische Chance besteht durch eine andere Instanz beim Beobachten beobachtet zu werden. Wie eine Schlange, die sich selbst verzehrt. Wenn keiner zuguckt, starren wir weiter ungebremst drauf. Vollgas-Starren. Frontal-Starrer. Gaffertypen. Glotz-Fressen! So ist der Mensch! So sind wir! Am liebsten hätten wir noch einen Stuhl (natürlich möglichst gemütlich) und einen Kaffee (mit Sojamilch und braunem Zucker). Und am allerliebsten hätten wir auch eine einwandfreie Rechtfertigung für unseren Voyeurismus frei Haus geliefert, die im Kern eine andere Begründung als »Schadenfreude« oder »Angeilen« enthält. Gibt es aber nicht. Sorry! Und solange müssen wir eben lückenlos weiter lügen. Ich allerdings habe es satt. Ich gucke den Dreck! Meist sogar echt gerne.</p>\n<p>In meiner Achtzehn-Zimmer Altbauwohnung in Kreuzberg bin ich in der Regel ziemlich alleine, fernab von jeder moralischen Instanz und bleibe derzeit beim »Durchzappen« eben etwas zu lange beim Dschungelcamp hängen. Dort beobachte ich dann genüsslich wie niemand die »Verletzten« aus dem »brennenden Autowrack« zieht, das sich RTL nennt.</p>\n<p>Wir sind Sadisten und solange wir den Eindruck haben, dass nicht wirklich jemand zu Schaden kommt, geht das auch alles schwer in Ordnung für uns, finde ich. Könnten wir uns also bitte einfach auf folgende Punkte einigen:</p>\n<p>Jeder einzelne von euch guckt jede Folge Dschungelcamp! Der Wendler ist ja eigentlich ein ganz netter Kerl! Der Wendler ist einer zum Pferde-Stehlen! Der Wendler sieht mit seinem Bart auf einer Skala von 1 bis 10 immerhin wie eine 6 aus! Larissa hat den gleichen kindlichen Charme wie Money Boy! Die Ex-Frau vom Drews soll mal was richtig brutal fieses wegfressen müssen! Der Wendler ist der neue Wendler!</p>\n<p>Mehr Ada und meine monatliche Kolumne natürlich auf <a href=\"http://www.intro.de/autor/Ada%20Blitzkrieg\">INTRO</a>.</p>\n"}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

	module.exports = {"title":"INTRO Kolumne: Fernseh-Diät","date":"2014-01-09 09:17:53 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/introcoverweare.jpg\" alt=\"introcoverweare.jpg\" />\n<p>Zugegeben, ich hatte vor dem Verfassen dieser Kolumne weiß Gott längere Zeit nicht mehr aufrichtig interessiert Fernsehen gesehen und ließ es Intro einfach nicht wissen. Zum einen weil ich mich im Herbst so lange im Urlaub aufhielt, dass ich zuletzt kaum mehr wagte die genaue Dauer meiner Reise gegenüber Freunden mit einem festen Arbeitsverhältnis zu erwähnen und zum anderen weil ich aufgrund meines Naturells sowieso eher der verschlagene Typ mit kriminellen Tendenzen bin, der zu Eigenbrödlertum und Heimlichtuerei tendiert.</p>\n<p>Ich packte in den letzten Wochen lediglich ab und an ein paar kleinere TV-Häppchen der »Tagesschau« hinten in meinen Kopfraum rein, um im Fall der Fälle, wenn es mit einer anderen Partei zu einem kopflastigen Nahgefecht mit Informationen zum aktuellen Weltgeschehen kommen sollte, wenigstens als immerhin leichtbewaffnet und schon mittelgefährlich zu gelten. Es könnte ja jederzeit passieren, dass man sich aus Versehen auf der Rückbank eines Taxis wiederfindet, bei einem Frisör in der Kleinstadt aufwacht oder vom Amt für Beziehungen und Lebenspartnerschaften eine gesprächige Schwiegermutter zugeteilt bekommt und darauf irgendwie reagieren muss. Nach Möglichkeit natürlich am besten angemessen. In diesen Fällen hat es sich über die Jahre bundesweit als beste Prophylaxe etabliert aktuelle Schlagworte wie »Deutschlandkette« und »Koalitionsbildung« wie selbstverständlich aus dem Konversationshut zaubern zu können. Taxifahrer nicken dann in der Regel versöhnlich und schweigen weiter, während Schwiegermütter selbstlos die Absolution für das letzte Stück Marmorkuchen erteilen. Und da ist besonders viel Schokoladenguß drauf und Schokolade ist eigentlich ganz okay, finden viele. Ein guter Deal also, so alles in allem. Nur »Tagesschau« muss man eben dafür gucken.</p>\n<p>Den Handlungsstrang von »Köln 50667« kenne ich inzwischen auch nicht mehr, denn der Fernseher durfte nicht perfomen und prunkte tagelang nur tiefschwarz im Raum rum. Ich erkenne mich einfach nicht wieder. Meine Hand fühlt sich ohne Fernbedienung irgendwie leer und fremd an. Vielleicht bin ich auch einfach nur alt geworden. Von mir aus.</p>\n<p>Nach einem minderspektakulären Trinkunfall im September hatte ich ohnehin die Glotze aus Selbstschutzgründen lieber gemieden, denn im Verlauf des besagten Abends fand ich erst mehrere Gin Basil Smash sehr gut und dann recht schnell auch das gesamte Abendprogramm ausnahmslos aller Sendeanstalten ohne jeglichen Kompromiss. Ich fühlte mich körperlich von Schlagersängerinnen erregt und erlebte die blonden Tausendsasserinnen als junge und toughe Frauen, die in der Schlagerbranche erfolgreich Karriere gemacht haben und ein gutes Rolemodel für die Empanzipation darstellen. So dachte ich. Und so dachte bestimmt auch Erika Steinbach.</p>\n<p>Am nächsten Morgen wachte ich in meinem feinbibrig bezogenen Doppelbett neben dem langjährigen Lebenspartner auf und lag anstatt in einer Lache Kotze nur mit einer pfleglich behandelten Knirscherschiene in meinem Selbsthass und fühlte mich insgesamt gar nicht so gut. Irgendwas ist ja schließlich immer. Doch dann kam ein neues Format in mein Leben: »Fashion Hero«.</p>\n<p>Die Beschreibung klang wie für mich gemacht: Es geht offenbar um Mode und Superhelden. Im Prinzip liest sich das Konzept ähnlich wie »Project Runway«, eine amerikanische Castingshow für aufstrebende Modedesigner, die mich schon ganze Staffeln lang begeisterte. Moderiert wird »Project Runway« von Heidi Klum. Im Gegenzug ist »Fashion Hero« mit Claudia Schiffer besetzt, die sich zu Heidi Klum verhält wie ein Nerzmantel zu einem »I love Schweinenacken«-T-Shirt. Wen soll das jetzt ansprechen? Fashion? Girls lieben das! Hero? Könnte was für Boys sein! Englisch? Klar, die Zielgruppe versteht sowieso nichts. Karl Lagerfeld wird es bestimmt gucken. Ganz bestimmt.</p>\n<p>Neben Heidi Klum übernimmt auch Steven Gätjen die Moderation. »Dazu« möchte ich mich allerdings nicht äußern, weil es vemutlich ziemlich viele Hardcore-Fans unter der Intro-Leserschaft gibt. Es gab allerdings mal eine Zeit, da habe ich schreckliche Dinge über Steven Gätjen gesagt. Noch schlimmer war allerdings, dass sie alle stimmten, was nicht meine Schuld war. Selbst Markus Lanz könnte zum Thema Anbiederung und durchschaubare Verkumpelungsversuche noch einiges von Steven Gätjen lernen.</p>\n<p>Die Sendung ist leider nur ein weiteres dieser unzähligen ProSieben-Formate, in denen in langer Tradition  egal wer oder was gecastet wird - ob Modells, Sänger, Tänzer, oder eben Designer  Menschen mit Undercuts vor einem völlig überladenen Hintergund zu Dubstep angespannt gucken. Reicht ja schon für die Einschaltquote.</p>\n<p>Wahlweise könnte sich natürlich jemand die Mühe machen Steven Gätjen aus dem Bild zu entfernen und stattdessen zwei tschechische Märchenspielfilme laufen zu lassen, in denen menschenähnliche Ziegen mit Haarausfall einen verwunschenen Apfel mit einem klappernden Bollerwagen durch Böhmen ziehen und nebenbei Ugg-Boots erfinden, die dann die Kandiaten bei »Fashion Hero« in ihren eigenen vier Wänden tragen können.</p>\n<p>Mehr Ada und meine monatliche Kolumne natürlich auf <a href=\"http://www.intro.de/autor/Ada%20Blitzkrieg\">INTRO</a>.</p>\n"}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	module.exports = {"title":"INTRO Kolumne: Germanys Next Hochwasser-Contest","date":"2013-08-27 09:53:10 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/introcoverweare.jpg\" alt=\"introcoverweare.jpg\" />\n<p>»Denn nur eine Stadt kommt auf das Cover der deutschen BILD Zeitung. Und nur eine Stadt gewinnt den exklusiven Besuch von Angela Merkel in Anglerhosen.«</p>\n<p>Leistet das deutsche Fernsehen eigentlich gerade heimlich Lobbyarbeit für die Snack-Industrie? Ich meine, der Mai war ja rückblickend in seinem allgemeinen Wetterdesign schon etwas auffällig: Rund um die Uhr hingen graue Fäden vor den Fenstern und Türen der einfachen Leute. Dichte, meterdicke Wasserwände und hundsgroße Regentropfen kennzeichneten den »Sommeranfang« und wurden von den Fernsehzuschauern wahlweise im Wohnzimmer am Fliesentisch, oder durch die geübten Profis (Schüler, Arbeitslose, Hausfrauen und Freiberufler) sogar komplett im Bettsetting zelebriert. Wer eine Festanstellung hatte, wurde im Mai ziemlich nass und konnte allerhöchstens neidzerfressen auf die immer fülligeren Bodys der Daheimgebliebenen schauen, die vor Wonne aufquollen wie Hefeteig im Solarium.</p>\n<p>Was für ein großes Los für die unzähligen Hochwassersendungen, dachte ich mir noch und bestaunte die nicht enden wollenden Sonder- und Spezialausstrahlungen auf nahezu jedem Kanal außer HSE24. Endlich konnten die Gebührengelder wieder für handfeste Dinge, wie kinnhohe Gummistiefel und Windmaschinen, ausgegeben werden, da waren wir uns einig. Regen, glücklich und fett, so lautete die Agenda der Unterhaltungskonsumenten im Mai, aber nur so lange sich ausreichend Knabbereien im Haus befanden und man nicht in unmittelbarer Flussnähe wohnte.</p>\n<p>Das Finale von Germanys Next Topmodel gegen Ende des Monats interessierte dann allerdings wirklich niemanden mehr. Vollkommen ausgelaugt durch den emotionsreichen 58. Eurovision Song Contest wurde Heidi und ihre »Mädchen« einfach so nebenbei mit weggeguckt, weil die Glotze gerade eh zufällig seit einem Monat lief und uns die »schöne Lovelyn« (16), die von Heidi auch »Baby Beyoncé« genannt wurde, zu diesem Zeitpunkt mit ihren arschlastigen Tanzeinlagen die zum Umschalten notwenigen Säfte entzogen hatte. Im Finale, das bei GNTM traditionell die langweiligste Episode darstellt, gab es dann doch ein unerwartetes Highlight: Eine Kandidatin, die sich aus Angst davor einpinkelte, mit ihren zwei Meter hohen Plastikstelzen durch die Panoramafenster des Tanzstudios zwanzig Meter in den asphaltierten Innenhof zu fallen, wurde durch das Jurymitglied Thomas Hayo geströstet, indem dieser sich beschützend über ihren beschmutzten kleinen Körper bückte und lächelte. Einige ältere Herren und ich waren wieder versöhnt mit dem Format, in dessen Finale Lovelyn als Siegerin hervorging, eine Rasierklingenwerbung machen durfte und dann in drei Jahren ein Topmodel Finale moderieren wird, bevor auch bei ihr die Physik zu wirken beginnt. Baby Beyoncé!</p>\n<p>Für den Eurovision Song Contest interessieren sich angeblich immer nur die anderen. Von all den Jahren explodierender Feuerwerkskörper und devoter Frauen mit Hochsteckfrisuren, die auf vulvaförmigen Bühnen performen, sind nur Dana International, die nette Transexuelle von nebenan, Knorkator, Raab, Lordi und die blinde Corinna May Im Gedächtnis hängengeblieben, die einen schrecklichen Blick auf eine mögliche Version einer zehn Jahre älteren Sarah Connor offenlegt. Heute nimmt Khaleesi aus »Game Of Thrones« für alle Länder am Contest teil und gewinnt folglich immer. Spannend ist das nur für Leute, die beim Einparken vor Aufregung zittern. Wer keine Frau ist, verkleidet sich eben als Vampir oder Hipster und gentrifiziert die klassischen Balladen weg. Aber ich mag den Grand Prix ja eigentlich ganz gerne: Erdnussflips essen, unvernünftig viel Fassbrause trinken und am Nachmittag vorschlafen um bis zu den Votings durchhalten zu können. Das alles nur um mit dem guten Gefühl ins Bett gehen zu können, dass Deutschland es mal wieder ordentlich verkackt hat und die Nachbarn nun bestimmt supertraurig sind.</p>\n<p>Um 22 Uhr steht dann mein Plan: Ich schreibe meinen nächsten Roman über einen Typ (Wolfgang Grupp), der rum fährt und Männern mit Mascara einen Spiegel vorhält, bis sie sich dafür auf Knien bei ihm entschuldigen. In diesem Moment hörte der Regen plötzlich kurz auf und ich freute mich auf Fernsehabende in kurzer Hose am offenen Fenster. Die große Zeit für Auswandererreportagen sollte kommen.</p>\n<p>Mehr Ada und meine monatliche Kolumne natürlich auf <a href=\"http://www.intro.de/autor/Ada%20Blitzkrieg\">INTRO</a>.</p>\n"}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	module.exports = {"title":"INTRO Kolumne: Got To Dance","date":"2013-08-27 09:53:18 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/introcoverweare.jpg\" alt=\"introcoverweare.jpg\" />\n<p>Moment mal, der niedliche Howie von Take That ist inzwischen Vierundvierzig und hat das graumelierte Haupthaar eines pensionierten Physiklehrers? Richtig, und falls wir es vergessen haben, wir sind auch nicht mehr Vierzehn, sondern zwischen 25 und 35, leben in den inneren Bezirken Berlins, einige auch in Hamburg oder München, und sind offenbar immer noch hochempfänglich für kurzweilige Popmusik, schrille Neon-Kleidung, dicke Bässe und harten Wettbewerb. Aber ist das nicht eigentlich eine gute Nachricht?</p>\n<p>Ich meine, es könnte weitaus schlimmer sein: Unsere Eltern hatten in diesem Alter bereits stillschweigend resigniert und fanden sich plötzlich nach freier Liebe, Drogenkonsum und Brandstiftung mit Bayer AG Aktien im ockerfarbenen Einfamilienhaustraum wieder. Sie empfanden die Musik der jungen Menschen, die inzwischen ihre Kinder waren - denn die hatte man als kleines Eingeständnis für seine Sesshaftigkeit wie selbstverständlich nebenher in die Welt geschleudert - als »anstregend« und wiederholten starrsinnig »Ätzend!« in die ideologische Leere des auf solide zweiundzwanzig Grad beheizten Hobbyraums.\nDie gute Nachricht lautet aber: Wer heute, mit Ende Zwanzig, einen Zugang zu Dubstep und B-Boying findet und die durchtrainierten Bodys der Kandidaten bei »Got To Dance« ertragen kann, ohne sich gleich einen Finger in den Hals zu schieben, wer das Format konsumieren kann ohne darüber zu philosophieren, dass elektronische Musik keine »echte« Musik sei, weil es keine Instrumente gibt, bei dem besteht durchaus noch Hoffnung.</p>\n<p>Ist es nicht ein beruhigendes Gefühl, es jedes Mal aufs Neue auf die Kette zu bekommen, sich mit kontemporären Trends auseinanderzusetzen, statt sich ihnen zu versperren? »Got To Dance« scheint der geeignete Rorschachtest zu sein, um tief in die eigene Seele blicken zu können. Sind wir im Allgemeinen interessiert? Turnt uns Wettbewerb noch? Oder wollen wir einfach mit unserem Wachsfigurenkabinett aus Erinnerungen und LP-Regalen in Ruhe auf der Stelle stehen, bis irgendwann der Krebs die Bodenklappe unter uns öffnet und wir einfach im Nichts verschwinden?</p>\n<p>Die Jury besteht aus Nikeata Thompsen, eine aus Stahlbeton gegossene Tanzmaschine, die mehr Emotionen als ein echter Mensch mit sich führt. Die anderen beiden Jurymitglieder Palina Rojinski, die durch die Sendung neoParadise bekannt wurde, und Howard Donald, das ehemalige Take-That-Mitglied, kommen ebenfalls aus dem Tanzbusiness und scheinen über ein integres Grundgerüst an Respekt und Fairness gegenüber harter Arbeit und dem Mut der Kandidaten zu verfügen, das uns durch andere Castingshows bereits erfolgreich abtrainiert wurde.</p>\n<p>Wie wunderbar organisch sich eine sonst nicht ganz so überzeugende Palina in dieses Wettbewerbsformat einfügt, indem sie einfach das tut was sie am besten kann und nicht klanglos bei dem Versuch untergeht, tiefgreifende Kultur-Inhalte zu produzieren, wie bei ihrem Auftritt in der Sendung »Durch die Nacht mit\n« auf ARTE. Wo ein offensichtliches Gefühl für Mode, Trends, Musik und Bewegung vorhanden ist, braucht es nicht den kräftezehrenden Aufwand mit Frida Gold in einer »hippen« Berliner Werbeagentur über Social Media, Selbstdarstellung und Markenkommunikation zu sprechen, denn das geht voll in die Hose. Dann schon lieber bei »Got To Dance« diejenigen Tänzer aussortieren, die besser auf den Tag der offenen Tür in der Gesamtschule Brühl passen oder eben den kleinen Jungen feiern, der aussieht wie ein von Titus gesponsorter Stephen Hawking.\nProSieben kaufte sich das Format in Großbritannien ein und erzielt derzeit eine durchgängige Einschaltquote von acht Prozent in den ersten Sendungen. Vielleicht ist der Grund dafür ganz simpel darin zu suchen, dass mit »Got To Dance« endlich eine Talentshow präsentiert wird, in der sich alles ohne heuchlerischen Pathos um das Subjekt »Tanz« dreht, und nicht wie bei anderen Shows um einen fiktiven Preis und unrealistische Versprechen. Der Sieger erhält seine 100.000 Tacken auf die Hand. Keine halbseidenen Karrierchancen für die Gewinner und keinen hässlichen Opel Adam, für den man im Drive-In ohnehin nur ausgelacht wird, damit kann man als Zuschauer doch gut leben.</p>\n<p>Mehr Ada und meine monatliche Kolumne natürlich auf <a href=\"http://www.intro.de/autor/Ada%20Blitzkrieg\">INTRO</a>.</p>\n"}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	module.exports = {"title":"INTRO Kolumne: Markus Lanz, ein Backstreet Boy auf der Ersatzbank","date":"2014-01-09 09:22:07 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/introcoverweare.jpg\" alt=\"introcoverweare.jpg\" />\n<p>Wir sind vom öffentlich-rechtlichen Fernsehen ja stets aufwendige Produktionen in Milliardenhöhe (GEZ) und phantastisch übertriebene Kostüme (GEZ) gewohnt. Dennoch fanden wir uns letzten Dienstag relativ unbeeindruckt vor unseren (angemeldeten) Rundfunkgeräten wieder. Das ZDF lud an diesem Abend zu einem promistarken Plaudertreff zu Markus auf die abgegrabbelte Ansammlung sperriger Kunstledersessel (GEZ) ein. Ein Kunstprojekt dessen Humor sich fachfremden Fernsehfreunden nicht gleich auf den ersten Blick erschließen dürfte, oder? Vielleicht! Aber wieso sind unsere Erwartungen eigentlich so verdammt hoch?</p>\n<p>Ich sag es einfach mal frei heraus: Wir sind zu verwöhnt und in unserer pubertären Meckerattitüde zwischen Beanstandungs-Mails an den DHL Kundensupport und kritischen Facebook-Postings auf die Fanseiten von Parmesanherstellern haben wir uns irgendwann selbst verloren.\nUnser inneres »Fernseh-Ich«, das »Sendung-Mit-Der-Maus«-Kind, das gebannt zusieht wie Luftpolsterfolie hergestellt wird und bei »Wetten Dass…?!« ungebremst über die Saalwetten kichert - ich möchte gerne wieder ähnlich befriedet sein und es als vollends ausreichend empfinden, wenn der Moderator ein formschönes Sakko trägt und keinen Senf auf der Krawatte hat - existiert nicht mehr! Wir waren doch mal so zufrieden, aber wo ist das alles hin?</p>\n<p>Unter den gefühlten dreihundert Talkgästen dieser Sendung befand sich unter anderem »Wolfgang Rademann«, der TV-Produzent mit »Berliner Schnauze«, der mehr wie ein besonders überzeugender Comedian in einem zu großen Wolfgang Rademann Kostüm wirkte und der mit seiner Performance vermutlich nur die Aufmerksamkeit der Zuschauer abfragen wollte. Wer also an diesem Abend nicht in die »Rademann-Falle« tappte und »Oh, der ist ja gar nicht echt!« dachte, der ist nun offiziell und Markus-Lanz-geprüft tot und dürfte damit auch die Zielgruppe darstellen, die schrill kreischt, wenn die Backstreet Boys in einem kleinen Fernsehstudio in Hamburg Altona sitzen und unfassbar hungrig aussehen. Crazy 90er Jahre Zombies.</p>\n<p>Der »Rock- und Popstar H. P. Baxxxter« (Zitat: Markus Lanz) erzählte im lockeren Plauderton von gut bezahlten Auftritten bei KGB-Weihnachtsfeiern in russischen Strip-Clubs. Generell ist Hans-Peter, so der bürgerliche Name des Kajalstift-Warriors aus Ostfriesland, eher der Evil Twin des ZDF-Moderators. Hans-Peter ist so einer, den so welche wie der Markus Lanz auf dem Schulhof immer heimlich bewundert haben (aus der Entfernung, versteht sich), mit denen sie aber nie Kontakt hatten, weil die Eltern generell eher davon abgeraten haben und man das glaubte, was die Eltern sagten, denn die waren ja schon irgendwie alt, trotzdem ganz in Ordnung und hatten es zu einem silbernen Opel Astra für Vater und einem geländegängigen Stadtjeep für Mutter gebracht. Markus Lanz war also eher so ein Anhimmler-Typ. Und ja, er hat es geschafft sich seine Begeisterungsfähigkeit als Charaktermove beizubehalten, nervt damit aber heute leider eher. Oder sind wir bloß eifersüchtig?</p>\n<p>Scooter-Sänger H. P. Baxxxter ist also kein Typ, den die Eltern mögen. Natürlich nur bis sie ihn dann irgendwann besser kennenlernen. Lanz hingegen gab als Jugendlicher bestimmt auf die Frage nach seinem Lieblingstag weder den eigenen Geburtstag noch Weihnachten an (da geht es nämlich nur um einen selbst), sondern nannte voller Überzeugung den Tag vor den Schulferien (Aber nur wegen der Zeugnisvergabe) und den Geburtstag seiner Mutter (die freute sich immer so schön über die Narzissen). Heute ist Markus Lanz das »junge« Vorzeigegesicht eines antiquierten TV-Senders und H. P. Baxxxter ist offizieller Repräsentant der Eishockey Weltmeisterschaft der Herren 2010 und hat im Allgemeinen einen viel zu kurzen Wikipedia-Artikel.</p>\n<p>Lanz outete sich in der besagten Folge dann auch als riesiger Backstreet Boys-Fanboy der ersten Stunde und läutet die zweite Runde Gäste ein: Die Backstreet Boys - die Echten! Aber Moment mal! War Markus nicht eigentlich damals schon zu alt für die ganze Boyband-Nummer? Und wieso sollte jemand so verrückt sein, das Ganze auch noch zu recherchieren? Richtig! Weil er dafür bezahlt wird. Hier also die Fakten:</p>\n<p>Als die Backstreet Boys 1997 mit ihrem Hit »Everybody« an der Spitze der Charts standen, war Markus Lanz bereits 28 Jahre alt - und hörte die Backstreet Boys - und zwar gerne. Ich lasse das mal unkommentiert in dieser Kolumne stehen, damit ihr die Schwere und tiefe Bedeutung dieser Tatsache spüren könnt.</p>\n<p>Klein und verdrugt sehen die Boys heute aus. Immer noch in »Tragen sie doch mal was Flippiges!«-Klamotten, wirken sie mehr wie ein Testimonial für Esprit, die »junge« Kleidungsmarke, als eine Band die aus 40 Jährigen Männern besteht und die auch 2012 noch auffallend intensiv betonen, dass sie nicht homosexuell sind. Whatever!</p>\n<p>Und liebes ZDF, zeig uns bitte nicht Nick Carter in Nahaufnahme, wir wissen bereits schmerzlich um unsere eigene Sterblichkeit!</p>\n<p>Hat man Nick Carter und Eminem eigentlich schon mal in einem Raum gesehen?</p>\n<p>Funfact: Nick Carter führte ein paar Jahre lang eine Beziehung mit Paris Hilton, in der auch sein Paris-Tattoo entstand, dass er sich nach dem Beenden der Beziehung mit einem Totenkopf übertätowierte und mit dem Schriftzug »Old habits die hard« überdecke. Michelle Hunziker hat sich ihr Dornenkranz-Oberarm-Tattoo mit einem Gesicht von Markus Lanz übertätowieren lassen und es mit dem Schriftzug »Authentizität« versehen lassen.</p>\n<p>Am Ende bleibt allerdings eine Frage offen: Hat Markus Lanz etwas aufgedeckt? <a href=\"http://hat-markus-lanz-etwas-aufgedeckt.de/\">http://hat-markus-lanz-etwas-aufgedeckt.de/</a> Hat er (KGB) und dieses Mal hat wirklich keiner hat den Counter umgestellt.</p>\n<p>Mehr Ada und meine monatliche Kolumne natürlich auf <a href=\"http://www.intro.de/autor/Ada%20Blitzkrieg\">INTRO</a>.</p>\n"}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

	module.exports = {"title":"INTRO Kolumne: Markus Lanz und die Ganzkörperhunziker","date":"2013-08-27 09:53:24 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/introcoverweare.jpg\" alt=\"introcoverweare.jpg\" />\n<p>Es ist mir schon etwas peinlich, aber ich habe erst kürzlich erfahren, dass Barney Stinson, Christian Lindner und Markus Lanz nicht ein und dieselbe Person sind. Ich meine, wurde Markus Lanz eigentlich jemals in Freizeitkleidung gesehen? War die Nachgeburt des Moderators wirklich ein Paket mit gebügelten Hemden, so wie es die Legende erzählt? Ist der Maßanzug nur ein weiteres raffiniertes Bodypainting oder sogar ein permanentes »Ganzkörperhunziker«, das die einfachenLeute so lieben?</p>\n<p>Wen interessiert schon, dass Heidi Klum, unser größter Exportschlager neben Neid und dem Zweiten Weltkrieg, vermutlich aus gutem Grund in L.A. lebt und derzeit etwas zu gut im Fleisch steht, wenn das beste Pferd im Stall Markus Josef Lanz heißt und mit aufgegelten Haaren eine stattliche Widerristhöhe von 1,81m erreicht: Nicht zu groß um uns zu ängstigen und nicht zu klein um nicht mehr ernst genommen zu werden, sondern genau richtig für Einen, der nicht nur im Strom mitschwimmt, sondern dabei auch noch authentisch Spaß empfindet. Der »Blonder-Italiener-Lanz« bildet die perfekte Synthese rassiger Gestik und deutscher Charakterlosigkeit. Das mag man.</p>\n<p>Der Strahlemann ist wie junger Gouda (44), den mag auch jeder. Auch ich, und das kommt selten bis nie vor, mochte den Moderator mal ganz gerne. Eben genau so gerne, wie man jemand mögen kann, der einen in Ruhe lässt und Patschehändchen wie ein Vierjähriger hat. Man weiß was einen in einer Stunde Talk erwartet und das sind keine großen Überraschungen. Sarah Kuttner sagte mal: »Im Ernst: Ist jemand, der im Restaurant immer das Gleiche bestellt, ein ignoranter Arsch oder einfach jemand, der weiß, was ihm schmeckt?« Man muss sich also gar nicht schämen den vermutlich sexuell aktivsten Moderator (wenn man die Jungs aus dem Frühstücksfernsehen außen vor lässt) aufrichtig zu mögen.</p>\n<p>Diese bedingungslose Sympathie hatte er sich allerdings unlängst in der Talkrunde zur Ausstrahlung des etwas nationalistischen getönten ZDF-Dreiteilers »Unsere Mütter, unsere Väter« verspielt. Lanz konnte beim Thema für meinen Geschmack etwas zu herzlich lachen, denn seine Weste schien nicht nur auftätowiert, sondern auch rein zu sein und er wusste ob seiner starken Tugend »Respekt vor dem Gast«, die er auch in dieser Sendung sechzig Minuten eindringlich unter Beweis stellte, als er Arnulf Bahring, der unentwegt nationalistische Scheiße propagierte, nicht etwa unterbrach oder korrigierte, sondern ihn im gebührenfinanzierten Fernsehen gut gelaunt darüber schwadronieren ließ, dass die jüdische Bevölkerung im Dritten Reich ebenso Täter gewesen wären wie die Deutschen. Ich war fassungslos.</p>\n<p>Es war aber nicht alles schlecht unter Lanz. Drei Mal die Woche Peter Altmaier, Uschi Glas und Kurt Beck sind zwar drei Mal Peter Altmaier, Uschi Glas und Kurt Beck zu viel, aber in der direkten Gegenüberstellung zur Bachelor-Talk-Runde von Jauch sorgt Lanz immerhin für Frauenquote. Ja, Frauen dienen ihm zwar nur als auflockerndes Füllmaterial und sind ausschließlich ZDF-Schauspielerinnen aus gutem Hause, mit mittlerer Intelligenz und kokettierendem politischen Desinteresse, die im Ernstfall als Erregungspuffer die Diskussion entschärfen sollen, aber es funktioniert. »Wer macht den bei Ihnen den Abwasch? Ihr Mann?« (Gelächter im Publikum)</p>\n<p>Auch junge Menschen sind bei Lanz besser aufgehoben als bei Jauch, der im Vier-Sendungs-Zyklus ein Kind als Gast zum Thema »Sitzenbleiber und Bildungssystem« einlädt und nie den rechten Draht zu seinem »kleinen« Gast findet. Markus hingegen hat die Kids spätestens nach ein paar Sekunden beim Kicken auf eine Zweiloch-Torwand und verkumpeltem Abklatschen um den kleinen Patschefinger gewickelt. Gut so!</p>\n<p>Wo sind denn die echten Talkgrößen hin? Ricky? Arabella und Britt, die den Menschen noch aufrichtig liebten und nicht die autistischen Züge eines distanzierten Günther Jauch aufwiesen? In diesem Sinne: Danke, dass es Markus Lanz gibt!</p>\n<p>Mehr Ada und meine monatliche Kolumne natürlich auf <a href=\"http://www.intro.de/autor/Ada%20Blitzkrieg\">INTRO</a>.</p>\n"}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

	module.exports = {"title":"INTRO Kolumne: Sommerloch","date":"2013-08-27 09:53:32 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/introcoverweare.jpg\" alt=\"introcoverweare.jpg\" />\n<p>Wenn man nicht zufällig durch besonders unverschämtes Glück oder genetische Überbevorteilung zu den grobschlächtigen Menschen gehört, deren Haut eine Eigenschutzzeit von über fünf Sekunden in der mitteleuropäischen Sonne aufweist, sollte man in diesem Sommer entweder einen saisonalen Behindertenausweis beantragen, um in der Videothek ganz vorne parken zu dürfen, oder sich lieber gleich aufraffen eine ausgewachsene Depression zu beherbergen. Diese legitimiert es dann die Rollläden für einige Monate unten zu lassen und die sporadische Gesellschaft eines guten Pizzalieferdienstes schätzen zu lernen.</p>\n<p>Die größte Hürde bei diesem Unterfangen ist leider klar definiert: Auf der Suche nach probater Ablenkung wird man im Sommerloch der Unterhaltungswüste ohne langjähriges Informatikstudium und einen brauchbaren DSL Anschluss nicht besonders weit kommen. Es befinden sich zwar vierhundert Kanäle auf der 80 Zoll Menükarte, die aber von Juni bis September lediglich eine Light-Variante der dringend benötigten Zerstreuung bietet. Leichte Kost für heiße Tage nennen die in den Sendeanstalten das. Ich nenne es: Scheiße! Selig sind derzeit die, die Netflix haben. Der Rest kann zusehen, dass er nicht auf der Strecke bleibt.</p>\n<p>Drei lange Monate nichts als Scripted Reality auf RTL, ProSieben, Sat1, Kabeleins, VOX und dazwischen die ein oder andere Kochshow mit bedürftigen Prominenten und übermotivierten Kleinstadt-Floristinnen, die zu Nudelauflauf »Kasserolle« und zu Laubabfällen »Gebinde« sagen. Aber die Moderation! Ein echter Pfundskerl dieser Steffen Henssler von Topfgeldjäger, wenn es wieder heißt: Quizzen und Kochen. Immer genau den richtigen Spruch auf den Lippen. Frech, aber dennoch absolut liebenswert. Da soll noch einmal jemand sagen, die »Jugend« von heute könnte nicht mehr kochen!</p>\n<p>Neben einigen von der Redaktion selbst verfassten »Zuschauerbriefen«, findet sich immer die ein oder andere freie Minute, in der eine ältere Damen durch den adretten Steffen konzeptunterwürfig angeflirtet wird oder die Kamera sich auf eine rasante Achterbahnfahrt durch das beige Beinkleidlabyrinth des Studiopublikums begibt. Dazwischen serviert man der Zielgruppe (Verlierertypen und/oder Menschen mit Hauttyp I) ein Rätsel in unverständlicher Mundart aus Regionen, in denen man als Einwohner mit Migrationshintergrund in der Regel nichts zu lachen hat, und zeigt zwei bis drei große Brocken Fleisch, die man allerdings nicht brät, sondern lieber farblos kocht.</p>\n<p>Das Fernsehen lehrt uns also derzeit Eines: Das Angebot bestimmt immer das Angebot. Marktforschung? Unsinn! Sollen die Scheißleute doch kaputt gehen mit ihrer Kacklaune und ihren verräterisch weißen Unterarmen! Wenn die nicht interessiert wie man niedersäschische Wurst herstellt oder einen Lavendelballen mit Eigenhaar stabilisiert, dann haben sie auch von September bis Juni keinen Anspruch auf den Markus und die anderen Zugpferde der Sender. Wer sich also im Sommer frecherweise erdreistet ein Unterhaltungsprogramm zu erwarten, während der Lanz, die Maischberger und Ulrich Meyer verdient auf Sylt in einem unförmigen Sitzsack im abgetrennten Bereich eines netten Fischlokals rumaalen und Detox-Shakes balancieren, ist doch bestimmt nur ganz besonders egoistisch, oder?</p>\n<p>Statt also mit dem erweiterten Freundeskreis ein kühles Biermischgetränk in der untergehenden Sonne am Schlachtensee (»Auf die Freundschaft!«) zu genießen und dabei zuzusehen wie irgendein Lars oder Hannes mit Indiefrisur ein kleines Feuer anzündet, verlangen wir aus eigennützigen Gründen dem Fernsehen ein Rezept gegen Langeweile ab. Vermessen! Statt uns dabei für Instagram fotografieren zu lassen wie wir an einem am Baum befestigten Seil in den See segeln, ohne dabei unangenehm durch nachschwabbelnde Arme aufzufallen, liegen wir zerstört auf dem Sofa und tragen das helle Fleisch an uns, das die anderen gerade irgendwo grillen.</p>\n<p>Wer noch nicht ernüchtert genug ist, der kann in einem alten Sakko Presseclub schauen und dabei mit einer Schöpfkelle Sauerampfersuppe direkt aus dem Topf essen. Aber Kopf hoch! Nur noch zwei Wochen Langeweile bis die nächste Staffel Breaking Bad beginnt. Bis dahin schaffen wir locker noch vierzehn Pizzen mit Sauce Hollandaise und stämmen noch fünf Heulkrämpfe bevor endlich wieder für junge Leute gekocht wird. Bloß ohne Steffen Henssler. Und auch keine Waldpilzcremesuppe.</p>\n<p>Mehr Ada und meine monatliche Kolumne natürlich auf <a href=\"http://www.intro.de/autor/Ada%20Blitzkrieg\">INTRO</a>.</p>\n"}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	module.exports = {"title":"INTRO Kolumne: Stuckrad-Barre","date":"2013-09-26 15:01:52 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/introcoverweare.jpg\" alt=\"introcoverweare.jpg\" />\n<p>Benjamin von Stuckrad-Barre ist so ein Typ über den Dieter Moor verliebt schwärmen würde, er hätte ein markantes Gesicht. Die NEON nannte den WELT-Journalisten, der derzeit die interessanteste Polittalkshow im deutschen Fernsehen moderiert, in ihrer jüngsten Ausgabe den »neuen Helmut Schmidt« und tat ihm damit unrecht. Stuckrad-Barre ist ein gedankenflinkes Journalismuswiesel, das meist nur selektiv an seinem Gegenüber interessiert ist, dafür aber genau in diesen Teilaspekten seine Gäste rhetorisch so weit auseinanderfleddert bis ihr aufklaffender Brustkorb dem Zuschauer einen unverstellten Blick auf ihr hässliches oder schönes Inneres freigibt.</p>\n<p>Der sinnlose Optimismus von Politikern stimmt ihn traurig, sagt der Moderator über sich selbst. EURO-Themen kann und will er einfach nicht. Das macht ihn besonders sympathisch. Er lässt sich seine Langeweile während der Sendung nicht nur anmerken, sondern thematisiert diese als Teil des Showkonzepts. Und die Rechnung geht auf: Durch die Konfrontation der Gäste mit seinen Befindlichkeiten und Sympathien, die nur selten positiv daherkommen, entsteht ein spannender Talk, der in der Woche vor den Bundestagswahlen täglich auf Tele 5 (dem Star Trek Sender) ausgestrahlt wurde. Stuckrad-Barre ist also das ziemlich genaue Gegenteil von Markus Lanz: Authentisch.</p>\n<p>Im Allgemeinen ist es nicht meine Art Angst vor etwas zu haben, es sei denn ich soll Teil eines »interaktiven Publikums« sein. Die Mail der Stuckrad-Barre Redaktion lag also in meinem Postfach. Ob ich zur Sendung eingeladen werden wollte, fragte man mich. Klar wollte ich. Einige Tage später fiel mir dann wieder ein, was ich doch für ein scheuer Mensch bin und ob ich nicht unter Umständen der denkbar ungeeignetste Kandidat für die Befüllung eines Studiopublikums wäre, das eigentlich klatschen und lachen sollte, anstatt mit verschränkten Armen nervös auf den Boden zu starren und den Magen voll Fingernägeln zu haben. Aktiv sein, das ist nichts für so welche wie mich und spröde Haare habe ich auch. Gar nicht gut für diese Fernsehdinger, dachte ich mir. Aus diesem Grund vergaß ich vermutlich auch die Absage abzuschicken. Ich reiste also am Tag der Aufzeichnung mit dem Fahrrad an. Fernsehwerft Berlin. Ehemaliges MTV Gebäude. Studio 2. Zum Glück, denn der Abend kam ganz anders als erwartet:</p>\n<p>Ich betrat mit überwältigender Lust auf angstlösende Canapés und einen schalen Sekt das Studio in Berlin Friedrichshain. Was würde in dieser Aufzeichnung passieren? Wer würde zu Gast sein? Immerhin hatte ich als Fanboy der Sendung sogar meinen Sommerurlaub an der Adria unterbrochen um die Folge zu sehen in der Kurt Beck sich »gehen lässt«.</p>\n<p>Ohne Schnittchen wurden wir im Publikum platziert und kurz eingewiesen während der Sendung nicht hungrig in die Kameras zu schauen. Heute sollte die große letzte Aufzeichnung der Talkshow stattfinden. Stuckrad-Barre begrüßte uns, verschwand dann wieder und dann war die Sendung auch schon vorbei und ich fand mich auf den Toiletten wieder, abpissend, direkt neben Heide Simons, die in dieser Folge der geladene Studiogast war, und die nun ihre Blase einige Zentimeter neben mir entleerte.</p>\n<p>Christian Ulmen, der Produzent des Formats, hat mit Stuckrad-Barre eine Idee verwirklicht, die jenseits der immer gleichen, repetitiven Talkshows liegt, in denen Politiker ihr altbewährtes Medienkonzept ungehindert abfahren können, ohne durch den Moderator auch nur im Entferntesten umgeleitet zu werden. Also 30% Wahlprogramm durchnudeln, 50% die Wahlprogramme der anderen Parteien schlecht reden, 10% »witzige« Anekdoten über die Besonderheiten des Ehepartners »ausplaudern« und 10% aufgesetzte Lockerheit. In der Regel hundert Prozent Langeweile.</p>\n<p>Mit seinem Sidekick Markus Feldenkichen vom SPIEGEL, zieht Stuckrad-Barre sich regelmäßig während der Show zu einer kurzen Bestandsaufnahme zurück, um sich wie ein Bluthund auf widersprüchliche Aspekte und Aussagen des Gegenübers schärfen zu lassen und diese dann im Fortlauf der Sendung umfassender zu vertiefen. Der Gast hört derweil alles mit und darf schon mal ungebremst Adrenalin ausschütten. Man muss dabei im Hinterkopf behalten, dass Politiker performen wie Vollprofis, die es gewohnt sind 24/7 ihre Person und die Ziele der Partei zu vermarkten. Was bleibt aber hinter der Fassade zurück, wenn man diese nicht nur einreißt, sondern die Person sogar dazu bringt diese selbst, beabsichtigt oder unbeabsichtigt, einzureißen? Darin liegt nichts Gehässiges, sondern etwas sehr Wahres. Hier entsteht Unterhaltung. Stuckrad-Barre schafft es mit seinem Sinn für die Details der Kommunikation den Menschen hinter den Politfiguren rauszuprügeln und das kann je nach Gast auch mal verblüffend positiv daherkommen, wie bei Dorothee Bär, oder merkwürdig beängstigend, wenn auch weniger überraschend, sein. So bekam Bernd Lucke, der Parteivorsitzende der Alternative für Deutschland, der Menschen mit Migrationshintergrund als »Bodensatz der Gesellschaft« bezeichnete ein paar gerechte Fausthiebe vom Gastgeber und Günther Beckstein von der Jungen Union versuchte vergeblich eine Waschmaschine zu bedienen. Momente, die mehr aussagen als ganze Parteiprogramme.</p>\n<p>Das Konzept von Christian Ulmen funktioniert hervorragend und schafft Inhalte durch die bewusste Entfernung von diesen und gehört daher zum Pflichtprogramm für diejenigen, die bei schweren TV-Unfällen im Fernsehen gerne hingucken möchten. Es müsste mal ein Markus Lanz zu Stuckrad-Barre eingeladen werden! Wir hoffen auf eine nächste Staffel.</p>\n<p>Mehr Ada und meine monatliche Kolumne natürlich auf <a href=\"http://www.intro.de/autor/Ada%20Blitzkrieg\">INTRO</a>.</p>\n"}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	module.exports = {"title":"INTRO Kolumne: Warum sich der kleine Lord ruhig mal die Haare waschen könnte","date":"2014-01-09 00:00:00 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/introcoverweare.jpg\" alt=\"introcoverweare.jpg\" />\n<p>Müsst Ihr Euch an Weihnachten auch immer vorstellen, wie der kleine Lord heimlich eine Zigarette raucht oder am Hermannplatz von Klassenkameraden ordentlich was auf die Fresse bekommt, weil Cedric ein unfassbar »schwuler Name« für einen langhaarigen Pubertierenden ist?</p>\n<p>Mit seinem Boho-Häckelkragen und der Berlin Mitte-Frise könnte der kleine Pleppo heute vermutlich problemlos in einem American Apparel Katalog abgebildet sein und würde höchstwahrscheinlich auch über die nötigen finanziellen Mittel verfügen, um seiner bedürftigen Mutter ein schönes Paket mit bunten Macarons zum Fest der Liebe nach Hellersdorf zu schicken.\nEnge Leggins trägt der kleine Lord ja ohnehin schon voller Inbrunst und wenn sein klobiger Körper nicht so speckig aufgedunsen wäre, könnte sich der junge Mann von der Gage noch häufiger unter dem Solarium rumaalen. Das würde auch dem alten Earl von Dorincourt, der sich als Ziehvater des kleinen blonden Engels versteht, ein Like unter einem der unzähligen Cedric-Selfies entlocken. Aber sollte der alte Earl nicht ohnehin lieber mehr mit Gleichaltrigen rumhängen oder bin ich da bloß etwas zu kritisch?\nIst also eigentlich alles gut so wie es da im Fernsehen gezeigt wird? Ich meine: Mit der hungrigen Mutter und dem devoten Jungen? Whatever. Da steckste nicht drin!</p>\n<p>An Weihnachten drehen ohnehin alle Sendeanstalten gehörig durch. Im Fernsehen wird ein Megafilm nach dem anderen abgeschossen. Alles Fiction, Märchen und Fantasy. Und alles nur damit Mutter beim GTA V einpacken ein bisschen heile Welt in ihr Herz reinpampen kann, während der Haselnussschnaps die Leberzellen weiter zerlegt und Vater den Schlüssel für den Waffenschrank irgendwo in der Wirtsschänke verlegt hat.</p>\n<p>Wundert sich denn heute keiner der Zehnjährigen mehr über tschechische Kindermärchen? Warum sind da alle Tiere so unfassbar verloddert? Ganzkörperglatzen an Ziegen und Wölfe mit Kinderfleischkrümeln im Fell? Ich will gesunde Märchen sehen! Märchen, in denen alle Tiere so gut aussehen, dass ich mir rein hypothetisch vorstellen könnte, sie sofort zu verspeisen!</p>\n<p>Wie unrealistisch ist das denn bitte? Wenn ich persönlich das letzte Einhorn wäre, würde ich immer mit fettigen Haaren rumlaufen. Sieht ja schließlich keiner mehr! Ich würde bestimmt auch unvernünftig schnell Auto fahren, schrecklich viele Cinnabons essen und über jedes Gericht Ahornsirup schütten. Ich würde in der U-Bahn schwarzfahren und müsste laut kichern, weil ich mir ab diesem Jahr auch endlich das Porto für Weihnachtskarten sparen könnte.\nVermutlich hätte ich aber schon längst ein Kickstarter-Projekt gestartet um mich zu klonen. Ich bin ja schließlich nicht total blöd. Aber wie so ein irrer Anthroposoph durch den halben Wald hetzen (ohne Funktionsschuhe) nur um ein anderes Einhorn zu finden, ohne dabei Technik (böse!) zu benutzen, das käme für mich nicht in Frage.\nWenn dann noch so ein »dahergelaufener« Schmetterling behaupten würde, ich wäre der letzte meiner Art, würde ich erstmal mit dem iPhone Mutter anrufen. Gut, die ginge dann gegebenenfalls nicht an den »Apparat«. Ich würde dann erstmal was Witziges twittern: »Wenn ich angeblich das letzte Einhorn bin, wieso trage ich dann überhaupt eine Hose?«</p>\n<p>»Kevin  Allein zu Haus«, ist das überhaupt realistisch? Muss sich ein Junge, der von seinen Eltern in diesem Alter alleine zu Hause vergessen wird, wirklich vor zwei obdachlosen Einbrechern mit niedrigem IQ fürchten? Müsste man nicht eher Angst davor haben, der hyperaktive Junge bekäme schon bald die erste Abmahnung von Redtube oder einen auffallend roten Kopf, wenn die nächste Kreditkartenabrechnung einen dreistelligen Betrag an Dominos Pizza ausweist und man die zu engen Hosen nicht mehr mit »Wachstumsschub, das ist normal in diesem Alter!« abtun kann?</p>\n<p>Ich wünsche mir doch zu Weihnachten bloß eine heile Welt und vielleicht, wenn das Christkind dieses Jahr megagut drauf ist, dass Markus Lanz sich das Gesicht in Zukunft nicht mehr mit »Kohle und Schuhcreme« für seine Saalwetten schwärzen möchte.</p>\n<p>Mehr Ada und meine monatliche Kolumne natürlich auf <a href=\"http://www.intro.de/autor/Ada%20Blitzkrieg\">INTRO</a>.</p>\n"}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	module.exports = {"title":"Ist eine Schlägerei mit Donato undenkbar?","date":"2014-03-10 13:14:44 +0000","tags":null,"layout":"post","body":"<p>Donato ist endlich zurück! Der Rap-Poet und in der Badewanne iPad Benutzer veröffentlicht am 14.03.2014 sein drittes Soloalbum ‘Enzo’ auf <a href=\"http://www.kopfhoerer-rec.de/\">Kopfhörer Recordings</a>. Ich durfte mir Enzo vor dem offiziellen Release anhören und es ergab sich so, dass ich noch einige Dinge mit diesem Marco Donato zu klären hatte:</p>\n<p><img src=\"http://www.kopfhoerer-rec.de/wp-content/uploads/KHR013_Front-480x480.jpg\" alt=\"alt\"></p>\n<p><strong>Ada: Woher kennen wir uns eigentlich?</strong></p>\n<p>Donato: (lacht) Stellst du die schwierigste Frage immer zuerst? Keine Ahnung. Wahrscheinlich bin auf Twitter über einen deiner Tweets gestolpert. Weil ich parallel oft esse, ist mir vor Lachen wahrscheinlich das Leberwurstbrötchen im Hals stecken geblieben. Außerdem teilen wir offenbar die Vorliebe für ALF. Das verbindet.</p>\n<p><strong>Ada: Kannst Du die letzten vier Jahre zwischen den Releases Deiner beiden Alben in einem Satz zusammenfassen?</strong></p>\n<p>Donato: Sogar in einem Wort: Veränderung.</p>\n<p><strong>Ada: Enzo soll den Hörer mit auf eine Reise nehmen. Was hat es mit diesem Konzept auf sich?</strong></p>\n<p>Donato: Konzept ist fast etwas zu hochgegriffen, das hat immer was von Kalkül. Wahr ist: Das Album ist mein persönlicher Road-Trip - raus aus der Komfortzone, rein in ein ungewisses, neues Leben. Und das sieht mir eigentlich nicht ähnlich.</p>\n<p><strong>Ada: Bekommt man beim Hören auch Heimweh?</strong></p>\n<p>Donato: Ich nicht. Was aber daran liegen mag, dass ich gar nicht mehr weiß, was Heimat ist.</p>\n<p><strong>Ada: Wo bist fühlst Du Dich zuhause?</strong></p>\n<p>Donato: Grönemeyer hat mal gesungen: “Heimat ist kein Ort, Heimat ist ein Gefühl.”. Darf ich ihn überhaupt zitieren, oder ist das uncool?</p>\n<p><strong>Ada: Grönemeyer ist der deutsche Kurt Cobain für Realschullehrer. Du darfst aber alles!</strong></p>\n<p>Donato: Herbert ist mein Held. Jedenfalls, Heimatgefühle verspüre ich gerade keine. Wohnhaft bin ich in München, ursprünglich komme ich aus Dortmund. Ich mag beide Städte, aber so richtig zu Hause bin ich nur in der Musik.</p>\n<p><img src=\"https://fbcdn-sphotos-b-a.akamaihd.net/hphotos-ak-prn1/t1/58256_145596568814150_152258_n.jpg\" alt=\"alt\"></p>\n<p><strong>Ada: Poet oder Schlägertyp?</strong></p>\n<p>Donato: Ganz klar Poet.</p>\n<p><strong>Ada: Du hast ein paar schicke Features auf deinem Album? Wie hast du ausgewählt? Freunde? Oder wonach sucht man aus?</strong></p>\n<p>Donato: Features müssen den jeweiligen Song voranbringen, ihn veredeln. Namen sind schön, aber die Kernfrage ist: Was kann Künstler XY dem Song noch geben, was ich ihm nicht selbst geben kann? Deshalb sind die Features rar gesät. Aber auf jedes einzelne bin ich sehr, sehr stolz.</p>\n<p><strong>Ada: Was passiert wenn Prinz Pi und Du aufeinander treffen? Erzfeinde oder Busenbrüder?</strong></p>\n<p>Donato: Letzteres wäre mir lieber. Ich bin auch ein recht umgänglicher Typ.</p>\n<p><strong>Ada: Ich musste bei allen Liedern heulen. Ist das Absicht?</strong></p>\n<p>Donato: Ja.</p>\n<p><strong>Ada: Macht Dich Deine eigene Musik eigentlich traurig?</strong></p>\n<p>Donato: Nein. Bis auf wenige Ausnahmen. Bei “Enzo” treibt’s mir oft Tränen in die Augen. Ansonsten höre ich meine eigenen Songs eher selten.</p>\n<p><strong>Ada: Du hast mir verraten, dass Du im Auto noch einen CD-Player hast. Was hörst Du und wohin fährst Du?</strong></p>\n<p>Donato: 2013 war das Jahr der Fernbeziehung, da saß ich pro Fahrt 6 Stunden und mehr am Steuer. Wenn es dunkel ist, läuft im Zweifel Radiohead. Der ganze Katalog, rauf und runter. Aber wenn ich übermüdet bin, hör ich mir US-Rap aus den 90ern an, damit ich bei 180 nicht einschlafe. Sonst war “Enzo” wohl mein letztes Album…</p>\n<p>** Ada: Ich danke Dir auf jeden Fall sehr für das Gespräch und werde meine Leser zwingen sich <a href=\"http://donato.de/\">Enzo HIER zu kaufen</a>. Danke Dir!**</p>\n<p><strong>Hier könnt Ihr noch einen Blick in die Trackliste werfen:</strong></p>\n<p>1 Einfach</p>\n<p>2 Feuer ft. Tatwaffe</p>\n<p>3 STRG-Z</p>\n<p>4 Winterschlaf</p>\n<p>5 Nordsüdwestost</p>\n<p>6 Du</p>\n<p>7 Wozu ft. Jinx</p>\n<p>8 Wenn ich gehe</p>\n<p>9 Nachtrag ft. Jinx</p>\n<p>10 Gib dich nicht auf</p>\n<p>11 Panzer</p>\n<p>12 König und Königin</p>\n<p>13 Ich bin nicht normal</p>\n<p>14 Qual ft. Moses Pelham</p>\n<p>15 Bei Nacht</p>\n<p>16 Enzo</p>\n"}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

	module.exports = {"title":"Jeder ist 30","date":"2015-08-12 08:30:43 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2015/Aug/IMG_1050-1.JPG\" alt=\"alt\"></p>\n<p>Es ist immer ein etwas sonderbar anmutendes Gefühl, wenn man obenrum bekleidet und untenrum vollkommen entblößt auf der mintfarbenen Liege eines nach Rauch riechenden Gynäkologen liegt und mit unbekannten Händen und kalten Instrumenten in sich rumgreifen lässt, wie eine Gans am Heiligen Abend. Nur ohne Apfelbefüllung. Manchmal, und das ist das Gute, stimmt dann alles, und das ist auch in Ordnung so, und manchmal stimmt dann eben nichts, und dann muss man damit irgendwie zurechtkommen.</p>\n<p>Ich verließ die schön gestaltete Praxis (wenn man denn den Geschmack einer 50jährigen Chemielehrerin teilt) an diesem Tag, nur eine Woche vor meinem 30sten Geburtstag, mit ambivalenten Gefühlen. Emotionen wie eine gemischte Tüte machten sich in mir breit und peitschten mein Inneres in eine wunde Masse. Man will ja aus dieser Süßüberraschung eigentlich nur eben gerne alle Speckmäuse und sauren Schnüre in sich reinstopfen und wenn man dann aber in das Papiermonster reingreift, hat man nur die braunen Haribo Konfekte und vielleicht noch eine bescheuerte Schaumbanane in der Hand und soll damit dann zufrieden sein.\nImmerhin keine ernstzunehmende Krankheit, dachte ich mir, dankte keinem Gott, und hielt eines dieser superfancy Ultraschall-Fotos in der Hand, die meine anderen 30jährigen Freunde (und das sind derzeit alle) immer und immer wieder auf Facebook posten. Zuhause zeigte ich das kleine Bild dann meinem Freund. <strong>Was dann geschah - ihr werdet es nicht glauben!</strong></p>\n<p><img src=\"/content/images/2015/Aug/nodo-1.jpg\" alt=\"alt\"></p>\n<p>Das Foto zeigt den vollkommen korrekten Sitz einer Kupferspirale in meiner Gebärmutter. Ich bin 30. Ich habe Angst vor Kindern. Ich weiß, das klingt ziemlich daneben. Veantwortung liegt mir in vielen Bereichen. Ich bin ein echter Chef-Typ. Ein echter Macher. Gewinnermensch mit Ideen und Führungsqualitäten. Ich finde es beruhigend, wenn ich die Strippen für das Gelingen oder Scheitern von Projekten in der Hand halte. Ich scheue mich nicht. Ich bin ehrgeizig. Ich bin ein starker Charakter, das weiß ich. Ich schätze das an mir. Kinder hingegen ängstigen mich und ihre reine Präsenz im Freundeskreis oder in meiner physischen Umgebung bereitet mir Gänsehaut.</p>\n<p>Den Vertrag einer lebenslangen Bindung. Die schreckliche Angst zu versagen. Schon im Vorfeld. Vielleicht. Mit der falschen Partnerwahl. Dem Gebähren in der falschen Lebenssituation. Falsche Entscheidungen. Fehlende Empathie. Ein Versprechen, dass ich gerne geben würde, aber befürchte, dass ich es nicht einhalten und erfüllen kann. Ein Perfektionist mit Angst vor dem Scheitern. Ausgelöst durch einen 30sten Geburtstag. Als wenn jemand mein 14jähriges Ich gefragt hätte, ob es nun ein Kind bekommen mag. Die gleichen Ängste wie eh und je. Ich bin nicht älter geworden in den letzten 16 Jahren. Nicht in dieser Hinsicht. Ich habe gelernt, im besten emanzipatorischen Sinn, mich durchzusetzen, mich als Person zu etablieren, zurechtzukommen, zu arbeiten, einen Sinn zu stiften und mich zu mögen.</p>\n<p><strong>Aber was, wenn man ein Kind bekommt und dann ist es mit 20 ein Rassist oder behandelt andere Menschen schlecht?</strong></p>\n<p>Mütter müssen die mutigsten Menschen auf der ganzen Welt sein und dafür danke ich ihnen von Herzen. Mutter war ein wahrer Optimist. Zwei Mal. Mein Bruder und ich. Wir sind eine Familie geworden durch ihren Mut und ihre Bereitschaft ein Risiko einzugehen.</p>\n<p><img src=\"/content/images/2015/Aug/Screen-Shot-2015-08-12-at-10-06-20.png\" alt=\"alt\"></p>\n<h2>Das sind keine Probleme. Das sind Privilegien!</h2>\n<p>Wir, die Generation <em>Nudeln mit Buttersoße</em>, wird dieses Jahr 30. Jeder von uns. Wir arbeiten in Berlin. Wir sind erfolgreicher denn je und wir haben unsere Vorstellungen und Ziele, die wir umsetzen. Kinder haben wir keine. Dabei haben wir Gebärmütter, Gebärmutters, Gebärmütterinen, oder wie auch immer der Plural des Teils heißt, dass wir bisher immer so ausser Acht gelassen haben. Immer öfter kommt uns der Gedanke - zu alt zu sein. Sich irgendwann nach einem langen Run mit beruflichen und charakterbildenden Erfolgen zurückzubesinnen auf genau das, was uns immer begleitet hat: Familie. Der Ursitz aller Neurosen, Sprallotäten, Ängsten und der Hauptwohnsitz der Liebe und Verbundenheit.</p>\n<p><img src=\"/content/images/2015/Aug/CMLIlp3UYAAwJ45-1.jpg\" alt=\"alt\"></p>\n<p><img src=\"/content/images/2015/Aug/Screen-Shot-2015-08-12-at-08-13-12.png\" alt=\"alt\">\n<a href=\"s://twitter.com/lauramaryharker\">Laura Harker</a></p>\n<p>Vor einigen Tagen postete ich meine Story des letzten Jahres auf Facebook. Es ging mir nicht immer gut. Das letztes Jahr hatte es in sich. Aber ich konnte für mich sorgen. Mehr möchte ich gerade nicht, im Nachhinein betrachtet. Auf mich aufpassen. Und vielleicht ein bisschen nett sein und etwas abgeben. Im nächsten Jahr. Nette Dinge schreiben oder Menschen helfen, denen es nicht so gut geht: <a href=\"http://www.findingberlin.com/10-ways-to-help-refugees-in-berlin/\">10 Ways To Help Refugees in Berlin</a></p>\n<p><img src=\"/content/images/2015/Aug/Screen-Shot-2015-08-12-at-08-21-42.png\" alt=\"alt\"></p>\n<p>Hier der Link zu meiner Amazon Wishlist, falls mir jemand eine Freude machen möchte:\n<a href=\"http://www.amazon.de/registry/wishlist/3PIK2FF6GZI5D\">AMAZON BLITZWUNSCHWUNDERLISTE ZUM 30STEN GEBURTSTAG</a></p>\n<p>Nächste Woche fahre ich meine Eltern besuchen. Das erste Mal mit 30. Vielleicht wird alles anders sein. Vielleicht steht aber auch meine Mama jeden Abend vor dem Schlafengehen mit ihrem Nachthemd in meinem Kinderzimmer und fragt, ob ich noch fünf Minuten mit ihr ins Bett komme. Und dann liegen wir zusammen etwas rum und ich bin immer noch das Kind einer Mama. Für immer wahrscheinlich. Und beeindruckt über ihren Mut, das bin ich. Und ich werde es mit dem Alter immer mehr.</p>\n<p><img src=\"/content/images/2015/Aug/doogg.jpg\" alt=\"alt\"></p>\n"}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	module.exports = {"title":"Kampagne zum Fremdschämen","date":"2012-04-18 10:23:18 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/tn_black1.jpg\" alt=\"tn_black1.jpg\" />\n<p>Muss Werbung eigentlich um jeden Preis auffallen? Wo genau liegen die Grenzen des guten Geschmacks? Auffallen um jeden Preis?</p>\n<p>Im Fokus: Die aktuelle SIXT-Kampagne</p>\n<p>Heute überraschte der Autovermieter SIXT auf seiner Facebookseite mit einer kontroversen Social Media Kampagne. <a href=\"http://www.olivervoss.com/\">Oliver Voss</a>, der ehemalige Vorstand von Jung von Matt, ist der “kreative” Kopf hinter dem Clou. In der Kampagne wird Gerwald Claus-Brunner, der als Mitglied der Piratenpartei im Abgeordnetenhaus von Berlin sitzt, mit dem Text <strong>“Total beliebt. Und keiner weiß warum. Die Piraten: Günstige Brise”</strong> und einem - zugegebenermaßen - etwas dümmlichen Gesichtsausdruck dargestellt. Daneben befindet sich das gleiche Foto mit einem lächelnden Brunner, dem mit infantilen - sehr Clipart anmutenden - Bildbearbeitungsmitteln ein Lenkrad und eine Rennfahrerhaube ins Bild geschnitten wurde. Unter dem besagten Bild findet sich der Slogan <strong>“Total beliebt. Und jeder weiß warum. Sixt Cabrios: Grünstige Preis”.</strong></p>\n<p>Wo genau liegt eigentlich die Idiotie dieser Werbung, die mich entfremdet, aber zeitgleich auch viele Menschen anspricht? Welcher Texter hat das verbrochen? Clicks gibt es in diesem Fall lediglich für das Beipflichten zur ohnehin schon bestehenden allgemeinen Belustigung über die Piraten Partei. Die Kampagne ist ein schneller Klatscher, der für sein lautes Geklatsche gerne weiteres Geklatsche von Menschen, die gerne Klatschen erzielen will. Inhaltslosigkeit hat sich in diesem Fall schon derart abstrahiert, dass man gar nicht mehr weiß, worüber man hier eigentlich lacht (Ich lache lieber gar nicht). Notfalls, und wenn einem kein Grund mehr einfällt, klatscht man eben für die reine Provokation und über einen Gerwald Claus-Brunner, der optisch und durch seine Kleidung alles andere als den normative Durchschnitt eines Politiker oder Menschen darstellt.</p>\n<p>Lieber Texter, Inhaltslosigkeit kann nicht auf der einen Seite kritisiert werden und auf der anderen Seite das selbstgewählte Stilmittel für eine Kampagne darstellen. Die Schlange beißt sich selber in den Schwanz. Ob diese Art von Werbung langfristig für ein Unternehmen gut ist? <strong>“Die Piraten: Günstige Brise”</strong> Kritik ist sicherlich in vielen Punkten möglich, aber dann auch bitte zielsicher und inhaltszentriert. Irgendwie verschwimmt alles zu Ignoranz.</p>\n<p>Die Kampagen könnt Ihr <a href=\"http://www.sixt.de/?sxref=sm_sixtfacebook_de&utm_source=sm_sixtfacebook_de&utm_medium=text&utm_campaign=piraten_12&utm_content=facebook_DE\">hier</a> ansehen.</p>\n<p>Wer diese Werbung 2012 noch als radikal und provokant empfindet, der kann bei SIXT ohnehin kein Auto mehr mieten, weil er vermutlich schon lange seinen Führerschein abgegeben hat.</p>\n<p>Werbung hatte schon immer den Vorteil Werbung zu sein. Hier kann so gut wie alles erlaubt sein. Die Grenzen sind geweitet. Die Grundvoraussetzung ist allerdings immer Treffsicherheit, Information und Humor gewesen. Ich erinnere an die heiß diskutieren <a href=\"http://www.spiegel.de/fotostrecke/fotostrecke-46277.html\">Hitlerkampagnen</a>.</p>\n<p>Aber Vorsicht! Zum einen wird durch die Benutzung des Konterfeis von  Brunner die Kampagne leicht persönlich. Die Aussage lautet schnell: Keiner weiß, warum dieser Typ so beliebt ist. Man projiziert Belustigung auf eine einzelne Person. Der Bezug zur Partei und die eigentliche Kritik geht leider verloren. Der ungeschulte Betrachter wird sich in erster Linie über Herr Brunner, seine Kleidung und sein Kopftuch lustig machen. Möchte sich eine Firma damit identifizieren?</p>\n<p>SIXT besticht hingegen mit der neuen Piraten-Kampage durch die unterschwellige Botschaft “Provokation!” und “Bitte bringt uns ins Gerede!”. In werbetechnischer Hinsicht ein Kurzschluss. Jeder Fan, der etwas liket oder teilt ist ein potenzieller Kunde, Käufer, Sympathisant und Multiplikator. Gerne fungiert er aber als dieser ohne sich selber mit paradoxen Inhalten zu benetzen. Achte deinen Kunden und begibt dich mit deinen Fans auf die gleiche Augenhöhe! Leider hat sich in letzter Zeit ein neuer Trend definiert: Mit provokante Inhalten die Teilfreudigkeit der User rauszukitzeln. Mich langweilt das. Es bleibt die Frage wie effizient diese Art von Werbung ist? Kann Werbung, die potenzielle Kunden für stumpfsinnig verkauft wirklich erfolgreich sein? Schließlich füllt Mario Barth ja auch seine Hallen. Sich kollektiv lustig machen, das funktioniert im ersten Moment ganz gut. Wenn die ersten Lacher verklungen sind, merken aber meistens selbst die Dümmsten der Dummen schnell, dass sie nur für die platte Publikation leerer Inhalte benutzt wurden.</p>\n<p>Die Grenze des guten Geschmacks wird durch Humor definiert. Sind die Witze das Produkt aus Information und Wissen rund um das Objekt (Feminismus, Nerds, Nazis, Frauen, Ökos oder was auch immer), dann kommen sie humorvoll und intelligent daher. Wenn der Witz aber aus Ignoranz, Gehässigkeit und Multiplikationsabsicht getätigt wird, dann bleibt er nur eines: Peinlich für den, der ihn tätigt. Und langweilig für mich.</p>\n"}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	module.exports = {"title":"Katzen und Laser, lauert der Tod in den Kleinanzeigen?","date":"2012-10-10 13:22:28 +0000","tags":null,"layout":"post","body":"<p>Katzen sind gefährlich. Keine Frage. Aber Katzen mit Lasern sind etwa vier Mal so gefährlich, wenn man den Schätzungen renommierter <a href='http://icanhas.cheezburger.com/'>Wissenschaftler</a> trauen darf. Schlimm, dass man die Tiere problemlos auch als Vorbestrafter einfach so in den lokalen Kleinanzeigen erwerben kann.</p>\n<p>Ada Blitzkrieg hat die erschreckenden Bilder für Sie zusammengefasst.\nQuelle: Internet</p>\n<img src=\"/content/images/CAT8.JPG\" alt=\"CAT8.JPG\" />\n<img src=\"/content/images/CAT7.JPG\" alt=\"CAT7.JPG\" />\n<img src=\"/content/images/CAT6.JPG\" alt=\"CAT6.JPG\" />\n<img src=\"/content/images/CAT5.JPG\" alt=\"CAT5.JPG\" />\n<img src=\"/content/images/CAT4.JPG\" alt=\"CAT4.JPG\" />\n<img src=\"/content/images/CAT3.JPG\" alt=\"CAT3.JPG\" />\n<img src=\"/content/images/cat2.JPG\" alt=\"cat2.JPG\" />\n<img src=\"/content/images/cat1.JPG\" alt=\"cat1.JPG\" />\n"}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

	module.exports = {"title":"kaufen","date":"2012-12-16 00:00:00 +0000","tags":null,"layout":"post","body":"<h1>Alle Formate</h1>\n<p>ZIP-Datei mit epub, mobi, PDF und Cover</p>\n<p><a href=\"http://pul.ly/b/48119\"><img src=\"/content/images/dackelkrieg_buy.jpg\" alt=\"dackelkrieg_buy.jpg\" /></a></p>\n<h1>epub</h1>\n<p>Für iPhone, iPad, Sony Reader und die meisten E-Book-Reader (Ausnahme Amazon Kindle)</p>\n<p><a href=\"http://pul.ly/b/48125\"><img src=\"/content/images/dackelkrieg_buy.jpg\" alt=\"dackelkrieg_buy.jpg\" /></a></p>\n<h1>mobi</h1>\n<p>Für Amazon Kindle</p>\n<p><a href=\"http://pul.ly/b/48116\"><img src=\"/content/images/dackelkrieg_buy.jpg\" alt=\"dackelkrieg_buy.jpg\" /></a></p>\n<h1>PDF</h1>\n<p>Für PC und zum Audrucken</p>\n<p><a href=\"http://pul.ly/b/48122\"><img src=\"/content/images/dackelkrieg_buy.jpg\" alt=\"dackelkrieg_buy.jpg\" /></a></p>\n"}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	module.exports = {"title":"Keywords und Dackelkrieg","date":"2011-11-17 11:09:42 +0000","tags":null,"layout":"post","body":"<p>\n\tNach dem großen Erfolg meiner Hasspredigten auf <a href=\"http://textkrieg.de/2011/11/16/dienstleister-die-auf-dich-scheieen-dhl\">DHL</a>, <a href=\"http://textkrieg.de/2011/10/16/die-90er-megaparty-oder-wege-in-die-misanthropie\">90er Jahre Partys</a>&nbsp;und Menschen names <a href=\"http://textkrieg.de/2011/09/13/menschen-carmen\">Carmen</a>&nbsp;möchte ich denjenigen Menschen, die sich aus Versehen über die Googlesuche auf meinen Blog verirren ehrenamtlich unter die Arme greifen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDie wenigsten Menschen wissen, dass ich ein Einserdiplom im Fach Sozialpädagogik besitze, das ich mir aus Langeweile einige Jahre zuvor angeeignet habe. Ich kenne nicht nur Sarkasmus, kritische Arroganz und Hatedays, sondern auch den Dienste am Menschen.</p>\n<p>\n\tHeute also, völlig kostenlos und mit -100% Penis Enlargement, folgt nun ein Servicebeitrag um ungeklärte Fragen der Leserschaft zu beantworten.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tNutzen auch Sie heute noch die Googlesuche um in persönlichen Kontakt mit mir zu treten und lassen Sie sich mysteriöse Sachverhalte, moralische Fragen und einfache Suchanfragen zum aktuellen KiK-Angebot von einer Akademikerin ohne Niveau beantworten.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDank <a href=\"http://de.wikipedia.org/wiki/Google_Analytics\">Google Analytics</a>&nbsp;erhalte ich Statistiken über meinen Blog, die ich heute mit Ihnen teilen möchte. Manche nennen mich den heiligen St. Martin des Web 2.0, ich nenne mich einfach Servicefachkraft für intellektuelle Alltagsintegration.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_analytics1.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tOk, widmen wir uns vorweg den häufigsten Anfragen bei Google, über die Menschen auf Textkrieg gelangen. In erster Linie handelt es sich um Anfragen zu meiner Person. Die wenigsten wissen, dass ich <a href=\"http://textkrieg.de/pages/kaeuflich\">buchbar</a>&nbsp;für alle Angelegenheiten bin, die Text, Presstexte, Social Media, Werbung und fluffige redaktionelle Inhalte umkreisen.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDie von mir erschaffende und geprägte Phrase &quot;<a href=\"http://textkrieg.de/2011/07/07/thor-steinar-der-vorbereitungsnazis\">Thor Steinar der Vorbereitungsnazis</a>&quot; scheint ein Selbstläufer geworden zu sein, der mir im späteren Verlauf auf Reallife-Camps und diversen anderen Seiten begegnete. Der Grund für diese Metapher ist eine kleine und familienfreundliche Anekdote, die sich nicht nur schön einfach für alle Altersklasse liest, sondern auch bunte Bilder enthält.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_analytics2.JPG\" style=\"width: 500px; height: 19px; \" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDanke für Ihre Anfrage! Frittierter Käse ist das beste an Prag. &nbsp;Lassen Sie sich nichts anderes weismachen!</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_analytics3.JPG\" style=\"width: 500px; height: 19px; \" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tOffensichtlich besteht ein monumentaler Bedarf eine Ausnahmeperson wie mich in einem Wikipediaartikel näher zu umschreiben. Wer einen Wikipediaartikel über mich schreiben möchte, darf sich über ein Präsent in Form von in <a href=\"http://textkrieg.de/files/Foto%20(4).jpg\">Zwiebelsaft eingelegten Äpfel</a> freuen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_analytics4.JPG\" style=\"width: 500px; height: 18px; \" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEndlich hängen die Hipsters für Eventfragen und Infos nicht mehr bei <a href=\"http://www.mitvergnuegen.com/\">Mit Vergnügen</a> oder <a href=\"http://www.iheartberlin.de/\">iHeartBerlin</a> ab, sondern finden den Weg zu distanzierten und sachlichen Informationen über trendige Großevents, wie dem Bockbierfest und der 90er Megaraveparty, auf meinem Blog.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_analytics5.JPG\" style=\"width: 500px; height: 18px; \" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tMistranthropie verhütet am besten und der Weg zu Menschenhass, Hinterfragung von Rollenbildern, Klischees und unkorrekten Statements führt zwangsläufig zu Textkrieg. Nirgendwo wird schöner gehasst und geliebt. Lassen Sie sich nicht täuschen und retten Sie durch das Liken jedes Blogartikels einen Quadratzentimenter Morningwood!</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_analytics6.JPG\" style=\"width: 500px; height: 19px; \" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tHier ist Ernsthaftigkeit angebracht. Als Fachfrau für alle Fragen rund um den <a href=\"http://textkrieg.de/2011/09/07/ein-sonntag-auf-dem-dachshundrennen\">Dackel</a>, widme ich mich der Diagnose mit großem Herzblut. Wann erbricht sich der Dackel? Erbricht sich der Dackel nach den Mahlzeiten? Was erbricht der Dackel (gegebenenfalls mit einem Foto dokumentieren)? Wie heißt der Dackel? Welches Sternzeichen hat der Dackel oder ist der Kleine schon wieder gesund?</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_analytics7.JPG\" style=\"width: 500px; height: 52px; \" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tImmer wieder schön, wenn sich Menschen in historischen Fragen an mich als Fachfrau wenden. Ich bin fest davon überzeugt, dass Textkrieg alle Fragen der Interessierten fachkundig und mit professioneller Distanz restlos beantwortet. <a href=\"http://de.wikipedia.org/wiki/Guido_Knopp\">Guido Knopp</a> nutzt meinen Blog, um sich für seine Reportagen mit rudimentärem Hintergrundwissen zu versorgen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_analytics8.JPG\" style=\"width: 500px; height: 18px; \" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tLieber Interessent, schreiben Sie sich nicht ab und schauen Sie zur Abwechslung Filme mit Niveau! Ich empfehle Ihnen <a href=\"http://www.ulrichseidl.com/\">Ulrich Seidl</a>, <a href=\"http://www.youtube.com/watch?v=Xv3qJqM_ki4\">Lars von Trier</a> oder den Film <a href=\"http://www.imdb.com/title/tt1612774/\">Rubber</a> von <a href=\"http://de.wikipedia.org/wiki/Mr._Oizo\">Mr.Oizo</a>.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_analytics9.JPG\" style=\"width: 500px; height: 19px; \" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tNein, leider nicht. Und bitte denken Sie daran von den &quot;Einheimischen&quot; niemals Essen anzunehmen!</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/tn_analytics10.JPG\" style=\"width: 500px; height: 17px; \" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEs kommt nicht auf das an, was wir sind, sondern auf das, was wir gerne sein möchten.</p>\n"}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

	module.exports = {"title":"Kotti Couture","date":"2011-04-21 15:25:53 +0000","tags":null,"layout":"post","body":"<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/olli2.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/peter2.jpg\" width=\"500\" /></p>\n"}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	module.exports = {"title":"Kultur Enlargement","date":"2011-04-27 15:19:39 +0000","tags":null,"layout":"post","body":"<p>\n\tKultur Enlargement&nbsp;100% seriös! Keine Abzocke.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tLichtenberg ist ein kein Bezirk. Lichtenberg ist eine Plattenbauschönheit in Berlin. Zwischen aufreizendem Stahlbeton steht ein großer russischer Intermarkt. Warum dort nicht mal seinen alltäglichen Einkauf erledigen, dachte ich, und fuhr mit in Zwiebelsaft eingelegten Äpfeln und 3 Liter Flaschen Bier heim. Alles wie immer.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"667\" src=\"/files/Foto (4).jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tAlles was dort in den Regalen steht ist in Konservenform. Russland, geheimnisvolles Land der Haltbarkeitsmachung. Russland, das Portionierwunder. Russland, bekannt für gutes und edles Bier.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tAuf dem Rückweg wusste ich nicht wohin mit all den östlichen Köstlichkeiten. Tüten voll Bonbons, mehrere Liter Wodka, eine Menge Pilmeni, die gut und gerne eine pubertierende Schulklasse nach den Bundesjugendspielen sättigen könnte und Birkensaft.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWer Birkensaft nicht kennt, der kennt Mode nicht. In Berlin reißen sie sich um jede Art von coolem Getränk aus natürlichen Zutaten. In Birkensaft ist ausschließlich Birkensaft und Zucker. Natürlicher geht nicht. Die volle Schambehaarung unter den Erfrischungsgetränken. Ehrlicherweise muss ich sagen, dass dieses Getränkewunder weder erfrischend wirkte, noch gut schmeckte, aber einen Suchtfaktor aufwies, der gut und gerne mit dem von Coca Cola verglichen werden kann. Eine Frage der Zeit, bis ein Millionenkonzern das Getränk aufkauft und damit die Menschen unter seinem Birkensaft-Monopol vereint.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"667\" src=\"/files/Foto.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"667\" src=\"/files/Foto (1).jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tPferdefleisch. Auch so eine Sache. Und um gleich mit einem Gerücht aufzuräumen: Um Pferdefleisch zu lieben muss man kein abgebrühter Sozialwichser sein, sondern nur hungrig.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"667\" src=\"/files/Foto (2).jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"667\" src=\"/files/Foto (3).jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWenn jemand etwas von cleverem Produktdesign versteht, dann der Ostblock. Charmant und funktional können synchron existieren, wie diese köstlichen Fleischkonserven eindrucksvoll beweisen. Was drauf ist ist auch drin. Viele Tiere sehen nicht einmal glücklich aus. Der Westen arbeitet mit Photoshop. Russland benutzt die Wahrheit.</p>\n"}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

	module.exports = {"title":"'Lauter verlorene Männer', Frauenquote und Feminismus","date":"2012-06-07 16:35:09 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/pferdtitte.JPG\" alt=\"pferdtitte.JPG\" />\n<p>Es geht um die <a href=\"http://www.faz.net/aktuell/beruf-chance/frauenquote-chefinnen-per-gesetz-11768021.html\">Frauenquote</a>. Ihr könnt also jetzt schon mal genervt das Browser-Fenster schließen und Euch etwas Kurzweiligerem widmen, oder Ihr lest einfach mal weiter, was in den letzten Tagen so passiert ist. Keine Angst, es wird nicht kompliziert und <em>Günter Grass</em> kommt auch vor.</p>\n<p>Ich möchte kurz Bezug nehmen auf den Artikel <a href=\"http://www.faz.net/aktuell/wirtschaft/menschen-wirtschaft/frauenquote-lauter-verlorene-maenner-11771952.html\">Lauter verlorene Männer</a> in der <em>Frankfurter Allgemeinen Wirtschaft</em>.</p>\n<blockquote>\n<p>“Wie wild befördern die Konzerne Frauen. Auf der Strecke bleibt eine Männergeneration, doch flüchten ist keine Option.”</p>\n</blockquote>\n<p>Damit wäre der Inhalt dieses Artikels im Groben auch schon abgegrast. Die Autorin, <a href=\"http://www.faz.net/redaktion/bettina-weiguny-11104444.html\"><em>Bettina Weguny</em></a>, scheint bei genauerer Studie des Textes eine “dieser” Frauen zu sein, die Feminismus und Gleichberechtigung aus egoistischen Gründen ablehnen (dazu später mehr). Der Artikel stellt ein zähes und repetitives Wiederkäuen und Niederschreiben der Gesprächsfetzen mit karrierefrustrierten Männern dar. Nebenbei werden einige hetzerische Zitate mit Verweis auf Negativbeispiele aus Großkonzernen gereicht, welche die Frauenquote beschlossen haben und in denen es nun zu angeblichen “Negativkonsequenzen” für das männliche Geschlecht gekommen sein soll. In diesen Firmen herrscht aber ohnehin meist ein genickbeisserisches Karriere-Klima. Die Einführung der Frauenquote stellt nun den einfachsten Weg dar die Zukunftangst der männlichen Innehaber von Führungspositionen zu bündeln und auf ein falsches Ziel zu komprimieren - Gegen Frauenquote und gegen Gleichberechtigung.</p>\n<blockquote>\n<p>“So schnell dreht der Wind. Galten bislang die Kriterien weiblich, ledig, jung als Nachteil bei der Karriereplanung, ist nun das Gegenteil der Fall: Bewerberinnen haben erstmals in der Geschichte einen Gender-Bonus bei der Jobsuche. Ist es doch peinlich, wenn es keine Frau an der Spitze zu präsentieren gibt.”</p>\n</blockquote>\n<p>So, so. Feminismus scheint, wenn man Frau <em>Weguny</em> glauben mag, kein Thema mehr für unsere Gesellschaft zu sein. Angeblich existiere sogar ein “Trend” - die Anstellung von Frauen in höheren Positionen. Frauen als Chef? Frauen mit gleichen Bildungschancen? Frauen mit den gleichen Gehältern? <a href=\"http://www.journelle.de/1377/und-dabei-heist-es-doch-immer-frauen-wurden-zur-hysterie-neigen/\">Journelle</a> dazu:</p>\n<blockquote>\n<p>“Das Ausgrenzen von 50% der Bevölkerung auf dem Arbeitsmarkt ist nicht gut, nicht für die Stimmung, nicht für die Wirtschaft und da wir in Deutschland immer sehr auf unsere Außenwirkung bedacht sind: es sieht auch von draußen ziemlich altbacken, piefig und muffig aus.”</p>\n</blockquote>\n<p>Dass unsere Gesellschafts keinesfalls auch nur annähernd auf dem durch diesen Artikel propagierten Level der Gleichberechtigung angelangt ist, zeigt uns beispielsweise der aktuelle Gesetzentwurf von <em>Kristina Schröder</em> zur Einführung eines <a href=\"http://www.spiegel.de/politik/deutschland/betreuungsgeld-kostet-100-millionen-im-jahr-weniger-als-geplant-a-836796.html\">Betreuungsgeldes</a> ab 2013, welches denjenigen “Eltern” zukommen soll, die keine öffentlichen Kindertagesbetreuungsangebote nutzen. Ein belächelnswerter Versuch einen plumpen familienpolitischen Fail zu umspielen. Betreuungsplätze schaffen Gleichberechtigung! Dazu schreibt <a href=\"http://maedchenmannschaft.net/ein-lautes-nein-zum-betreuungsgeld-jetzt-unterschreiben/\">Mädchenmannschaft</a>:</p>\n<blockquote>\n<p>“Der Rechtsanspruch auf einen Betreuungs­platz ab dem 1. Geburtstag, der ab Oktober 2013 gilt, kann nach momentanem Stand nicht für jedes Kind, das einen Platz braucht, ein­gelöst werden. Statt­dessen sieht der Gesetz­entwurf von Kristina Schröder bereits ab Januar 2013 die Zahlung von 100 Euro vor, wenn Eltern keinen Krippen­platz und keine vom Jugendamt bezahlte Tages­pflege in Anspruch nehmen. Ein klares familien­politisches Ver­sagen und keineswegs ein Beitrag zu mehr Wahl­freiheit, als der es gern ver­kauft wird. Eine familien­politische Not­wendigkeit für das Betreuungs­geld besteht also nicht. Familien im Hartz IV Bezug wird das Betreuungs­geld keine finanzielle Anerkennung ihrer Betreuungs­leistung bringen, jedenfalls keine spürbare im Portemonnaie, denn das Betreuungs­geld wird in voller Höhe als Einkommen angerechnet.”</p>\n</blockquote>\n<p>Weiter geht es mit dem <a href=\"http://www.faz.net/aktuell/beruf-chance/frauenquote-chefinnen-per-gesetz-11768021.html\">Aufreger von Bettina Weguny</a> in der FAZ:</p>\n<blockquote>\n<p>“Seine Chefs seien alle Frauen, meldet Panten. Bei mancher fragt sich der 40-Jährige: Wie um alles in der Welt kam sie auf die Position?”</p>\n</blockquote>\n<p><em>Weguny</em> wählt ihre Beispiele gekonnt schlecht aus. Ein Interview mit einem “Mitarbeiter in höherer Position”, der aber lieber anonym bleiben möchte und sich über die Qualifikation und den Führungsstil seiner Chefinnen aufregt. Hand aufs Herz, wer tut das nicht? Ist das Geschlecht dabei nicht irgendwie zweitrangig? Und ich sage es zum wiederholten Mal - **dieser Artikel instrumentalisiert bestehende geschlechtsneutrale Zukunftsängste, um Stimmung gegen die Frauenquote zu machen. **</p>\n<blockquote>\n<p>“Vorstände hören in Zielgesprächen mit jungen Männern immer häufiger den Heide-Simonis-Satz: Und was wird aus mir? Gratifikationskrise nennen Mediziner das. Resignation, Angst und Zynismus der Männer am Arbeitsplatz werden ein Riesenthema, prophezeit Anette Wahl-Wachendorf, Chefin des Verbands der Betriebs- und Werksärzte.”</p>\n</blockquote>\n<p>Irritierender als den eigentlichen Artikel finde ich allerdings die Tatsache, dass dieser von einer Frau stammt. Ein Phänomen, das ich häufig beobachte. Frauen sind oft die schärfsten Kritiker von Feminismus und Frauenquote. <a href=\"http://happyschnitzel.com/\">Happyschnitzel</a> schreibt dazu in ihrem <a href=\"http://happyschnitzel.com/?p=6070\">Blog</a>:</p>\n<blockquote>\n<p>“Ich weiß nicht, was ich schlimmer finde  dass solche Artikel überhaupt geschrieben werden  oder dass sie dann meist von Frauen stammen. Männer bilden Karrierenetzwerke und helfen sich gegenseitig mit irgendwelchen Klüngeleien, aber die Frau bleibt der Frau eine Wölfin.”</p>\n</blockquote>\n<p>Frauen, die sich bereits ohne Frauenquote oder ohne den durch <em>Frau Weguny</em> propargierten “Frauen-In-Führungspositionen-Offenheits-Trend” eine höhere berufliche Position erarbeitet haben, argumentieren häufig gegen eine Quote. Doch woran liegt das? Vielleicht fühlt man sich um die eigenen arbeitsintensiven Bemühungen und getätigten Investitionen betrogen und greift fäschlicherweise auf das Argument “Aber ich habe es doch auch geschafft mich hochzuarbeiten!” zurück. Man kann nichts gönnen, denn rein subjektiv fühlt sich das oft ungerecht und schmerzlich an. Dabei wird häufig außer Acht gelassen, welche Umstände dazu geführt haben, das besondere Privileg zu besitzen als Frau Karriere zu machen und sich überhaupt “hochzukämpfen” zu können.</p>\n<p>Dass es auch anders und ohne Stöcke in Speichen zu werfen geht, zeigen die Speakerinnen bei <a href=\"http://netzfeminismus.org/\">Netzfeminismus</a>, die sich auf einer <a href=\"http://netzfeminismus.org/?page_id=114\">Liste gegen frauenlose Panels</a> organisieren.</p>\n<p>Doch zurück zum eigentlichen Artikel:</p>\n<blockquote>\n<p>“Öffentlich jammert kaum ein Mann. Keiner will in den Ruf kommen, Frauen ihre Rechte zu nehmen.”</p>\n</blockquote>\n<p>Dieses rhetorische Mittel kennen wir seit der Israel-Kritik durch <em>Günter Grass</em>, der ein “Gedicht” mit dem populistischen Titel <a href=\"http://www.spiegel.de/kultur/gesellschaft/dokumentation-gedicht-was-gesagt-werden-muss-von-guenter-grass-a-825744.html\">Was gesagt werden muss</a> verfasste.</p>\n<p>Was passiert, wenn man in einer Diskussion das “Grass-Argument” benutzt (Ich wünsche mir, dass dieser Begriff bald in Lehrbüchern populistisch platte Stilmittel umschreibt)? Der Urheber untergräbt die Diskussion inhaltlich, indem er sich über oder neben die Diskusson stellt, eine Art “unparteiische Beobachterrolle” einnimmt und behauptet, dass man über etwas nicht sprechen dürfte und dass die Diskussion aus diesem Grund nicht funktioniere. Der Urheber konstruiert ein Tabu und tätigt die Unterstellung es gäbe einen bestehenden gesellschaftlichen Konsens über eine Thematik und ein “Mundtotmachen” von Andersdenkenden. Dabei ist rein objektiv gesehen sowohl Gleichberechtigung als auch eine israelpositive Grundeinstellung in Deutschland leider in keinster Art und Weise Konsens. Die verdummten Lesern fühlen sich gleich angesprochen in ihrer Opfermentalität. “Man darf ja wohl nochmal was sagen dürfen!” und “Endlich sagt es mal jemand!”. Dass der ursprüngliche Inhalt der Aussage gegen Frauenquote und Gleichberechtigung grenzenlos dumm und falsch ist, interessiert an dieser Stelle den Leser oft nicht mehr.</p>\n<p>Wer eine inhaltszentrierte und lösungsorientierte Diskussion führen möchte, sollte sich nicht der irrationalen Angst hingeben morgen in einer Welt aufzuwachen, in der es keine Arbeit mehr für das männliche Geschlecht gibt, denn Gleichberechtigung gilt für beide Geschlechter.</p>\n<p>Fakt ist: Unser derzeitiges Beschäftigungsverhältnis in den Führungspositionen ist männerdurchsetzt und hat von der jahrelangen Unterdrückung der Frau profitiert. Das muss sich ändern!</p>\n<p><a href=\"http://juliaschramm.de\"><em>Julia Schramm</em></a>, Bloggerin und Mitglied der Piratenpartei, brachte in ihrem Blogartikel <a href=\"http://juliaschramm.de/2012/03/08/feminismus-und-piraten/\">Feminismus und Piraten</a> ein paar unfrustrierte und wahre Worte zur Notwendigkeit der Diskussion über Gleichberechtigung:</p>\n<blockquote>\n<p>“Warum nenne ich mich Feministin? Ich habe mich lange gegen den Begriff gewehrt, weil ich nicht verstand, worum es dabei geht. Frauen sind doch rechtlich gleichgestellt. Die großen Kämpfe haben wir doch hinter uns! Wieso kriegen die Frauen den Arsch nicht hoch und nutzen ihre Vorteile? Männer sind doch auch oft Opfer von Frauen! Die Liste an Argumenten geht ewig weiter. Doch spätestens, als ich während meines Shitstorms wegen des Spackeriainterviews merkte, wie sexualisiert und frauenfeindlich viele der Aussagen waren (Die soll putzen, nicht reden.  Die muss man mal ordentlich durchnehmen  Das passiert, wenn man Frauen wählen lässt etc.), beschäftigte ich mich intensiver mit Feminismus.”</p>\n</blockquote>\n"}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	module.exports = {"title":"Learn The Kitchenbasics: Salsa","date":"2012-11-01 00:00:00 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/tacos.JPG\" alt=\"tacos.JPG\" />\n<p>Hand auf’s nichtvorhandene Herz - nichts ist einfacher als eine geile Salsa halbwegs vernünftig hinzubekommen. Dennoch sieht aber nichts leckerer aus, macht die räumlich distanzierten Zuschauer eifersüchtiger und ist somit die perfekte Basis für jedes Hipster-Cook-Portfolio.</p>\n<p>Wie einfach eine Salsa geht, verrate ich Euch:</p>\n<img src=\"/content/images/salsa2.JPG\" alt=\"salsa2.JPG\" />\n<p><strong>Salsa</strong></p>\n<p>Zutaten:</p>\n<p>1 Dose ganze geschälte Tomaten</p>\n<p>3 Roma Tomaten geviertelt</p>\n<p>1/2 Zwiebel</p>\n<p>3 Knoblauchzehen</p>\n<p>1 Hand frisch gehackter Koriander</p>\n<p>2 eingelegte <a href=\"http://www.lacostena.com.mx/chipotlesadobados.html?page=7\">Chipotles</a> (ersatzweise Chilis oder Jalapeno)</p>\n<p>DIY:</p>\n<p>Alles in ein hohes Gefäß geben und kurz mit dem Pürierstab durch die Fressmaterie rattern. Aber Vorsicht - nicht zu viel pürieren! Nur ein paar Sekunden. Eine schöne Salsa muss noch stückig und teils wässrig sein.</p>\n<img src=\"/content/images/salsa3.JPG\" alt=\"salsa3.JPG\" />\n<p>Portionen:</p>\n<p>Das Rezept ergibt etwa 1l Salsa, die sich auch hevorragend einfrieren lässt. Salsa wird von Menschen wie mir am liebsten zu Tacos oder Burritos gegessen oder einfach nur auf ein selbstgebackenes Brot gepackt. Mein Guacamolerezept folgt bald.</p>\n"}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	module.exports = {"title":"Learn The Kitchenbasics: Selfmade Pasta","date":"2012-11-06 00:00:00 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/pasta1.JPG\" alt=\"pasta1.JPG\" />\n<p>Wir haben früher zu Pasta einfach nur “Nudeln” gesagt und statt Lasagne gab es bei uns immer bloß Nudelauflauf. Seit ich groß bin, mache ich plötzlich auch mit Pasta rum. Es freut mich also sehr Euch heute ein gelungenes Rezept für selbstgemachte Pasta ans Herz zu legen. Dauert nur mehrere Stunden, macht Euch Oberarme wie Hulk Hogan und die Küche sieht nachher aus wie bei Hempels unter dem Fliesentisch, schmeckt aber ziemlich großartig und hinterlässt ein gutes Gefühl.</p>\n<img src=\"/content/images/pasta4.JPG\" alt=\"pasta4.JPG\" />\n<p><strong>Pasta selber machen</strong></p>\n<p>Zutaten:</p>\n<p>800g Weizenmehl</p>\n<p>8 Eier</p>\n<p>5 EL Olivenöl</p>\n<p>Wasser</p>\n<p>DIY:</p>\n<p>Unbedingt die Arbeitsplatte gründlich putzen, sonst habt Ihr nachher Katzenhaare und Larveneier in der Pasta!</p>\n<p>Das Mehl als Berg auf der Arbeitsfläche aufschütten und in der Mitte eine Krater mit den Fingern formen. In dieses Loch schlägt man nun die Eier und gibt das Olivenöl. Vorsicht, dass Euch an den Seiten keine Flüssigkeit ausläuft, das ist sonst eine fette Sauerei!</p>\n<img src=\"/content/images/pasta7.JPG\" alt=\"pasta7.JPG\" />\n<p>Vorsichtig mit einer Gabel das Ei und das Olivenöl vermischen, bis es eine einheitliche Matsche gibt. Nun beginnen langsam mit den Fingern von außen Mehl in die Mische fallen zu lassen. Dabei mit einer Hand vermengen. Dies solange tun, bis die Eierpampe halbwegs vermischt ist.</p>\n<p>Nun dürft Ihr nicht erschrecken. Der Teig ist enorm krümmelig un erinnert irgendwie an Mürbeteig. Aber nun kommt es auf Kraft an und Ihr müsst Euch motivieren. Kneten! Kneten! Kneten! Und immer eine klitzekleine Menge Wasser hinzugeben. Teelöffel für Teelöffel. Dabei kneten. Und seid vorsichtig mit dem Wasser. Bloß nicht zu viel! Erstmal den Teig durchkneten, auch wenn er bröckelt und nur so wenig Wasser wie nötig verwenden. Nach einiger Zeit - etwa 10 Minuten sollte so ein schöner runder Teig entstehen, den ihr dann auch erstmal 5 Minuten kräftig auf der Arbeitsfläche durchnehmt.</p>\n<img src=\"/content/images/pasta6.JPG\" alt=\"pasta6.JPG\" />\n<p>Nun sollte man den teig kurz ruhen lassen. Ich lasse ihn eine Stunde in einer Frischhaltefolie stehen.</p>\n<img src=\"/content/images/pasta3.JPG\" alt=\"pasta3.JPG\" />\n<p>Nun den Teig in 8 Teigteile schneiden. Jedes Teigteil muss einzeln ausgerollt werden. Dazu die Arbeitsfläche gut einmehlen und die Teigkugeln so lange mit ein Backrolle auswalzen bis er hauchdünn ist. Nun ist theoretisch Eure Nudelplatte fertig und Ihr könnt entscheiden wie es weitergeht. Man die Platten in Lasagnengröße schneiden, Bandnudeln herstellen oder die kompletten Platten einfach einfrieren und bei Bedarf wieder auftauen. Das ganze dann 8 mal mit allen Teigkugeln wiederholen.</p>\n<img src=\"/content/images/pasta2.JPG\" alt=\"pasta2.JPG\" />\n<p>Die frischen Nudeln werden dann als Spaghetti, Bandnudeln - oder in welcher Form Ihr Sie Euch auch schneiden mögt - für 3 Minuten in siedendes Salzwasser geworfen und sind dann fertig und lecker.</p>\n<img src=\"/content/images/pasta8.JPG\" alt=\"pasta8.JPG\" />\n"}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

	module.exports = {"title":"Lisa Rank, die Kloß-Im-Hals-Autorin","date":"2013-04-08 00:00:00 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/lisafenster.jpg\" alt=\"lisafenster.jpg\" />\n<p>Vor Menschen wie <a href=\"http://mevme.com/lizblog/\">“Lisa Rank”</a> habe ich eine große Ehrfurcht, denn sie scheint ihr Leben irgendwie mehr im Griff zu haben als die meisten anderen Menschen. Die erfolgreiche junge Autorin arbeitet nicht nur bei der bekannten Werbeagentur <a href=\"http://www.tlgg.de/\">“TLGG”</a> als Senior Creative, sondern nimmt sich auch gerne mal Urlaub, um Blumensträuße auf ihrem Tisch zu arrangieren, durch Berliner Cafés zu flanieren oder ganz nebenbei ihren neuen Roman <a href=\"http://www.amazon.de/Bist-du-noch-wach-Roman/dp/3827010950\">“Bist du noch wach?”</a> aus dem Boden einer schier unendlich scheinenden Quelle romantischer Phantasie und blühenden Worten zu formen. Warum ihr Buch einen dicken Kloß im Hals hinterlässt und wie es in ihrem Leben wirklich um die Perfektion steht, verrät die 28jährige mir im Interview:</p>\n<p><strong>Hallo Lisa. Deine Worte und die Sprache in deinem Roman klingen zeitlos schön. Jede Szene wird vor meinem inneren Auge sichtbar und ist bis in die kleinsten Details von dir liebevoll umschrieben. Man möchte danach greifen. Sind Details wichtig für dich?</strong></p>\n<p>Ich finde es anstrengend, wenn man sich immer nur von ganz großen Dingen begeistern lässt, es gibt viele Leute, die brauchen immer das ganz große Hurra oder das große Drama, damit etwas in ihnen bewegt wird. Ich glaube, dass das Leben besser ist, wenn man hier und da die Messlatten verschiebt. Das heißt nicht, dass ich durch die Straßen renne und bei jedem Gänseblümchen in hysterisches Seufzen verfalle und mit Herzchen in den Augen gegen Laternen laufe. Ich glaube nur, dass es gesund ist, sich hier und da um die kleinen Dinge, Ecken und Momente zu kümmern und diese auch zählen zu lassen.</p>\n<p><strong>Glaubst du, dass Details im Alltag auch einen Nachteil haben können?</strong></p>\n<p>Wer sich nur mit Fitzelchen beschäftigt, verliert irgendwann den Blick fürs große Ganze, das ist ja auch der Hauptfigur Rea in meinem Buch passiert. Generell glaube ich eh, dass nur das Eine oder nur das Andere bei den meisten Dingen zu einem Problem wird. Weil man den Abgleich mit der Realität und dem Außen vergisst. Und Abgleich ist wichtig, hinterfragen ist wichtig, Perspektive wechseln sowieso.</p>\n<img src=\"/content/images/lisablumen.jpg\" alt=\"lisablumen.jpg\" />\n<p><strong>Fühlst du dich im Chaos oder in der Ordnung wohler?</strong></p>\n<p>Ich kann das nicht so verallgemeinern, es gibt Bereiche in meinem Leben, da komme ich mit Chaos sehr gut zurecht, da brauche ich das auch, im Kreativen zum Beispiel, da sammle ich Gedanken und Ideen in losen Sammlungen, tausend Notizbüchern und Zetteln  in anderen Gegenden hab ichs gern sortiert, im Umgang mit Menschen zum Beispiel. Ich kann gut mit Chaos, wenn offen zum Chaos gestanden wird. Sobald aber Ordnung vorgegeben, vorgetäuscht und applaudierend hochgehalten wird, obwohl dahinter der Teufel wütet, bekomme ich einen Knoten im Gehirn.</p>\n<p><strong>Hast du einen Lieblingsschlafanzug?</strong></p>\n<p>Ich habe eine Lieblingsjogginghose, sie ist grau und geht mit mir durch dick und dünn. Manchmal schlafe ich auch in ihr ein, sie trägt mich dann meistens ins Bett, ohne mich zu wecken. Sie ist eine von den Guten.</p>\n<p><strong>Gehörst du eigentlich einer Generation an?</strong></p>\n<p>Generation Jogginghose? Nein, im Ernst. Alle wollen immer einen Generationenbegriff, das ist so eine schöne Schublade, aber ich glaube nicht daran, weil so ein Zeitpunkt der Geburt zwar einen Rahmen setzt, aber nicht so einen engen, dass eine ganze Generation charakterlich hineinpasst. Mir sind diese Generationenbegriffe zu einfach, aber ich habe auch aufgehört, mich darüber aufzuregen. Wems hilft…</p>\n<p>**Wenn man in Berlin wohnt, wird man von außen sehr schnell zugeordnet und etikettiert. Empfindest du das auch so und ist das ein Vor- oder ein Nachteil für eine Schriftstellerin?&quot;</p>\n<p>Auch das ist so eine Geschichte, über die ich nur den Kopf schütteln kann. Dieses Berlin-Label funktioniert genauso wenig wie das Generationen-Label, das ist nur ein Bild für die Suche nach mehr, glaube ich. Ich bin in Berlin-Mitte direkt neben der Mauer geboren und aufgewachsen, wo jetzt alles restauriert, renoviert und gepudert ist, dafür gibt es jetzt andere Gegenden, die den Grauputz übernommen haben  und hurra, das ist nichts Neues, das funktionierte in Berlin schon immer so. Die Kieze und Gegenden werden sich bis in die Ewigkeiten abklatschen, die Suche nach Stillstand und Unveränderlichem von allen, die sich darüber aufregen, ist in diesem Zusammenhang so paradox, weil das in Berlin nicht passieren wird.</p>\n<p>**Dein Roman <a href=\"**http://www.amazon.de/Bist-du-noch-wach-Roman/dp/3827010950\">“Bist du noch wach?”</a> handelt von einer jungen Frau, die als Kreative in Berlin lebt. Das klingt sehr nach einer Welt. Ist es für dich leichter zu schreiben, wenn sich die Lebenswelt der Hauptfigur mit deiner eigenen Lebenswelt deckt?&quot;</p>\n<p>Ich vermute, ja. Ich bin niemand, der sich die wildesten Lebensläufe ausdenkt, von denen er noch nie gehört hat. Das überlasse ich anderen, das können andere besser. Ich schreibe von Dingen, von denen ich zumindest den Hauch einer Ahnung zu haben meine. Reas Leben ist nicht 1:1 meins, aber eben ein Modell, das hier häufiger vorkommt.</p>\n<p><strong>Was sind die größten Überschneidungen zwischen Rea, der Hauptfigur, und dir?</strong></p>\n<p>Dass wir mit Abschieden nicht so gut sind. Und dass die Angst, nicht genügen zu können, vielleicht manchmal lauter ist als nötig. Was mich irre an ihr macht, ist, dass sie mit allem so lange wartet.</p>\n<img src=\"/content/images/lisalaptop.jpg\" alt=\"lisalaptop.jpg\" />\n<p><strong>Das Buch wirft einen entzaubernden Blick auf Freundschaften und deren Ende. Glaubst du, dass Egozentrismus ein Problem unserer Gesellschaft darstellt?</strong></p>\n<p>Findest du den Blick entzaubernd? Ich finde ihn eigentlich entspannend. Also wenn man weiß, dass Freundschaften nicht dem Superzwang der Ewigkeit unterliegen und es auch einen Weg geben kann, da gut rauszukommen. Ja, den gab es bei Rea und Konrad nicht, aber so was muss man ja auch erst einmal lernen. Und sich von diesem riesigen Ideal verabschieden, dass so was einfach da bleibt, auch wenn man sich nicht drum kümmert. In dem Sinne steht das Ego natürlich im Weg  und Egozentrismus war schon immer ein Problem unserer Gesellschaft, natürlich.</p>\n<p><strong>Was bedeutet Freundschaft für dich? Ist es möglich trotz eines nüchternen Blicks auf Freundschaft eine solche zu führen?</strong></p>\n<p>Ich finde meinen Blick gar nicht nüchtern sondern eher noch romantischer als das Bild, was ich vorher von Freundschaften hatte. Also bevor ich mich mit dem Thema in mir drin noch einmal verheiratet habe. Weils eben doch nicht so einfach ist: Ja hier Liebe, da Freundschaft. Und dieser scheiß Spruch Die Liebe geht, die Freunde bleiben. Die Freunde sollten auch gehen, wenn du dauerhaft scheiße zu ihnen bist. Man muss nicht alles aushalten und mitmachen. Man darf aber, wenn man sich darauf geeinigt hat. Und ich glaube, so ein gemeinsames Konzept von Erwartungen und Wie können wir gut miteinander leben ist auch für Freundschaften ganz wichtig. So was entwickelt sich natürlich nur, wenn man ausprobiert und guckt, was geht miteinander und was geht nicht. Und ja ja ja! Freundschaften sind so was von möglich und wichtig und gut. Das habe ich nie in Frage gestellt. Nur diese Sicht, die viele begleitet und meint: Freundschaften sind für immer, egal, was ist. Das ist nicht egal. Auch Freundschaften können sich verändern, vermischen, Freundschaften sind Liebe und deswegen manchmal auch genauso kompliziert. Und eben auch manchmal einfach unwiederbringlich vorbei.</p>\n<p><strong>Hast du einen Lieblingssatz in deinem Buch und verrätst du ihn uns?</strong></p>\n<p>Die Panik schlägt sich mit einer Axt durch den Sand, bis sie trifft.</p>\n<p><strong>Ist es gut in deinen Roman zu investieren und sich beim Lesen zu fühlen?</strong></p>\n<p>Meine Bücher machen einen auf unaufhaltsamen Staubsaugerroboter im Wohnzimmer deines emotionalen Haushalts. Wer da Bock drauf hat und keine Verfolgungsjagden oder zehn Witze auf einer Seite erwartet, könnte ganz gut bedient sein.</p>\n<p><strong>Verrätst du uns zum Schluss noch dein Lieblingskatzenvideo auf YouTube?</strong></p>\n<p>Es gibt eine Katze, die sich auf einem Staubsaugerroboter herumfahren lässt, damit kann ich mich sehr gut identifizieren.</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/xE8kyQOwoGU\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Lisa Rank feiert am <a href=\"https://www.facebook.com/events/141770352661625/\">“18.04.2013 die Buchpremiere”</a> von <a href=\"http://www.amazon.de/Bist-du-noch-wach-Roman/dp/3827010950\">“Bist du noch wach?”</a> du schon im <a href=\"http://www.kaufdichgluecklich-shop.de/\">“Kauf Dich Glücklich”</a> in Berlin.</p>\n"}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

	module.exports = {"title":"Listen sind das neue Schwarz","date":"2014-05-15 16:49:03 +0000","tags":null,"layout":"post","body":"<img src=\"http://ecx.images-amazon.com/images/I/51XnrHdM6%2BL.jpg\">\n<p>Mein lieber Freund Peter hat ein Buch geschrieben, nein vielmehr hat er ein Buch mit Listen gefüllt. Der Peter hat es halt einfach mit den Listen, nicht nur regelmäßig für INTRO <a href=\"http://www.intro.de/news/newsfeatures/23073358/auslisten-zehn-saetze-die-man-2013-nicht-gehoert-hat\">INTRO</a>, sondern auch auf <a href=\"https://twitter.com/diktator\">Twitter</a> und vielleicht auch zu ganz alltäglichen Dingen wie Einkaufen, aber das bleibt wohl vorerst das Geheimnis des Sakko tragenden Tausendsassas. Ich hatte zu diesem Anlass zwei Fragen an Peter, die er stilsicher in Listenform beantwortet hat.</p>\n<p><strong>Warum sollte man das Buch kaufen?</strong></p>\n<h1>3. 50 Prozent der Erlöse gehen an die Stiftung Peter Wittkamp rettet bedrohte Tierarten.</h1>\n<h1>2. Weitere 50 Prozent der Erlöse gehen an die Stiftung Peter Wittkamp gegen rechts.</h1>\n<h1>1. Zufällig neun Euro gefunden und nicht interessiert an drei schönen, großen Bieren in der nächsten Kneipe.</h1>\n<p><strong>Warum sollte man das Buch nicht kaufen?</strong></p>\n<h1>3. Tiere sind dir egal!</h1>\n<h1>2. Nazis auch.</h1>\n<h1>1. Zufällig neun Euro gefunden und sehr interessiert an drei schönen, großen Bieren in der nächsten Kneipe.</h1>\n<p>Natürlich hat der charmante Peter noch eine selbsterdachte Bonusfrage ausgefuchst:\n<strong>Was man über Ada Blitzkrieg eher selten sagt.</strong></p>\n<h1>3. Untalentiert.</h1>\n<h1>2. Hat deutlich zu wenig Hobbys.</h1>\n<h1>1. Man liest in letzter Zeit so wenig von ihr</h1>\n<img src=\"http://www.kiwi-verlag.de/blog/wp-content/uploads/2013/12/Peter-Wittkamp.jpg\">\n<p>Und hier findet Ihr der Link zum seinem aktuellen Buch <a href=\"http://amzn.to/QHrjyr\">Die fünf schlechtesten Antworten auf “Ich liebe dich!”</a>, das heute bei KiWi Verlag erscheint und schon morgen bei Euch sein könnte.</p>\n"}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

	module.exports = {"title":"Lokalradiomoderatoren beim Bundesvisíon Songcontest","date":"2011-09-30 16:06:27 +0000","tags":null,"layout":"post","body":"<p>\n\tWas war das gestern für ein aufregender <a href=\"http://de.wikipedia.org/wiki/Bundesvision_Song_Contest\">Bundesvision Songcontest</a>! Viele nackte Menschen in Glitzerkostümen und mit unmöglichen Hochsteckfrisuren, angespeckte Altkünstler und die gestählerten Jungmännerkörper der Musikformation&nbsp;<a href=\"http://soundcloud.com/kraftklub\">Kraftklub</a>, die mir musikalisch ein bisschen den Abend gerettet haben.</p>\n<p>\n\tTrotzt akuter Fieberschübe aufgrund meiner Magen-Darm-Grippe wollte sich beim Anschauen der Show keine futuristisch erfolgreiche Vision der Popszene einstellen. Stattdessen wappnete ich mich innerlich um aufrichtig von der Popmusikszene enttäuscht zu werden und das wurde ich auch.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tFür mich aber wie jedes Jahr ein Quell unerschöpflicher Freude: Die schlechten Liveschaltungen zu Lokalradiomoderatoren. Für Euch habe ich mich mit einem kleinen Team aus magendarmkranken TV-Spezialisten an die Analyse der jeweiligen Punktevergabenteams aller Bundesländer gewagt und möchte Euch auf eine unschöne Deutschlandsafari mitnehmen, auf der Ihr Euch noch wünschen werdet, Ihr hättet nur den Broder vorliegen und nicht Textkrieg.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"408\" src=\"/files/tn_1 meckpomm.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDie meisten Sachen sind im Nachhinein nicht mehr so witzig, wie sie im Suff noch erschienen. Wie das Abhängen mit deiner Mutter oder dem Zwergkaninchen einen Brötchenhut aufsetzen. Heute befeuert dieser Screenshot eines Lokalradiomoderatoren-Teams aus dem merkwürdigen Bundesland Mecklenburg-Vorpommern meinen Humormotor nicht mehr ausreichend um die fünf Meter Richtung Minibar zurückzulegen.</p>\n<p>\n\tDiese Zusammenkunft in einer Großraumdiskothek mit dem gefühlten Namen &quot;Planet Joy&quot; sieht im Grunde aus wie Viva Interaktiv, bloß dass keiner der Moderatoren ein Neger ist, denn man ist hier in Mecklenburg-Vorpommern.</p>\n<p>\n\t2/10 Punkte, davon einer aus Mitleid für die Kassierin, die nahzu jedem Käufer der einheitlich bedruckten T-Shirts Rohlinge dazu raten musste doch eine Nummer größer zu wählen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"409\" src=\"/files/tn_2 sachsen anhalt.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIn Sachsen-Anhalt arbeiten offensichtlich alle bei KiK, was schön ist, denn von einer Firma mit einem derart zweifelhaften Ruf erwartet auch niemand mehr etwas anderes, als auf den ersten Blick unschuldige Schilder, die auf das Anagram &quot;Für immer Führer!&quot; verweisen.</p>\n<p>\n\tDie gefühlte Fernfahrernation Sachsen-Anhalt versucht durch Wurstplatten und Käsearrangements Wohlstand zu symbolisieren, was beim Zuschauer sympathisch und authentisch rüberkommt. Extrapunkte gibt es hier übrigens für die Dame rechts, die unbeeindruckt von aktuellen Modetrends weiße Leggings aufträgt. Auf die Frage &quot;Was ist zu weißen Leggings zu sagen?&quot; antwortetet man mir im Bewertungsteam kalt &quot;Müsste ich sehen!&quot;. Mehr ist dazu nicht zu sagen.</p>\n<p>\n\t7/10 Punkten, weil Wurst mag man.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"408\" src=\"/files/tn_3 schleswig.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tSchleswig Holstein lässt sich nicht auf den Lokalpatriotismus der anderen Bundesländeridioten ein. Diese gut gelaunte LSD Runde hat besseres zu tun als sich selber für durchsichtige Ländergrenzen zu feiern. Volle Freude wirft die Frau, die rechts neben dem Moderator steht während der gesamten Punktevergabe die Hände in die Luft, jubelt, klatscht und es ist leider nicht gespielt.</p>\n<p>\n\tDafür gibt es 6/10 Punkten.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/tn_4 branden.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tSo oder so ähnlich stelle ich mir einen FDP-Porno vor. Verwunderlich ist auch, dass Brandenburg das einzige Bundesland ist, dessen Lokalradiomoderatoren nicht aussehen wie Brandenburger Lokalradiomoderatoren.</p>\n<p>\n\t4/10 Punkten dafür, weil ich mir viel zu sicher bin, die beiden Damen bald in den Sexy Sportclips zu sehen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"409\" src=\"/files/tn_5 baden würt.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tHat denn Baden-Württemberg überhaupt noch einen Grund zu feiern? Ist ewa noch Konfetti von der Stuttgart 21 Party übriggeblieben? Und wieso droht der Mann links unten uns?</p>\n<p>\n\tAn diesen Handschuhen bin ich schon mal erstickt. Für mich das bedrohlichste Szenario der Liveschaltungen, neben dem angsteinflößenden Mensch aus Bayern.</p>\n<p>\n\tBaden-Württemberg, das Land der Unterbisse punktet mit 7/10.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/tn_6 saarland.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIm Saarland winkt man noch fröhlich mit Baguette und spielt unbedarft mit dem ätzenden Stereotypen des kohlehydrategeilen Froschfressers. Diese Vereinfachung ist in keinster Weise angebracht oder annäherend witzig. Auch die aufblasbare Gummiwurst kann nicht darüber hinwegtäuschen, dass die meisten Zuschauer über dumpfen Humor wie diesen tatsächlich lachen müssen. Der Mario Barth unter den Bundesländern.</p>\n<p>\n\t3/10 Punkten.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/tn_7 bayern.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIn Bayern kam die Liveschaltung gefühlt direkt aus dem DRK Zelt des Oktoberfestes. Für mich der unheimlichste Mensch des Abends: Steht links im Bild und überlegt sich in Ruhe, wem er als erstes mit einem zerbrochenen Glas die Kehle aufschlitzen soll. Auf der Pro Sieben Seite, auf der es den Stream zu sehen gibt, hat er auch gleich kommentiert &quot;Man sieht mich links im Bild.&quot; und dieser teilnahmslose Kommentar macht mir im Grunde noch mehr Angst. Verschließt also bitte Eure Türen. Wer bist du, böser Mann?&nbsp;</p>\n<p>\n\t9/10 Punkten für den geheimnisvollen Fremden, der viele Psychologenherzen höher schlagen lässt.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/tn_8 thürigen.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIn Thürigen feiert man noch stilecht mit Duff-Bier, Twilightpostern und Polohemden vor einem großen freischwebendem Gogo-Tänzerinnen-Käfig in der Lokaldiskothek &quot;Clubeins&quot;.</p>\n<p>\n\t8/10 Punkten für sympathisches Understatement und die ständig psychisch anwesende gefühlte Wurstplatte.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/tn_9 niedersachsen.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDa kündigt der Morgenhans doch glatt in Niedersachen den Co-Moderator Mike Leon Grosch an, der schamlos eine beige Hose trägt, die seine Genitalien auf die Art und Weise betont, dass man später nicht mehr weiß, ob es Penismasse oder voluminöser Hoden ist.</p>\n<p>\n\tDie Menschen in Niedersachen halten zum größen Teil Plakate vor ihre Gesichter. Aus gutem Grund.</p>\n<p>\n\t7/10 Punkten. Davon alleine 7 Punkte, weil der Morgenhans eine Kappe mit Schirm nach vorne trägt. Ist das überhaupt der Morgenhans?</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/tn_10 hessen.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tHessen hat mich durch und durch gelangweilt. Die am wenigstens peinliche Moderation, kein übergewichtiger Lokalradiomoderator. Hier könnten ein paar Baguettes Wunder wirken.</p>\n<p>\n\tIch gebe nur 1/10 Punkten, weil nicht mal das Publikum aussieht wie aus Brandenburg.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/tn_11 hamburg.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tHamburg meldet sich dann mit einer Frau zu Wort, die definitiv zu schön fürs Radio ist. Daher nur 1/10 Punkten. Zu wenig Trash und zu wenig Engleisungen der Suffmimik. Langweilig durch und durch.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/tn_12 rheinland.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tRheinland-Pfalz, das Bundesland aus dem ich stamme, begeisterte durch ein unglaublich merkwürdiges Outfit der Quality-Time Moderatorin. Bauchfrei, aber mit transparentem grauen Stoff verhangene Bauchmasse und ein Ausschnitt dazu, der die Brüste und den gesamten Oberkörper unmöglich surreal verformt. Ansonsten sind alle gut gelaunt und das möchte man auch zeigen. Ich beschliesse eine kurze Pause zu machen und türkisches Gebäck im Späti zu kaufen, wo die meistens Menschen noch aufrichtig schlecht gelaunt sind.</p>\n<p>\n\t2/10</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/tn_13 bremen.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIn Bremen hat man dann kurzerhand die Liveschaltung mit dem Casting der Bewerberinnen für &quot;Schwiegertochter Gesucht&quot; zusammengelegt.&nbsp;</p>\n<p>\n\tDafür 8/10 Punkte.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/tn_14 berlin.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIn Berlin finden wir dann endlich den Grund, warum in der Brandenburger Liveschaltung kein einziger authentisch wirkender Brandenburger zu sehen war: Die waren alle in Berlin.</p>\n<p>\n\tWenn du dem Brandenburger wirklich weh tun willst, dann zünde ein paar Tattoostudios an.</p>\n<p>\n\tBerlin nervt mich an. Erst mit dem diesjährigen Gewinner des Bundesvision Songcontest, dessen Namen ich schon wieder vergessen haben, der aber so aussieht als hätte ihn deine Mutter auf dem Blackboard entworfen&acute;und dann vergessen ihn mit Testosteron auszustatten, dann die unglaublich langweiligen und auf jung getrimmten Moderatoren.</p>\n<p>\n\t3/10 Punkten.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/tn_15 NRW.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tNordrhein-Westfalen tut mir leid, denn jemand der zu einem Glitzeranzug greift, muss es echt nötig haben. Sorry Ingo Appelt, aber das war nichts!</p>\n<p>\n\t4/10</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/tn_16 sachsen.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tMan sagt mir, dass ich Prozente bekomme, wenn ich die <a href=\"http://www.realdoll.com/\">Realdoll</a>&nbsp;an der linken Seite mit authentisch und gutaussehend beschreibe.</p>\n<p>\n\t6/10 Punkten.</p>\n"}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mal ganz unter uns: Rezeptlieblinge","date":"2015-05-29 09:25:46 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://31.media.tumblr.com/704c1c9deacfa599b9c0cc5612e75704/tumblr_inline_mu6jx2dOC71qanxkz.jpg\" alt=\"alt\"></p>\n<p>Ich koche bekanntlich überdurchschnittlich viel und vermutlich auch besonders intensiv. Natürlich sabbern daher einige Leute über meinen Fotos bei Instagram und fragen mich immer wieder nach Rezepten und Tipps. Nun ist es aber so, dass ich den Anfragen leider bei der hohen Menge an Nachrichten und Kommentaren nicht gerecht werden kann. Aus zeitlichen Gründen und aus fehlender Motivation. Und weil ich nicht verrückt bin, vielleicht. Deswegen.</p>\n<p>Die meisten Rezepte sind zudem bereits von mir derart adaptiert und folgen bei der Zubereitung keinem starrem Rezeptplan. Daher habe ich für diesen Post meinen Lieblinge ausgewählt, die mir hier regelmäßig die Abende versüßen und die Anleitungen dazu verlinkt. Nennen wir es einfach die <strong>“Classic Ada Eats”</strong> Sammlung.</p>\n<p>Dann also mal los in den Supermarkt, auf die Wochenmärkte oder in den Garten von Oma Gisela um Hackfleisch zu ernten oder einen Kürbis zu schlachten! Verlinkt mich außerdem gerne mit meinem Instagramaccount <a href=\"https://instagram.com/bangpowwww/\">@bangpowwww</a> unter euren Ergebnissen. Ich bin gespannt!</p>\n<h1>Best Basic Hummus</h1>\n<p><img src=\"/content/images/2015/May/1hummus.jpg\" alt=\"alt\"></p>\n<blockquote>\n<p>Hummus is proof that some of the best tasting things in life are the simplest to make. It can be rustled up with just six ingredients and requires no cooking – only a food processor. The hummus recipe below will give you perfect basic hummus, and also a solid base from which to work in terms of experimenting with flavours.</p>\n</blockquote>\n<p>Mein favorisiertes <a href=\"http://www.jamieoliver.com/news-and-features/features/best-basic-hummus-recipe/#C3p6dEsL73LAoFus.97\">Hummus Rezept</a> dauert keine 10 Minuten und gilt daher als resistent gegen Faulheit und Pizzabestellanfälle.\n<img src=\"http://www.jamieoliver.com/news-and-features/features/wp-content/uploads/sites/2/2014/08/feature-header15.jpg\" alt=\"alt\"></p>\n<h1>Roberta’s Pizza Dough and Lucky Peach Barbecue Chicken Pizza</h1>\n<p><img src=\"https://s-media-cache-ak0.pinimg.com/736x/a0/80/d3/a080d38bb1e9793068f1ff1d961890c7.jpg\" alt=\"alt\"></p>\n<blockquote>\n<p>This recipe, adapted from <a href=\"http://www.robertaspizza.com/\">Roberta’s</a>, the pizza and hipster haute-cuisine utopia in Bushwick, Brooklyn, provides a delicate, extraordinarily flavorful dough that will last in the refrigerator for up to a week.</p>\n</blockquote>\n<p><a href=\"http://cooking.nytimes.com/recipes/1016230-robertas-pizza-dough\">Roberta’s Dough</a> ist ziemlich idiotensicher und gelingt auch, wenn man keinen Pizzastein oder andere Absurditäten wie einen Holzkohleofen zur Hand hat.</p>\n<p><img src=\"/content/images/2015/May/1bbqpizza.jpg\" alt=\"alt\"></p>\n<blockquote>\n<p>If you came of high-school age in Southern California in or after the nineties and spent any time in shopping malls, chances are you celebrated a birthday or driver’s license over barbecue-chicken pizza from California Pizza Kitchen (CPK).</p>\n</blockquote>\n<p>Mit einer handfesten Menge Knoblauch und Thaikoriander schmeckt die <a href=\"http://luckypeach.com/recipes/barbecue-chicken-pizza/\">Barbecue Pizza</a> übrigens noch überwältigender.</p>\n<p><img src=\"http://luckypeach.com/wp-content/uploads/2014/12/BBQChickenPizza.jpg\" alt=\"alt\"></p>\n<h1>Bibimbap</h1>\n<p><img src=\"/content/images/2015/May/1kimbap.jpg\" alt=\"alt\"></p>\n<blockquote>\n<p>Bibimbap(비빔밥) which means “mixed rice” is a healthy and hearty everyday dish that consists of steamed rice, vegetables and meat. And before the rice is placed in the bowl, the bottom of the bowl is coated with sesame oil making the layer of the rice forms a crispy crust at the bottom(a bit similar to our Asian Claypot Rice) while the dish is often serve with a dollop of gochujang.</p>\n</blockquote>\n<p>Für mein <a href=\"http://www.ellenaguan.com/2012/05/bibimbap.html?m=1\">Lieblings-Bibimbap</a>nutze ich übrigens das abgepackte Kimchi aus dem <a href=\"https://de.foursquare.com/v/hao-cai-lei-asiensupermarkt/4d122c511f95236ae00e3c06\">Hao Cai Lei Asia Markt</a> in Neukölln.</p>\n<h1>Black Sesame Seed Butter</h1>\n<p><img src=\"/content/images/2015/May/1blackses.jpg\" alt=\"alt\"></p>\n<blockquote>\n<p>There are few constants in my kitchen, but one of them might be the high probability that there is a semi-full can of tahini hiding out at the back of the fridge on any given evening. Its precise origin and month of purchase are murky. I’m sure I thought about inking the date on the lid when I first open it, but I didn’t.</p>\n</blockquote>\n<p><a href=\"http://www.seriouseats.com/2013/02/diy-how-to-make-black-tahini.html\">Back Tahini</a> schmeckt übrigens hervorragend auf einem Bagel mit angebratenem Bacon und Peanut Butter.</p>\n<h1>Kimchi Fries</h1>\n<p><img src=\"http://31.media.tumblr.com/704c1c9deacfa599b9c0cc5612e75704/tumblr_inline_mu6jx2dOC71qanxkz.jpg\" alt=\"alt\">\nAls ich das erste Mal in San Francisco <a href=\"http://peegaw.tumblr.com/post/63149217074/making-kimchi-fries\">Kimchi Fries</a> gegessen habe, hat es mir glatt die Sprache verschlagen. Ich war total perplex, weil dieses Gericht so ziemlich alles vereint, was ich liebe: Bulgogi Beef, Sour Cream, Kimchi, Garlic, Siracha, Fries, Mayonnaise, Fett, Fett und noch mehr Fett. Cheddar, Cheddar, Cheddar. Und Soja. Sesam. Und Zwiebeln. Wer will da schon Nein sagen?</p>\n<p><img src=\"/content/images/2015/May/1kimchifries.jpg\" alt=\"Kimchi Fries\"></p>\n<h1>Shakshuka</h1>\n<p><img src=\"/content/images/2015/May/1shasuka.jpg\" alt=\"alt\"></p>\n<blockquote>\n<p>When I say the word shakshuka, people often give me a strange look… like I’ve sneezed, or something. I get excited when I see that look– it means they don’t know what the heck shakshuka is, which means they have no idea what they’re missing out on. If you aren’t familiar with shakshuka, I’m thrilled to introduce the concept to you! It’s one of my favorite dishes—a simple, go-to meal that works as a breakfast, lunch, or dinner (“brinner” might be the more appropriate word, since eggs are the star of the dish). I always have the ingredients for shakshuka on hand, and it never fails to make people say “yum!”</p>\n</blockquote>\n<p>Sonntag ist im Blitzkrieg HQ <a href=\"http://toriavey.com/toris-kitchen/2010/07/summer-2010-travel-blog-shakshuka/\">Shakshuka</a> Tag!</p>\n<p><img src=\"http://toriavey.com/images/2010/07/Shakshuka-Side-View-2-640x480.jpg\" alt=\"alt\"></p>\n<blockquote>\n<p>In Israel shakshuka is often eaten for breakfast, but I usually find myself serving it with a side salad as a light evening meal. It’s super easy and versatile. When my hubby was in the Israeli army, he and the other soldiers would sneak into the barracks kitchen late at night and cook shakshuka using whatever they could find in the pantries. It’s a vegetarian one-skillet meal that is easy to make, very healthy, and totally addicting.</p>\n</blockquote>\n<h1>Homemade Burger</h1>\n<p><img src=\"/content/images/2015/May/1burger.jpg\" alt=\"alt\"></p>\n<blockquote>\n<p>Finding high-quality hamburger meat at the market is a lot easier than it used to be, but the same cannot be said for the buns. They’re never the right dimensions for a decent sized patty; and they’re either made from some insipid white sponge with seventy-three ingredients, or from high-fiber, whole grains, which in many ways is even worse.</p>\n</blockquote>\n<p>Gut, dass es dieses Rezept für butterweiche <a href=\"http://foodwishes.blogspot.de/2013/07/homemade-hamburger-buns-oh-my-god-becky.html\">Supersoft Burger Buns</a> gibt. Zu meinen Burger ist ansonsten wenig zu sagen, weil ich Minimalist bin. Ich benutze Rinderhackfleisch aus dem türkischen Supermarkt, weil ich dort welches mit einem höheren Fettanteil bekomme, was wesentlich besser schmeckt und beim Braten nicht einschrumpelt. Eine Burgersauce nutze ich ebenfalls nicht, sondern nur einen guten Cheddar, Senf, Ketchup, karamellisierte Zwiebeln, Pickles und Jalapenos. Das weiche Burgerbrötchen und das gute, fettige Fleisch arbeiten geschmacklich schon gut für sich selbst.</p>\n<blockquote>\n<p>A proper bun should be nothing more than a light, buttery, airy delivery system for getting a hot, juicy hamburger into your mouth. Oats, spelt, and flax seeds have no business getting anywhere near this type of operation. That’s what turkey sandwiches are for.</p>\n</blockquote>\n<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/ace-TXcX6GY\" frameborder=\"0\" allowfullscreen></iframe>\n"}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	module.exports = {"title":"Marathonmann","date":"2011-07-14 15:28:39 +0000","tags":null,"layout":"post","body":"<p>\n\tDer Prinz von Berlin , <a href=\"http://prinzpi.biz/\">Prinz Pi</a>, betätigte sich jüngst als Herausgeber des Marathonmanns, einem Magazin für Laufkultur, das in limitierter Auflage nur an Freunde und Förderer verschickt wurde. Das Magazin riecht nicht nur gut, sondern erklärt Euch einfach alles rund ums Laufen und Posen und ist vollgepackt mit schönen Menschen und Hundewitzen.</p>\n<p>\n\tIn der Ausgabe 23. Oktober 1979 finden sich brilliante Farbfotografien, der Lauf-Guide, Pornostellungen von E-Rich und die besten Laufstrecken Berlins.&nbsp;</p>\n<p>\n\tDas Magazin ist eine Zusammenarbeit von Friedrich Kautz (Prinz Pi), seinem Kreativpartner Wassif, dem Rapper <a href=\"http://www.juice.de/juice-tv/achse-des-schonen-episode-1\">Kamp</a> und natürlich von Ada Blitzkrieg.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch verschenke 20 Exemplare der limitierten und dem Pöbel nicht zugänglichen Liebhaberzeitung. Eine Kleinigkeit müsst Ihr dafür aber machen: </p>\n<p>\n\tEinen Tweet oder ein Statusupdate bei Facebook mit einem Link zu meinem Blog (www.textkrieg.de/blog) posten, ganz viel Liebe reinpacken und mir den Link zum Tweet oder Eurer Facebookseite an kontakt@textkrieg.de senden.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/marathonmann2.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/marathonmann1.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"372\" src=\"/files/marathonmann3.jpg\" width=\"500\" /></p>\n"}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mein neues Buch ist erschienen: Die Strenge","date":"2013-09-26 15:19:09 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/strenge1.jpg\" alt=\"strenge1.jpg\" />\n<p>Endlich steht mal wieder ein großartiges Release meiner Texte vor der Tür und dieses Mal ist es ein hübsches Projekt bei dem tollen Verlag (<a href=\"http://www.sukultur.de/\">SuKultur</a>) geworden, der meine Geschichte ab sofort als <a href=\"http://www.sukultur.de/die-strenge-211.html\">eBook</a>, als <a href=\"http://www.sukultur.de/die-strenge.html\">Leseheftchen</a> über den Onlineshop oder als <a href=\"http://www.sukultur.de/\">Automatenkauf</a> in Vending Machines an unterschiedlichen Standorten verkauft. Oder Ihr gewinnt einfach eines von zehn Exemplaren am Ende des Blogposts. Wieso nicht?</p>\n<p><a href=\"http://www.sukultur.de/die-strenge.html\">“<strong>Die Strenge</strong>”</a>, so lautet der Titel des Werkes, ist ein ganz besonderes Stück Blitzkrieg geworden, dass sich im Regal äußerst gut neben “Dem Mann ohne Eigenschaften” und einer Flasche Sliwowitz machen kann, wenn man es denn nur lässt.</p>\n<h1>Textauszug:</h1>\n<p><strong>“Für den Fall, dass Herr K. nun nicht tot auf dem weißen Vinyl seines Arbeitstraumes liegen würde, hätte die Histamin-Konzentration in seinem Blut in den folgenden Stunden unwiderruflich zu starken und schmerzhaften Blähungen geführt. Nun aber, da er eben tot ist, wird sein sportlicher Leichnam in dreißig Minuten von der netten Thea aus der Buchhaltung entdeckt werden, die aus Gewohnheit verschämt auf den Boden schaut. Dort wird heute allerdings ihr inzwischen ehemaliger Chef liegen und tot zu sein scheinen. Sie wird ihn kurz betrachten und die Mappe mit den Recruitment-Unterlagen auf dem rechten der beiden kniehohen Leuchtbuchstaben ablegen, der laut Company Philosophie für F wie FUTURE steht, eigentlich aber aus dem Fundus einer geschlossenen FDP Zentrale stammt.”</strong></p>\n<img src=\"/content/images/strenge2.jpg\" alt=\"strenge2.jpg\" />\n<iframe width=\"400\" height=\"315\" src=\"//www.youtube.com/embed/CMylGxfeG2E\" frameborder=\"0\" allowfullscreen></iframe>\n<h1>Über SuKultur:</h1>\n<p><strong>The SuKuLTuR Publishing Company sells small books called “Schöner Lesen” for one euro in vending machines since 2004. Most vending machines selling “Schöner Lesen” you can find in Berlin, but also in other parts of Germany. With over 75.000 books sold so far, “Schöner Lesen” is a great success. The first books-only vending machine was established in June 2006 on the island Sylt.</strong></p>\n<p>Mehr über den Verlag und die Automaten könnt Ihr <a href=\"http://www.sukultur.de/\">HIER</a> erfahren. Die Automaten findet Ihr an den folgenden Standorten. Gründet also Banden, zieht Euch Strumpfhosen über die Gesichter und holt Euch meinen Text:</p>\n<h2>Automaten:</h2>\n<h3>Berlin</h3>\n<ul>\n<li>S-Bhf. Gesundbrunnen</li>\n<li>S-Bhf. Potsdamer Platz</li>\n<li>S-Bhf. Zoologischer Garten</li>\n<li>S-Bhf. Schöneberg</li>\n<li>S-Bhf. Tempelhof</li>\n<li>S-Bhf. Rathaus Steglitz</li>\n</ul>\n<h3>Rantum/Sylt</h3>\n<ul>\n<li>Raum Sylt-Quelle, Hafenstraße 1, 25980 Rantum/Sylt</li>\n</ul>\n<h2>Buchhandlungen mit umfangreichen Leseheft-Sortiment:</h2>\n<h3>Berlin</h3>\n<ul>\n<li>Neurotitan, Rosenthaler Str. 39, 10178 Berlin</li>\n<li>Buchladen zur schwankenden Weltkugel, Kastanienallee 85, 10435 Berlin</li>\n<li>Das besondere Buch, Göhrener Str. 2, 10437 Berlin</li>\n<li>Lettrétage  Das junge Literaturhaus, Methfesselstraße 23-25, 10965 Berlin</li>\n</ul>\n<h3>Köln</h3>\n<ul>\n<li>Buchhandlung Klaus Bittner, Albertusstr. 6, 50667 Köln</li>\n</ul>\n<h3>Leipzig</h3>\n<ul>\n<li>Lehmanns Media GmbH, Grimmaische Str. 10, 04109 Leipzig</li>\n<li>Kurt-Wolff-Buchdepot in der Galerie ERATA, Brockhausstr. 56, 04229 Leipzig</li>\n</ul>\n<h1>Gewinne ein Exemplar:</h1>\n<p>Schick mir einfach ein Foto von Dir auf dem Du besonders streng guckst. Die Gewinner werden im Blog veröffentlicht und erhalten ein Exemplat von “Die Strenge”, in dem ich ein paar freundschaftliche Grußworte schreibe und meine Hosengröße verrate. Die Fotos solltet Ihr bitte per Twitter als Reply an mich richten (<a href=\"https://twitter.com/bangpowwww/\">@bangpowwww</a>).</p>\n"}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mein zweiter Roman - Verlage vor!","date":"2014-03-14 14:32:14 +0000","tags":null,"layout":"post","body":"<img src='http://media-cache-ak0.pinimg.com/736x/1d/60/3f/1d603f7eaa996fcc81c663477b71c2c8.jpg' alt=''>\n<p>Hurra, es ist vollbracht. Fakt ist: Das Exposé zu meinem zweiten Buch ist nun fertig. Verlage können sich gerne bei mir per Mail melden und das Exposé anfragen.</p>\n<p>Es dürfte ja allgemein kein großes Geheimnis mehr sein, dass ich derzeit an meinem zweiten Roman arbeite und mich wie auch beim ersten Mal mit der Frage eines möglichen Verlags rumquäle. Ich möchte einfach das Beste für den Leser bieten. Anbieten und Gespräche führen, das möchte ich auf jeden Fall. Print oder Ebook. Wir werden sehen. Ich bin offen für Ideen und Anfragen.</p>\n<p>Mein erster Roman <a href=\"http://textkrieg.de/pages/dackelkrieg\">Dackelkrieg</a> wurde von Euch überraschend gut angenommen und so hoffe ich auch für den zweiten Roman einen geeigneten Rahmen zu finden um der Nachfrage gerecht zu werden.</p>\n"}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	module.exports = {"title":"Meine Leistungen als Freiberuflerin","date":"2013-04-09 00:00:00 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/IMG_8999_4.JPG\" alt=\"IMG_8999_4.JPG\" />\n<p>Es freut mich nach Veröffentlichung meines Romans <a href=\"http://textkrieg.de/pages/dackelkrieg\">Dackelkrieg</a> nun endlich wieder freie Kapazitäten für meinen eigentlichen Job anbieten zu können.</p>\n<p>Ab dieser Woche wird wieder fleißig im Blitzkrieg HQ zu den üblichen Officezeiten (10:00-19:00) an interessanten Projekten gearbeitet. Zum einen geht in diesem Monat meine neue Kolumne für das <a href=\"http://www.intro.de/\">INTRO Magazin</a> in den Druck und wird ab sofort monatlich erscheinen, und zum anderen gibt es jetzt endlich einen bessern Überblick über meine Tätigkeiten und Dienstleistungen, denn ich habe meine Xing und linkedin Profile aktualisiert. Ihr könnt Euch dort informieren zu welchen Aufträgen Ihr mich buchen könnt oder mir eine Festanstellung in Eurer Agentur oder Eurem Unternehmen schmackhaft machen.</p>\n<p><a href=\"https://www.xing.com/profile/Clara_Hitzel\">Ada bei XING</a></p>\n<p><a href=\"http://www.linkedin.com/in/adablitzkrieg\">Ada bei linkedin</a></p>\n<p>Außerdem erreicht Ihr mich wie immer per <a href=\"http://textkrieg.de/pages/kontakt\">Mail</a></p>\n"}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

	module.exports = {"title":"Menschen: Carmen","date":"2011-09-13 14:57:55 +0000","tags":null,"layout":"post","body":"<p>\n\t&nbsp;</p>\n<p style=\"font-style: normal; widows: 2; orphans: 2; \">\n\t<font color=\"#222222\"><font face=\"Arial, Verdana, sans-serif\"><font size=\"2\" style=\"font-size: 9pt\"><span style=\"background: #ffffff\">Carmen ist Lehrerin. Im Referendariat. Sie hatte sich damals entschieden. Ein Beruf mit Zukunft? Ja, und dabei mit jungen Menschen was machen, das ist Carmens Ding. Die kann man ja nicht einfach so auf der Straße sitzen lassen. Zusatzausbildungen. Kurse über kreatives Schreiben. Mein Job ist meine Welt, sagt Carmen und lacht. Hahahaha statt Hihihi, denn sie ist keine von &quot;diesen Mädchen&quot;. Carmen kommt durch ihren Charakter immer gut an. Bodenständig und sozial. Das kommt vom Aufwachsen in einer Großfamilie, sagt sie und zwinkert ihrem Freund zu. Der ist Einzelkind, aber das ist nicht schlimm, denn sie ergänzen sich super.</span></font></font></font></p>\n<p style=\"widows: 2; orphans: 2\">\n\t<br />\n\t&nbsp;</p>\n<p style=\"font-style: normal; widows: 2; orphans: 2; \">\n\t<font color=\"#222222\"><font face=\"Arial, Verdana, sans-serif\"><font size=\"2\" style=\"font-size: 9pt\"><span style=\"background: #ffffff\">Carmen mag Musik und Parties. Es gibt mehr im Leben als ihre Arbeit, sagt sie. Und trotzdem hat sie das letzte Jahr kein einziges Mal gefehlt. Was muss das muss. Zu ihren Geschwistern hat sie ein gutes Verhältnis. Ihr Bruder ist Künstler und macht Holzschmuck, den sie total süß, aber etwas gewagt findet. Sie erzählt gerne von ihren Urlauben. Denn das Leben ist mehr als daheim rumsitzen, sagt sie, wenn die Mädelsrunde sich bei ihr trifft um amerikanische Serien zu gucken. In Originalsprache, sonst geht da so viel verloren. &nbsp;Nach dem zweiten Glas Weißwein erzählt sie dann gerne, wie sie mal auf der Frankreichexkursion im Studium einen Franzosen geküsst hat. Aber jetzt hat sie ja Henning.&nbsp;</span></font></font></font></p>\n<p style=\"widows: 2; orphans: 2\">\n\t<br />\n\t&nbsp;</p>\n<p style=\"font-style: normal; widows: 2; orphans: 2; \">\n\t<font color=\"#222222\"><font face=\"Arial, Verdana, sans-serif\"><font size=\"2\" style=\"font-size: 9pt\"><span style=\"background: #ffffff\">Carmen ist in jeder Gruppe unverzichtbar. Das macht sie einzigartig. Sie opfert sich gerne auf und sieht wo Not am Mann ist. Ob jemand etwas mitgebracht haben möchte, sie geht nun einkaufen. Carmen würde am liebsten in einer WG wohnen, aber das geht nicht, denn ihr Freund und sie sind nunmal zusammen und was besseres hätte ihr nicht passieren können. Henning. Zeit zu zweit ist wichtig. Gemeinsam einen guten Film gucken, schön etwas Ausgefallenes kochen. Auch gerne ab und zu etwas Ungesundes, lacht sie, aber nur manchmal.&nbsp;</span></font></font></font></p>\n<p style=\"widows: 2; orphans: 2\">\n\t<br />\n\t&nbsp;</p>\n<p style=\"font-style: normal; widows: 2; orphans: 2; \">\n\t<font color=\"#222222\"><font face=\"Arial, Verdana, sans-serif\"><font size=\"2\" style=\"font-size: 9pt\"><span style=\"background: #ffffff\">Carmen hat hellbraune Haare, sie hatte auch mal Strähnen und einen Pony, aber sie ist stolz auf ihre Naturlocken und ihre Augen wechseln bei Lichteinfall die Farben. Ihre Eltern hätten manchmal gewitzelt sie sei adoptiert, raunt sie verschwörerisch, denn sie ist sicher, dass sie es nicht ist, denn die Familie verbindet so viel. Alle vier Wochen geht es heim. Das ist selten. Aber Henning kommt ja mit, denn der gehört irgendwie auch zur Familie, sagt sie stolz. Etwas besonderes ist sie schon, denn sie macht etwas aus ihrem Leben und ist dabei immer für andere da. Denn sonst, so sagt sie, kann sie selber nicht glücklich sein.</span></font></font></font></p>\n<p style=\"widows: 2; orphans: 2\">\n\t<br />\n\t&nbsp;</p>\n<p style=\"font-style: normal; widows: 2; orphans: 2; \">\n\t<font color=\"#222222\"><font face=\"Arial, Verdana, sans-serif\"><font size=\"2\" style=\"font-size: 9pt\"><span style=\"background: #ffffff\">Ihr Freund Henning ist ein Lieber. Carmen ist nicht eifersüchtig, denn sie weiß, wie viel sie ihm bedeutet. Die beiden sind seit vier Jahren ein Paar und man kennt sie auch nur zusammen. Ausser beim Mädelsabend. Da will sie etwas alleine machen und was beim Mädelsabend besprochen wid, bleibt auch unter den Mädels. Carmen redet dort trotzdem nie schlecht über Henning, denn die beiden sind glücklich und das sieht man auch. Sie wäscht Hennings Klamotten, sie kocht, obwohl er nie darum gebeten hat. Umso toller, dass sie alles einfach so macht. Sie erwartet keineGegenleistung.</span></font></font></font></p>\n<p style=\"widows: 2; orphans: 2\">\n\t<br />\n\t&nbsp;</p>\n<p style=\"font-style: normal; widows: 2; orphans: 2; \">\n\t<font color=\"#222222\"><font face=\"Arial, Verdana, sans-serif\"><font size=\"2\" style=\"font-size: 9pt\"><span style=\"background: #ffffff\">Manchmal gehen die beiden auf ein Konzert. Indie. Das hört man jetzt im Freundeskreis. Mit Wollmütze, aber diese engen Hosen trägt sie nicht. Man muss nicht jeden Trend mitmachen. Obwohl sie sportlich ist, denn sie isst nicht einfach, sie ernährt sich gesund. Sport muss sein. Manchmal läuft in der Schule nicht alles so wie sie es will, aber das gehört dazu, das weiß sie genau. Beim Sport kann sie den Tag Revue passieren lassen und sich verausgaben.</span></font></font></font></p>\n<p style=\"widows: 2; orphans: 2\">\n\t<br />\n\t&nbsp;</p>\n<p style=\"font-style: normal; widows: 2; orphans: 2; \">\n\t<font color=\"#222222\"><font face=\"Arial, Verdana, sans-serif\"><font size=\"2\" style=\"font-size: 9pt\"><span style=\"background: #ffffff\">Carmen beschwert sich nicht. Uns geht es doch in Deutschland eigentlich sehr gut. Den anderen geht es viel schlechter, sagt sie, uns schickt eine SMS ab um 5 Euro für die Elfenbeinküste zu spenden. Das ist doch eine Welt und sie fühlt sich verantwortlich und möchte ihr Glück gerne teilen. Aber Carmen ist kein Mitläufer. Carmen ärgert vieles. Sie hat eine starke Meinung zu Atomkraft, Kennzeichnungspflicht bei Lebensmitteln und Tierquälerei und vertritt sie. Man kann nur die Grünen wählen, alles andere ist unvernünftig. Schließlich will sie eine gute Welt für ihre Kinder. Henning möchte noch keine. Sie auch noch nicht. Sie ist keine von diesen Frauen, die sich für ihre Kinder opfern. Es gibt für alles den richtigen Zeitpunkt im Leben und der wird kommen. Kinder sind trotzdem toll, aber sie würde nie einfach so fremde Kinder anfassen, denn sie weiß, wie das für die Eltern ist. Also wartet sie, bis man es ihr anbietet. Mit Kindern kann sie gut und mit Tieren. Haustiere kann sie leider nicht haben, denn sie ist allergisch, was schade ist, sagt Carmen.</span></font></font></font></p>\n<p style=\"widows: 2; orphans: 2\">\n\t<br />\n\t&nbsp;</p>\n<p style=\"font-style: normal; widows: 2; orphans: 2; \">\n\t<font color=\"#222222\"><font face=\"Arial, Verdana, sans-serif\"><font size=\"2\" style=\"font-size: 9pt\"><span style=\"background: #ffffff\">Carmen liebt es ausgelassen zu tanzen. Einfach die Augen schließen und sich rundum wohlfühlen, das schwappt direkt auf andere über. The Kooks, Franz Ferdinand und die Beatsteaks. Das gefällt nicht jedem, sagt sie, aber es ist ihr egal. Ihren Fernseher benutzt sie nicht mehr. Das verblödet und es ist schrecklich, dass so viele Menschen ihre Zeit damit vergeuden. Sie würde niemandem vorschreiben, was er zu tun und zu lassen hat. Aber schade ist es, denn die Zeit kann doch schließlich für schöne Aktivitäten genutzt werden, findet Carmen. Es ist so nett abends im Bett zu liegen und zu wissen, was man alles erlebt hat. Ihr Freund Henning kuschelt sich von hinten an sie. Dann kann sie sich sicher fühlen, obwohl sie sich auch ohne ihn sicher fühlt, denn ohne diese Gewissheit kann eine gute Beziehung nicht funktionieren, findet Carmen.</span></font></font></font></p>\n<p style=\"widows: 2; orphans: 2\">\n\t<br />\n\t&nbsp;</p>\n<p style=\"font-style: normal; widows: 2; orphans: 2; \">\n\t<font color=\"#222222\"><font face=\"Arial, Verdana, sans-serif\"><font size=\"2\" style=\"font-size: 9pt\"><span style=\"background: #ffffff\">Einmal hat Carmen etwas gestohlen, das kam aber nie wieder vor. Trotzdem, Kinder sind so und sie hat aus ihren Fehlern gelernt und ihrer Mutter die 50 Cent weinend zurückgegeben.&nbsp;</span></font></font></font></p>\n<p style=\"font-style: normal; widows: 2; orphans: 2; \">\n\t&nbsp;</p>\n<p style=\"font-style: normal; widows: 2; orphans: 2; \">\n\tCarmen hat auch schon mal an einem Joint gezogen. Das kann man manchmal machen, meint sie. Aber nur mit den richtigen Leuten und auch nur selten. Sie hat gesehen, wie es manchen Leuten geschadet hat. Henning mag auch kein Bier und Carmen mag Henning. Ein Glas Wein am Abend und sonntags Tatort mit Freunden in der kleinen süßen Eckkneipe mit den urigen Besitzern.</p>\n<p style=\"widows: 2; orphans: 2\">\n\t<br />\n\t&nbsp;</p>\n<p style=\"font-style: normal; widows: 2; orphans: 2; \">\n\t<font color=\"#222222\"><font face=\"Arial, Verdana, sans-serif\"><font size=\"2\" style=\"font-size: 9pt\"><span style=\"background: #ffffff\">Vorratsdatenspeicherung findet Carmen gar nicht gut. Da unterschreibt sie auch gleich und redet viel mit ihren engsten Freunden über die Thematik. Man muss sich mit Politik und Zeitgeschehen beschäftigen findet Carmen, aber der Nahostkonflikt ist schon heikel, das muss man differenziert sehen.</span></font></font></font></p>\n<p style=\"widows: 2; orphans: 2\">\n\t<br />\n\t&nbsp;</p>\n<p style=\"font-style: normal; widows: 2; orphans: 2; \">\n\t<font color=\"#222222\"><font face=\"Arial, Verdana, sans-serif\"><font size=\"2\" style=\"font-size: 9pt\"><span style=\"background: #ffffff\">Carmen hat ein paar enge Freunde. Das reicht ihr absolut, sagt sie im ernsten Tonfall. Freundschaften müssen erst entstehen, ständig gepfelgt werden und halten dann meist ein Leben lang. Ihre beste Freundin kennt sie seit der Schule, und obwohl sie in unterschiedlichen Städten studiert haben, sind sie immer beste Freundinnen geblieben, die sich gerne über ihren Job, den Johanna ist auch Lehrerin, unterhalten. Ihre anderen guten Freunde hat sie im Studium kennengelernt. Was für eine erlebnisreiche Zeit.</span></font></font></font></p>\n<p style=\"widows: 2; orphans: 2\">\n\t<br />\n\t&nbsp;</p>\n<p style=\"font-style: normal; widows: 2; orphans: 2; \">\n\t<font color=\"#222222\"><font face=\"Arial, Verdana, sans-serif\"><font size=\"2\" style=\"font-size: 9pt\"><span style=\"background: #ffffff\">Carmen mag Pistazieneis. Ein bisschen ausgefallen, wie sie selbst. Am liebsten vor ihren häufigen Kinogängen. Anspruchsvolle Filme und gerne auch mal Beziehungskomödien. In einer guten Beziehung muss man auch lachen können, glaubt Carmen und bezieht ihr Doppelbett mit getrennten Matratzen neu. In weiß. Aber Hennings Seite in Blau, denn der schwitze immer so. Über dem Bett hängt ein &quot;Wenn das Leben dir Zitronen gibt, mach Limonade daraus!&quot; Plakat, das beide ausgesucht haben.</span></font></font></font></p>\n"}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mira Lykke im Interview","date":"2013-04-10 15:29:57 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/myralikke.jpg\" alt=\"myralikke.jpg\" />\n<p>Ich habe mir Theresa geschnappt, die eine Hälfte des erfolgsversprechenden Berliner Techno-Duos <a href=\"https://www.facebook.com/MiraLykke\">“Mira Lykke”</a> bildet, und sie mit Fragen rund um Pop, Musik, Leben und Berlin bombardiert.</p>\n<p><strong>Hallo Theresa, ihr sagt auf eurer <a href=\"https://www.facebook.com/MiraLykke\">“Facebookseite”</a> “We love you and we want to make you dance”. Ist das so?</strong></p>\n<p>Ja! So soll es sein. Wir haben Spaß an Musik und Tanzen und all dem was dazu gehört. Und, was ist schöner als das was einem selber Spaß macht mit anderen zu teilen?</p>\n<p><strong>Muss man die Menschen mögen um Musik zu machen?</strong></p>\n<p>Naja, ja ich denke schon! Oder andersrum; man sollte sicherlich niemand sein, der Menschen hassend und andauernd meckernd mit einer halb-leeres-Glas-Mentalität in seinem Keller lebt. Was uns betrifft; We love you and we want to make you dance  das haben wir uns ja nicht einfach so auf die Fahne geschrieben. Wir mögen Menschen. Wir mögen tanzen. Und am liebsten beides gleichzeitig.</p>\n<p><strong>Beschreibt doch mal Eure Musik! Zu welchem Film würde sie den perfekten Soundtrack abliefern?</strong></p>\n<p>Unsere Musik ist irgendwie ein Spannungsbogen zwischen unseren verschiedenen Wurzeln. Ich steh wohl eher für den ganzen melodischen Mädchenkram, das Konfetti und all das Zeugs. Clément gibt dem ganzen einen Boden, er bringt quasi den Beat und sorgt dafür dass es nicht zu kitschig und klischeebeladen wird. Das ist es wohl auch, was uns ausmacht. Erst sind es die Moog-Melodien die dir durch den ganzen Körper fahren und alles zittern und vibrieren lassen und dann wieder nette Töne und Klänge, die so ein Sommer-draußen-Tanz-Gefühl in sich tragen.\nUnd welcher Film…puh, einen konkrete Namen habe ich nicht. Aber irgendwas mit schönen Farben und Menschen, die mit Musik in den Ohren durch die Gegend streifen. Fröhlich und lebensbejahend.</p>\n<p><strong>Wird dir warm ums Herz, wenn du über Mira Lykke sprichst?</strong></p>\n<p>Wohlig warm wird es da in mir! Ja, Mira Lykke ist ein absolutes Herzensprodukt!</p>\n<p><strong>Seid ihr Pop oder Techno? Sind die Grenzen in den letzten Jahren verrutscht?</strong></p>\n<p>Was sind wir? Ja, gute Frage. Um ganz ehrlich zu sein, ich verzweifle regelmäßig an der genauen Beschreibung und Titulierung von Musik-Arten. Wir sind sicher mehr Techno als Pop. Aber, ja es stimmt schon, die Grenze ist schwimmender geworden.</p>\n<p><strong>Ihr lebt und arbeitet in Berlin. Ist das heute ein unabdingbares Muss für Erfolg oder nur ein schönes Bonbon?</strong></p>\n<p>Wir sind beide nicht der Musik wegen nach Berlin gekommen. Das hatte viel profanere Gründe. Und auch wenn ich glaube das Musik, bzw. elektronische Musik auch außerhalb Berlins funktioniert, wäre es natürlich Blödsinn zu behaupten, dass Berlin nicht hilft. Gerade bei unserer Art von Musik gibt es hier einfach wahnsinnig viel! Diese Plattform hat man bei weitem nicht überall. Gleichzeitig; so denken natürlich viele. Das macht es nicht gerade einfacher gehört zu werden. Gerade am Anfang. Vielleicht ist es für die anfängliche Aufmerksamkeit gar nicht schlecht an einem anderen Ort zu beginnen.\nAber; wir wollen Berlin nicht missen. Das positive überwiegt. Und Wettbewerb lässt einen ja auch wachsen und besser werden. Ja, es ist so etwas wie unser Bonbon.</p>\n<p><strong>Lass’ uns doch mal einen Blick in die Zukunft wagen! Wird es ein Album geben? Was passiert mit Berlin? Bleibt ihr und was wird die Musik mit euch machen?</strong></p>\n<p>Ein Album wäre natürlich ein Traum! Aber, so weit sind wir noch nicht. Unser vorrangiges Ziel ist es mehr und mehr durch Clubs, Festivals und Open Airs zu touren. Wir komponieren immer weiter und wollen besser und besser werden. Was daraus wird und wo es noch hingeht  das wird sich zeigen. Wir arbeiten hart, dass es stets bergauf geht. Für den Moment sind wir froh Musik machen zu können und sie anderen vorspielen zu dürfen.   Was aus Berlin wird  oha, ja. Ich glaube diese ganze Diskussion über sich verändernde Stadtteile und Zugezogene und Studenten und all jene, irgendwie müßig. Gehört das denn nicht auch irgendwie dazu? Jetzt ist es hier cool und dort uncool, in einigen Jahren zieht es Künstler, Studenten oder wer auch immer zu dieser Scene gehört in den nächsten Stadtteil. Und was gerade cool ist wird wieder uncool. Nicht das ich falsch verstanden werde; Ich bin absolut kein Fan davon, dass Leute aus ihren Wohnungen gedrängt werden, damit dort tolle Loft-Wohnungen und das nächste Hotel entstehen kann oder das horrende Mieten verlangt werden können. Das finde ich auch furchtbar. Ich denke Berlin zerrstört sich damit selbst; nimmt sich seinen Charme weg.\nAber was den ganz normalen zu  und abnehmenden Hype um einzelne Ecken angeht, da glaube ich, dass sich das Karussell der angesagten Stadtteile immer so weiter drehen wird. Eben so wie es sich bisher gedreht hat.</p>\n<p><strong>Ich will euch live sehen. Wo kann ich das?</strong></p>\n<p>Wir sind gerade dabei die Dates für den Sommer fest zu machen. Bisher sind wir über die ersten frühlingshaften Open-Airs hier in Berlin getingelt. Mehr soll und wird folgen! Die Dates veröffentlichen wir dann rechtzeitig in unserem SoundCloud-Profil und auf Facebook.</p>\n<p><strong>Eine Frage noch am Ende: Kannst du mir verraten welche Musik du privat hörst und deine beiden Lieblingstracks auf SoundCloud schicken!</strong></p>\n<p>Und hier einmal Lieblingsmusik von jedem von uns:</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"http://soundcloud.com/brandtbrauerfrick/06-on-powdered-ground-mixed\">player</a></p></p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"http://soundcloud.com/allefarben/daughter-youth-alle-farben\">player</a></p></p>\n"}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: Anatolian Psychedelic","date":"2016-05-23 09:03:38 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2016/May/swim.jpg\" alt=\"alt\"></p>\n<h4>Nackenschellen an alle verteilen, die nicht endlich mal entspannen!</h4>\n<p>Es ist eine gute Musik. Es ist 1 gutes Life! Irre Instrumente. Bässe. Unter Bäumen. Im Park. Von mir für euch. Klickiklacki.</p>\n<p>Nun aber raus aus der Bude, Mixtape anwerfen und mir auf <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen!</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/216383371&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n<p>Foto: From <a href=\"http://digitalcollections.nypl.org/collections/cigarette-cards#/?tab=about\">Cigarette Card</a> collection at New York Public Library.</p>\n"}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape April: Sheesh Days","date":"2014-04-10 15:51:34 +0000","tags":null,"layout":"post","body":"<img src='http://media-cache-ec0.pinimg.com/736x/0b/ae/c6/0baec6e6d8ba0b06fe15d9449f9ddd9d.jpg' alt=''>\n<p>Meine Herren, das Jahr ist fast schon wieder rum und wir finden uns immer noch nutzlos und im Scheitern begriffen in der ranzigen Großstadt wieder und vertreiben uns die Zeit mit ablenkender Mucke und folgen Ada Blitzkrieg auch bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a>. Oder eben auch nicht.</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/sheesh-days\">player</a></p></p>\n"}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: BIRDDOG","date":"2014-06-09 20:49:48 +0000","tags":null,"layout":"post","body":"<img src=\"http://media-cache-ak0.pinimg.com/736x/ae/04/d3/ae04d32a9d6678d7a7102c94c8d8e03d.jpg\" alt=\"\">\n<p>Haha! Nachdem ich mir eine Flasche Rotwein reingestellt habe, sind mir zwar die 40 Grad Sommerhitze egal, aber ich habe aus Versehen ein Mixtape mit 3000000000 Songs veröffentlicht. Ihr könnt es nun hören als wäre nie etwas passiert und Ada Blitzkrieg bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen:</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/birddog\">player</a></p></p>\n"}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: Butter Gang","date":"2015-07-26 11:49:59 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2015/Jul/drive.jpg\" alt=\"alt\"></p>\n<p>Heute ist Sonntag. Für viele von uns heißt es dann konkret: Rührei mit Tabasco pumpen, den Hund auf dem Gehweg abwursten lassen und dann irgendwie die Zeit bis zum abendlichen Pizza bestellen absitzen. Warum die Dauer also nicht einfach mit einem feinen Mixtape verfeinern? Zudem könnte man mir auch auf <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen und sich mal locker machen.</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/126467355&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: Chickengirlz","date":"2015-05-14 15:07:57 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2015/May/caaake.jpg\" alt=\"alt\"></p>\n<p>Im Blitz-HQ herrscht beste Laune, denn soeben habe ich meine Unterkünfte für den Juni und Juli in San Francisco und Cancun Mexiko gebucht und freue mich auf eine perfekte Sommerzeit in Mission und in einer Villa direkt am Meer mit eigenem Pool. Ich brauche vermutlich nicht zu erwähnen, dass man das machen kann. Ja. Ganz nett. Jetzt eben nur noch die nächsten drei Wochen rumbekommen…</p>\n<p>Um auch ein wenig gute Laune in euch zu pumpen, habe ich mal wieder ein Mixtape gebaut. Folgt mir auch gerne auf <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> und esst mehr Kuchen! Ich sage es immer wieder.</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/103777211&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape - Entfremdung von der Leichtigkeit","date":"2012-10-11 14:24:22 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/9000000.jpg\" alt=\"9000000.jpg\" />\n<p>Sagt alles ab, ich habe ein neues Mixtape für Euch gebaut:</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/sadness\">player</a></p></p>\n"}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape Fabruar: Fap Fap Fap","date":"2014-02-03 10:18:36 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://media-cache-ak0.pinimg.com/originals/b1/19/0c/b1190cd3e6ee6bc3a3c295bae794d69d.jpg\" alt=\"Alt text\"></p>\n<p>Hier der perfekte Soundtrack zum Köfte essen und Minimotorrad fahren, also besser schnell noch Ada Blitzkrieg bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen und etwas wagemutiger fühlen!</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/fap-fap-fap\">player</a></p></p>\n"}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: Fuck Tatort","date":"2015-01-18 18:14:46 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2015/Jan/larren.jpg\" alt=\"alt\">\n<em>Illustation: <a href=\"http://willlaren.tumblr.com/tagged/art\">Will Larren</a></em></p>\n<p>Für Euch. Passt genau zwischen JETZT und Tatort und ist ein echter Ohrenschmaus. Keine Ausreden.</p>\n<p>Bussi,\nEure Magendarmqueen Ada</p>\n<p>Folgt mir gerne auch bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> und packt Euch beim Hören ein paar hartgekochte Eier rein!</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/73275422&amp;color=ff5500&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false\"></iframe>\n"}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: Goodbye California!","date":"2014-11-11 00:56:55 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://neongoldrecords.com/blog/images/milowildcat.gif\" alt=\"alt\"></p>\n<p>Wisst Ihr noch wie ungerecht es sich als Kind angefühlt hat, wenn man ins Bett musste obwohl man noch sehr wach war? Mit meiner Abreise aus San Francisco fühlt es sich gerade genauso an. Viel zu früh. Viel zu ungerecht.</p>\n<p>Auch die besten Dinge im Leben haben ein Ende, denke ich etwas wehmütig. Dann fällt mir allerdings wieder ein, wie viel Zeit ich dieses Jahr in dieser Stadt an der Bay verlebt habe und wie endlos lang mein Sommer deswegen war. Ich habe Deutschland genau zu dem Zeitpunkt verlassen, an dem es kalt wurde und bin im Frühjahr, als es in Berlin noch frostig war, ebenfalls in die Bay Area geflüchtet. In Kalifornien wurde ich immer bei knackigen 26 Grad empfangen, die sich bis heute - im fucking November - hielten.</p>\n<p>Ich durfte hier Halloween, Día de los Muertos und den Sieg der Giants, sowie die darauf folgenden Feiern und Riots vor meiner Tür erleben. Die Menschen waren wieder sehr nett zu mir. Sehr offen und sehr unvoreingenommen, so dass es mir wie immer bei meiner Rückkehr schwer fallen wird die Berliner “Art” akzeptieren zu können.</p>\n<p>In einer Woche geht der Flug. In Berlin wartet jemand auf mich. Jeden Morgen, beim Spazieren in der kalifornischen Sonne, will ich nie wieder heim. Abends erzähle ich, wie sehr ich meine Katze vermisse.</p>\n<p><img src=\"http://scontent-a-sjc.cdninstagram.com/hphotos-xpf1/t51.2885-15/10299835_1488195731397019_514601899_n.jpg\" alt=\"alt\"></p>\n<p>Ein sehr kluger Mann hat mal zu mir gesagt, man muss nach vorne sehen und sich auf Club Mate freuen. Zum Abschied habe ich noch schnell dieses Mixtape gepumpt. Wir sehen uns nächste Woche im Winter!</p>\n<p>Folgt mir auch bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> und zieht Euch warm arn!</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/58790849&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: Hasenscharte","date":"2015-04-03 09:49:32 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2015/Apr/bloo.gif\" alt=\"alt\"></p>\n<p>Frohe Ostern, ihr Eierköpfe! Anbei findet ihr mein neues herrliches Mixtape.</p>\n<p>Mit den besten Grüßen,\nBlitz</p>\n<p>Folgt mir gerne auch bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> und verratet mir ob ihr Medium oder Large Eier esst!</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/87107460&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: Howl Geheule","date":"2015-05-21 12:22:57 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2015/May/uii.png\" alt=\"alt\"></p>\n<p>Kann mich nicht entscheiden was länger ist: Das anstehende Wochenende oder mein Penis? Das tangiert euch allerdings nicht wirklich und somit möchte ich mich dann doch den Themen widmen, die euch angehen: Mein neues Mixtape.</p>\n<p>Folgt mir auch gerne auf <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> und geht mal wieder raus an die Luft!</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/109694492&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape im August: The Miniwurstelmonth","date":"2013-07-30 13:44:12 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/bikini.jpg\" alt=\"bikini.jpg\" />\n<p>Man kann ja mit vielen Dingen ein Problem haben, aber wer in diesem Sommer nicht schon längst seinen Flachbildschirmfernseher an das faulige Seeufer geräumt hat, um von der Luftmatratze aus Street Fighter II auf der SNES zu zocken, ist ein ziemlicher Verlierertyp und sollte mal besser mit seinem letzten Funken Selbstachtung noch schnell Ada Blitzkrieg bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen.</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/the-miniwurstelmonth\">player</a></p></p>\n"}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape im Dezember: No Wanderlust","date":"2013-11-26 00:00:00 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://farm8.staticflickr.com/7017/6751157273_106c4a9bc4_b.jpg\" alt=\"Alt text\"></p>\n<p>Foto: <a href=\"http://www.flickr.com/photos/laserbread/\">Laser Bread</a></p>\n<p>Bald ist Weihnachten und dann sind wir auch schon fast wieder in Rente und generell tot, also besser schnell noch Ada Blitzkrieg bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen und etwas zeitgeistiger fühlen!</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/no-wanderlust\">player</a></p></p>\n"}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape im Januar: FUCKTTHATSHIT!","date":"2014-01-09 09:10:21 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://i.huffpost.com/gen/557752/thumbs/r-PRINCESS-DIANA-STYLE-large.jpg\" alt=\"Alt text\"></p>\n<p>Nichts wird besser, alles fällt entzwei. Also noch schnell Ada Blitzkrieg bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen und lieber mit musikalischer Untermalung in der Bedeutungslosigkeit verpuffen.</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/fuckthatshit\">player</a></p></p>\n"}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape im Juli: Adrette Ausreden","date":"2013-07-10 08:08:16 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/lopez.jpg\" alt=\"lopez.jpg\" />\n<p>Foto: Elle Magazin by <a href=\"http://inspirational-imagery.blogspot.it/2012/04/antonio-lopez-elle-magazine-1967.html\">Antonio Lopez</a></p>\n<p>Ich habe für Euch ein Juli-Mixtape zusammengestellt. Also schnell etwas Bratensoße eintuppern und nichts wie raus in die Sonne und Ada Blitzkrieg auch bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen!</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/adrette-ausreden\">player</a></p></p>\n"}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape im Juni: The Liverwurst Diaries","date":"2013-06-07 14:59:06 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/dolphines.jpg\" alt=\"dolphines.jpg\" />\n<p>Foto: Dolphins by <a href=\"http://whitekaffir.tumblr.com/\">A White Kaffir Draws</a></p>\n<p>Das neue Juni Mixtape ist da. Also raus in den Park, Gras rauchen, verwegen sein und Ada Blitzkrieg auch bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen!</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/the-liverwurst-diaries\">player</a></p></p>\n"}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape im Mai: Peng","date":"2013-05-08 00:00:00 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/finger.jpg\" alt=\"finger.jpg\" />\n<p>Der Mai zeigt seine weißen Quallenbeine in der Hasenheide, der erste Sonnenbrand lässt unsere Haut wie Bacon glänzen und es ist endlich Zeit für ein tightes Mixtape. Also, PENG anmachen, schön sein und Ada Blitzkrieg auch bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen!</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/peng\">player</a></p></p>\n"}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape im November: Schnaps and Zweifel","date":"2013-11-02 09:50:39 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://www.juliahetta.com/photos/big/IMG_7380%203__20_klar_l.jpg\" alt=\"Alt text\"></p>\n<p>Foto: <a href=\"http://www.juliahetta.com/\">Julia Hetta</a></p>\n<p>Grau ist es und kalt. Es regnet und man liegt nur im Bett und die Welt liegt in einem. Aber einfach mal schnell aufstehen, sich warme Corissants mit ganzen Aprikosen als Füllung holen und schnell noch Ada Blitzkrieg bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen und ein klein wenig besser fühlen - das ist nicht verkehrt.</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/schnaps-and-selbstzweifel\">player</a></p></p>\n"}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape im Oktober: The Darkness Lights You Up","date":"2013-09-26 08:44:10 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/oktoberblume.jpg\" alt=\"oktoberblume.jpg\" />\n<p>Foto: <a href=\"http://www.flickr.com/people/abasolo/\">mariana abasolo</a></p>\n<p>Meine Depression hat ein Mixtape zusammengestellt, das sich perfekt dazu eignet um den ganzen Tag (und damit meine ich acht bis 20 Uhr) im Bett zu liegen und die Wolken anzustarren. Hören, weinen und schnell noch Ada Blitzkrieg bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen!</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/the-darkness-lights-you-up\">player</a></p></p>\n"}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape im September: Goodbye Flutschfinger","date":"2013-08-26 15:47:38 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/flutschizwei.jpg\" alt=\"flutschizwei.jpg\" />\n<p>Foto: <a href=\"http://blogs.dion.ne.jp/bonfire/\">Yosuke Yamaguchi</a></p>\n<p>Die letzten schönen Tage im Jahr sind irgendwie auch nur grob mittelschön und ohne Musik wären wir vermutlich noch aufgeschmissener. Sagt also Hallo zu sechs Monaten Kälte, Depression, Beklemmung und folgt schnell noch Ada Blitzkrieg bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a>!</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/goodbye-flutschfinger\">player</a></p></p>\n"}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: Klammbumm","date":"2015-03-07 10:48:41 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2015/Mar/christ.jpg\" alt=\"alt\"></p>\n<p>Hallo Freunde. Heute gibt es richtig was auf die Ohren. Ein nettes Mixtape, das förmlich dazu einlädt das gute Wetter auszunutzen und mit offenem Verdeck durch die Hochhäuserschluchten von Marzahn zu fahren.</p>\n<p>Folgt mir gerne auch bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> und verratet mir eure Körbengröße!</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/80721102&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape Mai: WHAT THE","date":"2014-05-01 16:25:46 +0000","tags":null,"layout":"post","body":"<img src=\"http://media-cache-ec0.pinimg.com/736x/86/d0/4b/86d04b95ed1871447502b91ab3df8164.jpg\" alt=\"\">\n<p>Wow, schon wieder Mai! Draußen randalieren die Vermummten und drinnen sitzen wir mit unseren viel zu engen Hosen und den großen Erwartungen und fassen uns unaufhörlich an. Wer bis jetzt noch keine Eiscreme essen war, wird es in diesem Jahr auch nicht mehr (Versprochen!) und nun folgen wir alle brav Ada Blitzkrieg bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> und ziehen uns das neue Mixtape rein:</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/what-the\">player</a></p></p>\n"}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: Marzipanschnaps und Gyroskekse","date":"2013-10-15 15:12:39 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://farm4.staticflickr.com/3421/4002596658_a0bdc04515_o.jpg\" alt=\"Alt text\"></p>\n<p>Fotos: <a href=\"http://www.flickr.com/photos/holywow/\">Spew Barrymore</a></p>\n<p>Wie lautet eigentlich die Quersumme von Grau?\nGegen schlechte Laune und Kuchenmundgeruch habe ich ein Mixtape zusammengebaut. Hören, weinen und schnell noch Ada Blitzkrieg bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen! Mit Musik ist der Oktober doch ganz erträglich.</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/marzipanschnaps-und-gyroskekse\">player</a></p></p>\n"}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: Monaco Mini","date":"2015-07-18 07:54:09 +0000","tags":null,"layout":"post","body":"<p><img src=\"https://s-media-cache-ak0.pinimg.com/736x/14/f1/4d/14f14d75d3512027c477d1ccd661d0ca.jpg\" alt=\"alt\"></p>\n<p>Der Sommer geht auf’s Ganze und alle fragen sich wie blöd ob Markus Lanz überhaupt schwitzt und wie das wohl riechen mag.\nFür den Moment heißt es aber erstmal: Raus aus dem Bett, rein mit dem Kaffee und fleißig mein neues Mixtape hören. Wer ein feiner Kerl ist, folgt mir auch gerne auf <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> und geht dann raus in die Sonne Fahrräder stehlen oder Eis fallen lassen.</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/110260656&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape März: Fuck You Eiscreme","date":"2014-02-26 00:00:00 +0000","tags":null,"layout":"post","body":"<img src='http://media-cache-ec0.pinimg.com/736x/d3/c0/85/d3c08552bad1a6a2cc1e46e002948e4f.jpg' alt=''>\n<p>Kaum steigt das Thermometer wieder in den zweistelligen Bereich an, entkleidet sich der Berliner bis auf seine Air Max und macht mit seiner Awtomat Kalaschnikowa offen am Kanal rum als wäre es Mary-Kate und Ashley Olsen. Zuhause kann man dann, wenn man zufällig nicht Matthias Matussek ist, Ada Blitzkrieg auch bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen und Sprühpflaster essen. Oder eben auch nicht.</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/fuck-you-eiscreme\">player</a></p></p>\n"}

/***/ }),
/* 667 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: Next Stop - Down","date":"2014-07-24 14:25:25 +0000","tags":null,"layout":"post","body":"<p>{&lt;1&gt;}<img src=\"http://media-cache-ak0.pinimg.com/736x/a5/eb/ed/a5ebed911cb9eb680464905f2c7a8652.jpg\" alt=\"alt\"></p>\n<p>Draußen tragen die Puppen weiße Birkenstock Sandaletten als hätte es ihre verwachsenen Öko-Eltern und die eigene Rebellion nie gegeben. Nebenher baut jemand ein ordinäres Mixtape und möchte bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> abonniert werden:</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/38288941&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 668 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: Oh komm ohn","date":"2015-10-01 12:56:51 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2015/Oct/fuck.jpg\" alt=\"alt\"></p>\n<h4>Depression ist was du draus machst.</h4>\n<p>Wieso also nicht einfach bedingungslos Musik hören und ein bisschen rumliegen? Ich habe euch dafür ein Mixtape geschraubt, dass euch hiermit sehr ans Herz gelegt wäre.</p>\n<p>Nun aber auf den Boden werfen und die Wolken anstarren. Außerdem solltet ihr mir auf <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen und euch wund hören!</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/150454988&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: Pappa Bear","date":"2015-02-13 14:42:27 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2015/Feb/mampf.gif\" alt=\"alt\"></p>\n<p>Das Wochenende steht vor der Tür und wieso die letzten Arbeitsstunden der Woche nicht mit einem schönen Mixtape verschönern? Keine Gegenargumente. War ja klar. Also dann bitte.</p>\n<p>Folgt mir gerne auch bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> und schickt mir Käse!</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/73827246&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 670 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: Pizza Christmas","date":"2014-12-11 13:40:08 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2014/Dec/fuck.jpg\" alt=\"alt\"></p>\n<p>Boah Weihnachten. Alle supermüde. Silvester. Laut. Jahr um. Mixtape an und Fresse halten. Für Wehmut und Klagen darf kein Raum sein.</p>\n<p>Folgt mir gerne auch bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> und wichst schon mal die Kufen!</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/60529144&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: Summer Silly","date":"2015-09-08 07:23:39 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2015/Sep/li.jpg\" alt=\"alt\"></p>\n<p>Im Winter ist jeder verdammte Tag ein Montag. Je eher wir uns damit abfinden, desto besser.</p>\n<p>Bei ALDI gibt es gerade warme Fleecejacken für sechs Euro. Reißt Euch also mal zusammen. Das Leben kann nicht immer nur Freitagabend sein!</p>\n<p>Das neue Miley Cyrus Album ist draußen. Kostenlos auf ihrer Homemage und bei <a href=\"https://soundcloud.com/mileycyrus\">SoundCloud</a>.</p>\n<p>Nun aber ein croissantintensives Frühstück und ein neues Mixtape. Zudem könntet Ihr auch so nett sein und mir auf <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen und Euch selbst beglücken.</p>\n<p><img src=\"/content/images/2015/Sep/GRRLS.jpg\" alt=\"alt\"></p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/132944714&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: SUPERSUPER","date":"2016-07-06 08:28:34 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2016/Jul/tis.jpg\" alt=\"alt\"></p>\n<h4>Zu faul zum Beschreiben.</h4>\n<p>Es ist ein Mixtape und ihr könnt mir gerne auch auf <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen!</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/232239431%3Fsecret_token%3Ds-rr4UO&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 673 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: The Birthday Tape","date":"2014-08-14 15:38:50 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2014/Aug/dawg.jpg\" alt=\"alt\"></p>\n<p>Vorweg: Morgen werde ich zum 29sten Mal nicht Dreißig. Also, herzlichen Glückwunsch im Voraus an mich! Happy Ada!</p>\n<p>Aus diesem Anlass habe ich ein kleines Mixtape zusammengeleimt. Folgt also Ada Blitzkrieg bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a>, stoßt heute Nacht auf mich an und strahlt einfach mal!</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/46720145%3Fsecret_token%3Ds-rfaXq&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 674 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mixtape: The Catnapper","date":"2014-09-01 15:10:13 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://media-cache-ec0.pinimg.com/736x/b1/c5/74/b1c574a2ca8d408230d2bbc81d2460c1.jpg\" alt=\"alt\"></p>\n<p>Mit meinem neuen Mixtape möchte ich mich dann auch erstmal offiziell in den Urlaub verabschieden. Der Blitz goes Bretagne.</p>\n<p>Aus diesem Anlass habe ich ein kleines Mixtape zusammengewurstet. Folgt also Ada Blitzkrieg bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a>, und bleibt mir wohlgesonnen.</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/48547182&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 675 */
/***/ (function(module, exports) {

	module.exports = {"title":"Nationale Bürgerwehr und Bündnis gegen das Pferd","date":"2011-05-21 12:02:37 +0000","tags":null,"layout":"post","body":"<p>\n\tGestern Nacht hat sich zum ersten Mal die <strong>Nationale Bürgerwehr und Bündnis gegen das Pferd</strong> (NBUBGDF) versammelt, um den Kiez vor den Gefahren des gemeinen Pferdes (lat. Equus) zu warnen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/IMG_6142.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<h2>\n\t1. Pferde schleichen sich nachts in unsere Städte und fressen Kinder</h2>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/IMG_6156.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<h2>\n\t2. Pferde besitzen Atomwaffen</h2>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"741\" src=\"/files/IMG_6133.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<h2>\n\t3. Pferde haben unzulässige Frisuren</h2>\n<h2>\n\t&nbsp;</h2>\n<p>\n\tWeiteres Informationsmaterial und Beitrittsformular unter: kontakt@textkrieg.de</p>\n"}

/***/ }),
/* 676 */
/***/ (function(module, exports) {

	module.exports = {"title":"Neid im Internet","date":"2012-07-04 15:15:30 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/neide.JPG\" alt=\"neide.JPG\" />\n<p>Neid im Internet ist ein ewiges Thema. Der eine hat etwas, das man auch haben könnte. Aber wieso hat man es nicht? Ungerecht! Sie verdient so viel, das könnte man eigentlich ja auch. Aber wieso eigentlich sie? Die kennt so viele Promis. Aber die sind sowieso alle kacke. Die hasse ich! Und ausserdem könnte ich das auch. Der macht ja nur Müll! Ich gönne dem nichts. Wieso hat der alles und ich nicht? Wieso hat die so viele Follower? Die hat das alles nicht verdient! Und was ist überhaupt mit mir? Wo bleibe ich?</p>\n<p>Mal angenommen:\nEs ist 10:45 Uhr und ich lade <strong>ein Foto meines Frühstückkaffees auf der Plattform <a href=\"http://instagram.com/\">Instagram</a></strong> hoch, denn ich möchte etwas teilen, was ich gerne mag und was mich gerade sehr gefreut hat. Ein leckerer Kaffee in der Sonne. Zwei Minuten später meldet sich ein Follower zu Wort: “Hipster! Essensfotografie ist doch eh behindert und deine ganze Scheiße interessiert doch eh niemanden!” Ein Tweet von einem anderen User folgt kurz darauf: “Ich schreibe besser auch mal ein Buch ‘Pinienkerne aufs Essen werfen und alles voll hübsch und so!’” Vielleicht schreibt ein weiterer Nutzer auf irgendeiner Plattform auch “Halt´s Maul! Du nervst!”. Und dann folgen beliebige andere Kommentare, die sich  im ähnlichen Tonus fortsetzen. Vielleicht ist mal kurz Ruhe. Vielleicht bekommt man mal auf ein Foto oder Statusupdate keine böswilligen Kommentare. Man wundert sich schon fast, wenn man mal etwas publiziert und die Kritik ist konstruktiv.</p>\n<p>Es ist 11.30 Uhr und ich <a href=\"https://twitter.com/bangpowwww/status/220462187720876033\">twittere</a>: <strong>“It really hurts if someone you once loved is laughing about your books, your way of living and your philosophy.”</strong> Die Replys und Antworten auf meinen Facebookstatus sind nicht alle nett. Das sind sie nie. “Wenn ich nicht wüßte, wie man Interferenzfehler vemeidet, würde ich lieber gar nichts schreiben!” oder “Dann denk halt mal darüber nach, dumme Kuh!” Vielleicht nicht die schönsten Antworten, die man in einem kurzen Moment der Verletzlichkeit erhalten möchte, aber leider sind sie immer gegenwärtig und müssen irgendwie bearbeitet/verarbeitet werden. Wie geht man mit solchen Kommentaren um? Und wie funktioniert eigentlich dieser Mechanismus, der dafür sorgt, dass sich ein nicht so geringer Teil der Internetnutzer durch das Darstellen der eigenen Person immerzu provoziert und angesprochen fühlt?</p>\n<p><strong>Die einfache Faustformel “Wenn Dich nicht interessiert was ich schreibe oder Du mich als im Internet agierende Person nicht magst, wenn Du ablehnst wie ich arbeite oder lebe, dann folge mir nicht!” scheint zu kurz gegriffen.</strong> Das Gefühl ein Anrecht auf das Leben, Handeln und Denken einer Person zu haben, spielt in der Neid-Thematik ebenfalls eine kleine Rolle. Neid ist der Motivator für große Massen an inhaltsloser “Kritik”, die letzlich doch nur auf die Person abzielt. Inhaltsleer und überflüssig.</p>\n<p><strong>Die Art Mensch, die ihr Charakterprofil nur über die Fehler anderer oder Gehässigkeiten über andere bildet.</strong></p>\n<p>Bis vor einiger Zeit war ich ein Mensch, der über jede Zuschrift und jede gottverdammte Reply nachdachte und versuchte darin einen Mehrwert für meine Person zu entdecken. <strong>Das führte zum einen zu schmerzlichen Momenten (“Warum hasst der/die mich so?” - “Was habe ich denen denn getan?”), und zum anderen dazu, dass ich schlicht und einfach meine Zeit verschwendete.</strong> Das Internet ist ein selektiver Raum. Daher nehme ich unkonstruktive Kritik nicht mehr ernst und denke darüber nicht weiter nach. Das funktionierte nicht von heute auf morgen, sondern ist Teil eines langen Erkenntnisprozesses, den ich Euch weiter ausführen möchte:</p>\n<p>Wer seine Zeit mit Gehässigkeiten und dem Austeilen von Verletzungen verschwendet, signalisiert deutlich, dass der Adressat dieser Zeitaufwendung ein Teil seines selektiven Lebens und seines selbstbestimmten Medienkonsums ist. Dabei ist es egal wie sehr er beteuert, dass ihm der Adressat egal sei - er hat ihn bereits längst zu einem Götzen erhoben.</p>\n<p><strong>Ich will nicht am laufenden Band mit den Schwächen anderer Menschen konfrontiert werden, die versuchen diese durch Zerstörung meiner Person in eine Stärke zu katalysieren!</strong></p>\n<p>Aber wer sind diese Menschen eigentlich? Ein Phänomen, das wir nicht nur aus der Netzwelt kennen, sondern auch aus unserem Alltag. Menschen, die sich immer nur dann melden, wenn jemand einen Fehler macht oder einen kurzen Moment verletzlich und angreifbar erscheint. Wenn die Wortmeldung mal wieder lediglich dazu dient sich über eine Person zu stellen, um das eigene Ego zu erhöhen. Häufig wird diese <strong>Gehässigkeit fälschlicherweise als Humor verpackt</strong> (um sich als Urheber solcher Äußerungen nicht moralisch angreifbar zu machen) und verletzt schlechtestenfalls den Adressaten. Warum es das aber nicht tun sollte, möchte ich in diesem Blogbeitrag erläutern:</p>\n<p><strong>Ignorieren! Die Kommentare abstellen! Blockieren! Du darfst das nicht so an Dich heran lassen! Du weißt doch wie das Internet ist! Die Liste der Ratschläge ist endlos lang und alle anderen “Betroffenen” solcher Neidkommentare, scheinen gut damit zurechtzukommen.</strong> Wir vergessen dabei oft, dass die wenigsten gerne über ihre Verletzlichkeit sprechen und zugeben möchten, wie schwer es ist, wenn einem Erfolg und Glück nicht gegönnt wird.</p>\n<p>Die fabelhafte <a href=\"http://silenttiffy.de\">Silenttiffy</a> veröffentlichte kürzlich eine interessante Trilogie über das Thema “Neid” in ihrem Blog (die im Folgenden als Zitat markierten Stellen stammen aus ihren Artikel):</p>\n<p><a href=\"http://silenttiffy.de/2012/04/der-dumme-neid/\">I Der dumme Neid</a></p>\n<p><a href=\"http://silenttiffy.de/2012/04/rat-fur-neider/\">II Rat für Neider</a></p>\n<p><a href=\"http://silenttiffy.de/2012/05/es-ist-nicht-alles-neid-was-grantelt/\">III Es ist nicht alles Neid, was grantelt</a></p>\n<blockquote>\n<p>“Ich hasse den Anblick von Hüllen großer Talente, die der Neid zerfressen hat, bevor sie sich entfalten konnten. Schlaflos machen mich auch die Opfer des Neides, denen dieses Unrecht widerfährt. Was soll diese unnütze Emotion eigentlich? Was kann man tun, wenn man ohnmächtig ist vor Neid? Wie geht man als Beneideter mit Neidern um? Kann man dieses Unkraut auch jäten?”</p>\n</blockquote>\n<p><strong>Neid ist deshalb schlecht, weil er sich nicht in etwas Konstruktives formen lässt. Missgunst möchte nicht Kreieren, ausser das eigene Ego.</strong> Es gibt keine Möglichkeit aus den Kommentaren von Neidern bereichernde Erkenntnis zu gewinnen und diese dann zum Wachsen und Weiterentwickeln zu nutzen. Wir müssen lernen damit zu leben: Zerstörerische Kommentare sind immer vorhanden und möchten unsere Zeit und unsere Aufmerksamkeit stehlen. Wir müssen ihnen beides nicht geben, auch wenn es in den Fingern kribbelt zu antworten und sich zu rechtfertigen.</p>\n<p><strong>Sich zu rechtfertigen ist immer gut, aber nur inhaltlich und nicht als Person.</strong></p>\n<p>Ich halte es meist so, dass ich Menschen nicht bewerte/abwerte, die mir mit Neid oder Missgunst entgegentreten. Diejenigen Menschen, die meiner Person bewusst oder unbewusst Schaden zufügen wollen. Ich entferne sie einfach kommentarlos aus meinem Alltag und widme mich den Dingen, die mich nicht lediglich bremsen.</p>\n<p>Bei dem Phänomen “Neid” handelt es sich nicht um ein reines Internetphänomen und ich stehe auch nicht im Mittelpunkt der Aufmerksamkeit und des Neids, sondern der Neidmechanismus betrifft auch unzählige andere Menschen. Viele von Euch werden es noch aus Schulzeiten kennen, wenn “Freunde” Eure erzielten Erfolg relativieren: “Naja, du hast aber so viel gelernt! Das war ja auch klar, dass du eine gute Note schreibst.” Ich habe diese Menschen schon immer konsequent aus meinem Freundes- und Bekanntenkreis gestrichen - allerdings ohne sie abzuwerten und mit Verständnis für ihr defizitäres Denken. Anfangs fühlte sich das “Aufgeben” von Menschen, von Freunde, von Lesern, Followern, potenziellen Kunden oder Bekannten schwer und falsch an, tat aber zusehends besser und besser.</p>\n<blockquote>\n<p>“Über das Gefühl des Neides kann man sagen, dass ihm bestimmte zu hinterfragende Annahmen zugrunde liegen. Erstens: Das, was der Beneidete hat, ist toll. Zweitens: Der Beneidete misst der Sache denselben Wert zu wie ich. Und drittens: Meine Vorstellungen vom Glück, das diese Person aus dem Besitz der Sache zieht, stimmen mit ihrem subjektiven Glück überein. Im praxisnahen Beispiel könnte Neider Fritzi denken: Also, Murmels Blog ist eins der meistgelesenen in Deutschland. Man, das ist toll! Ich wette, Murmel geht da jeden Tag einer ab, bei den Besucherzahlen. Wenn ich so gut schreiben könnte, hätt ich voll das Traumleben. Wie Murmel. Schön wäre, wenn Fritzis Gedankengang nun eigene Initiative folgen würde. Wenn Fritzi Top-Blogger werden wollte, könnte er sich ein Beispiel an Murmel nehmen und ebenfalls jeden Tag stundenlang Recherchen zu diversen Themen treiben, um am Abend in der Lage zu sein, einige kluge Sätze darüber zu schreiben. Leider kommen die meisten Bewunderer nicht über diesen Schritt hinaus. Die Einsicht, selbst nicht auf Anhieb zu können, was der Beneidete scheinbar mühelos kann, ist lähmend, entmutigend, ein Angriff auf das Selbstbewusstsein.”</p>\n</blockquote>\n<p>Neid ist also nur menschlich und taucht in besonders zugespitzer Form im Internet auf. <strong>Als Adressat tut es immer gut sich vom Gefühl des Rechtfertigens frei zu machen, nur noch inhaltliche Diskussionen zu führen und zu akzeptieren, dass der eigene Erfolg und die eigene Art zu leben als Provokation gegenüber denen darsteht, die davon nicht zehren können. Vom Neider vemutete Zufriedenheit ist unser provokativstes Gut!</strong> Es wirkt sehr befreiend zu verstehen, dass diese Kommentare vorhanden sind und es immer sein werden, weil der Mechanimus des Neids einfach zu menschlich ist. Natürlich ist mein “Erfolg” in dem Moment schnell provokativ, in dem man nicht versteht, dass ich jeden Tag hart arbeite, dass ich oft auch an den Wochenenden arbeite, dass ich ständig meine Kontakte pflege, aufbaue und erweitere, dass ich Mails im zweistelligen Bereich Tag für Tag freundlich und voller Liebe beantworte, dass ich eine Marke kreiert habe, dass jeden Tag tolle Ideen von mir erwartet werden, die ich pünktlich und voller Überzeugung abliefere, dass ich ständig telefonisch und auf hunderten anderen Social Media Plattformen und Kommunikationswegen erreichbar bin und Kunden dies auch gerne nutzen und dass ich ständig Deals aushandel und Konzepte entwerfe. Diese Texte und Blogtexte schreiben sich nicht von allein und hinter jedem Blogbeitrag steckt Nachdenken, Analyse, Einbau, Umbau, Schreiben, Posten, Zweifel, Erkenntnis und die Spannung wie die Reaktionen ausfallen. Das Beantworten von Fragen und der Umgang mit Neidern. Ich halte Euch immerzu auf dem Laufenden was ich mache und woran ich arbeite. Nebenher schreibe ich ein Exposé für meinen Roman. Daneben schreibe ich für Zeitungen, Seiten, entwickle kleine Projekte und führe einen Haushalt und ich bin verdammt nochmal nicht immer so glücklich und fröhlich und erfolgreich und reich und beliebt und selbstsicher, wie es den Neidern erscheinen mag. Deswegen muss ich mich schützen. Denn ich gönne mir alles.</p>\n<p>Wie dick aber muss so eine Haut noch werden? Ist dieses Nicht-an-sich-Ranlassen wirklich so einfach?</p>\n<blockquote>\n<p>“Dumm ist der Neid nicht nur, weil man ihm nichts Positives abgewinnen kann. Neid ist dumm, weil er aus fehlerhaftem Denken erwächst. Der Neider leidet an einem selbstgeschaffenen Phantom, das ihn zerfrisst, ehe er seine Falschheit durchschauen kann. […] Was dann folgt, ist ein alberner Schwanz an Gedanken, die auf irrationalste Weise das geknickte Selbst wiederaufzurichten suchen. […] Das Erste, was man gegen die Bedrohung unternehmen kann, ist, die Legitimität des Bewunderten anzuzweifeln. Der Neider sucht nach Widersprüchen, Fehlern und Unvollkommenheiten, einzig um nachweisen zu können, dass die beneidete Person der eigenen schmerzenden Idealvorstellung von ihr nicht standhält. Wenn Fritzi sich selbst (und am besten auch anderen!) klarmachen kann, dass der König seinem Status nicht gerecht wird, hat er die Illusion, die Chancen stünden für ihn besser, eines Tages selbst den Thron zu erklimmen.”</p>\n</blockquote>\n<p>Viele Neider sind in dem Moment, in dem sie fehlerhaft denken sehr egozentrisch und verschaffen sich ihr kurzes Glück über das Zerstören des Glückes der anderen. In diesem Moment assozieren sie mit dem Adressaten keinesfalls den Menschen, den eine solche Bemerkung unter Umständen kränken könnte, sondern eine Bedrohung, die ihr eigens Glück bröckeln lässt. Wer sich misst, wird unglücklich. Wieso andere mehr haben als man selbst? Um sich zu schützen mutmaßt man eine Ungerechtigkeit, die dahinter stecken muss und fühlt sich fast automatisch um sein Glück betrogen und lässt es den Adressaten auch spüren.</p>\n<p>Hilf Dir selber:</p>\n<ol>\n<li>\n<p>Meinungen und Kommentare, die dekonstruktiv sind UND Dich verletzen, sollten Dir keinen Gedanken wert sein.</p>\n</li>\n<li>\n<p>Wenn Du es nicht schaffst diese Kommentare zu ignorieren oder wenn sie sich häufen, dann entferne den Urheber aus Deinem Leben/Netzwerk. Du hast ein Recht dazu!</p>\n</li>\n<li>\n<p>Nutze hingegen die kontruktive Kritik um daran zu wachsen und sei dankbar dafür!</p>\n</li>\n</ol>\n<p>Warum tummeln sich aber gefühlt so viele Neider im Netz? Vielleicht weil die harte Arbeit, die im Bereich der neuen Medien liegt, nicht von vorneherein sichtbar und für jedermann transparent ist? Weil das Internet neue Stars produziert hat? Und weil es sich nicht um Lohnarbeit handelt, an der die Investion von Zeit und Ausbildung einfach ablesbar ist?</p>\n<p>Silenttiffy gibt einen schönen Tipp für von Neid Betroffene, um das eigene Handeln zu reflektieren:</p>\n<blockquote>\n<p>“Was mag der Preis des Erfolges (gewesen) sein, den ich einem anderen missgönne? Und wäre ich selbst bereit, diesen Preis zu zahlen, wenn keine anderen Hindernisse mir im Weg stünden? Würde ich das höchste Tier im Betrieb sein wollen, wenn ich das Büro jeden Tag nicht vor 22:00 verlassen könnte? Möchte ich meine sozialen Kontakte der Einsamkeit des Schriftstellers opfern? Hätte ich die Nerven, mich als öffentliche Person verletzender Kritik auszusetzen? Niemand, der seine Sache gut macht, tut es einfach so. Überall müssen Prioritäten bestimmt und Opfer erbracht werden.”</p>\n</blockquote>\n<p><strong>Dass man diejenigen, die einen mit Missgunst bedenken, mit Respekt und Verständnis behandeln sollte, bedeutet noch lange nicht, dass man ihre Worte bis zu sich durchdringen lassen muss!</strong></p>\n"}

/***/ }),
/* 677 */
/***/ (function(module, exports) {

	module.exports = {"title":"Neues Blitzkrieg Mixtape 3000 DEN TIGHTS","date":"2012-11-03 14:50:09 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/mutant.jpg\" alt=\"mutant.jpg\" />\n<p>Es ist Samstag und eine Menge Zeit für Mixtapes, Pasta selber machen, Schweinebraten, Katzen streicheln und sich gut zu fühlen. Also, 3000 DEN TIGHTS anmachen, schön sein und Ada Blitzkrieg auch bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen!</p>\n<p>Die Illustration stammt übrigens von meiner Freundin <a href=\"https://www.facebook.com/mathilda.mutant/\">Mathilda Mutant</a>.</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/3000-den-tights\">player</a></p></p>\n"}

/***/ }),
/* 678 */
/***/ (function(module, exports) {

	module.exports = {"title":"Neues Blitzkrieg Mixtape TURNVATTER","date":"2013-04-03 00:00:00 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/turnvatter.jpg\" alt=\"turnvatter.jpg\" />\n<p>Feierabend. Packt also besser mal Eure Adidas Franz Beckenbauer Sporthosen in Größe S Made in Westdeutschland aus, schmeißt das Mixtape auf dem Grammophon an und folgt Ada Blitzkrieg auch bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a>!</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/sets/turnvatter-mixtape\">player</a></p></p>\n"}

/***/ }),
/* 679 */
/***/ (function(module, exports) {

	module.exports = {"title":"Neues Blogdesign und Mixtape:","date":"2014-07-24 14:18:46 +0000","tags":null,"layout":"post","body":"<img src=\"http://media-cache-ak0.pinimg.com/736x/56/fe/5e/56fe5e788949ede1f4e80efebfea8657.jpg\" alt=\"\">\n<p>Vorweg: Es tut mir leid, ich blogge wieder!</p>\n<p>Heute geht auch nach wochenlanger Textabstinenz das neues Blogdesign online. Warum ich die letzten Wochen nicht aktiv war, werde ich in den nächsten Tagen in einem ausführlichen Beitrag mit dem Titel <strong>“Die Dürüm Depression”</strong> eingehender beleuchten. Und nun zum Mixtape.</p>\n<p>Tierisch Lust auf Sommer und gerade keine fleischfarbenen Birkenstock zur Hand mit denen ihr erbesengroße Kugeln Rosmarin-Blutorangeneis in Prenzlauer Berg für den Gegenwert eines Neuwagens essen gehen könnten? Kein Problem! Einfach Fenster weit aufreissen, Mixtape an und Ada Blitzkrieg bei <a href=\"https://soundcloud.com/bangpowwww\">SoundCloud</a> folgen!</p>\n<iframe width=\"100%\" height=\"450\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/41354678&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>\n"}

/***/ }),
/* 680 */
/***/ (function(module, exports) {

	module.exports = {"title":"Neuigkeiten zum Roman","date":"2012-12-07 00:00:00 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/ada1111.JPG\" alt=\"ada1111.JPG\" />\n<p>Es freut mich heute Folgendes bekannt geben zu können:\nIch mache es nun offiziell. Als <strong>Erscheinungstermin</strong> für meinen <strong>Roman</strong> ist der <strong>17.12.2012</strong> geplant. Das Buch wird zunächst als eBook erscheinen und über den <strong><a href=\"http://www.amazon.de/ebooks-kindle/b?ie=UTF8&node=530886031\">Amazon Kindle Shop</a></strong> verfügbar sein.</p>\n<p>Im Blitzkrieg HQ arbeite ich gerade auf Hochtouren an den letzten Korrekturen und Feinschliffen und heule und lache Tränen, weil der Inhalt mich so bewegt. Es freut mich ganz besonders, dass dieses Sahnebonbon der Popliteratur noch vor Weihnachten fertig wird.</p>\n<p>Wer von Euch bloggt oder journalistisch unterwegs ist, darf sich freuen: Ich würde gerne noch vor dem offiziellen Veröffentlichungstermin einige <strong>kostenlose Exemplare</strong> meines Romans unter <strong>Blogger und Freunde</strong> bringen, die gerne ein paar Worte dazu in ihren Blogs oder Homepornos verlieren dürfen. Wer daran Interesse hat, schickt mir einfach eine kurze Mail an: <strong><a href=\"mailto:kontakt@textkrieg.de\">kontakt@textkrieg.de</a></strong></a></p>\n<p>Am 17.12 folgen auch ein paar weitere schöne Aktionen und Neuerungen rund um die Textkrieg-Homepage. Ihr dürft also gespannt sein und es nun in die Welt hinaus tragen. Mein Baby ist bereit für die Welt. Aber ist es die Welt auch für mein Baby?</p>\n<p>Ich weiß was Ihr Euren Freunden und besonders Euren Feinden zu Weihnachten schenken solltet.</p>\n"}

/***/ }),
/* 681 */
/***/ (function(module, exports) {

	module.exports = {"title":"Neulich im Supermarkt","date":"2012-10-05 14:04:30 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/Foto1.JPG\" alt=\"Foto1.JPG\" />\n<p>Hinter mir am Kassenband steht Christine, die von Freunden in lockerer Runde auch gerne mal Tine genannt wird. Sie steht ziemlich nah dran an meiner ohnehin schon viel zu ängstlichen Person und ich spüre den Druck ihrer Gedankenpaste durch die schmalen Spalten meiner Herzschutzhülle quillen. Tine hat Zeit, denn sie ist Hausfrau und Mutter und eigentlich muss sie sehen wie sie ihren langen Tag gefüllt bekommt. Diese Zeit will sie aber Leuten wie mir nicht einfach so ohne Gegenleistung schenken, denn ich bin gesellschaftlich wertlos und kein Macher, sondern bloß eine 1,75m hohe Fettmuskelblockade, die sich mit ihrem Cerealienschrott und den drei Rucolapäckchen zwei Meter über das Kassenband aufgebahrt hat und wichtige Leute von noch wichtigeren Dingen abhält. Gesellschaft. Einen Sinn haben. Kinder kriegen zum Beispiel oder abgelaufene Medikamente entsorgen. Eine Familie ernähren. Kinder erziehen. Für unsere Rente sorgen. Deutschland unterstützen. Entschuldigung, Tine! Aber nur noch drei Mal Staubsaugen und dann kommt dein Manuel endlich aus dem Büro nach Hause und freut sich auf den ruhigen Feierabend mit dir. Brot mit Halbfettmagerine. Ein schönes Bier und du einen halbtrockenen Wein. Der darf auch mal was kosten. Das Glas gönnst du dir. Drei verschiedene Sorten Wurst. Aber die vom Kerner und morgen dafür aber Sport. Radieschen. Pfeffer. Ein schöner Käse. Von der Theke. In einem Behälter. Bei euch existiert eine Butterdose.</p>\n<p>Hast du schon wieder im Büro geraucht? Es war so ein stressiger Tag. Ja, hier auch. Es muss blitzblank in der Wohnung sein und das nicht aus Langeweile, sondern aus dem Herzen. Das Laminat ist in moderner Holzoptik. Täuschend echt und viel funktionaler. Das bekommt man mit einem Wisch sauber. Ausserdem spielen die Kinder doch auf dem Boden. Die mittelmäßig vielen Gegenstände in den Regalen, die Leonardo Gläser und die Hochzeitsfotos sind gerade noch persönlich genug um nicht unpersönlich zu sein. Aber unpersönlich genug um keinen Fetisch haben zu können oder bei wem auch immer mit was auch immer anzuecken. Nicht aufdringlich. Das sind sie nicht. Man möchte sich mitteilen. Schaut, unsere Familie kommuniziert! Wir benutzen auch Internet. Unsere Hochzeit. Meine Facebookseite. Das ist die von Tine. Die Kinder. Unsere Urlaubsfotos. Meine Frau putzt gut. Wir haben ein gutes Leben. Aber auch nicht zu gut. Niemand soll das denken. Es wird hart gearbeitet und es wird ordentlich geputzt und es wird sich informiert. Die Nachrichten sind mal wieder schrecklich. Um 20:15 wird umgeschaltet. Die Kinder ins Bett bringen und dann abschalten. Tisch für den nächsten Tag decken. Wecker stellen. Solche Leute schaffen es sogar mit der Knopfleiste nach unten einzuschlafen.</p>\n<p>Ich bin für Tine hingegen nur die unglaublich langsame Frau, die für das Auflegen der Waren am Kassenband kein System hat. Systemlos. Unorganisiert. Organisation ist die halbe Miete. Die andere Hälfte ist Planung. Ihr Mann interessiert sich nicht für solche wie mich. Was will man denn auch mit mir? Entweder bin ich zu blöd alles nach ihren Regeln - nach den globalen Regeln des Warenauflegens - zu machen oder ich mache es bewusst nicht. Tine kann sich nicht entscheiden was sie verwerflicher finden soll und entscheidet sich für meine Person. Der Körper drängt weiter Richtung Ausgang. Am liebsten würde sie mich in der Schlange schon mal überholen. Entschuldigung, könnte ich zuerst bezahlen. Verdient. Solche Leute haben sich immer so viel verdient. Was du dir alles verdient hast, Tine! Tine würde nie danach verlangen und wenn sie Lob oder Anerkennung bekommt, würde sie den Verdienst ablehnen. Abwinken. Ach, das mache ich doch gerne! Sie fühlt sich gut dabei. Aber sie will es spüren. Nützlich bist du, Tine! Einer muss es ihr ja mal sagen. Vielleicht so ein dummes Arschloch wie ich? Ich lege ja immer noch Lebensmittel auf das Gummiband. Ist das denn wahr? Immer noch. Sie ist hinter mir und braucht für die dreifache Menge an Waren nur ein Drittel meines Platzes und ist in der halben Zeit fertig. Ich lege immer noch nicht enden wollende Mengen Butterklötze auf das Kassenband. Bremsklotz des Lebens. Ich halte sie darin auf perfekt zu sein. Ihr Körper drängt immer weiter in Richtung des Ausgangs zu ihrem blöden Kastenwagen und dem Kofferraum mit der Blumenerde. Wenn sich zwei Tines treffen, reden sie nur über ihre Beschäftigtkeit und die der anderen. Beschäftigt sein. Ohne mich hättest du gar keinen Haken an dem du deine Geschäftigkeit voran treiben könntest, Tine! Tine ist eine Frau, die kann. Es ist eine Kunst die Waren auf das Kassenband zu legen, dass es so aussieht als kostet es zwar keine Mühe, denn Beeilen ist ja auch verkehrt, aber dass man immer merkt, dass für die anderen mitgedacht wird. Tine ist eine Künstlerin. Wir sind alle wichtig. Niemanden aufhalten. Geben und Nehmen. Und das erwartet sie von den anderen auch. Auch wenn sie das nicht durchblicken lassen würde, nur ihr Körper. Dieser verinnerlichte Kassenknigge ist natürlich jahrelang angewachsen. Jeder hat mal klein angefangen. Aber Warenauflegen ist ja bekanntlich Krieg und da darf man keine Schwäche zeigen. So jemand wie ich kann für die Selbstbestätigung gerne mal geopfert werden. Immer das Gleiche. Jeden Tag einkaufen gehen und dann die Leute mit dem drängelnden Körper anpampen. Ich lehne den Supermarkt ab. Ein Mal in der Woche einkaufen ist das Maximum das ich mir aus meinem ausgenörgelten Energiereserven entlocken kann. Den Wagen bis oben vollpacken und nichts vergessen. Bloß nicht nochmal los müssen in diese Hölle zu Tine und zu Dieter. Der steht vor mir. Bei Tine ist das nicht so. Die steht hinter mit. Soll ich doch ruhig wissen wie scheiße mein Leben ist. Dass ich es auch nach Jahren des unregelmäßig Einkaufens, nach Jahren mit Umzügen, Trennungen, Depressionen, Manien und Niederschlägen nicht schaffe in dem Supermarkt, den ich erst seit einigen Tage neu besuche eine Routine aufgebaut zu haben ist natürlich sehr zu verachten. Aber die schafft immer alles. Die bewältigt ihren Haushalt und ihr Mann dankt es ihr. Ich versuche zu arbeiten und zu überleben und schaffe nichts von beiden. Es sollte eine extra Kasse für Menschen wie mich geben. Du bist besser und an der Kasse darfst du das ausnahmsweise auch mal spüren, Tine!</p>\n<p>Der Dieter schiebt seine vier Produkte ganz eng zusammen. Freiräume dürfen unter keinen Umständen entstehen. Nicht gestört werden und niemanden stören. Schnell sein. Rein. Raus. Niemanden aufhalten. Tüten aufschütteln. Keinen Fehler machen. Nur raus. Nur nach Hause. Gelobt werden. Ducken. Sogar im Supermarkt.</p>\n<p>Hast du alles mitgebracht? Ja. Danke! Damit kann er eine Woche leben. Er hat etwas richtig gemacht. Wenn er etwas richtig macht, dann fühlt sich das gut an. Wenn er seine Einkäufe nur akurat genug hinlegt wird ihm schon nichts passieren. Mit System. Vier Waren. Er kauft auch nur den Rest ein, den seine Frau vergessen hat. Sybille arbeitet auch Vollzeit, bekommt aber trotzdem die Familie und das Geschäft unter einen Hut. Sybille. Von Sybille gelobt werden. Sybille glücklich machen. Nur die vier Kleinigkeiten soll er noch mitbringen. Sie hat die Liste in Druckbuchstaben geschrieben damit Dieter kein Fehler unterläuft. Sie will, dass Dieter auch Erfolg hat und sie beide später Erfolg haben, weil alle Zutaten für das Abendessen vorhanden sind. Sie arbeitet für ihren Erfolg und für den der anderen. Für das gemeinsame Glück. Mit System. Das Glück darf nicht brüchig werden. Wenn erst eine Ritze entsteht ist diese für immer unfüllbar. System schützt. Wir handeln. Dieter wird heute kein Fehler unterlaufen. Das ist ihm schon zu oft passiert. Nie wieder. Was für ein Tag! Erst die beiden schweren Sachen auf das Band. Dann die leichten Lebensmittel. Erst die schweren Produkte in die Tüte einpacken und dann die leichten. Die Tüte hält er griffbereit. Sie wird heute nicht reissen. Das Geld ist abgezählt. Er stiehlt niemandem die Zeit. Er ist vorbereitet. Er macht alles richtig. Glück.</p>\n<p>Ein Kind schreit im Kassenbereich. Nein, nein, nein, seine Kinder mit zum Einkaufen zu nehmen und dann ihr Geschreie nicht einstellen können. Die Eltern sind Versager. Wenn die Eltern gucken - zaghaft lächeln. Ach ja, man will nicht konfrontieren. Tine und Dieter. Und man darf ja auch sowas nicht denken. Und über Kinder schon gar nicht. Die Eltern sind der Fehler. Die Kinder sind unschuldig. Aber das Schreien nervt. Als wenn es direkt aus den Mündern der Eltern dringen würde. Kinder sind doch nur ein Sprachrohr. Da muss man viel früher ansetzen. Deutschland ist ja gar nicht so. Tine und Dieter lieben Familie. Die Erziehung muss eben stimmen. Schreiende Kinder im Supermarkt. Das muss nicht sein. Kinder alleine Zuhause lassen und dann Einkaufen gehen. Womöglich noch Zigaretten. Wer macht denn sowas? Eine Nanny? Zu unpersönlich. Sein Kind früh in die Kita geben? Das ist so gemein. Die werden doch schon immer mit drei Jahren in den Kindergarten gepackt und dann mit Sieben in die Schule. Und dann haben sie mit 17 mittlere Reife und können den Familienbetrieb übernehmen oder eben etwas rebellieren und vielleicht lange Haare haben und eine Band gründen und dann ihr Examen machen und Biolehrer werden. Rebellion ist erwünscht und bringt unser Land voran. Tine und Dieter. Die jungen Leute mit ihrer Energie. Die bereichern unsere Gesellschaft. Immer im Rahmen bleiben. Lächeln. Kind ignorieren. Sowas würde einem ja selber niemals passieren. In Deutschland haben wir das beste Brot.</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/neulich-im-supermarkt\">player</a></p></p>\n"}

/***/ }),
/* 682 */
/***/ (function(module, exports) {

	module.exports = {"title":"Nightlover by Max Seedorf and Airen","date":"2012-01-03 17:45:38 +0000","tags":null,"layout":"post","body":"<p>\n\tNightlover ist ein Film von <a href=\"http://www.maxseedorf.com/\">Max Seedorf</a> nach der Idee von <a href=\"http://airen.wordpress.com/\">Airens</a>&nbsp;Buch <a href=\"http://www.sukultur.de/airen-strobo.html\">Strobo</a>. Ich durfte mit Max Seedorf und Airen an Idee und Konzept mitarbeiten und möchte nun das Resultat präsentieren. Die Clubszenen sind in einem Kreuzberger Club&nbsp;entstanden.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tStrobolicht. Elektrobombardement und Migränephantasien, Nightlover ist der perfekte Begleiter zu Futschi und Spühkonfetti.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<object height=\"281\" width=\"500\"><param name=\"allowfullscreen\" value=\"true\" /><param name=\"allowscriptaccess\" value=\"always\" /><param name=\"movie\" value=\"http://vimeo.com/moogaloop.swf?clip_id=34389867&amp;server=vimeo.com&amp;show_title=1&amp;show_byline=1&amp;show_portrait=0&amp;color=00adef&amp;fullscreen=1&amp;autoplay=0&amp;loop=0\" /><embed allowfullscreen=\"true\" allowscriptaccess=\"always\" height=\"281\" src=\"http://vimeo.com/moogaloop.swf?clip_id=34389867&amp;server=vimeo.com&amp;show_title=1&amp;show_byline=1&amp;show_portrait=0&amp;color=00adef&amp;fullscreen=1&amp;autoplay=0&amp;loop=0\" type=\"application/x-shockwave-flash\" width=\"500\"></embed></object></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tInfos:</p>\n<h2>\n\t<a href=\"http://vimeo.com/maxseedorf\">http://vimeo.com/maxseedorf</a></h2>\n<h2>\n\t<a href=\"http://www.maxseedorf.com/\">http://www.maxseedorf.com/</a></h2>\n<h2>\n\t<a href=\"http://airen.wordpress.com/\">http://airen.wordpress.com/</a></h2>\n<p>\n\t&nbsp;</p>\n"}

/***/ }),
/* 683 */
/***/ (function(module, exports) {

	module.exports = {"title":"OMG Tiere - Videos der Woche","date":"2012-08-22 12:47:44 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/OMG.JPG\" alt=\"OMG.JPG\" />\n<p>Es gibt wenige Menschen, die Musikjournalisten, wie ich ja auch einer bin, noch halbwegs beeindrucken können. Mishka scheint eine Art Allvatter für Reviews zu sein. In diesem YouTube Video wird ein bedeutendes Stück Journalismusgeschichte geschrieben:</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/oclYJWVr01g\" frameborder=\"0\" allowfullscreen></iframe>\n<p>Mein Endgegner:</p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/XxCW83qSyJc\" frameborder=\"0\" allowfullscreen></iframe>\n"}

/***/ }),
/* 684 */
/***/ (function(module, exports) {

	module.exports = {"title":"Ontape Bodi Bill","date":"2011-06-03 14:08:14 +0000","tags":null,"layout":"post","body":"<p>\n\tGestern war ich Gast in der Sendung <a href=\"http://www.tape.tv/channel/ontape\">ontape</a> von <a href=\"http://www.tape.tv/\">tape.tv</a>&nbsp;in der <a href=\"http://www.bodibill.de/\">Bodi Bill</a> ein kleines Konzert gaben und ziemlich absurde Fragen beantworteten. ontape wird live im Onlinestream und einige Tage später bei <a href=\"http://kultur.zdf.de/\">ZDF kultur</a> übertragen. Wir schickten gleich mehrere SMS an unsere Eltern und fühlten uns wie verfickte Stars. Gleich im Fernsehen und der ganze Nation zeigen wie schön und elitär wir sind. Leider sind wir auf der Aufnahme nicht wirklich zu sehen. Zu Beginn der Sendung raunte der beahaarteste der Kameramänner mir etwas zu, das ich erst im Nachhinein als &quot;Etwas freundlicher gucken!&quot; verstand.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tNicht einkalkuliert wurde die enorme Hitze im Studio, das einem alten Gewölbekeller glich. Meine Fresse, Mama, wenn du das siehst, ich schwitze nicht, ich glänze nur so stark um Schiffe zu den Klippen zu leiten. Leider stand neben mir mehrerer Stunden eine Frau mit Echtledertasche. Den Geruch werde ich niemals vergessen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tVorweg - es gab kostenloses Bier und die tape.tv Leute haben sich große Mühe gegeben. Zweifellos bin ich eigentlich auch ein großer Bodi Bill Fan und besitze auch zwei Hornbrillen und den Kunststudentinnen-Blick, aber <a href=\"http://youtu.be/Gqkx2qIqt54\">live</a> sind die Typen einfach nicht zu leiden. Man guckt kurz auf den Boden und alles ist noch normal und wenn man wieder hochsieht, trägt der Sänger ein Vogelkostüm und macht &quot;Kunst&quot;. </p>\n<p>\n\tDem netten Moderator, Rainer Maria (so habe ich es jedenfalls verstanden), gab der Sänger nur patzige Antworten, die arrogant und zugleich wenig wortgewandt waren. Der arme Rainer Maria, dachte ich und dann war die Sendung auch schon vorbei.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tBodi Bill ist und bleibt für mich eine Daheim-Hör-Sache. Wunderschöne Musik, die mir den Speichelfluss anregt und mich von Berlin Mitte, Dachterassen und Club-Mate-Feldern träumen lässt. Konzerte enttäuschen mich regelmäßig. Zu voll, zu kurz, zu teuer. Die ontape Aufnahmen überzeugen mich dennoch wieder vom Gegenteil.</p>\n<p>\n\tFazit: Unbedingt bei einer Limonade auf dem Balkon anschauen.</p>\n<p>\n\tDie ganze Sendung gibts hier zu sehen: <a href=\"http://www.tape.tv/channel/ontape\">ONTAPE</a></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"304\" src=\"/files/bodibill2.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/bodibill3.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/bodibill1.jpg\" width=\"500\" /></p>\n"}

/***/ }),
/* 685 */
/***/ (function(module, exports) {

	module.exports = {"title":"Optimier dich doch selbst, du Opfer!","date":"2014-06-05 15:46:37 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://media-cache-ak0.pinimg.com/736x/05/57/49/05574905354f39ee6785f9ced7a6b2ea.jpg\" alt=\"Alt text\"></p>\n<p>Es ist kurz vor 9 mitten in Manhattan, New York. Am Abend. Ich weiß das heute und in der Regel sowieso immer ganz präzise, weil ich mich vorher mit diesem ganzen p.m. und a.m. Rumgenöle der Amis und der sonstigen coolen Restwelt beschäftigt habe. Ich bin so ein geil kontrollierter Typ (weiblich), zumindest erwecke ich im Kopf meines Gegenübers (zum Beispiel dem Internet) offenbar den Anschein, dass meine gelegentlichen Ausfälle kontrolliert und süß wären. Eher Koketterie als Realität. Denn eigentlich sehe ich ja voll spitze aus, produziere tolle Ideen und bin ein erstklassiges Mädchen. Unsinn! Glaubt man aber von mir. Ich muss ja irgendwie alles im Griff haben, denkt man, denn ich lebe ja, sagt man, ernähre mich und bin dazu noch ein äußerst lustiger Zeitgenosse. So ein richtiges Positivbeispiel für alles mögliche. Sollten die anderen Kinder und besonders die anderen Mädchen doch auch alle so sein. So natürlich geblieben und schrecklich selbstsicher und der ganze geile Kram aus den Joghurtwerbungen. Schmarrn! Wer mich persönlich kennt, weiß um meine unzähligen Mängel. Und die gehören, so ist es eben, untrennbar zu meiner Person und meinem Selbstbild.</p>\n<p><img src=\"http://media-cache-ak0.pinimg.com/736x/4c/fd/bc/4cfdbcdc7e75c827ee310d58084d6699.jpg\" alt=\"Alt text\"></p>\n<p>Hallo! Ich möchte gefälligst darum kämpfen als fehlerhaft wahrgenommen zu werden. Ich möchte dies aus der festen Überzeugung tun, dass nicht nur mir und meinem Selbstbild diese Ehrlichkeit entscheidend gut tut, sondern ich möchte ebenso dem Optimierungszwang und den hässlichen Seiten des Optimierten-Selbst, dem immer aggressiver werdenden Shaming von Menschen, die in den Augen der Gesellschaft vermeintlich nicht die “optimale Version” ihrer Person sind, meinen ausgestreckten Mittelfinger entgegenhalten - und dabei möchte ich genüsslich einen dicken Joint rauchen und ohne Zähne zu putzen ins Bett gehen und dann noch ein Schokoladeneis essen und in Katzenhaaren liegen.</p>\n<p><img src=\"http://photos-e.ak.instagram.com/hphotos-ak-xfa1/914374_1411128195838324_1525815583_n.jpg\" alt=\"Alt text\"></p>\n<p>In wenigen Minuten wird der Fressmarkt am Union Square schließen. Dreißig Foodtrucks stehen auf dem Court in Reih und Glied und liebäugeln mit den Passanten um die kleinen Plastikkarten mit denen sie hier alles bezahlen und die immer etwas nach Arsch riechen. Oh, jetzt ist Eile geboten. Kurz vor 9. Nein, gleich machen die hier alles dicht! Ich kippe schnell im Park noch eine Flasche Weißwein in mich und meinen Freund rein. Natürlich heimlich und in Sodadosen umgefüllt. Dreißig Grad an diesem Tag. Dunkle Achselflecken auf dem weißen T-Shirt. Hot! Die Sonne hat sich, Gott sei Dank, schon hinter den großen Büroklötzen verabschiedet und lässt mich mit meiner Lobster Roll Hautfarbe für heute in Ruhe. Gelber Ficker! Mein großen Poren schwitzen Matsche aus. Ich bin den ganzen Tag gelaufen wie ein Aufziehmännchen. Das Mädchen in der großen Stadt. Über den Williamsburg Flea Markt flaniert. Zur Brooklyn Bridge. Wieder nach Manhattan. Ins Hotel. Aus dem Hotel. Zum Weindepot. Zurück. Den Flaschenöffner vergessen. Hin und her. Nun sitze ich hier und habe Wein im Kopf.</p>\n<p>Die erste Auster meines Lebens verschwindet an diesem Stand in mir. $1,50 und ich bin schwer begeistert und fühle wie ich vor Glück auf dem heißen Asphalt zerberste und einfach mal die Kontrolle verliere. Etwas salzig und das Fleisch glibbert einem nur so die Fressröhre runter. Ich habe matschiges Austernfleisch im Bauch. Wie herrlich absurd und skurril sich das anfühlt! Heute soll mir alles recht sein. Ich habe jahrelang keinen Fisch gegessen und nun, mit 28, schlägt die Geilheit des Meeres einfach so zurück und bekommt mich doch noch. Wehren kann ich mich nicht. Ich bin stolz darauf, dass es mir schmeckt. In mir brennen Tausend Lichter der Freude und der Selbstliebe. Meine Wangen sind vom Wein errötet und ich bin verliebt in meinen Freund, der im Folgenden das Glück hat mich bei meiner Explosion beobachten zu dürfen.</p>\n<p>Nur heute, das denke ich regelmäßig und gebe mich Exzessen und Ausschweifungen hin. Nur kurz. Nur schnell und eilig so viel wie man kann. Alles vollstopfen mit Suff, Freude, Essen, Sex. Die Reserven füllen. Es werden dunkle Tage kommen. Und sie kommen. Schnell kaufe ich mir noch allerhand Essbares auf dem Markt. Eine Holzofenpizza mit vier Käsesorten, zwei fettige Duck Buns, ein leckeres Eis. Dann stellen wir uns in der langen Schlange vor Shake Shack an. Wir lachen. Essen einen gigantischen Burger. Und Pommes, also Cheese Fries, und ein Getränk. Mein Bauch quillt vorne über die Hose. Ich berühre ihn. Ein Wein wird schnell aus der Apfelsaftdose hinterhergekippt. Wir bleiben kurz atemlos sitzen. Tolle Stadt! Tolle Ada! Nur das Rauchen beginne ich an diesem Abend wieder nicht. Ich würde aber, wenn ich Lust drauf hätte. Zum Glück kommt niemand vorbei und verkauft mir Hasch-Trüffel. So bleibt es eben nur beim Essen pumpen und schwitzen wie so ein vollgefutterter Mensch es eben tut. Wir ziehen weiter. Die Auswahl in New York ist der Wahnsinn. Artichoke New York Slices. Jedes Slice an sich ist so groß wie eine herkömmliche Pizza und etwa drei Mal so schwer. Vier herrliche Zentimeter Cheese-Artichoke thronen auf dem dicken Pizzaboden. Es werden drei Slices. Für mich. Und ein Eisbecher bei Momofuku, der nach Cerealien Milk und Liebe schmeckt und mit zuckrigen Cornflakes verziert ist. Mir ist megaschlecht.</p>\n<p>Hui! Die letzten Meter nach Hause krieche ich mehr als dass ich sie laufe und werde die ganze Nacht im Bett liegen und mich fragen: <em>Was habe ich nur gemacht? Warum optimiere ich mich stattdessen nicht lieber? Aber muss das denn jetzt echt sein, denke ich und dann kommt plötzlich die tolle Ada um die Ecke, diese eine die ich so liebe und sagt der blöden Ada, der mir der Reue: Junge, egal! Wir sind eine Person. Fuck that shit! Es ist einfach nicht wahr, dass ich dich trotzdem mag! Sondern ich mag dich genau deswegen! Und das ist der kleine Unterschied. Und das müssen wir alle noch lernen.</em></p>\n<p><img src=\"http://media-cache-ec0.pinimg.com/originals/c1/bc/16/c1bc16d364f02d8ba1c1e4dfca1ace0e.jpg\" alt=\"Alt text\"></p>\n<p>Die Tendenz ist eindeutig: Ob Women-Running-Night, Schwangerschaftssport oder Akademikerinnen-Yoga, ob dies, ob das - wir versuchen uns alle zu optimieren. Laufhosen. Bauchfrei. Ich habe keinen Bock mehr. Bester Abschluss. Beste Feministin mit der richtigsten Ansicht. Antideutscher als alle anderen. Das neuste Modell Schuhe. Schönste Selfies. Vegan. Biomarkt. Das tollste Haustier. Optimaler Haarschnitt. Alles im Griff haben. Kleidung, die der Figur schmeichelt. Und die Gesellschaft steuert auch ein nicht so unwesentliches Por­ti­ön­chen Druck dazu. Optisch, psychologisch, sozial und auf allen anderen erdenkbaren Wegen - es geht immer etwas besser. <em>Wir verlieren also am laufenden Stück gegen die Vorstellung, die wir von einem besseren Selbst haben. Aber was bedeutet das überhaupt? Sich optimieren? Sich verbessern? Gibt es überhaupt eine bessere Version von sich selbst? Ist es nicht respektlos gegenüber sich selbst und den Menschen, die einen als Person lieben, wenn man sich durch Teilhabe an Optimierung in seiner jetzigen Person selber herabwürdigt? In seinen Bedürfnissen und Ideen? Wenn man seine Gegenwart opfert? Entwürdigt man sich damit nicht? Ist es nicht eigentlich eine unfassbare Unverschämtheit sich selber als schlechtere Version von sich selbst zu verstehen?</em></p>\n<h2>Im Ernst: Ich bin die beste Version, die es von mir gibt!</h2>\n<p><img src=\"http://media-cache-ec0.pinimg.com/736x/49/28/8a/49288ade21f1baf64530d2a2c8aff508.jpg\" alt=\"Alt text\"></p>\n<p>Führen wir uns unsere eigene Person vor Augen. Lernen wir halt mal uns nicht nur als “nicht optimal” zu akzeptieren, sondern eben dieser nicht-optimalen Person den Vorzug über die langweilige Optimalversion zu geben. Sie mehr zu schätzen. Uns dafür zu lieben, dass wir uns nachts um halb vier noch drei Pizzen nach zwei Flaschen Suff in den Backofen stellen und am nächsten Tag verpennen und mit schmutziger Unterwäsche zur Arbeit hechten. Ist das nicht lustig? Haben wir damit nicht Größe bewiesen? Und dafür brauch es nichtmal einen dummen Hashtag und einen aussagelose Kampagne von der Stange einer verschissenen Mineralwassermarke, die am Ende doch nur wieder Kundinnen binden will, die “etwas anderes ticken”, aber “trotzdem auf sich achten”. Ich will hier nichts von #100happydays oder #sizezero Dreck hören. Ich will verdammt nochmal, dass ihr euch etwas entspannt in dieser Welt!</p>\n<p>Zum Abschluss meine zwei schönster Fail-Moment der letzten beiden Wochen in optisch nicht so ansprechender Form. Und ich finde mich trotzdem noch ziemlich in Ordnung. Und die Pizzen auch.</p>\n<p><img src=\"http://photos-c.ak.instagram.com/hphotos-ak-xpf1/10375750_656263014467034_218273161_n.jpg\" alt=\"Alt text\">\n<img src=\"https://farm6.staticflickr.com/5037/14349513081_600d59d441_z.jpg\" alt=\"Alt text\"></p>\n"}

/***/ }),
/* 686 */
/***/ (function(module, exports) {

	module.exports = {"title":"Paint your favorite blogs!","date":"2012-08-03 12:29:00 +0000","tags":null,"layout":"post","body":"<p>It´s raining the whole day and i paint some of my favorite blogs.</p>\n<img src=\"/content/images/Foto-_7_.jpg\" alt=\"Foto-_7_.jpg\" />\n[Cats With Guns](http://www.buzzfeed.com/tiad/cats-with-guns) - \"It looks like some violence is about to go down.\"\n<img src=\"/content/images/Foto-_6_.jpg\" alt=\"Foto-_6_.jpg\" />\n[Indifferent Cats in Amateur Porn](http://indifferent-cats-in-amateur-porn.tumblr.com/) - \"They're watching us but they don't care at all.\"\n<img src=\"/content/images/Foto-_5_.jpg\" alt=\"Foto-_5_.jpg\" />\n[No Breasts No Requests](http://nobreastsnorequests.tumblr.com)- \"Notes & signs found around the DJ booth.\"\n<img src=\"/content/images/Foto-_4_.jpg\" alt=\"Foto-_4_.jpg\" />\n[Girls Making Gun Sounds](http://girlsmakinggunsounds.com) - They do.\n<img src=\"/content/images/Foto-_8_.JPG\" alt=\"Foto-_8_.JPG\" />\n[Cook Suck](http://cooksuck.com/) - \"Internet food police.\"\n<p>What are your favorite blogs? Send me paintings of them and I’ll publish the best pictures on my blog!</p>\n"}

/***/ }),
/* 687 */
/***/ (function(module, exports) {

	module.exports = {"title":"Partykapitalismus","date":"2011-11-01 17:04:07 +0000","tags":null,"layout":"post","body":"<p>\n\t<img alt=\"\" src=\"/files/plu.jpg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tHallo, ich bin keine Party. Hey, ich meine, was soll das alles immer? Können wir bitte einfach damit aufhören?&nbsp;Dieser ewige Wettlauf um die besten Wochenendaktivtäten, den interessantesten Freundeskreis und die qualitativ besten Sozialkontakte. Wer bewertet das eigentlich? Unterliegen Menschen, Erlebnisse und Erinnerungen auch der Mode? Erkenntnisgewinn durch Maximierung. Soziales Glück durch das Überbieten anderer. Was schon bei materiellen Dingen eklig daherkommt, wirkt bei Aktivitäten auch nicht wirklich schöner. Das ist der Partykapitalismus.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tFrüher, da zählte noch die Qualität der sozialen Interaktionen. Die beste Freundin. Ewige Telefonate über Jungs, mit Pipi gefüllte Wasserbomben und unsere blöden Eltern. Wir waren zu zweit, vielleicht auch mal zu dritt, aber nie mehr als das. Und wenn es doch passierte, dann spalteten wir uns auf in Gruppen, die einander bekriegten, hassten und anschrien. Manchmal waren wir uns auch einfach egal. Und wir hatten diese merkwürigen Ponyfrisuren und Armbänder, die steif waren und sich wie von selbst um den Arm wickelten, wenn man sie darauf schlug.&nbsp;</p>\n<p>\n\tIn einer Zeit, in der wir nur ein Mal in der Woche duschten und uns unsere eigenen Weihnachtsgeschenke nicht danach aussuchten, was vielleicht den anderen Kindern gefallen könnte, sondern was wir selber von Herzen liebten. Heute ist es andersrum. Mit allem. Der gesunde Egoismus ist verlorengegangen. Heute muss man alle kennen und man muss mit vielen unterwegs sein. Am besten immer. Und das soll funktionieren? Was bleibt am Ende des Tages? Viele digitale Fotos mit schönen Retroeffekten, ein paar &quot;Wow, das sieht nach einem coolen Abend aus!&quot; Kommentare unter unserem Facebookstatus und mit etwas Glück das Gefühl mit jedem ein paar Worte ausgetauscht zu haben. Das stolze Gefühl wieder ein paar neue Leute kennengelernt zu haben mit denen man demnächst bestimmt mal wieder ein paar Worte wechselt.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tNun ist es aber bei mir leider so, dass sich für mich einzelne Gespräche in der Gesamtbewertung des Abends nicht simpel summieren, sondern jedes Gespräch einzeln als Gespräch bewertet werden muss. Das beste Gespräch macht meinen Abend. Ich möchte nicht vieles und immer und überall. Ich möchte das Eine, das Wahre und das Schöne. Ich möchte Freude für mich erleben. Meine eigene Freude, die individuell und für andere unbegreifbar ist. Die geheime Freude wiederentdecken und sie nicht teilen, das sollten wir.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tUnd während sich draußen bereits dienstags wieder die ersten fragen, was sie am Wochenende Tolles unternehmen können, möchte ich, dass aus dem &quot;Tollen&quot; einfach ein &quot;Etwas&quot; wird. Warum nicht einfach mal irgendetwas unternehmen und niemandem davon erzählen. Ich rufe einen Freund an.</p>\n<p>\n\t&quot;Hallo, wollen wir uns morgen treffen?&quot;</p>\n<p>\n\t&quot;Ja, was wollen wir machen?&quot;</p>\n<p>\n\t&quot;Nichts.&quot;</p>\n<p>\n\t&quot;Wie jetzt, hast du doch keine Zeit?&quot;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDieser Hedonismus, der ist bestimmt oft eine Lüge. Hedonismus, der sich nicht auf die eigene Freude, das eigene Glück oder die eigenen Bedürfnisse konzentriert, sondern einer Art Dokumentation oder Reportage gleicht. Das Wochenende ist nicht gut. Das Wochenende wird erst gut, wenn wir darüber berichten. Freude existiert nur in der Retroperspektive und in der Reflexion. Was, wenn diese Freude keine aufrichtige Freude wäre? Wieso filmen wir bei einem Konzert mit statt zuzuhören. Ich möchte das Soziale ablehnen. Endlich kommt der Winter.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tSich selber immer wieder rückversichern wie toll man doch ist. Ein Selbstwertgefühl, das nur auf der Anerkennung durch andere fußt, ist kein Selbstwertgefühl sondern ein Eingeständnis.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch nehme mir vor vermehrt Dinge mit mit alleine zu unternehmen, um mich nicht auseinanderzuleben.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n"}

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	module.exports = {"title":"Pferdeshow in Audio","date":"2011-07-16 12:02:30 +0000","tags":null,"layout":"post","body":"<p>\n\t<img alt=\"\" height=\"157\" src=\"/files/greeeenblu.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tAus allen Einsendungen zu meinem <a href=\"http://textkrieg.de/2011/07/09/gewinnspiel-mit-pferde-merchandise\">Gewinnspiel</a> habe ich die drei besten Einsendungen ausgewählt. Ihr könnte jetzt abstimmen, welche Aufnahme euch am besten gefällt und wer psychologisch durch den Gewinn meines Pferdemerchandisepakets zerstört werden soll.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEs stehen zur Auswahl:</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<object height=\"81\" width=\"100%\"> <param name=\"movie\" value=\"http://player.soundcloud.com/player.swf?url=http%3A%2F%2Fapi.soundcloud.com%2Ftracks%2F19148745\" /> <param name=\"allowscriptaccess\" value=\"always\" /> <embed allowscriptaccess=\"always\" height=\"81\" src=\"http://player.soundcloud.com/player.swf?url=http%3A%2F%2Fapi.soundcloud.com%2Ftracks%2F19148745\" type=\"application/x-shockwave-flash\" width=\"500\"></embed> </object> <span><a href=\"http://soundcloud.com/bangpowwww/der-gelbe-reiter-pferdewurst\">Der Gelbe Reiter (Pferdewurst-Baxxter X-tra Senf Mix)</a></span></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<object height=\"81\" width=\"100%\"> <param name=\"movie\" value=\"http://player.soundcloud.com/player.swf?url=http%3A%2F%2Fapi.soundcloud.com%2Ftracks%2F19148575\" /> <param name=\"allowscriptaccess\" value=\"always\" /> <embed allowscriptaccess=\"always\" height=\"81\" src=\"http://player.soundcloud.com/player.swf?url=http%3A%2F%2Fapi.soundcloud.com%2Ftracks%2F19148575\" type=\"application/x-shockwave-flash\" width=\"500\"></embed> </object> <span><a href=\"http://soundcloud.com/bangpowwww/pferdammt-lang-her\">Pferdammt lang her</a></span></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<object height=\"81\" width=\"100%\"> <param name=\"movie\" value=\"http://player.soundcloud.com/player.swf?url=http%3A%2F%2Fapi.soundcloud.com%2Ftracks%2F19148670\" /> <param name=\"allowscriptaccess\" value=\"always\" /> <embed allowscriptaccess=\"always\" height=\"81\" src=\"http://player.soundcloud.com/player.swf?url=http%3A%2F%2Fapi.soundcloud.com%2Ftracks%2F19148670\" type=\"application/x-shockwave-flash\" width=\"500\"></embed> </object> <span><a href=\"http://soundcloud.com/bangpowwww/horse-v8\">Horse V8</a> </span></p>\n<p>\n\t<span>&nbsp;</span></p>\n<p>\n\t<span>&nbsp;</span></p>\n<p>\n\t<span>Abstimmen könnt ihr hier:</span></p>\n<p>\n\t<span>&nbsp;</span></p>\n<script type=\"text/javascript\" src=\"http://modpoll.com/poll.js?pid=agdwb2xsMmdvcg0LEgRQb2xsGNva0gcM&amp;theme=white&amp;width=500\"></script>\n"}

/***/ }),
/* 689 */
/***/ (function(module, exports) {

	module.exports = {"title":"Pimp your Silvesterbaum und gewinne!","date":"2013-12-29 11:46:15 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://i40.tinypic.com/244tlpk.jpg\" alt=\"Alt text\"></p>\n<p>Weihnachten ist vorbei und der Baum - stets eine klassische Schönheit - steht deplaziert in dem Raum, in dem wir uns noch zwei Tage zuvor Glückseligkeit und Liebe mit buntem Geschenkpapier und Eggnog vorgegaukelt haben. Dabei wissen Profis längst: Das wahre Fest der Freude ist Silvester und nicht Tradition, sondern die Möglichkeit eines Neuanfangs ist es, die uns stets belebt und den “Betrieb” am Laufen hält.</p>\n<p><img src=\"http://i5.photobucket.com/albums/y197/joeybee12/ChristmasTree011_zps3970af37.jpg\" alt=\"Alt text\"></p>\n<p>Darum rufe ich in diesem Jahr zum großen Baum-Pimpen und maßloser Überdekoration zu Silvester auf!\nPimpt Euren gammeligen Weihnachtsbaum zu einer Ode der trashigen Freude, startet was Neues und packt ein Foto vom Silvesterbaum auf Instagram und mentionend mich mit @bangpowwww!</p>\n<p>Unter den besten Bäumen teile ich meine unbeliebtesten Weihnachtsgeschenke der letzten Jahre auf.</p>\n"}

/***/ }),
/* 690 */
/***/ (function(module, exports) {

	module.exports = {"title":"Platzrebellen","date":"2011-07-13 08:10:34 +0000","tags":null,"layout":"post","body":"<p>\n\t&quot;Beim Vulkan braucht man entweder sieben oder einen Schlag!&quot; pflegte mein Vater zu sagen und es stimmt.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tAuf dem Minigolfplatz zeigen Menschen ihr wahres Gesicht. In erster Linie handelt es sich um &nbsp;Renter, Renter mit Enkelkindern, Renter, die dort arbeiten, Rentnergruppen und aber auch vereinzelte <a href=\"http://www.youtube.com/watch?v=EDW4M5u3eJ4\">Quality-Time-Pärchen</a>. Der Minigolf-Quickie kostet irgendwas um die 2,90 Euro und beinhaltet eine Runde mit 21 Bahnen. Es darf jede Bahn nur ein Mal gespielt werden. Da ist man streng.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"322\" src=\"/files/minigolf2.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tSchmerzlich ließ uns die eingesessene Minigolfgemeinde spüren, dass wir Neuankömmlinge zwar das Geld für die Renovierung der Freischlagbahn einbringen, aber uns gefälligst in das Reglement der deutschen Minigolf-Platzordnung einzufügen zu haben. Wer auffällt verliert. Ich spürte eine Stunde lang die Blicke der Ballsportler im Nacken. Beim Minigolfspielen ist es immer über 30&deg;C.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEs gibt zwei Dinge, die mich ängstigen: Frühmorgens im Schwimmbad aus Versehen eine Bahn zu benutzen, die schon ein Renter beschwimmt oder beim Minigolf die Bahnen in falscher <a href=\"https://twitter.com/bangpowwww/status/90103491774779392\">Reihenfolge</a> zu bespielen.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<br />\n\t<span class=\"Apple-style-span\" style=\"font-family: georgia; font-size: 29px; line-height: 36px; color: rgb(0, 0, 0); \">In Deutschland gilt man als Rebell, wenn man auf dem Minigolfplatz die Bahnen in falscher Reihenfolge bespielt.</span></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tLeider ist es mir nicht möglich mich beim Minigolfspielen als guter Verlierer zu zeigen. Ich bin dort um zu gewinnen. Niemand bezahlt &nbsp;2,90Euro um zu verlieren und niemand hat den Platz ohne Eis zu verlassen. Die Bahnen werden mit unserem Ehrgeiz und unserer Fettsucht finanziert.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tMinigolf gibt es dort jetzt auch als Tischvariante. Keine Ahnung was das soll. Fühlt sich aber an, wie das Gerücht, dass Schokoladenweihnachtsmänner zu Schoko-Osterhasen eingeschmolzen werden. Ich spüre nichts mehr. Am liebsten möchte ich gehen. Ist denn auf nichts mehr Verlass, frage ich mich. Dann scheitere ich mit 7 Schlägen am Vulkan und alles ist wieder gut.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/minigolf4.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEs gibt den Typ Mensch, der Bahnen entweder mit ein oder zwei Schlägen spielt oder in die vollen 7 haut. Erklären kann man das nicht. Ich nenne es das Martin Semmelrogge Phänomen (MSP):</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&quot;<span class=\"Apple-style-span\" style=\"font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif; line-height: 17px; color: rgb(0, 0, 0); \">&nbsp;Beides gehört zum Leben dazu. Nur wer volle Fahrt nach unten rauscht, hat den nötigen Schwung, wieder ganz nach oben zu kommen.&quot; (Martin Semmelrogge)</span></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"335\" src=\"/files/minigolf1.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWer fürchtet sich nicht eine der schlecht erhaltenen Bahnen zu betreten, auf denen in schwarzen Großbuchstaben steht, dass Betreten aber sowas von verboten ist? Der Besitzer könnte ausrasten und einem später kein Calippo verkaufen. Die anderen Minigolfer würden mit Abscheu reagieren. Mir kommt wieder der Gedanke, dass ich eigentlich gerne gehen möchte. Minigolf ist ein harter Sport.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEine Stunde später denkt man darüber nach, welche Bahn man als Obdachloser als Toilette benutzen könnte. Und dann sind die Bahnen auch schon gespielt und man hat nur eine Runde bezahlt und ist ein bißchen froh, wenn man wieder gehen darf.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"325\" src=\"/files/minigolf3.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tAm benachtbarten Kinderspielplatz positioniere ich mich gegenüber der Schaukel und schaue einer 60Jährigen beim Schaukeln unter den Rock.&nbsp;</p>\n"}

/***/ }),
/* 691 */
/***/ (function(module, exports) {

	module.exports = {"title":"Podcasts, I'm in love!","date":"2015-03-06 16:27:20 +0000","tags":null,"layout":"post","body":"<p><img src=\"/content/images/2015/Mar/toast.jpg\" alt=\"alt\"></p>\n<p>Hört mir zu, ich habe euch etwas Wichtiges mitzuteilen! Podcasts sind schwer im Kommen. In meiner Filterbubble hat plötzlich so ziemlich jeder einen eigenen und das ist auch gut so, denn das Format eignet sich hervorragend um es nebenbei zu konsumieren. Ich mag an Podcasts, dass sie keine Aktion erfodern. Kopfhörer auf, Playbutton drücken und nebenbei das tun, was man ohnehin vorhatte. Ich konsumiere inzwischen jeden Tag. Bestimmt im Schnitt eine Stunde. Am liebsten höre ich beim Sport, beim Aufräumen oder Kochen. Und ganz manchmal auch vor dem Einschlafen. Wenn ich richtig stoned bin, bringt der Kuchenpodcast mich gut drauf. Danke Podcasts also dafür! Ich habe als eine kleine Hommage an das Format eine Liste meiner derzeitigen Lieblingspodcasts aufgestellt. Gebt euch das!</p>\n<p><img src=\"/content/images/2015/Mar/lila.jpg\" alt=\"alt\">\n###<a href=\"http://lila-podcast.de/\">Der Lila Podcast</a>\nIm lila Podcast dreht sich alles um Feminismus. Spannend, humorvoll und ohne Zeigefinger. Katrin Rönicke, Susanne Klingner und Barbara Streidl sprechen über Gesellschaft.</p>\n<p><img src=\"/content/images/2015/Mar/tina.png\" alt=\"alt\">\n###<a href=\"http://whyarepeopleintothat.com/\">Why are people into that?</a>\nWhy Are People Into That?! is an indie podcast created, produced, and hosted by Tina Horn. Each episode focuses on a subject of human sexuality and non-judgmentally asks the question: WHY ARE PEOPLE INTO THAT?!</p>\n<p><img src=\"/content/images/2015/Mar/joko.jpg\" alt=\"alt\">\n###<a href=\"http://www.radioeins.de/archiv/podcast/zwei_alte_hasen.html\">Sanft &amp; Sorgfältig</a>\nVermutlich muss ich gar nicht viele Worte verlieren. Kennt ohnehin jeder. Dennoch jeden Sonntag eine neue Episode und ein bis zwei Stündchen Lachen mit Olli Schulz, Jan Böhmermann und Jan Böhmermanns Kaugeräuschen.</p>\n<p><img src=\"/content/images/2015/Mar/Screen-Shot-2015-03-06-at-16-34-38.png\" alt=\"alt\">\n###<a href=\"http://www.blackgirlstalking.com/\">Black Girls Talking</a>\nBlack Girls Talking is a podcast wherein 4 black women discuss pop culture, Beyonce, &amp; the pursuit of the perfect body oil.</p>\n<p><img src=\"/content/images/2015/Mar/wrint.jpg\" alt=\"alt\">\n###<a href=\"http://www.wrint.de/\">WRINT</a>\nJa okay, ein absoluter Klassiker ist auch dabei. WRINT - Wer redet ist nicht tot, ist der Podcast von Holger Klein, der das ganze Gewurste in mehrere Themenreihen eingeteilt hat, die immer wieder aufpoppen: Wissenschaft, Realitätsabgleich, Kochschule und meine Lieblingsserie mit Alexandra Tobor zusammen: <a href=\"http://www.wrint.de/category/wrintheit/\">Die Wrintheit</a>. WRINT gibt es schon tausend Jahre und das aus gutem Grund.</p>\n<p><img src=\"/content/images/2015/Mar/leit.jpg\" alt=\"alt\">\n###<a href=\"http://leitmotiv.cc/\">Leitmotiv</a>\nLeitmotiv ist ein Podcast von Caspar Clemens Mierau, der seine wechselnden Gäste löchert. Er selbst sagt, es seien entschleunigte Gespräche mit über Medien, Kultur, Gesellschaft und diese kleinen Themen, über die man schon immer einmal reden wollte. Und das stimmt so auch.</p>\n<p><img src=\"/content/images/2015/Mar/wir.png\" alt=\"alt\">\n###<a href=\"http://wir.muessenreden.de/\">Wir. Müssen Reden</a>\n“Wir müssen reden” ist der gemeinsame Podcast von mspro und 343max, die sich ab und an zusammenhängen, um die aktuelle “Netz-kultur-politisch-feuilletonistisch-dingsige-Weltlage” zu entaalen. Max ist kürzlich nach San Francisco gezogen um bei Facebook zu arbeiten und hat immer spannende Statusupdates am Start.</p>\n<p><img src=\"/content/images/2015/Mar/bild.jpg\" alt=\"alt\">\n###<a href=\"https://bildungstrinken.com/\">Bildungstrinken</a>\nIntoxication as a Podcast mit moeffju und Jörg Meyer, dem Inhaber der Bar Le Lion in Hamburg. Es geht um Suff. Suffsorten. Geschichten rund um das Trinken, Zubereitung, Cocktails, Longdrinks. Dies. Das. Kultur.</p>\n<p><img src=\"/content/images/2015/Mar/b-.jpg\" alt=\"alt\">\n###<a href=\"http://in-trockenen-buechern.de/\">In trockenen Büchern</a>\nIch liebe Alexandra Tobor. Besonders wenn sie Bücher liest und dann darüber spricht.</p>\n<p><img src=\"/content/images/2015/Mar/kuchen.png\" alt=\"alt\">\n###<a href=\"http://kuchenkram.com/tag/kuchenradio/\">Kuchenradio</a>\n&quot;Backen ist Liebe. Also eigentlich ist Kuchen essen Liebe. Aber irgendjemand muss ja auch backen, wenn gegessen werden will.&quot;</p>\n<p><img src=\"/content/images/2015/Mar/serial.png\" alt=\"alt\">\n###<a href=\"http://serialpodcast.org/\">SERIAL</a>\nSerial is a podcast from the creators of This American Life, and is hosted by Sarah Koenig. Serial tells one story - a true story - over the course of an entire season. Each season, we’ll follow a plot and characters wherever they take us. And we won’t know what happens at the end until we get there, not long before you get there with us.</p>\n<p><img src=\"/content/images/2015/Mar/whore.jpeg\" alt=\"alt\">\n###<a href=\"http://www.thewhorecast.com/\">The Whorecast</a>\nSiouxsie Q has a quest: Destroy the evil forces of sex worker stigma, and fight for truth, justice and the American whore.</p>\n<p><img src=\"/content/images/2015/Mar/wtf.gif\" alt=\"alt\">\n###<a href=\"http://www.wtfpod.com/\">WTF with Marc Maron</a>\nWTF zählt inzwischen fast 600 Episoden in denen Comedian Marc Maron mit seinen Gästen schnackt.</p>\n"}

/***/ }),
/* 692 */
/***/ (function(module, exports) {

	module.exports = {"title":"PORTFOLIO","date":"2011-04-20 00:00:00 +0000","tags":null,"layout":"post","body":"<h1>Pressetexte</h1>\n<p>&lt;r:img_small float=“1”&gt;tn_tchik-cover.JPG&lt;/r:img_small&gt;</p>\n<p>&lt;r:img_small float=“1”&gt;tn_audio-stunts_and_mahumba_cover.jpg&lt;/r:img_small&gt;</p>\n<br style=\"clear: both\" />\n# Kunden\n<r:img_small float=\"1\">frontlineshop.gif</r:img_small>\n<p>&lt;r:img_small float=“1”&gt;yves_rocher.gif&lt;/r:img_small&gt;</p>\n"}

/***/ }),
/* 693 */
/***/ (function(module, exports) {

	module.exports = {"title":"PR-Texte aus der Hölle (Folge 1)","date":"2014-08-04 14:52:35 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://media-cache-ak0.pinimg.com/736x/f4/cf/2c/f4cf2c7bec41829cdc33587bb6698ffa.jpg\" alt=\"alt\"></p>\n<p>Herzlich willkommen zu meiner neuen Serie <strong>PR-Texte aus der Hölle</strong> mit der heutigen Folge 1, in der ich mich dem <strong>1st Village Market</strong> in Friedrichshain widme!</p>\n<p>PR-Texter, wieso tut Ihr uns das eigentlich an? Zugegeben, schlechte Pressetexte zu verfassen ist gar nicht mal so schwer, liebe Leser. Das könnt Ihr. Das kann aber auch Eure von mir im Übrigen hochgeschätzte Mutter. Das kann ich sogar im betrunkenen Halbschlaf mit dem Handy auf dem Weg zum Klo. Daher ziehe ich letzlich hochachtungsvoll vor jedem Texter meinen Hut, der es schafft, eine gar nicht mal so schlechte Veranstaltungsidee (ich hörte der Village Markt war eigentlich eine ganz feine Sache) oder einen Künstler, der eigentlich ganz okay ist, im ungünstigsten Licht der total beliebigen Anbiederung erscheinen zu lassen. Alles ist möglich. Super Sache! Aber steckt da eigentlich eine Agenda hinter (Verschwörungstheorie “Dummer deutscher Mainstream”) oder lässt sich diese Tatsache doch einfach nur mit grenzenloser Ignoranz begründen?</p>\n<p>Doch woran erkennt man eigentlich einen <strong>guten Pressetext?</strong> Die Antwort ist denkbar simpel:\nEin guter Pressetext beinhaltet Informationen und bedient sich nur wenigen, dafür aber äußerst passgenauen Adjektiven, um das zur erwartende Flair einer Veranstaltung oder die Stimmung eines Albums oder Buches einzufangen. <strong>Weniger ist immer mehr. Nicht oft. Nicht manchmal. Immer!</strong></p>\n<p>Ein Beispiel? Berlin ist eben keine “pulsierende Stadt”. Berlin ist nicht “bunt und verrückt”. Hier leben nicht nur “Kreative” und “Nachtschwärmer”. Eine Stimmung, die als “einzigartig” oder “unverwechselbar” beschrieben wird, ist es in der Regel nicht. Keine Ursache.</p>\n<p>Was also tun als jemand der einen PR-Text benötigt? Ich weiß, es ist oft schwer als kleiner Veranstalter oder milliardenschweres Label einen mutigen Schritt weg von Beliebigkeit und seelenloser Schleimerei zu wagen. Zumindest scheint es so, denn nur selten wird etwas riskiert. Mein Posteingang und meine Veranstaltungseinladungen bei Facebook, meine Newsletter und die Promotexte zu “pfiffigen” Alben-Neuerscheinungen sprechen eine deutliche Idiotensprache. Aufträge werden den immer gleichen Agenturen zugeschustert, in denen desillusionierte Texter in abgenutzten Fatboys in Neonfarben rumliegen und zum hundertsten Mal an einem Tag “Gesamterlebnis” in die Tastatur hämmern. Ich will ja keinesfalls dazu motivieren etwas Neues zu wagen, aber da draußen gibt es so viele unverbrauchte Köpfe, die nicht nur sprachbegabt sind, sondern auch ein Bündel innovativer Ideen in sich tragen. Sollten die nicht vielleicht mal einen Auftrag bekommen? Vielleicht als Reiseveranstalter mal einen schönen Katalog an Freiberuflern führen, die man durchrotieren kann und damit als netten Nebeneffekt vermeidet, dass alle Top-Hotels, egal in welchem Teil von Berlin sie liegen, mit “das junge Berlin” und “am Puls der Zeit” beworben werden?</p>\n<p>Funfact: Im Folgenden habe ich mir einen beliebigen PR-Text für eine Veranstaltung herausgepickt, der mir heute durch die Timeline gerattert ist und habe dort alle Textpassagen kursiv markiert, die inhaltsleer, überflüssig, Floskeln oder dummes Geschwofel sind. Schade, dass es sich eigentlich um eine gelungene Veranstaltung handelte, die rein gar nichts mit dem Publikum gemein hatte, dass mit dieser Art Text angetriggert werden sollte.</p>\n<p>Hier nun der Text und zur Erinnerung - alle Textpassagen sind kursiv markiert, die inhaltsleer, überflüssig, Floskeln oder dummes Geschwofel sind:</p>\n<p><strong><a href=\"https://www.facebook.com/events/251460818311231/\">// STREETFOOD . ART . MUSIC //</a></strong></p>\n<blockquote>\n<p>&quot;Im <strong>Herzen der Stadt</strong> entsteht mit dem VILLAGE MARKET ein <strong>Schmelztiegel</strong> für <strong>Kunst, Kultur und kulinarische Gaumenfreuden</strong> - ein <strong>Erlebnis- und Erfahrungsraum</strong> für die <strong>Gestaltungsfreudigen, die Kreativen und Genießer</strong>. Der VILLAGE MARKET ist ein neuer Anlaufpunkt für den Kiez und für Berlin.</p>\n</blockquote>\n<blockquote>\n<p>Ab dem ersten Augustwochenende nehmen wir euch immer sonntags in der Neuen Heimat mit auf eine <strong>Entdeckungsreise</strong>: Inspiriert von den <strong>Straßen und Kulturen der Welt</strong> zeigen euch an über 30 Ständen etablierte <strong>Streetfood-Veteranen</strong> und zahlreiche junge, neue Betreiber von Ständen, Foodtrucks und Garküchen wie vielfältig, exotisch und aufregend diese mobile Art des Kochens sein kann.</p>\n</blockquote>\n<blockquote>\n<p>Damit ihr nicht auf dem Trockenen sitzen müsst, gibt es neben den zahlreichen Essensständen Cocktails, auserlesene Weine, <strong>besondere</strong> Biere und eine Smoothie-Bar - und das auch noch in die Nacht hinein, wenn die Streetfood-Stände um 22 Uhr schließen.</p>\n</blockquote>\n<blockquote>\n<p>Neben dem <strong>kulinarischen Patchwork</strong> machen Kunst und Musik den VILLAGE MARKET zu einem <strong>Gesamterlebnis für alle Sinne</strong>: Performances, Theater und Künstler <strong>aller Couleur</strong> werden zukünftig den VILLAGE MARKET <strong>bevölkern</strong>. Bereits zum Opening machen Live-Bands und Überraschungs-Acts an den Turntables ihre <strong>Aufwartung</strong>, um den Abend <strong>einzuläuten</strong> und euch in die Nacht zu <strong>begleiten</strong>.</p>\n</blockquote>\n<blockquote>\n<p>Alle weiteren Infos zu den einzelnen Ständen, ihren Köstlichkeiten und was es sonst noch beim VILLAGE MARKET zu <strong>entdecken</strong> gibt, folgen in den nächsten Tagen und Wochen. Um immer up to date zu sein, besucht auch unsere Facebook-Page unter <a href=\"www.facebook.com/neueheimatBLN\">www.facebook.com/neueheimatBLN</a></p>\n</blockquote>\n<blockquote>\n<p>Wir sehen uns am 3. August - zum <strong>Schlemmen und Genießen</strong>!&quot;</p>\n</blockquote>\n<p>I doubt this!</p>\n"}

/***/ }),
/* 694 */
/***/ (function(module, exports) {

	module.exports = {"title":"Prag - kann das was?","date":"2011-09-21 16:27:29 +0000","tags":null,"layout":"post","body":"<p>\n\tPrag ist bestimmt eine wunderschöne Stadt, wenn man außer Acht lässt, dass dort an jeder Ecke unfreundliche Touristen mit unfreundlichen Einheimischen Unfreundlichkeiten austauschen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tOk, das Fickmaschinenmuseum hat mehr Eintritt gekostet als meine gesamte Tagesgarderobe, dafür gab es aus Spargründen in der Suite Menüs einer namhaften Fastfoodkette, die uns bereits im Geschäft kalt ausgehändigt wurden. Servicewüste Ostblock. Aber irgendwie auch schön. Man wird von Pragern schlecht behandelt, teilweise angefahren und angezickt, und niemals weiß man warum. Es muss vermutlich eine Ursache geben und die gestehe ich den Menschen dort gerne zu. Es wäre bloß nett gewesen zu erfahren welche. Tschechien ist nicht arm. Ausnahmsweise ist es also nicht dieser deutsche prunkvolle Reichtum, der verärgert. Vielleicht unsere Partnerschuhe in jeweils unterschiedlichen Farbtönen? Das wäre möglich.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"500\" src=\"/files/tn_Foto (11).JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDa endlich mein Geschäft mit den Texten anläuft, leisteten wir uns eine protzige Suite. Natürlich wurden wir im Hotel bei der Ankunft direkt verarscht. Ja, hätte ich vielleicht auch gemacht. Am Ende sieht ja jeder Mensch mit Koffern und Sportschuhen aus, als provoziere er gerade das.&nbsp;</p>\n<p>\n\tDie gebuchte Suite entpuppte sich bei Ankunft als Dachgeschosskammer mit 70er Jahre Echtholzoptik. Wo war der versprochene Marmorboden? Wo die große Badewanne? Meine Dusche? Aber mit mir nicht. Ich bin Punk. Ich log also ich sei schwanger und ließ meine Schläfenadern eindrucksvoll pulsieren und verdammt nochmal ich und das verdammte Kind bräuchten diese verdammte Wanne. Widerwillig zeigte der Typ uns schließlich unser Suite. Ja, die wollten wir. Schön. Meine mooshammereske Begleitung steckte dem unfreundlichen Mann schnell noch ein paar Scheine zu, damit seine Seele sich für immer beschmutzt fühlen sollte.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIn der Suite mit drei Zimmern, zwei Badezimmern und zwei gigantischen Flachbildschirmfernsehern konnte man es aushalten. Prag schafft sich ab. Ich verbrachte viel Zeit auf dem Marmorfußboden.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"669\" src=\"/files/tn_Foto (1).JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"500\" src=\"/files/tn_Foto (2).JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWas die Prager so essen: Frittierter Käse und Gulasch, Klöße und die geilen Oblaten mit Nussfüllung. Bier. Hallo, wie kann man als Bürger in einem Land schlecht gelaunt sein, in dem frittierter Käse ein Nationalgericht ist? Beim Mittagstisch im Restaurant zogen gefühlt 3000 Hochzeitsgesellschaften an uns vorbei. Muss denn jeder in diesem Land immer heiraten?</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"669\" src=\"/files/tn_Foto (3).JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"544\" src=\"/files/tn_Foto (4).JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"500\" src=\"/files/tn_Foto (5).JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tZugegeben, die Innenstadt ist ein einziger Wulst aus Prostituierten, Dealern, deutschen Touristen und überteuerten Cafes, aber irgendwie ist die Stadt schön und das kann man zu jeder Zeit auch erahnen. Wie schön muss es sein als letzter Mensch auf der Welt durch diese wunderschöne Stadt zu flanieren. Leichen links. Leichen rechts. Niedersetzen und die Schönheit bestaunen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDas nächste Mal komme ich mit dem Klapprad.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"500\" src=\"/files/tn_Foto (6).JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"500\" src=\"/files/tn_Foto (7).JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"500\" src=\"/files/tn_Foto (8).JPG\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"669\" src=\"/files/tn_Foto (9).JPG\" width=\"500\" /></p>\n"}

/***/ }),
/* 695 */
/***/ (function(module, exports) {

	module.exports = {"title":"PRESSE","date":"2013-06-30 00:00:00 +0000","tags":null,"layout":"post","body":"<p><img src=\"http://distilleryimage0.ak.instagram.com/2a13b7fe27a011e3ab8622000ab5c723_8.jpg\" alt=\"Alt text\"></p>\n<h3>Presse</h3>\n<h5><a href=\"http://www.seiten.faz-archiv.de/fas/20130303/sd1201303033808261.html\">Aus den Bunkern des Narzissmus</a></h5>\n<p>FAS Feuilleton</p>\n<h5><a href=\"http://diepresse.com/home/techscience/internet/1383519/Netzprosa_Hier-schreibt-die-Generation-Twitter\">Hier schreibt die Generation Twitter</a></h5>\n<p>Die Presse</p>\n<h5><a href=\"http://www.welt.de/print/welt_kompakt/vermischtes/article122104565/Gedankenblitze.html\">Gedankenblitze</a></h5>\n<p>Die WELT</p>\n<h5><a href=\"http://www.rap.de/news/40-news/12056-ada-blitzkrieg-veroeffentlicht-debuetroman\">Ada Blitzkrieg veröffentlicht Debütroman</a></h5>\n<p><a href=\"http://rap.de\">rap.de</a></p>\n<h5><a href=\"http://www.spiegel.de/netzwelt/web/kurzportraets-so-sehen-blogger-aus-a-906120.html\">So sehen Blogger aus - Kurzportrait</a></h5>\n<p>SPON</p>\n<h5><a href=\"http://www.interview.de/literatur/meine-b%C3%BCcher/meine-b%C3%BCcher-ada-blitzkrieg\">Meine Bücher: Ada Blitzkrieg</a></h5>\n<p>Interview Magazin</p>\n<h5><a href=\"http://www.districtmtv.de/article/thema/style-de/1npr61/interview_mit_ada_blitzkrieg_130828/e5o197\">Talking Heads: Ada Blitzkrieg</a></h5>\n<p>MTV</p>\n<h5><a href=\"http://www.zeitjung.de/medien/medien/6674-erklaer-doch-mal-das-internet-ada-blitzkrieg-ada-blitzkrieg-im-interview/\">Erklär doch mal das Internet, Ada Blitzkrieg!</a></h5>\n<p><a href=\"http://Zeitjung.de\">Zeitjung.de</a></p>\n<h5><a href=\"http://fuenfbuecher.de/clara-hitzel/\">Fünf Bücher von Clara Hitzel</a></h5>\n<p>FÜNF Bücher</p>\n<h5><a href=\"http://twitterhuder-abendblatt.de/?p=685\">“Ich erkläre meine Tweets nicht mehr”</a></h5>\n<p>Twitterhuder Abendblatt</p>\n<h5><a href=\"http://zeitspiegel.wordpress.com/2012/09/14/ada-blitzkrieg-im-interview-zu-twitter/\">Ada Blitzkrieg im Interview zu Twitter</a></h5>\n<p>Zeitspiegel</p>\n<h5><a href=\"http://steglitzmind.wordpress.com/2012/10/22/steglitz-stellt-ada-blitzkrieg-mit-text-krieg-vor/\">Steglitz stellt Ada Blitzkrieg mit TEXTKRIEG vor</a></h5>\n<p>SteglitzMind</p>\n<h5><a href=\"http://www.i-ref.de/2012/12/17/buch-tipp-dackelkrieg/\">Buchtipp: DACKELKRIEG</a></h5>\n<p>i-ref magazine for contemporary culture</p>\n<h5><a href=\"http://mixeryrawdeluxe.tv/textnews/dackelkrieg-rouladen-rap-gewinnspiel\">Dackelkrieg Buchvorstellung</a></h5>\n<p>Mixery Raw Deluxe</p>\n<h3>Veröffentlichungen</h3>\n<h3><a href=\"http://www.intro.de/spezial/kolumne\">INTRO Magazin monatliche Kolumne</a></h3>\n<h3><a href=\"http://www.intro.de/autor/Ada+Blitzkrieg\">INTRO Magazin Texte</a></h3>\n<h3><a href=\"http://vimeo.com/32784590\">MARATHONMANN Magazin mit Prinz Pi</a></h3>\n<h3><a href=\"http://das-heimatmagazin.de/\">STIJLROYAL MAGAZIN</a></h3>\n<h3><a href=\"http://www.freitag.de/autoren/der-freitag/schmeckt-das-denn\">DER FREITAG</a></h3>\n<h3><a href=\"http://textkrieg.de/pages/dackelkrieg\">DACKELKRIEG</a></h3>\n<h3><a href=\"http://textkrieg.de/pages/sukultur\">DIE STRENGE</a></h3>\n"}

/***/ }),
/* 696 */
/***/ (function(module, exports) {

	module.exports = {"title":"Prinz Pi bei tape.tv","date":"2011-05-24 08:41:28 +0000","tags":null,"layout":"post","body":"<p>\n\t<a href=\"http://prinzpi.biz/\">Prinz Pi</a> gab gestern ein exklusives Konzert für Fans und Freunde auf dem Dachboden des inzwischen geschlossenen <a href=\"http://www.knaack-berlin.de/\">Knaack Clubs</a>.&nbsp;Gastgeber war&nbsp;<a href=\"http://www.tape.tv/\">tape.tv</a>, die das Konzert aufzeichneten, ein paar unbespielte Kasetten und Flyer verteilten und das Treppenhaus mit Klebeband zuklebten.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/pi1.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDie Location ist imposant: Loftstyle, geweißte Wände und darüber ein kleiner dunkler Dachboden. Ein Publikum aus Freunden des Prinzen und Gewinnern einer tape.tv Verlosung. Fotografieren mit Blitz verboten und bitte leise sein. Dafür kostenloses Bier. Man möchte sich nicht beschweren.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tPrinz Pi mit Band ist neu und gut. Näher und privater. Das ganze Konzert gibt es dann demnächst auf <a href=\"http://www.tape.tv\">tape.tv</a> zu sehen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/pi3.jpg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/pi2.jpg\" width=\"500\" /></p>\n"}

/***/ }),
/* 697 */
/***/ (function(module, exports) {

	module.exports = {"title":"Rassekatzen, Glitzer und Katzenmasse","date":"2012-01-05 16:52:30 +0000","tags":null,"layout":"post","body":"<p>\n\t<img alt=\"\" src=\"/files/katzi.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tSeit es das Internet gibt, gibt es auch Katzen. Und mit Katzen meine ich Katzenbabys, Katzenhochzeiten, Katzenpannenvideos, <a href=\"http://icanhascheezburger.com/\">Lolcatz</a>&nbsp;und&nbsp;Rassekatzenzüchterhomepages. Letztere sind liebevoll gestaltete Designfolterstätten, denen wir grundsätzlich mehr Beachtung schenken sollten.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDer Ausflug in die Welt der Rassekatzen lohnt sich nicht nur für grenzwertige Chaktere wie mich. Man sucht eine beliebige Katzenrasse und gibt in die Googlesuche &quot;<strong>BELIEBIGE RASSEKATZE + Züchter</strong>&quot; ein. Jeder Schuss ist garantiert ein Volltreffer - dafür stehe ich mit meinem Namen! Katzenzüchter gestalten ihre Homepages alle gleich: Ein großes weichgezeichnetes Bild ihrer schönsten Pralltiere mit Namen wie &quot;Mooneye&quot; oder &quot;Miss Tigerfawn&quot;. Ausgestatt mit einem saloppen FROHE OSTER, FROHE WEIHNACHTEN, GUTEN RUTSCH oder CARPE DIEM Gruß in bunter Comic Sans Schrift ist die Kriegserklärung gleich für die mittelfristige Ewigkeit gut konserviert. Häufig ist das Bild animiert oder besitzt einen mit Paint platzierten Goldrahmen. Wer denkt, da kann nicht noch mehr kommen, irrt. Betritt man die Homepage, ist man mit einem ganzen Haufen Insider-Texten zur Katzenrasse (fast ausnahmslos von Wikipedia kopiert oder voneinander abgeschrieben) konfrontiert. Wer selber schreibt, sammelt Sympathiepunkte, lässt aber meistens entscheidende Fragen offen. Ist der Katze mit dem dicken Fell im Sommer nicht warm? Wohin gehen die verlorenen Haare? Wie viel Kubikzentimeter Katzenhaare fasst eine menschliche Lunge?&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tAha, norwegische Waldkatzen sehen also so aus, weil mal ein Mensch eingekreuzt wurde. Will man mehr darüber erfahren, muss man die Nummer neben dem animierten Zappeltelefon wählen. Vermutlich spricht auch noch jemand mit Hexenstimme am Apparat. Viel zu viele Eindrücke in viel zu kurzer Zeit. Niemand sollte Killerspiele zocken müssen um seine Konzentrationsfähigkeit zu erhöhen. Rassekatzenzüchterhomepages sind die neuen Killerspiele.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDie Katzenpension <a href=\"http://www.riegers-edelkatzen.de/pension.htm\">Riegers Edelkatzen</a> bietet &quot;<em>Keine Gesellschaftsräume für Katzen!</em>&quot;. Wo treffen sich denn dann die Rassekatzen zum &quot;Mädelsabend&quot;? Wo spielen sie Skat? In dieser Gesellschaft gibt es keinen Platz mehr für Katzenhedonismus. Es stehen aber &quot;<em>3 Räume mit ca. 75qm, ein Studio, ca. 45qm, Südseite mit gesichertem Balkon, sowie eine Außenanlage zur Verfügung</em>&quot;. &quot;Hallo, ich rufe wegen meiner Katze an. Haben Sie noch ein Zimmer mit Pay-TV zur Verfügung?&quot;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tRassekatzen. Jede einzelne war schon mal irgendwo Europachampion oder Tiermodel für eine namhafte Fleischabfallverwertungsmarke oder für die Titelseite von <a href=\"http://www.schoener-wohnen.de/\">Schöner Wohnen</a>. Das kann sonst nur Vera Int-Veen von sich behaupten.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEin bißchen spät, aber übermäßig herzlich und im glamourösen&nbsp;<a href=\"http://www.haraldgloeoeckler.de/\">Harald Glööckler</a> Stil wünschen uns die <a href=\"http://www.rassekatzenvomadlerdenkmal.de/\">Rassekatzen vom Adlerdenkmal</a> (Birmchen!) ein frohes Weihnachtsfest. Die Zucht präsentiert sich mit einem Birmchen-Außengehege. In diesem Außengehege wurde fleissig dekoriert, die Katzen sollen sich ja schließlich wohlfühlen. Weihnachtsschmuck und Christbaumkugeln. Katzen lieben das. Die Katzen sehen von hinten auf einem <a href=\"http://www.rassekatzenvomadlerdenkmal.de/Ausengehege2008_0002.jpg\">Foto</a> aus, als seien es Affen, was wesentlich angenehmer wäre. Cool ist anders, liebe Katzen!</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDas <a href=\"http://www.rassekatzenvomadlerdenkmal.de/adler-frame.htm\">Gästebuch</a> gilt offiziell als das Mutterschiff der Liebe und des Powerglitzers. &quot;<em>Nächstes Jahr werden wir Onkel und Tante von süßen Wolfspitzwelpen. Wir lassen uns gerne von unserem Hund schlecken und knubbeln und besonders Bellini schmust gerne ne Runde mit dem Wolf.</em>&quot; Interracial wird zur Interspecies Lovestory, man kann nicht aufhören zu lesen. Offenbar wird hier wild alles verpaart. Ich bin immer beeindruckter. Jetzt will ich mitmachen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tJeder Kommentator in Gästebüchern von Rassenkatzehomepages scheint die perfekte Erstellung von GIFs und animierten Grußkarten aus dem Handgelenk zu beherrschen. Fragt der Züchter &quot;Was habt ihr Ostern gemacht?&quot;, antwortet der Kommentator mit einer Blumenwiesengrußkarte mit Rosen und Narzissen, auf die eine Milch schleckende Katze mit kullernden Augen platziert wurde. Die Goldschrift, die fluoresziert und glitzert, verkündet zurückhalten &quot;Nichts besonderes!&quot;.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDie Katzenhersteller <a href=\"http://www.vomnibelungental.de/\">vom Nibelungental</a>&nbsp;überzeugen mit indianderhaftem Startseitenbild. Russisch Blau heißt der Zuchtgegenstand. Edel und teuer. Alle Katzen sind bekannte Modells für die Zeitschrift <a href=\"http://www.vomnibelungental.de/de/veroeffentlichungen.html\">CATS</a>. Bulemie und Koks. Die Russisch Blau wirkt arrogant und leidend. Ein schlechtes Gewissen und sehr viel Verzweiflung und Wut in die fleischige 5kg Form einer sehnigen Katzenmasse gepresst. Kostet dann auch mal eben 1/700 Einfamilienhaus. Ich tendiere dann doch eher zum Kauf einer Playstation.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDie Katzen <a href=\"http://www.vomwaldzauber.de/\">vom Waldzauber</a> beunruhigen mich. Merkwürdig konzipierte Seltsamwesen. Halb Mensch, halb Katze. Wie Dieter Moor. Das Fell sieht unkämmbar und drahtig aus. Diese Katzen werden auf der Fuchsjagd eingesetzt und zerren den blutigen Fuchsfetzen aus dem Bau. Meistens zerreißen sie das getötete Tier an Ort und Stelle. Die Reste tauchen dann auf Salamitiefkühlbaguettes namhafter Discounter wieder auf. Norwegische Waldkatzen sehen intelligenter aus als die meisten Menschen, die ich kenne.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<a href=\"http://www.merryborn.de/\">Merryborn</a> züchtet Maine Coon und erinnert an die alten Poesiealben meiner Mutter. Liebe ist, wenn die Katze 75qm Wohnfläche und einen Balkon zur Südseite hat. &quot;<em>Come in and rest a bit with us! Have a good time</em>!&quot; Die hatte ich.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tAlle Homepages zeugen von großen Mühen und großer Liebe zu den Tieren. Für mich ist das Stöbern auf den Seiten ein Gefühl der Liebe, Bewunderung und des Interesses für eine neue Welt, die ich so nicht kenne. Verzeiht mir meine barsche Wortwahl, liebe Besitzer, aber ich wünsche euch nur das Beste. Danke für diesen humoristischen Einblick!</p>\n<p>\n\t&nbsp;</p>\n"}

/***/ }),
/* 698 */
/***/ (function(module, exports) {

	module.exports = {"title":"Regentage","date":"2012-06-20 14:07:47 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/frauimregen1.jpg\" alt=\"frauimregen1.jpg\" />\n<p><strong>Ich mag Regen, denn der macht die Menschen traurig!</strong></p>\n<p>Aufgrund des freiwillig auferlegten Produktivitätsverordnungsgesetzes für mein Freiberuflertum, möchte ich an diesem regnerischen Tag mit zwei Dingen unterhalten:</p>\n<p>Eine Kurzlesung von Streugedanken:</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/es-ist-mittwoch\">player</a></p></p>\n<p>Ein im <a href=\"http://googledogs.de/\">Googledogs HQ</a> von mir kreiertes Set für langweilige Regentage:</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"http://soundcloud.com/bangpowwww/sets/rain\">player</a></p></p>\n"}

/***/ }),
/* 699 */
/***/ (function(module, exports) {

	module.exports = {"title":"Sag es laut: Mir geht es gut","date":"2014-05-12 19:02:25 +0000","tags":null,"layout":"post","body":"<img src=\"http://photos-d.ak.instagram.com/hphotos-ak-prn/928244_235873886611619_129498117_n.jpg\">\n<p>Wann habe ich eigentlich das letzte Mal gedacht, mir geht es bedingungslos gut? Ohne Wenn und Aber? Ganz ohne Einschränkungen, Rückhalte und vollkommen gelöst? Niemals tat ich das. Und nun fällt plötzlich so viel Ballast von mir ab, dass ich merke wie federleicht ich eigentlich bin. Was habe ich da nur immer alles mit mir rumgetragen? Ich bin der Typ Mensch, der in bestimmten Zeitabständen seine Lebenssituation ändern muss, der neue Stimulation und Einflüsse braucht, um funktionieren zu können. Ich bin einfach kein Familienmensch. Und ich bin kein Mensch für jahrelange Freundschaften. Ich brauche den Wandel. Diese Erkenntnis ist in den letzten Tagen zu einer großen Sicherheit herangewachsen. Der Umzug nach San Francisco ist eine Entscheidung, die zu keinem bessern Zeitpunkt hätte getroffen werden können. Mir geht es hervorragend. Ich lache sogar auf Fotos.</p>\n<img src=\"http://photos-b.ak.instagram.com/hphotos-ak-frc/10311063_1448310258749009_955829194_n.jpg\">\n<img src=\"http://scontent-b.cdninstagram.com/hphotos-prn/t51.2885-15/927056_1496251610589797_2107924632_n.jpg\">\n<p>Die Tage hier in San Francisco spielen mir zu. Es ist hell und mein Wohnzimmer ist 600,7 km² groß, von einer aufregenden Bay umgeben und riecht nach Carne Asada und exotischem Obst. Ich stehe jeden Morgen ohne Wecker um halb Sieben mit der Sonne auf, um draußen zu frühstücken, bei <a href=\"https://de.foursquare.com/v/philz-coffee/44ce9913f964a52018361fe3\">Phillz Coffee</a> den besten Kaffee der Welt zu trinken und Scones mit Blueberries und Birnen zu essen. In den letzten Tagen war ich an keinem einzigen Tag mehr als zwei Stunden zuhause - es sei denn ich habe geschlafen.</p>\n<img src=\"https://farm8.staticflickr.com/7349/14171125545_40c1f4b1db_b.jpg\">\n<img src=\"http://photos-a.ak.instagram.com/hphotos-ak-ash/1209549_459554470857360_1013741086_n.jpg\">\n<p>Und Zuhause? Ja, das gibt es nun. Auch wenn die derzeitige Wohnung erstmal nur für diesen Monat ist, denn danach geht es nach New York weiter und im Juni nochmal nach Berlin. Die Wohnung in der wir gerade leben hat eine eigene Dachterrasse und ich möchte mich nicht beschweren. Mitten im schönen Mission District. Direkt vor der Türe die besten Taquerien der Welt, das bunteste Obst und die durchmischteste Szene die man sich vorstellen kann. Die Flugtickets für meinen Freund, die Katze und mich sind gekauft. Am ersten Juli findet dann der “große” Umzug statt.</p>\n<img src=\"http://photos-f.ak.instagram.com/hphotos-ak-ash/10349241_623233927768709_538370665_n.jpg\">\n<img src=\"http://photos-e.ak.instagram.com/hphotos-ak-prn/925496_1415032495438236_725306980_n.jpg\">\n<p>Das Gefühl beim Transport vom Flughafen in unseren Stadtteil war irrsinnig. Ich war mehr als übermüdet und mit den Nerven nach dem langen Flug, der mir immer alles abfordert, ziemlich runter. Ich hasse es fremde Menschen zu riechen. Ich hasse es Rücksicht zu nehmen und ich hasse enge Räume und wenn mein Arm den Arm von Menschen berührt, die der Stewardess auf den Arsch glotzen und dann zu ihrer Begleitung “Ist die nicht zu fett für den Job?” sagen. Eingefercht und immer mit dem Gedanken “Durchhalten!”. Fünfzehn lange Stunden. Dann noch durch die ESTA Kontrolle am Flughafen und den Koffer vom Zoll zerwühlen lassen - mit der Frage ob ich von einer holländischen “Farm” komme. Raus aus dem Flughafen. In die BART reinfallen. Erst unterirdisch und dann sieht man zum ersten Mal die Landschaft. Es geht nach oben. Und es wird wüstiger. Ein paar Palmen und rote Erde. Sandiger. Ein bisschen wie in Breaking Bad. Man fühlt sich fremd und das tut einem heimatskritischen Menschen wie mir verdammt gut.</p>\n<img src=\"http://scontent-b.cdninstagram.com/hphotos-ash/t51.2885-15/10349631_434116550065072_525530810_n.jpg\">\n<img src=\"http://photos-b.ak.instagram.com/hphotos-ak-ash/10326597_240485022807897_1747291200_n.jpg\">\n<img src=\"http://photos-a.ak.instagram.com/hphotos-ak-ash/925512_395750640567624_1877984552_n.jpg\">\n<img src=\"http://photos-c.ak.instagram.com/hphotos-ak-frc/10296831_706572919401218_1807336151_n.jpg\">\n<p>San Francisco hat herrliche Stadtteile. Am Wochenende hat es uns direkt nach Chinatown getrieben, weil ich Fan von authentischer Küche und szenischen Straßenzügen bin. Plötzlich wimmelte die ganze Straße von Asiaten. Eine Demo mit Hakenkreuzen zog an uns vorbei (religiöses Symbol) und man fühlte sich wie in einem brummenden Ameisenhaufen. Schnell ein paar frischgemachte und gedämpfte Dim Sum auf die Hand greifen und meine Neuentdeckung (Pork Buns) für einen lächerlichen Preis kaufen und auf dem Bordstein mit schmutzigen Händen in sich reinschieben, während um einen herum die Welt tobt, in der man seinerseits gerade wütet. Was noch kommen mag, ich weiß es nicht.</p>\n<img src=\"http://photos-c.ak.instagram.com/hphotos-ak-prn/10354315_1412985708977914_1783083734_n.jpg\">\n<p><a href=\"https://de.foursquare.com/bangpowwww/list/san-francisco\">WHAT TO DO IN SAN FRANCISCO? ADA KNOWS BEST!</a></p>\n<img src=\"http://photos-d.ak.instagram.com/hphotos-ak-prn/928537_1378382395770227_404447231_n.jpg\">\n<img src=\"http://photos-e.ak.instagram.com/hphotos-ak-prn/891371_634601493297884_311791988_n.jpg\">\n<img src=\"http://photos-g.ak.instagram.com/hphotos-ak-prn/924352_663111563744774_1856346364_n.jpg\">\n"}

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	module.exports = {"title":"San Francisco Food Story","date":"2012-09-14 18:30:47 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/usagirlandboy.JPG\" alt=\"usagirlandboy.JPG\" />\n<p>Was ist eigentlich mit dem Essen in San Francisco los? Was essen die “Einheimischen” denn so? Was kostet der ganze Scheiß? Gibt es nur Burger und Fries? Was ist ein Cheesesteak? Essen Amerikaner ausschließlich Müll? Und wo soll ich wann, wie, warum und was essen?</p>\n<img src=\"/content/images/burger1.JPG\" alt=\"burger1.JPG\" />\n<p>Weil ich ein großer Freund von guten Speisen und eine sehr soziale Kumpeline bin, habe ich für alle diejenigen, die heute, morgen, demnächst oder in 50 Jahren mal nach San Francisco reisen, eine kleine Liste mit unbedingten Fress-Empfehlungen und <a href=\"https://de.foursquare.com/bangpowwww/list/san-francisco\">To-Do Tipps für San Francisco</a> auf Foursquare gepackt. Genießt die Stadt! Liebt den Kaffee! Fresst Euch fett! Wühlt Euch durch Potstickers, Chicago Style Pizza, Burger und Burritos, Burritos und noch mehr Burritos!</p>\n<p>Neben meiner <a href=\"https://de.foursquare.com/bangpowwww/list/san-francisco\">Foursquare Liste</a> habe ich natürlich noch ziemlich betrunken eine kleine und unangenehme Audioshow für Euch aufgenommen, für die ich mich selber dezent etwas schäme und in der ich wie ein beratterter Paketfahrer klinge. Das ganze könnt Ihr dann hier sehen und hören:</p>\n<p><a href=\"http://storywheel.cc/bangpowwww/food-story-san-francisco\">DIE ADA BLITZKRIEG SAN FRANCISCO FOOD STORY</a></p>\n"}

/***/ }),
/* 701 */
/***/ (function(module, exports) {

	module.exports = {"title":"Schlechte Zeiten, gute Zeiten - Neues Blitzkrieg HQ","date":"2012-01-31 14:51:19 +0000","tags":null,"layout":"post","body":"<p>\n\t<img src=\"/content/images/grandmother%20(12).JPG\" alt=\"grandmother%20(12).JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tNun ist es soweit: Ich habe endlich eine neue neue Wohnung gefunden und professionalisiere mich bezüglich meiner Selbstständigkeit final. Das Blitzkrieg HQ siedelt nach Kreuzberg um. Größer, schöner, besser und mit perfektem Officezimmer.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDeswegen ist, wie Ihr vielleicht schon gemerkt habt, eine kleine Zwangspause im Textkrieg-Blog, in meinem Job als Texterin und in meinen Social Media Tätigkeiten entstanden. Umso schöner heute endlich mit maximaler Motivation mitteilen zu können, dass ich ab Mitte Februar, wenn die Nachmietersuche für die alte Wohnung und das Renovieren und Einrichten der neuen Wohnung abgeschlossen sind, wieder Aufträge entgegen nehme und zeitnah beginnen werde mein erstes Buch zu schreiben, für das ich derzeit einen Verlag suche.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch freue mich also ab sofort wieder Eure Aufträge, Projektideen und Liebesgrüße über die altbekannten <a href=\"http://textkrieg.de/pages/kontakt\">Kontaktwege</a> zu empfangen. Auf ein weiteres erfolgreiches Geschäftsjahr!</p>\n"}

/***/ }),
/* 702 */
/***/ (function(module, exports) {

	module.exports = {"title":"Silenttiffy, ihr Roman, and the Masters of Aussiedlerfashion","date":"2012-06-04 11:55:34 +0000","tags":null,"layout":"post","body":"<p>Ich habe eine gute und eine schlechte Nachricht. Die gute Nachricht ist, Alexandra Tobor, besser bekannt als <a href=\"https://twitter.com/#!/silenttiffy\">Silenttiffy</a>, rotzt in den nächsten Tagen ein rauchgelbes Buch wie eine ordentliche Portion Schnupftabak mit Asbestfasern auf den Markt. Die schlechte Nachricht ist, Ihr müsst Euch noch ein paar Tage gedulden, denn ich hatte den Roman exklusiv als Gegenleistung für körperliche Liebesdienste zugespielt bekommen und möchte Euch in diesem Beitrag für eine Ostblock-Experience in sprachlicher Vollendung anwerben.</p>\n<p>Worum geht es im Buch: <strong>Osteuropäischer Klanz, duftende Frauenklatzen und ALDI Klamauk</strong> - “Sitzen vier Polen im Auto”, so der Titel des Romans, der zunächst Angst macht und wie einer diese Romane klingt, in denen sich endlos Klischee an Klischee reiht und der Normalbürger ständig seinen langweiligen “Stimmt!” Effekt erleben darf. Diese Bücher haben dann meist nichts mit einer liebevollen und humoristisch hochwertigen Auseinandersetzung mit Vorurteilen zu tun, sondern nutzen Klischees und Skepsis gegenüber allem Fremden als platten Aufmerksamkeitsfänger für einer Mitte-Rechts-Leserschaft. Dieses Buch ist grundlegend anders und wunderschön. Die Herangehensweise ist zarghaft, feingeistig und erzählt berechtigterweise eine Perspektive, die man so nicht kennt. Alexandra Tobor informiert, führt ein, lässt den Leser zwischen riesigen Haarschleifen, grauen Kommunionskleidern und Kisiel weinen, schmunzeln und laut lachen.</p>\n<img src=\"/content/images/tn_Fashion2.jpg\" alt=\"tn_Fashion2.jpg\" />  \n<p>Die Autorin, bekennende und schwadronierende Spätaussiedlerin mit bleichem Teint und einem erstklassigen Gespür für literarische Figuren, erzählt über eine polnische Auswanderer-Geschichte, die ihre eigene sein könnte, es aber nicht ist. Bewusst macht sie sich von autobiographischen Elementen frei, doch möchte diese auch nicht gänzlich ausschließen.</p>\n<p>Irgendwie findet man sich wieder, wenn die rührende Geschichte eines Aussiedlermädchens erzählt wird. Selbstironie, Fremdironie und eine Menge Liebe für die unzähligen kleinen Details zeichnen dieses Buch aus. Die hohen Erwartungen der Aussiedlerkinder und ihrer Eltern, die unzähligen Enttäuschungen, die Scham der Eltern über die Rückschläge in der neuen Heimat in ihrem Heimatland zu berichten, das Aufrechterhalten der äußeren Form, die Intoleranz der Deutschen und die tollen Kleider und Häuser der deutschen Kinder. Neid und Anerkennung. Optimismus und Pessimismus.</p>\n<p>Die ersten Kapitel könnt Ihr als Hörbuch hören:</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/rosereule/kapitel-1-das-goldene-buch\">player</a></p></p>\n<p><a class=\"widget\" href=\"https://soundcloud.com/rosereule/kapitel-2-der-schatz-in-der\">player</a></p></p>\n<p>Die passenden Impressionen zum Buch und Hörspiel liefert die Autorin dann mit ihrem herzergreifenden <a href=\"http://silenttiffy.de/2012/05/spataussiedler-fashion-blog/\">Spätaussiedlerfashionblog</a>, den sie jüngst selbst auf ihrem Blog veröffentlichte.</p>\n<p>Beim Lesen ist mir zu jedem Zeitpunkt bewusst, dass ich in meiner eigenen Schulzeit eines der anderen Kinder war, denen das alles ziemlich egal war. Ich wusste nicht einmal, dass die vier Spätaussiedler in meiner Grundschulklasse vielleicht Zeit in Flüchtlings- oder Aussiedlerlagern verbracht haben könnten, geschweige denn wo sie wohnen. Ich machte mir wenig Gedanken um alles was nicht ich war oder keinen Lacoste-Pullover trug. Was sie wohl zurückgelassen hatten und was sie erwarten? Ich machte mir damals keine tiefergreifenden Gedanken. Ich dachte bloß, die wären irgendwie uncool. Aus der Coolheit, aus dem Sinn.</p>\n<p>Ich kenne das Gefühl nicht, wenn das Jugendzimmer von OTTO geliefert wird, und man nicht weiß, wer dieser Typ überhaupt ist. Wenn alle Teile des Mobilars zusammenhängen und aus Furnierholz im konsensfähigen Buche-Look bestehen. Wenn sich in der neuen Heimat plötzlich die Türen vom Supermarkt automatisch öffnen und magisch erscheinen. Für mich keine Zauberrei, sondern Technik, mit der ich aufwuchs. Ich sammelte keine Obstaufkleber, denn meine Eltern kauften mir 3D-Aufkleber mit Dinosaurieren und flauschige Katzenabziehbildchen. Wir besaßen keinen “Aussiedlersarg”, in dem die wenigen Kostbarkeiten aufgebahrt wurden, die wir besaßen, wir hatten ja einen Keller und eine Bibliothek mit Regalen und einen Speicher und einen Vorratsraum und Kommoden, Kisten, Stauraum unter Betten. Wir hatten jeder unser eigenes Kinderzimmer. In den dunklen Schrankwänden der Aussiedler präsentierten sich also abgegriffene Bibeln und Bilder der ersten Kommunion. Spannend!</p>\n<img src=\"/content/images/tn_Fashion1.jpg\" alt=\"tn_Fashion1.jpg\" />\n<p>Der erste Schultag in Deutschland:</p>\n<blockquote>\n<p>“Ich beschloss, dass ich für den Anfang meine roten Eichhörnchen-Schuhe tragen würde. Sie waren ‘Made in China’, was in Polen der Inbegriff von extravagantem Chic und weltlicher Eleganz war. […]\nObwohl ich nicht verstand, was sie zueinander sagten, wusste ich, dass ihr Getuschel etwas mit mir zu tun haben musste. Erst jetzt fiel mir auf, wie anders ich aussah mit der großen steifen Schleife auf dem Kopf und den tristen Farben meines Pullovers. […] Auf den letzten Metern zum Klassenraum starrte ich befangen auf meine Eichhörnchen-Schuhe, deren leuchtendes Rot innerhalb von Minuten verblasst war.”</p>\n</blockquote>\n<p><a href=\"http://silenttiffy.de/2012/05/spataussiedler-fashion-blog/\">Fotos gibts hier.</a></p>\n<p><a href=\"http://www.amazon.de/gp/product/3548283748/ref=as_li_tf_tl?ie=UTF8&amp;tag=silenttiffy-21&amp;link_code=as3&amp;camp=2514&amp;creative=9386&amp;creativeASIN=3548283748\">Buch hier.</a></p>\n<p><a href=\"http://silenttiffy.de/\">Silenttiffy im Blogformat 90:4.</a></p>\n<p><a href=\"https://soundcloud.com/rosereule\">Silenttiffy bei SoundCloud.</a></p>\n<p><a href=\"https://twitter.com/#!/silenttiffy\">Silenttiffy bei Twitter.</a></p>\n"}

/***/ }),
/* 703 */
/***/ (function(module, exports) {

	module.exports = {"title":"Slowenien, Slowakei oder so","date":"2011-06-27 16:04:49 +0000","tags":null,"layout":"post","body":"<p>\n\tHallo Mama, ich bin in Slowenien oder Slowkei oder so.</p>\n<p>\n\tDieses Slowenien, von dem niemals jemand spricht, liegt irgendwo eingepackt zwischen sehr korrekten Ländern (Österreich, Italien, Kroatien und irgendwas im Osten) und finanziert sich in erster Linie durch die Autobahnmaut der Durchreisenden, die unterwegs zu einem coolern Ort sind. Die Autobahnmaut beträgt 500 Euro oder so. Dafür bekommt man eine 7-Tage Plakette um 20 Minuten auf Sloweniens Autobahnen zu verbringen.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/slowenien33.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tOhne gültigen Personalausweis oder Reisepass wird man an der kroatischen Grenze abgewiesen und muss entweder 10 Stunden zurück nach Berlin reisen oder in Slowenien abhängen. Das wurde uns auch bewusst, als wir einen Tag nach unserem Einreiseverbot in der Deutschen Botschaft in Ljubljana mit 200 rotverbrannten Russen für Einreisepapiere und Pass anstanden.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tSlowenien ist die eine Sache. Die andere Sache ist, in einem slowenischen Waldstück die restliche Kiffe vor der Einreise nach Kroatien verstecken zu wollen und in Klärschlamm auszurutschen und den ganzen Körper voller Exkremente und seltsamer roter Würmer zu haben.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/slowenien8788.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tSchnell weiter! Bloß nicht mit den Einheimischen sprechen, die aussehen wie die Fensterputzer am Kottbusser Tor in Berlin, keine Speisen zu sich nehmen und auf gar keinen Fall Pizza essen gehen. Pizza besteht in Slowenien aus einer etwa 5cm dicken Backpulverteigmasse, auf die farb- und geschmackloses Dosengemüse geworfen wird. Anschließend wird der Teig mit Scheiblettenkäse überbacken. Wer etwas essen will, sollte sich an Körpereigenes halten. Ich sehne mich nach meiner ehemaligen Uni-Mensa.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/slowenien.JPG\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tStilecht haben wir die Nacht in einem Motel mit direktem Blick auf den Kosmetiksalon mit dem schmückenden Namen &quot;KZ Hoce&quot; verbracht. Ein Motel unterscheidet sich von einem Hotel nur darin, dass lauter gebumst und weniger geputzt wird und man mit dem Auto bis ins Zimmer fahren kann.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/slowenien2.JPG\" width=\"500\" /></p>\n"}

/***/ }),
/* 704 */
/***/ (function(module, exports) {

	module.exports = {"title":"Sofawissenschaften","date":"2012-02-01 09:31:59 +0000","tags":null,"layout":"post","body":"<p>\n\tJeder der im Internet schon mal auf den bekannten Kleinanzeigenseiten nach gebrauchten Sofas gesucht hat, kennt das Gefühl des totalen Ausgeliefertseins an die unpassenden Adjektive aus schwammigen Beschreibungen von selbsternannten Innenarchitekturexperten der dörflichen Randgebiete. &quot;Modische Sofas&quot;, &quot;gemütliche Sofakuschellandschaften&quot; und viel Terracotta und Wischtechnik. Vielleicht zu viel? Die Fotos erzählen Geschichten, die man eigentlich nie hören wollte. Und schon hat man eine posttraumatische Belastungsstörung oder kämpft sein Leben lang mit Panikattacken. Sofasuche.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch stelle in diesem Artikel die bewegendsten Modelle meiner gestrigen Recherche im Raum Berlin vor und verliere einige Worte über Designaspekte, sowie zum aktuellen Stand der Sofawissenschaftsforschung. Wer bis zum Ende liest, darf sich 8KP in das Modul &quot;Wollte ich niemals wissen&quot; eintragen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img src=\"/content/images/tn_Sofa1.jpeg\" alt=\"tn_Sofa1.jpeg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tBlaues Kunstleder. Was war nochmal genau das Motiv sich für ein blaues Sofa zu entscheiden? Und was ist nochmal genau das Motiv sich für Kunstleder zu entscheiden? Die Wissenschaft hat darauf eine Antwort: Kommen bei Polstermöbel zwei unklare Motive zusammen, handelt es sich um einen Käufer, der mit hoher Wahrscheinlichkeit den ganzen Tag nackt mit einem lebensgroßen Guido Westerwelle Poster auf dem Sofa sitzt und über Bluetooth philosophiert. Der Käufer ist in erster Linie sehr egozentrisch. Er wird Euch unter keinen Umständen helfen das Sofa zum Auto zu tragen. Wenn Ihr weg seid, lässt er den Artikel noch einige Tage im Internet stehen, damit Menschen anrufen und etwas von ihm wollen. Für ihn fühlt sich das richtig an. Der Farbton nennt sich übrigens &quot;Manhatten Blau&quot; und wird von arbeitslosen 90er Jahre Werbern im Rahmen einer Arbeitsbeschaffungsmaßnahme auf Möbel mit Stahlfüßen gerotzt.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img src=\"/content/images/tn_Sofa2.jpeg\" alt=\"tn_Sofa2.jpeg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tTerracotta hießt in meiner Schulzeit noch Fleischfarbe und war Nudisten und Metzgern vorbehalten. In den 90er Jahren wurde der mysteriöse Farbton dann in &quot;Terracotta&quot; umbenannt, um seinen globalen Siegeszug in die Wohnungen von geschiedenen Sozialpädgoginnen und in die Plattenbauten der ostdeutschen Kleinstädte anzutreten. Dieses Sofa könnte theoretisch interessant sein, wenn es Titten hätte. Hat es aber nicht. Und mal ehrlich, wer will schon auf einem Polstermöbel sitzen und sich ständig überlegen müssen, ob man ihm eigentlich die Fußnägel schneiden muss.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img src=\"/content/images/tn_Sofa3.jpeg\" alt=\"tn_Sofa3.jpeg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch wünschte ich hätte 600 Euro über um mir diesen Designertraum leisten zu können. Ein echtes Schnäppchen wenn man überlegt, dass dieser wendige Sportwagen mal 4000 Euro gekostet hat. Deswegen steht er auch heute runtergeranzt in Köpenick und wartet auf den neuen TÜV. Sofas, die aussehen wie futuristische Kleinwagen, lösen nicht nur das Emissionsproblem der Neuzeit, sondern kaschieren auch bequem kleinere Egoedfizite. Wer Gäste eine Runde mit dem Flitzer drehen lässt, erntet nicht nur Applaus, sondern auch abfärbende Hosen auf weißem Kunstleder.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img src=\"/content/images/tn_Sofa4.jpeg\" alt=\"tn_Sofa4.jpeg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tHier schreibt der Verkäufer &quot;Wir sind etwas unter Zeitdruck, wenn also Interesse besteht, schnell zuschlagen!&quot; und ich würde in der Tat gerne dieses Sofa aufsuchen und ihm dann mal richtig eine reinzimmern. Sofas, die zum Schlagen provozieren. Orange macht aggressiv und die Kombination mit Indiandermuster signalisiert dann auch dem Verstand das drigend benötigte &quot;GO!&quot; zum Zerprügeln der hässlichen Polstermasse.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img src=\"/content/images/tn_Sofa5.jpeg\" alt=\"tn_Sofa5.jpeg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWow! Dieses Sofa soll mal einer verstehen! Sieht aus wie eine Raketenabschussrampe eines Gegenstandes, auf dem normalerweise nach dem Genuß von zwiebellastigen Mahlzeiten nur Richtung Boden abgefeuert wird. Auf der ausziehbaren Bettfläche finden locker 8 illegale Einwanderer eine Wohn- und Arbeitsfläche. Die Farbe erinnert mich an die Zähne der Moderatorin von &quot;Unser Star für Baku&quot; und das Muster ist zwar nicht mehr zu erkennen, aber trotzdem maximal schlimm. Eine üble Kombination. Immerhin ist der Preis Verhandlungssache und dürfte sich wohl im mittlernen vierstelligen Bereich bewegen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img src=\"/content/images/tn_Sofa6.jpeg\" alt=\"tn_Sofa6.jpeg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&quot;Dieser gepflegter Sofa&quot;, wie es in der &nbsp;Artikelbeschreibung heißt, ist gefühlte 20km lang. Wenn man es auf dem Alexanderplatz aufstellt, können noch Menschen in Brandenburg oder Potsdam darauf Platz nehmen. Das geheimnisvolle Foto lässt eine Unendlichkeit dieses Polstermöbels denkbar erscheinen. Was wäre wenn das Sofa einmal den Erdball umfasst? Wäre es dann ein Rundsofa? Die Sofawissenschaft hat noch keine abschließende Meinung zu diesem Wohntraum.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img src=\"/content/images/tn_Sofa7.jpeg\" alt=\"tn_Sofa7.jpeg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tMal ehrlich, eigentlich wollte ich dieses Sofa gar nicht erwähnen. Mir sitzt die Angst im Nacken, dass mir jemand dieses unglaubliche Schnäppchen für 150 Euro wegschnappen könnte. Ein Wahnsinn ist das! Die Fotos sprechen Bände. Die Sofawissenschaft ist sich einig: Schnäppchenalarm für alle, die es gerne kastenförmig, maskulin und pfirsischfarben mögen. Ein Hybrid. Macht sich vielleicht schön im neuen Gottschalk LIve Studio.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img src=\"/content/images/tn_Sofa8.jpg\" alt=\"tn_Sofa8.jpg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tLaminat, Wischtechnik, ein nierenförmiger Furnierholztisch. Passt perfekt in den Warteraum einer Zeitarbeitsfirma oder eines &quot;edlen&quot; Frisörsalons in Lichtenberg. Dafür hat man die Garantie, dass auf diesem Sofa niemand gestorben ist, denn dort kommt man einfach nicht zur Ruhe. Aggressive und wilde Musterung des Poslters. Durchbrochene Flächen. Der Designer hat ein unglaubliches Händchen für die Lokalisierung des Brechzentrums. Sieht bestimmt exzellent unter einer BVG Flagge aus. Wohnzimmerfüllmaterial für Tangaträger.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img src=\"/content/images/tn_Sofa9.jpeg\" alt=\"tn_Sofa9.jpeg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tMan fragt sich die ganze Zeit nur, wer das Teil eigentlich schlachtet und ob das Fleisch gut schmeckt. Die Sofawissenschaft rät allerdings vom Verzehr ab.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img src=\"/content/images/tn_Sofa10.jpeg\" alt=\"tn_Sofa10.jpeg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDer Verkäufer benutzt den Fachausdruck &quot;Terraorange&quot;, den wir sonst nur von den Beinen von Loveparadeteilnehmern, extraterrestrischen Begegnungen oder den großen Spaßautos der Müllabfuhr kennen. Von &quot;sehr gut erhalten&quot; ist die Rede. Man darf sich also wieder jung fühlen. Das Sofa sieht aus als wäre es eigentlich terracottafarben und bloß aufgrund seiner absurd hässlichen Form peinlich errötet. Da schämt sich jemand. Zu Recht.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img src=\"/content/images/tn_Sofa11.jpg\" alt=\"tn_Sofa11.jpg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDieses einmalig schöne Stück wird mit &quot;beige bunt&quot; angepriesen. Beige bunt ist ein Paradoxon, aber vielleicht die Erklärung, warum so viele Renter beige Hosen tragen. Die Sofawissenschaft hinterfragt derzeit, ob Beige in einer anderen Dekade als bunt galt. Und wenn nein, warum das auch richtig so ist.</p>\n"}

/***/ }),
/* 705 */
/***/ (function(module, exports) {

	module.exports = {"title":"SoundCloud and Fun","date":"2012-11-12 14:07:13 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/kunst.JPG\" alt=\"kunst.JPG\" />\n<p>Irgendwann musste ich feststellen, dass es so unglaublich wenige witzige Texte zum Audiokonsum im Internet zu finden gibt. Ich habe keine Lust die ewigen 100 gleichen Hörbücher der langweiligen Massencomedians aus der Amazon Bestseller-Liste zu hören und mich dabei zu schämen. Also habe ich gesucht. Daher hier für Euch ein paar Audio-Häppchen von Menschen, über deren Stuff ich gerne lache und die ich Euch gnadenlos weiterempfehlen möchte:</p>\n<p><a href=\"https://soundcloud.com/mfdaviddeery\">David Deery</a> lebt in Berlin und kommt eigentlich aus Brooklyn und ich bin eigentlich ganz froh, dass er hier ist.</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/mfdaviddeery/mf-david-deerys-mailbox-s01\">player</a></p></p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/mfdaviddeery/mf-david-deerys-mailbox-s01-1\">player</a></p></p>\n<p>Ich mag <a href=\"https://soundcloud.com/silvester-klement\">Silvestah</a>:</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/silvester-klement/mecklenburg-vorpommern\">player</a></p></p>\n<p><a href=\"https://soundcloud.com/psalamone\">Paul Salamone</a> erzählt über seine Deutsch-Lern-Gruppe in Berlin Marzahn.</p>\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/psalamone/ami-deutsch\">player</a></p></p>\n"}

/***/ }),
/* 706 */
/***/ (function(module, exports) {

	module.exports = {"title":"Spannung vor dem Release","date":"2012-12-15 00:00:00 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/196061_517339604944018_22379036_n.jpg\" alt=\"196061_517339604944018_22379036_n.jpg\" />\n<p>Wow, am Montag ist es endlich soweit und mein erster Roman erscheint! Natürlich sind der Titel und das Cover noch ein großes Geheimnis, das ich erst am Montag lüften werden. Aber ich sterbe bereits jetzt vor Aufregung, weil mich zum ersten Mal seit 27 Jahren so etwas wie “Stolz” überkommt und ich unglaublich zufrieden mit dem bin was ich geschaffen habe, denn der Roman ist einfach unglaublich gut geworden.</p>\n<p>In den letzten Tagen habe ich weder geschlafen noch gegessen, so anstregend war alles. Die Nächte habe ich mir damit um die Ohren geschlagen Korrektur zu lesen und gerade laufen die letzen Vorbereiten vor der Veröffentlichung.</p>\n<p>Selbst ein Buch zu publizieren fordert echt viel. Und ja, das hatte ich vielleicht als unwissende “Bishernochnichttautorin” etwas unterschätzt. Neben dem Setzen, dem Umwandeln, der Gestaltung des Covers (es ist perfekt geworden!), gilt es auch das Baby irgendwie unter die Leute zu bringen. Die Promotion des Romans übernimmt dabei kein Verlag oder keine Agentur für mich, sondern ganz alleine ich. Ich muss also Mails verschicken und Vorabexemplare versenden, Interviews geben, PR-Texte verfassen und vieles mehr. Das macht Spaß, aber es macht auch müde. Daher habe ich es auch noch nicht geschafft meine Winterreifen aufzuziehen, obwohl ich nach der Veröffentlichung ein paar Tage zu meinen Eltern fahren möchte, um zu entspannen. Ich habe es mir verdient.</p>\n<p><strong>Ab heute verschicke ich Exemplare des Romans an Blogger und Presse. Wenn Ihr auch gerne über meinen Roman berichten wollte, oder Interviewanfragen an mich habt, dann schickt mir einfach eine kurze Mail an <a href=\"mailto:kontakt@textkrieg.de\">kontakt@textkrieg.de</a>!</p>\n<p>Aber so viel sei schon mal verraten: Das Buch erscheint am Montag, den 17.12, wird Euer Budget nicht überstrapazieren und ist ein absolut perfektes Geschenk für ausnahmslos jeden, der lesen kann und schon mal gelacht hat.</strong></p>\n<p>Am Montag gibt es dann mehr Information über den Romantitel und wo Ihr ihn für wie viel Geld kaufen könnt. Drückt mir die Daumen und erzählt Euren Freunden, Followern und Müttern davon!</p>\n"}

/***/ }),
/* 707 */
/***/ (function(module, exports) {

	module.exports = {"title":"Start","date":"2011-04-21 15:59:29 +0000","tags":null,"layout":"post","body":"<p>\n\t<img src=\"/content/images/horssssetzmittextgrau.jpg</r:img><r:img>munitionundmaedchenbanner.jpg\" alt=\"horssssetzmittextgrau.jpg</r:img><r:img>munitionundmaedchenbanner.jpg\" /></p>\n"}

/***/ }),
/* 708 */
/***/ (function(module, exports) {

	module.exports = {"title":"Prominente im Studiopublikum - Teil I: Der Sänger von Frittenbude","date":"2011-07-28 16:12:21 +0000","tags":null,"layout":"post","body":"<p>\n\tHeute startet in diesem Blog die&nbsp;neue Serie &quot;Prominente im Studiopublikum&quot;. Ständig konfrontieren uns Talk-Shows und TV-Formate, die wir eigenlich nicht gucken möchten, sondern höchstens aus Selbsthass zur Bestrafung einschalten, mit Menschen, die Prominenten verdächtig ähneln. Sie sitzen im Studiopublikum mitten unter uns oder laufen zufällig bei Einspielern im Hintergrund vorbei. Heute frage ich, Verschwörung oder Überdosierung?</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tBitte schickt mir in den nächsten Tagen eure fotografisch dokumentierten Beobachtungen an kontakt@textkrieg.de und ich veröffentliche sie im Blog!</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tHeute: Teil I - Der Sänger von <a href=\"http://www.audiolith.net/frittenbude\">Frittenbude</a> bei Stern TV</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"364\" src=\"/files/strizi.jpg\" width=\"500\" /></p>\n"}

/***/ }),
/* 709 */
/***/ (function(module, exports) {

	module.exports = {"title":"SUKULTUR","date":"2013-10-07 00:00:00 +0000","tags":null,"layout":"post","body":"<h1>Die Strenge</h1>\n<p>Endlich steht mal wieder ein großartiges Release meiner Texte vor der Tür und dieses Mal ist es ein hübsches Projekt bei dem tollen Verlag (<a href=\"http://www.sukultur.de/\">SuKultur</a>) geworden, der meine Geschichte ab sofort als <a href=\"http://www.sukultur.de/die-strenge-211.html\">eBook</a>, als <a href=\"http://www.sukultur.de/die-strenge.html\">Leseheftchen</a> über den Onlineshop oder als <a href=\"http://www.sukultur.de/\">Automatenkauf</a> in Vending Machines an unterschiedlichen Standorten verkauft.</p>\n<p><img src=\"https://fbcdn-sphotos-h-a.akamaihd.net/hphotos-ak-ash4/1374090_305321059611042_47331444_n.jpg\" alt=\"Alt text\"></p>\n<p><a href=\"http://www.sukultur.de/die-strenge.html\">“<strong>Die Strenge</strong>”</a>, so lautet der Titel des Werkes, ist ein ganz besonderes Stück Blitzkrieg geworden, dass sich im Regal äußerst gut neben “Dem Mann ohne Eigenschaften” und einer Flasche Sliwowitz machen kann, wenn man es denn nur lässt.</p>\n<h1>Textauszug:</h1>\n<p><strong>“Für den Fall, dass Herr K. nun nicht tot auf dem weißen Vinyl seines Arbeitstraumes liegen würde, hätte die Histamin-Konzentration in seinem Blut in den folgenden Stunden unwiderruflich zu starken und schmerzhaften Blähungen geführt. Nun aber, da er eben tot ist, wird sein sportlicher Leichnam in dreißig Minuten von der netten Thea aus der Buchhaltung entdeckt werden, die aus Gewohnheit verschämt auf den Boden schaut. Dort wird heute allerdings ihr inzwischen ehemaliger Chef liegen und tot zu sein scheinen. Sie wird ihn kurz betrachten und die Mappe mit den Recruitment-Unterlagen auf dem rechten der beiden kniehohen Leuchtbuchstaben ablegen, der laut Company Philosophie für F wie FUTURE steht, eigentlich aber aus dem Fundus einer geschlossenen FDP Zentrale stammt.”</strong></p>\n<iframe width=\"400\" height=\"315\" src=\"//www.youtube.com/embed/CMylGxfeG2E\" frameborder=\"0\" allowfullscreen></iframe>\n"}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

	module.exports = {"title":"Swag-Guide to Berlin","date":"2011-05-30 15:58:50 +0000","tags":null,"layout":"post","body":"<p>\n\tSeit geraumer Zeit existiert ein geheimer Undercover <a href=\"http://www.qype.com/people/newkid\">Qypeaccount</a>, den ich jetzt mit Euch, meinen Freunden, teilen möchte.</p>\n<div style=\"background-color: rgb(255, 255, 255); \">\n\t<p>\n\t\tIm Grunde habe ich mal kurz zusammengefasst, was zuletzt in Sachen Freizeit/Ernährung in der Welt der Freiberufler und Arbeitslosen passierte und einen kleinen Berlin-Guide mit den beiden schlechtesten Fotos, die ich auf meinem Handy gefunden habe, zusammengestellt.</p>\n\t<p>\n\t\t </p>\n\t<h3>\n\t\tPizza Dach / Friedrichshain</h3>\n\t<p>\n\t\t\"Jetzt mal im Ernst: Nüchtern würde man dort vermutlich nicht mal etwas geschenkt annehmen. Aber wenn sich zweimal die Woche im Vollsuff Fleischhunger und der Bock auf das fettigste Essen der Stadt paaren, dann kann man ruhig sein Leergut eintauschen und von den 3 Tacken fünf verschiedene Gerichte, die alle gleich schmecken, bei Pizza Dach einfahren gehen.\"</p>\n\t<h3>\n\t\tCassiopeia / Friedrichshain</h3>\n\t<p>\n\t\t<span class=\"Apple-style-span\" style=\"font-size: 12px; font-weight: normal; \">\"Der Club ist ein Todschlagargument für Türpolitik im allgemeinen. Da kann jeder rein und macht es auch. Wenn gerade wieder Stütze überwiesen wurde, wimmelt der Club von Menschen aus dem RTL Nachmittagsprogramm.</span></p>\n\t<p>\n\t\tDas Bier ist gut, denn es kommt aus der Flasche.\"</p>\n\t<h3>\n\t\tMr.Pizza / Friedrichshain</h3>\n\t<p>\n\t\t\"Wo fängt Kreativität an und wo beginnt misanthropischer Gastronomie-Faschismus?\"</p>\n\t<h3>\n\t\tPizzeria Ameretto Due / Friedrichshain</h3>\n\t<p>\n\t\t\"Ich hatte Hunger und zugebenermaßen bin ich ein leicht übergewichtiger soziophober Nerd, der Sonntagsabends eine Familienpizza bestellt, weil online Rollenspiele immer etwas hungrig machen.</p>\n\t<p>\n\t\tAls ich den Karton mit großer Anstrengung öffnete, kam eine wabbelige Masse farbloser Substanz im Schein meines flimmerndern Jappy-Chatfensters zum Vorschein. Die Pizza schmeckte fad und ich bin normale ehrlich ein Typ, der alles in sich reinschlingt, aber das ging wirklich so nicht. Der Teig war ziemlich fettig und das Gemüse schmeckte wie aus der Dose und war nicht am Geschmack zu unterscheiden.</p>\n\t<p>\n\t\tJetzt liegt der fast volle Karton hier und ich bin traurig.\"</p>\n\t<h3>\n\t\tSSE Schwimmhalle / Prenzlauer Berg</h3>\n\t<p>\n\t\t\"Ich habe noch niemals in meiner langen Karriere als Falschparkeraufschreiber so eine faschistoide Hackordnung gesehen wie in diesem Schwimmbad.\"</p>\n\t<h3>\n\t\tFleischerei Domke / Friedrichshain</h3>\n\t<p>\n\t\t\"Nachher gehe ich meist vollkommen übersättigt heim und pöbel unterwegs ein paar Touristen an.\"</p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t<img alt=\"\" height=\"375\" src=\"/files/essen2.jpg\" width=\"500\" /></p>\n\t<p>\n\t\t </p>\n\t<h3>\n\t\tFamily Chicken / Friedrichshain</h3>\n\t<p>\n\t\t\"Ich hasse es, dass ich gar nichts kritisieren kann. wenn man nicht mal zu einem billigen Geflügelschrottladen anonym im Internet einen bösartigen Beitrag schreiben kann, dann hat das doch mit \"schön\" nichts mehr zu tun.</p>\n\t<p>\n\t\tVorweg: Ja, es ist Geflügelschrott, aber der undefinierbare Kram kam immerhin heiß und in einer unrealistisch großen Menge zu einem spottbilligen Preis an. Es gibt ja ohnehin nichts geileres als sich zugedichtet Chickenteile reinzufahren und dabei wie Baumwollpflücker am Fuße des Missisippi zu schwadronieren.</p>\n\t<p>\n\t\tNach dem Familymenü geht's einem zugebenermaßen sehr schlecht. Stundenlanges aufstoßen, Oberbauchschmerzen. Einige Tage später rächt sich der Geflügelwulst aus 4688 verschiedenen Tieren durch das Aufblühen lassen einer postpubertären Akne.\"</p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t<img alt=\"\" src=\"/files/essen1.jpg\" /></p>\n\t<p>\n\t\t </p>\n\t<p>\n\t\t </p>\n\t<p style=\"color: rgb(34, 34, 34); font-family: Arial, Verdana, sans-serif; font-size: 12px; \">\n\t\t </p>\n</div>\n"}

/***/ }),
/* 711 */
/***/ (function(module, exports) {

	module.exports = {"title":"Techno 2Pac","date":"2012-02-14 10:47:37 +0000","tags":null,"layout":"post","body":"<script src='/javascripts/jquery.js'></script><script src='/javascripts/widget.js'></script>\n<p>\n\t<img src=\"/content/images/tn_diskopac.jpg\" alt=\"tn_diskopac.jpg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWenn ich mal ein Album aufnehme, dann wird es &quot;Techno 2Pac&quot; heißen. Heute muss sich aber niemand fürchten, denn bin ich im Dienste der Popmusik unterwegs und präsentiere eine gigantische Schlachtplatte an neuen, bekannten und nicht weniger liebenswerten Musikern.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<a class=\"widget\" href=\"http://soundcloud.com/kompakt/whomadewho-below-the-cherry\">player</a></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<a class=\"widget\" href=\"http://soundcloud.com/mariemadeleine/no-love-the-feeling-of-love\">player</a></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<a class=\"widget\" href=\"http://soundcloud.com/sound-injections/au-palais-tender-mercy\">player</a></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<a class=\"widget\" href=\"http://soundcloud.com/tape3000/tape3000-f-rst-r-mig\">player</a></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<a class=\"widget\" href=\"http://soundcloud.com/mittekill-1/you-are-home\">player</a></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<a class=\"widget\" href=\"http://soundcloud.com/segyou/jan-turkenburg-in-my-spaceship\">player</a></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<a class=\"widget\" href=\"http://soundcloud.com/jokers-of-the-scene/jokers-of-the-scene-black-3\">player</a></p>\n<p>\n\t&nbsp;</p>\n"}

/***/ }),
/* 712 */
/***/ (function(module, exports) {

	module.exports = {"title":"Text für meine demente Großmutter","date":"2012-11-16 00:00:00 +0000","tags":null,"layout":"post","body":"<p>Dieser Text ist für meine demente Großmutter, damit sie weiß wer sie ist.</p>\n<img src=\"/content/images/grafikflower.jpg\" alt=\"grafikflower.jpg\" />\n<script src=\"/javascripts/jquery.js\"></script><script src=\"/javascripts/widget.js\"></script>\n<p><a class=\"widget\" href=\"https://soundcloud.com/bangpowwww/text-f-r-meine-demente\">player</a></p></p>\n<p>Großmutter, das war immer Batman für mich. Nicht Catwoman, sondern Batman. Die Frau, die von morgens bis abends wild gestikulierend und bis aufs Blut aufgeregt über die Nazis schwadronierte und auf ihrem knarzenden und knarrendem Dielenboden knackend hin- und herlief wie ein bis auf die Zähne bewaffneter Soldat mit grauem Herrenhaarschnitt, einer riesigen Hakennase - und Augen muss sie wohl damals auch gehabt haben. Niemand kann bis heute die Farbe ihrer Augen benennen. Sie ist auch egal. Aber sie waren bestimmt - sie waren immer schon da und sie waren immer hellwach und so ein Blitzen und analytisches Durchfräsen ging von ihnen aus. Nein, nein, diese Verbrechen dürften nicht noch einmal passieren! Wir müssen immer aufpassen. Und solange Großmutter lebt, wird es sowas nicht mehr geben wie den Hitler. Und die Deutschen. Denn Großmutter wusste das Geheimnis, dass es damals nicht der Hitler war, sondern dass es die Deutschen waren und es damals und heute nicht zu trennen galt. Der Batman der Demokratie eben. Aber was ist, wenn sie mal stirbt?</p>\n<p>Komisch. Meine Erinnerungen an die vielen Dinge, die sie sagte sind sehr detailgetreu und messerscharf, aber ich kann nicht sagen, ob sie all die Jahre in ihrem Haus, in der Wohnung, in der kleinen puppig eingerichteten Küche Schuhe trug oder eben nicht. Das macht auch keinen Unterschied, denn auch ohne Schuhe hätte ihre Erscheinung, ihr knüppelharter Körper, der schmale Stahlleib auf dem Dielenboden bestimmt ebenso hölzern geklungen wie er es auch mit Absatzschuhen getan hätte. Großmutter war unzerstörbar. Und ist es bis heute. Trotz ihrer Demenz. Oder vielleicht gerade deswegen.</p>\n<img src=\"/content/images/IMG_0230.jpg\" alt=\"IMG_0230.jpg\" />\n<p>Wenn man bei Großmutter schlief und morgens in der Früh durch die dicken verstaubten Gardinen neben dem Schminktisch aus Ebenholz mit den Elfenbeinpuderdosen schaute, konnte man direkt auf den benachbarten Schlachthof sehen. Metzgerei Hammer. Unser Fleischer. Hier wurde immerzu geschlachtet und der ganze Schrott dann fünfzig Meter weiter in der Filale der Metzgerei in der Fußgängerzone an die Familien und tratschenden Witwen der kleinen Stadt verkauft. Statt Kilo gab es Pfund und irgendwann kam dann BSE und alle kauften nur noch Schwein. Aber auch nur ein paar Jahre. Wir aßen manchmal Rind. Großmutter hatte eben Superheldenmut. Und Schweinehackfleisch schmeckte auch nicht so gut. Schweine wurden mittels eines Stahlgitters in das gekachelte Gebäude eingefercht. Ansonsten war unser Haus toll. Das zweitälteste Haus in Hachenburg, dem kleinen Ort in dem ich geboren und aufgewachsen bin. Angeblich sollte es dort spuken. Nicht in Hachenburg. Aber in unserem Haus. Wir fanden Knochen in einem verschütteten Brunnen im Keller. Manchmal, ein Mal die Woche, kam der Abdecker und holte die Abfälle des Schlachthofs ab. Oft zur Mittagszeit, wenn Großmutter, die unter der Woche für uns kochte, gerade am Mittagstisch Sauerampfersupper oder Scheppklöße servierte. Kreppelchen oder Dergutekuchen. Dann musste eines von uns Kindern schnell aufstehen und die Balkontür schließen. Die vielen Fliegen kamen sehr rasch. Magisch vom Geruch des verwesenden Fleisches angezogen und aufgegeilt wie nach einem animierten Fetischporno. Draußen kippte der Abdecker - kaum zwanzig Meter von unserer heilen Tafel entfernt - die Tierreste, die Felle und Knochen und all den übel riechenden Schrott, der schon seit Tagen in dicken Plastiktonnen vor sich hinrottetet in einen riesigen Sammelbehälter für Tiermasse, der dann ein mir unbekanntes Ziel ansteuerte. Vielleicht die Haribo Werk in Bonn? Wir aßen die kleinen Klößchen in unserer Suppe. Und, was habt ihr als Hausaufgaben aufbekommen?</p>\n<img src=\"/content/images/IMG_0201.jpg\" alt=\"IMG_0201.jpg\" />\n<p>Wenn Großmutter kochte, dann gab es kein attraktives Gemüse. Das Gemüse war hart, fettig und vom restlichen Essen sowohl räumlich als auch emotional abgetrennt. Möglichst wenig ansprechend für Kinder. Beilagen. Beilagen. Beilagen. Erbsen. Möhren. Oder mal was besonderes, wie zum Beispiel Erbsen und Möhren gemischt. Blumenkohl einfach dabei. Mich gruselt es noch heute vor Menschen, die für Blumenkohl Geld ausgeben. Brokkoli. Immer dabei. Niemals Salat. Salat, dieses Konzept war unserer Familie nicht bekannt. Erst Jahre später schaffte es Mutter erfolgreich Gemüse in Gerichte zu integrieren und dieses somit für uns essbar zu gestalten. Großmutter wird bald sterben und das so nicht kennen. In ihrer Erinnerung, im Portfolio ihres Lebens, in ihrer Erinnerungskartei, die da irgendwo liegen muss, auf die sie aber keinen Zugriff mehr hat, wird irgendwo eine Karte liegen auf der steht, dass sie ihr ganzes Leben Gemüse nur als Beilage gekannt hat. Als Beilage. Aus der Dose. Und zu Fleisch. Immer Kartoffeln. Wir aßen immer nur Kartoffeln. Oder Nudeln. Pasta kannten wir schlichtweg nicht und bei uns hieß Lasagne auch immer nur Nudelauflauf und auf alles kam Ei. Ei auf dem Nudelauflauf. Und Pizza mochten wir bei Oma gerne. Die Pizza bestand aus einem drei Zentimeter dicken Backpulverteigboden, Cervelatwurst, Gouda und Ei. Ei über alles. Oma hasste den Führer, aber sie liebte Ei. Im Nudelauflauf waren immer dicke Schinkenwürfel.</p>\n<p>An Geburtstagen gab es für uns Kinder immer köstlichen selbstgebackenen Frankfurter Kranz statt den Gutenkuchen, den es an Wochenenden sonst immer gab, wenn uns mein Onkel aus der großen Stadt besuchte. Ihr Sohn. Der langhaarige Mann mit dem großen Auto, der immer so gerne mit uns Kindern spielte und im Phantasialand auf den Achterbahnen kreischte wie eine Grundschülerin. Der Gutekuchen hieß Gutekuchen, weil ich ihn liebte und mangels Sprachkenntnissen als kleines Kind so betitelte. Familien entwickeln ihre eigenen Vokabeln. Wir hatten eine Familie. Der Gutekuchen war Sandkuchen. Bei uns war es eben der Gutekuchen. Wir sind die Familie Hitzel. Wir haben Wörter für unsere Zusammengehörigkeit. Der Krokant des Frankfurter Kranzes schmolz an den Kinderzähnen förmlich nur so dahin. Eine Explosion der Liebe. Und der Zuneigung. Diese Großmutter musste uns sehr lieben. Wie sorgsam sie sie Zutaten mit ihrer alten Wandwaage abwog, die Butter auf dem Herd schmolz, das Mehl siebte. Die Buttercreme war zart wie die Handtücher nie waren, die Mutter immer ohne Feinwaschmittel wusch. Unsere Handtücher waren immer rauh und hart. Ich bin aufgewachsen ohne den Segen eines weichen Handtuchs.</p>\n<p>An Weihnachten haben wir Plätzchen gebacken. Spritzgebäck. Makronen. An Ostern färbten wir Eier bei Großmutter. Wir durften nachher die Schalen der bunten Objekte mit einer dicken Speckschwarte einreiben bis sie magisch glänzten. Speck. Wie das roch! Großmutters Kühlschrank war mir als Kind wenig unheimlich. Alle müssen so kochten, dachte ich. Mit echten Markklößchen mit Knochenmark, mit Speck. Alles wurde in kiloweise Butter angebraten bis es buttrig, fast schon durchsichtig glänzte und fettig von der Gabel glitschte. Gewürzt wurde ausschließlich mit Salz. Samstags gab es immer Braten. Und Klöße. Oder gutes Fleisch. Fettige Brocken. An Weihnachten aß Großmutter hemmungslos den Bürzel der Gans mit.</p>\n<p>Oma hatte immer die neuste Ausgabe der Zeitung die ZEIT auf dem Wohnzimmertisch liegen. Aus dieser schnitt sie einzelne Artikel aus. Ich weiß bis heute nicht wo diese Artikel geblieben sind. Vielleicht hat sie sie einfach heruntergschluckt. Für mich war Großmutter die intelligenteste Frau der Welt. Niemand war wie sie.</p>\n<p>Im Bett, wenn wir bei Großmutter schliefen, radelten wir morgens nach dem Aufstehen immer mit den Beinen in der Luft. Um gesund zu bleiben. Fünf Minuten. Dann hat uns Großmutter mit ihrer mächtigen Stimme aus Grimms Märchen oder Andersens Märchen vorgelesen und ist dann runter in die kleine warme Küche stolziert um sich dampfenden Mokka, und uns Kakao mit viel Haut zuzubereiten. Es gab Bröckelchen. Stücke von alten Brötchen in Butter knusprig angebraten und gepfeffert. Die Sendung mit der Maus auf dem viel zu lauten Fernsehgerät guckend, und am runden Wohnzimmertisch mit der Spitzendecke sitzend, habe ich dann Kakao getrunken und mich unendlich gefühlt. Warmer Kakao mit Haut. Und meine Bröckelchen gegessen. Und sonntags gab es immer Kaisersemmeln mit ziemlich dick Butter und Bierschinken und dieser Wurst, die ich als Kind so liebte und über die mir mein drei Jahre älterer Bruder in einem gehässigen Moment verriet Das ist Zungenwurst!.</p>\n<p>Kopfball. Und der Presseclub. Wenn der Presseclub lief und Großmutter dann interessiert war und zuhören wollte, konnte ich das meistens nicht mehr. Die Sendung mit der Maus hatte mich aufgepeitscht und überstrapaziert. Ich wollte lieber mit den Ritterfiguren im Treppenhaus spielen, oder Kugelblitz, Maumau oder Mühle. Man gönnt seinen Großeltern als Kind nichts. Einen Großvater hatte ich nie. Beide tot. Aber ich habe sie niemals vermisst, denn Großmutter war Mann und Frau und Großmutter war immer genug und war alles für mich.</p>\n<p>Wenn ich heute meine Großmutter besuche, dann ist sie immer kleiner. Sie ist geschrumpft. Ständig macht sie sich Kaffee. Sie hat vergessen, dass sie schon einen getrunken hat. Gekrümmter Rücken. Bis zum Boden und noch tiefer. Und so würdevoll wie sie mir vor zwei Jahren bei einem Besuch eine Zwiebel wie einen Apfel geschält und hingereicht hat, hat es noch niemand getan. Im Haus gibt es keine Musik mehr und keinen Fernseher. Nur Stille. Informationen dringen nicht mehr durch. Draußen könnte Krieg sein oder auch nicht, es würde nichts ändern. Wir sind ihr Batman geworden. Sie kennt meinen Namen. Wie ein verkrampftes Reptil sitzt sie in ihrem Samtsessel. Starrt bloß aus dem Fenster. Was in ihr drin ist, weiß niemand und das weiß noch nicht mal sie selber. Wenn ich sie frage, dann hat sie es schon vergessen und antwortet Mir gehts gut. Ich bin zufrieden. und starrt wieder aus dem Fenster und wartet auf den Sommer oder auf den Schnee.</p>\n"}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

	module.exports = {"title":"Textkrieg buchen","date":"2014-02-25 00:00:00 +0000","tags":null,"layout":"post","body":"<img src='http://media-cache-ec0.pinimg.com/originals/2d/d9/9e/2dd99eca41b5f2c2c070df867e533247.jpg' alt=''>\n<p>Nun ist es ja so: Ich powere wieder als Freiberuflerin durch alle Social Media Kanäle und man kann mich wie gewohnt für Textkrieg Dienstleistungen buchen und richtig gut finden. Über diese Tatsache freue ich mich wie ein kleines Kind, das zu Weihnachten ein Paket mit einem speckigen Shetlandpony unter dem Baum vorfindet. Freiberuflichkeit ist ein großes Privileg für kreative Menschen wie mich und verhütet Betriebsblindheit der Agenturen, die lediglich Klone anderer Agentur sind, die auch nur Kopien weiterer Agenturen sind und die die hübsche Social Media Landschaft durch permanente Rezidive unbemerkt veröden lassen. Das Internet hat Besseres verdient!</p>\n<p>Allerdings fragen mich interessierte Kunden immer wieder, wie denn eigentlich mein Leistungsspektrum genau aussieht und was ein Textkrieg Auftrag kostet. Daher möchte ich einige Worte über meine professionelle Seite verlieren. Wer ich bin. Und was ich mache. Und wieso ich das mit dem Text und den Ideen ganz gut kann.</p>\n<h1>Ada</h1>\n<p>Hallo, ich bin <a href=\"http://textkrieg.de/pages/presse\">Ada Blitzkrieg</a> und ich arbeite als freiberufliche Journalistin und Social Media Konzepterin in Berlin Kreuzberg. Nebenbei unterhalte ich eine kontroverse Kolumne bei <a href=\"https://www.intro.de/autor/Ada+Blitzkrieg\">INTRO Magazin</a> und bin Autorin zweier <a href=\"http://textkrieg.de/pages/dackelkrieg\">Überfliegerromane</a>. Vierundzwanzigtausend Follower bei <a href=\"https://twitter.com/bangpowwww\">Twitter</a> und ein paar Tausend Gequetschte bei Facebook, Pinterest, Vine und an die fünftausend Fans bei <a href=\"http://instagram.com/bangpowwww\">Instagram</a>. Wer mich bucht, bucht eine ganze Menge Kreativität und originäre Felderfahrung mit - und genau das unterscheidet mich von den üblichen Agenturen, die ihrer Konzepte und Texte auf dem sterilen Reißbrett entwerfen und Social Media nur beruflich kennen. Ich lebe Social Media.</p>\n<p><img src=\"http://distilleryimage10.ak.instagram.com/fce53366279f11e393fe22000a1fcb64_8.jpg\" alt=\"Alt text\"></p>\n<p>Die Festanstellung als Social Media Konzepterin für eine namhafte Agentur war in erster Linie eines: Lehrreich und inspirierend. Ob Pizza Hut oder Harley Davidson, zum einen habe ich nicht nur eine großartige Zeit in einem tollen Team gehabt, sondern währenddessen auch gelernt Ideen passgenau für die Ansprüche des Kunden zu strukturieren und zielorientiert in Hinblick auf eine langfristige Strategie zu präsentieren. Vom Status Quo Check, bis hin zu Strategiebausteinen und monatlichen Redaktionsplänen, ich habe meinen Erfahrungsschatz dehnen können.</p>\n<p>Zum anderen habe ich in der Branche auch erfahren müssen, wie betriebsblind viele Agenturen schnell ab einer gewissen Größe werden. Dabei werden wieder und wieder die gleichen Schemata und Ideenschatten auf die eigentlich sehr individuellen Wünsche der Kunden angepasst, anstatt sich mit der Frage des Alleinstellungsmerkmals genauer zu beschäftigen - oft fließt viel Geld für leicht abgeänderte Ideen, die eigentlich genau so schon vorhanden sind. Mein Schwerpunkt als Freiberuflerin liegt auf der Gestaltung eines einmaligen Mehrwertes für Fans, Follower und Unternehmen. Wer Textkrieg bucht, bekommt ihn auch. Jedes Konzept soll die Möglichkeit haben, das beste Konzept des ganzen verdammten Internets zu werden. Chancen müssen designet werden, anstatt lediglich ummodelliert.</p>\n<h3>Neue Skills:</h3>\n<p>Strategie und Konzepte in Strukturen gießen</p>\n<h3>Alte Skills:</h3>\n<p>Kreativität, Textsicherheit und ein Gespür für Trends jenseits von Bubble Tea, sexistischen Slogans und “frechen” Damenfrisuren</p>\n<h3>Was neu ist:</h3>\n<p>Ein Hybrid aus dem Besten der neuen und alten Welt von Textkrieg</p>\n<p>Kunden, die Textkrieg wollen, bekommen nun auch Textkrieg-Ideen. Daher biete ich folgende Leistungen an:</p>\n<h1>SOCIAL MEDIA KONZEPT</h1>\n<p>Für Produkte, Unternehmen, Künstler und Privatpersonen</p>\n<h1>TEXT</h1>\n<p>Redaktionspläne für alle Social Media Plattformen</p>\n<h1>KOSTEN</h1>\n<p>Ich biete individuelle Stundensätze, Tagessätze und Monatssätze, sowie Projektpauschalen an. Am Besten einfach direkt an mich wenden und ein Angebot bekommen!</p>\n<h1>SOLLST DU MICH ANSPRECHEN?</h1>\n<p>Versucht es doch einfach mal! Jedes Projekt verdient es im Mittelpunkt der Aufmerksamkeit stehen zu dürfen und individuell analysiert und designt zu werden. Kein Projekt ist zu klein - oder zu groß. Es findet sich immer eine Idee. Wir können in Dialog treten!</p>\n<h1>KONTAKT</h1>\n<p>Eine Anfrage startet Ihr einfach per Email mit den Rahmendaten an <a href=\"mailto:kontakt@textkrieg.de\">kontakt@textkrieg.de</a> und ich bin in der Regel schnell in Kontakt mit Euch.</p>\n"}

/***/ }),
/* 714 */
/***/ (function(module, exports) {

	module.exports = {"title":"Textkrieg goes to California","date":"2012-08-21 06:43:37 +0000","tags":null,"layout":"post","body":"<p>In einer Woche geht es dann endlich los: Das Blitzkrieg HQ startet in totaler Euphorie in Richtung Kalifornien. Meine Reisevorbereitungen beschränken sich bisher leider ausschließlich auf das Lesen von <a href='http://sanfrancisco.grubstreet.com/2012/07/50-best-burgers-list-san-francisco-hamburgers.html'>Burger-Porn</a> und das Rummeckern, weil ich wegen des teuren Flugs kein Geld mehr für die Sonnenbrille habe, die ich kürzlich für <a href='http://selekkt.com/design-tipps-von-ada-blitzkrieg'>Selekkt</a> in den Designtipps vorstellte. Ich habe es trotz hundertfachem Facebookgenerve ‘Hallo, kann mir jemand einen Trolley leihen?’ nicht geschafft mir einen größeren Trolley klarzumachen. Da habe ich es einfach wieder aufgegeben. Hallo, kann mir jemand einen Trolley leihen? Zum Glück hatte ich geistesgegenwärtig vor einigen Monaten meinen Reisepass beantragt und die ESTA Unterlagen zur Einreise ausgefüllt. Im schlechtesten Fall reise ich also mit Plastiktüten, aber immerhin darf ich einreise.</p>\n<img src=\"/content/images/CACACSF2222.jpg\" alt=\"CACACSF2222.jpg\" />\nFoto by <a href=\"http://carlsturgess.tumblr.com/\">Carl Sturgess</a>\n<p>Geht es in der Zeit eigentlich weiter mit Textkrieg?\nJa, mit Textkrieg wird es wie gewohnt weitergehen. Die erste Zeit verbringe ich in einem Appartment im schönen <a href=\"http://www.missionmission.org/\">Mission District</a> von San Francisco. Von dort werde ich wie gewohnt (außer die Zeitverschiebung!) arbeiten und bin dann auch weiterhin für Anfragen und Aufträge offen. Es wird zwar eine amerikanische Handynummer geben, dennoch bin ich nach wie vor am besten per Mail erreichbar. <a href=\"http://textkrieg.de/pages/kontakt\">Kontaktiert mich!</a></p>\n<p>Ab Mitte September lebe ich dann den Traum und heize mit einem <a href=\"http://de.wikipedia.org/wiki/Ford_Mustang\">Ford Mustang Convertible Cabrio</a> eine beachtliche Strecke durchs Land. Entlang des Highway 1 nach LA und San Diego. Durch Death Valley fahre ich nach Las Vegas um dort meinen <a href=\"https://twitter.com/bangpowwww/status/236409077146726400/photo/1\">Rettich</a> in einer festlichen Zeremonie zu heiraten. Weiter geht es durch den Grand Canyon National Park und den Yosemite National Park. Ich hoffe ich finde eine Jogginghose mit USA-Aufdruck, kann mir eine Waffe klauen, einen BBQ Cook-Off gewinnen und eine Hand voll Welpen aus dem Pet-Store mitnehmen.</p>\n<p>Und jetzt zu Euch: Schickt mir San Francisco und California-Tipps!</p>\n"}

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	module.exports = {"title":"The Guide To Don´t Give A Fuck","date":"2014-03-05 00:00:00 +0000","tags":null,"layout":"post","body":"<p>Klar, wir sind alle Individuen, die megatoll und sowieso superunique und liebenswert sind, aber die Frage lautet doch, wissen die anderen das eigentlich auch?</p>\n<h3>1. Es gibt immer Hater!</h3>\n<img src=\"http://data1.whicdn.com/images/88316706/large.jpg\" alt=\"\">\nGanz ehrlich, verabschiede Dich doch einfach von dem naiven Gedanken, dass Dich alle anderen lieben und mögen müssen. Ab einer bestimmten Bekanntheit oder dem einmaligen Posten eines Ganzkörperfotos im Social Web fungierst Du sowieso nur noch als Zielscheibe für das Scheißleben und den Frust der anderen. Als eine Art Katalysator dient jede Deiner wie auch immer gearteten Aktionen, jedes Fotos oder jedes Wort, das du mit der hassenden Masse teilst. Dabei ist es egal ob Du hübsch bist oder hässlich wie die Nacht, dumm oder schlau; es gibt immer einen Angriffspunkt und der wird in der Regel auch ausfindig gemacht werden.\n<p>Share also in Zukunft lieber gezielt Inhalte, die Dich so darstellen wie du wirklich bist: Nett, aber auch ziemlich hassenswert. Und hör verdammt nochmal auf Dir selbst vorzulügen, Du wärst zu hundert Prozent liebenswert und hättest eine gute Reputation verdient. Hast Du nicht.\nHerzlichen Glückwunsch, jetzt kannst Du Dich gemütlich zurücklehnen und Dir bei jeder Anfeindung denken “Haha! Meinetwegen. Who cares?”.</p>\n<h3>2. Das Internet hasst Dich doch sowieso!</h3>\n<p><img src=\"http://cdn.shopify.com/s/files/1/0170/2786/products/card_j_1024x1024.jpg?v=1393278087\" alt=\"Alt text\">\nDas Internet ist neidisch und nimmt sich gegenseitig die Butter vom Brot. Minütlich. In Echtzeit und aus einer sicheren Entfernung hinter dem Bildschirm. Totzdem kennt ihn wohl jeder: Den Erzfeind. Man weiß nicht warum, aber diese Person hasst Dich bis auf´s Blut. Meistens hat sie das gleiche Geschlecht, ist ähnlich alt und - das ist der entscheidende Punkt - ist weitaus weniger erfolgreich als Du selbst. Der Erzfeind stalkt Dir permanent hinterher. Er kommentiert Dein Leben im Glauben er wäre witzig und irgendwie wäre seine Tätigkeit wichtig für die Gesellschaft. Nicht zuletzt, damit alle wissen wie defizitär Du bist.\nDas Dumme nur: Niemand liest den Idiot, außer natürlich Du. Ändere das doch einfach durch Blocken oder verschaffe ihm die nötige Aufmerksamkeit für sein Lieblingsprojekt: DICH! Teile die Boshaftigkeiten und freue Dich darüber im Mittelpunkt der Aufmerksamkeit zu stehen.</p>\n<p>Im Internet herrscht Selbstwert-Kannibalismus. Friss oder stirb! Lass Dich einfach niemals von jemand unterkriegen, der Dich nicht auch auf der Strasse zu einer Messerstecherei herausfordern würde, sondern hinter seinem schmodderigen Bildschirm sitzt und sowieso weitaus weniger interessante Fehler hat als Du.</p>\n<h3>3. Deine Eltern hassen Dich!</h3>\n<p><img src=\"http://media-cache-ak0.pinimg.com/736x/4c/fd/bc/4cfdbcdc7e75c827ee310d58084d6699.jpg\" alt=\"Alt text\">\nDeine Eltern hassen Dich ohnehin seit Jahren. Sei froh, denn so kannst Du dich ganz easy zurücklehnen und weiterhin ihre nichtvorhanden Erwartungen an Dich ohne besonderen Kraftaufwand erfüllen.</p>\n<h3>4. Dein Partner hasst Dich auch!</h3>\n<p><img src=\"http://media-cache-cd0.pinimg.com/736x/4f/1c/da/4f1cda753b005105de206a9337f2eed2.jpg\" alt=\"Alt text\">\nSchade, dass man sich den Ring noch nicht selbst anstecken kann! Dein Partner steht nicht hinter Dir? Verpetze seine letzten Fehltritte bei seinen Eltern oder trete ihn das nächste Mal um, wenn er wieder im Stehen pinkelt. Mach Dich von Menschen frei, die Dich bremsen! Keine Freundschaft existiert zu lange um sie nicht auf der Stelle zu beenden.</p>\n<h3>5. Dein größer Hater bist Du selbst!</h3>\n<p><img src=\"http://24.media.tumblr.com/dc4e2839d90827caea8525b7283ca8f8/tumblr_mkqqmwuV311qz4d4bo1_500.jpg\" alt=\"Alt text\">\nOb Bulimie, Perfektionismus oder einfach nur fehlende Selbstliebe, wir sind uns ständig am messen und rechtfertigen. Vor anderen und vor uns selbst. Such Dir doch lieber ein entspannteres Defizit mit Zukunft wie Cannabis-Konsum oder einen durch die Gesellschaft nicht geduldeten Fetisch. Mach Dich selbst zum Aussenseiter und spiele mit Deinen Angriffspunkten. Setze Dich auf einer Party an den Rand und gucke traurig! Esse einen Döner im Hipster-Café! Bitte trag Leggings oder Röhrenhosen egal wie dick oder dünn Du bist! Weine vor Aufregung wenn Dich ein Fremder anspricht oder gib offen zu in Stresssituationen Dein Haustier anzuschreien. Du kannst es Dir wert sein, wenn Du nur willst!</p>\n"}

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	module.exports = {"title":"Incredible banana bread with pecan ice cream","date":"2012-11-06 00:00:00 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/banananbread.JPG\" alt=\"banananbread.JPG\" />\n<p>Wow, könnt Ihr Euch noch erinnern, wie ich vorgestern auf so ziemlich jeder Euch bekannten Social Media Plattform mit meinem selbstgebackenen Banananbrot mit Walnüssen rumprahlte wie ein beschissenes Ego-Arschloch? Wisst Ihr noch wie Ihr total angegeilt, leicht bekifft oder berattert und ziemlich positiv angetan vor Euren Bildschirmen saßt und Euch das Wasser im Mund zusammenlief? Ja, dann lest weiter:</p>\n<p>Ehrlich, es gibt nichts Besseres, als einen noch warmen Kuchen oder eben ein Bananenbrot direkt aus dem Ofen auf den Teller und dazu eine gute Eiscreme und Schlagsahne. Schon als das Brot im Ofen war, verbreitete sich in der Küche ein derartig betörender Duft nach kulinarischer Geilheilt, das ich wie gebannt die ganzen 55 Minuten Backzeit dem obszönen Treiben im Ofen zugucken musste.</p>\n<p>Hier also das Rezept für mein Bananenbrot. Das Eis ist übrigens gekauft, da ich keine Eismaschine besitze. Ich nehme bevorzugt ein gutes Eis. Für die Kombination mit meinem Bananenbrot empfehle ich eine Nusssorte von Häagen-Dazs.</p>\n<img src=\"/content/images/bananan3.JPG\" alt=\"bananan3.JPG\" />\n<p><strong>Hot banana walnut bread with pecan ice cream and whipping cream</strong></p>\n<p>Zutaten:</p>\n<p>Eiscreme nach Belieben</p>\n<p>200ml Schlagsahne</p>\n<p>3 sehr reife Bananen</p>\n<p>1 Tasse Walnüsse</p>\n<p>2 Eier</p>\n<p>1/2 Becher Naturjoghurt</p>\n<p>2 Tassen Mehl</p>\n<p>1 Tasse Zucker</p>\n<p>1 TL Backpulver</p>\n<p>1/2 TL Salz</p>\n<p>5 EL geschmolzene Butter</p>\n<p>1 Vanilleschote</p>\n<p>DIY:</p>\n<ol>\n<li>\n<p>Den Backofen auf 180°C vorheizen.</p>\n</li>\n<li>\n<p>Eine circa 22x12cm Backform mit Butter einfetten und dünn aber gleichmäßig mit Mehl bestäuben.</p>\n</li>\n<li>\n<p>Die Walnüsse kurz in einer heißen Pfanne ohne Fett anrösten. Dabei aber gut aufpassen, denn wenn die Pfanne erst einmal heiß ist, verbrennen die Nüsse unfassbar schnell.</p>\n</li>\n<li>\n<p>In einer Schüssel Zucker, Mehl, Backpulver und Salz vermischen.</p>\n</li>\n<li>\n<p>In einer zweiten Schüssel die geschälten Bananen (unbedingt sehr sehr reife Bananen mit dunklen Stellen benutzen!) mit einer Gabel zermatschen. Den Joghurt, den Inhalt der Vanilleschote, die Eier und die 5EL der geschmolzenen Butter dazumischen und alles mit einem Teigschaber durchmischen bis die Konsistenz etwas gleichmäßiger ist. Nun die Walnüsse untermischen.</p>\n</li>\n<li>\n<p>Nun die Bananen-Nuss-Mischung nach und nach in die Schüssel mit dem Mehl einrühren. Alles gut mit dem Teigschaber oder einem Holzlöffel vermengen. Den fertigen Teig dann in die Backform geben.</p>\n</li>\n<li>\n<p>Das Bananen-Walnuss Brot circa 55 Minuten im Ofen bei 180°C backen bis es schön braun wird.</p>\n</li>\n<li>\n<p>Die Schlagsahne steif schlagen.</p>\n</li>\n<li>\n<p>Etwa 10 Minuten vor Ende der Backzeit das Eis aus dem Tiefkühlfach nehmen.</p>\n</li>\n<li>\n<p>Das heiße Brot aus dem Ofen nehmen und warm mit einem Löffel Eis und Schlagsahne servieren.</p>\n</li>\n</ol>\n<img src=\"/content/images/banana2.JPG\" alt=\"banana2.JPG\" />\n"}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	module.exports = {"title":"Thor Steinar der Vorbereitungsnazis","date":"2011-07-07 08:09:41 +0000","tags":null,"layout":"post","body":"<p>\n\tDienstag, 5.Juli 2011. Irgendeine Uhrzeit zwischen 12 und 18 Uhr. Ich bin ungeduscht. Mein Telefon klingelt. Am Apparat.&nbsp;Der Pressesprecher einer bekannten &nbsp;Bekleidungs- und Outdoormarke. Es gehe um meinen Nazivergleich.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEin kurzer Rückblick: Einen Tag zuvor postete ich meine Review zum <a href=\"http://textkrieg.de/2011/07/04/fusion-festival-2011\">Fusion Festival</a>, in der ich schrieb, dass eine bestimmte Marke beim Camping &quot;das Thor Steinar der Vorbereitungsnazis&quot; sei. Ich verfasste ebenfalls einen Tweet mit diesem Satz und dem Link zu &nbsp;meinem Blogbeitrag. Darüber stolperte irgendwo in Süddeutschland der Pressesprecher der betreffenden Marke und griff zum Telefon.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"211\" src=\"/files/steinar.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tOb ich Ada Blitzkrieg sein und ob ich den Tweet wieder löschen könnte? Der Chef des Unternehmens sei im Grunde sehr links und ein feiner Kerl und fürchtet sich nun vor Reaktionen des Pöbels, der geistig nicht in der Lage sei diesen Vergleich richtig zu verstehen. Die Marke soll doch bitte nicht in Verbindung mit Nazis gebracht werden. Der Pöbel sei nicht mündig genug um selbst zu differenzieren.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tBei diesem Vergleich liegt es auf der Hand: Die Marke ist keine Nazimarke, sondern eine Marke, die hauptsächlich reiche Vorbereitungsneurotiker ausstattet. Menschen, die sich durch finanzielle Investition in Outdoorkleidung auf alle Wetterlagen und Eventualitäten akribisch vorbereiten. Gut organisiert und stramm in ihrer Vorbereitung. Vorbereitungsnazis eben. Passender könnte ein Vergleich nicht sein. Ich traue meinen Lesern und Followern durchaus zu diesen Vergleich richtig zu verstehen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch löschte dennoch den Tweet und den Namen des Herstellers aus meinem Blogartikel aus Angst vor rechtlichen Konsequenzen. Trotzdem möchte ich zu diesem, meiner Meinung nach, vollkommen falschen Vorgehen seitens des Herstellers Stellung beziehen.</p>\n<p>\n\t<br />\n\tWirft diese Bitte nicht ein noch schlechteres Licht auf diese Firma? Meinungen kontrollieren. Mich erinnert dieses Vorgehen immer stark an die Reviews kleiner Restaurants in Berlin, die ihre erste Bewertung bei Qype immer selbst schreiben und jeder merkt es.&nbsp;</p>\n"}

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	module.exports = {"title":"TKKG und der Affen- und Vogelpark","date":"2011-07-22 12:53:36 +0000","tags":null,"layout":"post","body":"<p>\n\tEs scheint ja allgemeinhin in bestimmten Kreisen recht mordern geworden zu sein über Heimat zu sprechen. Meist entladen sich die Antworten in hochemotionalen Ergüßen mittels irgendwelcher Foto- oder Textexperimenten, die ich liebevoll \"Herz-Hiroshima\" nenne. Immer in Hochglanz. Nicht einmal Ross Antony weint, wenn er sowas lesen muss.</p>\n<p>\n\t </p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/affe4.jpg\" width=\"500\" /></p>\n<p>\n\t </p>\n<p>\n\tUm es kurz zu machen: Meine Heimat ist meistens nicht sehr schön gewesen und manchmal auch überhaupt nicht so schön. Aus diesem Grund sind sowohl meine Eltern, als auch meine Lehrer und spätere Freunde, Freier und Geschäftspartner mit mir bei jeder Gelegenheit gerne in den Affen- und Vogelpark Eckenhagen gefahren.</p>\n<p>\n\tZugegeben, ich sah schon immer schön auf dem Trampolin aus. Niemand ist eleganter als ich und drückt sich dabei zeitgleich vulgärer aus. Ab einer gewissen Lachfrequenz produzieren meine Stimmbänder obszöne Grunzlaute. Mir ist diese Tatsache bekannt, aber Fachmänner schätzen sie als untherapierbar ein. Ich bin 24 Stunden am Tag auf die Toleranz anderer angewiesen. Dennoch muss ich in Zoos und Vergnügungsparks den vollen Eintritt bezahlen. Das macht traurig.</p>\n<p>\n\t </p>\n<p>\n\tFür Studenten gibt es keine Ermäßigung. Wieso sollte es auch?</p>\n<p>\n\t </p>\n<p>\n\t </p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/aff3.jpg\" width=\"500\" /></p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/affe2.jpg\" width=\"500\" /></p>\n<p>\n\t </p>\n<p>\n\tVor einigen Wochen waren mein Macker und ich zu Besuch bei den Schwiegereltern. Wie es der Zufall so will, sind wir nur einige Kilometer voneinander großgeworden, obwohl er eigentlich aus dem Osten stammt. Aber wir verschweigen das gerne. </p>\n<p>\n\t </p>\n<p>\n\tWir tollten also einige Zeit in der Outdoorspielhalle herum (lange genug um den Betreibern des Parks zu signalisieren \"Hey, uns gefällt es hier!\", aber kurz genug um nicht unter den Verdacht zu geraten, man schaue den Kindern zu lange auf ihre kleinen schweißglänzenden Speckkörper), machten uns über Kinder mit Zahnspangen lustig und testeten die Spielgeräte aus. Wir fütterten Wellensittiche (am nettesten war der dicke Blaue) und fuhren auf Miniaturachterbahnen. Wir waren so glücklich. </p>\n<p>\n\t </p>\n<p>\n\t<img alt=\"\" height=\"733\" src=\"/files/affe1.jpg\" width=\"500\" /></p>\n<p>\n\t </p>\n<h1>\n\tBerberaffen haben unser Glück zerstört.</h1>\n<p>\n\t </p>\n<p>\n\tEs ist immer so. Ein schöner Tag und dann betritt man das Freigehege dieser Monster. Berberaffen. Neben Pferden gibt es nur eine Tierart, die  so grausam und brutal ist: Der gemeine Berberaffe. Mal angenommen, diese Kreatur wurde wirklich von Gott erschaffen, dann nur nachdem er auf PHOENIX 24 Stunden lang Hitler-Reportagen gesehen hat und in eine Adrenalinspritze gefallen ist. Berberaffen.</p>\n<p>\n\t </p>\n<p>\n\tWas im Gehege passierte und wie ich ein paar Ameisenbären anrotze, könnt ihr hier sehen.</p>\n<p>\n\t </p>\n<p>\n\t </p>\n<iframe width=\"100%\" src=\"http://www.youtube.com/embed/j9LsiICAwg0\" frameborder=\"0\" allowfullscreen></iframe>\n"}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

	module.exports = {"title":"WELT FUNK Blitzkrieg Weihnachtsgrüße C60","date":"2011-12-24 14:20:28 +0000","tags":null,"layout":"post","body":"<p>\n\t<img alt=\"\" src=\"/files/mc.jpg\" /></p>\n<p>\n\t </p>\n<p>\n\tMit dieser Tonbandaufnahme meiner Weihnachtsliedperformance von 1986 wünsche ich Euch allen ein frohes Weihnachtsfest!</p>\n<p>\n\t </p>\n<p>\n\t </p>\n<iframe width=\"100%\"%\" scrolling=\"no\" frameborder=\"no\" src=\"http://w.soundcloud.com/player/?url=http%3A%2F%2Fapi.soundcloud.com%2Ftracks%2F31497487&amp;auto_play=false&amp;show_artwork=true&amp;color=4fff1a\"></iframe>\n"}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

	module.exports = {"title":"Werbeunterbrechung","date":"2011-11-28 16:55:21 +0000","tags":null,"layout":"post","body":"<p>\n\t<img alt=\"\" src=\"/files/marathonmann1.jpg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tMein Kumpel <a href=\"http://prinzpi.biz/\">Prinz Pi</a> beschießt dieser Tage die präfrontalen Konsumareale unseres Gehirns mit seinen visionären Designs für perfektes Textilmerchandise und für uns gilt ein universeller Kaufbefehl.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWas ich damit zu tun habe und wie Ihr an die limitierte Auflage des <a href=\"http://textkrieg.de/2011/07/14/marathonmann\">Marathonmanns</a> kommt, seht Ihr hier:</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<object height=\"455\" width=\"500\"><param name=\"allowfullscreen\" value=\"true\" /><param name=\"allowscriptaccess\" value=\"always\" /><param name=\"movie\" value=\"http://vimeo.com/moogaloop.swf?clip_id=32784590&amp;server=vimeo.com&amp;show_title=0&amp;show_byline=0&amp;show_portrait=0&amp;color=00adef&amp;fullscreen=1&amp;autoplay=0&amp;loop=0\" /><embed allowfullscreen=\"true\" allowscriptaccess=\"always\" height=\"455\" src=\"http://vimeo.com/moogaloop.swf?clip_id=32784590&amp;server=vimeo.com&amp;show_title=0&amp;show_byline=0&amp;show_portrait=0&amp;color=00adef&amp;fullscreen=1&amp;autoplay=0&amp;loop=0\" type=\"application/x-shockwave-flash\" width=\"500\"></embed></object></p>\n<p>\n\t<a href=\"http://vimeo.com/32784590\">PiTV-Werbeunterbrechung No.2</a> from <a href=\"http://vimeo.com/prinzpi\">Keine Liebe Records</a> on <a href=\"http://vimeo.com\">Vimeo</a>.</p>\n<p>\n\t&nbsp;</p>\n"}

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	module.exports = {"title":"Where hipsters get their coffee","date":"2013-09-24 00:00:00 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/barn.jpg\" alt=\"barn.jpg\" />\nFoto: <a href=\"https://foursquare.com/leitmedium\">C. C. Mierau</a>\n<p>Vorweg: Kritik über Hipsterkultur langweilt mich nicht nur bis zum Äußersten, nein sie widert mich vielmehr auch an. Individualismus-Kampftruppen stampfen durch die Sozialen Netzwerke und die hübschen Bezirke der vielen Städte und haben nichts anderes zu tun als sich gegenseitig zu stigmatisieren, anzugaffen und sich auf der Suche nach ein paar Sekunden in Likes messbarem Fame gegenseitig schlecht zu reden. Bestätigung durch Abwertung von Hipstern ist einfach, aber auch durchschaubar und überflüssig.</p>\n<p>Und weil wir uns auch einfach ab und zu mal lieb haben sollten und unser Wissen über guten Kaffee und tolle Orte zusammen perfektionieren könnten, habe ich für Euch diese kleine Liste mit meinen Empfehlungen auf Foursquare gespeichert: <a href=\"https://foursquare.com/bangpowwww/list/hipster-coffee\">Hipster Coffee</a></p>\n<img src=\"/content/images/cof1.jpg\" alt=\"cof1.jpg\" />\n<p>Folgt mir gerne auch auf <a href=\"https://foursquare.com/bangpowwww\">Foursquare</a> und schickt mir gerne Tipps zum Erweitern!</p>\n"}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	module.exports = {"title":"Wie die WELT Quellen aus meinen Tweets streicht","date":"2012-01-11 16:44:31 +0000","tags":null,"layout":"post","body":"<p>\n\tZur Sachlage:</p>\n<p>\n\tVorgestern verfasste ich einen Tweet, der einen befreundeten Künstler (<a href=\"http://torsun.blogsport.de/\">Torsun von Egotronic</a>) zitierte, der auf seiner Facebookseite eine lesenswerte und kritische Aussage über Gentrifizierung und Stadtentwicklung traf. Diese Aussage twitterte ich als Zitat kenntlich mit Anführungszeichen und mit Quellenangabe, die den Namen des Verfassers (&quot;via <a href=\"http://torsun.blogsport.de/\">Torsun Egotronic</a>&quot;) nannte.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDer Tweet tauchte heute in der Druckausgabe der WELT in der Rubrik &quot;Tweets des Tages&quot; (<a href=\"http://www.welt.de/print/welt_kompakt/print_politik/article13808697/Tweets-des-Tages.html\">hier auch online</a>) ohne die Nennung des eigentlichen Urhebers auf. Warum denn nur?</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tHier der Originaltweet:</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/Gentrifizierung.JPG\" style=\"width: 500px; height: 134px; \" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tMein Tweet (Danke <a href=\"https://twitter.com/#!/sanitwitta\">@sanitwitta</a>) in der Druckausgabe der WELT:</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/Gentrifizierung1.jpg\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tLiebe WELT, wieso druckt Ihr nicht den Urheber des Zitates ab? Wieso kürzt Ihr Tweets? Wieso wird wissentlich ein Urheber entfernt?&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch würde mich über eine offene Antwort in den Kommentaren oder eine Mail an kontakt@textkrieg.de freuen.</p>\n"}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	module.exports = {"title":"Wie ich 2kg Fleisch in den Slow Cooker stämmte","date":"2012-11-19 00:00:00 +0000","tags":null,"layout":"post","body":"<p>Neulich war es irgendwann plötzlich 14 Uhr - Ich möchte mich aber da nicht ganz genau festlegen lassen - als ich mein Mailfach abcheckte und eine freudige Mail entdeckte. Man möchte mir einen Slow Cooker schenken. Das fand ich natürlich ziemlich nett und da ich so ein Teil schon haben will seit ich das erste Mal gesehen habe wie <a href='http://www.youtube.com/watch?v=odWwc9OiS7o&feature=related'>Amis Fleisch</a> auf ihre massiven Schweine-, Truthahn- oder Chickenburger fleddern, sagte ich ‘Cool!’. Ich wollte auch endlich fleddern. Zeitgleich bin ich aber stets viel zu geizig Erspartes in Küchenutensilien zu investieren. Ich koche dann in der Regel lieber mit den bloßen Händen, rühre mit Strohhälmen um und serviere meine Gerichte auf Tellern, die ich aus Alufolie oder Fimo forme. Daher an dieser Stelle ein dickes Dankeschön für den Morphy Richards Slow Cooker an <a href='http://www.preis.de/'>Preis.de</a>! Und wer ist überhaupt Morphy Richards und wieso hat er mal eben so gute Ideen?</p>\n<p>Was kann man also mit so einem <a href=\"http://en.wikipedia.org/wiki/Slow_cooker\">Slow Cooker</a> alles anstellen? Und wie kann man Burger “mal anders” gestalten?\nIch habe also ein Rezept erdacht und es war zugegebenermaßen ziemlich großartig. Daher für Euch nun das Rezept und einige Impressionen aus meiner Küche, um Euch für die Geilheit des Kochens und das Herummachen mit diversen Lebensmitteln zu sensibilisieren:</p>\n<img src=\"/content/images/Burger.JPG\" alt=\"Burger.JPG\" />\n<p><strong>Burgers with Crock Pot Chicken and Caramelized Pears </strong></p>\n<p>Zutaten für 4 Burger:</p>\n<p>1 Birne</p>\n<p>4 Burgerbrötchen (am besten selbergemacht nach diesem <a href=\"http://www.chefkoch.de/rezepte/1747451284034681/Hamburger-Broetchen.html\">Rezept für Burger Buns</a>)</p>\n<p>1kg Hähnchenbrust</p>\n<p>Feldsalat</p>\n<p>1 Packung passierte Tomaten</p>\n<p>8 Knoblauchzehen</p>\n<p>6 getrocknete Chilischoten</p>\n<p>2 EL Worcestershiresauce</p>\n<p>8 EL Balsamico</p>\n<p>3 EL Sojasauce</p>\n<p>2 EL körniger Senf</p>\n<p>Pfeffer</p>\n<p>Salz</p>\n<p>brauner Zucker</p>\n<p>2 TL Honig</p>\n<img src=\"/content/images/BurgerBirneBunsTisch.JPG\" alt=\"BurgerBirneBunsTisch.JPG\" />\n<img src=\"/content/images/BurgerSenf.JPG\" alt=\"BurgerSenf.JPG\" />\n<p>In einer Schale die passierten Tomaten, die Worcestershiresauce, den Balsamico, die Sojasauce und den körnigen Senf mischen. Die Knoblauchzehen schälen und in die Sauce pressen. Die Mischung mit braunem Zucker, Pfeffer und eventuell etwas Salz abschmecken. Dabei darauf achten, dass die Sauce eine leichte tomatige Süße behält.</p>\n<p>Jetzt die Hähnchenbrust in den Slow Cooker geben und mit der Sauce bedecken. Der Slow Cooker arbeitet nun für sich. Nett von ihm! Auf der Stufe Medium müsst Ihr damit rechnen, dass das Teil so circa 8 Stunden braucht, bis das Fleisch schön saftig und fledderig gegart ist. In dieser Zeit lassen sich super die Burger Buns vorbereiten oder die erste Staffel <a href=\"http://www.imdb.com/title/tt1796960/\">Homeland</a> gucken, falls Ihr Euch nur für gekaufte Burgerbrötchen entschieden habt. Ich habe das Fleisch im Slow Cooker dann alle paar Stunden mal kurz gewendet und geschaut wie weich es ist.</p>\n<img src=\"/content/images/BurgerCooker.JPG\" alt=\"BurgerCooker.JPG\" />\n<p>Wenn das Fleisch gar und lecker ist und Ihr es nicht mehr abwarten könnt - 8 Stunden können so lange sein - dann müsst Ihr noch die Birnen und den Salat vorbereiten. Feldsalat also waschen und bereit legen. Aus der Birne schneidet Ihr dann 4 dicke Scheiben. Wenn in der Mitte noch Kerngehäuse ist, solltet Ihr das entfernen (Ekelhaft!). Nun in einer heißen Pfanne 2TL Honig schmelzen lassen und die Birnen darin karamellisieren bis sie schön golden sind.</p>\n<img src=\"/content/images/BurgerBirne.JPG\" alt=\"BurgerBirne.JPG\" />\n<img src=\"/content/images/BurgerBuns.JPG\" alt=\"BurgerBuns.JPG\" />\n<img src=\"/content/images/BurgerOpenburger.JPG\" alt=\"BurgerOpenburger.JPG\" />\n<p>Wenn Euer Timing optimal ist, wären genau jetzt Eure Burger Brötchen fertig und warm. Oder eben die gekauften Brötchen warm. Die warmen Teile also vorsichtig aufschneiden und mit Feldsalat und der karamallisierten Birnenscheibe belegen. Nun das Fleisch im Slow Cooker mit der Gabel etwas zerfallen lassen und zusammen mit Sauce auf die Birnenscheibe legen. Der Burger ist jetzt fertig. Dazu passt gut Weißwein oder Ziegenmilch.</p>\n"}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

	module.exports = {"title":"Wie ist das so als Freiberufler?","date":"2011-05-18 13:41:52 +0000","tags":null,"layout":"post","body":"<p>\n\tMenschen fragen mich, wie das so als Freiberufler ist. Dazu kann ich nichts sagen, denn meistens erreicht mich die Frage erst gar nicht.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tZu Uhrzeiten, wo andere arbeiten und Fragen fragen, liege ich noch im Bett oder wieder. Wenn es an der Tür klingelt, schrecke ich ängstlich zusammen. Die Option, dass jemand etwas von mir wollen könnte, ängstigt mich. Ich baue sozial ab. Deutschland und ich, wir sind uns ähnlich.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch arbeite gerne. Ich habe viele Ideen. Diese Ideen werfen alle kein Geld ab. Derzeit dienen sie dazu meinen Namen zu verbreiten und mich selbst als Marke zu etablieren. Davon bezahlt sich kein Strom. Ich schnorre ständig. Der Pfandautomat ist mein Girokonto.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"324\" src=\"/files/IMG_8823.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tNachmittags stehe ich dann meistens doch auf. Duschen kann tagesfüllend sein, wenn man es von einer Notwendigkeit zu einem Hobby degradiert. Ich dusche unser Wasser weg. Ich zahle keine Steuern. Aber ich produziere Kunst. Drei gute Gründe mich zu hassen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tMeine Projekte erledige ich im Schnelldurchlauf. Ich habe zu viele Ideen und zu wenige Aufträge. Mutter sieht das auch so.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"334\" src=\"/files/IMG_1881.jpg\" width=\"500\" /><img alt=\"\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tSeit ein paar Wochen träume ich häufig meine Zähne zu verlieren. Die Traumdeutung hat dazu ihre eigene Meinung und stempelt mich als asoziales Monster ab. Zähne gelten als &quot;Waffen in einer Ellenbogengesellschaft&quot;. Ich mag den Wettbewerb und ich mag Waffen. Eine Ellenbogengesellschaft ist der Kampf, den ich benötige.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tAm Ende des Monats ist das Portemonnaie wieder leer und der Hunger plagt. Ich möchte dann lieber nicht mehr auf meinen Enthusiasmus und Arbeitspathos angesprochen werden. Zyklisch bewerbe ich mich bei AstroTV und als Reinigungskraft. Kunst und Hunger gehören zusammen wie Priklopil und Baumärkte. Und ich führe Protokoll.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"333\" src=\"/files/IMG_5471.jpg\" width=\"500\" /></p>\n"}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

	module.exports = {"title":"Wie meine Tweets im ZDF wieder auftauchten","date":"2011-12-02 13:15:56 +0000","tags":null,"layout":"post","body":"<p>\n\tHallo, mein Name ist Ada Blitzkrieg und ich bin wütend.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIn der Sendung <a href=\"http://neoparadise.zdf.de/ZDFde/inhalt/3/0,1872,8354499,00.html?dr=1\">Neoparadise</a> auf <a href=\"http://neo.zdf.de/\">ZDFneo</a> bediente sich Klaas Heufer-Umlauf gestern eines meines Toptweets um einen guten Lacher für die Sendung abzugreifen. Nun gut, ich saß zufällig auf dem Sofa und schaute mir die Neoparadise Sendung an und zuckte regelrecht zusammen, als mein Tweet von Klaas präsentiert wurde als sei es ein eigener Witz. Das fühlt sich nicht nur falsch an, das ist es auch.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tEs handelt sich um den im folgenden genannten <a href=\"http://favstar.fm/users/bangpowwww/status/27822738961866752\">Tweet</a> in dieser Sequenz (ca. ab Minute 34:00) der <a href=\"http://www.zdf.de/ZDFmediathek#/beitrag/video/1503678/neoParadise-vom-1-Dezember-2011\">NeoParadise Folge vom 1.12.2011</a>.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/plattenbau.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch schrieb nach der Sendung Klaas an. Zum einen, weil ich die Sendung eigentlich sehr mag und es mich stark enttäuschte nicht genannt worden zu sein, und zum anderen weil ich hoffte, dass es sich um ein einfaches Missverständnis handeln würde. Vielleicht hatte er meinen Tweet einfach noch im Kopf, ohne zu wissen woher er diesen Witz kennt? Vielleicht hat er ihn in der Sendung spontan einfach rezitiert, ohne sich Gedanken über die Quelle zu machen? Ich hoffe sehr die Sache würde sich auf diese Art und Weise klären, da ich Klaas und seine Sendung bisher immer sehr schätzte. Hier der daraus resultierende Dialog:</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/conversation.JPG#\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tFür mich hatte sich nach diesem Dialog alles geklärt. Kann passieren, dachte ich mir. Was danach folgte, war aber durchaus unangenehm.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch bekam in den nächsten Stunden viele Zuschriften von meinen Followern auf Twitter und per Mail, die mich darauf aufmerksam machten, dass genau dieser Tweet ein fester Platz sowohl am besagten Abend in der NeoParadise-Show, als auch in einer von Klaas moderierten Radioshow einige Tage zuvor hatte. Damit scheidet der besagte Entschuldigungspunkt &quot;spontan&quot; wohl aus.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIn den nächsten Stunden erreichte mich eine Mail, die einen Link enthielt, der auf eine Radioshow von Klaas Heufer-Umlauf und Jan Böhmermann aufmerksam machte, in der ebenfalls einer meiner Tweets wortwörtlich benutzt wurde. Es handelt sich um diesen <a href=\"http://favstar.fm/users/bangpowwww/status/73648697921110016\">Tweet</a>:</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" src=\"/files/hunde.JPG\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDer Tweet taucht in Minute 19:56 der Radioliveshow &nbsp;zum Live-Bühnenhow &quot;<a href=\"http://www.radioeins.de/programm/sendungen/zwei_alte_hasen/index.html\">Zwei alte Hasen erzählen von früher</a>&quot; auf. Er wird sogar als Titel einer Kategorie verwendet und ist keineswegs ein spontaner Live-Einfall, sondern wortwörtlich übernommen und vermutlich auf einem Zettel notiert.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch möchte meinen Ärger sachlich benennen und Punkte aufführen, die begründen warum ich es moralisch bedenklich finde sich am geistigen Eigentum anderer ohne Urhebernennung zu bedienen:</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t- Ich bin Texterin. Für mich heißt das: Ich verdiene mein Geld mit Schreiben, mit witzigen Solgans und sprachlichen Spielereien. In diesem Fall bedient sich jemand an meinen Produkten ohne meinen Namen als Urheber anzugeben. Persönlich als auch beruflich ist das nicht korrekt.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t- Dieses Sachverhalt ist nicht straf- oder belangbar in diesem Fall, stellt aber für mich persönlich ein großes Ärgernis dar, denn mein Gegenüber ist kein Mensch, der diese Inhalte privat an Freunde und Familie weitergibt, etwas abänderte oder als Inspirationsquelle benutzt, sondern mit den exakten Inhalten, die ich geschaffen habe, seinen Lebensunterhalt verdient.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t- Ich bin verärgert, da sich meine Arbeit, bis auf ein phänomenales Feedback seitens meiner Twitterfollower (Danke!) monetär leider kaum bei mir bemerkbar macht. Wie ich bereits in <a href=\"http://textkrieg.de/2011/05/18/wie-ist-das-so-als-freiberufler\">diesem</a> Artikel einige Zeit zuvor beschrieben habe, kämpfte ich in den letzten Jahren mit Geldproblemen und großen Existenznöten. Freunde schickten mir Packete mit Nudeln und Tabak. Ich konnte monatelang mit akuten Problemen nicht zum Arzt gehen, weil ich mir die verfickten 10 Euro Praxisgebühr nicht leisten konnte. Ich möchte kein Mitleid dafür, sondern einfach nur kurz den Backround wiedergeben auf dem ich heute argumentiere. Ich habe lange Zeit nichts besessen ausser meiner Ideen und einer großen Vision mit der Sache Geld zu verdienen, die ich so liebe.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t- Ich freue mich, wenn meine Tweets andere Menschen inspirieren, wenn sie sie verbessern oder als Gedankensprungbrett für eigene Ideen nutzen, aber ich freue mich nicht, wenn man sie schlichtweg wortwörtlich nutzt, ohne mich zu nennen und damit Geld verdient.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t- Wäre es denn tatsächlich bei diesem besagten einen Mal geblieben, wäre das alles für mich kein Problem gewesen. Aber ich habe leider durch das zweite Vorkommnis den Glauben an das Zufällige verloren und bin nun wirklich enttäuscht.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<strong>Liebes ZDF, Lieber Klaas,</strong></p>\n<p>\n\t<strong>Wenn Euch meine Witze gefallen, dann tut mir den Gefallen und bezahlt mich für Texte, Pressetexte, Dialoge und Showlacher, denn ich freue mich, wenn ich Geld verdiene kann und Ihr habt bezahlt und müsst kein schlechtes Gewissen haben. Wie wäre das?</strong></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&nbsp;</p>\n"}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	module.exports = {"title":"Wie viel Wahrheit steckt in DACKELKRIEG?","date":"2012-12-22 00:00:00 +0000","tags":null,"layout":"post","body":"<img src=\"/content/images/Dacki6.JPG\" alt=\"Dacki6.JPG\" />\n<p>“Ein schrecklicher Verdacht keimte in mir auf - hatte der kleine Wellensittich Coco die\nGroßmutter etwa dement gemacht?”</p>\n<img src=\"/content/images/dacki1.jpg\" alt=\"dacki1.jpg\" />\n<p>“Das nächtliche Kinderzimmer muss eher einem Kriegsschauplatz in einem Science-Fiction Film mit\nHorrorelementen geglichen haben, als einer sicheren Schlafstätte für zwei kleine Kinder.”</p>\n<img src=\"/content/images/Dacki2.JPG\" alt=\"Dacki2.JPG\" />\n<p>“Im Hellen stellte sich in den Folgetagen heraus, dass der gefährliche Hund bloß ein kleiner Rehpinscher war. Aber natürlich trotzdem brandheiß und bissig, redeten wir uns ein. Ein dominanter Rüde mit einer Widerristhöhe von zwanzig Zentimetern. Aber ich hatte bisher noch jeden Mann mit Wurst verführt, und so packte ich mir die Innentaschen meiner Strickjacke voll mit feiner Cervelatwurst, denn Cervelatwurst war der Sprengstoffgürtel meiner Verführungskünste.”</p>\n<img src=\"/content/images/Dacki3.JPG\" alt=\"Dacki3.JPG\" />\n<p>&quot;Die Videokassette lag unter dem reichlich geschmückten Baum, den meinen Eltern in familiärer Tradition immer derart mit thematisch unpassendem Weihnachtschmuck einkleideten, dass man sich bei dessen Anblick immer verwundert fragte, wann er seine Mission auf der Erde beendet haben und wieder ins All aufbrechen würde.</p>\n<img src=\"/content/images/Dacki4.JPG\" alt=\"Dacki4.JPG\" />\n<p>“Mein Liebling war der kleine Angelo Kelly, denn wir sahen uns sehr ähnlich. Fast schon wie eineiige Zwillinge. Wenn ich die Schrauben meiner losen Zahnspange immer weiter selbst justiert h ?tte, wie es der ursprüngliche Plan gewesen war, hätte ich heute auch so eine hübsche Zahnlücke, aber mir fehlte damals leider das Feinwerkzeug und die Muse perspektivisch zu denken. Alles was ich stattdessen besaß war Kelly Familiy Merchandise im mehrstelligen Tonnenbereich und Mundgeruch von der losen Zahnspange, an der im Laufe des Tages in der großen Plastikdose, in die mir Mutter manchmal liebevoll Feinkostsalate als kleine Pausenmahlzeit einpackte, mein Speichel und die Nudelsalatreste festtrockneten, die dann einen unangenehmen Duft von Mundraum und Fleischsalat freisetzten, den niemand so recht zu mögen schien.”</p>\n<img src=\"/content/images/Dacki5.JPG\" alt=\"Dacki5.JPG\" />\n<p>“Mein Vater und mein Onkel spielten den ganzen Nachmittag NES, SNES, N64, Carrera-Bahn oder Kicker mit oder gegen meinen Bruder und mich. Mutter strickte ununterbrochen. Die anderen Geschenke, die wir noch tags zuvor mit leuchtenden Augen ausgepackt hatten, standen vergessen in der Ecke, während aus der Küche der Geruch von Gans, Ente, Reh, Huhn, Hähnchen, Truthahn, Hirsch, Rind, Schwein und Klößen zu uns strömte und wir mit unseren Controllern die kleinen Karts uber die Rainbow-Road steuerten und den Mushroom-Cup gewannen oder verloren. Je nachdem.”</p>\n<p><strong> Der Roman &quot;<a href=\"http://textkrieg.de/pages/dackelkrieg\">DACKELKRIEG - Rouladen und Rap</a> ist ab sofort bei <a href=\"http://textkrieg.de/pages/dackelkrieg\">AMAZON</a> oder über meine Homepage käuflich zu erwerben.</strong></p>\n"}

/***/ }),
/* 727 */
/***/ (function(module, exports) {

	module.exports = {"title":"Wohnungssuche in Berlin","date":"2011-08-22 10:50:32 +0000","tags":null,"layout":"post","body":"<p>\n\tAuf der Beschissenheits-Skala der Dinge, die mein Leben ficken, findet sich derzeit Wohnungssuche in Berlin ungeschlagen auf Platz 1. Wohnungssuche trägt Tennissocken und hat sich unter der Vorhaut nicht gewaschen. Wer mein verbales Rumgewichse und Gejammer auf <a href=\"https://www.facebook.com/adablitzkrieg\">Facebook</a> oder <a href=\"http://twitter.com/bangpowwww\">Twitter</a> verfolgt, hat bestimmt das ein oder andere Mal mitbekommen, dass ich die verschiedensten Aufrufe für Wohnungssuchen gestartet habe, die immer mehr frustrierten. Übrig bleibt eine ratlose Ada Blitzkrieg. Alter, wieso findet man in ganz fucking Berlin keine korrekte Wohnung?</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tVorweg: Was wir suchen.</p>\n<p>\n\tEine Wohnung in den Bezirken Kreuzberg, Neukölln oder Mitte. Auf jeden Fall Altbau mit hohen Decken. Da ich einen sehr ausgepräten und sexuell motivierten Bodenbelag-Fetisch besitze, sollte der Bodenbelag optimalerweise aus Dielen oder Parkett bestehen. Kein Ergeschoss. 2-3 Zimmer. Und irgendwas zwischen 60 und 120qm.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDie Vorgeschichte.Warum ich ausziehen möchte?</p>\n<p>\n\tWeil ich in der Simon-Dach-Straße wohne. Die Wohnung, die nur als Zwischenlösung zu einer größeren Bude gedacht war, entpuppt sich als Endstation. Alle paar Minuten klingeln betrunkene Franzosen, Menschen sitzen nachts auf meiner Fensterbank und können ihren Mageninhalt nicht bei sich behalten, und wenn ich schlafen möchte, unterhalten sie sich über Hornbrillen oder vegane Kunst.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tDa die Wohnung halb unterirdisch liegt, findet auch kein Licht den Weg zu mir. Ich verharre regungslos über meiner Arbeit. Als Freelancer hänge ich mehr als andere Menschen in den eignen vier Wänden ab, denn ich muss ja arbeiten, denken und kreativ sein. Das Leben dort macht meine Haut aschfahl. Wenn ich das Haus dann doch mal verlasse um Softdrogen, Zigaretten oder Fastfood zu kaufen, sehe ich hinsichtlich des gleißenden Lichts erstmal mehrere Stunden nichts. Wenn meine Augen sich endlich an die Helligkeit gewöhnt haben, ist es meist schon dunkel.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/tn_April09 047.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tJeder zieht derzeit nach Berlin. Jeder möchte eine tolle Wohnung. Die meisten Menschen verdienen regelmäßig Geld. Ich bin Freiberuflerin und meine Elternbürgschaft ist nichts wert, denn meine Eltern sind keine Düsseldorfer Bonzen. Mein Freund fährt regelmäßig Geld ein, aber das scheint derzeit auch niemanden zu interessieren. Wir wären die perfkten Mieter, wenn man uns denn lassen würde.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t&quot;Warum holst du dir keinen Makler?&quot;, fragen sie. &quot;Weil ich es liebe mit 300 hässlichen Menschen auf Wohnungsbesichtigungen in einem 10qm Zimmer zu stehen und fremden Schwanz zu riechen.&quot;&nbsp;</p>\n<p>\n\tBei den wenigen Wohnungen, die nicht über einen Makler vermittelt werden, sondern über den Vormieter, gibt es keine Maklergebühr und dementsprechend viele Interessenten, unter denen immer einer dabei ist, der besser verdient. Das ist die goldene Faustregel für die Wohnungssuche in der Hauptstadt.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"323\" src=\"/files/tn_April09 077.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tAls ich vor drei Jahren nach Berlin gezogen bin, war es bei weitem noch nicht so schwer Wohnraum zu finden. Die Bedingungen verschärfen sich von Jahr zu Jahr. Einige Bezirke gentrifizieren sich tot. Wohnungen in angesagten Bezirken wissen um ihren Wert. Bei Weitervemittlung verlangen die Vormieter unverschämte Preise für die Übernahme bestimmter Dinge, damit sie im Gegenzug den Interessenten beim Vermieter vorschlagen. Was schon alles vorgekommen ist;</p>\n<p>\n\t- Für einen Anstrich von vor 4 Jahren noch 1000 Euro verlangen</p>\n<p>\n\t- Für einen alten Küchentisch &quot;mit Geschichte&quot; 500 Euro</p>\n<p>\n\t- Für zwei in der Wand befestigte Bretter (&quot;Bücherregal&quot;) 200 Euro</p>\n<p>\n\tDie Liste könnte ich ewig weiterführen. Ich habe Lust auf eine Wohnung, aber ich habe keine Lust mich verarschen zu lassen. Ich bin gerne bereit für bestimmte Dinge zu bezahlen, aber ich finanziere niemandem den Umzug. Hier gilt es abzuwägen. Wer einen fairen Preis für Arbeit oder Gegenstände verlangt, wird nicht mit Hass überschüttet. Mich ärgert es unglaublich, dass es Menschen gibt, die diesen vollkommen überzogenen Preis für genannte Dinge zu zahlen, statt kollektiv NEIN zu Menschen zu sagen, die um jeden Preis versuchen aus der Not anderer Menschen zu profitieren. <a href=\"http://www.classless.org/musik/\">Nein, nein, das ist nicht der Kommunismus!</a></p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"667\" src=\"/files/tn_April09 117.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tZwischendinger gibt es nicht mehr. Entweder sind Wohnungen total veloddert, voller Schimmelpilze, Leichenflecke oder über Fischbuden und Prügelkneipen, oder sie sind totrenoviert. Ich habe die wenigen schönen Wohnungen, die ich mir in den letzten Jahren angesehen habe, nicht vergessen können und hatte das Glück bis vor einiger Zeit in einer phänomenalen Wohnung leben zu dürfen. Ein Glücksgriff. Ich gebe die Hoffnung nicht auf eine bezahlbare Wohnung zu finden, die nicht einen Monatslohnmiete als Courtage kostet. Makler sind für mich die allerletzten Menschen.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/tn_Ekelhaus.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWenn Ihr Tipps für die Wohnungssuche habt, wenn Ihr auch frustriert seid, wenn Ihr Ideen habt, oder glaubt etwas zu wissen, wenn Ihr eine Wohnung habt die frei wird oder Eure Mutter gerade auszieht, dann meldet Euch. Informationen &amp; Angebote gerne an <a href=\"http://textkrieg.de/pages/kontakt\">mich</a>.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"750\" src=\"/files/tn_IMG_1443.JPG\" width=\"500\" /></p>\n"}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

	module.exports = {"title":"Zwischen Frustration und Freiheit","date":"2011-08-04 15:52:39 +0000","tags":null,"layout":"post","body":"<p>\n\tMein Nagel ist schon einige Zeit eingerissen. Keine Ahnung bei welcher meiner zahlreichen beschissenen Aktivitäten der Bruch passierte, aber er ist gesplittert und ich wollte das so niemals haben.</p>\n<p>\n\tHeute ist ein besonderer Tag, denn ich bin schlecht gelaunt, aber nicht am Boden zerstört und kann meine Umwelt klar reflektieren, während der flüssige Scheiblettenkäse in meinem gebrochenen Nagel fest wird.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\t<img alt=\"\" height=\"375\" src=\"/files/frauimregen.jpg\" width=\"500\" /></p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch bin manchmal frustriert. Ich möchte nicht zufrieden sein mit meinem Leben uns mit gewissen Umständen, die es kreativen Menschen in dieser Gesellschaft nicht einfach machen sich nicht bedingungslos der Frustration zu unterwerfen, um dann nur noch in Björk-Klamotten auf der Strasse zu flanieren oder mit ihrem Streichorchestern, die Songs der DSDS Gewinner zu covern, um &quot;ein Zeichen zu setzen&quot;.</p>\n<p>\n\tIch bin nicht der Typ Mensch, der irgendwann vor einer Statue enden möchte, die ich Kunst nenne, die aber eigentlich nur ein überdimensioniertes Kastenbrot ist. Ich will nicht in teuren Printmagazinen auf hochglanzgewichsten Fotos mit wirren Haaren zu sehen sein, wie ich eine Rose aus Wurst für Christoph Schlingensief niederlege.&nbsp;</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tAber machen wir uns nichts vor, die Gesellschaft will den Künstler liebend gerne als Freund haben, sie will sich mit ihm schmücken und ihren Freunden erzählen, dass sie jemanden kennt, der &quot;das alles&quot; macht, aber bezahlen möchte die Gesellschaft dafür in den meisten Fällen nicht.&nbsp;Aber dann kam der Hunger.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tWenn man jahrelang beobachtet, wie andere Menschen in Urlaub fahren, in Restaurant gehen, sich Fahrräder kaufen oder einfach eine Limo beim Späti erwerben ohne sich zu überlegen wie man mit 5 Euro 14 Tage überlebt. Für mich ist dieses Leben nicht normal. Ich fahre seit Jahren nicht in Urlaub, ich besuche meine Familie nicht, weil ich mir die Reisekosten nicht leisten kann, denn ich habe schlicht und einfach kein Geld. Ich kaufe die billigsten Klamotten, und das auch nur, wenn mir etwas kaputtgeht. Ich habe einen Monat lang geweint, weil mein Fahrrad gestohlen wurde und ich mir kein neues gebrauchtes Rad für 20 Euro kaufen konnte. Ich verfüge über dieses Geld nicht. Alles was für die meisten Menschen selbstverständlich ist, ist für mich ein kleines Wunder.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tIch prangere an dieser Gesellschaft eine besonders hässliche Eigenschaft an: Menschen werden bezahlt um eine bestimmte Zeit ihres Lebens jeden Tag an einem bestimmten Ort zu verbringen. Nennt sich auch Festanstellung. Das Konzept &quot;Zeit gegen Geld&quot; ist für mich ein unsinniger Auswurf unserer Gesellschaft, der die falschen Menschen bevorteilt. Dennoch sehne ich mich nach Sicherheit. Ich möchte einfach die Gewissheit haben im nächsten Monat meine Krankenkasse bezahlen zu können und genug Geld für ein paar Nudeln und Billigbier bereitstellen zu können. </p>\n<p>\n\tIn letzter Zeit bekomme ich häufig Stellenangebote und Nachfragen, die mir schmeicheln und ich spiele mit dem Gedanken meine Energie in ein Team zu stecken und gemeinsam an einem Ziel zu arbeiten.</p>\n<p>\n\t&nbsp;</p>\n<p>\n\tLangsam kommt aber auch mein Geschäft ins Rollen. Mehr und mehr Aufträge flattern rein. Dieser Monat ist der Stichmonat. Mein Business hat nicht zuletzt durch meinen Textkrieg-Blog endlich Fuss gefasst. Menschen erfahren endlich, dass ich Dienstleistungen anbiete. Ich habe mir mit harter Arbeit und freier Schnauze einen Ruf erworben. Und vielleicht werde ich mir zu meinem Geburtstag in zwei Wochen mein eigenes Fahrrad für 200 Euro gönnen, den Rest spare ich, denn ich weiß gar nicht wohin mit so viel Geld. Vielleicht ist ja doch noch alles gut geworden und ich werden von den äußeren Umständen gezwungen wieder gut gelaunt sein.</p>\n"}

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// bundle.js